
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dydBa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("4uT5g")).SidebarClassicSoftware);
$parcel$export(module.exports, "useFeatures", () => (parcelRequire("ezRTW")).useFeatures);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $4uT5g = parcelRequire("4uT5g");

var $ezRTW = parcelRequire("ezRTW");

});
parcelRegister("4uT5g", function(module, exports) {

$parcel$export(module.exports, "SidebarClassicSoftware", () => $8a7cb76999fd746f$export$94b90281549a07ad);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $fobme = parcelRequire("fobme");

var $acDan = parcelRequire("acDan");

var $fpoBX = parcelRequire("fpoBX");

var $lGo7j = parcelRequire("lGo7j");

var $e9ZW3 = parcelRequire("e9ZW3");
const $8a7cb76999fd746f$export$94b90281549a07ad = ()=>{
    const { data: data, loading: loading } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    if (loading || data == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGo7j.Skeleton), {
        isFull: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarRenderStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpoBX.SidebarThemeProvider), {
        theme: $8a7cb76999fd746f$var$THEME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e9ZW3.Menu), null))), !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acDan.SidebarReady), {
        id: (0, $fobme.SIDEBAR_ID).JSW_CLASSIC
    }));
};
const $8a7cb76999fd746f$var$menuItemActiveHoverColor = "var(--ds-background-selected, #E9F2FF)";
const $8a7cb76999fd746f$var$THEME = {
    navigation: {
        item: {
            background: {
                default: 'transparent',
                active: $8a7cb76999fd746f$var$menuItemActiveHoverColor,
                hover: $8a7cb76999fd746f$var$menuItemActiveHoverColor
            },
            color: {
                active: `${"var(--ds-text-selected, #0C66E4)"}`
            }
        }
    }
};

});
parcelRegister("fobme", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_ID", () => $4b9be639c0c7f77b$export$adf978edbdfaf080);
const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
    CONNECT: 'CONNECT',
    CORE: 'CORE',
    FILTERS: 'FILTERS',
    FILTERS_GLOBAL: 'FILTERS_GLOBAL',
    FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
    GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
    GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
    GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
    GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
    GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
    JSM: 'JSM',
    JSW_CLASSIC: 'JSW_CLASSIC',
    JSW_NEXT_GEN: 'JSW_NEXT_GEN',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    EOC_OPERATIONS: 'EOC_OPERATIONS',
    POLARIS: 'POLARIS',
    USER: 'USER',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
};

});

parcelRegister("fpoBX", function(module, exports) {

$parcel$export(module.exports, "SidebarThemeProvider", () => $c9116269ddc1accc$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $c9116269ddc1accc$export$b1a81b4626bc52c3);

var $5uXOq = parcelRequire("5uXOq");
const $c9116269ddc1accc$var$ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);

});

parcelRegister("e9ZW3", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $cb9d120cac330869$export$d9b273488cd8ce6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ddl7e = parcelRequire("ddl7e");

var $3pK7p = parcelRequire("3pK7p");

var $cu8LJ = parcelRequire("cu8LJ");

var $7mIBt = parcelRequire("7mIBt");

var $lKJPg = parcelRequire("lKJPg");

var $aqJO7 = parcelRequire("aqJO7");

var $044lR = parcelRequire("044lR");

var $2VmPP = parcelRequire("2VmPP");

var $af7Zc = parcelRequire("af7Zc");

var $fxg6i = parcelRequire("fxg6i");

var $5E93O = parcelRequire("5E93O");

var $4KUYb = parcelRequire("4KUYb");

var $cQJCJ = parcelRequire("cQJCJ");

var $62UZ9 = parcelRequire("62UZ9");

var $fVgSt = parcelRequire("fVgSt");

var $dnGcR = parcelRequire("dnGcR");

var $eOat1 = parcelRequire("eOat1");

var $5ZzwP = parcelRequire("5ZzwP");
var $bNEt5 = parcelRequire("bNEt5");
var $a4hJx = parcelRequire("a4hJx");
var $kxnYb = parcelRequire("kxnYb");
var $2zFxf = parcelRequire("2zFxf");
var $9K9UK = parcelRequire("9K9UK");

var $b4PzF = parcelRequire("b4PzF");


var $2vSU6 = parcelRequire("2vSU6");

var $k0iPT = parcelRequire("k0iPT");

var $gwIPs = parcelRequire("gwIPs");

var $7CMCs = parcelRequire("7CMCs");

var $dkNvt = parcelRequire("dkNvt");

var $lRM9B = parcelRequire("lRM9B");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $3QTQ5 = parcelRequire("3QTQ5");

var $2MtwW = parcelRequire("2MtwW");

var $jvcra = parcelRequire("jvcra");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $a2iZU = parcelRequire("a2iZU");

var $2gP8z = parcelRequire("2gP8z");

var $fNi03 = parcelRequire("fNi03");

var $18FbX = parcelRequire("18FbX");

var $lpwtK = parcelRequire("lpwtK");

var $cF0ZN = parcelRequire("cF0ZN");

var $2A1mZ = parcelRequire("2A1mZ");

var $jineK = parcelRequire("jineK");

var $juTur = parcelRequire("juTur");

var $1GbRa = parcelRequire("1GbRa");

var $jsI7v = parcelRequire("jsI7v");

var $kZj7F = parcelRequire("kZj7F");

var $l468O = parcelRequire("l468O");

var $c162r = parcelRequire("c162r");

var $7EMGV = parcelRequire("7EMGV");

var $3SzZi = parcelRequire("3SzZi");

var $7OqB4 = parcelRequire("7OqB4");

var $3tHFY = parcelRequire("3tHFY");

var $hWtQt = parcelRequire("hWtQt");

var $jfqNX = parcelRequire("jfqNX");

var $gZbSF = parcelRequire("gZbSF");

var $6hMYg = parcelRequire("6hMYg");

var $231OU = parcelRequire("231OU");

var $8zgGo = parcelRequire("8zgGo");

var $aNdqN = parcelRequire("aNdqN");

var $fZIti = parcelRequire("fZIti");

var $73Ebi = parcelRequire("73Ebi");

var $6jY6G = parcelRequire("6jY6G");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $aImhn = parcelRequire("aImhn");

var $kfztd = parcelRequire("kfztd");

var $20Eax = parcelRequire("20Eax");

var $9OXo1 = parcelRequire("9OXo1");

var $d7642 = parcelRequire("d7642");

var $hADcq = parcelRequire("hADcq");

var $ezRTW = parcelRequire("ezRTW");

var $69H2H = parcelRequire("69H2H");

var $3QUEt = parcelRequire("3QUEt");

var $dvdrL = parcelRequire("dvdrL");

var $l5Ald = parcelRequire("l5Ald");

var $7pPua = parcelRequire("7pPua");

var $fzMyx = parcelRequire("fzMyx");

var $egnSq = parcelRequire("egnSq");
const $cb9d120cac330869$var$isConnectOpen = (route)=>(0, $k0iPT.CONNECT_ROUTES_SET).has(route.name);
const $cb9d120cac330869$var$isForgeOpen = (route)=>[
        'forge-spa-project',
        'project-settings-software-forge-apps'
    ].includes(route.name);
const $cb9d120cac330869$var$calculateStack = (route, connectStack, forgeStack)=>{
    if ([
        'legacy-pin',
        'issue-navigator',
        'issue-navigator-classic'
    ].includes(route.name)) return [
        (0, $hADcq.SECTION_ID).ISSUES
    ];
    if ([
        'project-settings-automation',
        'project-settings-classic-data-classifications',
        'classic-software-details',
        'classic-software-features',
        'classic-software-link-opsgenie',
        'classic-software-notifications-issue-logs',
        'project-settings-classic-issue-layout',
        'project-settings-software-proforma-project-forms',
        'project-settings-software-toolchain-company-managed',
        'legacy-project-settings-edit',
        'legacy-project-settings-delete',
        'legacy-project-settings-collectors',
        'legacy-project-settings-config',
        'legacy-project-settings-people',
        'legacy-project-settings-fields',
        'legacy-project-settings-issue-layout',
        'legacy-project-settings-issue-security',
        'legacy-project-settings-issue-types',
        'legacy-project-settings-notifications',
        'project-settings-software-notifications-notification-email',
        'legacy-project-settings-opsgenie',
        'legacy-project-settings-permissions',
        'legacy-project-settings-screens',
        'legacy-project-settings-summary',
        'legacy-project-settings-workflows',
        'project-settings-versions',
        'project-settings-components',
        'legacy-project-settings-dev'
    ].includes(route.name)) return [
        (0, $hADcq.SECTION_ID).SETTINGS
    ];
    if ([
        ...(0, $4R6GH.fg)('reports-overview-page-migration') ? [
            'software-reports',
            'software-reports-boardless',
            'software-reports-velocity-cmp'
        ] : [],
        'rapidboard-report',
        'legacy-custom-report',
        'legacy-all-reports',
        'legacy-reports-configure',
        'legacy-reports-average-age-report',
        'legacy-reports-created-vs-resolved-report',
        'legacy-reports-pie-report',
        'legacy-reports-recently-created-report',
        'legacy-reports-resolution-time-report',
        'legacy-reports-single-level-group-by-report',
        'legacy-reports-time-since-report',
        'legacy-reports-time-tracking-report',
        'legacy-reports-developer-workload-report',
        'legacy-reports-version-workload-report',
        'legacy-reports-workload-pie-report',
        'software-reports-cycle-time-classic',
        'software-reports-deployment-frequency-classic'
    ].includes(route.name)) return [
        (0, $hADcq.SECTION_ID).REPORTS
    ];
    if ($cb9d120cac330869$var$isConnectOpen(route) && connectStack) return connectStack;
    if ($cb9d120cac330869$var$isForgeOpen(route) && forgeStack) return forgeStack;
    return [];
};
const $cb9d120cac330869$var$calculateProjectGroupActive = (route)=>[
        'software-roadmap-classic',
        'software-timeline-classic',
        'rapidboard-backlog',
        'legacy-backlog',
        'rapidboard-board',
        'legacy-board',
        ...(0, $4R6GH.fg)('reports-overview-page-migration') ? [
            'software-reports',
            'software-reports-boardless',
            'software-reports-velocity-cmp'
        ] : [],
        'rapidboard-report',
        'legacy-custom-report',
        'legacy-all-reports',
        'legacy-reports-configure',
        'legacy-reports-average-age-report',
        'legacy-reports-created-vs-resolved-report',
        'legacy-reports-pie-report',
        'legacy-reports-recently-created-report',
        'legacy-reports-resolution-time-report',
        'legacy-reports-single-level-group-by-report',
        'legacy-reports-time-since-report',
        'legacy-reports-time-tracking-report',
        'legacy-reports-developer-workload-report',
        'legacy-reports-version-workload-report',
        'legacy-reports-workload-pie-report',
        'software-reports-cycle-time-classic',
        'software-list-classic'
    ].includes(route.name);
const $cb9d120cac330869$var$hasMultipleNavModulesActive = (features)=>!!features && (features.hasCode || features.hasSecurity || features.hasReleases || features.hasDeployments || features.hasOpsgenieSchedule);
const $cb9d120cac330869$var$isReportsIssuesOpen = (route)=>[
        ...(0, $4R6GH.fg)('reports-overview-page-migration') ? [
            'software-reports',
            'software-reports-boardless',
            'software-reports-velocity-cmp'
        ] : [],
        'rapidboard-report',
        'legacy-custom-report',
        'legacy-all-reports',
        'legacy-reports-configure',
        'legacy-reports-average-age-report',
        'legacy-reports-created-vs-resolved-report',
        'legacy-reports-pie-report',
        'legacy-reports-recently-created-report',
        'legacy-reports-resolution-time-report',
        'legacy-reports-single-level-group-by-report',
        'legacy-reports-time-since-report',
        'legacy-reports-time-tracking-report',
        'legacy-reports-developer-workload-report',
        'legacy-reports-version-workload-report',
        'legacy-reports-workload-pie-report',
        'software-reports-cycle-time-classic',
        'software-reports-deployment-frequency-classic',
        'legacy-pin',
        'issue-navigator',
        'issue-navigator-classic'
    ].includes(route.name);
const $cb9d120cac330869$export$e8026ff3708f95e4 = (0, $7OqB4.withThrowOnError)((0, $ezRTW.useFeatures));
const $cb9d120cac330869$export$a4007dc4843ca7f6 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $cb9d120cac330869$export$6377a0d210ab3036 = (0, $7OqB4.withThrowOnError)((0, $fNi03.useBoard));
const $cb9d120cac330869$export$1108315bd91bf04b = (0, $7OqB4.withThrowOnError)((0, $gZbSF.useProjectConnectItems));
const $cb9d120cac330869$export$3da22ae99edc5982 = (0, $7OqB4.withThrowOnError)((0, $hWtQt.useProjectReportsConnectItems));
const $cb9d120cac330869$export$1f8e4b2910733f3 = (0, $7OqB4.withThrowOnError)((0, $jfqNX.useProjectSettingsConnectItems));
const $cb9d120cac330869$export$1d46f5c48140258a = (0, $7OqB4.withThrowOnError)((0, $18FbX.useJiraSoftwareProjectPagesLink));
const $cb9d120cac330869$var$forgeSettingsStack = [
    (0, $hADcq.SECTION_ID).SETTINGS
];
const $cb9d120cac330869$var$ConfigurableProjectHeader = ({ name: name, avatarUrl: avatarUrl, projectId: projectId, description: description })=>{
    const shouldShowInlineConfigProjectHeader = (0, $aNdqN.useIsEditableToInline)();
    return shouldShowInlineConfigProjectHeader() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZIti.InlineConfigurableProjectHeaderAsync), {
        key: projectId,
        avatarUrl: avatarUrl,
        description: description,
        name: name,
        projectId: projectId,
        canEdit: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l468O.ProjectHeader), {
        avatarUrl: avatarUrl,
        description: description,
        name: name
    });
};
const $cb9d120cac330869$export$d9b273488cd8ce6f = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: board } = $cb9d120cac330869$export$6377a0d210ab3036();
    const { data: project } = $cb9d120cac330869$export$a4007dc4843ca7f6();
    const { data: features } = $cb9d120cac330869$export$e8026ff3708f95e4();
    const { data: connectItems, stack: connectProjectStack } = $cb9d120cac330869$export$1108315bd91bf04b();
    const { data: projectPagesData } = $cb9d120cac330869$export$1d46f5c48140258a();
    const { data: connectReportsItems, stack: connectReportsStack } = $cb9d120cac330869$export$3da22ae99edc5982();
    const { data: connectSettingsItems, stack: connectSettingsStack } = $cb9d120cac330869$export$1f8e4b2910733f3();
    const { stack: forgeProjectStack } = (0, $231OU.useProjectForgeApps)('forge-spa-project');
    const { data: forgeSettingsItems, stack: forgeProjectSettingsStack } = (0, $6hMYg.useProjectSettingsForgeAppsForMenu)('project-settings-software-forge-apps', $cb9d120cac330869$var$forgeSettingsStack);
    const navModulesCollapsedState = (0, $2A1mZ.useNavModulesCollapseState)();
    const { isAdmin: isAdmin } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
            forge: forgeSettingsItems,
            connect: connectSettingsItems
        }), [
        connectSettingsItems,
        forgeSettingsItems
    ]);
    const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
    const forgeStack = forgeProjectStack || forgeProjectSettingsStack;
    const [stack, setStack] = (0, $5uXOq.useState)($cb9d120cac330869$var$calculateStack(route, connectStack, forgeStack));
    const [projectGroupActive, setProjectGroupActive] = (0, $5uXOq.useState)($cb9d120cac330869$var$calculateProjectGroupActive(route));
    const [scrollableNestedMenu, setScrollableNestedMenu] = (0, $5uXOq.useState)(stack.includes((0, $hADcq.SECTION_ID).REPORTS)); // We need to check we're dealing with a nested menu for a connect item - if we navigate while inside a
    // nested connect item menu or if we're deep linking into a nested menu for a connect item -> we need to maintain the hiding of nav-modules
    const nestedEcosystemAppOpen = (0, $5uXOq.useMemo)(()=>$cb9d120cac330869$var$isConnectOpen(route) && !!connectStack && connectStack.length > 0 && !connectStack.includes((0, $hADcq.SECTION_ID).REPORTS) || $cb9d120cac330869$var$isForgeOpen(route) && !!forgeStack && forgeStack.length > 0, [
        connectStack,
        forgeStack,
        route
    ]);
    const [hideExpandableSections, setHideExpandableSections] = (0, $5uXOq.useState)(stack.includes((0, $hADcq.SECTION_ID).SETTINGS) || nestedEcosystemAppOpen);
    const [nestedMenuActive, setNestedMenuOpen] = (0, $5uXOq.useState)(stack.includes((0, $hADcq.SECTION_ID).REPORTS) || stack.includes((0, $hADcq.SECTION_ID).ISSUES) || stack.includes((0, $hADcq.SECTION_ID).SETTINGS) || nestedEcosystemAppOpen); // Reports and issues were dissappearing when deeplinking when the planning section was collapsed
    // this state controls if the reports or issues items are open, so we can expand the Planning nav module temporarly
    const [reportsIssuesOpen, setReportsIssuesOpen] = (0, $5uXOq.useState)($cb9d120cac330869$var$isReportsIssuesOpen(route));
    const [navModuleCollapseState, setNavModuleCollapseState] = (0, $5uXOq.useState)(navModulesCollapsedState.classic);
    const [multipleNavModulesActive, setMultipleNavModulesActive] = (0, $5uXOq.useState)($cb9d120cac330869$var$hasMultipleNavModulesActive(features));
    const setNavModulesCollapseStateLocalStorage = (0, $5uXOq.useCallback)((key)=>{
        const currentState = navModulesCollapsedState;
        const rtnObj = {
            ...currentState.classic
        }; // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ development: { isCollapsed: boolean; }; operations: { isCollapsed: boolean; }; planning: { isCollapsed: boolean; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'NavModulesCollapsedType'.
        rtnObj[key].isCollapsed = !currentState.classic[key].isCollapsed;
        (0, $2A1mZ.setNavModulesCollapseState)({
            ...currentState,
            classic: {
                ...rtnObj
            }
        }); // Update local state
        setNavModuleCollapseState(rtnObj);
    }, [
        navModulesCollapsedState
    ]);
    const setNavModulesCollapseStateLocalStoragePlanning = (0, $5uXOq.useCallback)(()=>setNavModulesCollapseStateLocalStorage('planning'), [
        setNavModulesCollapseStateLocalStorage
    ]);
    const setNavModulesCollapseStateLocalStorageDevelopment = (0, $5uXOq.useCallback)(()=>setNavModulesCollapseStateLocalStorage('development'), [
        setNavModulesCollapseStateLocalStorage
    ]);
    const setNavModulesCollapseStateLocalStorageOperations = (0, $5uXOq.useCallback)(()=>setNavModulesCollapseStateLocalStorage('operations'), [
        setNavModulesCollapseStateLocalStorage
    ]);
    const nestedMenuItemOnClick = (0, $5uXOq.useCallback)((event)=>{
        // Ignore cmd or ctrl clicks - neither of these should set nested menus open
        if (!event.metaKey && !event.ctrlKey) // Wait till event loop finishes before setting nested menu open
        // without this, we get a little bit of jank between issues and
        // ProjectGroupWrapper prior to the transition LN-236
        // *issue presisted when using requestAnimationFrame in lieu of setTimeout
        setTimeout(()=>{
            setReportsIssuesOpen(true);
            setNestedMenuOpen(true);
        });
    }, [
        setNestedMenuOpen
    ]);
    const reportsNestedItemOnClick = (0, $5uXOq.useCallback)((event)=>{
        // Ignore cmd or ctrl clicks - neither of these should set nested menus open
        if (!event.metaKey && !event.ctrlKey) setTimeout(()=>{
            setScrollableNestedMenu(true);
            setNestedMenuOpen(true);
            setReportsIssuesOpen(true);
        });
    }, [
        setNestedMenuOpen
    ]);
    const nonExpandableSectionNestedOnClick = (0, $5uXOq.useCallback)((event)=>{
        // Ignore cmd or ctrl clicks - neither of these should set nested menus open
        if (!event.metaKey && !event.ctrlKey) {
            setHideExpandableSections(true); // Wait till event loop finishes before setting nested menu open
            // without this, we get a little bit of jank transitioning back to the
            // main sidebar.
            // *issue presisted when using requestAnimationFrame in lieu of setTimeout
            setTimeout(()=>setNestedMenuOpen(true));
        }
    }, [
        setHideExpandableSections,
        setNestedMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const newStack = $cb9d120cac330869$var$calculateStack(route, connectStack, forgeStack);
        setStack(newStack);
        setProjectGroupActive($cb9d120cac330869$var$calculateProjectGroupActive(route));
        setNestedMenuOpen(newStack.includes((0, $hADcq.SECTION_ID).REPORTS) || newStack.includes((0, $hADcq.SECTION_ID).ISSUES) || newStack.includes((0, $hADcq.SECTION_ID).SETTINGS) || nestedEcosystemAppOpen);
        setReportsIssuesOpen($cb9d120cac330869$var$isReportsIssuesOpen(route));
        setHideExpandableSections(newStack.includes((0, $hADcq.SECTION_ID).SETTINGS) || nestedEcosystemAppOpen);
    }, [
        route,
        connectStack,
        forgeStack,
        nestedEcosystemAppOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setMultipleNavModulesActive($cb9d120cac330869$var$hasMultipleNavModulesActive(features));
    }, [
        features
    ]);
    const getBackMenuItem = (0, $5uXOq.useCallback)((preventNavigation = false)=>{
        const isDisabled = false && !board;
        let backUrl = project && !isDisabled ? `/browse/${project.key}` : undefined;
        if (project && board) backUrl = `/jira/software/c/projects/${project.key}/boards/${board.id}`;
        return {
            isDisabled: // @ts-expect-error - 'isDisabled' does not exist in BackMenuItem props
            isDisabled,
            href: backUrl,
            title: formatMessage((0, $dvdrL.default).backItem),
            onClick: (event)=>{
                // on a board-less project we allow to go back without changing url
                // as we don't know where to land :(
                if (!board || preventNavigation) event.preventDefault();
                 // Only reset state items if we're _not_ navigating - the navigation will reset these items automatically
                // This also stops some janky behavior in Safari.
                if (preventNavigation) // wait for the event loop to end so in the instance this back menu item appears in the
                // Project group wrapper - without this the blue background appears too soon.
                setTimeout(()=>{
                    setReportsIssuesOpen(false);
                    setNestedMenuOpen(false);
                    setScrollableNestedMenu(false);
                    setHideExpandableSections(false);
                });
            }
        };
    }, [
        board,
        project,
        formatMessage,
        setReportsIssuesOpen,
        setNestedMenuOpen,
        setScrollableNestedMenu,
        setHideExpandableSections
    ]);
    const multiProductUpgradeProps = (0, $lRM9B.useMultiProductUpgrade)();
    const { data: incidentExperimentTraits } = (0, $cF0ZN.useIncidentExperimentTraits)();
    if (project == null || features == null || connectItems == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const showOperationsSection = !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && (features.hasDeployments || features.hasOpsgenieSchedule || features.hasIncidents && (incidentExperimentTraits && (0, $20Eax.default)(incidentExperimentTraits) || (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira')));
    const showDevelopmentSection = !(0, $b4PzF.isFedRamp)() && (features.hasComponents || features.hasCode || features.hasSecurity || features.hasDevelopment || features.hasReleases);
    const showCodeNavigationLink = !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && features.hasCode;
    const showSecurityNavigationLink = !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && features.hasSecurity;
    const showDevelopmentNavigationLink = (0, $4R6GH.fg)('guava_development_page_in_jira_enabled') ? !(0, $b4PzF.isFedRamp)() && features.hasDevelopment && (0, $4R6GH.fg)('jira-periscope-new-page') : !(0, $b4PzF.isFedRamp)() && (0, $4R6GH.fg)('jira-periscope-new-page');
    const showIncidentsNavigationLink = !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && features.hasIncidents && (incidentExperimentTraits && (0, $20Eax.default)(incidentExperimentTraits) || (0, $4R6GH.fg)('corex_operandi_incidents_page_in_jira'));
    const projectType = project && (0, $2vSU6.toProjectType)(project.type);
    const showMultiProductUpgradeModal = projectType && projectType === (0, $2vSU6.SOFTWARE_PROJECT) && !multiProductUpgradeProps.isLoading && multiProductUpgradeProps.isEnrolled;
    const reportsHrefWithBoard = `/jira/software/c/projects/${project.key}/boards/${board?.id}/reports`;
    const reportsHrefBoardless = `/jira/software/c/projects/${project.key}/reports`;
    const reportsNewHref = board ? reportsHrefWithBoard : reportsHrefBoardless;
    const timelineHref = `/jira/software/c/projects/${project.key}/boards/${board?.id}/timeline`;
    const backlogHref = `/jira/software/c/projects/${project.key}/boards/${board?.id}/backlog`;
    const boardHref = `/jira/software/c/projects/${project.key}/boards/${board?.id}`;
    const reportsHref = (0, $4R6GH.fg)('reports-overview-page-migration') ? reportsNewHref : `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    const listHref = `/jira/software/c/projects/${project.key}/list`;
    const calendarHref = `/jira/software/c/projects/${project.key}/boards/${board?.id}/calendar`;
    const summaryHref = `/jira/software/c/projects/${project.key}/summary`;
    const shouldRenderFormItem = ()=>(0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && features.hasForms;
    const ssrPlaceholderEnabledRoutes = [
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') ? [
            'issue-navigator-classic'
        ] : [],
        ...(0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nav_for_iv') ? [
            'issue'
        ] : [],
        ...(0, $4R6GH.fg)('add_nav_ssr_placeholder_for_board_and_backlog') ? [
            'rapidboard-board',
            'rapidboard-backlog'
        ] : []
    ];
    if ((0, $4R6GH.fg)('issue_terminology_refresh_change_boarding_modal')) {
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'projectOrIssuePage',
            action: 'viewed'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectOrIssueScreen');
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.ContextualAnalyticsData), {
        menuId: (0, $hADcq.MENU_ID),
        stack: stack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2zFxf.default), {
        label: "",
        isServer: false,
        isSSRPlaceholderEnabled: ssrPlaceholderEnabledRoutes.includes(route.name)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bNEt5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jsw_inline_config_project_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$ConfigurableProjectHeader, {
        avatarUrl: project.avatarUrl,
        description: formatMessage((0, $dvdrL.default).headerDescriptionCompanyManaged),
        name: project.name,
        projectId: project.id
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l468O.ProjectHeader), {
        description: formatMessage((0, $dvdrL.default).headerDescriptionCompanyManaged),
        avatarUrl: project.avatarUrl,
        name: project.name
    }), (0, $4R6GH.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c162r.CustomTemplateInlineMessage), {
        isLiveTemplate: project.isLiveTemplate
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showMultiProductUpgradeModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7642.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkNvt.AsyncMultiProductUpgradeModal), multiProductUpgradeProps))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a4hJx.default), {
        stack: stack,
        onChange: setStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationExpandableContentWrapper), {
        nestedAppOpen: hideExpandableSections,
        submenuActive: nestedMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2iZU.ScreenReaderMenuHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        context: "classic",
        headingLevel: 3,
        title: multipleNavModulesActive ? formatMessage((0, $dvdrL.default).planningModule) : undefined,
        submenuActive: nestedMenuActive,
        isCollapsed: navModuleCollapseState.planning.isCollapsed && !reportsIssuesOpen,
        expandClick: setNavModulesCollapseStateLocalStoragePlanning,
        removeTitleSection: !multipleNavModulesActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$ProjectGroupWrapper, {
        active: projectGroupActive && !nestedMenuActive,
        submenuOpen: nestedMenuActive,
        forceScrollableNestedMenu: scrollableNestedMenu,
        positionForExpandableSection: multipleNavModulesActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EMGV.ScopeSwitcher), null), board && features.hasRoadmap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'roadmap'
        },
        selectedOn: [
            'software-timeline-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fVgSt))), {
            spacing: "spacious",
            label: ""
        }),
        href: timelineHref,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.roadmap-link"
    }, formatMessage((0, $dvdrL.default).timelineItem)), board && features.hasBacklog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: `backlog-${board.type}`
        },
        selectedOn: [
            'rapidboard-backlog',
            'legacy-backlog'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lKJPg))), {
            spacing: "spacious",
            label: ""
        }),
        to: backlogHref,
        prefetch: "hover",
        onClick: __SPA__ ? undefined : (0, $egnSq.handleRapidboardSPAClick)('plan'),
        testId: "navigation-apps-sidebar-software-classic.ui.menu.backlog-link"
    }, formatMessage((0, $dvdrL.default).backlogItem)), board && features.hasBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: `board-${board.type}`
        },
        selectedOn: [
            'rapidboard-board',
            'legacy-board'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
            spacing: "spacious",
            label: ""
        }),
        to: boardHref,
        prefetch: "hover",
        onClick: __SPA__ ? undefined : (0, $egnSq.handleRapidboardSPAClick)('work'),
        testId: "navigation-apps-sidebar-software-classic.ui.menu.board-link"
    }, formatMessage(board.type === (0, $976eff6d67d3515b$export$4498412e32a31fb6) ? (0, $dvdrL.default).scrumBoard : (0, $dvdrL.default).kanbanBoard)), board && features.hasCalendar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'calendar'
        },
        selectedOn: [
            'software-calendar-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2VmPP))), {
            spacing: "spacious",
            label: ""
        }),
        to: calendarHref,
        prefetch: "hover",
        testId: "navigation-apps-sidebar-software-classic.ui.menu.calendar-link"
    }, formatMessage((0, $dvdrL.default).calendarItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'reports'
        },
        href: !(0, $4R6GH.fg)('reports-overview-page-migration') ? reportsHref : undefined,
        to: (0, $4R6GH.fg)('reports-overview-page-migration') ? reportsHref : undefined,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4KUYb))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: reportsNestedItemOnClick,
        id: (0, $hADcq.SECTION_ID).REPORTS,
        overrides: {
            BackMenuItem: getBackMenuItem(true)
        },
        prefetch: (0, $4R6GH.fg)('reports-overview-page-migration') ? 'hover' : false,
        selectedOn: [
            ...(0, $4R6GH.fg)('reports-overview-page-migration') ? [
                'software-reports',
                'software-reports-boardless',
                'software-reports-velocity-cmp'
            ] : [],
            'rapidboard-report',
            'legacy-custom-report',
            'legacy-all-reports',
            'legacy-reports-configure',
            'legacy-reports-average-age-report',
            'legacy-reports-created-vs-resolved-report',
            'legacy-reports-pie-report',
            'legacy-reports-recently-created-report',
            'legacy-reports-resolution-time-report',
            'legacy-reports-single-level-group-by-report',
            'legacy-reports-time-since-report',
            'legacy-reports-time-tracking-report',
            'legacy-reports-developer-workload-report',
            'legacy-reports-version-workload-report',
            'legacy-reports-workload-pie-report',
            'software-reports-cycle-time-classic',
            'software-reports-deployment-frequency-classic'
        ],
        title: formatMessage((0, $dvdrL.default).reportsItem),
        testId: "navigation-apps-sidebar-software-classic.ui.menu.reports-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pPua.Reports), {
        connectItems: connectReportsItems
    }))), projectType === (0, $2vSU6.SOFTWARE_PROJECT) && (0, $6s1PB.expVal)('helios_summary_page_experiment', 'isEnabled', false) && features.hasSummaryPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: [
            'software-summary-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3pK7p))), {
            label: "",
            color: "currentColor"
        }),
        href: summaryHref,
        "data-testid": "navigation-apps-sidebar-software-classic.ui.menu.summary-link"
    }, formatMessage((0, $dvdrL.default).summaryItem)), features.hasList && (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'list'
        },
        selectedOn: [
            'software-list-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($044lR))), {
            spacing: "spacious",
            label: ""
        }),
        href: listHref,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.list-link"
    }, formatMessage((0, $dvdrL.default).listItem)), shouldRenderFormItem() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'forms'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ddl7e))), {
            label: "",
            color: "currentColor"
        }),
        href: `/jira/software/c/projects/${project.key}/form`,
        selectedOn: [
            'software-form-classic',
            'software-form-builder-classic'
        ],
        "data-testid": "navigation-apps-sidebar-software-classic.ui.menu.software-forms-link"
    }, formatMessage((0, $dvdrL.default).formsItem)), features.hasGoals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'goals'
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GbRa.GoalIcon), null),
        href: `/jira/software/c/projects/${project.key}/goals`,
        selectedOn: [
            'software-goals-classic'
        ],
        "data-testid": "navigation-apps-sidebar-software-classic.ui.menu.software-goals-link"
    }, formatMessage((0, $dvdrL.default).goalsItem)), (0, $3SzZi.shouldRenderNesting)(features.hasIssues, stack, (0, $hADcq.SECTION_ID).ISSUES) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juTur.IssuesContextualAnalyticsData), {
        navigatorScope: "project"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'project-issue-navigator'
        },
        href: `/jira/software/c/projects/${project.key}/issues`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQJCJ))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: nestedMenuItemOnClick,
        id: (0, $hADcq.SECTION_ID).ISSUES,
        overrides: {
            BackMenuItem: getBackMenuItem(true)
        },
        selectedOn: [
            'issue-navigator',
            'issue-navigator-classic',
            'issue'
        ],
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dvdrL.default).ninItemIssueTermRefresh : (0, $dvdrL.default).ninItem)),
        testId: "navigation-apps-sidebar-software-classic.ui.menu.issues-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jsI7v.Issues), {
        projectKey: project.key,
        pinUrl: `/jira/software/c/projects/${project.key}/issues/?filter=`,
        titleHeaderText: formatMessage((0, $dvdrL.default).newNinNestedMenuItemTitleHeader)
    })))), showDevelopmentSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        headingLevel: 3,
        title: formatMessage((0, $dvdrL.default).developmentModule),
        submenuActive: nestedMenuActive,
        isCollapsed: navModuleCollapseState.development.isCollapsed,
        expandClick: setNavModulesCollapseStateLocalStorageDevelopment
    }, features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'components'
        },
        selectedOn: [
            'project-components'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxg6i))), {
            spacing: "spacious",
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/components`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.components-link-development"
    }, formatMessage((0, $dvdrL.default).componentsItem), (0, $4R6GH.fg)('jsw_component_link_recommended_lozenge') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $dvdrL.default).recommended)))), showDevelopmentNavigationLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "periscopeMenuItem",
        teamName: "nova",
        packageName: "jiraNavigationAppsSidebarSoftwareClassic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'periscope'
        },
        selectedOn: [
            'software-periscope-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cu8LJ))), {
            label: "",
            color: "currentColor"
        }),
        href: `/jira/software/c/projects/${project.key}/development`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.work-suggestions-link"
    }, formatMessage((0, $dvdrL.default).periscopeItemNonFinal), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $dvdrL.default).beta))))), showCodeNavigationLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: "spotlight-sidebar-code-classic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'code',
            // @ts-expect-error TS2322 | TS2322 - Type '{ itemId: string; nextgen: true; projectId: any; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'. | Type '{ itemId: string; nextgen: true; projectId: any; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'.
            nextgen: true,
            projectId: project.id
        },
        selectedOn: [
            'software-code-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($af7Zc))), {
            spacing: "spacious",
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/code`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.code-link"
    }, formatMessage((0, $dvdrL.default).codeItem)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "codeNavigationItem",
        attributes: {
            nextgen: false
        },
        action: "viewed"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-code-classic"
    })), showSecurityNavigationLink && (0, $4R6GH.fg)('isotopes-security-page-in-jira-enabled-v2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: [
            'software-security-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($62UZ9))), {
            spacing: "spacious",
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/security`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.security-link"
    }, formatMessage((0, $dvdrL.default).securityItem)), features.hasReleases && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "releasesMenuItem" // Fusion Solaris owns this particular menu item
        ,
        teamName: "fusion-solaris",
        packageName: "navigationAppsSidebarSoftwareClassic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l5Ald.ReleasesMenuItem), {
        projectKey: project.key,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.releases-link"
    }))), showOperationsSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jvcra.ExpandableSection), {
        headingLevel: 3,
        title: formatMessage((0, $dvdrL.default).operationsModule),
        submenuActive: nestedMenuActive,
        isCollapsed: navModuleCollapseState.operations.isCollapsed,
        expandClick: setNavModulesCollapseStateLocalStorageOperations
    }, features.hasDeployments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "deploymentsMenuItem" // Fusion Solaris owns this particular menu item
        ,
        teamName: "fusion-solaris",
        packageName: "navigationAppsSidebarSoftwareClassic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69H2H.DeploymentsMenuItem), {
        projectKey: project.key,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.deployments-link"
    })), features.hasOpsgenieSchedule && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie',
            // @ts-expect-error TS2322 | TS2322 - Type '{ itemId: string; nextgen: true; projectId: any; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'. | Type '{ itemId: string; nextgen: true; projectId: any; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'.
            nextgen: true,
            projectId: project.id
        },
        selectedOn: [
            'opsgenie-schedule'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73Ebi.OnCallIcon), {
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/on-call-schedule`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.on-call-link"
    }, formatMessage((0, $dvdrL.default).opsgenieItem)), showIncidentsNavigationLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: [
            'software-incidents-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5E93O))), {
            spacing: "spacious",
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/incidents`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.incidents-link"
    }, formatMessage((0, $dvdrL.default).incidentsItem), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $dvdrL.default).beta)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: nestedMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.ShortCutsAndAppsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QTQ5.Shortcuts), {
        canAddItem: features.hasShortcutsAdd,
        canAddLinks: true,
        canAddRepositories: true,
        projectKey: project.key,
        projectId: project.id,
        pagesLink: projectPagesData,
        hasPages: features.hasPages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zgGo.ForgeProjectSection), {
        nestedMenuActive: nestedMenuActive,
        overrides: {
            BackMenuItem: getBackMenuItem(true),
            ParentMenuItem: {
                onClick: nonExpandableSectionNestedOnClick
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tHFY.ConnectMenu), {
        items: connectItems,
        showIcons: true,
        overrides: {
            BackMenuItem: getBackMenuItem(true),
            // @ts-expect-error - 'ParentMenuItem' does not exist in ConnectMenu props
            ParentMenuItem: {
                onClick: nonExpandableSectionNestedOnClick
            }
        }
    })), (0, $3SzZi.shouldRenderNesting)(features.hasSettings, stack, (0, $hADcq.SECTION_ID).SETTINGS) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'settings'
        },
        href: `/jira/software/c/projects/${project.key}/settings`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dnGcR))), {
            spacing: "spacious",
            label: ""
        }),
        onClick: nonExpandableSectionNestedOnClick,
        id: (0, $hADcq.SECTION_ID).SETTINGS,
        overrides: {
            BackMenuItem: getBackMenuItem()
        },
        selectedOn: [
            'classic-software-details'
        ],
        title: formatMessage((0, $dvdrL.default).projectSettingsItem),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.project-settings-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        eventName: "classicProjectSettingsSidebar viewed",
        attributes: {
            isAdmin: isAdmin
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fzMyx.Settings), {
        ecosystemItems: ecosystemItems
    })))), ((0, $4R6GH.fg)('archived_issues_in_nav4_sidebar') ? features?.hasArchivedIssues === true : true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'archives'
        },
        selectedOn: [
            'archived-issues-directory'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7mIBt))), {
            spacing: "spacious",
            label: ""
        }),
        href: `/jira/software/c/projects/${project.key}/issues/archive`,
        testId: "navigation-apps-sidebar-software-classic.ui.menu.archives-link"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dvdrL.default).itemArchivesIssueTermRefresh : (0, $dvdrL.default).itemArchives), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb9d120cac330869$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $dvdrL.default).new))))) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZzwP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aImhn.JswSideNavRecommendation), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3QUEt.Footer), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jineK.RegisterProjectNavigationCommands), {
        timelineHref: timelineHref,
        backlogHref: backlogHref,
        boardHref: boardHref,
        reportsHref: reportsHref,
        features: {
            hasBacklog: board !== null && features.hasBacklog,
            hasBoard: board !== null && features.hasBoard,
            hasReports: board !== null,
            hasRoadmap: board !== null && features.hasRoadmap
        }
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $cb9d120cac330869$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $cb9d120cac330869$var$ProjectGroupWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuOpen: submenuOpen, active: active, forceScrollableNestedMenu: forceScrollableNestedMenu, positionForExpandableSection: positionForExpandableSection, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_suoboi": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 2.666), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1kw7 _vpnrdlk8 _170sdlk8 _1dmddlk8 _289118uv _ivyj18uv _l35r18uv _kbs15oil _167o5oil _l3461ylp _e3poglyw _uzloi7a9",
            __cmplp.submenuOpen && !__cmplp.active && !__cmplp.forceScrollableNestedMenu || !__cmplp.submenuOpen ? "_4t3i1wug" : "_4t3i1osq",
            !__cmplp.positionForExpandableSection ? "_1bsb54a6" : "_1bsb1osq",
            __cmplp.submenuOpen ? "_2rkoidpf" : "_2rko17ff",
            __cmplp.submenuOpen ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44",
            __cmplp.submenuOpen ? "_otyridpf" : "_otyr1y44",
            !__cmplp.submenuOpen ? "_18u01d7o" : "_18u0idpf",
            __cmplp.active ? "_1xppi1yw _jr1di1yw _8ki2i1yw _u8nbi1yw _ifqzi1yw _1nkli1yw" : "_1xppfg4m _jr1dfg4m _8ki2fg4m _u8nbfg4m _ifqzfg4m _1nklfg4m",
            __cmplp.active && (0, $4R6GH.fg)('blu-6205_nav3_sidebar_a11y_fix') && "_1g32pnps _p3ogpnps _62qdpnps",
            __cmplp.active ? "_19gpaqb7" : "_19gp1kw7",
            __cmplp.submenuOpen && "_bfhk1hed",
            !__cmplp.submenuOpen && __cmplp.active && "_bfhkfg4m",
            !__cmplp.submenuOpen && !__cmplp.active && "_bfhkm7j4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ddl7e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f6cd595d4ec67af9dd83acc02e35c9f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99ecde63fa3b9455$var$_react = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $99ecde63fa3b9455$var$_baseNew = $99ecde63fa3b9455$var$_interopRequireDefault((parcelRequire("enEmH")));
function $99ecde63fa3b9455$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Form".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Represents forms across Atlassian products, including Proforma.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99ecde63fa3b9455$var$FormIcon = (props)=>/*#__PURE__*/ $99ecde63fa3b9455$var$_react.default.createElement($99ecde63fa3b9455$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.5H1V0h6zM1 3.875c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75C15 6.385 14.384 7 13.625 7H2.375C1.615 7 1 6.384 1 5.625zM2.5 4v1.5h11V4zM7 10.5H1V9h6zm-6 2.375c0-.76.616-1.375 1.375-1.375h11.25c.76 0 1.375.616 1.375 1.375v1.75c0 .76-.616 1.375-1.375 1.375H2.375C1.615 16 1 15.384 1 14.625zM2.5 13v1.5h11V13z" clip-rule="evenodd"/>`
    }, props));
$99ecde63fa3b9455$var$FormIcon.displayName = 'FormIcon';
var $99ecde63fa3b9455$var$_default = module.exports.default = $99ecde63fa3b9455$var$FormIcon;

});

parcelRegister("7mIBt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::542b8587e912458cb1fe6aa28ca83d10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55cd2fc561012e90$var$_react = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $55cd2fc561012e90$var$_archiveBox = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("lgPyf")));

var $55cd2fc561012e90$var$_archive = $55cd2fc561012e90$var$_interopRequireDefault((parcelRequire("wjLwN")));
function $55cd2fc561012e90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArchiveBoxIcon.
 * This component is ArchiveBoxIcon, with `UNSAFE_fallbackIcon` set to "ArchiveIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55cd2fc561012e90$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $55cd2fc561012e90$var$_react.default.createElement($55cd2fc561012e90$var$_archiveBox.default, Object.assign({
        LEGACY_fallbackIcon: $55cd2fc561012e90$var$_archive.default
    }, props));
$55cd2fc561012e90$var$ArchiveBoxIcon.Name = 'ArchiveBoxIconMigration';
var $55cd2fc561012e90$var$_default = module.exports.default = $55cd2fc561012e90$var$ArchiveBoxIcon;

});
parcelRegister("lgPyf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7c314a31c145780$var$_react = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f7c314a31c145780$var$_baseNew = $f7c314a31c145780$var$_interopRequireDefault((parcelRequire("enEmH")));
function $f7c314a31c145780$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7c314a31c145780$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $f7c314a31c145780$var$_react.default.createElement($f7c314a31c145780$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$f7c314a31c145780$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $f7c314a31c145780$var$_default = module.exports.default = $f7c314a31c145780$var$ArchiveBoxIcon;

});

parcelRegister("wjLwN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0612524e773ce519$var$_react = $0612524e773ce519$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0612524e773ce519$var$_archiveBox = $0612524e773ce519$var$_interopRequireDefault((parcelRequire("lgPyf")));
function $0612524e773ce519$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0612524e773ce519$var$ArchiveIcon = (props)=>/*#__PURE__*/ $0612524e773ce519$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 3H4.85A2 2 0 0 0 3 5v4h1v10.45A1.67 1.67 0 0 0 5.77 21h12.46A1.67 1.67 0 0 0 20 19.45V9h1V5a2 2 0 0 0-2-2m-1 16H6V9h12zm1-12H5V5h14zm-4 7H9v-2h6z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $0612524e773ce519$var$_archiveBox.default
    }));
$0612524e773ce519$var$ArchiveIcon.displayName = 'ArchiveIcon';
var $0612524e773ce519$var$_default = module.exports.default = $0612524e773ce519$var$ArchiveIcon;

});


parcelRegister("2VmPP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22129e2c287d5de4$var$_react = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $22129e2c287d5de4$var$_calendar = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("iTgNO")));

var $22129e2c287d5de4$var$_calendar2 = $22129e2c287d5de4$var$_interopRequireDefault((parcelRequire("kqwhU")));
function $22129e2c287d5de4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22129e2c287d5de4$var$CalendarIcon = (props)=>/*#__PURE__*/ $22129e2c287d5de4$var$_react.default.createElement($22129e2c287d5de4$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $22129e2c287d5de4$var$_calendar2.default
    }, props));
$22129e2c287d5de4$var$CalendarIcon.Name = 'CalendarIconMigration';
var $22129e2c287d5de4$var$_default = module.exports.default = $22129e2c287d5de4$var$CalendarIcon;

});
parcelRegister("iTgNO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dc0a65a8f23cfe26$var$_react = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $dc0a65a8f23cfe26$var$_baseNew = $dc0a65a8f23cfe26$var$_interopRequireDefault((parcelRequire("enEmH")));
function $dc0a65a8f23cfe26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dc0a65a8f23cfe26$var$CalendarIcon = (props)=>/*#__PURE__*/ $dc0a65a8f23cfe26$var$_react.default.createElement($dc0a65a8f23cfe26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$dc0a65a8f23cfe26$var$CalendarIcon.displayName = 'CalendarIcon';
var $dc0a65a8f23cfe26$var$_default = module.exports.default = $dc0a65a8f23cfe26$var$CalendarIcon;

});

parcelRegister("kqwhU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edef480bec250815$var$_react = $edef480bec250815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $edef480bec250815$var$_calendar = $edef480bec250815$var$_interopRequireDefault((parcelRequire("iTgNO")));
function $edef480bec250815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $edef480bec250815$var$CalendarIcon = (props)=>/*#__PURE__*/ $edef480bec250815$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $edef480bec250815$var$_calendar.default
    }));
$edef480bec250815$var$CalendarIcon.displayName = 'CalendarIcon';
var $edef480bec250815$var$_default = module.exports.default = $edef480bec250815$var$CalendarIcon;

});


parcelRegister("af7Zc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::892203c72b828429279b82b0b7182ba7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $77517ff8b1b9e4eb$var$_react = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $77517ff8b1b9e4eb$var$_angleBrackets = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("elXz8")));

var $77517ff8b1b9e4eb$var$_code = $77517ff8b1b9e4eb$var$_interopRequireDefault((parcelRequire("7Vx4o")));
function $77517ff8b1b9e4eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $77517ff8b1b9e4eb$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $77517ff8b1b9e4eb$var$_react.default.createElement($77517ff8b1b9e4eb$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $77517ff8b1b9e4eb$var$_code.default
    }, props));
$77517ff8b1b9e4eb$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $77517ff8b1b9e4eb$var$_default = module.exports.default = $77517ff8b1b9e4eb$var$AngleBracketsIcon;

});
parcelRegister("elXz8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::196b600e7960a1af1a5f6fffc09ddaa0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7313b5c9f1080d6$var$_react = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a7313b5c9f1080d6$var$_baseNew = $a7313b5c9f1080d6$var$_interopRequireDefault((parcelRequire("enEmH")));
function $a7313b5c9f1080d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a7313b5c9f1080d6$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $a7313b5c9f1080d6$var$_react.default.createElement($a7313b5c9f1080d6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.315 14.445 6-13.5 1.37.61-6 13.5zM13.982 10l-2.925 2.145.886 1.21 3.75-2.75a.75.75 0 0 0 0-1.21l-3.75-2.75-.886 1.21zM2.018 6l2.926 2.145-.888 1.21-3.75-2.75a.75.75 0 0 1 0-1.21l3.75-2.75.888 1.21z" clip-rule="evenodd"/>`
    }, props));
$a7313b5c9f1080d6$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $a7313b5c9f1080d6$var$_default = module.exports.default = $a7313b5c9f1080d6$var$AngleBracketsIcon;

});

parcelRegister("7Vx4o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c57823dfa4237dd$var$_react = $5c57823dfa4237dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5c57823dfa4237dd$var$_angleBrackets = $5c57823dfa4237dd$var$_interopRequireDefault((parcelRequire("elXz8")));
function $5c57823dfa4237dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5c57823dfa4237dd$var$CodeIcon = (props)=>/*#__PURE__*/ $5c57823dfa4237dd$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $5c57823dfa4237dd$var$_angleBrackets.default
    }));
$5c57823dfa4237dd$var$CodeIcon.displayName = 'CodeIcon';
var $5c57823dfa4237dd$var$_default = module.exports.default = $5c57823dfa4237dd$var$CodeIcon;

});


parcelRegister("fxg6i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afb010b77a3674d977e5adddea745303>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f66d54b6c02996$var$_react = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b4f66d54b6c02996$var$_component = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("gLsrb")));

var $b4f66d54b6c02996$var$_component2 = $b4f66d54b6c02996$var$_interopRequireDefault((parcelRequire("btAaL")));
function $b4f66d54b6c02996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ComponentIcon.
 * This component is ComponentIcon, with `UNSAFE_fallbackIcon` set to "ComponentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f66d54b6c02996$var$ComponentIcon = (props)=>/*#__PURE__*/ $b4f66d54b6c02996$var$_react.default.createElement($b4f66d54b6c02996$var$_component.default, Object.assign({
        LEGACY_fallbackIcon: $b4f66d54b6c02996$var$_component2.default
    }, props));
$b4f66d54b6c02996$var$ComponentIcon.Name = 'ComponentIconMigration';
var $b4f66d54b6c02996$var$_default = module.exports.default = $b4f66d54b6c02996$var$ComponentIcon;

});
parcelRegister("gLsrb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b85e957a451f01111d5005fe7bfa754b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3471833a6d190d1$var$_react = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3471833a6d190d1$var$_baseNew = $c3471833a6d190d1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $c3471833a6d190d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Component".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for components in Jira and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3471833a6d190d1$var$ComponentIcon = (props)=>/*#__PURE__*/ $c3471833a6d190d1$var$_react.default.createElement($c3471833a6d190d1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.75A.75.75 0 0 1 2.75 2h3.5a.75.75 0 0 1 .75.75V4.5h2V2.75A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75V4.5a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6.5a2 2 0 0 1 2-2zM3.5 4.5h2v-1h-2zm9 0v-1h-2v1zM2 6a.5.5 0 0 0-.5.5V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5A.5.5 0 0 0 14 6z" clip-rule="evenodd"/>`
    }, props));
$c3471833a6d190d1$var$ComponentIcon.displayName = 'ComponentIcon';
var $c3471833a6d190d1$var$_default = module.exports.default = $c3471833a6d190d1$var$ComponentIcon;

});

parcelRegister("btAaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85ae7647340a2223$var$_react = $85ae7647340a2223$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $85ae7647340a2223$var$_component = $85ae7647340a2223$var$_interopRequireDefault((parcelRequire("gLsrb")));
function $85ae7647340a2223$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85ae7647340a2223$var$ComponentIcon = (props)=>/*#__PURE__*/ $85ae7647340a2223$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991M3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991z"/><path d="M7 8.34h2V6.67H7zM5 6.67C5 5.75 5.9 5 7 5h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.66-2 1.66H7c-1.11 0-2-.75-2-1.66zm10 1.67h2V6.67h-2zm-2-1.67c0-.92.9-1.67 2-1.67h2c1.11 0 2 .75 2 1.67v1.67c0 .92-.9 1.67-2 1.67h-2c-1.11-.01-2-.76-2-1.67z"/></g></svg>`
    }, props, {
        newIcon: $85ae7647340a2223$var$_component.default
    }));
$85ae7647340a2223$var$ComponentIcon.displayName = 'ComponentIcon';
var $85ae7647340a2223$var$_default = module.exports.default = $85ae7647340a2223$var$ComponentIcon;

});


parcelRegister("4KUYb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3767a65103c7d22a$var$_react = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3767a65103c7d22a$var$_chartTrend = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("g95pD")));

var $3767a65103c7d22a$var$_graphLine = $3767a65103c7d22a$var$_interopRequireDefault((parcelRequire("6tgIY")));
function $3767a65103c7d22a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3767a65103c7d22a$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $3767a65103c7d22a$var$_react.default.createElement($3767a65103c7d22a$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $3767a65103c7d22a$var$_graphLine.default
    }, props));
$3767a65103c7d22a$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $3767a65103c7d22a$var$_default = module.exports.default = $3767a65103c7d22a$var$ChartTrendIcon;

});
parcelRegister("6tgIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $013743d1004a6124$var$_react = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $013743d1004a6124$var$_chartTrend = $013743d1004a6124$var$_interopRequireDefault((parcelRequire("g95pD")));
function $013743d1004a6124$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $013743d1004a6124$var$GraphLineIcon = (props)=>/*#__PURE__*/ $013743d1004a6124$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $013743d1004a6124$var$_chartTrend.default
    }));
$013743d1004a6124$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $013743d1004a6124$var$_default = module.exports.default = $013743d1004a6124$var$GraphLineIcon;

});


parcelRegister("62UZ9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $466f220dfb291cc3$var$_react = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $466f220dfb291cc3$var$_lockLocked = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("5DSGX")));

var $466f220dfb291cc3$var$_lock = $466f220dfb291cc3$var$_interopRequireDefault((parcelRequire("cln90")));
function $466f220dfb291cc3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $466f220dfb291cc3$var$LockLockedIcon = (props)=>/*#__PURE__*/ $466f220dfb291cc3$var$_react.default.createElement($466f220dfb291cc3$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $466f220dfb291cc3$var$_lock.default
    }, props));
$466f220dfb291cc3$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $466f220dfb291cc3$var$_default = module.exports.default = $466f220dfb291cc3$var$LockLockedIcon;

});
parcelRegister("5DSGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $41bb04ef30194277$var$_react = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $41bb04ef30194277$var$_baseNew = $41bb04ef30194277$var$_interopRequireDefault((parcelRequire("enEmH")));
function $41bb04ef30194277$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $41bb04ef30194277$var$LockLockedIcon = (props)=>/*#__PURE__*/ $41bb04ef30194277$var$_react.default.createElement($41bb04ef30194277$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$41bb04ef30194277$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $41bb04ef30194277$var$_default = module.exports.default = $41bb04ef30194277$var$LockLockedIcon;

});

parcelRegister("cln90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fc9662f19240bd3$var$_react = $8fc9662f19240bd3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $8fc9662f19240bd3$var$_lockLocked = $8fc9662f19240bd3$var$_interopRequireDefault((parcelRequire("5DSGX")));
function $8fc9662f19240bd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8fc9662f19240bd3$var$LockIcon = (props)=>/*#__PURE__*/ $8fc9662f19240bd3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $8fc9662f19240bd3$var$_lockLocked.default
    }));
$8fc9662f19240bd3$var$LockIcon.displayName = 'LockIcon';
var $8fc9662f19240bd3$var$_default = module.exports.default = $8fc9662f19240bd3$var$LockIcon;

});


parcelRegister("5ZzwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a61c4dfff08e7bae$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $a61c4dfff08e7bae$var$styles = {
    navigationFooter: "_kqswh2mm"
};
/**
 * __Navigation footer__
 *
 * Allows for customisation of the footer.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $a61c4dfff08e7bae$var$NavigationFooter = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        padding: "space.100",
        paddingBlockEnd: "space.200",
        xcss: $a61c4dfff08e7bae$var$styles.navigationFooter,
        children: children
    });
};
var $a61c4dfff08e7bae$export$2e2bcd8739ae039 = $a61c4dfff08e7bae$var$NavigationFooter;

});

parcelRegister("bNEt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $17ac19a84e29fc0b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5sRpy = parcelRequire("5sRpy");
const $17ac19a84e29fc0b$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $17ac19a84e29fc0b$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        xcss: $17ac19a84e29fc0b$var$styles.navigationFooter,
        "data-navheader": true,
        children: children
    });
};
var $17ac19a84e29fc0b$export$2e2bcd8739ae039 = $17ac19a84e29fc0b$var$NavigationHeader;

});

parcelRegister("a4hJx", function(module, exports) {

$parcel$export(module.exports, "ROOT_ID", () => $60ed2743269ce34a$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $60ed2743269ce34a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7xhdA = parcelRequire("7xhdA");

var $fHpHg = parcelRequire("fHpHg");

var $79Hag = parcelRequire("79Hag");

var $65Cwx = parcelRequire("65Cwx");

var $4bO8w = parcelRequire("4bO8w");

var $fsi33 = parcelRequire("fsi33");

var $atNen = parcelRequire("atNen");
const $60ed2743269ce34a$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $60ed2743269ce34a$var$nestableNavigationContentStyles = null;
const $60ed2743269ce34a$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $60ed2743269ce34a$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $5uXOq.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $60ed2743269ce34a$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $5uXOq.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $5uXOq.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $79Hag.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $4bO8w.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $5uXOq.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $60ed2743269ce34a$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $bwpsq.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xhdA.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $atNen.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ...motion,
                            className: (0, $bwpsq.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fsi33.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $65Cwx.default), {
                                    title: "",
                                    id: $60ed2743269ce34a$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $60ed2743269ce34a$export$2e2bcd8739ae039 = $60ed2743269ce34a$var$NestableNavigationContent;

});
parcelRegister("79Hag", function(module, exports) {

$parcel$export(module.exports, "default", () => $46dfc43720f75948$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3xWPD = parcelRequire("3xWPD");


var $4iTJw = parcelRequire("4iTJw");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $46dfc43720f75948$var$GoBackItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        cssFn: cssFn,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $46dfc43720f75948$export$2e2bcd8739ae039 = $46dfc43720f75948$var$GoBackItem;

});
parcelRegister("3xWPD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19a10e1149a5b84d93e6a05c6f1be0d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295216f354fff637$var$_react = $295216f354fff637$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $295216f354fff637$var$_arrowLeft = $295216f354fff637$var$_interopRequireDefault((parcelRequire("kmtfL")));

var $295216f354fff637$var$_arrowLeftCircle = $295216f354fff637$var$_interopRequireDefault((parcelRequire("2H8VS")));
function $295216f354fff637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295216f354fff637$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $295216f354fff637$var$_react.default.createElement($295216f354fff637$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $295216f354fff637$var$_arrowLeftCircle.default
    }, props));
$295216f354fff637$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
var $295216f354fff637$var$_default = module.exports.default = $295216f354fff637$var$ArrowLeftIcon;

});
parcelRegister("kmtfL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed2c8dd1c17ad869$var$_react = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ed2c8dd1c17ad869$var$_baseNew = $ed2c8dd1c17ad869$var$_interopRequireDefault((parcelRequire("enEmH")));
function $ed2c8dd1c17ad869$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed2c8dd1c17ad869$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $ed2c8dd1c17ad869$var$_react.default.createElement($ed2c8dd1c17ad869$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$ed2c8dd1c17ad869$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $ed2c8dd1c17ad869$var$_default = module.exports.default = $ed2c8dd1c17ad869$var$ArrowLeftIcon;

});

parcelRegister("2H8VS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f6686b5a2de8be4$var$_react = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1f6686b5a2de8be4$var$_arrowLeft = $1f6686b5a2de8be4$var$_interopRequireDefault((parcelRequire("kmtfL")));
function $1f6686b5a2de8be4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f6686b5a2de8be4$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $1f6686b5a2de8be4$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props, {
        newIcon: $1f6686b5a2de8be4$var$_arrowLeft.default
    }));
$1f6686b5a2de8be4$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $1f6686b5a2de8be4$var$_default = module.exports.default = $1f6686b5a2de8be4$var$ArrowLeftCircleIcon;

});


var $a7f8c6b391092279$exports = {};

$parcel$export($a7f8c6b391092279$exports, "R50", () => $a7f8c6b391092279$export$4b84fd0e2c617bd);
$parcel$export($a7f8c6b391092279$exports, "R75", () => $a7f8c6b391092279$export$b34b069eff244586);
$parcel$export($a7f8c6b391092279$exports, "R100", () => $a7f8c6b391092279$export$be802dd0d8b57f35);
$parcel$export($a7f8c6b391092279$exports, "R200", () => $a7f8c6b391092279$export$60847d42f9da92a6);
$parcel$export($a7f8c6b391092279$exports, "R300", () => $a7f8c6b391092279$export$4a7404f376229999);
$parcel$export($a7f8c6b391092279$exports, "R400", () => $a7f8c6b391092279$export$2010d0fb4295b346);
$parcel$export($a7f8c6b391092279$exports, "R500", () => $a7f8c6b391092279$export$2837b5a1a71d5c02);
$parcel$export($a7f8c6b391092279$exports, "Y50", () => $a7f8c6b391092279$export$8d9596b529bbb9cf);
$parcel$export($a7f8c6b391092279$exports, "Y75", () => $a7f8c6b391092279$export$41060a744ab0b7ae);
$parcel$export($a7f8c6b391092279$exports, "Y100", () => $a7f8c6b391092279$export$1cc05bbbf340e559);
$parcel$export($a7f8c6b391092279$exports, "Y200", () => $a7f8c6b391092279$export$5aae31392d72caaa);
$parcel$export($a7f8c6b391092279$exports, "Y300", () => $a7f8c6b391092279$export$c6930421db9fa514);
$parcel$export($a7f8c6b391092279$exports, "Y400", () => $a7f8c6b391092279$export$59619663aa6500fb);
$parcel$export($a7f8c6b391092279$exports, "Y500", () => $a7f8c6b391092279$export$874739ea9e379ab6);
$parcel$export($a7f8c6b391092279$exports, "G50", () => $a7f8c6b391092279$export$8a6341c32b6a3ee6);
$parcel$export($a7f8c6b391092279$exports, "G75", () => $a7f8c6b391092279$export$69a3bf21b9686c2b);
$parcel$export($a7f8c6b391092279$exports, "G100", () => $a7f8c6b391092279$export$afbce1382ec95f73);
$parcel$export($a7f8c6b391092279$exports, "G200", () => $a7f8c6b391092279$export$747d86715d4175de);
$parcel$export($a7f8c6b391092279$exports, "G300", () => $a7f8c6b391092279$export$940e1f69e873f202);
$parcel$export($a7f8c6b391092279$exports, "G400", () => $a7f8c6b391092279$export$a49394138f7b8e85);
$parcel$export($a7f8c6b391092279$exports, "G500", () => $a7f8c6b391092279$export$6fa04827ac68a4fb);
$parcel$export($a7f8c6b391092279$exports, "B50", () => $a7f8c6b391092279$export$226de0355ed012f8);
$parcel$export($a7f8c6b391092279$exports, "B75", () => $a7f8c6b391092279$export$8c13c2ee36917869);
$parcel$export($a7f8c6b391092279$exports, "B100", () => $a7f8c6b391092279$export$ecfc1dff386a3e7a);
$parcel$export($a7f8c6b391092279$exports, "B200", () => $a7f8c6b391092279$export$215b7063051591f1);
$parcel$export($a7f8c6b391092279$exports, "B300", () => $a7f8c6b391092279$export$e62e8919cca44969);
$parcel$export($a7f8c6b391092279$exports, "B400", () => $a7f8c6b391092279$export$b3de0ae08da2ce64);
$parcel$export($a7f8c6b391092279$exports, "B500", () => $a7f8c6b391092279$export$a6ee3d71bc067634);
$parcel$export($a7f8c6b391092279$exports, "B600", () => $a7f8c6b391092279$export$67f15409e87642a1);
$parcel$export($a7f8c6b391092279$exports, "B700", () => $a7f8c6b391092279$export$f0539dbc42dbb067);
$parcel$export($a7f8c6b391092279$exports, "P50", () => $a7f8c6b391092279$export$363e4475840015bb);
$parcel$export($a7f8c6b391092279$exports, "P75", () => $a7f8c6b391092279$export$4b0a4417ed59760f);
$parcel$export($a7f8c6b391092279$exports, "P100", () => $a7f8c6b391092279$export$6011520a64d9a187);
$parcel$export($a7f8c6b391092279$exports, "P200", () => $a7f8c6b391092279$export$a7175d4e9206bc80);
$parcel$export($a7f8c6b391092279$exports, "P300", () => $a7f8c6b391092279$export$b48405b95304b5a1);
$parcel$export($a7f8c6b391092279$exports, "P400", () => $a7f8c6b391092279$export$c71e4279dd54a18d);
$parcel$export($a7f8c6b391092279$exports, "P500", () => $a7f8c6b391092279$export$147899de772240ec);
$parcel$export($a7f8c6b391092279$exports, "T50", () => $a7f8c6b391092279$export$2cf711fe14c66f06);
$parcel$export($a7f8c6b391092279$exports, "T75", () => $a7f8c6b391092279$export$7a8f4d33f6f9772c);
$parcel$export($a7f8c6b391092279$exports, "T100", () => $a7f8c6b391092279$export$776c9c497ef08533);
$parcel$export($a7f8c6b391092279$exports, "T200", () => $a7f8c6b391092279$export$69cb3ca10c1e330e);
$parcel$export($a7f8c6b391092279$exports, "T300", () => $a7f8c6b391092279$export$9dc1ef0f3f48059b);
$parcel$export($a7f8c6b391092279$exports, "T400", () => $a7f8c6b391092279$export$7c835c78b6fcdef8);
$parcel$export($a7f8c6b391092279$exports, "T500", () => $a7f8c6b391092279$export$6036577f95c3877e);
$parcel$export($a7f8c6b391092279$exports, "N0", () => $a7f8c6b391092279$export$29a4f05edc054374);
$parcel$export($a7f8c6b391092279$exports, "N10", () => $a7f8c6b391092279$export$e655ef011c4aa1a2);
$parcel$export($a7f8c6b391092279$exports, "N20", () => $a7f8c6b391092279$export$9fdfb749e33cdf97);
$parcel$export($a7f8c6b391092279$exports, "N30", () => $a7f8c6b391092279$export$3e51e8f1440314ba);
$parcel$export($a7f8c6b391092279$exports, "N40", () => $a7f8c6b391092279$export$1ce2d1575d444ceb);
$parcel$export($a7f8c6b391092279$exports, "N50", () => $a7f8c6b391092279$export$8754fc7e6d8b3000);
$parcel$export($a7f8c6b391092279$exports, "N60", () => $a7f8c6b391092279$export$c2e91cbeada39b8b);
$parcel$export($a7f8c6b391092279$exports, "N70", () => $a7f8c6b391092279$export$5f71e19f3a7ad9de);
$parcel$export($a7f8c6b391092279$exports, "N80", () => $a7f8c6b391092279$export$eaa8c8a70ac22806);
$parcel$export($a7f8c6b391092279$exports, "N90", () => $a7f8c6b391092279$export$7c87d337fb91a97d);
$parcel$export($a7f8c6b391092279$exports, "N100", () => $a7f8c6b391092279$export$d6447c357493214f);
$parcel$export($a7f8c6b391092279$exports, "N200", () => $a7f8c6b391092279$export$f563ee71e9ee74cd);
$parcel$export($a7f8c6b391092279$exports, "N300", () => $a7f8c6b391092279$export$e2ef2124cf4024b1);
$parcel$export($a7f8c6b391092279$exports, "N400", () => $a7f8c6b391092279$export$eece5f492e429f08);
$parcel$export($a7f8c6b391092279$exports, "N500", () => $a7f8c6b391092279$export$c39c0fe0f26207ae);
$parcel$export($a7f8c6b391092279$exports, "N600", () => $a7f8c6b391092279$export$7090862dc3038a9f);
$parcel$export($a7f8c6b391092279$exports, "N700", () => $a7f8c6b391092279$export$ad0bacf983b7ddaa);
$parcel$export($a7f8c6b391092279$exports, "N800", () => $a7f8c6b391092279$export$7d61b15e0da132af);
$parcel$export($a7f8c6b391092279$exports, "N900", () => $a7f8c6b391092279$export$fbda843f0a27fe96);
$parcel$export($a7f8c6b391092279$exports, "N10A", () => $a7f8c6b391092279$export$791e57b27ca738ef);
$parcel$export($a7f8c6b391092279$exports, "N20A", () => $a7f8c6b391092279$export$8d43898f60b96a82);
$parcel$export($a7f8c6b391092279$exports, "N30A", () => $a7f8c6b391092279$export$920c0d5c49070351);
$parcel$export($a7f8c6b391092279$exports, "N40A", () => $a7f8c6b391092279$export$46987b49aab6d1a8);
$parcel$export($a7f8c6b391092279$exports, "N50A", () => $a7f8c6b391092279$export$7d3359664e8bb0e5);
$parcel$export($a7f8c6b391092279$exports, "N60A", () => $a7f8c6b391092279$export$d2d3bedfb276cac0);
$parcel$export($a7f8c6b391092279$exports, "N70A", () => $a7f8c6b391092279$export$6e5e7499ff054f6d);
$parcel$export($a7f8c6b391092279$exports, "N80A", () => $a7f8c6b391092279$export$59264b346c877fa7);
$parcel$export($a7f8c6b391092279$exports, "N90A", () => $a7f8c6b391092279$export$d092757d7c64925c);
$parcel$export($a7f8c6b391092279$exports, "N100A", () => $a7f8c6b391092279$export$486ab785e4bac3c6);
$parcel$export($a7f8c6b391092279$exports, "N200A", () => $a7f8c6b391092279$export$fba592bbc6419fea);
$parcel$export($a7f8c6b391092279$exports, "N300A", () => $a7f8c6b391092279$export$13609db0e6812ab8);
$parcel$export($a7f8c6b391092279$exports, "N400A", () => $a7f8c6b391092279$export$fbae4efaa892d883);
$parcel$export($a7f8c6b391092279$exports, "N500A", () => $a7f8c6b391092279$export$f13946d26f440ce6);
$parcel$export($a7f8c6b391092279$exports, "N600A", () => $a7f8c6b391092279$export$19f58225ac52a306);
$parcel$export($a7f8c6b391092279$exports, "N700A", () => $a7f8c6b391092279$export$6384f09da70e7b62);
$parcel$export($a7f8c6b391092279$exports, "N800A", () => $a7f8c6b391092279$export$d0dccc730683edc2);
$parcel$export($a7f8c6b391092279$exports, "DN900", () => $a7f8c6b391092279$export$2f6319cf7d736c2a);
$parcel$export($a7f8c6b391092279$exports, "DN800", () => $a7f8c6b391092279$export$95126bc8884d6634);
$parcel$export($a7f8c6b391092279$exports, "DN700", () => $a7f8c6b391092279$export$8338d8c35d44ff1);
$parcel$export($a7f8c6b391092279$exports, "DN600", () => $a7f8c6b391092279$export$5368d76ae4fbbda7);
$parcel$export($a7f8c6b391092279$exports, "DN500", () => $a7f8c6b391092279$export$9f0a771d16ec8d36);
$parcel$export($a7f8c6b391092279$exports, "DN400", () => $a7f8c6b391092279$export$abcf8c38338b4aa5);
$parcel$export($a7f8c6b391092279$exports, "DN300", () => $a7f8c6b391092279$export$97e81faa16a182c7);
$parcel$export($a7f8c6b391092279$exports, "DN200", () => $a7f8c6b391092279$export$bfe21c59123ecf33);
$parcel$export($a7f8c6b391092279$exports, "DN100", () => $a7f8c6b391092279$export$ee82aa2ea6a1558);
$parcel$export($a7f8c6b391092279$exports, "DN90", () => $a7f8c6b391092279$export$682927c6ed76be02);
$parcel$export($a7f8c6b391092279$exports, "DN80", () => $a7f8c6b391092279$export$91fd9994c5be9757);
$parcel$export($a7f8c6b391092279$exports, "DN70", () => $a7f8c6b391092279$export$d281fbfe3cff2df6);
$parcel$export($a7f8c6b391092279$exports, "DN60", () => $a7f8c6b391092279$export$3902c91d8b98a753);
$parcel$export($a7f8c6b391092279$exports, "DN50", () => $a7f8c6b391092279$export$8e8133c1ba5845b5);
$parcel$export($a7f8c6b391092279$exports, "DN40", () => $a7f8c6b391092279$export$33ff357f6620b39);
$parcel$export($a7f8c6b391092279$exports, "DN30", () => $a7f8c6b391092279$export$633847cf062b69e0);
$parcel$export($a7f8c6b391092279$exports, "DN20", () => $a7f8c6b391092279$export$9776a6e503bdbf76);
$parcel$export($a7f8c6b391092279$exports, "DN10", () => $a7f8c6b391092279$export$6c813d5160dff5db);
$parcel$export($a7f8c6b391092279$exports, "DN0", () => $a7f8c6b391092279$export$3d4f271a500072a);
$parcel$export($a7f8c6b391092279$exports, "DN800A", () => $a7f8c6b391092279$export$fe151285c22759ec);
$parcel$export($a7f8c6b391092279$exports, "DN700A", () => $a7f8c6b391092279$export$a101c6190d0da34);
$parcel$export($a7f8c6b391092279$exports, "DN600A", () => $a7f8c6b391092279$export$4b16f52932fda51);
$parcel$export($a7f8c6b391092279$exports, "DN500A", () => $a7f8c6b391092279$export$a74bcd7b9845b0d8);
$parcel$export($a7f8c6b391092279$exports, "DN400A", () => $a7f8c6b391092279$export$9209c179316d1751);
$parcel$export($a7f8c6b391092279$exports, "DN300A", () => $a7f8c6b391092279$export$88f55133f636c8dd);
$parcel$export($a7f8c6b391092279$exports, "DN200A", () => $a7f8c6b391092279$export$51126f85d1009512);
$parcel$export($a7f8c6b391092279$exports, "DN100A", () => $a7f8c6b391092279$export$a069b547bd23af78);
$parcel$export($a7f8c6b391092279$exports, "DN90A", () => $a7f8c6b391092279$export$40cce05af3b2600a);
$parcel$export($a7f8c6b391092279$exports, "DN80A", () => $a7f8c6b391092279$export$b78942185925a0d);
$parcel$export($a7f8c6b391092279$exports, "DN70A", () => $a7f8c6b391092279$export$e058fb44b8eaafca);
$parcel$export($a7f8c6b391092279$exports, "DN60A", () => $a7f8c6b391092279$export$92b0b8de26920c18);
$parcel$export($a7f8c6b391092279$exports, "DN50A", () => $a7f8c6b391092279$export$67564f7459d3fc9e);
$parcel$export($a7f8c6b391092279$exports, "DN40A", () => $a7f8c6b391092279$export$77868e1ca884ffa3);
$parcel$export($a7f8c6b391092279$exports, "DN30A", () => $a7f8c6b391092279$export$2afd71d7d3ea2cd5);
$parcel$export($a7f8c6b391092279$exports, "DN20A", () => $a7f8c6b391092279$export$f2a0acaab9972c70);
$parcel$export($a7f8c6b391092279$exports, "DN10A", () => $a7f8c6b391092279$export$9ab70e67d6475361);
$parcel$export($a7f8c6b391092279$exports, "T30", () => $a7f8c6b391092279$export$d2adc5dedf09fced);
$parcel$export($a7f8c6b391092279$exports, "L50", () => $a7f8c6b391092279$export$f51762073d2bb381);
$parcel$export($a7f8c6b391092279$exports, "L75", () => $a7f8c6b391092279$export$95e26d54def96891);
// Reds
const $a7f8c6b391092279$export$4b84fd0e2c617bd = '#FFEBE6';
const $a7f8c6b391092279$export$b34b069eff244586 = '#FFBDAD';
const $a7f8c6b391092279$export$be802dd0d8b57f35 = '#FF8F73';
const $a7f8c6b391092279$export$60847d42f9da92a6 = '#FF7452';
const $a7f8c6b391092279$export$4a7404f376229999 = '#FF5630';
const $a7f8c6b391092279$export$2010d0fb4295b346 = '#DE350B';
const $a7f8c6b391092279$export$2837b5a1a71d5c02 = '#BF2600';
const $a7f8c6b391092279$export$8d9596b529bbb9cf = '#FFFAE6';
const $a7f8c6b391092279$export$41060a744ab0b7ae = '#FFF0B3';
const $a7f8c6b391092279$export$1cc05bbbf340e559 = '#FFE380';
const $a7f8c6b391092279$export$5aae31392d72caaa = '#FFC400';
const $a7f8c6b391092279$export$c6930421db9fa514 = '#FFAB00';
const $a7f8c6b391092279$export$59619663aa6500fb = '#FF991F';
const $a7f8c6b391092279$export$874739ea9e379ab6 = '#FF8B00';
const $a7f8c6b391092279$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $a7f8c6b391092279$export$69a3bf21b9686c2b = '#ABF5D1';
const $a7f8c6b391092279$export$afbce1382ec95f73 = '#79F2C0';
const $a7f8c6b391092279$export$747d86715d4175de = '#57D9A3';
const $a7f8c6b391092279$export$940e1f69e873f202 = '#36B37E';
const $a7f8c6b391092279$export$a49394138f7b8e85 = '#00875A';
const $a7f8c6b391092279$export$6fa04827ac68a4fb = '#006644';
const $a7f8c6b391092279$export$226de0355ed012f8 = '#DEEBFF';
const $a7f8c6b391092279$export$8c13c2ee36917869 = '#B3D4FF';
const $a7f8c6b391092279$export$ecfc1dff386a3e7a = '#4C9AFF';
const $a7f8c6b391092279$export$215b7063051591f1 = '#2684FF';
const $a7f8c6b391092279$export$e62e8919cca44969 = '#0065FF';
const $a7f8c6b391092279$export$b3de0ae08da2ce64 = '#0052CC';
const $a7f8c6b391092279$export$a6ee3d71bc067634 = '#0747A6';
const $a7f8c6b391092279$export$67f15409e87642a1 = '#669DF1';
const $a7f8c6b391092279$export$f0539dbc42dbb067 = '#8FB8F6';
const $a7f8c6b391092279$export$363e4475840015bb = '#EAE6FF';
const $a7f8c6b391092279$export$4b0a4417ed59760f = '#C0B6F2';
const $a7f8c6b391092279$export$6011520a64d9a187 = '#998DD9';
const $a7f8c6b391092279$export$a7175d4e9206bc80 = '#8777D9';
const $a7f8c6b391092279$export$b48405b95304b5a1 = '#6554C0';
const $a7f8c6b391092279$export$c71e4279dd54a18d = '#5243AA';
const $a7f8c6b391092279$export$147899de772240ec = '#403294';
const $a7f8c6b391092279$export$2cf711fe14c66f06 = '#E6FCFF';
const $a7f8c6b391092279$export$7a8f4d33f6f9772c = '#B3F5FF';
const $a7f8c6b391092279$export$776c9c497ef08533 = '#79E2F2';
const $a7f8c6b391092279$export$69cb3ca10c1e330e = '#00C7E6';
const $a7f8c6b391092279$export$9dc1ef0f3f48059b = '#00B8D9';
const $a7f8c6b391092279$export$7c835c78b6fcdef8 = '#00A3BF';
const $a7f8c6b391092279$export$6036577f95c3877e = '#008DA6';
const $a7f8c6b391092279$export$29a4f05edc054374 = '#FFFFFF';
const $a7f8c6b391092279$export$e655ef011c4aa1a2 = '#FAFBFC';
const $a7f8c6b391092279$export$9fdfb749e33cdf97 = '#F4F5F7';
const $a7f8c6b391092279$export$3e51e8f1440314ba = '#EBECF0';
const $a7f8c6b391092279$export$1ce2d1575d444ceb = '#DFE1E6';
const $a7f8c6b391092279$export$8754fc7e6d8b3000 = '#C1C7D0';
const $a7f8c6b391092279$export$c2e91cbeada39b8b = '#B3BAC5';
const $a7f8c6b391092279$export$5f71e19f3a7ad9de = '#A5ADBA';
const $a7f8c6b391092279$export$eaa8c8a70ac22806 = '#97A0AF';
const $a7f8c6b391092279$export$7c87d337fb91a97d = '#8993A4';
const $a7f8c6b391092279$export$d6447c357493214f = '#7A869A';
const $a7f8c6b391092279$export$f563ee71e9ee74cd = '#6B778C';
const $a7f8c6b391092279$export$e2ef2124cf4024b1 = '#5E6C84';
const $a7f8c6b391092279$export$eece5f492e429f08 = '#505F79';
const $a7f8c6b391092279$export$c39c0fe0f26207ae = '#42526E';
const $a7f8c6b391092279$export$7090862dc3038a9f = '#344563';
const $a7f8c6b391092279$export$ad0bacf983b7ddaa = '#253858';
const $a7f8c6b391092279$export$7d61b15e0da132af = '#172B4D';
const $a7f8c6b391092279$export$fbda843f0a27fe96 = '#091E42';
const $a7f8c6b391092279$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $a7f8c6b391092279$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $a7f8c6b391092279$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $a7f8c6b391092279$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $a7f8c6b391092279$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $a7f8c6b391092279$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $a7f8c6b391092279$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $a7f8c6b391092279$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $a7f8c6b391092279$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $a7f8c6b391092279$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $a7f8c6b391092279$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $a7f8c6b391092279$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $a7f8c6b391092279$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $a7f8c6b391092279$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $a7f8c6b391092279$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $a7f8c6b391092279$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $a7f8c6b391092279$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $a7f8c6b391092279$export$2f6319cf7d736c2a = '#E6EDFA';
const $a7f8c6b391092279$export$95126bc8884d6634 = '#DCE5F5';
const $a7f8c6b391092279$export$8338d8c35d44ff1 = '#CED9EB';
const $a7f8c6b391092279$export$5368d76ae4fbbda7 = '#B8C7E0';
const $a7f8c6b391092279$export$9f0a771d16ec8d36 = '#ABBBD6';
const $a7f8c6b391092279$export$abcf8c38338b4aa5 = '#9FB0CC';
const $a7f8c6b391092279$export$97e81faa16a182c7 = '#8C9CB8';
const $a7f8c6b391092279$export$bfe21c59123ecf33 = '#7988A3';
const $a7f8c6b391092279$export$ee82aa2ea6a1558 = '#67758F';
const $a7f8c6b391092279$export$682927c6ed76be02 = '#56637A';
const $a7f8c6b391092279$export$91fd9994c5be9757 = '#455166';
const $a7f8c6b391092279$export$d281fbfe3cff2df6 = '#3B475C';
const $a7f8c6b391092279$export$3902c91d8b98a753 = '#313D52';
const $a7f8c6b391092279$export$8e8133c1ba5845b5 = '#283447';
const $a7f8c6b391092279$export$33ff357f6620b39 = '#202B3D';
const $a7f8c6b391092279$export$633847cf062b69e0 = '#1B2638';
const $a7f8c6b391092279$export$9776a6e503bdbf76 = '#121A29';
const $a7f8c6b391092279$export$6c813d5160dff5db = '#0E1624';
const $a7f8c6b391092279$export$3d4f271a500072a = '#0D1424';
const $a7f8c6b391092279$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $a7f8c6b391092279$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $a7f8c6b391092279$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $a7f8c6b391092279$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $a7f8c6b391092279$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $a7f8c6b391092279$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $a7f8c6b391092279$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $a7f8c6b391092279$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $a7f8c6b391092279$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $a7f8c6b391092279$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $a7f8c6b391092279$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $a7f8c6b391092279$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $a7f8c6b391092279$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $a7f8c6b391092279$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $a7f8c6b391092279$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $a7f8c6b391092279$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $a7f8c6b391092279$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $a7f8c6b391092279$export$d2adc5dedf09fced = '#292A2E';
const $a7f8c6b391092279$export$f51762073d2bb381 = '#94C748';
const $a7f8c6b391092279$export$95e26d54def96891 = '#B3DF72';

parcelRegister("4iTJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $23465bf5670bf66e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7H980 = parcelRequire("7H980");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $23465bf5670bf66e$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7H980.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $23465bf5670bf66e$export$2e2bcd8739ae039 = $23465bf5670bf66e$var$ButtonItem;

});


parcelRegister("65Cwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee06468e5ae9b2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6gA2o = parcelRequire("6gA2o");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");


var $4iTJw = parcelRequire("4iTJw");
var $bY5Mc = parcelRequire("bY5Mc");
var $2uGoK = parcelRequire("2uGoK");

var $a4hJx = parcelRequire("a4hJx");

var $fsi33 = parcelRequire("fsi33");

var $4bO8w = parcelRequire("4bO8w");
const $1fee06468e5ae9b2$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $1fee06468e5ae9b2$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $fsi33.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
    const parentItemRef = (0, $5uXOq.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $fHpHg.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $5uXOq.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $4bO8w.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $fsi33.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2uGoK.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $a4hJx.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    "data-right-arrow": true,
                    xcss: $1fee06468e5ae9b2$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6gA2o))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $a7f8c6b391092279$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1fee06468e5ae9b2$var$styles.nestingItem,
            isDisabled && $1fee06468e5ae9b2$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4iTJw.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            $1fee06468e5ae9b2$var$styles.nestingItem,
            isDisabled && $1fee06468e5ae9b2$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $1fee06468e5ae9b2$export$2e2bcd8739ae039 = $1fee06468e5ae9b2$var$NestingItem;

});
parcelRegister("6gA2o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dbc8100b1314a43ce0868b8331a89007>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $490030febd58df31$var$_react = $490030febd58df31$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $490030febd58df31$var$_arrowRight = $490030febd58df31$var$_interopRequireDefault((parcelRequire("kAczT")));

var $490030febd58df31$var$_arrowRightCircle = $490030febd58df31$var$_interopRequireDefault((parcelRequire("ax5oF")));
function $490030febd58df31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $490030febd58df31$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $490030febd58df31$var$_react.default.createElement($490030febd58df31$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $490030febd58df31$var$_arrowRightCircle.default
    }, props));
$490030febd58df31$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $490030febd58df31$var$_default = module.exports.default = $490030febd58df31$var$ArrowRightIcon;

});
parcelRegister("kAczT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efc0ed230d3ca890$var$_react = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $efc0ed230d3ca890$var$_baseNew = $efc0ed230d3ca890$var$_interopRequireDefault((parcelRequire("enEmH")));
function $efc0ed230d3ca890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efc0ed230d3ca890$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $efc0ed230d3ca890$var$_react.default.createElement($efc0ed230d3ca890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$efc0ed230d3ca890$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $efc0ed230d3ca890$var$_default = module.exports.default = $efc0ed230d3ca890$var$ArrowRightIcon;

});

parcelRegister("ax5oF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ab12c2904bc0560$var$_react = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $7ab12c2904bc0560$var$_arrowRight = $7ab12c2904bc0560$var$_interopRequireDefault((parcelRequire("kAczT")));
function $7ab12c2904bc0560$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7ab12c2904bc0560$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7ab12c2904bc0560$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props, {
        newIcon: $7ab12c2904bc0560$var$_arrowRight.default
    }));
$7ab12c2904bc0560$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7ab12c2904bc0560$var$_default = module.exports.default = $7ab12c2904bc0560$var$ArrowRightCircleIcon;

});


parcelRegister("bY5Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bca491cca55dea$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-overrides */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $f1bca491cca55dea$var$CustomItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(// Type needed on props to extract types with extract react types.
({ cssFn: cssFn, ...rest }, ref)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssOverride = (0, $c48kn.overrideStyleFunction)((0, $c48kn.baseSideNavItemStyle), cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2COCu.default), {
        ref: ref,
        cssFn: cssOverride,
        ...rest
    });
});
var $f1bca491cca55dea$export$2e2bcd8739ae039 = $f1bca491cca55dea$var$CustomItem;

});

parcelRegister("2uGoK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522d7db65b02790$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iIWB4 = parcelRequire("iIWB4");

var $fsi33 = parcelRequire("fsi33");
const $0522d7db65b02790$var$outerContainerCSS = null;
const $0522d7db65b02790$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjgqwt _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $0522d7db65b02790$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $0522d7db65b02790$var$NavigationContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    const scrollbar = (0, $iIWB4.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3gqwt _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjgqwt _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $bwpsq.default)([
                $0522d7db65b02790$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $0522d7db65b02790$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                className: (0, $bwpsq.default)([
                    $0522d7db65b02790$var$containerCSS.basic,
                    showTopScrollIndicator && $0522d7db65b02790$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $0522d7db65b02790$export$2e2bcd8739ae039 = $0522d7db65b02790$var$NavigationContent;

});
parcelRegister("iIWB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $16e79fe7c7a46990$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $16e79fe7c7a46990$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
    const elementRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("4bO8w", function(module, exports) {

$parcel$export(module.exports, "useChildIds", () => $59c19cb7551d7415$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $59c19cb7551d7415$export$ea18c2b5f0e24612);

var $5uXOq = parcelRequire("5uXOq");

var $a4hJx = parcelRequire("a4hJx");
const $59c19cb7551d7415$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $5uXOq.useRef)(new Set());
    (0, $5uXOq.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $a4hJx.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $59c19cb7551d7415$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});


parcelRegister("atNen", function(module, exports) {

$parcel$export(module.exports, "NestingMotion", () => $73b6973e2eaccf98$export$9e743a8c2a6b450e);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3aB43 = parcelRequire("3aB43");
const $73b6973e2eaccf98$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aB43.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});


parcelRegister("2zFxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $75770a0a8b5fef07$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8ZVfC = parcelRequire("8ZVfC");
const $75770a0a8b5fef07$var$sidebarMinWidth = '240px';
const $75770a0a8b5fef07$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 */ const $75770a0a8b5fef07$var$SideNavigation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkw70a _syazjjyb"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8ZVfC.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch",
            children: children
        })
    });
});
var $75770a0a8b5fef07$export$2e2bcd8739ae039 = $75770a0a8b5fef07$var$SideNavigation;

});

// Backend types
const $976eff6d67d3515b$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $976eff6d67d3515b$var$CORE_BOARD = 'core-board';
const $976eff6d67d3515b$export$b4e9cdb19cfa0abb = 'kanban';
const $976eff6d67d3515b$export$4498412e32a31fb6 = 'scrum';

parcelRegister("k0iPT", function(module, exports) {

$parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", () => $c82776b15970ab04$export$a8aac2ba4dc1f57);
$parcel$export(module.exports, "CONNECT_ROUTES_SET", () => $c82776b15970ab04$export$c47bf667d3008c53);
$parcel$export(module.exports, "JSM_BOARD_ROUTES_SET", () => $c82776b15970ab04$export$50c2d6bcb0b94b74);
const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
    'classic-business-overview-summary',
    'classic-business-overview-calendar',
    'classic-business-overview-timeline',
    'classic-business-overview-redirect'
]);
const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
    'connect-project',
    'connect-general',
    'connect-general-service-desk-project',
    'legacy-connect-project',
    'legacy-connect-general'
]);
const $c82776b15970ab04$export$50c2d6bcb0b94b74 = new Set([
    'servicedesk-boards',
    'servicedesk-queues-views-config',
    'servicedesk-practice-views-config'
]);

});

parcelRegister("gwIPs", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $80d528dbc2b11cbc$export$7a57f79000377ca2);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $80d528dbc2b11cbc$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $80d528dbc2b11cbc$export$7be255094ccdc533);

var $b4a3S = parcelRequire("b4a3S");
const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = 8;
const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, $b4a3S.borderRadius)();
const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
    banner: (0, $b4a3S.layers).navigation(),
    card: (0, $b4a3S.layers).card(),
    dialog: (0, $b4a3S.layers).dialog(),
    navigation: (0, $b4a3S.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $b4a3S.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $b4a3S.layers).navigation() - 1,
    layer: (0, $b4a3S.layers).layer(),
    blanket: (0, $b4a3S.layers).blanket(),
    modal: (0, $b4a3S.layers).modal(),
    flag: (0, $b4a3S.layers).flag(),
    spotlight: (0, $b4a3S.layers).spotlight(),
    tooltip: (0, $b4a3S.layers).tooltip(),
    mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
};
const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
    issueIconSize: 16
};

});

parcelRegister("dkNvt", function(module, exports) {

$parcel$export(module.exports, "AsyncMultiProductUpgradeModal", () => $74011562e496dc9d$export$cdf745140dc0b98d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $74011562e496dc9d$var$LazyMultiProductUpgradeModal = (0, $b7Svb.lazy)(()=>(parcelRequire("5avY9")), {
    moduleId: "./src/packages/experiments/src/ui/experiments/multi-product-upgrade/main.tsx"
});
const $74011562e496dc9d$export$cdf745140dc0b98d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "multi-product-upgrade-modal",
        packageName: "jira-experiments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($74011562e496dc9d$var$LazyMultiProductUpgradeModal, props));

});
parcelRegister("5avY9", function(module, exports) {

let $3c36af505910e21f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3c36af505910e21f$var$load("h2MrD"),
    $3c36af505910e21f$var$load("bYT2S"),
    $3c36af505910e21f$var$load("aAwcA")
]).then(()=>parcelRequire('5Lvcs'));

});


parcelRegister("lRM9B", function(module, exports) {

$parcel$export(module.exports, "useMultiProductUpgrade", () => $31fe8fbfbabcae2e$export$8c3adf8adcae20f5);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $ldyPw = parcelRequire("ldyPw");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $itmJb = parcelRequire("itmJb");

var $9hrUq = parcelRequire("9hrUq");

var $hf6fa = parcelRequire("hf6fa");

var $j9WKn = parcelRequire("j9WKn");
const $31fe8fbfbabcae2e$var$getEligibilityData = async (cloudId)=>{
    const eligibility = {};
    const entitlements = await (0, $hf6fa.fetchEntitlements)(cloudId);
    const { serviceDesk: serviceDesk, confluence: confluence, jiraSoftware: jiraSoftware } = entitlements;
    const hasFreeEdition = serviceDesk?.edition === (0, $ldyPw.FREE_EDITION_KEY) || confluence?.edition === (0, $ldyPw.FREE_EDITION_KEY);
    if (!jiraSoftware || jiraSoftware.edition !== (0, $ldyPw.STANDARD_EDITION_KEY) || !hasFreeEdition) return null;
    // identify which product we are on
    if (serviceDesk?.edition === (0, $ldyPw.FREE_EDITION_KEY)) {
        eligibility.productKey = serviceDesk.productKey;
        eligibility.entitlementDetails = {
            billingAccountId: serviceDesk.billingAccountId,
            billingSourceSystem: serviceDesk.billingSystem,
            entitlementId: serviceDesk.ccpEntitlementId
        };
    } else if (confluence?.edition === (0, $ldyPw.FREE_EDITION_KEY)) {
        eligibility.productKey = confluence.productKey;
        eligibility.entitlementDetails = {
            billingAccountId: confluence.billingAccountId,
            billingSourceSystem: confluence.billingSystem,
            entitlementId: confluence.ccpEntitlementId
        };
    }
    return eligibility;
};
const $31fe8fbfbabcae2e$export$8c3adf8adcae20f5 = ()=>{
    const environment = (0, $2tT7R.useEnvironment)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [isEnrolled, setIsEnrolled] = (0, $5uXOq.useState)(false);
    const [eligibilityData, setEligibilityData] = (0, $5uXOq.useState)(null);
    const { productKey: productKey, entitlementDetails: entitlementDetails } = eligibilityData || {};
    const { hasMessageStarted: hasMessageStarted, setEpMessageStarted: setEpMessageStarted, stopMessage: stopMessage } = (0, $j9WKn.useCoordinationClient)(environment !== 'prod' ? (0, $9hrUq.MULTI_PRODUCT_UPGRADE_MSG_ID_STG) : (0, $9hrUq.MULTI_PRODUCT_UPGRADE_MSG_ID));
    (0, $5uXOq.useEffect)(()=>{
        if (hasMessageStarted === null) setEpMessageStarted();
    }, [
        hasMessageStarted,
        setEpMessageStarted
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isAdmin) {
            setIsLoading(false);
            return;
        }
        if (hasMessageStarted === false) {
            setIsLoading(false);
            return;
        }
        if (hasMessageStarted) $31fe8fbfbabcae2e$var$getEligibilityData(cloudId).then((eligibilityResult)=>{
            setEligibilityData(eligibilityResult);
            if (eligibilityResult) setIsEnrolled(true);
            else setIsEnrolled(false);
        }).catch(()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMultiProductUpgrade failed', {
                errorMessage: 'fetchFailed'
            });
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        cloudId,
        isLoading,
        isAdmin,
        createAnalyticsEvent,
        hasMessageStarted
    ]);
    return {
        billingAccountId: entitlementDetails?.billingAccountId,
        billingSystem: entitlementDetails?.billingSourceSystem,
        cloudId: cloudId,
        entitlementId: entitlementDetails?.entitlementId,
        isEnrolled: isEnrolled,
        isLoading: isLoading,
        productKey: productKey,
        onStopMessage: stopMessage
    };
};
var $31fe8fbfbabcae2e$export$2e2bcd8739ae039 = $31fe8fbfbabcae2e$export$8c3adf8adcae20f5;

});
parcelRegister("koeKL", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $559e3c14e9652b55$export$9da0f7c65f28ed16);

var $9OXo1 = parcelRequire("9OXo1");
const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("2tT7R", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $6bd66e47d4948917$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $6bd66e47d4948917$export$b0d8f74f433a09c9);

var $9OXo1 = parcelRequire("9OXo1");
const $6bd66e47d4948917$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $6bd66e47d4948917$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext?.environment || $6bd66e47d4948917$var$ENVIRONMENT.PROD;
};
const $6bd66e47d4948917$export$b0d8f74f433a09c9 = ()=>{
    const env = $6bd66e47d4948917$export$ea7ed2425832167d();
    return env === $6bd66e47d4948917$var$ENVIRONMENT.STAGING || env === $6bd66e47d4948917$var$ENVIRONMENT.DEV || env === $6bd66e47d4948917$var$ENVIRONMENT.LOCAL;
};

});

parcelRegister("9hrUq", function(module, exports) {

$parcel$export(module.exports, "CCP", () => $4126869ee1f76b51$export$908f60505a2de053);
$parcel$export(module.exports, "JiraMessageKeysWithIssueTerm", () => $4126869ee1f76b51$export$da5805b13a5f32ae);
$parcel$export(module.exports, "JiraMessageKeys", () => $4126869ee1f76b51$export$e72b217cde057017);
$parcel$export(module.exports, "ConfluenceMessageKeysSpork", () => $4126869ee1f76b51$export$fdcb07cfbfa71268);
$parcel$export(module.exports, "JSMKey", () => $4126869ee1f76b51$export$68cc8d21dc116f94);
$parcel$export(module.exports, "MULTI_PRODUCT_UPGRADE_MSG_ID", () => $4126869ee1f76b51$export$9f31b74e2dd93ce5);
$parcel$export(module.exports, "MULTI_PRODUCT_UPGRADE_MSG_ID_STG", () => $4126869ee1f76b51$export$6b166b4eb13eec67);
const $4126869ee1f76b51$export$d5a5208541f78b0 = 'HAMS';
const $4126869ee1f76b51$export$908f60505a2de053 = 'CCP';
const $4126869ee1f76b51$export$da5805b13a5f32ae = [
    'benefitsBulletJiraSync',
    'benefitsBulletJiraIssues',
    'benefitsBulletJiraAutomatically',
    'benefitsBulletJiraProcess',
    'benefitsBulletJiraUnlock'
];
const $4126869ee1f76b51$export$e72b217cde057017 = [
    'benefitsBulletJiraSync',
    'benefitsBulletJiraIssuesIssueTermRefresh',
    'benefitsBulletJiraAutomaticallyIssueTermRefresh',
    'benefitsBulletJiraProcess',
    'benefitsBulletJiraUnlock'
];
const $4126869ee1f76b51$export$fdcb07cfbfa71268 = [
    'benefitsBulletConfluenceShareSpork',
    'benefitsBulletConfluenceSpend',
    'benefitsBulletConfluenceCreate',
    'benefitsBulletConfluenceUnlock'
];
const $4126869ee1f76b51$export$b4577f34046f8c4 = 'jira-software.ondemand';
const $4126869ee1f76b51$export$68cc8d21dc116f94 = 'jira-servicedesk.ondemand';
const $4126869ee1f76b51$export$83e7d0da42c4250f = 'confluence.ondemand';
const $4126869ee1f76b51$export$9f31b74e2dd93ce5 = 'multi-product-upgrade-enhancement';
const $4126869ee1f76b51$export$6b166b4eb13eec67 = 'multi-product-upgrade-enhancement-stg';

});

parcelRegister("hf6fa", function(module, exports) {

$parcel$export(module.exports, "fetchEntitlements", () => $997ec67a8f440b6d$export$40c8db633a0f3539);

var $7f4tk = parcelRequire("7f4tk");
const $997ec67a8f440b6d$var$confluenceEntitlementFilter = (entitlement)=>entitlement.productKey === 'confluence.ondemand' || entitlement.productKey === 'confluence.ondemand.billedinccp';
const $997ec67a8f440b6d$var$serviceDeskEntitlementFilter = (entitlement)=>entitlement.productKey === 'jira-servicedesk.ondemand' || entitlement.productKey === 'jira-servicedesk.ondemand.billedinccp';
const $997ec67a8f440b6d$var$jiraEntitlementFilter = (entitlement)=>entitlement.productKey === 'jira-software.ondemand' || entitlement.productKey === 'jira-software.ondemand.billedinccp';
// CCP returns edition as title case, this function converts to lowercase to standardise
const $997ec67a8f440b6d$var$convertEditionToLowerCase = (entitlement)=>entitlement && {
        ...entitlement,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        edition: entitlement.edition?.toLowerCase()
    };
const $997ec67a8f440b6d$export$40c8db633a0f3539 = (cloudId)=>(0, $7f4tk.default)(`/gateway/api/billing-ux/cloud/${cloudId}/billing/v2/site-entitlements`).then((response)=>{
        const confluenceEntitlement = response.entitlements.find($997ec67a8f440b6d$var$confluenceEntitlementFilter);
        const serviceDeskEntitlement = response.entitlements.find($997ec67a8f440b6d$var$serviceDeskEntitlementFilter);
        const jiraEntitlement = response.entitlements.find($997ec67a8f440b6d$var$jiraEntitlementFilter);
        return {
            serviceDesk: $997ec67a8f440b6d$var$convertEditionToLowerCase(serviceDeskEntitlement),
            confluence: $997ec67a8f440b6d$var$convertEditionToLowerCase(confluenceEntitlement),
            jiraSoftware: $997ec67a8f440b6d$var$convertEditionToLowerCase(jiraEntitlement)
        };
    });

});

parcelRegister("j9WKn", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $09c2a26deae07e6e$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");
const $09c2a26deae07e6e$export$ddc368dc94a41e62 = (epMessageId)=>{
    // null means coordination client has not yet determined what that message status is
    // true means the message has started and should be shown
    // false means the message should not be shown for any reason
    const [hasMessageStarted, setHasMessageStarted] = (0, $5uXOq.useState)(null);
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, '/gateway/api', false, orgId), [
        cloudId,
        orgId
    ]);
    const setEpMessageStarted = (0, $5uXOq.useCallback)(async ()=>{
        const started = await coordinationClient.start(epMessageId);
        setHasMessageStarted(started);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stopMessage = (0, $5uXOq.useCallback)(async ()=>{
        setHasMessageStarted(false);
        await coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        setEpMessageStarted: setEpMessageStarted,
        stopMessage: stopMessage
    };
};

});
parcelRegister("eGLgs", function(module, exports) {

$parcel$export(module.exports, "CoordinationClient", () => $754c27d37ccd1133$export$580a2294c917898c);
$parcel$export(module.exports, "default", () => $754c27d37ccd1133$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9etNK = parcelRequire("9etNK");

var $brgOn = parcelRequire("brgOn");
var $980Xe = parcelRequire("980Xe");

var $g3Ayl = parcelRequire("g3Ayl");

var $ioD1B = parcelRequire("ioD1B");

var $10xFf = parcelRequire("10xFf");

var $4Pf62 = parcelRequire("4Pf62");

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $14XJw = parcelRequire("14XJw");

var $7qPn9 = parcelRequire("7qPn9");
const $754c27d37ccd1133$var$isSyntheticTenant = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
class $754c27d37ccd1133$export$580a2294c917898c extends (0, $980Xe.default) {
    constructor(cloudId, stargateUrl, shouldAllowOnSynthetic = false, orgId = '', messageType = 'transactional', onMessageDisposition, isAlreadyChoreographedAtAncestor = false){
        const environment = (0, $7qPn9.toEnvironment)((0, $j8DrX.default)('ajs-environment'));
        const getEnvironmentType = (env)=>{
            if (env === 'prod') return (0, $9etNK.envType).PROD;
            if (env === 'staging') return (0, $9etNK.envType).STAGING;
            return (0, $9etNK.envType).DEV;
        };
        // If a ancestor (e.g. CoordinationClient wraps CoordinationClient) is already choreographed,
        // we should not re-choreograph this CoordinationClient
        const enableChoreographer = (0, $10xFf.shouldBeChoreographed)({
            messageType: messageType
        }) && !isAlreadyChoreographedAtAncestor;
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: getEnvironmentType(environment),
            additionalData: {
                sourceProductId: (0, $g3Ayl.ProductIds).JIRA
            }
        };
        super({
            cloudId: cloudId,
            stargateUrl: stargateUrl,
            orgId: orgId,
            isFedRAMPEnvironment: false,
            coordinationOptions: coordinationOptions
        });
        this.shouldUseMockClient = $754c27d37ccd1133$var$isSyntheticTenant() && !shouldAllowOnSynthetic;
        this.enableChoreographer = enableChoreographer;
        this.onMessageDisposition = onMessageDisposition;
        // // This is a permanant flag: go/jira-ep-debugging
        this.isDebugModeEnabled = (0, $4R6GH.fg)('ep-external-message-debug-mode');
    }
    async start(messageId) {
        if (this.isDebugModeEnabled) {
            const serverResponse = await super.start(messageId);
            if (this.enableChoreographer) this.onMessageDisposition?.(serverResponse ? (0, $g3Ayl.MessageDeliveryStatus).STARTED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            // eslint-disable-next-line no-alert, no-restricted-globals
            const shouldShowMessage = confirm(`\u{1F41E} \u{1D5D8}\u{1D5E3} \u{1D5D8}\u{1D605}\u{1D601}\u{1D5F2}\u{1D5FF}\u{1D5FB}\u{1D5EE}\u{1D5F9} \u{1D5E0}\u{1D5F2}\u{1D600}\u{1D600}\u{1D5EE}\u{1D5F4}\u{1D5F2} \u{1D5D7}\u{1D5F2}\u{1D5EF}\u{1D602}\u{1D5F4}\u{1D5F4}\u{1D5F2}\u{1D5FF}

Message ID: ${messageId}
Start call server response: ${serverResponse}

Do you want to display the message?`);
            if (!shouldShowMessage) {
                const didStop = await super.stop(messageId);
                if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $g3Ayl.MessageDeliveryStatus).STOPPED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            }
            return shouldShowMessage;
        }
        return this.shouldUseMockClient ? false // never allow messages to start
         : super.start(messageId).then((didStart)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStart ? (0, $g3Ayl.MessageDeliveryStatus).STARTED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            return didStart;
        });
    }
    async stop(messageId) {
        return this.shouldUseMockClient ? true // always allow messages to stop
         : super.stop(messageId).then((didStop)=>{
            if (this.enableChoreographer) this.onMessageDisposition?.(didStop ? (0, $g3Ayl.MessageDeliveryStatus).STOPPED : (0, $g3Ayl.MessageDeliveryStatus).BLOCKED);
            return didStop;
        });
    }
}
function $754c27d37ccd1133$export$2e2bcd8739ae039(props) {
    const { cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const stargateUrl = '/gateway/api';
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = (0, $ioD1B.useChoreographedStatusContext)();
    const client = new $754c27d37ccd1133$export$580a2294c917898c(cloudId, stargateUrl, props.shouldAllowOnSynthetic, orgId, props.messageType, props.onMessageDisposition, isAlreadyChoreographedAtAncestor);
    const { fallback: fallback, messageId: messageId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: client.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $brgOn.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        client: client,
        fallback: fallback,
        messageId: messageId
    }, props.children));
}

});



parcelRegister("3QTQ5", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $8ff29ea69a98d034$export$b326d77e4b8b7664);

var $5uXOq = parcelRequire("5uXOq");

var $96isx = parcelRequire("96isx");

var $k11Fy = parcelRequire("k11Fy");

var $fjBW7 = parcelRequire("fjBW7");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $aWq5G = parcelRequire("aWq5G");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $7UhxN = parcelRequire("7UhxN");

var $k1ALc = parcelRequire("k1ALc");

var $1vBwL = parcelRequire("1vBwL");

var $2RBG9 = parcelRequire("2RBG9");

var $7E0T0 = parcelRequire("7E0T0");

var $kfztd = parcelRequire("kfztd");

var $itmJb = parcelRequire("itmJb");

var $cNJA1 = parcelRequire("cNJA1");

var $dsZRM = parcelRequire("dsZRM");

var $7dRTN = parcelRequire("7dRTN");
const $8ff29ea69a98d034$var$ShortcutsSimplifyNavExperimentInner = ({ children: children })=>{
    const isSimplifyNavExperimentEnabled = (0, $7E0T0.useIsSimplifyNavExperimentEnabled)();
    return isSimplifyNavExperimentEnabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $8ff29ea69a98d034$var$ShortcutsSimplifyNavExperiment = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraNavigationAppsSidebarCommon",
        id: "sidebar.shortcuts",
        teamName: "jlove-makkuro",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$var$ShortcutsSimplifyNavExperimentInner, null, children));
const $8ff29ea69a98d034$export$1e66c1282cda9ed2 = ({ addItemLabel: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'string'.
addItemLabel = null, canAddItem: canAddItem, canAddLinks: canAddLinks, canAddRepositories: canAddRepositories, children: children = null, hasPages: hasPages = false, isSimplifiedProject: isSimplifiedProject = false, pagesLink: pagesLink, projectId: projectId, onPagesTabClick: onPagesTabClick, projectKey: projectKey, isBusinessProject: isBusinessProject = false, canShowOtherShortcuts: canShowOtherShortcuts = true })=>{
    const [{ data: rawShortcuts }, actions] = (0, $k1ALc.useShortcutItems)();
    const baseUrl = '';
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const isProjectPagesEnabled = hasPages && !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)();
    const [isModalOpenViaAddView] = (0, $2RBG9.useIsModalOpenViaAddView)();
    const { setIsModalOpenViaAddView: setIsModalOpenViaAddView } = (0, $2RBG9.useSimplifyNavExperimentActions)();
    if (!rawShortcuts || !actions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    // We need this id to focus edit shortcut button after closing edit modal for repo type shortcut, which is legacy
    const EDIT_SHORTCUT_BUTTON_ID_PREFIX = 'navigation-apps-sidebar.shortcuts.edit-shortcut-button-';
    const shortcuts = rawShortcuts.map((s)=>({
            ...s,
            editButtonId: EDIT_SHORTCUT_BUTTON_ID_PREFIX + s.id
        }));
    const urlForSoftwareProjects = isSimplifiedProject ? `/jira/software/projects/${projectKey}/pages` : `/jira/software/c/projects/${projectKey}/pages`;
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const Icon = isBusinessProject ? (0, (/*@__PURE__*/$parcel$interopDefault($k11Fy))) : (0, (/*@__PURE__*/$parcel$interopDefault($fjBW7)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vBwL.default), {
        // Shortcuts app from nav-next expect the navItemType to be NavigationItem, which is deprecated
        // @ts-expect-error - TS2322 - Type 'BoundActions<State, { readonly addItem: (item: ShortcutItem) => Action<State, void, void | Promise<void>>; readonly deleteItem: (id: string) => Action<State, void, void | Promise<...>>; readonly editItem: (item: ShortcutItem) => Action<...>; readonly editItems: (items: ShortcutItem[]) => Action<...>; readonly update...' is not assignable to type '{ addItem: (arg1: NavigationItem) => any; deleteItem: (arg1: string) => any; editItem: (arg1: NavigationItem) => any; editItems: (arg1: NavigationItem[]) => any; }'.
        methods: actions,
        // @ts-expect-error - TS2322 - Type 'ShortcutItem[]' is not assignable to type 'NavigationItem[]'.
        items: shortcuts,
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectId: projectId,
        isAdmin: isAdmin,
        showPagesSelector: !isSimplifiedProject,
        canAddLinks: canAddLinks,
        canAddRepositories: canAddRepositories,
        pagesLink: pagesLink,
        ...(0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate') && {
            isModalOpenViaAddView: isModalOpenViaAddView,
            setIsModalOpenViaAddView: setIsModalOpenViaAddView
        }
    }, ({ openAddModal: openAddModal, openEditModal: openEditModal, openManagePagesLinkModal: openManagePagesLinkModal, addItemButtonRef: addItemButtonRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isProjectPagesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsZRM.PagesMenuItem), {
            analytics: {
                itemId: 'pages',
                // @ts-expect-error TS2322 | TS2322 - Type '{ itemId: string; nextgen: boolean; projectId: number; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'. | Type '{ itemId: string; nextgen: boolean; projectId: number; connectionState: DevOpsToolConnectionState | undefined; }' is not assignable to type 'Analytics'.
                nextgen: isSimplifiedProject,
                projectId: projectId
            },
            "aria-labelledby": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link",
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure, jira/integration/enforce-data-testid-usage
            "data-test-id": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link",
            href: isBusinessProject ? `/jira/core/projects/${projectKey}/pages` : urlForSoftwareProjects,
            projectId: projectId,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: ""
            }),
            onClick: onPagesTabClick,
            selectedOn: [
                'project-pages'
            ],
            onEditClick: pagesLink?.canEdit ? openManagePagesLinkModal : undefined,
            pagesMenuItemTitle: isBusinessProject ? (0, $7dRTN.messages).pagesItem : undefined
        }), canShowOtherShortcuts && shortcuts.map((shortcut)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aWq5G.Shortcut), {
                shortcut: shortcut,
                key: shortcut.id,
                openEditItem: openEditModal
            })), children, canAddItem && ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$var$ShortcutsSimplifyNavExperiment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'shortcuts--add'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96isx))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: openAddModal,
            ref: addItemButtonRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps-sidebar-common.ui.shortcuts.shortcuts-add-link"
        }, addItemLabel || formatMessage((0, $cNJA1.messages).addItem))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            analytics: {
                itemId: 'shortcuts--add'
            },
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96isx))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: openAddModal,
            ref: addItemButtonRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps-sidebar-common.ui.shortcuts.shortcuts-add-link"
        }, addItemLabel || formatMessage((0, $cNJA1.messages).addItem)))));
};
const $8ff29ea69a98d034$export$b326d77e4b8b7664 = ({ children: children = null, ...rest })=>{
    const { data: data, loading: loading } = (0, $7UhxN.useShortcutsData)();
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1ALc.ShortcutsContainer), {
        data: data,
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8ff29ea69a98d034$export$1e66c1282cda9ed2, rest, children));
};

});
parcelRegister("96isx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c635a2f2e69a7d56a90070d44e636799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a02fe353a1d9932$var$_react = $6a02fe353a1d9932$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6a02fe353a1d9932$var$_shortcut = $6a02fe353a1d9932$var$_interopRequireDefault((parcelRequire("7blBA")));

var $6a02fe353a1d9932$var$_addItem = $6a02fe353a1d9932$var$_interopRequireDefault((parcelRequire("7eJ3t")));
function $6a02fe353a1d9932$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShortcutIcon.
 * This component is ShortcutIcon, with `UNSAFE_fallbackIcon` set to "AddItemIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a02fe353a1d9932$var$ShortcutIcon = (props)=>/*#__PURE__*/ $6a02fe353a1d9932$var$_react.default.createElement($6a02fe353a1d9932$var$_shortcut.default, Object.assign({
        LEGACY_fallbackIcon: $6a02fe353a1d9932$var$_addItem.default
    }, props));
$6a02fe353a1d9932$var$ShortcutIcon.Name = 'ShortcutIconMigration';
var $6a02fe353a1d9932$var$_default = module.exports.default = $6a02fe353a1d9932$var$ShortcutIcon;

});
parcelRegister("7blBA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d24329325b8e254a68f910248b6c4858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53aa51d2cbebaf51$var$_react = $53aa51d2cbebaf51$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $53aa51d2cbebaf51$var$_baseNew = $53aa51d2cbebaf51$var$_interopRequireDefault((parcelRequire("enEmH")));
function $53aa51d2cbebaf51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53aa51d2cbebaf51$var$ShortcutIcon = (props)=>/*#__PURE__*/ $53aa51d2cbebaf51$var$_react.default.createElement($53aa51d2cbebaf51$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$53aa51d2cbebaf51$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $53aa51d2cbebaf51$var$_default = module.exports.default = $53aa51d2cbebaf51$var$ShortcutIcon;

});

parcelRegister("7eJ3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $544cca37a577ff71$var$_react = $544cca37a577ff71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $544cca37a577ff71$var$_shortcut = $544cca37a577ff71$var$_interopRequireDefault((parcelRequire("7blBA")));
function $544cca37a577ff71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $544cca37a577ff71$var$AddItemIcon = (props)=>/*#__PURE__*/ $544cca37a577ff71$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M16.002 3H4.995A1.995 1.995 0 0 0 3 4.995v14.01C3 20.107 3.893 21 4.995 21h14.01A1.995 1.995 0 0 0 21 19.005V7.998 11h-2v8H5V5h8V3z"/><path d="M19 5V3.99A1 1 0 0 0 18 3c-.556 0-1 .444-1 .99V5h-1a1 1 0 0 0 0 2h1v1.01A1 1 0 0 0 18 9c.556 0 1-.444 1-.99V7h1a1 1 0 0 0 0-2z"/></g></svg>`
    }, props, {
        newIcon: $544cca37a577ff71$var$_shortcut.default
    }));
$544cca37a577ff71$var$AddItemIcon.displayName = 'AddItemIcon';
var $544cca37a577ff71$var$_default = module.exports.default = $544cca37a577ff71$var$AddItemIcon;

});


parcelRegister("k11Fy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e92532192e00a5e6$var$_react = $e92532192e00a5e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $e92532192e00a5e6$var$_file = $e92532192e00a5e6$var$_interopRequireDefault((parcelRequire("4a1LF")));
function $e92532192e00a5e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e92532192e00a5e6$var$FileIcon = (props)=>/*#__PURE__*/ $e92532192e00a5e6$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 0 0 1.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8.995z"/><rect width="8" height="2" x="8" y="12" rx="1"/><rect width="4" height="2" x="8" y="15" rx="1"/></g></svg>`
    }, props, {
        newIcon: $e92532192e00a5e6$var$_file.default
    }));
$e92532192e00a5e6$var$FileIcon.displayName = 'FileIcon';
var $e92532192e00a5e6$var$_default = module.exports.default = $e92532192e00a5e6$var$FileIcon;

});
parcelRegister("4a1LF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $307977acb25eeff1$var$_react = $307977acb25eeff1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $307977acb25eeff1$var$_baseNew = $307977acb25eeff1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $307977acb25eeff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $307977acb25eeff1$var$FileIcon = (props)=>/*#__PURE__*/ $307977acb25eeff1$var$_react.default.createElement($307977acb25eeff1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$307977acb25eeff1$var$FileIcon.displayName = 'FileIcon';
var $307977acb25eeff1$var$_default = module.exports.default = $307977acb25eeff1$var$FileIcon;

});


parcelRegister("aWse0", function(module, exports) {

$parcel$export(module.exports, "useIntlV2", () => $6b28e3c9e1c89fbd$export$d82607073b68786);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");
const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
    const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $koVbs.default)();
    // Only recreate intl object if reference to originral intl changes.
    const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
        const modifiedIntl = {
            messages: // @ts-expect-error - TS2322 - Type 'Record<string, string> | Record<string, MessageFormatElement[]>' is not assignable to type '{ [id: string]: string; }'.
            messages,
            locale: locale,
            formats: formats,
            formatDate: formatDate,
            formatMessage: formatMessage,
            formatNumber: formatNumber,
            formatPlural: formatPlural,
            formatTime: formatTime
        };
        return modifiedIntl;
    }, [
        formatDate,
        formatMessage,
        formatPlural,
        formatTime,
        formatNumber,
        formats,
        locale,
        messages
    ]);
    return memoisedIntl;
};

});

parcelRegister("aWq5G", function(module, exports) {

$parcel$export(module.exports, "Shortcut", () => $a8022ab33881936a$export$59451aa6b6270879);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $5KCCi = parcelRequire("5KCCi");

var $aWse0 = parcelRequire("aWse0");

var $7eui6 = parcelRequire("7eui6");

var $72RJC = parcelRequire("72RJC");

var $kvHKs = parcelRequire("kvHKs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $9olct = parcelRequire("9olct");
const $a8022ab33881936a$var$styles = {
    emojiWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _p12f1tcg _c71l1tcg",
    emojiPlaceholder: "_11c8nf1z _kdam1apl",
    menuItem: "_btpd1ady _1c06idpf _g718kb7n _3u8ukb7n"
};
const $a8022ab33881936a$export$59451aa6b6270879 = ({ EditButton: EditButton = (0, $7eui6.EditButton), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), SyncButton: SyncButton = (0, $72RJC.SyncButton), openEditItem: openEditItem, shortcut: shortcut, useIntl: // @ts-expect-error - TS2339 - Property 'useIntl' does not exist on type 'ShortcutProps'.
useIntl = (0, $aWse0.useIntlV2) })=>{
    const { before: DefaultIconBefore, canEdit: canEdit, href: href, id: shortcutId, onEditClick: onEditClick, onSyncClick: onSyncClick, shortcutType: shortcutType, showSync: showSync, text: text, editButtonId: editButtonId } = shortcut;
    const { formatMessage: formatMessage } = useIntl();
    let iconBefore = DefaultIconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DefaultIconBefore, null) : null;
    let shortcutText = text || '';
    if (shortcutType === (0, $kvHKs.LINK_TYPE) && shortcutText) {
        const match = shortcutText.match((0, $kvHKs.EMOJI_REGEX));
        if (match) {
            const [emoji] = match;
            const linkText = shortcutText.substr(emoji.length).trim();
            if (linkText) shortcutText = linkText;
            if (emoji) iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                className: (0, $bwpsq.default)([
                    $a8022ab33881936a$var$styles.emojiWrapper
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
                className: (0, $bwpsq.default)([
                    $a8022ab33881936a$var$styles.emojiPlaceholder
                ])
            }, emoji));
        }
    }
    const iconAfter = (()=>{
        if (showSync === true && onSyncClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SyncButton, {
            id: shortcutId,
            onClick: onSyncClick,
            label: formatMessage((0, $9olct.messages).sync)
        });
        if (canEdit === true) {
            let onClick = openEditItem; // We do not edit repository shortcuts on our own, instead we allow another plugin doing it.
            // Till the moment that plugin gets initialized we won't be rendering edit icon.
            if (shortcutType === (0, $kvHKs.REPO_TYPE)) {
                if (!onEditClick) return null;
                onClick = onEditClick;
            }
            const ariaLabel = shortcutText !== '' ? formatMessage((0, $9olct.messages).editWithShortcutText, {
                shortcutText: shortcutText
            }) : formatMessage((0, $9olct.messages).edit);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditButton, {
                id: editButtonId,
                shortcutId: shortcutId,
                onClick: onClick,
                label: ariaLabel
            });
        }
        return null;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KCCi.default), {
        tag: "span",
        content: shortcutText,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: `shortcut--item-${shortcutId}`
        },
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        href: href,
        target: "_blank",
        className: (0, $bwpsq.default)([
            $a8022ab33881936a$var$styles.menuItem
        ])
    }, shortcutText));
};

});
parcelRegister("7eui6", function(module, exports) {

$parcel$export(module.exports, "EditButton", () => $3765b526fab19461$export$a8d3280cb45e38b8);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $gTpfq = parcelRequire("gTpfq");

var $45xDm = parcelRequire("45xDm");
const $3765b526fab19461$export$a8d3280cb45e38b8 = ({ onClick: onClick, shortcutId: shortcutId, id: id, label: label })=>{
    const [isHover, setIsHover] = (0, $5uXOq.useState)(true);
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onButtonClick = (event)=>{
        event.preventDefault();
        onClick(shortcutId, buttonRef);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle-link",
        "aria-label": label,
        spacing: "none",
        onClick: onButtonClick,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        onFocus: ()=>setIsHover(true),
        onBlur: ()=>setIsHover(false),
        id: id,
        ref: buttonRef
    }, isHover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45xDm))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gTpfq))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: ""
    }));
};

});
parcelRegister("gTpfq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c55e11080ecfc1$var$_react = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c4c55e11080ecfc1$var$_edit = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("084bx")));

var $c4c55e11080ecfc1$var$_edit2 = $c4c55e11080ecfc1$var$_interopRequireDefault((parcelRequire("78GxT")));
function $c4c55e11080ecfc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c55e11080ecfc1$var$EditIcon = (props)=>/*#__PURE__*/ $c4c55e11080ecfc1$var$_react.default.createElement($c4c55e11080ecfc1$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $c4c55e11080ecfc1$var$_edit2.default
    }, props));
$c4c55e11080ecfc1$var$EditIcon.Name = 'EditIconMigration';
var $c4c55e11080ecfc1$var$_default = module.exports.default = $c4c55e11080ecfc1$var$EditIcon;

});
parcelRegister("084bx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0006420a77150094$var$_react = $0006420a77150094$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0006420a77150094$var$_baseNew = $0006420a77150094$var$_interopRequireDefault((parcelRequire("enEmH")));
function $0006420a77150094$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0006420a77150094$var$EditIcon = (props)=>/*#__PURE__*/ $0006420a77150094$var$_react.default.createElement($0006420a77150094$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$0006420a77150094$var$EditIcon.displayName = 'EditIcon';
var $0006420a77150094$var$_default = module.exports.default = $0006420a77150094$var$EditIcon;

});

parcelRegister("78GxT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $532a48721af78794$var$_react = $532a48721af78794$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $532a48721af78794$var$_edit = $532a48721af78794$var$_interopRequireDefault((parcelRequire("084bx")));
function $532a48721af78794$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $532a48721af78794$var$EditIcon = (props)=>/*#__PURE__*/ $532a48721af78794$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $532a48721af78794$var$_edit.default
    }));
$532a48721af78794$var$EditIcon.displayName = 'EditIcon';
var $532a48721af78794$var$_default = module.exports.default = $532a48721af78794$var$EditIcon;

});


parcelRegister("45xDm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d8183d86255e266d89dc1fd99bbc4dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fa1b806f5b29ed7$var$_react = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2fa1b806f5b29ed7$var$_edit = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("084bx")));

var $2fa1b806f5b29ed7$var$_editFilled = $2fa1b806f5b29ed7$var$_interopRequireDefault((parcelRequire("glcam")));
function $2fa1b806f5b29ed7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fa1b806f5b29ed7$var$EditIcon = (props)=>/*#__PURE__*/ $2fa1b806f5b29ed7$var$_react.default.createElement($2fa1b806f5b29ed7$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $2fa1b806f5b29ed7$var$_editFilled.default
    }, props));
$2fa1b806f5b29ed7$var$EditIcon.Name = 'EditIconMigration';
var $2fa1b806f5b29ed7$var$_default = module.exports.default = $2fa1b806f5b29ed7$var$EditIcon;

});
parcelRegister("glcam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be580b73570dd198$var$_react = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $be580b73570dd198$var$_edit = $be580b73570dd198$var$_interopRequireDefault((parcelRequire("084bx")));
function $be580b73570dd198$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $be580b73570dd198$var$EditFilledIcon = (props)=>/*#__PURE__*/ $be580b73570dd198$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $be580b73570dd198$var$_edit.default
    }));
$be580b73570dd198$var$EditFilledIcon.displayName = 'EditFilledIcon';
var $be580b73570dd198$var$_default = module.exports.default = $be580b73570dd198$var$EditFilledIcon;

});



parcelRegister("72RJC", function(module, exports) {

$parcel$export(module.exports, "SyncButton", () => $34948fa341d4f6ba$export$3826f2c15cf9a4f4);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $5wFdR = parcelRequire("5wFdR");
const $34948fa341d4f6ba$export$3826f2c15cf9a4f4 = ({ id: id, onClick: onClick, label: label })=>{
    const onButtonClick = (event)=>{
        event.preventDefault();
        onClick(id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle-link",
        onClick: onButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wFdR))), {
        LEGACY_size: "small",
        label: label
    }));
};
var $34948fa341d4f6ba$export$2e2bcd8739ae039 = $34948fa341d4f6ba$export$3826f2c15cf9a4f4;

});
parcelRegister("5wFdR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $405fead422c4948a$var$_react = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $405fead422c4948a$var$_refresh = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("6SDzC")));

var $405fead422c4948a$var$_refresh2 = $405fead422c4948a$var$_interopRequireDefault((parcelRequire("UPm1a")));
function $405fead422c4948a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $405fead422c4948a$var$RefreshIcon = (props)=>/*#__PURE__*/ $405fead422c4948a$var$_react.default.createElement($405fead422c4948a$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $405fead422c4948a$var$_refresh2.default
    }, props));
$405fead422c4948a$var$RefreshIcon.Name = 'RefreshIconMigration';
var $405fead422c4948a$var$_default = module.exports.default = $405fead422c4948a$var$RefreshIcon;

});
parcelRegister("6SDzC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::688997f0a16a41562042ca280fe15628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50267bae9676a074$var$_react = $50267bae9676a074$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $50267bae9676a074$var$_baseNew = $50267bae9676a074$var$_interopRequireDefault((parcelRequire("enEmH")));
function $50267bae9676a074$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50267bae9676a074$var$RefreshIcon = (props)=>/*#__PURE__*/ $50267bae9676a074$var$_react.default.createElement($50267bae9676a074$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$50267bae9676a074$var$RefreshIcon.displayName = 'RefreshIcon';
var $50267bae9676a074$var$_default = module.exports.default = $50267bae9676a074$var$RefreshIcon;

});

parcelRegister("UPm1a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aad10f002a9a12a$var$_react = $0aad10f002a9a12a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $0aad10f002a9a12a$var$_refresh = $0aad10f002a9a12a$var$_interopRequireDefault((parcelRequire("6SDzC")));
function $0aad10f002a9a12a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0aad10f002a9a12a$var$RefreshIcon = (props)=>/*#__PURE__*/ $0aad10f002a9a12a$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $0aad10f002a9a12a$var$_refresh.default
    }));
$0aad10f002a9a12a$var$RefreshIcon.displayName = 'RefreshIcon';
var $0aad10f002a9a12a$var$_default = module.exports.default = $0aad10f002a9a12a$var$RefreshIcon;

});



parcelRegister("k0ZZ2", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $5e6269ab5deb76fb$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aZsz6 = parcelRequire("aZsz6");

var $bY5Mc = parcelRequire("bY5Mc");

var $hjSul = parcelRequire("hjSul");
var $doZTA = parcelRequire("doZTA");

var $fpoBX = parcelRequire("fpoBX");

var $jvqf4 = parcelRequire("jvqf4");
const $5e6269ab5deb76fb$var$cssVarPrefix = '--sidebar-menu-item';
const $5e6269ab5deb76fb$var$bgColorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color`;
const $5e6269ab5deb76fb$var$bgColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-hover`;
const $5e6269ab5deb76fb$var$bgColorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-bg-color-active`;
const $5e6269ab5deb76fb$var$colorCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color`;
const $5e6269ab5deb76fb$var$colorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-hover`;
const $5e6269ab5deb76fb$var$colorActiveCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-color-active`;
const $5e6269ab5deb76fb$var$boxShadowCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-box-shadow`;
const $5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar = `${$5e6269ab5deb76fb$var$cssVarPrefix}-icon-secondary-color-hover`;
const $5e6269ab5deb76fb$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $5e6269ab5deb76fb$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $5uXOq.createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $5uXOq.createElement($5e6269ab5deb76fb$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $jvqf4.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $doZTA.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZsz6)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $fpoBX.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $5e6269ab5deb76fb$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$5e6269ab5deb76fb$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$5e6269ab5deb76fb$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$5e6269ab5deb76fb$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$5e6269ab5deb76fb$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$5e6269ab5deb76fb$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$5e6269ab5deb76fb$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.root
            ]),
            isSelected && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $bwpsq.default)([
                $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $5uXOq.createElement((0, $bY5Mc.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            $5e6269ab5deb76fb$var$styles.root,
            isSelected && $5e6269ab5deb76fb$var$styles.selected,
            itemTheme?.color?.default && $5e6269ab5deb76fb$var$styles.themeColorDefault,
            itemTheme?.background?.default && $5e6269ab5deb76fb$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $5e6269ab5deb76fb$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $5e6269ab5deb76fb$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $5e6269ab5deb76fb$var$styles.themeColorHover,
            itemTheme?.color?.active && $5e6269ab5deb76fb$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $5e6269ab5deb76fb$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e6269ab5deb76fb$var$ButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvqf4", function(module, exports) {

$parcel$export(module.exports, "useOnClick", () => $568e03d72b926f2a$export$a81c45382e7253ac);

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("9olct", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8656b699d75bb3ee$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $8656b699d75bb3ee$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    edit: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.edit",
        "defaultMessage": "Edit shortcut"
    },
    editWithShortcutText: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.edit-with-shortcut-text",
        "defaultMessage": "Edit shortcut for {shortcutText}"
    },
    sync: {
        "id": "navigation-apps-shortcuts-sidebar.shortcut.sync",
        "defaultMessage": "Sync"
    }
});

});


parcelRegister("7UhxN", function(module, exports) {

$parcel$export(module.exports, "useShortcutsData", () => $799685b63be28a3b$export$47d387d66bf16cb);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $iEUaw = parcelRequire("iEUaw");

var $324W5 = parcelRequire("324W5");

var $5hv0u = parcelRequire("5hv0u");

var $89Akw = parcelRequire("89Akw");
const $799685b63be28a3b$var$transformShortcutsMemo = (0, $8QpSo.default)((a, b)=>(0, $89Akw.transformShortcuts)(a, b));
const $799685b63be28a3b$var$emptyData = [];
const $799685b63be28a3b$export$47d387d66bf16cb = (customContext)=>{
    const canEdit = (0, $5hv0u.useCanEditShortcuts)(customContext);
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $iEUaw.staticSidebarShortcutsResource), customContext);
    const items = (0, $5uXOq.useMemo)(()=>data && $799685b63be28a3b$var$transformShortcutsMemo(data, canEdit), [
        data,
        canEdit
    ]); // canEdit should be the same for all shortcuts per person, per project
    return {
        data: items || $799685b63be28a3b$var$emptyData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5hv0u", function(module, exports) {

$parcel$export(module.exports, "useCanEditShortcuts", () => $e888d8394c5baf80$export$cf4f3a9f01fdc8a7);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $dhuBw = parcelRequire("dhuBw");
const $e888d8394c5baf80$export$cf4f3a9f01fdc8a7 = (customContext)=>{
    const { data: data } = (0, $1J3t1.useProjectSidebarNavigation)(customContext);
    return (0, $5uXOq.useMemo)(()=>data && (0, $dhuBw.getCanEditShortcuts)(data), [
        data
    ]) || false;
};

});
parcelRegister("dhuBw", function(module, exports) {

$parcel$export(module.exports, "getCanEditShortcuts", () => $050e711b4fac24d4$export$c64b03ccce2c3de);
const $050e711b4fac24d4$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS || false;
const $050e711b4fac24d4$export$c64b03ccce2c3de = (data)=>{
    const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
    switch(projectType){
        case 'jira_work_management':
            return jiraWorkManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraWorkManagementNavData.permissionInfo) : false;
        case 'jira_software':
            return jiraSoftwareNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraSoftwareNavData.permissionInfo) : false;
        case 'jira_service_management':
            return jiraServiceManagementNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraServiceManagementNavData.permissionInfo) : false;
        case 'jira_product_discovery':
            return jiraProductDiscoveryNavData?.permissionInfo ? $050e711b4fac24d4$var$isProjectOrJiraAdmin(jiraProductDiscoveryNavData.permissionInfo) : false;
        case null:
            return false;
        default:
            return false;
    }
};

});


parcelRegister("89Akw", function(module, exports) {

$parcel$export(module.exports, "transformShortcuts", () => $c195049077f99f76$export$1fc4378e3ea910d0);
const $c195049077f99f76$var$getShortcutIcon = (type)=>{
    if (type == null || type === 'unknown' || type === 'unsupported') return 'shortcut';
    if (type === 'github') return 'repos';
    return type;
};
const $c195049077f99f76$export$1fc4378e3ea910d0 = (arrayOfShortcuts, canEditOld)=>{
    if (arrayOfShortcuts && Array.isArray(arrayOfShortcuts)) {
        const links = [];
        const repos = [];
        arrayOfShortcuts.forEach((shortcut)=>{
            const shortcutIcon = $c195049077f99f76$var$getShortcutIcon(shortcut.dvcsType);
            const s = {
                id: shortcut.type == null ? `com.atlassian.jira.jira-projects-plugin:project.shortcut.default.link.${shortcut.id}` : `com.atlassian.jira.jira-projects-plugin:${shortcut.type}.${shortcut.id}`,
                name: shortcut.name,
                icon: shortcutIcon,
                url: shortcut.url,
                selected: false,
                section: false,
                separator: false,
                showDot: false,
                hasLandingPage: false,
                canEdit: canEditOld,
                showSync: false,
                canDismiss: false,
                sortable: false,
                target: '_blank'
            };
            shortcut.type === 'source.code.link' ? repos.push(s) : links.push(s);
        });
        return repos.concat(links);
    }
    return [];
};

});


parcelRegister("k1ALc", function(module, exports) {

$parcel$export(module.exports, "ShortcutsContainer", () => $6885b5bf730cd03e$export$df449cf702d8e0fd);
$parcel$export(module.exports, "useShortcutItems", () => $6885b5bf730cd03e$export$2c1990af0fa688a3);

var $5uXOq = parcelRequire("5uXOq");

var $6P0Kj = parcelRequire("6P0Kj");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4bqWq = parcelRequire("4bqWq");
const $6885b5bf730cd03e$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        spacing: "spacious",
        label: "shortcut"
    });
const $6885b5bf730cd03e$export$fb9705de59d96855 = (item)=>({ setState: setState, getState: getState })=>{
        const { shortcutType: shortcutType } = item;
        const state = getState();
        const index = state.data.map((i)=>i.shortcutType).lastIndexOf(shortcutType);
        const newItem = {
            before: $6885b5bf730cd03e$var$renderShortcutIcon,
            ...item,
            target: '_blank',
            canEdit: true,
            itemType: 'shortcut'
        };
        // Append new item to same shortcuts group
        if (index === -1) // @ts-expect-error - TS2322 - Type 'ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'. | TS2322 - Type '{ target: string; canEdit: boolean; itemType: string; before: React.ComponentType<Record<any, any>> | (() => JSX.Element); href?: string | undefined; icon?: string | undefined; ... 6 more ...; text?: string | undefined; }' is not assignable to type 'ShortcutItem'.
        setState({
            data: [
                ...state.data,
                newItem
            ]
        });
        else setState({
            // @ts-expect-error - TS2322 - Type '(ShortcutItem | { target: string; canEdit: boolean; itemType: string; before: ComponentType<Record<any, any>> | (() => Element); href?: string | undefined; ... 7 more ...; text?: string | undefined; })[]' is not assignable to type 'ShortcutItem[]'.
            data: [
                ...state.data.slice(0, index + 1),
                newItem,
                ...state.data.slice(index + 1)
            ]
        });
    };
const $6885b5bf730cd03e$export$8d8542dbbc23fe1a = (id)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.filter((existingItem)=>existingItem.id !== id);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$60832f4899fbf6a1 = (item)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>existingItem.id !== item.id ? existingItem : item);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$8c896bccb18e1db1 = (items)=>({ setState: setState, getState: getState })=>{
        if (!items.length) return;
        const { data: data } = getState();
        const newItems = data.map((existingItem)=>items.find((item)=>item.id === existingItem.id) || existingItem);
        setState({
            data: newItems
        });
    };
const $6885b5bf730cd03e$export$ed2a7beca2c9674 = (data, loading)=>({ setState: setState, getState: getState })=>{
        const items = (data || []).map((0, $4bqWq.getItemFromLink));
        const state = getState();
        return setState({
            ...state,
            loading: loading,
            data: items,
            oldData: items,
            isLoaded: true
        });
    };
const $6885b5bf730cd03e$export$e324594224ef24da = {
    addItem: $6885b5bf730cd03e$export$fb9705de59d96855,
    deleteItem: $6885b5bf730cd03e$export$8d8542dbbc23fe1a,
    editItem: $6885b5bf730cd03e$export$60832f4899fbf6a1,
    editItems: $6885b5bf730cd03e$export$8c896bccb18e1db1,
    updateContainer: $6885b5bf730cd03e$export$ed2a7beca2c9674
};
const $6885b5bf730cd03e$export$d4c72bab9d6cc13a = {
    data: [],
    oldData: null,
    loading: false,
    isLoaded: false
};
/**
 * Instance
 */ const $6885b5bf730cd03e$var$Store = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: $6885b5bf730cd03e$export$d4c72bab9d6cc13a,
    actions: $6885b5bf730cd03e$export$e324594224ef24da
});
var $6885b5bf730cd03e$export$2e2bcd8739ae039 = $6885b5bf730cd03e$var$Store;
const $6885b5bf730cd03e$export$df449cf702d8e0fd = (0, $gg7kZ.createContainer)($6885b5bf730cd03e$var$Store, {
    onInit: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        },
    onUpdate: ()=>({ dispatch: dispatch }, { data: data, loading: loading })=>{
            dispatch($6885b5bf730cd03e$export$e324594224ef24da.updateContainer(data, loading));
        }
});
const $6885b5bf730cd03e$export$2c1990af0fa688a3 = (0, $3sQ5x.createHook)($6885b5bf730cd03e$var$Store);

});
parcelRegister("4bqWq", function(module, exports) {

$parcel$export(module.exports, "getItemFromLink", () => $5f237ed4c010c05c$export$60d4c4ef6da272ad);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $32ra4 = parcelRequire("32ra4");

var $a8Wzb = parcelRequire("a8Wzb");

var $h6M2t = parcelRequire("h6M2t");
const $5f237ed4c010c05c$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
const $5f237ed4c010c05c$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6M2t.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $5f237ed4c010c05c$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $5f237ed4c010c05c$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($32ra4));
        default:
            // @ts-expect-error - TS2322 - Type 'typeof default' is not assignable to type 'ComponentType<GlyphProps | Props | (Pick<GlyphProps, "testId" | "primaryColor" | "secondaryColor"> & Partial<Pick<GlyphProps, "label" | "size">> & Partial<...>) | (Pick<...> & ... 1 more ... & Partial<...>)>'.
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8Wzb));
    }
};
const $5f237ed4c010c05c$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($5f237ed4c010c05c$var$getLinkParts(linkId));
const $5f237ed4c010c05c$export$d37d2882f5261346 = (linkId)=>linkId;
const $5f237ed4c010c05c$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($5f237ed4c010c05c$var$getLinkParts(linkId)).join('.');
const $5f237ed4c010c05c$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $5f237ed4c010c05c$export$3cec694c50bc695d(linkId);
    const shortcutType = $5f237ed4c010c05c$export$92a97f8239a551c5(linkId);
    const target = link.target ?? '_blank';
    const Icon = $5f237ed4c010c05c$export$16b26cd5e98d9100(icon);
    return {
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});
parcelRegister("ixUGT", function(module, exports) {

var $dM3Z8 = parcelRequire("dM3Z8");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $d80748aee2c24c33$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $dM3Z8(array, 0, -1) : [];
}
module.exports = $d80748aee2c24c33$var$initial;

});

parcelRegister("32ra4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2366a0b0419b8fbf$var$_react = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $2366a0b0419b8fbf$var$_angleBrackets = $2366a0b0419b8fbf$var$_interopRequireDefault((parcelRequire("elXz8")));
function $2366a0b0419b8fbf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2366a0b0419b8fbf$var$BitbucketReposIcon = (props)=>/*#__PURE__*/ $2366a0b0419b8fbf$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 5v14h14V5zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/><path d="M9.23 8.31 6.3 11.26a1.06 1.06 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L8.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.02 1.02 0 0 0-.73-.3c-.27 0-.53.1-.73.31m4.06 0a1.05 1.05 0 0 0 0 1.48L15.5 12l-2.2 2.22a1.05 1.05 0 0 0 0 1.48c.4.41 1.06.41 1.46 0l2.93-2.95a1.05 1.05 0 0 0 0-1.48l-2.93-2.96a1.03 1.03 0 0 0-1.46 0"/></g></svg>`
    }, props, {
        newIcon: $2366a0b0419b8fbf$var$_angleBrackets.default
    }));
$2366a0b0419b8fbf$var$BitbucketReposIcon.displayName = 'BitbucketReposIcon';
var $2366a0b0419b8fbf$var$_default = module.exports.default = $2366a0b0419b8fbf$var$BitbucketReposIcon;

});

parcelRegister("h6M2t", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $8d4219c64b075729$export$5fc1066e677788d4);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $8d4219c64b075729$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $8d4219c64b075729$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $8d4219c64b075729$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("1vBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e55df98ec766a24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6P0Kj = parcelRequire("6P0Kj");

var $7T84i = parcelRequire("7T84i");
var $cQZXC = parcelRequire("cQZXC");

var $2YZCu = parcelRequire("2YZCu");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $g5X3G = parcelRequire("g5X3G");

var $b7Svb = parcelRequire("b7Svb");
var $Ix35T = parcelRequire("Ix35T");


var $lkWkR = parcelRequire("lkWkR");

const $0e55df98ec766a24$export$220dc4f1b8ffa17c = (0, $b7Svb.lazy)(()=>(parcelRequire("jA4Dc")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/add-link-modal/index.tsx"
});

const $0e55df98ec766a24$export$f4f22b2fa38658d6 = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiSFl")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item/index.tsx"
});

const $0e55df98ec766a24$export$f525b7ef0c89cbed = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("2EZdp")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/add-item-v2/index.tsx"
});

const $0e55df98ec766a24$export$234ec8e31562766c = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aFtLa")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/main/view/edit-shortcut-modal/index.tsx"
});

const $0e55df98ec766a24$export$14ff0695ca26505c = (0, $b7Svb.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("67YVY")), {
    moduleId: "./src/packages/navigation-apps/shortcuts/src/manage-pages-link-modal/index.tsx"
});
const $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY = 500;
const $0e55df98ec766a24$var$renderShortcutIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
        spacing: "spacious",
        label: ""
    });
const $0e55df98ec766a24$var$findRepoShortcuts = (items)=>items.filter((i)=>i.shortcutType === (0, $27f32c1fbb856eaf$export$399c7e6858236b4));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0e55df98ec766a24$var$toItem = (link)=>{
    // We cannot create shortcuts with legacyId as it would exclude them from the list of navigation items -
    // they don't exist in the sidebar config we've fetched before
    const { legacyId: legacyId, ...withoutLegacyId } = (0, $lkWkR.getItemFromLink)(link);
    return {
        ...withoutLegacyId,
        onEditClick: ()=>setTimeout(()=>link.onEditClick()),
        onSyncClick: link.onSyncClick
    };
};
class $0e55df98ec766a24$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isSpa: false,
            isAdmin: false,
            canAddLinks: true,
            canAddRepositories: false,
            showPagesSelector: true,
            items: []
        };
    }
    constructor(props){
        super(props), this.addItemButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onAddItem = ()=>{
            if (this.props.canAddLinks && !this.state.canAddRepositories) this.onAddLink();
            else if (this.state.canAddRepositories && !this.props.canAddLinks) this.onAddRepository();
            else this.setState({
                addItem: {
                    type: undefined
                }
            });
        }, this.onAddLink = ()=>{
            // if a modal is already open, close it and open the add link modal
            // with a delay to ensure the modal is closed before opening the new one
            if (this.state.addItem) {
                this.setState({
                    addItem: undefined
                });
                // wait for the modal to close before opening the next modal
                setTimeout(()=>{
                    this.setState({
                        addItem: {
                            type: 'link'
                        }
                    });
                }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
            } else this.setState({
                addItem: {
                    type: 'link'
                }
            });
        }, this.onAddRepository = ()=>{
            this.setState(()=>({
                    addItem: undefined
                }));
            setTimeout(()=>{
                if (typeof this.repositoryApi.add === 'function') this.repositoryApi.add();
                else (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', "Cannot open add repository shortcut modal - the API wan't set up");
            }, $0e55df98ec766a24$var$MODAL_ANIMATION_DELAY);
        }, this.onAddItemCompleted = ({ item: item })=>{
            if (item) this.props.methods.addItem({
                ...item,
                target: '_blank',
                canEdit: true,
                before: $0e55df98ec766a24$var$renderShortcutIcon
            });
            this.setState(()=>{
                return {
                    addItem: undefined
                };
            }, ()=>{
                if (this.addItemButtonRef?.current) this.addItemButtonRef.current.focus();
            });
        }, this.onEditOrDeleteItem = (id, ref)=>{
            if (ref) this.setState({
                editOrDeleteItem: id,
                editShortcutButtonRef: ref
            });
            else this.setState({
                editOrDeleteItem: id
            });
        }, this.openManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: true
            });
        }, this.closeManagePagesLinkModal = ()=>{
            this.setState({
                isPagesModalOpen: false
            });
        }, this.onEditOrDeleteItemCompleted = (args)=>{
            const { item: item, deleted: deleted } = args;
            if (item) deleted ? this.props.methods.deleteItem(item.id) : this.props.methods.editItem(item);
            this.setState(()=>{
                return {
                    editOrDeleteItem: undefined,
                    editShortcutButtonRef: undefined
                };
            });
        }, this.setPagesLink = ({ setPagesLink: setPagesLink })=>(isEnabled)=>{
                const { baseUrl: baseUrl, projectKey: projectKey } = this.props;
                return setPagesLink({
                    baseUrl: (0, $g5X3G.toBaseUrl)(baseUrl),
                    projectKey: (0, $g5X3G.toProjectKey)(projectKey),
                    enable: isEnabled
                });
            }, this.repositoryApi = {};
        this.state = {
            canAddRepositories: props.canAddRepositories,
            addItem: undefined,
            editOrDeleteItem: undefined,
            isPagesModalOpen: false,
            editShortcutButtonRef: undefined
        };
        if (props.canAddRepositories) this.initLegacyBridgeAPI();
    }
    componentDidMount() {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) this.showModalIfAddShortcutClickedFromAddView();
    }
    componentDidUpdate(prevProps) {
        if ((0, $4R6GH.fg)('jsw_simplify_navigation_m2_gate')) {
            if (this.props.isModalOpenViaAddView !== prevProps.isModalOpenViaAddView) this.showModalIfAddShortcutClickedFromAddView();
        }
    }
    showModalIfAddShortcutClickedFromAddView() {
        if (this.props.isModalOpenViaAddView === true) {
            this.onAddItem();
            this.props.setIsModalOpenViaAddView?.(false);
        }
    }
    initLegacyBridgeAPI() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $cQZXC.waitForHeritage)()?.then(()=>// eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $7T84i.loadBridgeStrict)({
                name: 'repository-shortcuts/navigation-next',
                wrmKeys: [
                    'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next'
                ]
            })) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.then((init)=>{
            const { methods: methods, items: items, projectKey: projectKey, projectId: projectId, isAdmin: isAdmin } = this.props;
            this.repositoryApi = init({
                shortcuts: $0e55df98ec766a24$var$findRepoShortcuts(items),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onAdd: (item)=>methods.addItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                onEdit: (item)=>methods.editItem($0e55df98ec766a24$var$toItem(item)),
                // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
                onDelete: (id)=>methods.deleteItem((0, $lkWkR.getIdFromLinkId)(id)),
                // @ts-expect-error - TS7006 - Parameter 'itemBulk' implicitly has an 'any' type.
                onBulkEdit: (itemBulk)=>// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
                    methods.editItems(itemBulk.map((item)=>$0e55df98ec766a24$var$toItem(item))),
                projectKey: projectKey,
                projectId: projectId,
                isAdmin: isAdmin
            });
        }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ?.catch((e)=>{
            this.setState({
                canAddRepositories: false
            });
            (0, $2YZCu.default).safeErrorWithoutCustomerData('navigation-next.shortcuts.repository', 'There was a problem loading or integrating with repository shortcuts', e);
        });
    }
    render() {
        const { children: children, baseUrl: baseUrl, pagesLink: pagesLink, projectKey: projectKey, items: items, showPagesSelector: showPagesSelector } = this.props;
        const { editOrDeleteItem: editOrDeleteItem, addItem: addItem, isPagesModalOpen: isPagesModalOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
            data: {
                shortcuts: items
            },
            openAddModal: this.onAddItem,
            openEditModal: this.onEditOrDeleteItem,
            openManagePagesLinkModal: pagesLink ? this.openManagePagesLinkModal : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            addItemButtonRef: this.addItemButtonRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "shortcuts-modal",
            packageName: "jiraNavigationShortcuts"
        }, pagesLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: (0, $4R6GH.fg)('nav_prevent_eager_manage_pages_modal') ? isPagesModalOpen === true : isPagesModalOpen != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "manage-pages-link-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$14ff0695ca26505c, {
            config: {
                isPagesLinkEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            isOpen: isPagesModalOpen,
            onClose: this.closeManagePagesLinkModal
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: addItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "add-item-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, pagesLink ? // add shortcut modal
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f525b7ef0c89cbed, {
            addItem: addItem,
            baseUrl: baseUrl,
            pages: {
                isEnabled: pagesLink.isEnabled,
                setPagesLink: this.setPagesLink(pagesLink)
            },
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository,
            showPagesSelector: showPagesSelector,
            addItemButtonRef: this.addItemButtonRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$f4f22b2fa38658d6, {
            addItem: addItem,
            baseUrl: baseUrl,
            projectKey: projectKey,
            onAddItemCompleted: this.onAddItemCompleted,
            onAddLink: this.onAddLink,
            onAddRepo: this.onAddRepository
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Ix35T.LazyWait), {
            until: editOrDeleteItem != null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "edit-shortcut-modal",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e55df98ec766a24$export$234ec8e31562766c, {
            baseUrl: baseUrl,
            projectKey: projectKey,
            editOrDeleteItem: editOrDeleteItem,
            items: items,
            editOrDeleteItemCompleted: this.onEditOrDeleteItemCompleted,
            editButtonRef: this.state.editShortcutButtonRef
        })))));
    }
}

});
parcelRegister("7T84i", function(module, exports) {

$parcel$export(module.exports, "loadBridgeStrict", () => $89a95eb8b151782d$export$eba600d28decc4ac);

var $c56lL = parcelRequire("c56lL");

var $ig88W = parcelRequire("ig88W");

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    (0, $c56lL.saveStats)(name, wrmKeys);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await (0, $fVOHM.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
        return (0, $ig88W.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError
        });
    }
};

});
parcelRegister("c56lL", function(module, exports) {

$parcel$export(module.exports, "saveStats", () => $6c875a5034ae8433$export$9ea3ff7978093559);
const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
    if (stats[resource] == null) // eslint-disable-next-line no-param-reassign
    stats[resource] = 1;
    else // eslint-disable-next-line no-param-reassign
    stats[resource] += 1;
};
const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
        requests: 0,
        amdModules: {},
        wrmKeys: {}
    });
const $6c875a5034ae8433$var$initStats = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__WRM_INTERNAL_STATS__ == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__ = {
        loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
    };
    else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WRM_INTERNAL_STATS__.loadBridge;
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
    try {
        const stats = $6c875a5034ae8433$var$initStats();
        // stop accumulating stats at TTI mark
        if ($6c875a5034ae8433$var$isPageInteractive()) return;
        stats.requests += 1;
        $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
        if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
        else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // not critical functionality
    }
};

});

parcelRegister("ig88W", function(module, exports) {

$parcel$export(module.exports, "loadBridgeRace", () => $64f1dbae1ea314ee$export$20c32b4579d78b92);

var $3GASE = parcelRequire("3GASE");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>Promise.race([
        (0, $9B86Q.loadBridgeWeak)({
            name: name
        }),
        new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $3GASE.loadBridgeBail)({
                name: name,
                shouldLogError: shouldLogError
            }))
    ]);

});
parcelRegister("3GASE", function(module, exports) {

$parcel$export(module.exports, "loadBridgeBail", () => $e512b6cc4a8702e5$export$a036f92c2465504e);

var $wRU6t = parcelRequire("wRU6t");

var $fqWWz = parcelRequire("fqWWz");
const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
        return window.require(name);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $wRU6t.safeStringify)(error) ?? ''}`, {
            isSpa: __SPA__,
            name: name,
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error(`Unable to load bridge "${name}"`, {
            cause: error
        });
    }
};

});
parcelRegister("wRU6t", function(module, exports) {

$parcel$export(module.exports, "safeStringify", () => $7e2bd894031d4476$export$56831a8b9cb27763);
/**
 * Stringifies a JS object for logging.
 * @param object
 * @returns {string}
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
    if (!object) return '';
    if (object instanceof Error) return object.stack || object.message;
    return JSON.stringify(object, Object.getOwnPropertyNames(object));
};

});

parcelRegister("fqWWz", function(module, exports) {

$parcel$export(module.exports, "safeErrorWithoutCustomerData", () => $71bf66166926d1dc$export$f19a2d31722e3428);
$parcel$export(module.exports, "MAX_RETRIES", () => $71bf66166926d1dc$export$1f86472c1374185a);
$parcel$export(module.exports, "DEFAULT_TIMEOUT", () => $71bf66166926d1dc$export$7bd623b29ec8e1eb);
$parcel$export(module.exports, "SHOULD_LOG_ERROR", () => $71bf66166926d1dc$export$37f20f0ff732fcd7);

var $2YZCu = parcelRequire("2YZCu");
const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, $2YZCu.default);
const $71bf66166926d1dc$export$1f86472c1374185a = 40;
const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;

});


parcelRegister("9B86Q", function(module, exports) {

$parcel$export(module.exports, "loadBridgeWeak", () => $61b2a5aa3a2a1160$export$3cefda82396756a1);

var $ifVVd = parcelRequire("ifVVd");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $61b2a5aa3a2a1160$var$pollingSingleton = null;
const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
    const getter = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, $ifVVd.createPollingCollection)((v)=>window.require(v), 100);
    $61b2a5aa3a2a1160$var$pollingSingleton = getter;
    return getter(name);
};

});
parcelRegister("ifVVd", function(module, exports) {

$parcel$export(module.exports, "createPollingCollection", () => $60e6b0d4bc46beac$export$f163446a982a8077);

var $gKZoD = parcelRequire("gKZoD");

var $aePFs = parcelRequire("aePFs");
const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
    (0, $gKZoD.di)(setTimeout);
    let isPolling = false;
    // Deferred instance is retained for polling
    const deferredMap = new Map();
    // Promise is derived from Deferred and is retained indefinitely
    const promiseMap = new Map();
    // Provided fn will throw until ready, once ready we will resolve and delete the Deferred
    const evaluateForKey = (key)=>{
        let result;
        try {
            result = fn(key);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            return;
        }
        const deferred = deferredMap.get(key);
        if (deferred instanceof (0, $aePFs.default)) {
            deferred.resolve(result);
            deferredMap.delete(key);
        }
    };
    const maybePoll = ()=>{
        if (!isPolling && deferredMap.size > 0) {
            isPolling = true;
            setTimeout(()=>{
                isPolling = false;
                [
                    ...deferredMap.keys()
                ].forEach(evaluateForKey);
                maybePoll();
            }, timeout);
        }
    };
    const getter = (key)=>{
        if (!promiseMap.has(key)) {
            const deferred = new (0, $aePFs.default)();
            const promise = deferred.then((v)=>v);
            deferredMap.set(key, deferred);
            promiseMap.set(key, promise);
            evaluateForKey(key);
            maybePoll();
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return promiseMap.get(key);
    };
    return getter;
};

});
parcelRegister("aePFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f3c6551bf5b1ff$export$2e2bcd8739ae039);
// @ts-expect-error - TS2417 - Class static side 'typeof Deferred' incorrectly extends base class static side '{ all<T>(values: Iterable<T | PromiseLike<T>>): Promise<Awaited<T>[]>; all<T extends readonly unknown[] | []>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>; }>; ... 5 more ...; readonly [Symbol.species]: PromiseConstructor; }'.
class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
    // go/jfe-eslint
    static resolve(v) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.resolve(v);
        return instance;
    }
    // go/jfe-eslint
    static reject(e) {
        const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
        instance.reject(e);
        return instance;
    }
    constructor(){
        // Promise.prototype.then() must be able to call new Deferred(fn)
        // @see https://stackoverflow.com/a/48159603
        // by using arguments flow will ensure we cannot instantiate with constructor parameters
        // eslint-disable-next-line prefer-rest-params
        const [fn] = Array.prototype.slice.call(arguments);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const callbacks = [];
        super(fn ?? callbacks.push.bind(callbacks));
        this.#resolve = callbacks[0];
        this.#reject = callbacks[1];
    }
    #resolve;
    #reject;
    resolve(v) {
        this.#resolve?.(v);
    }
    reject(e) {
        this.#reject?.(e);
    }
}

});




parcelRegister("fVOHM", function(module, exports) {

$parcel$export(module.exports, "loadWrmResources", () => $0c0552c7bb135144$export$6cda16b6eff75f59);

var $wRU6t = parcelRequire("wRU6t");

var $294PS = parcelRequire("294PS");

var $9B86Q = parcelRequire("9B86Q");

var $fqWWz = parcelRequire("fqWWz");
const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
    const isPrefetch = 'batchUrl' in options;
    let newWrmKeys = wrmKeys;
    try {
        const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
        const wrmRequireModule = await (0, $9B86Q.loadBridgeWeak)({
            name: name
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
        // @ts-expect-error - TS2322 - Type 'string | string[]' is not assignable to type 'string[]'.
        newWrmKeys = (0, $294PS.prependSuperBatchDepsOnce)(wrmKeys);
        if (isPrefetch) return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        return await new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve, reject)=>// wrmRequire returns a Deferred pretending to be a promise, this converts it to a normal Promise
            wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (shouldLogError) (0, $fqWWz.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
            isSpa: __SPA__,
            wrmKeys: JSON.stringify(newWrmKeys),
            error: (0, $wRU6t.safeStringify)(error)
        });
        throw new Error('Unable to load wrm resource', {
            cause: error
        });
    }
};

});
parcelRegister("294PS", function(module, exports) {

$parcel$export(module.exports, "prependSuperBatchDepsOnce", () => $a437264dd6b89021$export$93d9db5fbabad1b0);

var $1r4rO = parcelRequire("1r4rO");
let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
    const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
    const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname } = window.location;
    return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href.includes('secure/RapidBoard.jspa');
};
const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
    // These usually need injecting before most domain-specific deps but in rapidboards they load a
    // smaller set of the needed deps internally early and delay the rest
    if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
    $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
    return (0, $1r4rO.jiraSuperBatchDependencies).concat(wrmKeys);
};

});
parcelRegister("1r4rO", function(module, exports) {

$parcel$export(module.exports, "jiraSuperBatchDependencies", () => $e87d6a02e2466ae8$export$f14a6b583ce9e077);
const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner'
];

});




parcelRegister("cQZXC", function(module, exports) {

$parcel$export(module.exports, "waitForHeritage", () => $90def0f7a7aa11d6$export$c61060338d026f78);

var $7aBP4 = parcelRequire("7aBP4");

var $aePFs = parcelRequire("aePFs");
const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
    if (false) // WRM is not used on server
    // return null because we don't want to ?.then() chain into loadBridge functions
    return null;
    if (!__SPA__) // Heritage remainder is an SPA concept
    // return promise because we want to ?.then() chain into loadBridge functions
    return Promise.resolve();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.__WAIT_FOR_HERITAGE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__WAIT_FOR_HERITAGE__ = new (0, $aePFs.default)();
        (0, $7aBP4.bootstrapWrmClient)().then(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.__WAIT_FOR_HERITAGE__.resolve();
        });
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.__WAIT_FOR_HERITAGE__;
};

});
parcelRegister("7aBP4", function(module, exports) {

$parcel$export(module.exports, "bootstrapWrmClient", () => $f93199c7ae9c59d8$export$d001f71dd306cb0c);

var $7f4tk = parcelRequire("7f4tk");

var $wRU6t = parcelRequire("wRU6t");

var $jcw0u = parcelRequire("jcw0u");
const $f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT = '/rest/frontend/1/spawrmcontext';
const $f93199c7ae9c59d8$var$fetchSpaWrmContext = async ()=>{
    return (0, $7f4tk.default)($f93199c7ae9c59d8$var$SPA_WRM_CONTEXT_ENDPOINT);
};
const $f93199c7ae9c59d8$var$createResourceElement = ({ url: url, resourceType: resourceType, key: key, batchType: batchType })=>{
    let element;
    if (resourceType === 'JAVASCRIPT') {
        element = globalThis.document?.createElement('script');
        element.setAttribute('crossorigin', '');
        element.setAttribute('src', url);
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    } else {
        element = globalThis.document?.createElement('link');
        element.setAttribute('crossorigin', '');
        element.setAttribute('href', url);
        element.setAttribute('rel', 'stylesheet');
        element.setAttribute('media', 'all');
        element.setAttribute('data-client-bootstrapped', '');
        element.setAttribute('data-wrm-key', key);
        element.setAttribute('data-wrm-batch-type', batchType.toLowerCase());
    }
    return element;
};
let $f93199c7ae9c59d8$var$hasWrmInitialised;
const $f93199c7ae9c59d8$var$runBootstrap = ()=>{
    const spaWrmContext = $f93199c7ae9c59d8$var$fetchSpaWrmContext();
    return new Promise((resolve, reject)=>{
        spaWrmContext.then(({ data: data, errors: errors, resources: resources })=>{
            // eslint-disable-next-line no-multi-assign
            const WRM = globalThis.WRM = globalThis.WRM || {};
            WRM._unparsedData = data;
            WRM._unparsedErrors = errors;
            if (WRM._dataArrived) WRM._dataArrived();
            resources.map($f93199c7ae9c59d8$var$createResourceElement).forEach((element)=>globalThis.document?.head.appendChild(element));
            resolve();
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: new Error((0, $wRU6t.safeStringify)(error)),
                meta: {
                    id: 'bootstrap-wrm-client',
                    packageName: 'common-bridge',
                    teamName: 'jfp-magma'
                }
            });
            reject(new Error('Failed to fetch the spa wrm context'));
        });
    });
};
const $f93199c7ae9c59d8$export$d001f71dd306cb0c = ()=>{
    if (false) return Promise.resolve();
    if ($f93199c7ae9c59d8$var$hasWrmInitialised) return $f93199c7ae9c59d8$var$hasWrmInitialised;
    // todo maybe a more robust check to validate whether WRM initialisation already underway?
    if (typeof globalThis.WRM !== 'undefined') $f93199c7ae9c59d8$var$hasWrmInitialised = Promise.resolve();
    else $f93199c7ae9c59d8$var$hasWrmInitialised = $f93199c7ae9c59d8$var$runBootstrap();
    return $f93199c7ae9c59d8$var$hasWrmInitialised;
};

});


const $27f32c1fbb856eaf$export$399c7e6858236b4 = 'source.code.link';
const $27f32c1fbb856eaf$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
const $27f32c1fbb856eaf$export$3746846b4d8615c3 = 'INVALID_URL';

parcelRegister("lkWkR", function(module, exports) {

$parcel$export(module.exports, "getIdFromLinkId", () => $74dd3faace70a053$export$3cec694c50bc695d);
$parcel$export(module.exports, "getItemFromLink", () => $74dd3faace70a053$export$60d4c4ef6da272ad);

var $5uXOq = parcelRequire("5uXOq");

var $ixUGT = parcelRequire("ixUGT");

var $hYfgW = parcelRequire("hYfgW");

var $32ra4 = parcelRequire("32ra4");

var $a8Wzb = parcelRequire("a8Wzb");

var $h6M2t = parcelRequire("h6M2t");
const $74dd3faace70a053$var$getLinkParts = (linkId)=>linkId.split(':')[1].split('.');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $74dd3faace70a053$var$SizedBitBucketIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h6M2t.BitbucketIcon), {
        ...props,
        size: "small"
    });
const $74dd3faace70a053$export$16b26cd5e98d9100 = (iconName)=>{
    switch(iconName){
        case 'bitbucket':
            return $74dd3faace70a053$var$SizedBitBucketIcon;
        case 'github':
        case 'repos':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($32ra4));
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8Wzb));
    }
};
const $74dd3faace70a053$export$3cec694c50bc695d = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($74dd3faace70a053$var$getLinkParts(linkId));
const $74dd3faace70a053$export$92a97f8239a551c5 = (linkId)=>(0, (/*@__PURE__*/$parcel$interopDefault($ixUGT)))($74dd3faace70a053$var$getLinkParts(linkId)).join('.');
const $74dd3faace70a053$export$60d4c4ef6da272ad = (link)=>{
    const { id: linkId, icon: icon } = link;
    const id = $74dd3faace70a053$export$3cec694c50bc695d(linkId);
    const shortcutType = $74dd3faace70a053$export$92a97f8239a551c5(linkId);
    const target = link.target || '_blank';
    const Icon = $74dd3faace70a053$export$16b26cd5e98d9100(icon);
    return {
        type: 'Item',
        id: id,
        icon: icon,
        legacyId: linkId,
        target: target,
        shortcutType: shortcutType,
        text: link.name,
        before: Icon,
        href: link.url,
        canEdit: link.canEdit,
        showSync: link.showSync,
        itemType: 'shortcut'
    };
};

});

parcelRegister("jA4Dc", function(module, exports) {

let $e414f8ca3f5a3ebd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e414f8ca3f5a3ebd$var$load("9aYrW").then(()=>parcelRequire('1KSRk'));

});

parcelRegister("aiSFl", function(module, exports) {

let $7805fd52d29baf3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7805fd52d29baf3f$var$load("lw2WF").then(()=>parcelRequire('283Hr'));

});

parcelRegister("2EZdp", function(module, exports) {

let $1efecd478bb26902$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1efecd478bb26902$var$load("hVh0q").then(()=>parcelRequire('kSuJt'));

});

parcelRegister("aFtLa", function(module, exports) {

let $7c44d1638e625f20$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7c44d1638e625f20$var$load("bpNdl").then(()=>parcelRequire('5h9Nf'));

});

parcelRegister("67YVY", function(module, exports) {

let $4762a9c73f87d768$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4762a9c73f87d768$var$load("lVTe9").then(()=>parcelRequire('bw5U3'));

});


parcelRegister("2RBG9", function(module, exports) {

$parcel$export(module.exports, "useSimplifyNavExperimentActions", () => $4f93da38aa0d50ec$export$dec0900020ea5bc1);
$parcel$export(module.exports, "useIsModalOpenViaAddView", () => $4f93da38aa0d50ec$export$7159774426103694);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $hEThu = parcelRequire("hEThu");
const $4f93da38aa0d50ec$var$initialState = {
    isModalOpenViaAddView: false
};
const $4f93da38aa0d50ec$var$Store = (0, $iXqE5.createStore)({
    initialState: $4f93da38aa0d50ec$var$initialState,
    actions: $hEThu.actions,
    name: 'add-shortcut-modal'
});
const $4f93da38aa0d50ec$export$dec0900020ea5bc1 = (0, $3sQ5x.createActionsHook)($4f93da38aa0d50ec$var$Store);
const $4f93da38aa0d50ec$var$getIsModalOpenViaAddView = (state)=>state.isModalOpenViaAddView;
const $4f93da38aa0d50ec$export$7159774426103694 = (0, $3sQ5x.createHook)($4f93da38aa0d50ec$var$Store, {
    selector: $4f93da38aa0d50ec$var$getIsModalOpenViaAddView
});

});
parcelRegister("hEThu", function(module, exports) {

$parcel$export(module.exports, "actions", () => $2feb5bd35f69b764$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $2feb5bd35f69b764$export$e324594224ef24da = {
    setIsModalOpenViaAddView: (isOpen)=>({ setState: setState })=>{
            setState({
                isModalOpenViaAddView: isOpen
            });
        }
};

});


parcelRegister("7E0T0", function(module, exports) {

$parcel$export(module.exports, "useIsSimplifyNavExperimentEnabled", () => $22c277cef5718f50$export$9e64ffaf2b8ea06);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $dAfqg = parcelRequire("dAfqg");
const $22c277cef5718f50$export$9e64ffaf2b8ea06 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_simplify_navigation_m2');
    const isJsw = projectContext?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isProjectAdmin = projectContext?.isProjectAdmin;
    const isTmp = !!projectContext?.simplified;
    const isEligible = isJsw && isTmp && isProjectAdmin;
    if (isEligible) return expConfig.get('isEnabled', false);
    return false;
};

});
parcelRegister("dAfqg", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $0baaa0dcf730951a$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $0baaa0dcf730951a$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $0baaa0dcf730951a$export$a85f6b5857d2176);

var $5uXOq = parcelRequire("5uXOq");

var $324W5 = parcelRequire("324W5");

var $dxCvy = parcelRequire("dxCvy");
const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $324W5.useResourceWithCustomRouterContext)((0, $dxCvy.projectContextResourceWithCache), customContext);
    const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
    return children(projectContext);
};

});


parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $b4PzF = parcelRequire("b4PzF");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $b4PzF.isFedRamp)();

});

parcelRegister("cNJA1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aa04212b12cb992$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aa04212b12cb992$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    addItem: {
        "id": "navigation-apps-shortcuts-sidebar.add-item",
        "defaultMessage": "Add shortcut"
    }
});

});

parcelRegister("dsZRM", function(module, exports) {

$parcel$export(module.exports, "PagesMenuItem", () => $987860c5961bf9dc$export$134a99f2c72dc6b7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $1Seuh = parcelRequire("1Seuh");

var $45xDm = parcelRequire("45xDm");

var $eOat1 = parcelRequire("eOat1");

var $Pxnvj = parcelRequire("Pxnvj");

var $0yZbT = parcelRequire("0yZbT");
var $2Eqc8 = parcelRequire("2Eqc8");
var $6eFvr = parcelRequire("6eFvr");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lLoy3 = parcelRequire("lLoy3");

var $2MtwW = parcelRequire("2MtwW");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $1z3xg = parcelRequire("1z3xg");

var $b0i2u = parcelRequire("b0i2u");

var $doZTA = parcelRequire("doZTA");


var $4Y8PR = parcelRequire("4Y8PR");

var $gXsf7 = parcelRequire("gXsf7");

var $7dRTN = parcelRequire("7dRTN");
const $987860c5961bf9dc$var$EditIcon = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClick = (ev)=>{
        ev.preventDefault();
        if (onClick) onClick(ev);
    };
    // this function handle keydown event when user navigate to the edit button and press enter to open the dialog.
    const handleKeyDown = (event)=>{
        if (event.key === 'Enter') handleClick(event);
    };
    const buttonProps = {
        appearance: 'subtle-link',
        spacing: 'none',
        onClick: handleClick,
        onKeyDown: handleKeyDown
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        "data-edit-icon": true,
        ...buttonProps,
        "aria-describedby": "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45xDm))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? (0, $7dRTN.messages).editProjectPages : (0, $7dRTN.messages).edit)
    }));
};
const $987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge = ({ onEditClick: onEditClick, iconAfter: iconAfter, pagesMenuItemTitle: pagesMenuItemTitle, crossJoinNudge: crossJoinNudge = {
    isCrossJoinTeamEligible: false,
    canShowJoinTeamlozenge: false,
    canShowJoinTeamPulse: false
}, projectId: // Extracting here so that it does not end up in the "rest" which would eventually get passed to a normal DOM element and cause React to be unhappy
projectId, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isCrossJoinTeamEligible: isCrossJoinTeamEligible, canShowJoinTeamlozenge: canShowJoinTeamlozenge } = crossJoinNudge;
    if ((0, $4R6GH.fg)('blu-4174-enghealth-13134-page-item-a11y-fix')) {
        const icon = !iconAfter && onEditClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($45xDm))),
            onClick: (e)=>onEditClick(e),
            label: formatMessage((0, $4R6GH.fg)('blu-6205_misc_nav3_a11y_fixes') ? (0, $7dRTN.messages).editProjectPages : (0, $7dRTN.messages).edit),
            appearance: "subtle"
        }) : iconAfter; // In order to ensure that the spacing is correct in the Nav3 sidebar we need to wrap the icon in an element
        // with some padding. This ensures that everything lines up correctly when the menu item is selected.
        const { iconBefore: iconBefore, ...allTheRest } = rest;
        const augmentedIconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            paddingInlineStart: "space.200"
        }, iconBefore);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Eqc8.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
            iconBefore: augmentedIconBefore,
            ...allTheRest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
            id: "navigation-apps-sidebar-common.ui.shortcuts.business-pages-link"
        }, formatMessage(pagesMenuItemTitle || (0, $7dRTN.messages).projectPagesItem)), isCrossJoinTeamEligible && canShowJoinTeamlozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            "test-id": "shortcuts.business-pages-lozenge",
            className: (0, $bwpsq.default)([
                "_19bvu2gc"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
            appearance: "new"
        }, formatMessage((0, $7dRTN.messages).projectPagesLozenge))))), icon);
    }
    const cssFn = isCrossJoinTeamEligible ? (0, $1z3xg.cssFn) : (0, $b0i2u.cssFn);
    const extraProps = !iconAfter && onEditClick ? {
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$EditIcon, {
            onClick: onEditClick
        }),
        cssFn: cssFn
    } : {
        iconAfter: iconAfter
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ...extraProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        id: "shortcuts.business-pages-lozenge"
    }, formatMessage(pagesMenuItemTitle || (0, $7dRTN.messages).projectPagesItem)), isCrossJoinTeamEligible && canShowJoinTeamlozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "test-id": "shortcuts.business-pages-lozenge",
        className: (0, $bwpsq.default)([
            "_19bvu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $7dRTN.messages).projectPagesLozenge))));
};
const $987860c5961bf9dc$var$lozengeStyles = null;
const $987860c5961bf9dc$var$WrappedPagesMenuItem = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: (0, $bd24ef8cd2fd388b$export$965e349a75efe8dc)
    }, props.crossJoinNudge && props.crossJoinNudge.isCrossJoinTeamEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Y8PR.ProjectPageMenuItemWithJoinTeamPulse), {
        showPulse: props.crossJoinNudge.canShowJoinTeamPulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithMayBeLozenge, props)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: (0, $bd24ef8cd2fd388b$export$965e349a75efe8dc)
    }));
const $987860c5961bf9dc$var$WrappedPagesMenuItemWithNudge = (props)=>{
    // for a11y purposes, we drill the focussed state down so the nudge can be shown via keyboard controls
    const [isFocussed, setIsFocussed] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "pages-menu-item-end-user-activate-nudge",
        packageName: "jira-navigation-apps-sidebar-common",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXsf7.EndUserActivateNudgeProvider), {
        isFocussed: isFocussed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, {
        ...props,
        onFocus: (e)=>{
            setIsFocussed(true);
            props.onFocus?.(e);
        },
        onBlur: (e)=>{
            setIsFocussed(false);
            props.onBlur?.(e);
        }
    })));
};
const $987860c5961bf9dc$export$134a99f2c72dc6b7 = (props)=>{
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const crossJoinNudge = (0, $lLoy3.useCrossJoinTeamEligible)(props.projectId);
    const extraProps = {
        ...props,
        crossJoinNudge: crossJoinNudge
    }; // don't show the nudge if the user is already on project-pages
    return route.name !== 'project-pages' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItemWithNudge, extraProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987860c5961bf9dc$var$WrappedPagesMenuItem, extraProps);
};

});
parcelRegister("lLoy3", function(module, exports) {

$parcel$export(module.exports, "useCrossJoinTeamEligible", () => $5b34d0e1b0b740e7$export$c04acf198fab33d6);

var $5uXOq = parcelRequire("5uXOq");

var $iVil7 = parcelRequire("iVil7");

var $e1J1K = parcelRequire("e1J1K");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $koeKL = parcelRequire("koeKL");

var $9XCQv = parcelRequire("9XCQv");
const $5b34d0e1b0b740e7$export$c04acf198fab33d6 = (projectId)=>{
    const [isCrossJoinTeamEligible, setIsCrossJoinTeamEligible] = (0, $5uXOq.useState)(false);
    const [canShowJoinTeamlozenge, setCanShowJoinTeamLozenge] = (0, $5uXOq.useState)(false);
    const [canShowJoinTeamPulse, setCanShowJoinTeamPulse] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [checkIfSpotlightOrLozengeShown] = (0, $9XCQv.useIsEligibleForSpotlight)();
    const [markAsNotEligible] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $4R6GH.fg)('cjn_project_pages_gate') || !projectId) return;
        const checkEligibility = async ()=>{
            let ineligibilityReason = '';
            let cohort = 'not-enrolled';
            try {
                const [canShowPulse, canShowlozenge, isIneligibleForAccess] = await checkIfSpotlightOrLozengeShown();
                if (isIneligibleForAccess) ineligibilityReason = 'NOT_ELIGIBLE_FROM_LOCAL_STORE';
                else if (canShowPulse === false) {
                    cohort = 'variation'; // if spotlight is shown before, its safe to consider the user is in variation
                    if (canShowlozenge) {
                        ineligibilityReason = 'SPOTLIGHT_ELIGIBLE';
                        setCanShowJoinTeamLozenge(canShowlozenge);
                    } else ineligibilityReason = 'ALREADY_SHOWN_SPOTLIGHT';
                } else {
                    const alreadyHasAccess = await (0, $iVil7.hasProductAccess)('confluence', cloudId);
                    if (alreadyHasAccess) ineligibilityReason = 'ALREADY_HAVE_ACCESS';
                    else {
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'crossJoinNudgeProjectPages capabilityCheck');
                        const canRequestAccess = await (0, $e1J1K.fetchIsRequestAccessCapable)('confluence', cloudId);
                        if (canRequestAccess) {
                            cohort = (0, $6s1PB.expVal)('cjn_project_pages_on_userid', 'cohort', 'not-enrolled');
                            if (cohort === 'variation') {
                                if (canShowPulse || canShowlozenge) {
                                    ineligibilityReason = 'SPOTLIGHT_ELIGIBLE';
                                    setCanShowJoinTeamPulse(canShowPulse);
                                    setCanShowJoinTeamLozenge(canShowlozenge);
                                }
                            } else ineligibilityReason = 'NOT_ENROLLED_IN_VARIATION';
                        } else ineligibilityReason = 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS';
                    }
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error instanceof Error && error.message?.includes('status code: 400')) ineligibilityReason = 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS';
                else ineligibilityReason = 'ERROR_EVALUATING_ELIGIBILITY';
                (0, $jcw0u.default)({
                    meta: {
                        id: 'checkCJNEligibility',
                        packageName: 'jiraNavigationAppsShortcutsSidebar'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            const eventDetail = {
                flagKey: 'cjn_project_pages_on_userid',
                cohort: cohort,
                ineligibilityReason: ineligibilityReason
            };
            if ([
                'ALREADY_HAVE_ACCESS',
                'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
            ].includes(ineligibilityReason)) markAsNotEligible();
            if (cohort !== 'not-enrolled') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', eventDetail);
            else if (ineligibilityReason !== 'NOT_ELIGIBLE_FROM_LOCAL_STORE') // we don't need to fire multiple 'feature excluded' event for same user if we find ineligibility in local storage,
            // this will reduce the event volume greatly
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'feature excluded', eventDetail);
            const result = ineligibilityReason === 'SPOTLIGHT_ELIGIBLE';
            setIsCrossJoinTeamEligible(result);
        };
        checkEligibility();
    }, [
        projectId,
        cloudId,
        createAnalyticsEvent,
        checkIfSpotlightOrLozengeShown,
        markAsNotEligible
    ]);
    return {
        isCrossJoinTeamEligible: isCrossJoinTeamEligible,
        canShowJoinTeamlozenge: canShowJoinTeamlozenge,
        canShowJoinTeamPulse: canShowJoinTeamPulse
    };
};

});
parcelRegister("iVil7", function(module, exports) {

$parcel$export(module.exports, "hasProductAccess", () => $543bba9bf251c6d1$export$61073fd69a83a1e3);
$parcel$export(module.exports, "fetchCachedAccessCheck", () => $543bba9bf251c6d1$export$cd2f9bc003d00b45);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $543bba9bf251c6d1$var$URL = '/gateway/api/permissions/permitted';
const $543bba9bf251c6d1$export$61073fd69a83a1e3 = async (product, cloudId)=>{
    const data = {
        permissionId: 'write',
        resourceId: `ari:cloud:${product}::site/${cloudId}`
    };
    const response = await (0, $7f4tk.default)($543bba9bf251c6d1$var$URL, {
        method: 'POST',
        body: JSON.stringify(data)
    });
    return response.permitted;
};
// Purposefully set this to 7 days as it's unlikely user can be kicked out of Confluence when they already have access
const $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS = 604800000;
const $543bba9bf251c6d1$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-perms-api-cache');
const $543bba9bf251c6d1$export$cd2f9bc003d00b45 = async (createAnalyticsEvent, product, cloudId, touchpoint)=>{
    const cacheKey = `cross.join.${product}.cache.key`;
    let permissionResponse = $543bba9bf251c6d1$var$crossJoinApiCache.get(cacheKey);
    if (permissionResponse === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheMiss', {
            touchpoint: touchpoint,
            product: product
        });
        try {
            permissionResponse = await $543bba9bf251c6d1$export$61073fd69a83a1e3(product, cloudId);
        } catch (err) {
            // No PII from identity exception so fire operational analytics consistently
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck fetchError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        try {
            $543bba9bf251c6d1$var$crossJoinApiCache.set(cacheKey, permissionResponse, Date.now() + $543bba9bf251c6d1$var$PERMISSION_CACHE_KEY_EXPIRY_MS);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck setError', {
                touchpoint: touchpoint,
                product: product,
                err: err,
                skipSentry: true
            });
            return permissionResponse;
        }
        return permissionResponse;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'accessCheck cacheHit', {
        touchpoint: touchpoint,
        product: product
    });
    return permissionResponse;
};

});

parcelRegister("e1J1K", function(module, exports) {

$parcel$export(module.exports, "fetchIsRequestAccessCapable", () => $b1d9429bb117b963$export$c75518284e8dee24);
$parcel$export(module.exports, "fetchCachedIsConfluenceRACapable", () => $b1d9429bb117b963$export$f5767c68446c14cb);
$parcel$export(module.exports, "resetRACapableCache", () => $b1d9429bb117b963$export$5191fc85eb825b4b);

var $bSSG7 = parcelRequire("bSSG7");

var $7f4tk = parcelRequire("7f4tk");

var $8zOmE = parcelRequire("8zOmE");
const $b1d9429bb117b963$export$c75518284e8dee24 = async (product, cloudId)=>{
    const resource = `ari:cloud:${product}::site/${cloudId}`;
    const params = new URLSearchParams({
        resource: resource
    });
    const URL = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
    const response = await (0, $7f4tk.default)(URL, {
        credentials: 'include'
    });
    const requestCapabilities = response.results[resource];
    return requestCapabilities === 'DIRECT_ACCESS' || requestCapabilities === 'REQUEST_ACCESS';
};
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY = 'cross.join.confluence-capabilities.cache.key';
// This is set to 1 day only as capabilties has many more states e.g PENDING_REQUEST_EXISTS, APPROVED_REQUEST_EXISTS etc
// We expect capabilities to change more often than product access
const $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS = 86400000;
const $b1d9429bb117b963$var$crossJoinApiCache = (0, $bSSG7.createLocalExpirableStorageProvider)('cross-join-nudge-conf-capabilities-api-cache');
const $b1d9429bb117b963$export$f5767c68446c14cb = async (createAnalyticsEvent, cloudId, touchpoint)=>{
    let isRACapable = $b1d9429bb117b963$var$crossJoinApiCache.get($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
    if (isRACapable === undefined) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheMiss', {
            touchpoint: touchpoint
        });
        try {
            isRACapable = await $b1d9429bb117b963$export$c75518284e8dee24('confluence', cloudId);
        } catch (err) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck fetchError', {
                touchpoint: touchpoint,
                err: err,
                sendToPrivacyUnsafeSplunk: true,
                skipSentry: true
            });
            return null;
        }
        $b1d9429bb117b963$export$a901680cf5ecfb6c(createAnalyticsEvent, isRACapable, touchpoint);
        return isRACapable;
    }
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck cacheHit', {
        touchpoint: touchpoint
    });
    return isRACapable;
};
const $b1d9429bb117b963$export$a901680cf5ecfb6c = (createAnalyticsEvent, value, touchpoint)=>{
    try {
        $b1d9429bb117b963$var$crossJoinApiCache.set($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY, value, Date.now() + $b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY_EXPIRY_MS);
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'capabilitiesCheck setError', {
            touchpoint: touchpoint,
            err: err,
            skipSentry: true
        });
    }
};
const $b1d9429bb117b963$export$5191fc85eb825b4b = ()=>{
    $b1d9429bb117b963$var$crossJoinApiCache.remove($b1d9429bb117b963$var$CONFLUENCE_RA_CAPABILITIES_CACHE_KEY);
};

});

parcelRegister("9XCQv", function(module, exports) {

$parcel$export(module.exports, "PULSE_MESSAGE_ID", () => $05b5344c171266a0$export$1a5cb28e0beda89f);
$parcel$export(module.exports, "LOZENGE_MESSAGE_ID", () => $05b5344c171266a0$export$a5a1e9d7e5d0c391);
$parcel$export(module.exports, "INELIGIBLE_FOR_CONFLUENCE_ACCESS_ID", () => $05b5344c171266a0$export$810bc8a6202e075e);
$parcel$export(module.exports, "useIsEligibleForSpotlight", () => $05b5344c171266a0$export$eae410af47358d91);
$parcel$export(module.exports, "useUserSpotlightProperty", () => $05b5344c171266a0$export$352e2dad9741678e);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");
const $05b5344c171266a0$export$1a5cb28e0beda89f = 'menu-item-pulse';
const $05b5344c171266a0$export$a5a1e9d7e5d0c391 = 'menu-item-lozenge';
const $05b5344c171266a0$export$810bc8a6202e075e = 'ineligible-for-confluence-access';
const $05b5344c171266a0$var$sessionStorage = (0, $eNf8a.createSessionStorageProvider)('cjn_project_pages_on_userid');
const $05b5344c171266a0$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('cjn_project_pages_on_userid');
const $05b5344c171266a0$export$eae410af47358d91 = ()=>{
    const checkIfSpotlightOrLozengeShown = (0, $5uXOq.useCallback)(()=>{
        const canShowPulse = $05b5344c171266a0$var$canShowProperty($05b5344c171266a0$export$1a5cb28e0beda89f);
        const canShowLozenge = $05b5344c171266a0$var$canShowProperty($05b5344c171266a0$export$a5a1e9d7e5d0c391);
        const isIneligibleForAccess = $05b5344c171266a0$var$hasPropertyInLocalStore($05b5344c171266a0$export$810bc8a6202e075e);
        return [
            canShowPulse,
            canShowLozenge,
            isIneligibleForAccess
        ];
    }, []);
    return [
        checkIfSpotlightOrLozengeShown
    ];
};
const $05b5344c171266a0$var$canShowProperty = (propertyKey)=>!$05b5344c171266a0$var$sessionStorage.get(propertyKey) && !$05b5344c171266a0$var$localStorage.get(propertyKey);
const $05b5344c171266a0$var$hasPropertyInLocalStore = (propertyKey)=>$05b5344c171266a0$var$sessionStorage.get(propertyKey) || $05b5344c171266a0$var$localStorage.get(propertyKey);
const $05b5344c171266a0$export$352e2dad9741678e = (propertyKey)=>{
    const markAsPropertySeen = (0, $5uXOq.useCallback)(()=>{
        $05b5344c171266a0$var$localStorage.set(propertyKey, true);
        $05b5344c171266a0$var$sessionStorage.set(propertyKey, true);
    }, [
        propertyKey
    ]);
    return [
        markAsPropertySeen
    ];
};

});


parcelRegister("2MtwW", function(module, exports) {

$parcel$export(module.exports, "EngagementSpotlight", () => $0e9acf1f50def63d$export$f14689466e4eca7a);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $6OJ73 = parcelRequire("6OJ73");

var $axUP7 = parcelRequire("axUP7");
const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, $axUP7.withNestingOptimisation)(({ engagementId: engagementId })=>{
    const isFullyExpanded = (0, $6OJ73.useIsFullyExpanded)();
    return isFullyExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: engagementId
    });
});

});
parcelRegister("6OJ73", function(module, exports) {

$parcel$export(module.exports, "useIsFullyExpanded", () => $c20291d4f7970c77$export$7212b6b01271f5d1);

var $5uXOq = parcelRequire("5uXOq");

var $gPQRI = parcelRequire("gPQRI");
const $c20291d4f7970c77$var$TIMEOUT = 500;
const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
    const [ready, setReady] = (0, $5uXOq.useState)(false);
    const { isCollapsed: isCollapsed } = (0, $gPQRI.useLeftSidebarState)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setReady(!isCollapsed);
        }, $c20291d4f7970c77$var$TIMEOUT);
        return ()=>clearTimeout(timeoutId);
    }, [
        isCollapsed
    ]);
    return ready && !isCollapsed;
};

});
parcelRegister("gPQRI", function(module, exports) {

$parcel$export(module.exports, "useLeftSidebarState", () => $b19712b3cdd78134$export$610d81e163a897b3);
$parcel$export(module.exports, "useLeftSidebarController", () => $b19712b3cdd78134$export$900f29014a48fb23);

var $5uXOq = parcelRequire("5uXOq");

var $iqLcb = parcelRequire("iqLcb");

var $3sQ5x = parcelRequire("3sQ5x");

var $5e5zm = parcelRequire("5e5zm");
const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>({
            ...state.content.leftSidebar,
            shouldRender: !state.isChromeless
        })
});
const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
    const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
    return leftSidebar;
};
const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
    const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $iqLcb.usePageLayoutResize)();
    return (0, $5uXOq.useMemo)(()=>({
            collapseLeftSidebar: collapseLeftSidebar,
            expandLeftSidebar: expandLeftSidebar
        }), [
        collapseLeftSidebar,
        expandLeftSidebar
    ]);
};

});
parcelRegister("iqLcb", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $3d7d84f3bc65155e$export$6d1402fb58384e4f);
$parcel$export(module.exports, "Banner", () => $3d7d84f3bc65155e$export$3b4e64e77073e307);
$parcel$export(module.exports, "TopNavigation", () => $3d7d84f3bc65155e$export$8a421bddecb2bf5b);
$parcel$export(module.exports, "LeftPanel", () => $3d7d84f3bc65155e$export$110709f040143804);
$parcel$export(module.exports, "LeftSidebarWithoutResize", () => $3d7d84f3bc65155e$export$43ae342508cf8cc9);
$parcel$export(module.exports, "LeftSidebar", () => $3d7d84f3bc65155e$export$3cabf771c4f2de);
$parcel$export(module.exports, "Main", () => $3d7d84f3bc65155e$export$861edd1ccea2f746);
$parcel$export(module.exports, "Content", () => $3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "RightSidebar", () => $3d7d84f3bc65155e$export$84d58c19c21f637f);
$parcel$export(module.exports, "RightPanel", () => $3d7d84f3bc65155e$export$364a989a35814102);
$parcel$export(module.exports, "useCustomSkipLink", () => $3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $3d7d84f3bc65155e$export$94561f6055639ef7);
$parcel$export(module.exports, "usePageLayoutResize", () => $3d7d84f3bc65155e$export$10c7104037a7af62);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", () => $3d7d84f3bc65155e$export$991ef8098f87814a);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$e95b388ca8c92019);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", () => $3d7d84f3bc65155e$export$2ab8b83eed76656c);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", () => $3d7d84f3bc65155e$export$ac017575d43f5da);
$parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", () => $3d7d84f3bc65155e$export$d697087c06fd5e25);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gWVyJ = parcelRequire("gWVyJ");
var $l2AH9 = parcelRequire("l2AH9");
var $iCvLW = parcelRequire("iCvLW");
var $56fJj = parcelRequire("56fJj");
var $by9S8 = parcelRequire("by9S8");
var $7Stls = parcelRequire("7Stls");
var $33D3Q = parcelRequire("33D3Q");
var $jreT6 = parcelRequire("jreT6");
var $3IHID = parcelRequire("3IHID");
var $7EYXE = parcelRequire("7EYXE");
var $3fzVB = parcelRequire("3fzVB");
var $02o6B = parcelRequire("02o6B");

var $3HwlS = parcelRequire("3HwlS");

var $geqKu = parcelRequire("geqKu");
var $7YDkZ = parcelRequire("7YDkZ");
var $gXjR2 = parcelRequire("gXjR2");
var $ehQHm = parcelRequire("ehQHm");
var $dkD6V = parcelRequire("dkD6V");
var $jN4ko = parcelRequire("jN4ko");
var $fZJPK = parcelRequire("fZJPK");
function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dkD6V.Root), {
        UNSAFE_dangerouslyHoistSlotSizes: true,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33D3Q.default), props);
}
function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YDkZ.Banner), {
        UNSAFE_height: props.height,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWVyJ.default), props);
}
function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fZJPK.TopBar), {
        UNSAFE_height: props.height,
        testId: props.testId,
        UNSAFE_theme: props.theme
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EYXE.default), props);
}
function $3d7d84f3bc65155e$export$110709f040143804(props) {
    // LeftPanel is not supported in new page layout
    return (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iCvLW.default), props);
}
function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $by9S8.default), props);
}
function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jN4ko.SideNav), {
        defaultCollapsed: props.collapsedState === 'collapsed',
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $56fJj.default), props);
}
function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gXjR2.Main), {
        isFixed: props.isFixed,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Stls.default), props);
}
function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
    return (0, $3HwlS.getWillShowNav4)() ? // There isn't a concept of a `Content` wrapper component in the new page layout
    props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l2AH9.default), props);
}
function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geqKu.Aside), {
        isFixed: props.isFixed,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3IHID.default), props);
}
function $3d7d84f3bc65155e$export$364a989a35814102(props) {
    return (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehQHm.Panel), {
        xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
        defaultWidth: props.width,
        testId: props.testId
    }, props.children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jreT6.default), props);
}
const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3fzVB.useCustomSkipLink)(id, title, index);
const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, $3HwlS.getWillShowNav4)() ? {} : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.useLeftSidebarFlyoutLock)();
// A mock value is needed to match the signature of the hook
const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    collapseLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    leftSidebarState: {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    },
    setLeftSidebarState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleLeftSidebar: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, $3HwlS.getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $02o6B.usePageLayoutResize)();
const $3d7d84f3bc65155e$var$rightPanelStyles = {
    root: "_bfhk1bhr"
};
const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, $62b79b702763d93f$export$ed7cc0d417ee89e);
const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, $62b79b702763d93f$export$f963aecf2d4465bd);
const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, $62b79b702763d93f$export$f897e1ed9f8ed251);
const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, $62b79b702763d93f$export$750459958906793);
const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, $62b79b702763d93f$export$b44ab66843c05a69);
const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, $62b79b702763d93f$export$aeff86a16f13529);

});
// dimension vars
const $62b79b702763d93f$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $62b79b702763d93f$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $62b79b702763d93f$export$c103b605cd368aed = 'rightSidebarWidth';
const $62b79b702763d93f$export$fa34f417972d6341 = 'rightPanelWidth';
const $62b79b702763d93f$export$3a6a779d9181047c = 'topNavigationHeight';
const $62b79b702763d93f$export$bcd94a6a792e7f96 = 'bannerHeight';
const $62b79b702763d93f$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $62b79b702763d93f$export$344062f7cfc9528e = 'left-panel';
const $62b79b702763d93f$export$c7139cc2d6110b5f = 'right-panel';
const $62b79b702763d93f$export$238d30785c4bca84 = 'banner';
const $62b79b702763d93f$export$bec6dca2e63de4ae = 'top-navigation';
const $62b79b702763d93f$export$d1213e82613ff4df = 'content';
const $62b79b702763d93f$export$be83e7118304b28e = 56;
const $62b79b702763d93f$export$4a98ee0bd1ae362 = 56;
const $62b79b702763d93f$export$539e68c09584883a = 240;
const $62b79b702763d93f$export$b92df8810d2fcd01 = 280;
const $62b79b702763d93f$export$c3e41153b9288bcf = 368;
const $62b79b702763d93f$export$c4d6152f86ea28f6 = 368;
const $62b79b702763d93f$export$46acf8758e9e2636 = 20;
const $62b79b702763d93f$export$70740f5ad8360a78 = 16;
const $62b79b702763d93f$export$991d5285ad765a3d = 240;
const $62b79b702763d93f$export$6949d4f32b161684 = 200;
const $62b79b702763d93f$export$d6e7e8af042815bb = 350;
const $62b79b702763d93f$export$3749e1104328fde4 = 300;
const $62b79b702763d93f$export$1074d925b0b82be5 = 200;
const $62b79b702763d93f$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $62b79b702763d93f$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $62b79b702763d93f$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $62b79b702763d93f$export$70c702a8c5895f03 = 'data-grab-area-line';
const $62b79b702763d93f$export$48a43f91e4becf4e = 'data-grab-area';
const $62b79b702763d93f$export$dac2fb31a9f6844d = 'data-resize-button';
const $62b79b702763d93f$export$9ecd22db14e6c70e = 'data-resize-control';
const $62b79b702763d93f$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $62b79b702763d93f$export$206a08f7f8beb554 = 'Skip to:';
const $62b79b702763d93f$export$659ee746b31b360d = 'data-layout-container';
const $62b79b702763d93f$export$f963aecf2d4465bd = `var(--${$62b79b702763d93f$export$cbfb0f5b2869b17b}, 0px)`;
const $62b79b702763d93f$export$750459958906793 = `var(--${$62b79b702763d93f$export$fa34f417972d6341}, 0px)`;
const $62b79b702763d93f$export$f897e1ed9f8ed251 = `var(--${$62b79b702763d93f$export$a30f2e00489a8957}, 0px)`;
const $62b79b702763d93f$export$b44ab66843c05a69 = `var(--${$62b79b702763d93f$export$c103b605cd368aed}, 0px)`;
const $62b79b702763d93f$export$aeff86a16f13529 = `var(--${$62b79b702763d93f$export$3a6a779d9181047c}, 0px)`;
const $62b79b702763d93f$export$ed7cc0d417ee89e = `var(--${$62b79b702763d93f$export$bcd94a6a792e7f96}, 0px)`;
const $62b79b702763d93f$export$d2fa14f05b61e66 = `var(--${$62b79b702763d93f$export$b6744d31294864fd}, ${$62b79b702763d93f$export$991d5285ad765a3d}px)`;


parcelRegister("5e5zm", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $0c99a19d69d506cf$export$539e68c09584883a);
$parcel$export(module.exports, "layoutStore", () => $0c99a19d69d506cf$export$b8cdfd44cddaf07);
$parcel$export(module.exports, "useLayoutStoreActions", () => $0c99a19d69d506cf$export$6136bc3b9858cff4);
$parcel$export(module.exports, "useDetailPanelWidth", () => $0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
$parcel$export(module.exports, "useDetailPanelActions", () => $0c99a19d69d506cf$export$99e05a60cac05e86);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $8CM3x = parcelRequire("8CM3x");
const $0c99a19d69d506cf$export$539e68c09584883a = 240;
const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
const $0c99a19d69d506cf$var$initialState = {
    isChromeless: false,
    isFullscreen: false,
    banner: {
        height: 0,
        activeBanner: null
    },
    topNavigation: {
        isVisible: true
    },
    leftPanel: {
        isVisible: true,
        width: 0
    },
    rightPanel: {
        isVisible: true,
        width: 0
    },
    bottomRightCorner: {
        container: undefined,
        portals: []
    },
    content: {
        leftSidebar: {
            width: $0c99a19d69d506cf$export$539e68c09584883a,
            isCollapsed: true,
            isVisible: true,
            isFlyoutOpen: false
        },
        rightSidebar: {
            stackState: []
        }
    }
};
const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $iXqE5.createStore)({
    initialState: $0c99a19d69d506cf$var$initialState,
    actions: $8CM3x.actions,
    name: 'JiraLayoutStore'
});
const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
    selector: null
});
const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $iXqE5.createStore)({
    name: 'detailPanelWidth',
    initialState: {
        width: 0
    },
    actions: {
        setWidth: (value)=>({ setState: setState })=>{
                setState({
                    width: value
                });
            }
    }
});
const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $3sQ5x.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $3sQ5x.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);

});
parcelRegister("8CM3x", function(module, exports) {

$parcel$export(module.exports, "actions", () => $939ad82f8ddcb8d9$export$e324594224ef24da);

var $4oU0I = parcelRequire("4oU0I");

var $flhve = parcelRequire("flhve");

var $f5TQt = parcelRequire("f5TQt");

var $hPsAX = parcelRequire("hPsAX");

var $gqQUV = parcelRequire("gqQUV");

var $byk51 = parcelRequire("byk51");
const $939ad82f8ddcb8d9$export$e324594224ef24da = {
    setIsChromeless: // global
    $f5TQt.setIsChromeless,
    setIsFullscreen: $hPsAX.setIsFullscreen,
    showBanner: // banner
    $4oU0I.showBanner,
    dismissCurrentBanner: $4oU0I.dismissCurrentBanner,
    setLeftSidebarState: // left-sidebar
    $gqQUV.setLeftSidebarState,
    setRightSidebarState: // right-sidebar
    $byk51.setRightSidebarState,
    openRightSidebar: $byk51.openRightSidebar,
    closeRightSidebar: $byk51.closeRightSidebar,
    closeAllRightSidebar: $byk51.closeAllRightSidebar,
    closeCurrentRightSidebar: $byk51.closeCurrentRightSidebar,
    minimiseRightSidebar: $byk51.minimiseRightSidebar,
    registerBottomRightCornerContainer: // bottom-right-corner
    $flhve.registerBottomRightCornerContainer,
    insertBottomRightCornerPortal: $flhve.insertBottomRightCornerPortal,
    removeBottomRightCornerPortal: $flhve.removeBottomRightCornerPortal
};

});
parcelRegister("4oU0I", function(module, exports) {

$parcel$export(module.exports, "showBanner", () => $820929f36789bf81$export$f5c0eb035ef26e87);
$parcel$export(module.exports, "dismissCurrentBanner", () => $820929f36789bf81$export$a45bccc0cc9ac424);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
        setState({
            banner: newState
        });
    };
const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
        dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
            height: 0,
            activeBanner: null
        }));
    };

});

parcelRegister("flhve", function(module, exports) {

$parcel$export(module.exports, "registerBottomRightCornerContainer", () => $560ff4740e75fa9e$export$2992ecf780497763);
$parcel$export(module.exports, "insertBottomRightCornerPortal", () => $560ff4740e75fa9e$export$3ed25a6bee272520);
$parcel$export(module.exports, "removeBottomRightCornerPortal", () => $560ff4740e75fa9e$export$928bf7e228ce06d2);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                container: ref ?? undefined
            }
        });
    };
const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>// @ts-expect-error - TS2322 - Type '({ setState, getState }: StoreActionApi<LayoutState>) => number' is not assignable to type 'Action<LayoutState, void, void | Promise<void>>'.
    ({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        const sorted = [
            item,
            ...portals
        ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
        const index = sorted.findIndex((portal)=>portal.id === item.id);
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: sorted
            }
        });
        return index;
    };
const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
        const { bottomRightCorner: bottomRightCorner } = getState();
        const { portals: portals } = bottomRightCorner;
        setState({
            bottomRightCorner: {
                ...bottomRightCorner,
                portals: portals.filter((portal)=>portal.id !== id)
            }
        });
    };

});

parcelRegister("f5TQt", function(module, exports) {

$parcel$export(module.exports, "setIsChromeless", () => $0389a2d5715d1f25$export$1998c4816ad37edb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
        setState({
            isChromeless: isChromeless
        });
    };

});

parcelRegister("hPsAX", function(module, exports) {

$parcel$export(module.exports, "setIsFullscreen", () => $e3c9e6899dc6b3f0$export$9c73b2f282069160);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
        setState({
            isFullscreen: isFullscreen
        });
    };

});

parcelRegister("gqQUV", function(module, exports) {

$parcel$export(module.exports, "setLeftSidebarState", () => $54ca906cbb882b25$export$3e0fd2d894ef83c8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                leftSidebar: {
                    ...content.leftSidebar,
                    ...newState
                }
            }
        });
    };

});

parcelRegister("byk51", function(module, exports) {

$parcel$export(module.exports, "selectCurrentRightSidebar", () => $4dabd377b098e1a2$export$57758d0cfaeec2c);
$parcel$export(module.exports, "setRightSidebarState", () => $4dabd377b098e1a2$export$f5584170a8c1db02);
$parcel$export(module.exports, "closeAllRightSidebar", () => $4dabd377b098e1a2$export$d91a6e55d52aa3e9);
$parcel$export(module.exports, "closeCurrentRightSidebar", () => $4dabd377b098e1a2$export$a9a5075d3d1b2165);
$parcel$export(module.exports, "closeRightSidebar", () => $4dabd377b098e1a2$export$d7149233c76efb32);
$parcel$export(module.exports, "minimiseRightSidebar", () => $4dabd377b098e1a2$export$4eedf7fa26a2749a);
$parcel$export(module.exports, "openRightSidebar", () => $4dabd377b098e1a2$export$c8dafe074328c4ca);

var $ajpes = parcelRequire("ajpes");
const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
    const arrayCopy = [
        ...array
    ];
    const f = arrayCopy.splice(oldIndex, 1)[0];
    arrayCopy.splice(newIndex, 0, f);
    return arrayCopy;
};
const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const visited = {};
    return stackState.filter((item)=>{
        if (visited[item.panelId]) return false;
        visited[item.panelId] = true;
        return true;
    });
};
const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
    if (state.stackState.length === 1) return state.stackState[0];
    return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
};
const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: []
                }
            }
        });
    };
const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        if (!currentStack.length) return;
        const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
        if (!currentRightSidebar) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.filter((item)=>item.panelId !== panelId)
                }
            }
        });
    };
const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const currentStack = content.rightSidebar.stackState || [];
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: currentStack.map((item)=>{
                        if (item.panelId !== panelId) return item;
                        return {
                            ...item,
                            isMinimised: true
                        };
                    })
                }
            }
        });
    };
const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
        const { content: content } = getState();
        const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
            ...content.rightSidebar.stackState.map((item)=>{
                if (item.panelId === panelId) return {
                    ...item,
                    isMinimised: isMinimised,
                    width: width
                };
                return item;
            })
        ] : [];
        const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
        // if there's any matched panel id, we only move it to the top of the stack.
        if (matchedPanelIndex >= 0) {
            const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
            tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
            tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
            const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
            newRightSidebarStackStateValue[nextIdx].width = width;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
            return;
        }
        const newRightSidebarStackStateValue = toTop ? [
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            },
            ...tempRightSidebarStackStateValue
        ] : [
            ...tempRightSidebarStackStateValue,
            {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimised: isMinimised
            }
        ];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
        setState({
            content: {
                ...content,
                rightSidebar: {
                    stackState: newRightSidebarStackStateValue
                }
            }
        });
    };

});





parcelRegister("axUP7", function(module, exports) {

$parcel$export(module.exports, "withNestingOptimisation", () => $c861ce2b697701b9$export$ee1cb2a8280d8710);

var $5uXOq = parcelRequire("5uXOq");

var $fsi33 = parcelRequire("fsi33");

var $9sGI6 = parcelRequire("9sGI6");
const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
    const WithNestingOptimisation = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        const children = // @ts-expect-error - Property 'children' does not exist on type 'Props'.ts(2339)
        typeof props === 'object' && props != null ? props.children : null;
        return (0, $fsi33.useShouldNestedElementRender)().shouldRender && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ref: ref
        }) : children;
    });
    WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, $9sGI6.getDisplayName)(Component)})`;
    return WithNestingOptimisation;
};

});
parcelRegister("9sGI6", function(module, exports) {

$parcel$export(module.exports, "getDisplayName", () => $0d4ebae82d1d47ab$export$be63e0664592e141);
$parcel$export(module.exports, "default", () => $0d4ebae82d1d47ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
    if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
    if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
    return 'Component';
};
/**
 * @deprecated Just pass the props explicitly or create a new component that provides them. Do not use HOCs.
 */ const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
    const WithInjectedProps = (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...injectedProps,
            ...props
        });
    WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
    return WithInjectedProps;
};
var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;

});



parcelRegister("1z3xg", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $eb963f2e8b47e0f7$export$d722961e96b459c5);

var $1UikQ = parcelRequire("1UikQ");

var $gwIPs = parcelRequire("gwIPs");

var $ai0LF = parcelRequire("ai0LF");
const $eb963f2e8b47e0f7$export$d722961e96b459c5 = (0, $ai0LF.castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
    const newStyle = {
        '[data-edit-icon]': {
            display: 'none'
        },
        '&:hover [data-item-elem-after]': {
            '& > :not([data-edit-icon])': {
                display: 'none'
            },
            '& [data-edit-icon]': {
                display: 'flex'
            }
        },
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
});

});
parcelRegister("ai0LF", function(module, exports) {

$parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", () => $2bb346e8dcf8bbae$export$3f662b014fa1806e);
function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}
function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    return fn;
}

});


parcelRegister("b0i2u", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $3474e09f91a13a47$export$d722961e96b459c5);

var $gwIPs = parcelRequire("gwIPs");

var $42iU4 = parcelRequire("42iU4");
const $3474e09f91a13a47$export$d722961e96b459c5 = ()=>({
        ...(0, $42iU4.cssFn)(),
        height: `${(0, $gwIPs.gridSize) * 5.5}px`
    });

});
parcelRegister("42iU4", function(module, exports) {

$parcel$export(module.exports, "cssFn", () => $6016163e6eb4da1c$export$d722961e96b459c5);
const $6016163e6eb4da1c$export$d722961e96b459c5 = ()=>({
        // Display button when the menu item is focused
        '[data-item-elem-after]': {
            opacity: 0
        },
        '&:hover [data-item-elem-after], &:focus-within [data-item-elem-after]': {
            opacity: 1
        }
    });

});


const $bd24ef8cd2fd388b$export$965e349a75efe8dc = 'spotlight-sidebar-project-pages';

parcelRegister("4Y8PR", function(module, exports) {

$parcel$export(module.exports, "ProjectPageMenuItemWithJoinTeamPulse", () => $ac3dcb3683e445c1$export$7f5c350080123ae8);

var $5uXOq = parcelRequire("5uXOq");

var $cOGPo = parcelRequire("cOGPo");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $9XCQv = parcelRequire("9XCQv");
const $ac3dcb3683e445c1$export$7f5c350080123ae8 = ({ children: children, showPulse: showPulse })=>{
    const [markAsSpotlightPulseSeen] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.PULSE_MESSAGE_ID));
    const [markAsJoinTeamLozengeSeen] = (0, $9XCQv.useUserSpotlightProperty)((0, $9XCQv.LOZENGE_MESSAGE_ID));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const stopPulsing = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'lozenge'
        }), 'crossJoinTeamSidebar');
        markAsJoinTeamLozengeSeen();
    }, [
        markAsJoinTeamLozengeSeen,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        markAsSpotlightPulseSeen(); // mark as seen after first view
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOGPo.Pulse), {
        pulse: showPulse,
        radius: 3,
        onClick: stopPulsing,
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure -- PLEASE FIX - ENABLING FLAT LINT CONFIG
        testId: "navigation-apps-sidebar-common.ui.shortcuts.pages-menu-item.cross-join-team-nudge-provider.cross-join-nudge-pulse"
    }, children);
};

});

parcelRegister("gXsf7", function(module, exports) {

$parcel$export(module.exports, "EndUserActivateNudgeProvider", () => $f71cb08805be985b$export$a00e9d2e4877aaa0);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $6i9Dy = parcelRequire("6i9Dy");

var $jvHQd = parcelRequire("jvHQd");


const $f71cb08805be985b$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);
const $f71cb08805be985b$export$a00e9d2e4877aaa0 = ({ children: children, isFocussed: isFocussed })=>{
    const [showSpotlight, markAsSeen] = (0, $jvHQd.useShowProjectPagesSpotlightSeenStatus)((0, $6i9Dy.MESSAGE_ID));
    return showSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $6i9Dy.MESSAGE_ID),
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f71cb08805be985b$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6i9Dy.EndUserActivateNudge), {
            stop: stop,
            isFocussed: isFocussed,
            markAsSeen: markAsSeen
        }, children))) : children;
};

});
parcelRegister("6i9Dy", function(module, exports) {

$parcel$export(module.exports, "MESSAGE_ID", () => $cf909fe934837f3e$export$af60a7ae4202be66);
$parcel$export(module.exports, "EndUserActivateNudge", () => $cf909fe934837f3e$export$e44c6e87aab1f81);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dyUSJ = parcelRequire("dyUSJ");

var $cOGPo = parcelRequire("cOGPo");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $5oFIy = parcelRequire("5oFIy");

var $hd2Cc = parcelRequire("hd2Cc");
const $cf909fe934837f3e$export$af60a7ae4202be66 = 'jsw-pp-end-user-activated-confluence_v2';
const $cf909fe934837f3e$var$StyledNudge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cf909fe934837f3e$var$NudgeWrapper, {
        ...restProps,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));
const $cf909fe934837f3e$export$e44c6e87aab1f81 = ({ children: children, isFocussed: isFocussed, stop: stop, markAsSeen: markAsSeen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [dismissed, setDismissed] = (0, $5uXOq.useState)(false);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)(); // show the spotlight when focussed (via keyboard)
    (0, $5uXOq.useEffect)(()=>{
        if (isFocussed) spotlightRef.current?.toggleCardVisibility?.(true);
    }, [
        isFocussed,
        spotlightRef
    ]);
    const hideMessage = (0, $5uXOq.useCallback)(()=>{
        setDismissed(true);
        stop?.();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'endUserActivateProjectPagesSpotlight dismissed', {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        });
    }, [
        createAnalyticsEvent,
        stop
    ]);
    const handleOkClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'endUserActivateProjectPagesSpotlightDismissButton', {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        });
        hideMessage();
    }, [
        createAnalyticsEvent,
        hideMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "endUserActivateProjectPagesSpotlightNudge",
        sourceType: "Screen"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            messageId: $cf909fe934837f3e$export$af60a7ae4202be66
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dyUSJ.NudgeSpotlight), {
        ref: spotlightRef,
        hidden: dismissed,
        setHidden: hideMessage,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "endUserActivateProjectPagesSpotlight",
            sourceType: "Screen"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                messageId: $cf909fe934837f3e$export$af60a7ae4202be66
            }
        }), formatMessage((0, $hd2Cc.default).content)),
        actions: [
            {
                text: formatMessage((0, $hd2Cc.default).primaryActionText),
                onClick: handleOkClick
            }
        ],
        position: "right-end",
        onOutsideClick: hideMessage,
        nudgeTestId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-nudge`,
        cardTestId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-card`,
        showSpotlightCardOnFirstRender: false,
        onShow: markAsSeen,
        nudge: $cf909fe934837f3e$var$StyledNudge
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOGPo.Pulse), {
        pulse: !dismissed,
        radius: 3,
        testId: `${$cf909fe934837f3e$export$af60a7ae4202be66}-nudge-pulsing-border`
    }, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cf909fe934837f3e$var$NudgeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrv77o _vtwzu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyUSJ", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $f7c345708a5bf0df$export$eebbda33f5d4d735);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jerjL = parcelRequire("jerjL");

var $5g2iQ = parcelRequire("5g2iQ");

var $e5neF = parcelRequire("e5neF");

var $cBeZP = parcelRequire("cBeZP");

var $7ahpj = parcelRequire("7ahpj");

var $hDhHT = parcelRequire("hDhHT");

var $ao4Ml = parcelRequire("ao4Ml");
const $f7c345708a5bf0df$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $f7c345708a5bf0df$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $7ahpj.default), nudge: Nudge = (0, $jerjL.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $f7c345708a5bf0df$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $7ahpj.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5neF.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $hDhHT.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $f7c345708a5bf0df$export$2e2bcd8739ae039 = $f7c345708a5bf0df$export$eebbda33f5d4d735;

});
parcelRegister("jerjL", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $82e971f9cdd82e0b$export$b7d614104f4a4a7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gh9fJ = parcelRequire("gh9fJ");
const $82e971f9cdd82e0b$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $gh9fJ.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("gh9fJ", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $32214f4743f47717$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $b4a3S = parcelRequire("b4a3S");

var $fHpHg = parcelRequire("fHpHg");
function $32214f4743f47717$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32214f4743f47717$var$baseShadow = '0 0 0 3px';
const $32214f4743f47717$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $a7f8c6b391092279$exports).P75})`;
const $32214f4743f47717$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $32214f4743f47717$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $32214f4743f47717$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animation: `pulseKeyframes 3000ms ${$32214f4743f47717$var$easing} infinite`
});
const $32214f4743f47717$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $32214f4743f47717$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $32214f4743f47717$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$32214f4743f47717$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $32214f4743f47717$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$32214f4743f47717$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $32214f4743f47717$var$pulseAnimation
            ]
        }
    });
const $32214f4743f47717$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $b4a3S.borderRadius)(), pulseColor: pulseColor = $32214f4743f47717$var$basePulseColor, pulseShadowColor: pulseShadowColor = $32214f4743f47717$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: [
            $32214f4743f47717$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $fHpHg.fg)('jira_onboarding_experiences_a11y_fixes') && $32214f4743f47717$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $32214f4743f47717$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});


parcelRegister("7ahpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d40f012862dc8775$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $d40f012862dc8775$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d40f012862dc8775$var$borderRadius = 3;
const $d40f012862dc8775$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $a7f8c6b391092279$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $a7f8c6b391092279$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $a7f8c6b391092279$export$b48405b95304b5a1)})`,
    borderRadius: `${$d40f012862dc8775$var$borderRadius}px`,
    overflow: 'auto'
};
const $d40f012862dc8775$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $d40f012862dc8775$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $d40f012862dc8775$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $d40f012862dc8775$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $d40f012862dc8775$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $a7f8c6b391092279$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $a7f8c6b391092279$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $a7f8c6b391092279$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $a7f8c6b391092279$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $a7f8c6b391092279$export$a7175d4e9206bc80)})`
        }
    });
const $d40f012862dc8775$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $d40f012862dc8775$var$actionItemStyles(index),
        ...rest
    });
const $d40f012862dc8775$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $d40f012862dc8775$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($d40f012862dc8775$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$d40f012862dc8775$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $d40f012862dc8775$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $d40f012862dc8775$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $d40f012862dc8775$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $d40f012862dc8775$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $d40f012862dc8775$var$actionItemContainerStyles
    }, renderedActions))));
});
var $d40f012862dc8775$export$2e2bcd8739ae039 = $d40f012862dc8775$export$b3ae98194e057550;

});

parcelRegister("hDhHT", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $f0875c29640c6b93$export$d0f55839b708c0a0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $5g2iQ = parcelRequire("5g2iQ");
const $f0875c29640c6b93$export$474e8ee88cc7cd8f = 200;
const $f0875c29640c6b93$export$3d6f334bf7dc4597 = 120;
const $f0875c29640c6b93$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$f0875c29640c6b93$export$474e8ee88cc7cd8f}ms`
};
const $f0875c29640c6b93$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$f0875c29640c6b93$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $f0875c29640c6b93$var$timeoutDurations = {
    enter: 0,
    exit: $f0875c29640c6b93$export$3d6f334bf7dc4597
};
const $f0875c29640c6b93$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $f0875c29640c6b93$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5g2iQ.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$f0875c29640c6b93$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$f0875c29640c6b93$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});


parcelRegister("5oFIy", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
$parcel$export(module.exports, "FireTrackAnalytics", () => $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $3ea3e1dfbcd8cda6$export$2ccf161b817b43b);

var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");


var $8zOmE = parcelRequire("8zOmE");
// eslint-disable-next-line jira/react/no-class-components
class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
        if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
        if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
        const eventNameSplit = eventName ? eventName.split(' ') : [];
        const action = actionProps || eventNameSplit[1];
        const actionSubject = actionSubjectProps || eventNameSplit[0];
        if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
        const actionSubjectId = actionSubjectIdProps || componentName;
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $8zOmE.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, $3TR0I.default)()($3ea3e1dfbcd8cda6$var$FireComponent);
const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
    });
const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
    });
const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$12346a674644c156)
    });
const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
        ...props,
        type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("hd2Cc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5cd796d16315ac4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5cd796d16315ac4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    content: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.content",
        "defaultMessage": "Collaborate on product requirements, documentation, plans, and so much more."
    },
    primaryActionText: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.primary-action-text",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("jvHQd", function(module, exports) {

$parcel$export(module.exports, "useShowProjectPagesSpotlightSeenStatus", () => $fa98bfcce54b89aa$export$d2a473f76f614377);

var $5uXOq = parcelRequire("5uXOq");

var $89SaW = parcelRequire("89SaW");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

var $90yGq = parcelRequire("90yGq");
const $fa98bfcce54b89aa$export$d2a473f76f614377 = (messageId)=>{
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const propertyKey = `${messageId}.seen`;
    const accountId = (0, $90yGq.useAccountId)();
    (0, $5uXOq.useEffect)(()=>{
        if (accountId) (0, $89SaW.getUserProperty)(accountId, propertyKey).then(()=>{
            setShowSpotlight(false);
        }).catch((error)=>{
            // If we can't find key, we know user never seen the spotlight
            if (error.statusCode === 404) {
                setShowSpotlight(true);
                return;
            }
            (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Error reading data from getUserProperty with property key ${propertyKey}`, error);
        });
        else (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Can not read data from getUserProperty with property key ${propertyKey} because accountId is missing`);
    }, [
        accountId,
        propertyKey
    ]);
    const markAsSeen = (0, $5uXOq.useCallback)(()=>{
        if (accountId) (0, $89SaW.setUserProperties)(accountId, propertyKey, 'true').then((res)=>{
            if (res.ok) return;
            res.text().then((errResp)=>{
                throw new (0, $jJZqs.default)(res.status, errResp);
            });
        }).catch((error)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Failed to update the value in setUserProperties with property key ${propertyKey}`, error));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData('useShowProjectPagesSpotlightSeenStatus', `Can not set data using setUserProperties with property key ${propertyKey} because accountId is missing`);
    }, [
        accountId,
        propertyKey
    ]);
    return [
        showSpotlight,
        markAsSeen
    ];
};

});
parcelRegister("90yGq", function(module, exports) {

$parcel$export(module.exports, "useAccountId", () => $903db0de2618ef6c$export$e72033e0f5baa3e);

var $9OXo1 = parcelRequire("9OXo1");
const $903db0de2618ef6c$export$e72033e0f5baa3e = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.atlassianAccountId || null;
};

});



parcelRegister("7dRTN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $78c30a1a7f0b1479$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $78c30a1a7f0b1479$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectPagesItem: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.project-pages-item",
        "defaultMessage": "Project pages"
    },
    edit: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.edit",
        "defaultMessage": "Edit"
    },
    editProjectPages: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.edit-project-pages",
        "defaultMessage": "Edit project pages"
    },
    pagesItem: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.pages-item",
        "defaultMessage": "Pages"
    },
    projectPagesLozenge: {
        "id": "navigation-apps-shortcuts-sidebar.pages-menu-item.project-pages-lozenge",
        "defaultMessage": "Join Team"
    }
});

});



parcelRegister("jvcra", function(module, exports) {

$parcel$export(module.exports, "ExpandableSection", () => $181ed316b1c5154e$export$e86ef41bc845761);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $1u5XK = parcelRequire("1u5XK");
var $kxnYb = parcelRequire("kxnYb");

var $gwIPs = parcelRequire("gwIPs");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $4R6GH = parcelRequire("4R6GH");

var $fXJBp = parcelRequire("fXJBp");
const $181ed316b1c5154e$export$e86ef41bc845761 = (props)=>{
    const { title: title = '', submenuActive: submenuActive = false, isCollapsed: isCollapsed = false, hasSeparator: hasSeparator = false, removeTitleSection: removeTitleSection = false, testId: testId = '', headingLevel: headingLevel, expandClick: expandClick, context: context } = props;
    const [expanded, setExpanded] = (0, $5uXOq.useState)(true);
    const [showCaret, setShowCaret] = (0, $5uXOq.useState)(!expanded && !submenuActive);
    const [removeCaret, setRemoveCaret] = (0, $5uXOq.useState)(submenuActive);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const expandButtonId = title != null ? title.replace(/ /g, '-').toLowerCase() : '';
    const onContainerMouseOver = (0, $5uXOq.useCallback)(()=>{
        if (expanded && !submenuActive) setShowCaret(true);
        if (submenuActive) setShowCaret(false);
    }, [
        expanded,
        submenuActive
    ]);
    const onContainerMouseLeave = (0, $5uXOq.useCallback)(()=>{
        if (expanded) setShowCaret(false);
    }, [
        expanded
    ]);
    const onExpandButtonClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'navModules', {
            navModulesId: title,
            expanded: !expanded
        });
        setExpanded(!expanded);
        if (expandClick) expandClick();
    }, [
        createAnalyticsEvent,
        title,
        expanded,
        expandClick
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!expanded) setShowCaret(true);
    }, [
        expanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (submenuActive) setRemoveCaret(true);
        else setRemoveCaret(false);
    }, [
        submenuActive
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setExpanded(!isCollapsed);
    }, [
        isCollapsed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (removeTitleSection) setExpanded(true);
    }, [
        removeTitleSection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($181ed316b1c5154e$var$Container, {
        onMouseOver: onContainerMouseOver,
        onMouseLeave: onContainerMouseLeave,
        submenuActive: submenuActive,
        removeTitleSection: removeTitleSection,
        context: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXJBp.ExpandButton), {
        isExpanded: expanded || removeTitleSection,
        id: expandButtonId,
        isActive: true,
        label: props.title || '',
        onClick: onExpandButtonClick,
        size: "medium",
        isVisible: showCaret,
        removeCaret: removeCaret || removeTitleSection,
        tabIndex: 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: hasSeparator,
        testId: testId,
        title: (0, $4R6GH.fg)('blu-6205_nav3_sidebar_a11y_fix') ? title : undefined
    }, title && !(0, $4R6GH.fg)('blu-6205_nav3_sidebar_a11y_fix') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u5XK.default), {
        headingLevel: headingLevel
    }, title), expanded && props.children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $181ed316b1c5154e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, removeTitleSection: removeTitleSection, context: context, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _18u0yr36 _rh951ule _1hoi1gjq _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive || __cmplp.removeTitleSection ? "_19pkidpf" : "_19pkdlk8",
            __cmplp.submenuActive ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.submenuActive ? "_4t3i1osq" : "_4t3i1wug",
            __cmplp.submenuActive || __cmplp.removeTitleSection ? "_1xpp1osq" : "_1xpp5cnj",
            __cmplp.submenuActive ? "_1ipydlk8" : "_1ipy196n",
            __cmplp.submenuActive ? "_1ly419bv" : "_1ly4idpf",
            __cmplp.removeTitleSection ? "_135pglyw" : "_135p1ule",
            __cmplp.removeTitleSection ? "_15skidpf _178kidpf _18pcidpf _1bc7idpf" : "_15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z",
            __cmplp.removeTitleSection && "_ik0tidpf",
            !__cmplp.submenuActive && "_2rkoi2wt _189eyh40 _1dqonqa1 _1h6d3acm _2hwx196n _ca0qu2gc _19pkv77o _u5f314y2",
            __cmplp.removeTitleSection && "_ca0qidpf _19pkidpf",
            __cmplp.submenuActive && "_18u0idpf",
            !__cmplp.submenuActive && __cmplp.removeTitleSection && "_18u01skh",
            !__cmplp.submenuActive && !__cmplp.removeTitleSection && __cmplp.context !== 'classic' && "_18u0yr36",
            !__cmplp.submenuActive && !__cmplp.removeTitleSection && __cmplp.context === 'classic' && "_18u0d439",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1u5XK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8a315ea852f524$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $d6a7c = parcelRequire("d6a7c");

var $c48kn = parcelRequire("c48kn");

var $fsi33 = parcelRequire("fsi33");
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $4b8a315ea852f524$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    const cssFn = (0, $c48kn.overrideStyleFunction)((0, $c48kn.sectionHeaderSpacingStyles), props.cssFn);
    // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis, @repo/internal/react/no-unsafe-overrides, @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d6a7c.default), {
        ...props,
        cssFn: cssFn
    });
};
var $4b8a315ea852f524$export$2e2bcd8739ae039 = $4b8a315ea852f524$var$HeadingItem;

});

parcelRegister("fXJBp", function(module, exports) {

$parcel$export(module.exports, "ExpandButton", () => $a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cUaD8 = parcelRequire("cUaD8");

var $GYj5l = parcelRequire("GYj5l");

var $jVpd1 = parcelRequire("jVpd1");

var $LD2gx = parcelRequire("LD2gx");

var $0yZbT = parcelRequire("0yZbT");

var $dCm1o = parcelRequire("dCm1o");
const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'number'.
tabIndex = null })=>{
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    const ChevronOld = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($cUaD8))) : (0, (/*@__PURE__*/$parcel$interopDefault($GYj5l)));
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($jVpd1))) : (0, (/*@__PURE__*/$parcel$interopDefault($LD2gx)));
    const onKeydown = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    (event)=>{
        // Space bar or enter (Button A11y rules) triggers click of expand button
        if ([
            13,
            32
        ].includes(event.keyCode)) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    const chevronElement = (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        padding: "space.075",
        paddingBlockStart: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
        testId: `sidebar.expand-button.container-${id}`,
        color: "var(--ds-icon, #44546F)",
        label: label
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
        testId: `sidebar.expand-button.container-${id}`,
        primaryColor: "var(--ds-icon, #44546F)",
        label: label,
        size: size
    });
    // Performance optimisation - only render interactive button upon proxy interactions
    if (!isActive) return chevronElement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
        role: "button",
        "aria-expanded": isExpanded,
        onClick: onClick,
        onKeyDown: onKeydown,
        isVisible: isVisible,
        removeCaret: removeCaret,
        size: size,
        tabIndex: tabIndex
    }, chevronElement);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3120c1c485e5e18$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _kqswh2mm _4t3i1osq _bfhk18uv _80omtlke _1spjglyw _1ejjufon _19lvkb7n",
            __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("eYDk7", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderWrapper", () => $eea5dc8ebf00d36e$export$bae9b35e967353d5);
$parcel$export(module.exports, "NavigationExpandableContentWrapper", () => $eea5dc8ebf00d36e$export$4e88508e6904469e);
$parcel$export(module.exports, "NavigationContentWrapper", () => $eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
$parcel$export(module.exports, "NextGenIssueTypesWrapper", () => $eea5dc8ebf00d36e$export$f094f7aad76e4268);
$parcel$export(module.exports, "ExpandableProjectSettingsWrapper", () => $eea5dc8ebf00d36e$export$e38bb288d890ec2f);
$parcel$export(module.exports, "ShortCutsAndAppsWrapper", () => $eea5dc8ebf00d36e$export$337add4342ee7986);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");
const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
    const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
        nestedAppOpen: nestedAppOpen,
        submenuActive: submenuActive
    }, children);
};
const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
        submenuActive: props.submenuActive,
        nestedMenuOpen: props.nestedMenuOpen,
        "data-component-selector": "NavigationContentWrapperContainer"
    }, props.children);
const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1s541012 _1lfu1012",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ykp9lh": (0, $lD23V.default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive && "_4t3i1qw7",
            __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_6w8gix": (0, $lD23V.default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, $gwIPs.gridSize), "px"),
            "--_1qrlsbv": (0, $lD23V.default)(Math.round((0, $gwIPs.borderRadius) * 1.333), "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
            __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
            __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
            __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3i1osq _1wtppxbi _df5vpxbi",
            __cmplp.className
        ])
    });
});
const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _14tk72c6 _t3zc183y _1so41gjq _1thc1skh _a6avqslr _dnyv1skh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("a2iZU", function(module, exports) {

$parcel$export(module.exports, "ScreenReaderMenuHeader", () => $e545e14b3034e9ee$export$e4974841dcf2a587);

var $5uXOq = parcelRequire("5uXOq");

var $1u5XK = parcelRequire("1u5XK");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $lHJgi = parcelRequire("lHJgi");
const $e545e14b3034e9ee$export$e4974841dcf2a587 = ({ title: title })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const defaultTitle = formatMessage((0, $lHJgi.messages).sideBarNavigationTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1u5XK.default), {
        headingLevel: 2
    }, title || defaultTitle));
};

});
parcelRegister("dqoiX", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $11827e0613b04108$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $11827e0613b04108$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $11827e0613b04108$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $11827e0613b04108$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $11827e0613b04108$export$88fad6aa294f111c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});
const $11827e0613b04108$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _kqswstnw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("lHJgi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5890a868407d596f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5890a868407d596f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    sideBarNavigationTitle: {
        "id": "spa-apps-sidebar-common.common.screen-reader-header.side-bar-navigation-title",
        "defaultMessage": "Menu"
    }
});

});


parcelRegister("2gP8z", function(module, exports) {

$parcel$export(module.exports, "SpotlightTarget", () => $bac5b90628bba66f$export$e29577842f211e22);

var $5uXOq = parcelRequire("5uXOq");

var $Pxnvj = parcelRequire("Pxnvj");

var $axUP7 = parcelRequire("axUP7");
const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-test-id": `ak-spotlight-target-${props.name}`
    }, children));
const $bac5b90628bba66f$export$e29577842f211e22 = (0, $axUP7.withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);

});

parcelRegister("fNi03", function(module, exports) {

$parcel$export(module.exports, "useBoard", () => $860e4a990aab148d$export$15adc93832970b54);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");

var $gpXo6 = parcelRequire("gpXo6");

var $1J3t1 = parcelRequire("1J3t1");

var $6VnTH = parcelRequire("6VnTH");
const $860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES = [
    'rapidboard-user-board',
    'rapidboard-user-backlog',
    'rapidboard-user-report',
    'rapidboard-user-board-settings',
    'rapidboard-user-reports-overview',
    'software-reports-velocity-user-board'
];
const $860e4a990aab148d$var$isOnUserBoardRoute = (routeName)=>$860e4a990aab148d$var$USER_BOARD_ROUTE_NAMES.includes(routeName);
const $860e4a990aab148d$var$isOnLocationLessBoardRoute = (match, query)=>{
    const { locationless: locationless = 'false' } = query;
    return match.url.includes('RapidBoard.jspa') && JSON.parse(locationless) === true;
};
const $860e4a990aab148d$export$50230c720b1c453e = ()=>{
    const [{ match: match, route: route, query: query }] = (0, $doZTA.useRouter)();
    return $860e4a990aab148d$var$isOnUserBoardRoute(route.name) || $860e4a990aab148d$var$isOnLocationLessBoardRoute(match, query);
};
const $860e4a990aab148d$export$15adc93832970b54 = ()=>{
    const isOnUserOrLocationlessBoardRoute = $860e4a990aab148d$export$50230c720b1c453e();
    // pb -> project board
    const { data: pb, loading: pbLoading, error: pbError } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    // ub -> user board
    const { data: ub, loading: ubLoading, error: ubError } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    const projectBoard = (0, $5uXOq.useMemo)(()=>pb && (0, $6VnTH.extractData)(pb), [
        pb
    ]);
    const userBoard = (0, $5uXOq.useMemo)(()=>ub && (0, $6VnTH.extractUserBoard)(ub), [
        ub
    ]);
    if (isOnUserOrLocationlessBoardRoute) return {
        data: userBoard,
        loading: ubLoading,
        error: ubError
    };
    return {
        data: projectBoard,
        loading: pbLoading,
        error: pbError
    };
};

});
parcelRegister("gpXo6", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $c3c49f06ba708347$export$517acde8347261e3);

var $7xTO3 = parcelRequire("7xTO3");

var $2YP9W = parcelRequire("2YP9W");
const $c3c49f06ba708347$export$517acde8347261e3 = ()=>(0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));

});

parcelRegister("6VnTH", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $4d73b10ca351bbb3$export$9df5fa0a366163d2);
$parcel$export(module.exports, "extractUserBoard", () => $4d73b10ca351bbb3$export$67db9e2d1b6ed865);
const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
    if (jiraSoftwareNavData.boardInfo == null) return null;
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: true
    };
};
const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
    const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
    return {
        id: id,
        type: type,
        name: name,
        isProjectBoard: false
    };
};

});


parcelRegister("18FbX", function(module, exports) {

$parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", () => $066b0551287c1b35$export$50628ae0ad1a35f2);
$parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", () => $066b0551287c1b35$export$96e8a0c1f4717705);

var $5uXOq = parcelRequire("5uXOq");

var $eusud = parcelRequire("eusud");

var $1J3t1 = parcelRequire("1J3t1");
const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, $eusud.performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, $eusud.performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: data?.hasPages === true,
            canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};
const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
    const { loading: loading, refresh: refresh, error: error } = (0, $1J3t1.useJiraWorkmanagementProjectNavigation)();
    const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
        await $066b0551287c1b35$var$setPagesLinkService(...args);
        await refresh();
    }, [
        refresh
    ]);
    return {
        data: {
            isEnabled: true,
            canEdit: false,
            pending: loading,
            setPagesLink: setPagesLink
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("cF0ZN", function(module, exports) {

$parcel$export(module.exports, "useIncidentExperimentTraits", () => $66be814f01f13734$export$b8f7cdf3154dc677);

var $5uXOq = parcelRequire("5uXOq");

var $7GnDe = parcelRequire("7GnDe");

var $2YP9W = parcelRequire("2YP9W");
const $66be814f01f13734$export$b8f7cdf3154dc677 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $7GnDe.incidentExperimentTraitResource));
    return (0, $5uXOq.useMemo)(()=>({
            data: data || {
                cohort1: false,
                cohort2: false
            },
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});

parcelRegister("2A1mZ", function(module, exports) {

$parcel$export(module.exports, "setNavModulesCollapseState", () => $ab76932f9485bce1$export$ca5222c4b4062506);
$parcel$export(module.exports, "useNavModulesCollapseState", () => $ab76932f9485bce1$export$c7dfd32b1560e67f);

var $3TzYp = parcelRequire("3TzYp");

var $iBA0W = parcelRequire("iBA0W");
const $ab76932f9485bce1$export$7636f137b12a551a = 'navigation_modules_ui_state';
const $ab76932f9485bce1$var$defualtNavModulesState = {
    classic: {
        planning: {
            isCollapsed: false
        },
        development: {
            isCollapsed: false
        },
        operations: {
            isCollapsed: false
        }
    },
    nextGen: {
        planning: {
            isCollapsed: false
        },
        development: {
            isCollapsed: false
        },
        operations: {
            isCollapsed: false
        }
    }
};
const $ab76932f9485bce1$export$fc6c821ea6a7b14c = ()=>{
    const cookieData = (0, $3TzYp.getCookie)($ab76932f9485bce1$export$7636f137b12a551a);
    if (!cookieData) return $ab76932f9485bce1$var$defualtNavModulesState;
    let parsedCookieData = null;
    try {
        parsedCookieData = JSON.parse(cookieData);
    } catch  {
        // Rather than throw an error - just set the default state
        parsedCookieData = $ab76932f9485bce1$var$defualtNavModulesState;
    }
    return parsedCookieData;
};
const $ab76932f9485bce1$var$updateCookie = (data)=>(0, $iBA0W.setCookie)($ab76932f9485bce1$export$7636f137b12a551a, JSON.stringify(data));
const $ab76932f9485bce1$export$ca5222c4b4062506 = (navState = $ab76932f9485bce1$var$defualtNavModulesState)=>{
    $ab76932f9485bce1$var$updateCookie({
        ...$ab76932f9485bce1$var$defualtNavModulesState,
        ...navState
    });
};
const $ab76932f9485bce1$export$c7dfd32b1560e67f = ()=>{
    const uiState = $ab76932f9485bce1$export$fc6c821ea6a7b14c();
    if (uiState) return uiState;
    $ab76932f9485bce1$export$ca5222c4b4062506();
    return $ab76932f9485bce1$var$defualtNavModulesState;
};
const $ab76932f9485bce1$export$c30e8898a3640c8 = ()=>'/rest/greenhopper/1.0/profile/labs-panel/navigation-modules-visibility';

});
parcelRegister("iBA0W", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $03e61ca463f5df1b$export$110700823644f4a6);

var $1dN1z = parcelRequire("1dN1z");

const $03e61ca463f5df1b$export$110700823644f4a6 = async (key, value, attributes)=>{
    const result = await (0, $1dN1z.setCookie)(key, value, attributes);
    return result === (0, $7e1a2574c1b036d5$export$705aacb6e4365ec5);
};

});
parcelRegister("1dN1z", function(module, exports) {

$parcel$export(module.exports, "setCookie", () => $317d08d061b7f78b$export$110700823644f4a6);

var $eYli8 = parcelRequire("eYli8");

var $fHpHg = parcelRequire("fHpHg");

var $6ZTqw = parcelRequire("6ZTqw");
var $2MdED = parcelRequire("2MdED");

var $7B39G = parcelRequire("7B39G");

var $4TktD = parcelRequire("4TktD");

var $3liKs = parcelRequire("3liKs");
const $317d08d061b7f78b$export$110700823644f4a6 = async (key, value, attributes)=>{
    if ((0, $fHpHg.fg)('platform_moonjelly_bsc_master_killswitch')) {
        // Set the cookie without checking user preferences
        // when master killswitch is enabled
        (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
        return (0, $3liKs.Status).SUCCESS;
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    const productName = (0, $6ZTqw.getBscGlobalState)().product;
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetCookie = await (0, $7B39G.isProcessingAllowedByPreferences)({
        itemKey: key,
        storageType: (0, $3liKs.CategoryStorageType).Cookies,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetCookie,
        cookieKey: key
    };
    try {
        (0, $2MdED.sendPackageOperationalEvent)({
            action: 'usedSetCookie',
            attributes: eventAttributes
        });
        if (shouldSetCookie) {
            (0, (/*@__PURE__*/$parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
            return (0, $3liKs.Status).SUCCESS;
        } else return (0, $3liKs.Status).BLOCKED;
    } catch (e) {
        (0, $4TktD.Logger).errorWithOperationalEvent({
            action: 'usedSetCookieError',
            attributes: eventAttributes,
            message: `Failed to use set cookie. ${e.message || ''}`
        });
        return (0, $3liKs.Status).BLOCKED;
    }
};

});

const $7e1a2574c1b036d5$export$705aacb6e4365ec5 = 'SUCCESS';
const $7e1a2574c1b036d5$export$4ed08e1af9a6bef = 'BLOCKED';



parcelRegister("jineK", function(module, exports) {

$parcel$export(module.exports, "RegisterProjectNavigationCommands", () => $73fbd7ee6e88a9bb$export$75802ed43d6ca70e);

var $5uXOq = parcelRequire("5uXOq");

var $3YnyA = parcelRequire("3YnyA");

var $5p1kJ = parcelRequire("5p1kJ");

var $4l54H = parcelRequire("4l54H");

var $eG9rp = parcelRequire("eG9rp");

var $1Kt4o = parcelRequire("1Kt4o");

var $556k7 = parcelRequire("556k7");

var $koVbs = parcelRequire("koVbs");

var $8CVvd = parcelRequire("8CVvd");


var $ey3mx = parcelRequire("ey3mx");
const $73fbd7ee6e88a9bb$export$75802ed43d6ca70e = ({ features: features, timelineHref: timelineHref, boardHref: boardHref, backlogHref: backlogHref, reportsHref: reportsHref })=>{
    const { hideAndTransformNavigationCommands: hideAndTransformNavigationCommands } = (0, $4l54H.useTransformNavigationCommands)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const hasTimeline = features?.hasRoadmap;
    const hasBacklog = features?.hasBacklog;
    const hasBoard = features?.hasBoard;
    const hasReports = features?.hasReports;
    const commands = (0, $5uXOq.useMemo)(()=>hideAndTransformNavigationCommands([
            ...(0, $8CVvd.getWillShowNav3)() && hasTimeline ? [
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    command: {
                        id: (0, $fb3970c126a47b8b$export$c2d02b5cc942df6d),
                        name: formatMessage((0, $ey3mx.default).commandPaletteGoToTimeline),
                        section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation,
                        keywords: getKeywords('timelineSynonyms'),
                        shortcut: '4',
                        priority: (0, $5p1kJ.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToTimeline,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YnyA))), {
                                    spacing: "spacious",
                                    label: formatMessage((0, $ey3mx.default).commandPaletteGoToTimeline)
                                })
                        },
                        analytics: {
                            action: 'goToTimeline'
                        }
                    },
                    path: timelineHref
                }
            ] : [],
            ...(0, $8CVvd.getWillShowNav3)() && hasBacklog ? [
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    command: {
                        id: (0, $fb3970c126a47b8b$export$2caa1569d0e2b36a),
                        name: formatMessage((0, $ey3mx.default).commandPaletteGoToBacklog),
                        section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation,
                        keywords: getKeywords('backlogSynonyms'),
                        shortcut: '1',
                        priority: (0, $5p1kJ.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToBacklog,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YnyA))), {
                                    spacing: "spacious",
                                    label: formatMessage((0, $ey3mx.default).commandPaletteGoToBacklog)
                                })
                        },
                        analytics: {
                            action: 'goToBacklog'
                        }
                    },
                    path: backlogHref
                }
            ] : [],
            ...(0, $8CVvd.getWillShowNav3)() && hasBoard ? [
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    command: {
                        id: (0, $fb3970c126a47b8b$export$66c7fd2bb79d8c7d),
                        name: formatMessage((0, $ey3mx.default).commandPaletteGoToBoard),
                        section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation,
                        keywords: getKeywords('boardSynonyms'),
                        shortcut: '2',
                        priority: (0, $5p1kJ.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToBoard,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YnyA))), {
                                    spacing: "spacious",
                                    label: formatMessage((0, $ey3mx.default).commandPaletteGoToBoard)
                                })
                        },
                        analytics: {
                            action: 'goToBoard'
                        }
                    },
                    path: boardHref
                }
            ] : [],
            ...(0, $8CVvd.getWillShowNav3)() && hasReports ? [
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    command: {
                        id: (0, $fb3970c126a47b8b$export$6e068dae232ebb6),
                        name: formatMessage((0, $ey3mx.default).commandPaletteGoToReports),
                        section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).containerNavigation,
                        keywords: getKeywords('reportsSynonyms'),
                        shortcut: '3',
                        priority: (0, $5p1kJ.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToReports,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YnyA))), {
                                    spacing: "spacious",
                                    label: formatMessage((0, $ey3mx.default).commandPaletteGoToReports)
                                })
                        },
                        analytics: {
                            action: 'goToReports'
                        }
                    },
                    path: reportsHref
                }
            ] : []
        ]), [
        backlogHref,
        boardHref,
        formatMessage,
        getKeywords,
        hasBacklog,
        hasBoard,
        hasReports,
        hasTimeline,
        hideAndTransformNavigationCommands,
        reportsHref,
        timelineHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $556k7.RegisterCommands), {
        registrationId: (0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).PROJECT_NAVIGATION,
        commands: commands,
        deps: commands
    });
};

});
parcelRegister("3YnyA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e493f924d83b9dd$var$_react = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2e493f924d83b9dd$var$_arrowRight = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("kAczT")));

var $2e493f924d83b9dd$var$_arrowRight2 = $2e493f924d83b9dd$var$_interopRequireDefault((parcelRequire("k9YqY")));
function $2e493f924d83b9dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e493f924d83b9dd$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2e493f924d83b9dd$var$_react.default.createElement($2e493f924d83b9dd$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $2e493f924d83b9dd$var$_arrowRight2.default
    }, props));
$2e493f924d83b9dd$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $2e493f924d83b9dd$var$_default = module.exports.default = $2e493f924d83b9dd$var$ArrowRightIcon;

});
parcelRegister("k9YqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead386e1a3ec2bd9$var$_react = $ead386e1a3ec2bd9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $ead386e1a3ec2bd9$var$_arrowRight = $ead386e1a3ec2bd9$var$_interopRequireDefault((parcelRequire("kAczT")));
function $ead386e1a3ec2bd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead386e1a3ec2bd9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $ead386e1a3ec2bd9$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $ead386e1a3ec2bd9$var$_arrowRight.default
    }));
$ead386e1a3ec2bd9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $ead386e1a3ec2bd9$var$_default = module.exports.default = $ead386e1a3ec2bd9$var$ArrowRightIcon;

});


parcelRegister("5p1kJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $7691773a5eed3db6$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $7691773a5eed3db6$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $7691773a5eed3db6$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $7691773a5eed3db6$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $7691773a5eed3db6$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $7691773a5eed3db6$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $7691773a5eed3db6$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $7691773a5eed3db6$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $7691773a5eed3db6$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $7691773a5eed3db6$export$16b06d29ef8f802b = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["containerNavigation"] = "container-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
    COMMAND_PALETTE_SECTIONS["forge"] = "forge";
    return COMMAND_PALETTE_SECTIONS;
}({});
const $7691773a5eed3db6$export$156ebd2354e25466 = 'issueActions';
const $7691773a5eed3db6$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $7691773a5eed3db6$export$9f646ab88e1d2b14 = 'commandPalette';
var $7691773a5eed3db6$export$abf26cc5daebd2c8 = /*#__PURE__*/ function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["containerNavigation"] = 2] = "containerNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["forge"] = 9] = "forge";
    return COMMAND_PALETTE_SECTIONS_PRIORITY;
}({});
var $7691773a5eed3db6$export$12514ca8899b0521 = /*#__PURE__*/ function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
    return COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5fa0bcf59f933c21 = /*#__PURE__*/ function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
    return COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY;
}({});
var $7691773a5eed3db6$export$7d9743be0b7d862f = /*#__PURE__*/ function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
    return COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY;
}({});
var $7691773a5eed3db6$export$b4e1633c86db2b70 = /*#__PURE__*/ function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
    return COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY;
}({});
var $7691773a5eed3db6$export$5e5a87aac5d9771f = /*#__PURE__*/ function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
    return COMMAND_PALETTE_HELP_PRIORITY;
}({});

});

parcelRegister("4l54H", function(module, exports) {

$parcel$export(module.exports, "useTransformNavigationCommands", () => $586d7e6f1a99cb44$export$5b108cd54c923a60);

var $5uXOq = parcelRequire("5uXOq");

var $bngFq = parcelRequire("bngFq");

var $6P0Kj = parcelRequire("6P0Kj");

var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $jh7L9 = parcelRequire("jh7L9");

var $jiSaf = parcelRequire("jiSaf");

var $gM5ou = parcelRequire("gM5ou");

var $d8lE2 = parcelRequire("d8lE2");

var $2f2jJ = parcelRequire("2f2jJ");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $doZTA = parcelRequire("doZTA");

var $8btEA = parcelRequire("8btEA");

var $3XsL2 = parcelRequire("3XsL2");

var $d10H0 = parcelRequire("d10H0");

var $dmcoI = parcelRequire("dmcoI");

const $586d7e6f1a99cb44$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $doZTA.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $d8lE2.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const openNewTab = (0, $5uXOq.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $5uXOq.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $5uXOq.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $gM5ou.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $8zOmE.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3XsL2.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $2ea3babd020e8e8a$export$8db96ea7b6a4cbab)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $5uXOq.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8btEA.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
                        testId: (0, $2ea3babd020e8e8a$export$99957d8f5f113509),
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: $586d7e6f1a99cb44$var$iconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
                        label: "",
                        color: "currentColor"
                    })), !!shouldAlwaysOpenNewTab && !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8btEA.IconContainer), {
                        "data-testid": (0, $2ea3babd020e8e8a$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6P0Kj))), {
                        label: "",
                        color: "currentColor"
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $d10H0.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $jh7L9.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $5uXOq.useCallback)((hideCommandPath)=>!(0, $dmcoI.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $5uXOq.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $5uXOq.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};
const $586d7e6f1a99cb44$var$iconWrapperStyles = (0, $2s57o.xcss)({
    height: '24px',
    width: '24px',
    marginLeft: 'space.075'
});

});
parcelRegister("jh7L9", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3);
var $b1e48ebd4c8d5e4e$export$f041b1b117ab382f = /*#__PURE__*/ function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
    return CommandActionType;
}({});
const $b1e48ebd4c8d5e4e$export$3e448fd53031e13c = Object.values($b1e48ebd4c8d5e4e$export$f041b1b117ab382f);
const $b1e48ebd4c8d5e4e$export$904b2a0e38a1bef3 = [
    "command-list"
];

});

parcelRegister("jiSaf", function(module, exports) {

$parcel$export(module.exports, "components", () => $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);

var $5uXOq = parcelRequire("5uXOq");

var $dOktC = parcelRequire("dOktC");

var $haBRL = parcelRequire("haBRL");

var $dE25F = parcelRequire("dE25F");

var $d4iCz = parcelRequire("d4iCz");
const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
    CommandRow: $haBRL.CommandRow,
    Name: $44cb4d9bf5d8b8a6$var$NameComponent,
    LeftIcon: (0, $5uXOq.Fragment),
    Wrapper: (0, $5uXOq.Fragment),
    Footer: $dE25F.Footer,
    Body: (0, $dOktC.CommandPaletteBody),
    Header: $d4iCz.Header
};

});
parcelRegister("dOktC", function(module, exports) {

$parcel$export(module.exports, "NoResultsContainer", () => $2bc4c9970ded9a96$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $2bc4c9970ded9a96$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $bngFq = parcelRequire("bngFq");

var $d8lE2 = parcelRequire("d8lE2");

var $gM5ou = parcelRequire("gM5ou");

var $bYCTm = parcelRequire("bYCTm");

var $38IFv = parcelRequire("38IFv");

var $cLshs = parcelRequire("cLshs");

var $4nfzy = parcelRequire("4nfzy");

var $eKTyH = parcelRequire("eKTyH");

var $5aF2z = parcelRequire("5aF2z");

var $64ZBB = parcelRequire("64ZBB");
const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $d8lE2.useCommandPalette)();
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $gM5ou.getAnalyticsAttributesFromResult)(result),
                ...(0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $gM5ou.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const localResultRefs = resultsRefs.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
        "data-testid": (0, $5aF2z.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYCTm.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
            "data-testid": (0, $5aF2z.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nfzy.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38IFv.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKTyH.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $d8lE2.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
    const resultsRefs = (0, $5uXOq.useRef)([]);
    const modalBodyRef = (0, $5uXOq.useRef)(null);
    const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $5aF2z.SCROLL_DIRECTION).END : (0, $5aF2z.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $64ZBB.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $64ZBB.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $64ZBB.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cLshs.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bc4c9970ded9a96$var$GroupContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $lD23V.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d8lE2", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $f75514d959bfcca8$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $f75514d959bfcca8$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $f75514d959bfcca8$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $f75514d959bfcca8$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteHasChildPopup", () => $f75514d959bfcca8$export$a18633b655403b12);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $f75514d959bfcca8$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $f75514d959bfcca8$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $f75514d959bfcca8$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $f75514d959bfcca8$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $f75514d959bfcca8$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $f75514d959bfcca8$export$bbc05723eb144e03);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");

var $gM5ou = parcelRequire("gM5ou");

var $2sRNe = parcelRequire("2sRNe");
const $f75514d959bfcca8$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $f75514d959bfcca8$var$store = (0, $iXqE5.createStore)({
    initialState: $f75514d959bfcca8$var$initialState,
    actions: $2sRNe.actions,
    name: 'commandPalette'
});
const $f75514d959bfcca8$export$6b58f9610017fbb7 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$72aa7bc7c6a83c36 = (0, $3sQ5x.createActionsHook)($f75514d959bfcca8$var$store);
const $f75514d959bfcca8$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $f75514d959bfcca8$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $f75514d959bfcca8$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $gM5ou.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $gM5ou.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $gM5ou.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        relevancyModel: 'v2-string-similarity'
    });
const $f75514d959bfcca8$export$1f90c8f89f98110e = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$56f06313122d0aac
});
const $f75514d959bfcca8$export$cc979be9b69236df = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$a18633b655403b12 = (0, $3sQ5x.createStateHook)($f75514d959bfcca8$var$store, {
    selector: (state)=>state.hasPopupOverlay
});
const $f75514d959bfcca8$export$af8fd8cd4b048315 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $f75514d959bfcca8$export$4372697329bd9cbe = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $f75514d959bfcca8$export$7422170a403e909 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $f75514d959bfcca8$export$282aa48e4a3afada = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $f75514d959bfcca8$export$96819dfb22ad05d3 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $f75514d959bfcca8$export$a40e8ae3e53feab0 = (0, $6dDSs.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $gM5ou.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $f75514d959bfcca8$export$f893891deedab3c6 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: $f75514d959bfcca8$export$a40e8ae3e53feab0
});
const $f75514d959bfcca8$export$bbc05723eb144e03 = (0, $3sQ5x.createHook)($f75514d959bfcca8$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("gM5ou", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $cf289af0c139712c$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $cf289af0c139712c$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $cf289af0c139712c$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $cf289af0c139712c$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $cf289af0c139712c$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $cf289af0c139712c$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $cf289af0c139712c$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $cf289af0c139712c$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $cf289af0c139712c$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $cf289af0c139712c$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $cf289af0c139712c$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $cf289af0c139712c$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $cf289af0c139712c$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $cf289af0c139712c$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $cf289af0c139712c$export$c3d20e8c1e93a572);

var $5uXOq = parcelRequire("5uXOq");

var $bdDiz = parcelRequire("bdDiz");

var $2f2jJ = parcelRequire("2f2jJ");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");
const $cf289af0c139712c$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $cf289af0c139712c$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $cf289af0c139712c$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $cf289af0c139712c$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $cf289af0c139712c$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $cf289af0c139712c$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $cf289af0c139712c$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $cf289af0c139712c$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $cf289af0c139712c$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $cf289af0c139712c$export$389b0273703d5c48(sections)
    };
};
const $cf289af0c139712c$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $cf289af0c139712c$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...$cf289af0c139712c$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands) || {},
        ...$cf289af0c139712c$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$cf289af0c139712c$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $cf289af0c139712c$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $cf289af0c139712c$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $cf289af0c139712c$export$daa5beabdf8d9fc3 = (event)=>(0, $2f2jJ.isMacOs)() ? event.metaKey : event.ctrlKey;
const $cf289af0c139712c$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $jh7L9.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $cf289af0c139712c$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $cf289af0c139712c$export$fa1c95a5ffa92036 = (str)=>(0, $bdDiz.createHash)().update(str).digest('hex');
const $cf289af0c139712c$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $cf289af0c139712c$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $cf289af0c139712c$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $cf289af0c139712c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("2f2jJ", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $6846128323867ebd$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $6846128323867ebd$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $6846128323867ebd$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $6846128323867ebd$export$fe66dae91c68619b = ()=>$6846128323867ebd$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("bcTvL", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $3996a4302dca83b1$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $3996a4302dca83b1$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $3996a4302dca83b1$export$1ee9d153576afd13);
$parcel$export(module.exports, "COMMAND_PALETTE_DEBOUNCE_DEFAULT", () => $3996a4302dca83b1$export$894e19fc96687503);
// EVENT TYPES
const $3996a4302dca83b1$export$a1562d08625f5d7e = 'UI';
const $3996a4302dca83b1$export$947dac6c72b26f81 = 'TRACK';
const $3996a4302dca83b1$export$f1d537d508d2945a = 'SCREEN';
const $3996a4302dca83b1$export$12346a674644c156 = 'OPERATIONAL';
var $3996a4302dca83b1$export$1ee9d153576afd13 = /*#__PURE__*/ function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
    return SHORTCUT_ELEMENT_TYPES;
}({});
const $3996a4302dca83b1$export$894e19fc96687503 = 250;

});


parcelRegister("2sRNe", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4f4c9e92d50d4f24$export$e324594224ef24da);

var $kGsr8 = parcelRequire("kGsr8");

var $7Jxgt = parcelRequire("7Jxgt");

var $izip4 = parcelRequire("izip4");

var $8yVxK = parcelRequire("8yVxK");

var $2f2jJ = parcelRequire("2f2jJ");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $bcTvL = parcelRequire("bcTvL");

var $jh7L9 = parcelRequire("jh7L9");

var $gM5ou = parcelRequire("gM5ou");

var $4DwnT = parcelRequire("4DwnT");

var $h3eZO = parcelRequire("h3eZO");

var $feUec = parcelRequire("feUec");
const $4f4c9e92d50d4f24$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $4f4c9e92d50d4f24$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, $7Jxgt.v4)(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $4f4c9e92d50d4f24$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$4f4c9e92d50d4f24$var$rootCommands
        });
    };
const $4f4c9e92d50d4f24$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, $7Jxgt.v4)() : '',
            ...!isOpen ? $4f4c9e92d50d4f24$var$rootCommands : {}
        });
    };
const $4f4c9e92d50d4f24$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $4f4c9e92d50d4f24$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $4f4c9e92d50d4f24$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $4f4c9e92d50d4f24$var$forceSearchValue = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            shouldForceSearchValue: true
        });
    };
const $4f4c9e92d50d4f24$var$resetShouldForceSearchValue = ()=>({ setState: setState })=>{
        setState({
            shouldForceSearchValue: false
        });
    };
const $4f4c9e92d50d4f24$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $bcTvL.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $4f4c9e92d50d4f24$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $4f4c9e92d50d4f24$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $gM5ou.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $4f4c9e92d50d4f24$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction, onAnalytics: onAnalytics } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $8yVxK.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                    if (onAnalytics && onClosePendingCommandAction?.createAnalyticsEvent) {
                        const performAnalyticsEvent = onClosePendingCommandAction?.createAnalyticsEvent({
                            action: 'taskSucceeded',
                            actionSubject: 'commandPalette'
                        });
                        onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                            attributes: onClosePendingCommandAction?.analyticsArgs
                        });
                    }
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $jcw0u.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $izip4.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $4f4c9e92d50d4f24$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $4DwnT.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $gM5ou.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $feUec.setEventAttribute)(analyticsAttributes);
        const currentCommandAction = (0, $gM5ou.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if (currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $gM5ou.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $jh7L9.CommandActionType).PERFORM;
        if (command.mode) newState.shouldForceSearchValue = true;
        if (shouldLoadChildren) {
            (0, $8yVxK.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $h3eZO.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if (currentCommandAction.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            }
            if (wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $2f2jJ.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $8yVxK.default)('command-palette-executed');
                currentCommandAction.perform();
                if (currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const performAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'taskSucceeded',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(performAnalyticsEvent, (0, $bcTvL.TRACK_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $jcw0u.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $izip4.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analyticsAttributes,
                    createAnalyticsEvent: analytics?.createAnalyticsEvent
                }
            });
        }
    };
const $4f4c9e92d50d4f24$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $4f4c9e92d50d4f24$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $4f4c9e92d50d4f24$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $4f4c9e92d50d4f24$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $4f4c9e92d50d4f24$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $4f4c9e92d50d4f24$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $4f4c9e92d50d4f24$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $4f4c9e92d50d4f24$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $4f4c9e92d50d4f24$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $4f4c9e92d50d4f24$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $4f4c9e92d50d4f24$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $4f4c9e92d50d4f24$var$setHasPopupOverlay = (hasPopupOverlay)=>({ setState: setState })=>{
        setState({
            hasPopupOverlay: hasPopupOverlay
        });
    };
const $4f4c9e92d50d4f24$export$e324594224ef24da = {
    open: $4f4c9e92d50d4f24$var$open,
    toggle: $4f4c9e92d50d4f24$var$toggle,
    close: $4f4c9e92d50d4f24$var$close,
    addCommands: $4f4c9e92d50d4f24$var$addCommands,
    removeCommands: $4f4c9e92d50d4f24$var$removeCommands,
    handleSearch: $4f4c9e92d50d4f24$var$handleSearch,
    forceFocusSearch: $4f4c9e92d50d4f24$var$forceFocusSearch,
    setActiveIndex: $4f4c9e92d50d4f24$var$setActiveIndex,
    executeCommand: $4f4c9e92d50d4f24$var$executeCommand,
    goBackLevel: $4f4c9e92d50d4f24$var$goBackLevel,
    setChildCommands: $4f4c9e92d50d4f24$var$setChildCommands,
    setLoadingList: $4f4c9e92d50d4f24$var$setLoadingList,
    setFocusInput: $4f4c9e92d50d4f24$var$setFocusInput,
    registerSections: $4f4c9e92d50d4f24$var$registerSections,
    unregisterSections: $4f4c9e92d50d4f24$var$unregisterSections,
    markAsLoaded: $4f4c9e92d50d4f24$var$markAsLoaded,
    getAnalyticsAttributes: $4f4c9e92d50d4f24$var$getAnalyticsAttributes,
    setIsDisabled: $4f4c9e92d50d4f24$var$setIsDisabled,
    setRegistry: $4f4c9e92d50d4f24$var$setRegistry,
    updateActiveRegistry: $4f4c9e92d50d4f24$var$updateActiveRegistry,
    removeCommandsById: $4f4c9e92d50d4f24$var$removeCommandsById,
    removeFromActiveRegistry: $4f4c9e92d50d4f24$var$removeFromActiveRegistry,
    performDialogCloseCommand: $4f4c9e92d50d4f24$var$performDialogCloseCommand,
    setAnalytics: $4f4c9e92d50d4f24$var$setAnalytics,
    setFallbackOverride: $4f4c9e92d50d4f24$var$setFallbackOverride,
    setHasPopupOverlay: $4f4c9e92d50d4f24$var$setHasPopupOverlay,
    forceSearchValue: $4f4c9e92d50d4f24$var$forceSearchValue,
    resetShouldForceSearchValue: $4f4c9e92d50d4f24$var$resetShouldForceSearchValue
};

});
parcelRegister("4DwnT", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b4088022dc3f5c54$export$639b7f41b0b47a01);

var $jh7L9 = parcelRequire("jh7L9");
const $b4088022dc3f5c54$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("h3eZO", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $dd5db8363c7eeda7$export$d75616d77443fe4e);

var $jh7L9 = parcelRequire("jh7L9");
const $dd5db8363c7eeda7$export$d75616d77443fe4e = (action)=>action?.type === (0, $jh7L9.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});

parcelRegister("feUec", function(module, exports) {

$parcel$export(module.exports, "setEventAttribute", () => $dd73b01c41e7185b$export$7c0a9f4caaf7cfce);

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");
const $dd73b01c41e7185b$var$ACTIONS_TO_WATCH = [
    'unassign',
    'assignToMe'
];
const $dd73b01c41e7185b$export$7c0a9f4caaf7cfce = (attributes)=>{
    if (attributes.actionCategory === 'issueActions' && typeof attributes.action === 'string' && $dd73b01c41e7185b$var$ACTIONS_TO_WATCH.includes(attributes.action)) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.ASSIGNEE_TYPE), {
        isCommandPaletteEditing: true
    });
};

});
parcelRegister("5fc53", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINK_SEARCH", () => $81f079589240b9b7$export$b144116dae474c88);
$parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", () => $81f079589240b9b7$export$bc917bc699b25f75);
$parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", () => $81f079589240b9b7$export$5f26ca419fdffbe7);
$parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", () => $81f079589240b9b7$export$ce9bfd823c7e1a6d);
$parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", () => $81f079589240b9b7$export$346b72b1f7cd6d5a);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", () => $81f079589240b9b7$export$b20fbcacd7942c2a);
$parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", () => $81f079589240b9b7$export$a2e8554bffc61ece);
$parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$f25cd4907cbb25b9);
$parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", () => $81f079589240b9b7$export$5600354b43577e17);
$parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", () => $81f079589240b9b7$export$5dbc9917f72d0d2a);
$parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$253649f07fb55948);
$parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", () => $81f079589240b9b7$export$eb39592ba5247ee7);
$parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", () => $81f079589240b9b7$export$f48a9be226105736);
$parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", () => $81f079589240b9b7$export$42e2e93fc721df5d);
$parcel$export(module.exports, "APPROVALS_PANEL_TYPE", () => $81f079589240b9b7$export$7773375e72c953ed);
$parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", () => $81f079589240b9b7$export$80ad0037098f3919);
$parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", () => $81f079589240b9b7$export$6875c7efa3a5e380);
$parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", () => $81f079589240b9b7$export$7c1a5c7d37b8f968);
$parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", () => $81f079589240b9b7$export$c5931a5d7dbfb40b);
$parcel$export(module.exports, "BOOLEAN_GQL_FIELD", () => $81f079589240b9b7$export$c979d9c548c05133);
$parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ff25e7412c4ae9c7);
$parcel$export(module.exports, "CHECKBOX_GQL_FIELD", () => $81f079589240b9b7$export$16dbdf57e34e8d63);
$parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$1bf8bec92e6e84df);
$parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", () => $81f079589240b9b7$export$c32f5d822fe5ea95);
$parcel$export(module.exports, "CMDB_GQL_FIELD", () => $81f079589240b9b7$export$b0deb225eed90fbd);
$parcel$export(module.exports, "COLOR_GQL_FIELD", () => $81f079589240b9b7$export$add3775cfea8fde3);
$parcel$export(module.exports, "COMPONENTS_GQL_FIELD", () => $81f079589240b9b7$export$9631d4098abab3eb);
$parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$ee42bc16c09ee564);
$parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$fbcebbdce821f712);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$41dd2eb1f33d3042);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$f4e3e72a3be84e5b);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$d6738c8a6d1a735d);
$parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$79a75502a3f0c4c4);
$parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$ed2eabcf0931df31);
$parcel$export(module.exports, "DATE_TIME_GQL_FIELD", () => $81f079589240b9b7$export$1f17904e959f2f0b);
$parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", () => $81f079589240b9b7$export$6d8da4497234455);
$parcel$export(module.exports, "FLAG_GQL_FIELD", () => $81f079589240b9b7$export$9bcfac568e4fa59c);
$parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", () => $81f079589240b9b7$export$dd84cd6c957c6f5e);
$parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5cc7c39d7d1cf6d5);
$parcel$export(module.exports, "LABEL_GQL_FIELD", () => $81f079589240b9b7$export$810709f0c5c2e9db);
$parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$82cb6735134c23a2);
$parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$85e04e9a3a81ee1);
$parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", () => $81f079589240b9b7$export$24c916a8a33ed20c);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$c049920d930c3b8a);
$parcel$export(module.exports, "NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$3b6d7fc1833bf7da);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", () => $81f079589240b9b7$export$bd3e2fe853319c13);
$parcel$export(module.exports, "PARENT_GQL_FIELD", () => $81f079589240b9b7$export$6dfd3fc78bc751a0);
$parcel$export(module.exports, "PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$31aea7548807c6b5);
$parcel$export(module.exports, "PRIORITY_GQL_FIELD", () => $81f079589240b9b7$export$e89fbbf3983c0219);
$parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", () => $81f079589240b9b7$export$f5e2fb1022ff7912);
$parcel$export(module.exports, "PROJECT_GQL_FIELD", () => $81f079589240b9b7$export$12f54499c6252188);
$parcel$export(module.exports, "RADIO_GQL_FIELD", () => $81f079589240b9b7$export$8e4293d806f435e0);
$parcel$export(module.exports, "REPORTER_GQL_FIELD", () => $81f079589240b9b7$export$c69486dd643dfb69);
$parcel$export(module.exports, "RESOLUTION_GQL_FIELD", () => $81f079589240b9b7$export$1e4faa0d6dc58a81);
$parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", () => $81f079589240b9b7$export$37f4daaa7b409554);
$parcel$export(module.exports, "SECURITY_GQL_FIELD", () => $81f079589240b9b7$export$ca57cccd6d7bf97c);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$bea889616fd5bdab);
$parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", () => $81f079589240b9b7$export$ab5cecc580898d1c);
$parcel$export(module.exports, "SPRINT_GQL_FIELD", () => $81f079589240b9b7$export$bb63813d13e8eaf7);
$parcel$export(module.exports, "STATUS_GQL_FIELD", () => $81f079589240b9b7$export$e40f819979b3881d);
$parcel$export(module.exports, "TEAM_GQL_FIELD", () => $81f079589240b9b7$export$6c243704a22baffe);
$parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", () => $81f079589240b9b7$export$6c32429bac235203);
$parcel$export(module.exports, "TEXT_GQL_FIELD", () => $81f079589240b9b7$export$61b514b470cbbf07);
$parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", () => $81f079589240b9b7$export$e4bcb1729da5683);
$parcel$export(module.exports, "URL_GQL_FIELD", () => $81f079589240b9b7$export$37ccd11f08a93ccb);
$parcel$export(module.exports, "USER_PICKER_GQL_FIELD", () => $81f079589240b9b7$export$abf1bf8c1106ba7d);
$parcel$export(module.exports, "VERSION_GQL_FIELD", () => $81f079589240b9b7$export$b55604041ae7179e);
$parcel$export(module.exports, "VOTES_GQL_FIELD", () => $81f079589240b9b7$export$c8bf66d62e74cdd2);
$parcel$export(module.exports, "WATCHES_GQL_FIELD", () => $81f079589240b9b7$export$aa815aaa741ae18);
$parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", () => $81f079589240b9b7$export$e805f89b15d2abf4);
$parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", () => $81f079589240b9b7$export$5bfd36acd96f04c2);
$parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$695423a2bc8a9ac4);
$parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", () => $81f079589240b9b7$export$d29b0ba0d80bc129);
$parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", () => $81f079589240b9b7$export$ac6c7b30703608d6);
$parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", () => $81f079589240b9b7$export$478b546dccd33e1e);
$parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", () => $81f079589240b9b7$export$f90c042e9eb983e7);
$parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", () => $81f079589240b9b7$export$753ca4fb34ff3f2b);
$parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", () => $81f079589240b9b7$export$b7aed9efb4a9154b);
$parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", () => $81f079589240b9b7$export$1763713d718f7ef0);
$parcel$export(module.exports, "FORGE_USER_GQL_FIELD", () => $81f079589240b9b7$export$ebb0caa2a98dcf9e);
$parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", () => $81f079589240b9b7$export$671131ba12d94144);
$parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", () => $81f079589240b9b7$export$c48132adab502d6b);
$parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", () => $81f079589240b9b7$export$6cd83226f31c7072);
$parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$7de726bd6d97a9a7);
$parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", () => $81f079589240b9b7$export$8e4b538f77340a05);
$parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", () => $81f079589240b9b7$export$10ba8c0d74470907);
$parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", () => $81f079589240b9b7$export$1756bb4eff1cc3c6);
$parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", () => $81f079589240b9b7$export$5876b4be3c4407b);
$parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", () => $81f079589240b9b7$export$e7fe49e6f36c7154);
$parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", () => $81f079589240b9b7$export$aeed3395a6bca18b);
$parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", () => $81f079589240b9b7$export$9b725a1eafd02e4f);
$parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", () => $81f079589240b9b7$export$699805cbca2c41d);
$parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", () => $81f079589240b9b7$export$f658d5c0f0b5dbc2);
$parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", () => $81f079589240b9b7$export$e469bcb2060000af);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $81f079589240b9b7$export$f10e53e8928b61bd);
$parcel$export(module.exports, "GOALS_GQL_FIELD", () => $81f079589240b9b7$export$bfcb1a91094f113a);
$parcel$export(module.exports, "DURATION_GQL_FIELD", () => $81f079589240b9b7$export$db0bd6c04eb7d04a);
$parcel$export(module.exports, "JCS_ORGANIZATION_GQL_FIELD", () => $81f079589240b9b7$export$7fe9e7bac5a59952);
$parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", () => $81f079589240b9b7$export$798d2f5814884447);
$parcel$export(module.exports, "FORGE_STRING_TYPE", () => $81f079589240b9b7$export$1e188101081be3f8);
$parcel$export(module.exports, "FORGE_STRING_LIST_TYPE", () => $81f079589240b9b7$export$caf3b3f20c0589b9);
$parcel$export(module.exports, "FORGE_NUMBER_TYPE", () => $81f079589240b9b7$export$9bdf08a1276e866c);
$parcel$export(module.exports, "FORGE_DATE_TYPE", () => $81f079589240b9b7$export$996c3d3eb2880229);
$parcel$export(module.exports, "FORGE_DATETIME_TYPE", () => $81f079589240b9b7$export$578c5856bf684e2a);
$parcel$export(module.exports, "FORGE_USER_TYPE", () => $81f079589240b9b7$export$38791c0fdd0bcce);
$parcel$export(module.exports, "FORGE_USER_LIST_TYPE", () => $81f079589240b9b7$export$5c209e1debd6c274);
$parcel$export(module.exports, "FORGE_GROUP_TYPE", () => $81f079589240b9b7$export$8646fecba9a8be61);
$parcel$export(module.exports, "FORGE_GROUP_LIST_TYPE", () => $81f079589240b9b7$export$68b91cd2f2e6b810);
$parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", () => $81f079589240b9b7$export$269d70c1b1c9fb80);
$parcel$export(module.exports, "APPROVALS_CF_TYPE", () => $81f079589240b9b7$export$f0f17ef462331df4);
$parcel$export(module.exports, "CATEGORY_TYPE", () => $81f079589240b9b7$export$3c7d8923295a5199);
$parcel$export(module.exports, "PEOPLE_CF_TYPE", () => $81f079589240b9b7$export$fb431e758c9252df);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $81f079589240b9b7$export$c7faa96db185cfc6);
$parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", () => $81f079589240b9b7$export$492b0fa4fe201a22);
$parcel$export(module.exports, "URL_CF_TYPE", () => $81f079589240b9b7$export$60f0bd6e4b582fe6);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $81f079589240b9b7$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $81f079589240b9b7$export$39cd48613b53ce2f);
$parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", () => $81f079589240b9b7$export$977db5973ce73e44);
$parcel$export(module.exports, "LABELS_CF_TYPE", () => $81f079589240b9b7$export$ad4eb83f78528e13);
$parcel$export(module.exports, "DATE_CF_TYPE", () => $81f079589240b9b7$export$ff745f432984005d);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $81f079589240b9b7$export$42d097f7b1622ef1);
$parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", () => $81f079589240b9b7$export$65524be5675e57e6);
$parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", () => $81f079589240b9b7$export$5280e5501a801dc0);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c5d13ea26562d57a);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $81f079589240b9b7$export$22ac48a51c014e4b);
$parcel$export(module.exports, "EPIC_STATUS_TYPE", () => $81f079589240b9b7$export$6769c2c97b828e11);
$parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", () => $81f079589240b9b7$export$39866626496bbfc8);
$parcel$export(module.exports, "VERSION_CF_TYPE", () => $81f079589240b9b7$export$24382b4e8c58336b);
$parcel$export(module.exports, "GROUP_CF_TYPE", () => $81f079589240b9b7$export$b075907882e80160);
$parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", () => $81f079589240b9b7$export$b600addfa3355c57);
$parcel$export(module.exports, "USER_CF_TYPE", () => $81f079589240b9b7$export$c491a4b98394028e);
$parcel$export(module.exports, "MULTI_USER_CF_TYPE", () => $81f079589240b9b7$export$5365f2d3fac5261a);
$parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$cc8ffff49170b0f4);
$parcel$export(module.exports, "FLAGGED_CF_TYPE", () => $81f079589240b9b7$export$b7178f601d7373f9);
$parcel$export(module.exports, "TEAM_CF_TYPE", () => $81f079589240b9b7$export$eb1f1dca13a0f02d);
$parcel$export(module.exports, "PARENT_CF_TYPE", () => $81f079589240b9b7$export$3e71e11f80203acb);
$parcel$export(module.exports, "BASELINE_START_CF_TYPE", () => $81f079589240b9b7$export$d10d66823a65e688);
$parcel$export(module.exports, "BASELINE_END_CF_TYPE", () => $81f079589240b9b7$export$dfc6da4a9963d5dc);
$parcel$export(module.exports, "COLOR_CF_TYPE", () => $81f079589240b9b7$export$b4a1fbc1cf0059cf);
$parcel$export(module.exports, "EPIC_COLOR_TYPE", () => $81f079589240b9b7$export$4838a8a8d62a64fd);
$parcel$export(module.exports, "ASSETS_CF_TYPE", () => $81f079589240b9b7$export$ed2de20ab8b7ad3d);
$parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", () => $81f079589240b9b7$export$b755e97dbfa92610);
$parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", () => $81f079589240b9b7$export$1be1ecd4dfc06fab);
$parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", () => $81f079589240b9b7$export$34317c2d84a93553);
$parcel$export(module.exports, "ORGANIZATION_CF_TYPE", () => $81f079589240b9b7$export$c1e26582406f77ec);
$parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", () => $81f079589240b9b7$export$555b4f35f98a3210);
$parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", () => $81f079589240b9b7$export$1f2859a3ef701a14);
$parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", () => $81f079589240b9b7$export$68f62eb762e4157f);
$parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", () => $81f079589240b9b7$export$6da975fce1fbd38e);
$parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", () => $81f079589240b9b7$export$c6dd874aae21e51f);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $81f079589240b9b7$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "RANK_CF_TYPE", () => $81f079589240b9b7$export$af89c0396aaf23e3);
$parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", () => $81f079589240b9b7$export$3b5a62bb34372404);
$parcel$export(module.exports, "READ_ONLY_CF_TYPE", () => $81f079589240b9b7$export$247829aef464243f);
$parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", () => $81f079589240b9b7$export$65a6076c0927d413);
$parcel$export(module.exports, "RESPONDERS_CF_TYPE", () => $81f079589240b9b7$export$bcf83e1d934501c9);
$parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", () => $81f079589240b9b7$export$ae0eeec12e90a01e);
$parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", () => $81f079589240b9b7$export$c23f6b40da18371a);
$parcel$export(module.exports, "SENTIMENT_CF_TYPE", () => $81f079589240b9b7$export$c23cfbdf83daa90d);
$parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", () => $81f079589240b9b7$export$21dda64db57e4883);
$parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", () => $81f079589240b9b7$export$45700f3bf92a003a);
$parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", () => $81f079589240b9b7$export$2d75b47d12efc812);
$parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", () => $81f079589240b9b7$export$7b79405842547ccb);
$parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", () => $81f079589240b9b7$export$96201d0ae03ca323);
$parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", () => $81f079589240b9b7$export$fc276d6ccf118a14);
$parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", () => $81f079589240b9b7$export$8b0718167d092603);
$parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", () => $81f079589240b9b7$export$904b40dd2afd17a2);
$parcel$export(module.exports, "GOALS_CF_TYPE", () => $81f079589240b9b7$export$2bbb7f69c97ea279);
$parcel$export(module.exports, "ASSIGNEE_TYPE", () => $81f079589240b9b7$export$fba8634fd401ba8b);
$parcel$export(module.exports, "REPORTER_TYPE", () => $81f079589240b9b7$export$a91aea2438afcce8);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $81f079589240b9b7$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $81f079589240b9b7$export$34740f8d07d23ac0);
$parcel$export(module.exports, "LABELS_TYPE", () => $81f079589240b9b7$export$43b6e33ec70f2272);
$parcel$export(module.exports, "CREATED", () => $81f079589240b9b7$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $81f079589240b9b7$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "RESOLUTION_DATE", () => $81f079589240b9b7$export$6a052efb0b4ec5d2);
$parcel$export(module.exports, "COMPONENTS_TYPE", () => $81f079589240b9b7$export$37abf56f13f61ec5);
$parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", () => $81f079589240b9b7$export$aef0c22aecd16996);
$parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", () => $81f079589240b9b7$export$cff5b6d1e7135679);
$parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", () => $81f079589240b9b7$export$791007408faf42f4);
$parcel$export(module.exports, "DEV_SUMMARY_TYPE", () => $81f079589240b9b7$export$827a1c600bac12a3);
$parcel$export(module.exports, "RELEASES_TYPE", () => $81f079589240b9b7$export$e9ba671d077969f8);
$parcel$export(module.exports, "SPRINT_TYPE", () => $81f079589240b9b7$export$3d37701ba6fb68ec);
$parcel$export(module.exports, "STORY_POINTS_TYPE", () => $81f079589240b9b7$export$36fd22f47020f37b);
$parcel$export(module.exports, "EPIC_TYPE", () => $81f079589240b9b7$export$9f2fedcd916d2a79);
$parcel$export(module.exports, "EPIC_NAME_TYPE", () => $81f079589240b9b7$export$dfc63737b8c0150d);
$parcel$export(module.exports, "FIX_VERSIONS_TYPE", () => $81f079589240b9b7$export$a5c9f63aadcb220);
$parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", () => $81f079589240b9b7$export$94009605902e4fe5);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $81f079589240b9b7$export$5e7324042f1d6b31);
$parcel$export(module.exports, "ENVIRONMENT_TYPE", () => $81f079589240b9b7$export$113281d03e6830ef);
$parcel$export(module.exports, "WATCHES_TYPE", () => $81f079589240b9b7$export$5ff798870a3dffbf);
$parcel$export(module.exports, "SUMMARY_TYPE", () => $81f079589240b9b7$export$907219511d14ba3d);
$parcel$export(module.exports, "PROFORMA_FORMS", () => $81f079589240b9b7$export$d09aa6a4f3538063);
$parcel$export(module.exports, "RESOLUTION_TYPE", () => $81f079589240b9b7$export$3aca8c91b58a42e2);
$parcel$export(module.exports, "TIME_TRACKING_TYPE", () => $81f079589240b9b7$export$ccb5ffefbf8b987c);
$parcel$export(module.exports, "TIME_ESTIMATE_TYPE", () => $81f079589240b9b7$export$c8bedad98a5e7f5f);
$parcel$export(module.exports, "STATUS_TYPE", () => $81f079589240b9b7$export$358267065be1e);
$parcel$export(module.exports, "STATUS_CATEGORY_TYPE", () => $81f079589240b9b7$export$dcaa788c7ada56de);
$parcel$export(module.exports, "ISSUE_TYPE", () => $81f079589240b9b7$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_KEY_TYPE", () => $81f079589240b9b7$export$5e91047fe9955d0e);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $81f079589240b9b7$export$3b3d0889022c85b3);
$parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$335851d83a79891);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", () => $81f079589240b9b7$export$7b76bbcb87d41695);
$parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$297b67ac63f09f72);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", () => $81f079589240b9b7$export$ae87161126086be);
$parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$6a88420fc2f6901d);
$parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", () => $81f079589240b9b7$export$ef1a0421bd42c0e4);
$parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", () => $81f079589240b9b7$export$dd695c8c5ab62f9d);
$parcel$export(module.exports, "SLA_PANEL_TYPE", () => $81f079589240b9b7$export$7b3d247435a784fa);
$parcel$export(module.exports, "LINKED_ALERTS_TYPE", () => $81f079589240b9b7$export$17b7080ed1fe8cfd);
$parcel$export(module.exports, "CHAT_CHANNEL_TYPE", () => $81f079589240b9b7$export$29fe745131dad7ba);
$parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", () => $81f079589240b9b7$export$9c245100c3091ec3);
$parcel$export(module.exports, "ZOOM_MEETING_TYPE", () => $81f079589240b9b7$export$51eb15cea47a37ba);
$parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", () => $81f079589240b9b7$export$c7ae0622b0bd5d56);
$parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", () => $81f079589240b9b7$export$b5358afda8ff335e);
$parcel$export(module.exports, "JOURNEY_PANEL_TYPE", () => $81f079589240b9b7$export$d2a475ff30e5bf97);
$parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", () => $81f079589240b9b7$export$63cf6f392da16c25);
$parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", () => $81f079589240b9b7$export$22f61ccc2730431f);
$parcel$export(module.exports, "SUBTASKS_TYPE", () => $81f079589240b9b7$export$8bbb446f57294715);
$parcel$export(module.exports, "VOTES_TYPE", () => $81f079589240b9b7$export$34fcd7cb291a1e4d);
$parcel$export(module.exports, "PARENT_TYPE", () => $81f079589240b9b7$export$5e93f2a57cc4ca3a);
$parcel$export(module.exports, "PROJECT_TYPE", () => $81f079589240b9b7$export$91a9dba2d38d9a6f);
$parcel$export(module.exports, "TIME_SPENT_TYPE", () => $81f079589240b9b7$export$ede0a4c20124ec85);
$parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", () => $81f079589240b9b7$export$3eeb79d48fb5f667);
$parcel$export(module.exports, "SENTIMENT_TYPE", () => $81f079589240b9b7$export$45e72c9a63ab61ab);
$parcel$export(module.exports, "DETAILS_PANEL_IN_EDIT_MODE", () => $81f079589240b9b7$export$f4909db381566ce3);
$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $81f079589240b9b7$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $81f079589240b9b7$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $81f079589240b9b7$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", () => $81f079589240b9b7$export$84e5674890d55030);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE", () => $81f079589240b9b7$export$326a5522a485e43d);
$parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", () => $81f079589240b9b7$export$c9f3f01e2c535302);
$parcel$export(module.exports, "TEAM_TYPE", () => $81f079589240b9b7$export$66519f3bbff1796a);
$parcel$export(module.exports, "ESTIMATE_TYPE", () => $81f079589240b9b7$export$a4ee0bca77cc8463);
$parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", () => $81f079589240b9b7$export$fed53408e89e0497);
$parcel$export(module.exports, "TARGET_START_TYPE", () => $81f079589240b9b7$export$d53c26f9ce31f56b);
$parcel$export(module.exports, "TARGET_END_TYPE", () => $81f079589240b9b7$export$48f82d653f85e459);
$parcel$export(module.exports, "START_DATE_TYPE", () => $81f079589240b9b7$export$ea5a888f39f722c7);
$parcel$export(module.exports, "COLOR_TYPE", () => $81f079589240b9b7$export$f245bbec12cc0e40);
$parcel$export(module.exports, "ATTACHMENT_TYPE", () => $81f079589240b9b7$export$aed630b4b7114a59);
$parcel$export(module.exports, "ISSUE_LINKS_TYPE", () => $81f079589240b9b7$export$b50c1a8fef07104);
$parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", () => $81f079589240b9b7$export$ea3d72f4bb7738ba);
$parcel$export(module.exports, "COMMENT_TYPE", () => $81f079589240b9b7$export$a4cab0124760d860);
$parcel$export(module.exports, "WORK_LOG_TYPE", () => $81f079589240b9b7$export$734929aef118d7e2);
$parcel$export(module.exports, "PARENT_FIELD_TYPE", () => $81f079589240b9b7$export$ffbacacb07c1d46d);
$parcel$export(module.exports, "getLayoutFieldTypes", () => $81f079589240b9b7$export$3c3e26aadbfa2c32);

var $8QpSo = parcelRequire("8QpSo");

var $4R6GH = parcelRequire("4R6GH");
const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option'; // graphql currently returns this type
const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
const $81f079589240b9b7$export$5600354b43577e17 = 'user';
const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
const $81f079589240b9b7$export$253649f07fb55948 = 'object';
const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
const $81f079589240b9b7$export$82db8a26de491dd2 = 'array';
const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
const $81f079589240b9b7$export$7fe9e7bac5a59952 = 'JiraCustomerServiceOrganizationField';
const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
const $81f079589240b9b7$export$1e188101081be3f8 = 'forge/string';
const $81f079589240b9b7$export$caf3b3f20c0589b9 = 'forge/string-list';
const $81f079589240b9b7$export$9bdf08a1276e866c = 'forge/number';
const $81f079589240b9b7$export$996c3d3eb2880229 = 'forge/date';
const $81f079589240b9b7$export$578c5856bf684e2a = 'forge/datetime';
const $81f079589240b9b7$export$38791c0fdd0bcce = 'forge/user';
const $81f079589240b9b7$export$5c209e1debd6c274 = 'forge/user-list';
const $81f079589240b9b7$export$8646fecba9a8be61 = 'forge/group';
const $81f079589240b9b7$export$68b91cd2f2e6b810 = 'forge/group-list';
const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
const $81f079589240b9b7$export$358267065be1e = 'status';
const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
const $81f079589240b9b7$export$d2a475ff30e5bf97 = 'JOURNEY_PANEL';
const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue'; // Remove on FD-30157 clean-up
const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
const $81f079589240b9b7$export$f4909db381566ce3 = 'DETAILS_PANEL_IN_EDIT_MODE';
const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
const $81f079589240b9b7$export$326a5522a485e43d = 'security';
const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
/**
 * Fields shown in the issue layout
 *
 * Cannot declare as simple object - in case there is a FF in getLayoutItemMap() (which happens when we add a new field), because we cannot get FF value in SSR.
 * Memoization is needed not to rerender too many times.
 */ const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
    const types = {
        ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
        DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
        PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
        REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
        DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
        LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
        COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
        SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
        STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
        TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
        FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
        AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
        TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
        TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
        ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
        DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
        APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
        KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
        SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
        LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
        CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
        MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
        ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
        MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
        ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
        RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
        MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
        COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
        EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
        RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
        BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
        BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
        LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
        TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
        MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
        PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
        URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
        NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
        STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
        SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
        EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
        MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
        ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
        FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
        ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
        ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
        ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
        FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
        TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
        MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
        VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
        DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
        GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
        MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
        USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
        DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
        MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
        RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
        TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
        ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
        ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
        ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
        ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
        ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
        REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
        SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
        REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
        ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
        REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
        PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
        REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
        ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
        APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
        CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
        PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
        CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
        READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
        MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
        MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
        EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
        ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
        CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
        ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
        GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
        PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a,
        FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e,
        SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
    };
    Object.assign(types, {
        SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
    });
    if ((0, $4R6GH.fg)('jsm-journey-builder-in-issue-view')) Object.assign(types, {
        JOURNEY_PANEL_TYPE: $81f079589240b9b7$export$d2a475ff30e5bf97
    });
    return types;
};
const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, $8QpSo.default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);

});

parcelRegister("ctrpc", function(module, exports) {

$parcel$export(module.exports, "eventFlowManager", () => $a32e213c0a4381f7$export$87846400a9b428fc);
$parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", () => $a32e213c0a4381f7$export$f3b2b77402b2631f);

var $7Jxgt = parcelRequire("7Jxgt");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8ikZj = parcelRequire("8ikZj");

var $bximr = parcelRequire("bximr");
/**
 * A singleton class to provide a sessionId to track update of fields
 */ class $a32e213c0a4381f7$var$EventFlowManager {
    reset() {
        this.ids.clear();
        this.extraAttributes.clear();
    }
    push(key) {
        const id = (0, $7Jxgt.v4)();
        this.ids.set(key, id);
        return id;
    }
    pull(key, shouldDelete = true) {
        const value = this.ids.get(key);
        if (shouldDelete) this.ids.delete(key);
        return value;
    }
    constructor(){
        this.ids = new Map();
        this.extraAttributes = new Map();
    }
}
const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
/**
 * Concatenates updateSessionId, default attributes and the attributes sent through
 *  the event and/or setAttributes
 */ const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
    let fieldTypeValue = attributes.fieldType;
    const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
    const FIELD_TYPE_MAP = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $8ikZj.FIELD_TYPE_MAP) : (0, $8ikZj.FIELD_TYPE_MAP_OLD);
    const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
    return {
        updateSessionId: updateSessionId,
        ...(0, $8ikZj.DEFAULT_ATTRIBUTES),
        ...attributes,
        ...extraAttributes,
        fieldKey: fieldKey,
        fieldType: fieldType
    };
};
const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
/**
 * Provides three events START {@link fireAnalyticsStart},
 * END {@link fireAnalyticsEnd} to track the user flow when updating
 * a field and setAttributes{@link setAttributes} to set specific
 * fields attributes
 */ const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
    fireAnalyticsStart (fieldKey, params) {
        try {
            const { assigneeId: assigneeId, product: product } = (0, $bximr.getContextAssigneeIdAndProduct)(params.analytics.context);
            if (product === 'serviceDesk') return;
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...params.attributes
            });
            assigneeId && $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                assigneeId: assigneeId
            });
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
            const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireUIAnalytics)(params.analytics, `${(0, $8ikZj.START_ACTION_SUBJECT)} ${(0, $8ikZj.START_ACTION)}`, (0, $8ikZj.START_ACTION_SUBJECT_ID), attributes);
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
        try {
            if ((0, $bximr.getContextProduct)(params.analytics.context) === 'serviceDesk') return;
            const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
            const isFieldKeyUnknown = (0, $8ikZj.UNKNOWN_FIELD_IDS).includes(fieldKey) && (0, $4R6GH.fg)('one_event_rules_them_all_fg');
            const actualFieldKey = isFieldKeyUnknown && params.attributes.fieldKey && typeof params.attributes.fieldKey === 'string' ? params.attributes.fieldKey : fieldKey;
            const attributes = $a32e213c0a4381f7$var$concatAttributes(actualFieldKey, sessionid, params.attributes);
            if (isEndOfSession) {
                if (isFieldKeyUnknown) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(actualFieldKey);
            }
            if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) attributes.isIssueViewEditing = !attributes.isCommandPaletteEditing && !attributes.isContextMenuEditing && !attributes.isDragEditing && !attributes.isInlineEditing;
            (0, $8zOmE.fireTrackAnalytics)(params.analytics, `${(0, $8ikZj.END_ACTION_SUBJECT)} ${(0, $8ikZj.END_ACTION)}`, (0, $8ikZj.END_ACTION_SUBJECT_ID), {
                ...attributes,
                ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
                    is_new_1event: true
                }
            });
        } catch (e) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
        }
    },
    setAttributes (fieldKey, attributes) {
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const currentAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, {
                ...currentAttributes,
                ...attributes
            });
        } else $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
    },
    setActionTakenAttributes (fieldKey, oldValId, newValId) {
        if (oldValId !== newValId) this.setAttributes(fieldKey, {
            oldValId: oldValId,
            newValId: newValId,
            actionTaken: (0, $bximr.getActionTaken)(oldValId, newValId)
        });
    },
    // Use this to clean up session without firing analytics event. This happens for entity fields when
    // multiple end events can be fired after a start event
    endSession (fieldKey) {
        $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
        $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
    },
    reset () {
        $a32e213c0a4381f7$export$87846400a9b428fc.reset();
    }
};
const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;

});
parcelRegister("8ikZj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ATTRIBUTES", () => $ba1d12fd09beb370$export$69665899d8392309);
$parcel$export(module.exports, "START_ACTION", () => $ba1d12fd09beb370$export$c0a4673e0c78e972);
$parcel$export(module.exports, "START_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$34a5ae354a38cc7e);
$parcel$export(module.exports, "START_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$bc373f59492dc6e2);
$parcel$export(module.exports, "END_ACTION", () => $ba1d12fd09beb370$export$b19686c1fe99f85a);
$parcel$export(module.exports, "END_ACTION_SUBJECT", () => $ba1d12fd09beb370$export$4ce67e80878d47ed);
$parcel$export(module.exports, "END_ACTION_SUBJECT_ID", () => $ba1d12fd09beb370$export$e3d957ccc2d46469);
$parcel$export(module.exports, "ACTION_TAKEN_ADD", () => $ba1d12fd09beb370$export$3b3e3ac6d7f6e219);
$parcel$export(module.exports, "ACTION_TAKEN_REMOVE", () => $ba1d12fd09beb370$export$6137e1b2fcde2333);
$parcel$export(module.exports, "DRAG_DROP_UNKNOWN_FIELD_ID", () => $ba1d12fd09beb370$export$6d8c364f9d389764);
$parcel$export(module.exports, "UNKNOWN_FIELD_IDS", () => $ba1d12fd09beb370$export$7d1d20ff891eeb26);
$parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", () => $ba1d12fd09beb370$export$403ea87111529de);
$parcel$export(module.exports, "FIELD_TYPE_MAP", () => $ba1d12fd09beb370$export$d8ccf495ccc97a69);
$parcel$export(module.exports, "ENTITY_FIELD_KEYS", () => $ba1d12fd09beb370$export$7d9dd31e187cb2db);

var $5fc53 = parcelRequire("5fc53");
const $ba1d12fd09beb370$export$69665899d8392309 = {
    isInlineEditing: false,
    isCommandPaletteEditing: false,
    isDragEditing: false,
    isContextMenuEditing: false,
    isIssueViewEditing: false
};
const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
const $ba1d12fd09beb370$export$3b3e3ac6d7f6e219 = 'add';
const $ba1d12fd09beb370$export$6137e1b2fcde2333 = 'remove';
const $ba1d12fd09beb370$export$6d8c364f9d389764 = 'unknown';
const $ba1d12fd09beb370$export$7d1d20ff891eeb26 = [
    $ba1d12fd09beb370$export$6d8c364f9d389764
];
const $ba1d12fd09beb370$export$403ea87111529de = {
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'versions',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'versions',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.SPRINT_TYPE)]: 'link',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup'
};
const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
    [(0, $5fc53.AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
    [(0, $5fc53.ASSIGNEE_TYPE)]: 'singleUserPicker',
    [(0, $5fc53.ATTACHMENT_TYPE)]: 'attachment',
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
    [(0, $5fc53.COMPONENTS_TYPE)]: 'components',
    [(0, $5fc53.DATE_CF_TYPE)]: 'date',
    [(0, $5fc53.DATETIME_CF_TYPE)]: 'dateTime',
    [(0, $5fc53.DESCRIPTION_TYPE)]: 'richText',
    [(0, $5fc53.DUE_DATE_TYPE)]: 'date',
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: 'fixVersions',
    [(0, $5fc53.FLAGGED_CF_TYPE)]: 'flag',
    [(0, $5fc53.GOALS_CF_TYPE)]: 'goals',
    [(0, $5fc53.GROUP_CF_TYPE)]: 'singleGroup',
    [(0, $5fc53.ISSUE_TYPE)]: 'issuetype',
    [(0, $5fc53.LABELS_CF_TYPE)]: 'labels',
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: 'multiGroup',
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: 'multiSelect',
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: 'multiVersion',
    [(0, $5fc53.NUMBER_CF_TYPE)]: 'float',
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: 'organizations',
    [(0, $5fc53.PARENT_TYPE)]: 'parent',
    [(0, $5fc53.PEOPLE_CF_TYPE)]: 'multiUser',
    [(0, $5fc53.PRIORITY_TYPE)]: 'priority',
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: 'project',
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: 'radio',
    [(0, $5fc53.RANK_CF_TYPE)]: 'rank',
    [(0, $5fc53.START_DATE_TYPE)]: 'date',
    [(0, $5fc53.SELECT_CF_TYPE)]: 'singleSelect',
    [(0, $5fc53.SPRINT_TYPE)]: 'sprint',
    [(0, $5fc53.STATUS_TYPE)]: 'status',
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.STORY_POINTS_TYPE)]: 'storyPointEstimate',
    [(0, $5fc53.SUMMARY_TYPE)]: 'singleLineText',
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: 'team',
    [(0, $5fc53.TEXT_AREA_CF_TYPE)]: 'richText',
    [(0, $5fc53.TEXT_CF_TYPE)]: 'singleLineText',
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
    [(0, $5fc53.TIME_TRACKING_TYPE)]: 'timeTracking',
    [(0, $5fc53.URL_CF_TYPE)]: 'url',
    [(0, $5fc53.USER_CF_TYPE)]: 'singleUser',
    [(0, $5fc53.VERSION_CF_TYPE)]: 'version',
    [(0, $5fc53.VOTES_TYPE)]: 'votes',
    [(0, $5fc53.WATCHES_TYPE)]: 'watchers'
};
const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
    WEB_LINK: 'weblink',
    ATTACHMENT: 'attachment',
    ISSUE_LINKS: 'linkIssue',
    PARENT: 'parent'
};

});

parcelRegister("bximr", function(module, exports) {

$parcel$export(module.exports, "getActionTaken", () => $440267fcdb63291a$export$9d814e3464362b48);
$parcel$export(module.exports, "getContextAssigneeIdAndProduct", () => $440267fcdb63291a$export$e6dd41ec8f1794f6);
$parcel$export(module.exports, "getContextProduct", () => $440267fcdb63291a$export$4cb0aa9574634a48);

var $8ikZj = parcelRequire("8ikZj");
const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
    if (oldValId !== newValId) {
        if (newValId === null) return 0, $8ikZj.ACTION_TAKEN_REMOVE;
        if (oldValId === null || oldValId === undefined) return 0, $8ikZj.ACTION_TAKEN_ADD;
    }
    return undefined;
};
const $440267fcdb63291a$export$e6dd41ec8f1794f6 = (context)=>{
    let assigneeId;
    let product;
    for (const item of context){
        if (item?.attributes?.assigneeId) assigneeId = item.attributes.assigneeId;
        if (item?.attributes?.previousSubProduct) product = item.attributes.previousSubProduct;
        if (assigneeId && product) break;
    }
    return {
        assigneeId: assigneeId,
        product: product
    };
};
const $440267fcdb63291a$export$4cb0aa9574634a48 = (context)=>{
    for (const item of context){
        if (item?.attributes?.previousSubProduct) return item.attributes.previousSubProduct;
    }
};

});





parcelRegister("bYCTm", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $85a6ab23a77e1ea6$export$591c26128e5fd757);

var $5uXOq = parcelRequire("5uXOq");

const $85a6ab23a77e1ea6$export$591c26128e5fd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("38IFv", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $9082b0edc4f10018$export$1f8fa9d1eef77b32);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $9gNeg = parcelRequire("9gNeg");
const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        "aria-current": active,
        role: "menuitem",
        id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
        ...(0, $4R6GH.fg)('a11y_enghealth_fixes_deliveroo') && {
            'aria-label': formatMessage((0, $9gNeg.messages).resultListItemAriaLabel)
        },
        ...rest
    });
});

});
parcelRegister("9gNeg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37963fcec28f3d0a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37963fcec28f3d0a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("cLshs", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $42c35fc284860d36$export$95554f6fb39a83c2);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $koVbs = parcelRequire("koVbs");


var $zfug2 = parcelRequire("zfug2");

var $6LGvc = parcelRequire("6LGvc");
const $42c35fc284860d36$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const resizerRef = (0, $5uXOq.useRef)(null);
    const height = (0, $6LGvc.useSmoothExpand)(resizerRef);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $42c35fc284860d36$var$wrapperStyles,
        testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
        id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : 'menu',
        ref: ref,
        "aria-label": formatMessage((0, $zfug2.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $42c35fc284860d36$var$wrapperStyles = (0, $2s57o.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("zfug2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2745ea1cb0c1a200$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("6LGvc", function(module, exports) {

$parcel$export(module.exports, "useSmoothExpand", () => $38452c6bcba6455a$export$674ba8b02d2bfe86);

var $5uXOq = parcelRequire("5uXOq");
const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
    const callback = (0, $5uXOq.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("4nfzy", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $53a0c321a39d3b85$export$223f3c3c93a14a83);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("eKTyH", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $9e51067b4d29f53f$export$3ef5d254c3c573e3);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $haBRL = parcelRequire("haBRL");
const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $gM5ou.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haBRL.CommandRow), rowProps);
};

});
parcelRegister("haBRL", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $04586313afa284d7$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $dCm1o = parcelRequire("dCm1o");

var $dzeHJ = parcelRequire("dzeHJ");


var $3m7XM = parcelRequire("3m7XM");

var $3sBlN = parcelRequire("3sBlN");
const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
        "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
        "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $04586313afa284d7$var$iconStyles,
            isActive && $04586313afa284d7$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
        "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.OutlinedLozenge), {
        "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3m7XM.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sBlN.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainerInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandIconsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$iconStyles = (0, $2s57o.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $04586313afa284d7$var$iconActiveStyles = (0, $2s57o.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dzeHJ", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $0f9445e21ac061f1$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $0f9445e21ac061f1$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $0f9445e21ac061f1$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0f9445e21ac061f1$var$Lozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx31l7b _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("3m7XM", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $c1bc24527d77cdc3$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $cwX8H = parcelRequire("cwX8H");

var $eWkgo = parcelRequire("eWkgo");
var $2s57o = parcelRequire("2s57o");

var $dCm1o = parcelRequire("dCm1o");

var $gGkxR = parcelRequire("gGkxR");

const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $5uXOq.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGkxR.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
            justifyContent: "center",
            xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            color: "currentColor",
            label: "separator"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cwX8H))), {
            color: "currentColor",
            label: "separator"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1bc24527d77cdc3$var$CommandNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16eko3h": (0, $lD23V.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !!__cmplp.isParent && "_syazeu41",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, $2s57o.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("gGkxR", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $e999625ec19f201d$export$4495aca3d261add0);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $b4a3S = parcelRequire("b4a3S");

var $jgJNO = parcelRequire("jgJNO");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $jgArx.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $b4a3S.layers).tooltip()
    });
const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        ref: containerRef,
        xcss: [
            $e999625ec19f201d$var$tooltipContainerStyles,
            !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $e999625ec19f201d$var$tooltipContainerStyles = (0, $2s57o.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $e999625ec19f201d$var$truncateTooltipStyles = (0, $2s57o.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("jgJNO", function(module, exports) {

$parcel$export(module.exports, "JiraPopup", () => $93ebfe5964b2617d$export$2da4be1e3f9adef3);

var $5uXOq = parcelRequire("5uXOq");

var $vCqQa = parcelRequire("vCqQa");

var $10xFf = parcelRequire("10xFf");

var $egZ8z = parcelRequire("egZ8z");
const $93ebfe5964b2617d$export$2da4be1e3f9adef3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egZ8z.ChoreographerPopup), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $vCqQa.Popup), rest);
};

});
parcelRegister("egZ8z", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopup", () => $985c2abc03675c6b$export$8ecc19d18d3df807);

var $vCqQa = parcelRequire("vCqQa");

var $fG5AJ = parcelRequire("fG5AJ");
const $985c2abc03675c6b$export$8ecc19d18d3df807 = (0, $fG5AJ.withChoreographedToggle)((0, $vCqQa.Popup), 'isOpen', 'content');

});


parcelRegister("jgArx", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $3c6ba86682bb18eb$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $3c6ba86682bb18eb$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $3c6ba86682bb18eb$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $3c6ba86682bb18eb$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $3c6ba86682bb18eb$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $3c6ba86682bb18eb$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1Jlkv = parcelRequire("1Jlkv");

var $koVbs = parcelRequire("koVbs");

var $6nFD4 = parcelRequire("6nFD4");
const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $3c6ba86682bb18eb$export$534fc570264a52a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $6nFD4.messages).tooltipTriggerAriaLabel)
    });
});
const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $1Jlkv.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8cae238d61c8405a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6nFD4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87d1d47436abe24f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87d1d47436abe24f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;

parcelRegister("k7xca", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $ad951546dfa9fa2c$export$94b118b3187f12c);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");
const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $gM5ou.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $5uXOq.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("3sBlN", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $a83ca30f957fd273$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aCQsl = parcelRequire("aCQsl");

var $koVbs = parcelRequire("koVbs");

var $gM5ou = parcelRequire("gM5ou");


var $iLhkq = parcelRequire("iLhkq");

var $dSJBv = parcelRequire("dSJBv");

var $kbnU6 = parcelRequire("kbnU6");

var $lHtdH = parcelRequire("lHtdH");
const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const transitionStep = (0, $lHtdH.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, $gM5ou.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
        "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aCQsl))), {
        spacing: "spacious",
        label: formatMessage((0, $iLhkq.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
        "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSJBv.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $a83ca30f957fd273$var$animationFadeIn = null;
const $a83ca30f957fd273$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$RightContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aCQsl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bc624ae76a75667$var$_react = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7bc624ae76a75667$var$_chevronRight = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("LD2gx")));

var $7bc624ae76a75667$var$_chevronRightLarge = $7bc624ae76a75667$var$_interopRequireDefault((parcelRequire("asO21")));
function $7bc624ae76a75667$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bc624ae76a75667$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $7bc624ae76a75667$var$_react.default.createElement($7bc624ae76a75667$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $7bc624ae76a75667$var$_chevronRightLarge.default
    }, props));
$7bc624ae76a75667$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $7bc624ae76a75667$var$_default = module.exports.default = $7bc624ae76a75667$var$ChevronRightIcon;

});
parcelRegister("asO21", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $79e3541f2bdfe48d$var$_react = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $79e3541f2bdfe48d$var$_chevronRight = $79e3541f2bdfe48d$var$_interopRequireDefault((parcelRequire("LD2gx")));
function $79e3541f2bdfe48d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $79e3541f2bdfe48d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $79e3541f2bdfe48d$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $79e3541f2bdfe48d$var$_chevronRight.default,
        iconType: "utility"
    }));
$79e3541f2bdfe48d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $79e3541f2bdfe48d$var$_default = module.exports.default = $79e3541f2bdfe48d$var$ChevronRightLargeIcon;

});


const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("iLhkq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf35cee6e1d1204b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("dSJBv", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $57e6d30b2626ce39$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $bcTvL = parcelRequire("bcTvL");

var $gM5ou = parcelRequire("gM5ou");

var $dzeHJ = parcelRequire("dzeHJ");


var $esPgL = parcelRequire("esPgL");
const $57e6d30b2626ce39$var$KeyElementNew = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297),
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.lozenge,
            isLongText && $57e6d30b2626ce39$var$styles.longLozenge
        ])
    }, shortcut));
};
const $57e6d30b2626ce39$var$KeyElementOld = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.FilledLozenge), {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
    }, shortcut));
const $57e6d30b2626ce39$var$KeyElement = (0, $cSD7y.componentWithFG)('command-palette-display-shift-modifier-shortcut', $57e6d30b2626ce39$var$KeyElementNew, $57e6d30b2626ce39$var$KeyElementOld);
const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
        "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
    }, divisor);
const $57e6d30b2626ce39$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $57e6d30b2626ce39$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $57e6d30b2626ce39$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        (0, $4R6GH.fg)('command-palette-display-shift-modifier-shortcut') ? $57e6d30b2626ce39$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        }) : (acc.push({
            type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        }), types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY));
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, $koVbs.default)();
const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, $gM5ou.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $esPgL.messages).shortcutThen;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR) return (0, $esPgL.messages).shortcutOr;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $esPgL.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
        switch(type){
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $esPgL.messages).divisorThen);
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $esPgL.messages).divisorOr);
            default:
                return formatMessage((0, $esPgL.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
        "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $57e6d30b2626ce39$export$cde89099db64abe3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $57e6d30b2626ce39$var$styles = {
    lozenge: "_2rkoglpi _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx3glpi _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("esPgL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f430d579edd6c91$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f430d579edd6c91$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("kbnU6", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $d865f5b0afeb3acd$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;

});

parcelRegister("lHtdH", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $9c0e762a7fdf0cdc$export$eefd045a02bab4c6);

var $5uXOq = parcelRequire("5uXOq");

var $eXGNC = parcelRequire("eXGNC");

var $jcw0u = parcelRequire("jcw0u");

var $gM5ou = parcelRequire("gM5ou");

var $kbnU6 = parcelRequire("kbnU6");
const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, $kbnU6.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $5uXOq.useRef)(null);
    const isReducedMotion = (0, $eXGNC.useIsReducedMotion)();
    const commandHasChildren = (0, $gM5ou.hasChildren)(command);
    (0, $5uXOq.useEffect)(()=>{
        setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
        switch(transitionStep){
            case (0, $kbnU6.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $kbnU6.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).FINISHED, (0, $kbnU6.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).INITIAL, (0, $kbnU6.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $jcw0u.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("5aF2z", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $7ecce3582144481d$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $7ecce3582144481d$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $7ecce3582144481d$export$a6d65a8fb7b912d6);
const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $7ecce3582144481d$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("64ZBB", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $6b9215d3fa38a855$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $6b9215d3fa38a855$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $6b9215d3fa38a855$export$6be8a7238febd54f);

var $gM5ou = parcelRequire("gM5ou");

var $5aF2z = parcelRequire("5aF2z");
const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $5aF2z.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("dE25F", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $842574a5e4b1a419$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
        "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $842574a5e4b1a419$var$ModalFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("d4iCz", function(module, exports) {

$parcel$export(module.exports, "Header", () => $82822f3e363fec07$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $82822f3e363fec07$var$headerStyles,
        testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
    }, children);
const $82822f3e363fec07$var$headerStyles = (0, $2s57o.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("8btEA", function(module, exports) {

$parcel$export(module.exports, "NameContainer", () => $ddea451afbf29ad2$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $ddea451afbf29ad2$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ddea451afbf29ad2$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $ddea451afbf29ad2$export$8f314e512d92575f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3XsL2", function(module, exports) {

$parcel$export(module.exports, "NavigationLink", () => $fdfd62bd57e7226d$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hjSul = parcelRequire("hjSul");
const $fdfd62bd57e7226d$export$721ee963a67379f1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});

parcelRegister("d10H0", function(module, exports) {

$parcel$export(module.exports, "NewTabHintMessage", () => $9f2aa76d6a204b23$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jiSaf = parcelRequire("jiSaf");

var $dzeHJ = parcelRequire("dzeHJ");

var $2f2jJ = parcelRequire("2f2jJ");

var $koVbs = parcelRequire("koVbs");

var $kdbk3 = parcelRequire("kdbk3");
const $9f2aa76d6a204b23$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).Footer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$FooterContentContainer, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MessageWrapper, null, formatMessage((0, $kdbk3.messages).openInANewTab)), (0, $2f2jJ.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacTextOffset, null, "\u2318")) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterIconSVG, null)))));
};
const $9f2aa76d6a204b23$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f2aa76d6a204b23$var$FooterContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9f2aa76d6a204b23$var$HintMessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syaz1gjq _u5f312x7",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MacLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81ixg _18u0v77o _vwz47vkz _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MacTextOffset = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$WindowsLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qjk _k48pi7a9 _1p1d1dk0 _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$EnterLozenge = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $dzeHJ.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $9f2aa76d6a204b23$var$MessageWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kdbk3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $29cc514acfa3bb8e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $29cc514acfa3bb8e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("dmcoI", function(module, exports) {

$parcel$export(module.exports, "isCurrentPage", () => $b6be5b0653c72ae5$export$d4781f4a7d66b55c);
const $b6be5b0653c72ae5$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $2ea3babd020e8e8a$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $2ea3babd020e8e8a$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';


parcelRegister("eG9rp", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $61ebfb9239c4f8e5$export$4d8fe3ef6385358);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $dYWZb = parcelRequire("dYWZb");
const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, $dYWZb.messages)[keywordGroup] ? formatMessage((0, $dYWZb.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("dYWZb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $df7d7dd7b88156b7$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    },
    goToIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Advanced work item search Project Filter JQL search list View all"
    },
    viewAllIssuesSynonymsIssueTermRefresh: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms-issue-term-refresh",
        "defaultMessage": "Site work items JQL View all"
    }
});

});


parcelRegister("1Kt4o", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $3add01bee0e3b846$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $3add01bee0e3b846$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $3add01bee0e3b846$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE',
    FORGE: 'FORGE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $3add01bee0e3b846$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
        teamName: $3add01bee0e3b846$var$teams.Deliveroo
    }
};

});

parcelRegister("556k7", function(module, exports) {

$parcel$export(module.exports, "RegisterCommands", () => $ba0d6dd9c2ef02f6$export$cd555833c78729f1);

var $5uXOq = parcelRequire("5uXOq");

var $buHQa = parcelRequire("buHQa");
const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buHQa.RegisterCommandsWithRegistry), props);

});
parcelRegister("buHQa", function(module, exports) {

$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $3f4c8625aa6e8942$export$b8955a01360d2876);

var $6QoIp = parcelRequire("6QoIp");
function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $6QoIp.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});
parcelRegister("6QoIp", function(module, exports) {

$parcel$export(module.exports, "useRegisterCommandsWithRegistry", () => $9d04f6fb396fa7c9$export$8a824ae164ff968d);

var $5uXOq = parcelRequire("5uXOq");

var $fIZf0 = parcelRequire("fIZf0");
function $9d04f6fb396fa7c9$export$8a824ae164ff968d(registrationId, commands, dependencies = []) {
    const subscribe = (0, $fIZf0.useSubscribeCommandsWithRegistry)();
    const commandCache = (0, $5uXOq.useRef)(commands);
    (0, $5uXOq.useEffect)(()=>{
        commandCache.current = commands;
    }, [
        commands
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $5uXOq.useEffect)(()=>subscribe(registrationId, commandCache.current), [
        ...dependencies,
        subscribe
    ]);
}

});
parcelRegister("fIZf0", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $72118e9f2599bc72$export$880fc01e31710b27);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");
function $72118e9f2599bc72$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $d8lE2.useActionsCommandPalette)();
    const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});




const $fb3970c126a47b8b$export$c2d02b5cc942df6d = 'go-to-timeline-command';
const $fb3970c126a47b8b$export$2caa1569d0e2b36a = 'go-to-backlog-command';
const $fb3970c126a47b8b$export$66c7fd2bb79d8c7d = 'go-to-board-command';
const $fb3970c126a47b8b$export$6e068dae232ebb6 = 'go-to-reports-command';

parcelRegister("ey3mx", function(module, exports) {

$parcel$export(module.exports, "default", () => $faf9e701e4265365$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $faf9e701e4265365$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    commandPaletteGoToBacklog: {
        "id": "spa-apps-sidebar-common.command-palette.command-palette-go-to-backlog",
        "defaultMessage": "Go to backlog"
    },
    commandPaletteGoToBoard: {
        "id": "spa-apps-sidebar-common.command-palette.command-palette-go-to-board",
        "defaultMessage": "Go to board"
    },
    commandPaletteGoToReports: {
        "id": "spa-apps-sidebar-common.command-palette.command-palette-go-to-reports",
        "defaultMessage": "Go to reports"
    },
    commandPaletteGoToTimeline: {
        "id": "spa-apps-sidebar-common.command-palette.command-palette-go-to-timeline",
        "defaultMessage": "Go to timeline"
    }
});

});


parcelRegister("juTur", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$198470770171c65);
$parcel$export(module.exports, "IssuesContextualAnalyticsData", () => $ffb2d49dc0e79e64$export$bc7f6eebc16e6127);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $iXVV6 = parcelRequire("iXVV6");

var $lpwtK = parcelRequire("lpwtK");

var $3d1up = parcelRequire("3d1up");
const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
            navVersion: '3',
            viewId: (0, $3d1up.generateViewId)(menuId, ...stack),
            navigationLayer: 'container',
            ...attributes
        }
    });
const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $lpwtK.useProject), ...rest })=>{
    const { data: project } = useProject();
    const projectConfig = (project?.isSimplified ? (0, $2vSU6.ProjectStyle).NEXT_GEN : (0, $2vSU6.ProjectStyle).CLASSIC) || undefined;
    const projectType = project?.type || undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        ...rest,
        attributes: {
            ...attributes,
            projectConfig: projectConfig,
            projectType: projectType,
            navigatorScope: navigatorScope
        }
    });
};

});
parcelRegister("3d1up", function(module, exports) {

$parcel$export(module.exports, "generateViewId", () => $2f6f53381b1f04e0$export$5b5545ed894dc47a);
const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');

});


parcelRegister("1GbRa", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $12f8ec0674b81469$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");

var $koVbs = parcelRequire("koVbs");

var $bG0w3 = parcelRequire("bG0w3");
const $12f8ec0674b81469$var$getGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $12f8ec0674b81469$export$134cbcd70c6693b8 = ({ size: size, primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $12f8ec0674b81469$var$getGlyph,
        size: size,
        label: formatMessage((0, $bG0w3.default).goalIconLabel),
        primaryColor: primaryColor
    });
};

});
parcelRegister("bG0w3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9702f2f1c783da1a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9702f2f1c783da1a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "spa-apps-sidebar-common.goal-icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("jsI7v", function(module, exports) {

$parcel$export(module.exports, "Issues", () => $e89a82dba74cf1ac$export$1cb51167b20548a0);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9K9UK = parcelRequire("9K9UK");

var $7CMCs = parcelRequire("7CMCs");

var $iL2Ly = parcelRequire("iL2Ly");

var $6KxGW = parcelRequire("6KxGW");

var $8kM72 = parcelRequire("8kM72");

var $5w5Kh = parcelRequire("5w5Kh");

var $hnmuM = parcelRequire("hnmuM");
const $e89a82dba74cf1ac$export$1cb51167b20548a0 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { data: features } = (0, $8kM72.useDefaultPinFilters)();
    if (features === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5w5Kh.DefaultFilters), {
        pinUrl: pinUrl,
        projectKey: projectKey,
        features: features,
        titleHeaderText: titleHeaderText
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jira-navigation-apps-sidebar-common",
        id: "issues.starred-filters-section",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KxGW.StarredFiltersErrorFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerAfter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL2Ly.StarredFiltersContainer), {
        pinUrl: pinUrl,
        projectKey: projectKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e89a82dba74cf1ac$var$CompiledWrapper, {
        renderDividerBefore: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnmuM.FiltersFooter), {
        hasFilters: hasFilters
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e89a82dba74cf1ac$var$CompiledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xlv12x7 _1rqn1fxt",
            __cmplp.renderDividerBefore && "_175u1crf",
            __cmplp.renderDividerAfter && "_1we51crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iL2Ly", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersContainer", () => $1ec2742e0426c5a8$export$f5b4503a4a7ca418);

var $59JDz = parcelRequire("59JDz");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9K9UK = parcelRequire("9K9UK");

var $VILOn = parcelRequire("VILOn");

var $a3OKn = parcelRequire("a3OKn");

var $lfTZh = parcelRequire("lfTZh");

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $bATyw = parcelRequire("bATyw");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $aV2yn = parcelRequire("aV2yn");

var $8Jljs = parcelRequire("8Jljs");
const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
    // We store localStorageData as state so that it's not recalculated during subsequent renders. We want that as a
    // guarantee, not just as a performance optimisation, so we're using useState rather than useMemo.
    //
    // The reason we want to guarantee it's only fetched during the initial render is that we want
    // isNinGlobalScopeEnrolmentEnabled to be stable if there's localStorageData. This can prevent a bug where fetch
    // true from localStorage, we render NIN, the resource returns false, we update local storage to false, and then
    // GinRedirect is rendered again by a parent component and localStorage now returns false and we redirect later
    // than we should.;
    const [localStorageData] = (0, $5uXOq.useState)((0, $VILOn.getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
    const { data: resourceData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    // get value from localStorage if available, get from the resource if this code runs in SSR
    let isNinGlobalScopeEnrolmentEnabled;
    if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
    else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
    const baseHref = (0, $aV2yn.getStarredFilterLink)({
        projectKey: projectKey,
        pinUrl: pinUrl,
        shouldStayProjectScope: isNinGlobalScopeEnrolmentEnabled
    });
    const data = (0, $8Uumt.usePreloadedQuery)((0, $59JDz.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Jljs.StarredFiltersList), {
        baseHref: baseHref,
        jiraQuery: data.jira,
        onFavouritesChanged: onFavouritesChanged
    });
};
const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
    const { queryReference: resourceQueryRef } = (0, $ao2h1.useRelayResource)((0, $a3OKn.sidebarProjectIssuesResource));
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $59JDz.default), resourceQueryRef);
    const cloudId = (0, $koeKL.useCloudId)();
    const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
        loadQuery({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network'
        });
    }, [
        cloudId,
        loadQuery
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!queryReference) loadSidebarData();
    }, [
        loadSidebarData,
        queryReference
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "starred-filters",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null)
    }, queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
        queryReference: queryReference,
        onFavouritesChanged: loadSidebarData,
        pinUrl: pinUrl,
        projectKey: projectKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null));
};

});
parcelRegister("59JDz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7247f574fad09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f9654d948e0d21eca1746252fbb0b581>>
 * @relayHash 62d616b47f1dfc22a4c3e97140061306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e
const $6bc7247f574fad09$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "starredFiltersList_navigationAppsSidebarCommon"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraFilterConnection",
                            "kind": "LinkedField",
                            "name": "favouriteFilters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraFilterEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "jql"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isEditable"
                                                        }
                                                    ],
                                                    "type": "JiraCustomFilter"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
            "metadata": {},
            "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;

});

parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("a3OKn", function(module, exports) {

$parcel$export(module.exports, "sidebarProjectIssuesResource", () => $b491cf2963738bcf$export$be31dd7adcfd2297);

var $ao2h1 = parcelRequire("ao2h1");

var $59JDz = parcelRequire("59JDz");

var $6YG83 = parcelRequire("6YG83");
const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, $6YG83.withGiraAggAnonSsrFix)((0, $ao2h1.createRelayResource)({
    type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
    getQuery: (_, { tenantContext: tenantContext })=>({
            parameters: (0, $59JDz.default),
            variables: {
                cloudId: tenantContext.cloudId
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});

parcelRegister("bATyw", function(module, exports) {

$parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", () => $a818348721ae6866$export$3f6390b4131d761b);

var $2M1hQ = parcelRequire("2M1hQ");

const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("fjGDd"));
const $a818348721ae6866$export$3f6390b4131d761b = (0, $2M1hQ.createResource)({
    type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
    getKey: ()=>'ninGlobalScopeEnrolment',
    getDataLoader: $a818348721ae6866$var$getDataLoader
});

});
parcelRegister("fjGDd", function(module, exports) {

let $b269b315f9daed49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b269b315f9daed49$var$load("f9qz1").then(()=>parcelRequire('dIecw'));

});


parcelRegister("aV2yn", function(module, exports) {

$parcel$export(module.exports, "getStarredFilterLink", () => $a754d4f1af7bcc7d$export$7082c02465d0ecd4);
const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
    if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
    // xxx/issues?filter=123 -> xxx/issues
    const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
    return shouldStayProjectScope ? craftedPinUrl : '/issues/';
};

});

parcelRegister("8Jljs", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersList", () => $0208f837fc89d8ec$export$b7f4b26a8737eee0);

var $47bDC = parcelRequire("47bDC");

var $jUReQ = parcelRequire("jUReQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $kxnYb = parcelRequire("kxnYb");

var $koVbs = parcelRequire("koVbs");

var $b2GBS = parcelRequire("b2GBS");

var $kZDjT = parcelRequire("kZDjT");

var $4ABV3 = parcelRequire("4ABV3");
var $0208f837fc89d8ec$var$_StyledSection = /*#__PURE__*/ (0, $47bDC.default)((0, $kxnYb.default)).withConfig({
    componentId: "sc-8ugvpc-0"
})`${(p)=>p._css}`;
const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $jUReQ.default), jiraQuery);
    (0, $b2GBS.useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
        // refresh when transitioning from pending to NOT pending
        if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
    });
    const starredFilterEdges = data.favouriteFilters?.edges || [];
    if (!starredFilterEdges.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
        title: formatMessage((0, $4ABV3.messages).newStarredFiltersHeader),
        _css: sectionCustomCss
    }, starredFilterEdges.map((edge)=>edge?.node ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZDjT.FilterItem), {
            key: edge.node.filterId,
            baseHref: baseHref,
            filter: edge.node,
            customAnalytics: {
                isStarred: true
            }
        }) : null));
};

});
parcelRegister("jUReQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9363fe5268fd6910$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6a0ff7cd83606b406c54bd970f933e48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9363fe5268fd6910$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "starredFiltersList_navigationAppsSidebarCommon",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraFilterConnection",
            "kind": "LinkedField",
            "name": "favouriteFilters",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "filterId"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "filterItem_navigationAppsSidebarCommon"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$9363fe5268fd6910$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;

});

parcelRegister("b2GBS", function(module, exports) {

$parcel$export(module.exports, "useFavoritesChangeEffect", () => $0fca8b6d7b43f931$export$659f59218fc5dd14);

var $5uXOq = parcelRequire("5uXOq");

var $4f8Oj = parcelRequire("4f8Oj");

var $4041n = parcelRequire("4041n");

var $1XJ20 = parcelRequire("1XJ20");
const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
    const { items: items } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    // @ts-expect-error - TS2322 - Type 'ItemMap | undefined' is not assignable to type 'ItemMap'.
    const typeItems = items[type];
    const pendingChanges = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
    const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
    const previousHasPendingChanges = (0, $1XJ20.usePreviousWithInitial)(hasPendingChanges);
    (0, $5uXOq.useEffect)(()=>{
        effect(hasPendingChanges, previousHasPendingChanges);
    }, [
        effect,
        hasPendingChanges,
        previousHasPendingChanges
    ]);
};

});
parcelRegister("4041n", function(module, exports) {

$parcel$export(module.exports, "FavoriteChangeContext", () => $e574e5c3227b76f4$export$a5d258b9665ce94b);
$parcel$export(module.exports, "FavoriteChangeProvider", () => $e574e5c3227b76f4$export$b06b5ce59fd5e408);
$parcel$export(module.exports, "FavoriteChangeConsumer", () => $e574e5c3227b76f4$export$f227cdfbb355444a);
$parcel$export(module.exports, "useChangeFavorite", () => $e574e5c3227b76f4$export$cfa169f3278459e8);

var $kZupY = parcelRequire("kZupY");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $jcw0u = parcelRequire("jcw0u");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $erN97 = parcelRequire("erN97");

var $j6ttF = parcelRequire("j6ttF");

var $7lK06 = parcelRequire("7lK06");

var $eXQym = parcelRequire("eXQym");

var $5c9oS = parcelRequire("5c9oS");

var $7SIuT = parcelRequire("7SIuT");
const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
            ...state,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [item.type]: {
                ...state[item.type],
                [item.id]: item
            }
        });
const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
            ...state,
            items: {
                ...state.items,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [item.type]: {
                    ...state.items[item.type],
                    [item.id]: item
                }
            }
        });
const $e574e5c3227b76f4$export$b212ddc707077772 = {
    items: {
        boards: {},
        filters: {},
        issues: {},
        dashboards: {},
        projects: {},
        queues: {},
        plans: {}
    },
    changeFavorite: ()=>new Promise((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))),
    changeFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavorite: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    emitChangedFavoriteMutation: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    updateFavoriteState: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $e574e5c3227b76f4$export$a5d258b9665ce94b = /*#__PURE__*/ (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
// supports project types only for now
const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
        if (type === (0, $eXQym.PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const ari = (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                resourceType: 'project',
                resourceId: id,
                cloudId: cloudId
            });
            const projectRecordId = (0, $erN97.default)({
                id: ari
            }, 'JiraProject');
            if (projectRecordId) {
                const projectRecord = store.get(projectRecordId);
                const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                favoriteRecord?.setValue(value, 'isFavourite');
            }
        });
    }, [
        cloudId,
        environment
    ]);
    return {
        commitUpdate: commitUpdate
    };
};
const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
    const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
    const [items, setItems] = (0, $5uXOq.useState)({
        boards: {},
        filters: {},
        dashboards: {},
        issues: {},
        projects: {},
        queues: {},
        plans: {}
    });
    const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: true
        }));
    }, []);
    const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, // removing last letter to make item.type singular tense (i.e. boards => board)
        `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
    }, []);
    const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            value: !item.value,
            pending: false
        }));
        if (onShowFlag) onShowFlag((0, $7SIuT.errorFlag)());
        (0, $jcw0u.default)({
            meta: {
                id: analyticsId,
                packageName: 'jiraFavouriteChangeProvider',
                teamName: 'empanada'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        onShowFlag
    ]);
    const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
        const performChange = async ()=>{
            onChangeStart(item);
            try {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: item.value
                });
                await (0, $5c9oS.default)(item);
                const typename = (0, $j6ttF.favoriteTypeToTypename)(item.type, item.id);
                if (typename) (0, $7lK06.publishFavorite)(typename, {
                    type: 'REST',
                    entityId: item.id,
                    isFavourite: item.value
                });
                onChangeSuccess(item, analyticsEvent);
            } catch (error) {
                commitUpdate({
                    type: item.type,
                    id: item.id,
                    value: !item.value
                });
                onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
            }
        };
        return performChange();
    }, [
        commitUpdate,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $kZupY.default));
    const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename);
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        const onUpdate = (store, isOptimistic)=>{
            if (!dataId) return;
            (0, $7lK06.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: isOptimistic
            });
            const record = store.get(dataId);
            if (record) {
                // Some favoritable entities provide an `isFavourite` field, e.g. `JiraFilter`, `JiraProject`.
                if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                // Optimistically update the `favouriteValue` node associated with the updated entity (if present).
                // We only need to do this during optimistic update as the node will be returned in a successful
                // mutation response.
                if (isOptimistic) {
                    const favoriteRecord = record.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(payload.value, 'isFavourite');
                }
            }
        };
        onChangeStart(restItem);
        commitMutation({
            variables: {
                input: {
                    entityId: payload.id,
                    isFavourite: payload.value,
                    beforeEntityId: payload.beforeEntity?.id ?? null
                }
            },
            optimisticUpdater: (store)=>{
                onUpdate(store, true);
            },
            updater: (store, response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
            },
            onCompleted: (response)=>{
                if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                else onChangeFail(restItem, 'changeFavoriteMutation');
            },
            onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
        });
    }, [
        commitMutation,
        onChangeStart,
        onChangeSuccess,
        onChangeFail
    ]);
    const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
        setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
            ...item,
            pending: false
        }));
    }, []);
    const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
        onChangeSuccess(payload, analyticsEvent);
        const typeName = (0, $j6ttF.favoriteTypeToTypename)(payload.type, payload.id);
        if (typeName) (0, $7lK06.publishFavorite)(typeName, {
            type: 'REST',
            entityId: payload.id,
            isFavourite: payload.value
        });
    }, [
        onChangeSuccess
    ]);
    const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (payload, store, analyticsEvent)=>{
        const dataId = (0, $erN97.default)({
            id: payload.id
        }, payload.typename) ?? '';
        const restItem = (0, $j6ttF.favoriteMutationToRestPayload)(payload);
        onChangeSuccess(restItem, analyticsEvent);
        (0, $7lK06.publishFavorite)(payload.typename, {
            type: 'MUTATION',
            store: store,
            dataId: dataId,
            entityId: payload.id,
            isFavourite: payload.value,
            isOptimistic: false
        });
    }, [
        onChangeSuccess
    ]);
    const providerValue = (0, $5uXOq.useMemo)(()=>({
            items: items,
            changeFavorite: changeFavorite,
            changeFavoriteMutation: changeFavoriteMutation,
            emitChangedFavorite: emitChangedFavorite,
            emitChangedFavoriteMutation: emitChangedFavoriteMutation,
            updateFavoriteState: updateFavoriteState
        }), [
        items,
        changeFavorite,
        changeFavoriteMutation,
        emitChangedFavorite,
        emitChangedFavoriteMutation,
        updateFavoriteState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
        value: providerValue
    }, children);
};
const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
    const WithFavoriteChangeConsumer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>// @ts-expect-error - TS2322 - Type 'P & { favoriteChangeContext: FavoriteChangeContextType; }' is not assignable to type 'IntrinsicAttributes & W & { children?: ReactNode; }'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                favoriteChangeContext: favoriteChangeContext
            }));
    const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
    return WithFavoriteChangeConsumer;
};
const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);

});
parcelRegister("kZupY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64781493fbfe6b0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<581ee8573bf9ee1f32ccc64539d4c7bc>>
 * @relayHash 6de546c6546651e6c4572b78dca9bcd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f
const $d64781493fbfe6b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewSetFavouriteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
            "metadata": {},
            "name": "viewSetFavouriteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;

});

parcelRegister("dXq4S", function(module, exports) {

$parcel$export(module.exports, "isAri", () => $5c4418bd595ae8cf$export$8e68286aef4c3a8b);
$parcel$export(module.exports, "createAri", () => $5c4418bd595ae8cf$export$594d18a0ad2e0e57);
$parcel$export(module.exports, "toAri", () => $5c4418bd595ae8cf$export$24b47820a324e614);
$parcel$export(module.exports, "toAriOrDefault", () => $5c4418bd595ae8cf$export$e2789192113e8b07);
$parcel$export(module.exports, "parseAri", () => $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5);
$parcel$export(module.exports, "getAriConfig", () => $5c4418bd595ae8cf$export$3d8d7031a11613fd);
/**
 * Module to work with Atlassian Resource Identifier (ARI)
 * More info in go/aris
 */ const $5c4418bd595ae8cf$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
const $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
const $5c4418bd595ae8cf$export$8e68286aef4c3a8b = (ari)=>$5c4418bd595ae8cf$var$ARI_REG_EXP.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.test(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
const $5c4418bd595ae8cf$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
    if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
    if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
};
const $5c4418bd595ae8cf$export$24b47820a324e614 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) return ari;
    return undefined;
};
const $5c4418bd595ae8cf$export$e2789192113e8b07 = (ari, defaultValue = '')=>$5c4418bd595ae8cf$export$24b47820a324e614(ari) ?? defaultValue;
const $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5 = (ari)=>{
    if ($5c4418bd595ae8cf$export$8e68286aef4c3a8b(ari)) {
        const parts = $5c4418bd595ae8cf$var$ARI_REG_EXP.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $5c4418bd595ae8cf$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
        if (parts?.groups) {
            // reconstructing an object just to avoid flow error (otherwise says inexact object type of parts.groups is incompatible with exact AriConfig type)
            const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
            return {
                resourceOwner: resourceOwner,
                cloudId: cloudId,
                resourceType: resourceType,
                workspaceId: workspaceId,
                resourceId: resourceId,
                activationId: activationId
            };
        }
    }
    return undefined;
};
const $5c4418bd595ae8cf$export$3d8d7031a11613fd = (ari)=>{
    const config = $5c4418bd595ae8cf$export$f8e7d14b19dc8ba5(ari);
    if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
    return config;
};

});

parcelRegister("j6ttF", function(module, exports) {

$parcel$export(module.exports, "favoriteTypeToTypename", () => $b9c3378eb0d73712$export$b98f76d96728a853);
$parcel$export(module.exports, "favoriteMutationToRestPayload", () => $b9c3378eb0d73712$export$717886a1047f1287);

var $1Y49U = parcelRequire("1Y49U");

var $1WQct = parcelRequire("1WQct");

var $k0goX = parcelRequire("k0goX");

var $gbLWS = parcelRequire("gbLWS");

var $89DrR = parcelRequire("89DrR");

var $j5YhT = parcelRequire("j5YhT");
function $b9c3378eb0d73712$var$assertUnreachable(_) {
    throw new Error('Unexpected entity type');
}
const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
    switch(type){
        case 'projects':
            return 'JiraProject';
        case 'filters':
            return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
        case 'dashboards':
            return 'JiraDashboard';
        case 'plans':
            return 'JiraPlan';
        case 'boards':
            return 'JiraBoard';
        case 'queues':
            return 'JiraServiceManagementQueue';
        default:
            return undefined;
    }
};
const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
    switch(typename){
        case 'JiraProject':
            return (0, $j5YhT.JiraProjectAri).parse(ari).projectId;
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return (0, $gbLWS.JiraFilterAri).parse(ari).filterId;
        case 'JiraDashboard':
            return (0, $k0goX.JiraDashboardAri).parse(ari).dashboardId;
        case 'JiraPlan':
            return (0, $89DrR.JiraPlanAri).parse(ari).planId;
        case 'JiraBoard':
            return (0, $1WQct.JiraSoftwareBoardAri).parse(ari).boardId;
        case 'JiraServiceManagementQueue':
            return (0, $1Y49U.JiraServicedeskQueueAri).parse(ari).queueId;
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
    switch(typename){
        case 'JiraProject':
            return 'projects';
        case 'JiraCustomFilter':
        case 'JiraSystemFilter':
            return 'filters';
        case 'JiraDashboard':
            return 'dashboards';
        case 'JiraPlan':
            return 'plans';
        case 'JiraBoard':
            return 'boards';
        case 'JiraServiceManagementQueue':
            return 'queues';
        default:
            $b9c3378eb0d73712$var$assertUnreachable(typename);
    }
};
const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
        id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
        type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
        value: value,
        beforeEntity: beforeEntity ? {
            id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
        } : undefined
    });

});

parcelRegister("7lK06", function(module, exports) {

$parcel$export(module.exports, "publishFavorite", () => $703ce7b9c2eadfdd$export$229a24253fb568e1);
$parcel$export(module.exports, "useSubscribeToFavorite", () => $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);

var $5uXOq = parcelRequire("5uXOq");
/**
 * Simple pub-sub implementation to emit and listen to change events for the favorite state of an entity.
 */ class $703ce7b9c2eadfdd$var$FavoritePubSub {
    constructor(){
        this.subscribers = {};
        this.subscribe = (typename, subscriber)=>{
            this.subscribers[typename] = [
                ...this.subscribers[typename] ?? [],
                subscriber
            ];
            return ()=>{
                this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
            };
        };
        this.publish = (typename, payload)=>{
            this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
        };
    }
}
// Singleton to emit and listen to events
const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
    (0, $5uXOq.useEffect)(()=>{
        const typenames = Array.isArray(typename) ? typename : [
            typename
        ];
        const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
        return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
    }, [
        typename,
        subscriber
    ]);
};

});

parcelRegister("eXQym", function(module, exports) {

$parcel$export(module.exports, "BOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$aade82542e73ffc8);
$parcel$export(module.exports, "FILTERS_ITEM_TYPE", () => $6c76a5a290814989$export$a448ebfa10cebc74);
$parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", () => $6c76a5a290814989$export$f8099f229527572c);
$parcel$export(module.exports, "ISSUES_ITEM_TYPE", () => $6c76a5a290814989$export$8e58083dcbb878d);
$parcel$export(module.exports, "PLANS_ITEM_TYPE", () => $6c76a5a290814989$export$2fd44a6cb58b66cb);
$parcel$export(module.exports, "PROJECTS_ITEM_TYPE", () => $6c76a5a290814989$export$8e2cd98172988d7e);
$parcel$export(module.exports, "QUEUES_ITEM_TYPE", () => $6c76a5a290814989$export$6b0c8e47d2c7f1d9);
$parcel$export(module.exports, "VALID_ITEM_TYPES", () => $6c76a5a290814989$export$9c8cfad65800ddfb);
$parcel$export(module.exports, "VALID_ITEM_TYPENAMES", () => $6c76a5a290814989$export$2d63a9c2e78633c8);
const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
const $6c76a5a290814989$export$9c8cfad65800ddfb = [
    $6c76a5a290814989$export$aade82542e73ffc8,
    $6c76a5a290814989$export$f8099f229527572c,
    $6c76a5a290814989$export$a448ebfa10cebc74,
    $6c76a5a290814989$export$8e58083dcbb878d,
    $6c76a5a290814989$export$2fd44a6cb58b66cb,
    $6c76a5a290814989$export$8e2cd98172988d7e,
    $6c76a5a290814989$export$6b0c8e47d2c7f1d9
];
const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
    'JiraProject',
    'JiraCustomFilter',
    'JiraSystemFilter',
    'JiraDashboard',
    'JiraPlan',
    'JiraBoard',
    'JiraServiceManagementQueue'
];

});

parcelRegister("5c9oS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9559749111f2eca$export$2e2bcd8739ae039);

var $7eYK2 = parcelRequire("7eYK2");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, $7eYK2.updateFavorite)(request);

});
parcelRegister("7eYK2", function(module, exports) {

$parcel$export(module.exports, "updateFavorite", () => $16085bb5bdb7219b$export$8c2f00130cc945dc);

var $eusud = parcelRequire("eusud");
const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
    if (request.value) return (0, $eusud.performPostRequest)('/rest/internal/2/favourites', {
        body: JSON.stringify({
            entity: {
                id: request.id,
                type: request.type
            },
            beforeEntityPosition: request.beforeEntity || null
        })
    });
    return (0, $eusud.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
};

});


parcelRegister("7SIuT", function(module, exports) {

$parcel$export(module.exports, "errorFlag", () => $7252fdcfc0e15292$export$b9a7f1ebeaa76953);

var $0YlRJ = parcelRequire("0YlRJ");
const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
        type: 'error',
        ...(0, $0YlRJ.default)
    });

});
parcelRegister("0YlRJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ad72b3da53041c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("1XJ20", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $011794d66b906d20$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $011794d66b906d20$export$23fbbb2e62c4a911);

var $5uXOq = parcelRequire("5uXOq");
const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});


parcelRegister("kZDjT", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $f981c975abc56594$export$3cf161fcd24b6b4f);

var $lE53e = parcelRequire("lE53e");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $k0ZZ2 = parcelRequire("k0ZZ2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
    const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $lE53e.default), /* eslint-enable @atlassian/relay/unused-fields */ filter);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...customAnalytics || {},
            itemId: `filter-${filterId}`
        }), [
        customAnalytics,
        filterId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        key: filterId,
        analytics: analyticsAttributes,
        selectedOn: $f981c975abc56594$var$selectedOn,
        href: `${baseHref}?filter=${filterId}`
    }, name);
};

});
parcelRegister("lE53e", function(module, exports) {

$parcel$export(module.exports, "default", () => $251d70d9349441ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $251d70d9349441ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "filterItem_navigationAppsSidebarCommon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;

});


parcelRegister("4ABV3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f94c0f775539d45d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f94c0f775539d45d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    newStarredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});



parcelRegister("6KxGW", function(module, exports) {

$parcel$export(module.exports, "StarredFiltersErrorFallback", () => $48c59f757828f109$export$70765d6359132b82);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $9FSw2 = parcelRequire("9FSw2");

var $kxnYb = parcelRequire("kxnYb");

var $koVbs = parcelRequire("koVbs");

var $b1xML = parcelRequire("b1xML");
const $48c59f757828f109$export$70765d6359132b82 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
        // TODO remove SectionWrapper once @atlaskit/section design gets updated
        title: formatMessage((0, $b1xML.default).starredFiltersHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9FSw2.default), {
        appearance: "warning"
    }, formatMessage((0, $b1xML.default).errorMessage, {
        link: (linkText)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
                appearance: "link",
                spacing: "none",
                onClick: ()=>window.location.reload()
            }, linkText)
    })));
};
// TODO remove SectionWrapper once @atlaskit/section design gets updated
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $48c59f757828f109$var$SectionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $kxnYb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt3i2wt _euf41fxt _1qdg1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9FSw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $992999896a95fc30$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bWfiu = parcelRequire("bWfiu");

var $fHpHg = parcelRequire("fHpHg");

var $5sRpy = parcelRequire("5sRpy");
var $5sLH0 = parcelRequire("5sLH0");
var $gOkqF = parcelRequire("gOkqF");

var $fPYPu = parcelRequire("fPYPu");
const $992999896a95fc30$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $992999896a95fc30$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $fPYPu.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        as: "section",
        backgroundColor: $992999896a95fc30$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $992999896a95fc30$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5sLH0.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $992999896a95fc30$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                            xcss: $992999896a95fc30$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $fHpHg.fg)('platform_ads_explicit_font_styles') && $992999896a95fc30$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $992999896a95fc30$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$992999896a95fc30$var$SectionMessage.displayName = 'SectionMessage';
var $992999896a95fc30$export$2e2bcd8739ae039 = $992999896a95fc30$var$SectionMessage;

});
parcelRegister("fPYPu", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5E93O = parcelRequire("5E93O");

var $k01Ou = parcelRequire("k01Ou");

var $3vNgn = parcelRequire("3vNgn");

var $bMdrA = parcelRequire("bMdrA");

var $85eFT = parcelRequire("85eFT");

const $c121b5ea31b69b1c$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $a7f8c6b391092279$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($k01Ou))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $a7f8c6b391092279$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $a7f8c6b391092279$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($85eFT))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $a7f8c6b391092279$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $a7f8c6b391092279$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5E93O))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $a7f8c6b391092279$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $a7f8c6b391092279$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMdrA))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $a7f8c6b391092279$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3vNgn))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $a7f8c6b391092279$export$147899de772240ec)})`
    }
};
function $c121b5ea31b69b1c$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $c121b5ea31b69b1c$var$appearanceIconSchema[appearance] || $c121b5ea31b69b1c$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("b1xML", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc624d55e9cb181d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
        "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
    },
    starredFiltersHeader: {
        "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
        "defaultMessage": "Starred filters"
    }
});

});


parcelRegister("8kM72", function(module, exports) {

$parcel$export(module.exports, "useDefaultPinFilters", () => $42363ac07745a31e$export$3c69152f8409a017);

var $5uXOq = parcelRequire("5uXOq");

var $1b36n = parcelRequire("1b36n");

var $2YP9W = parcelRequire("2YP9W");
const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
    const { data: data, loading: loading, refresh: refresh, error: error } = (0, $2YP9W.useResource)((0, $1b36n.staticSidebarDefaultPINFiltersResource));
    (0, $5uXOq.useEffect)(()=>{
        if (data == null && error == null && loading === false) refresh();
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return {
        data: data,
        loading: loading
    };
};

});
parcelRegister("1b36n", function(module, exports) {

$parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", () => $f0c33588b62c7651$export$d3efe54a881807bf);

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $elyZV = parcelRequire("elyZV");
const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $2M1hQ.createResource)({
    type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
    getKey: ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        return projectKey || 'none';
    },
    getData: async ({ match: match, query: query })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        if (projectKey == null) return null;
        return (0, $elyZV.fetchDefaultPINFiltersNavData)(projectKey);
    },
    maxAge: 300000
});

});
parcelRegister("elyZV", function(module, exports) {

$parcel$export(module.exports, "fetchDefaultPINFiltersNavData", () => $88433d457c0f5220$export$268c1bcb44a0ddd3);

var $eusud = parcelRequire("eusud");
const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
    if (projectKey == null) throw new Error('invalid project id or key');
    const result = await (0, $eusud.performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
    const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
    return {
        hasMyOpenIssues: filterNavIds.has('myopenissues'),
        hasReportedByMe: filterNavIds.has('reportedbyme'),
        hasAllIssues: filterNavIds.has('allissues'),
        hasAllOpenIssues: filterNavIds.has('allopenissues'),
        hasDoneIssues: filterNavIds.has('doneissues'),
        hasViewedRecently: filterNavIds.has('recentlyviewed'),
        hasCreatedRecently: filterNavIds.has('addedrecently'),
        hasResolvedRecently: filterNavIds.has('resolvedrecently'),
        hasUpdatedRecently: filterNavIds.has('updatedrecently')
    };
};

});



parcelRegister("5w5Kh", function(module, exports) {

$parcel$export(module.exports, "DefaultFilters", () => $68067cb39e642d05$export$5df36bcfaa4d1f9d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $kxnYb = parcelRequire("kxnYb");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $doZTA = parcelRequire("doZTA");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $irHAa = parcelRequire("irHAa");

var $2q4IS = parcelRequire("2q4IS");
const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match, location: location }] = (0, $doZTA.useRouter)();
    // @ts-expect-error - TS2322 - Type '"comma"' is not assignable to type '"none" | "bracket" | "index" | undefined'.
    const { jql: jql } = (0, $ebyGx.parse)(location.search, {
        arrayFormat: 'comma'
    });
    const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
    const shouldUseNinLayout = !isOnLegacyPinRoute;
    const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute // Force legacy PIN route everywhere if user browsed here themselves
     ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
    const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).issuesIssueTermRefresh : (0, $irHAa.messages).issues) : titleHeaderText;
    const allOpenIssuesSelector = !shouldUseNinLayout ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentLocation, itemLocation)=>(0, $4OCke.matchUrlParams)([
            'filter'
        ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, $4OCke.matchUrlParams)([
        'filter'
    ], false);
    // NIN appends the corresponding jql to the URL for the selected filter so that it can
    // be read by integrated marketplace apps. So when determining if a MenuItem is selected, the
    // ?jql query URL param should be ignored unless this is for legacy PIN.
    // When we can be sure legacy is no longer in use, this const can be deleted.
    const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: title
    }, shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).ninLayoutAllIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).ninLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasMyOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).myOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).myOpenIssues.selectedOn(jql),
        href: `${pinUrlPrefix}myopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).myOpenIssuesIssueTermRefresh : (0, $irHAa.messages).myOpenIssues)), features.hasReportedByMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).reportedByMe.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).reportedByMe.selectedOn(jql),
        href: `${pinUrlPrefix}reportedbyme`
    }, formatMessage((0, $irHAa.messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).notNinLayoutAllIssues.analytics,
        selectedOn: (0, $2q4IS.itemMap).notNinLayoutAllIssues.selectedOn(jql),
        href: `${pinUrlPrefix}allissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allIssuesIssueTermRefresh : (0, $irHAa.messages).allIssues)), features.hasAllOpenIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).allOpenIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
        href: `${pinUrlPrefix}allopenissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).allOpenIssuesIssueTermRefresh : (0, $irHAa.messages).allOpenIssues)), features.hasDoneIssues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).doneIssues.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).doneIssues.selectedOn(jql),
        href: `${pinUrlPrefix}doneissues`
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $irHAa.messages).doneIssuesIssueTermRefresh : (0, $irHAa.messages).doneIssues)), features.hasViewedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).viewedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).viewedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}recentlyviewed`
    }, formatMessage((0, $irHAa.messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).createdRecently.analytics,
        selectedOn: (0, $2q4IS.itemMap).createdRecently.selectedOn(jql),
        href: `${pinUrlPrefix}addedrecently`
    }, formatMessage((0, $irHAa.messages).createdRecently)), features.hasResolvedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).resolvedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).resolvedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}resolvedrecently`
    }, formatMessage((0, $irHAa.messages).resolvedRecently)), features.hasUpdatedRecently && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: (0, $2q4IS.itemMap).updatedRecently.analytics,
        selectedOn: shouldIgnoreJqlUrlParam ? (0, $4OCke.matchUrlParams)([
            'filter'
        ], false) : (0, $2q4IS.itemMap).updatedRecently.selectedOn(jql),
        href: `${pinUrlPrefix}updatedrecently`
    }, formatMessage((0, $irHAa.messages).updatedRecently)));
};

});
parcelRegister("4OCke", function(module, exports) {

$parcel$export(module.exports, "matchPathname", () => $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $cf3ce1d2a79b8e17$export$63fdecce99465869);

var $f8l56 = parcelRequire("f8l56");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});

parcelRegister("irHAa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87feacba5b057fbf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87feacba5b057fbf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues",
        "defaultMessage": "Issues and filters"
    },
    issuesFilters: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
        "defaultMessage": "Issues and Filters"
    },
    myOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    reportedByMe: {
        "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    allIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
        "defaultMessage": "All issues"
    },
    allOpenIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
        "defaultMessage": "Open issues"
    },
    doneIssues: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    viewedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
        "defaultMessage": "Updated recently"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    issuesFiltersIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    allIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
        "defaultMessage": "All work items"
    },
    allOpenIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    }
});

});

parcelRegister("2q4IS", function(module, exports) {

$parcel$export(module.exports, "itemMap", () => $414ee2dbecb9ba58$export$1072457701b9918d);

var $kvHKs = parcelRequire("kvHKs");

var $4OCke = parcelRequire("4OCke");
const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
    // Initial load
    if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
    if (filter != null && filter !== 'allissues') return false;
    if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
    return false;
};
const $414ee2dbecb9ba58$export$1072457701b9918d = {
    ninLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, $4OCke.matchUrlParams)([
                    'filter'
                ], false)(...args) : false)
    },
    myOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    reportedByMe: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    notNinLayoutAllIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    allOpenIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
        },
        selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
    },
    doneIssues: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    viewedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    createdRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    resolvedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    },
    updatedRecently: {
        analytics: {
            itemId: `pin-${(0, $kvHKs.PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
        },
        selectedOn: (jql)=>!jql ? (0, $4OCke.matchUrlParams)([
                'filter'
            ], false) : ()=>false
    }
};

});


parcelRegister("hnmuM", function(module, exports) {

$parcel$export(module.exports, "FiltersFooter", () => $ca4a87e5b79a11b5$export$c131ccfc44bcd85c);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fcEY2 = parcelRequire("fcEY2");
const $ca4a87e5b79a11b5$var$analyticsPayload = {
    itemId: 'pin-manage-filters'
};
const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        hasSeparator: hasFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
        href: "/jira/filters"
    }, formatMessage((0, $fcEY2.messages).viewAllFilters)));
};

});
parcelRegister("fcEY2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $905189d98c72b841$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $905189d98c72b841$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    viewAllFilters: {
        "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
        "defaultMessage": "View all filters"
    }
});

});



parcelRegister("kZj7F", function(module, exports) {

$parcel$export(module.exports, "NestingMenuItem", () => $2fbfde7c900477f4$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3xWPD = parcelRequire("3xWPD");

var $65Cwx = parcelRequire("65Cwx");

var $5Hj3V = parcelRequire("5Hj3V");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fpoBX = parcelRequire("fpoBX");

var $kavsL = parcelRequire("kavsL");
const $2fbfde7c900477f4$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $2fbfde7c900477f4$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _btpd1ady _vl7qglyw _slhpglyw _7upw1txw"
};
const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("a", props, props.children);
const $2fbfde7c900477f4$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $5uXOq.createElement(WrapperComponent, null, /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xWPD))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $kavsL.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$2fbfde7c900477f4$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $bwpsq.default)([
                iconSecondaryColor && $2fbfde7c900477f4$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $65Cwx.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $bwpsq.default)([
                $2fbfde7c900477f4$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $5Hj3V.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $k0ZZ2.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("kavsL", function(module, exports) {

$parcel$export(module.exports, "isNormalClick", () => $e059487e30c8155a$export$729f3684d5c2b9b9);
const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("l468O", function(module, exports) {

$parcel$export(module.exports, "ProjectHeader", () => $3b1d5cf2181bf590$export$69277e177204bdfd);

var $5uXOq = parcelRequire("5uXOq");

var $ew55A = parcelRequire("ew55A");

var $fJoTF = parcelRequire("fJoTF");
const $3b1d5cf2181bf590$export$69277e177204bdfd = ({ Avatar: Avatar = (0, $ew55A.default), Header: Header = (0, $fJoTF.CustomHeader), avatarUrl: avatarUrl, iconBefore: iconBefore, description: description, name: name })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
        description: description,
        iconBefore: iconBefore ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: avatarUrl ? `${avatarUrl}?size=xxlarge` : avatarUrl
        })
    }, name);
};

});
parcelRegister("fJoTF", function(module, exports) {

$parcel$export(module.exports, "CustomHeader", () => $d2408f7c0923c3e9$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bY5Mc = parcelRequire("bY5Mc");

var $fpoBX = parcelRequire("fpoBX");
const $d2408f7c0923c3e9$var$bgColorCssVar = '--header-bg-color';
const $d2408f7c0923c3e9$var$textColorCssVar = '--header-text-color';
const $d2408f7c0923c3e9$var$containerStyles = null;
const $d2408f7c0923c3e9$var$bgColorThemeStyles = null;
const $d2408f7c0923c3e9$var$colorThemeStyles = null;
const $d2408f7c0923c3e9$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_vrjt140y _1cmdleuv _1w901jnk _14n4h2mm _1cg71wug _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_16hg1im0",
            item?.color?.default && "_1w901jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$d2408f7c0923c3e9$var$bgColorCssVar]: item?.background?.default,
            [$d2408f7c0923c3e9$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $d2408f7c0923c3e9$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $5uXOq.createElement((0, $bY5Mc.default), {
        ...rest,
        component: $d2408f7c0923c3e9$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: title, ...props })=>/*#__PURE__*/ $5uXOq.createElement("h2", props, title)
            }
        }
    }, children);
};

});


parcelRegister("c162r", function(module, exports) {

$parcel$export(module.exports, "CustomTemplateInlineMessage", () => $e210d8303f7d4524$export$b00a44669da41dd7);

var $5uXOq = parcelRequire("5uXOq");

var $eWkgo = parcelRequire("eWkgo");
var $6eFvr = parcelRequire("6eFvr");
var $2s57o = parcelRequire("2s57o");

var $9a675 = parcelRequire("9a675");

var $koVbs = parcelRequire("koVbs");

var $bEs3J = parcelRequire("bEs3J");
const $e210d8303f7d4524$export$b00a44669da41dd7 = ({ isLiveTemplate: isLiveTemplate })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return isLiveTemplate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eWkgo.default), {
        alignItems: "center",
        xcss: $e210d8303f7d4524$var$customTemplateInlineMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9a675))), {
        label: "",
        color: "var(--ds-icon-discovery)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6eFvr.default), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $bEs3J.messages).savedAsTemplateInlineMessage)));
};
const $e210d8303f7d4524$var$customTemplateInlineMessageStyles = (0, $2s57o.xcss)({
    paddingInlineStart: 'space.100',
    gap: 'space.075'
});

});
parcelRegister("bEs3J", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2a8b1807195dfedb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2a8b1807195dfedb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    savedAsTemplateInlineMessage: {
        "id": "spa-apps-sidebar-common.custom-template-inline-message.saved-as-template-inline-message.non-final",
        "defaultMessage": "Saved as template"
    },
    savedAsTemplateDialogMessage: {
        "id": "spa-apps-sidebar-common.custom-template-inline-message.saved-as-template-dialog-message.non-final",
        "defaultMessage": "This project is saved as a custom template. Project settings changes will apply to the template."
    }
});

});


parcelRegister("7EMGV", function(module, exports) {

$parcel$export(module.exports, "ScopeSwitcher", () => $055543892c96669f$export$8d2db9c1a2d8e427);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gxRCf = parcelRequire("gxRCf");

var $3w19c = parcelRequire("3w19c");
var $fsi33 = parcelRequire("fsi33");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $3zdOn = parcelRequire("3zdOn");

var $cYlk7 = parcelRequire("cYlk7");

var $4DPZY = parcelRequire("4DPZY");

var $cZpsT = parcelRequire("cZpsT");

var $lVJAU = parcelRequire("lVJAU");

var $fNi03 = parcelRequire("fNi03");

var $bdAP2 = parcelRequire("bdAP2");
const $055543892c96669f$var$ScopeSwitcher = ()=>{
    const baseUrl = '';
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { data: board } = (0, $fNi03.useBoard)();
    const [{ data: contextData }] = (0, $4DPZY.useContainerContext)();
    const { data: { user: currentUser } } = (0, $cYlk7.useCurrentUser)();
    const currentBoard = (0, $5uXOq.useMemo)(()=>board != null ? // URL not need as navigation handled via imperative API using board ID
        {
            id: String(board.id),
            name: board.name,
            url: ''
        } : // make switcher appear also on boardless projects
        {
            id: '0',
            name: ' ',
            url: ''
        }, [
        board
    ]);
    let locationName = '';
    if (contextData?.contextType === 'project' && contextData.project.name) locationName = contextData.project.name;
    else if (contextData?.contextType === 'user' && contextData.user.name) locationName = contextData.user.name;
    const onBoardClick = (0, $5uXOq.useCallback)(async (clickedBoard)=>{
        push(clickedBoard.url);
    }, [
        push
    ]);
    const onCreateBoard = (0, $5uXOq.useCallback)(()=>{
        (0, $1ADgn.default)();
    }, []);
    const projectKey = contextData?.contextType === 'project' ? contextData.project.key : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3zdOn.default), {
        key: projectKey,
        baseUrl: baseUrl,
        // @ts-expect-error - TS2322 - Type '{ baseUrl: string; boardsInLocation: { id: string; name: string; url: string; }[]; currentBoard: { id: string; name: string; url: string; }; currentProjectKey: string; currentUserName: string; defaultOpen: false; ... 7 more ...; onNavigateUrl: (path: string, state?: any) => void | Promise<...>; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<ScopeSwitcherApp> & Pick<Readonly<Props> & Readonly<...>, "children" | ... 3 more ... | "onBoardClick"> & Partial<...> & Partial<...>'.
        boardsInLocation: [
            currentBoard
        ],
        currentBoard: currentBoard,
        currentProjectKey: projectKey,
        currentUserName: currentUser.accountId ?? '',
        defaultOpen: false,
        isCreateBoardEnabled: !currentUser.isAnonymous,
        isLocationUser: false,
        isSearchEnabled: true,
        locale: currentUser.locale,
        locationName: locationName,
        onCreateBoard: onCreateBoard,
        onBoardClick: onBoardClick,
        onNavigateUrl: push
    });
};
const $055543892c96669f$export$8d2db9c1a2d8e427 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { data: board } = (0, $fNi03.useBoard)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shouldRender: shouldRender } = (0, $fsi33.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    if (isAnonymous) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055543892c96669f$var$CssFixContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3w19c.default), {
        description: formatMessage((0, $bdAP2.messages).board),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxRCf))), {
            spacing: "spacious",
            label: ""
        })
    }, board?.name ?? ''));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($055543892c96669f$var$ScopeSwitcher, null);
};
const $055543892c96669f$var$CssFixContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1lfu1kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gxRCf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b897b2ce2a13d32e1a5cc9d6fdc4caf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0b9516cf1171a18$var$_react = $c0b9516cf1171a18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c0b9516cf1171a18$var$_boards = $c0b9516cf1171a18$var$_interopRequireDefault((parcelRequire("5O4Cz")));

var $c0b9516cf1171a18$var$_switcher = $c0b9516cf1171a18$var$_interopRequireDefault((parcelRequire("48BvJ")));
function $c0b9516cf1171a18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BoardsIcon.
 * This component is BoardsIcon, with `UNSAFE_fallbackIcon` set to "SwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved as the icon to represent multiple boards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c0b9516cf1171a18$var$BoardsIcon = (props)=>/*#__PURE__*/ $c0b9516cf1171a18$var$_react.default.createElement($c0b9516cf1171a18$var$_boards.default, Object.assign({
        LEGACY_fallbackIcon: $c0b9516cf1171a18$var$_switcher.default
    }, props));
$c0b9516cf1171a18$var$BoardsIcon.Name = 'BoardsIconMigration';
var $c0b9516cf1171a18$var$_default = module.exports.default = $c0b9516cf1171a18$var$BoardsIcon;

});
parcelRegister("5O4Cz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::645b121bd5918c466000b65adda09490>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43a534ec1ea58c3e$var$_react = $43a534ec1ea58c3e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $43a534ec1ea58c3e$var$_baseNew = $43a534ec1ea58c3e$var$_interopRequireDefault((parcelRequire("enEmH")));
function $43a534ec1ea58c3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Boards".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved as the icon to represent multiple boards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43a534ec1ea58c3e$var$BoardsIcon = (props)=>/*#__PURE__*/ $43a534ec1ea58c3e$var$_react.default.createElement($43a534ec1ea58c3e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h1.833v-7zm3.333 0v7h2.334v-7zm3.834 0v7H11a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm14.5 7.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75" clip-rule="evenodd"/>`
    }, props));
$43a534ec1ea58c3e$var$BoardsIcon.displayName = 'BoardsIcon';
var $43a534ec1ea58c3e$var$_default = module.exports.default = $43a534ec1ea58c3e$var$BoardsIcon;

});

parcelRegister("48BvJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $303501aaf8749311$var$_react = $303501aaf8749311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $303501aaf8749311$var$_boards = $303501aaf8749311$var$_interopRequireDefault((parcelRequire("5O4Cz")));
function $303501aaf8749311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $303501aaf8749311$var$SwitcherIcon = (props)=>/*#__PURE__*/ $303501aaf8749311$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M3.507 15H16.5c-.007 0-.007-10-.007-10H3.5c.007 0 .007 10 .007 10M1.5 4.994C1.5 3.893 2.263 3 3.192 3h13.616c.934 0 1.692.895 1.692 1.994v10.012c0 1.101-.763 1.994-1.692 1.994H3.192c-.934 0-1.692-.895-1.692-1.994zM6.5 5v10h2V5zm5 0v10h2V5z"/><path d="M20.5 5h.006c1.101 0 1.994.895 1.994 1.994v12.012A1.995 1.995 0 0 1 20.506 21H8.494A1.995 1.995 0 0 1 6.5 19.006V19h13c.555 0 1-.448 1-1z"/></g></svg>`
    }, props, {
        newIcon: $303501aaf8749311$var$_boards.default
    }));
$303501aaf8749311$var$SwitcherIcon.displayName = 'SwitcherIcon';
var $303501aaf8749311$var$_default = module.exports.default = $303501aaf8749311$var$SwitcherIcon;

});


parcelRegister("3w19c", function(module, exports) {

$parcel$export(module.exports, "Container", () => $54b2e099858dbc74$export$42a852a2b6b56249);
$parcel$export(module.exports, "default", () => $54b2e099858dbc74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bY5Mc = parcelRequire("bY5Mc");
const $54b2e099858dbc74$var$styles = {
    header: "_vrjt140y _1cmd10s3 _1cg71wug _11kj1w7a _jl2n73ad _1et61w7a _1v6j10s3"
};
const $54b2e099858dbc74$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps,
        children: children
    }));
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $54b2e099858dbc74$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ...props,
        ref: ref,
        component: props.component || $54b2e099858dbc74$export$42a852a2b6b56249,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: {
            Title: {
                // eslint-disable-next-line @atlaskit/design-system/use-heading
                render: (_, { children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("h2", {
                        ...props,
                        children: children
                    })
            }
        },
        className: (0, $bwpsq.default)([
            $54b2e099858dbc74$var$styles.header
        ])
    });
});
var $54b2e099858dbc74$export$2e2bcd8739ae039 = $54b2e099858dbc74$var$Header;

});

parcelRegister("1ADgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a5ce13af6407cab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
const $7a5ce13af6407cab$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a5ce13af6407cab$export$2e2bcd8739ae039 = async ()=>{
    // eslint-disable-next-line jira/wrm/no-load-bridge
    const module = await (0, $7T84i.loadBridgeStrict)({
        name: $7a5ce13af6407cab$var$amdModuleName,
        wrmKeys: [
            'wrc!com.pyxis.greenhopper.jira:gh-create-board'
        ]
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return module.openCreateBoardModal();
};

});

parcelRegister("3zdOn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f9d3f4c22394aed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jD5no = parcelRequire("jD5no");

var $Lkw08 = parcelRequire("Lkw08");

var $2rxWW = parcelRequire("2rxWW");

var $36kWF = parcelRequire("36kWF");

var $iMWMK = parcelRequire("iMWMK");
// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
const $1f9d3f4c22394aed$var$mapBoard = ({ id: id, ...rest })=>({
        id: String(id),
        ...rest
    });
class $1f9d3f4c22394aed$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isCreateBoardEnabled: false,
            isLocationUser: false,
            baseUrl: '',
            defaultOpen: false,
            projectName: '',
            onCreateBoard: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onNavigateUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $36kWF.default)((0, $Lkw08.default));
        this.setUpContext(props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setUpContext(nextProps);
    }
    setUpContext(props) {
        const { baseUrl: baseUrl, currentBoard: currentBoard, onBoardClick: onBoardClick, onNavigateUrl: onNavigateUrl, currentProjectKey: currentProjectKey } = props;
        this.store.dispatch((0, $2rxWW.setUpContext)({
            baseUrl: baseUrl,
            // @ts-expect-error - TS2322 - Type '{ id: string; } | undefined' is not assignable to type 'Board | undefined'.
            currentBoard: currentBoard ? $1f9d3f4c22394aed$var$mapBoard(currentBoard) : currentBoard,
            onBoardClick: onBoardClick,
            onNavigateUrl: onNavigateUrl,
            currentProjectKey: currentProjectKey
        }));
    }
    render() {
        const { defaultOpen: defaultOpen, isCreateBoardEnabled: isCreateBoardEnabled, isLocationUser: isLocationUser, onCreateBoard: onCreateBoard, locationName: locationName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMWMK.default), {
            // @ts-expect-error - Property 'defaultOpen' does not exist on props
            defaultOpen: defaultOpen,
            isLocationUser: isLocationUser,
            locationName: locationName,
            hasCreateBoardButton: isCreateBoardEnabled,
            onCreateBoard: onCreateBoard
        }));
    }
}

});
parcelRegister("Lkw08", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c73c2efd424dd26$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $9qKDu = parcelRequire("9qKDu");

var $iYER9 = parcelRequire("iYER9");

var $6u1OS = parcelRequire("6u1OS");

var $kNymF = parcelRequire("kNymF");

var $hln65 = parcelRequire("hln65");
var $7c73c2efd424dd26$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, $iYER9.fetchInitialBoardsEpic), (0, $hln65.searchBoardsEpic), (0, $9qKDu.onItemClick), (0, $6u1OS.loadMoreEpic), (0, $kNymF.retryEpic));

});
parcelRegister("9qKDu", function(module, exports) {

$parcel$export(module.exports, "onItemClick", () => $3df5c92d10e7b8f9$export$20c413ae3260f4f0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $3df5c92d10e7b8f9$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.item-click';
const $3df5c92d10e7b8f9$export$20c413ae3260f4f0 = (action$, store)=>action$.ofType((0, $2rxWW.ITEM_CLICKED)).mergeMap((action)=>{
        const { id: id, isViewAll: isViewAll } = action.payload;
        const state = store.getState();
        const onNavigateUrl = (0, $1oWhI.getOnNavigateUrl)(state);
        // view all was clicked
        if (isViewAll) {
            onNavigateUrl((0, $1oWhI.getViewAllUrl)(state));
            return (0, $kVLXA.Observable).empty();
        }
        // board was clicked
        const board = (0, $1oWhI.getBoardById)(state, id);
        if (!board) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData($3df5c92d10e7b8f9$export$103bedf43ba882db, 'Tried to click on board which does not exist');
            return (0, $kVLXA.Observable).empty();
        }
        const onBoardClick = (0, $1oWhI.getOnBoardClick)(state);
        onBoardClick(board, (0, $1oWhI.isBoardInLocation)(state, board));
        return (0, $kVLXA.Observable).of((0, $2rxWW.setRecentlyClickedItem)(id));
    });

});
parcelRegister("2rxWW", function(module, exports) {

$parcel$export(module.exports, "FETCH_INITIAL_BOARDS", () => $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd);
$parcel$export(module.exports, "fetchInitialBoards", () => $2c2ab6c7d54a4c3f$export$3590168539f726b6);
$parcel$export(module.exports, "START_FETCHING_INITIAL_BOARDS", () => $2c2ab6c7d54a4c3f$export$20604d59ee87223);
$parcel$export(module.exports, "startFetchingInitialBoards", () => $2c2ab6c7d54a4c3f$export$64d54000aec63db2);
$parcel$export(module.exports, "INITIAL_BOARDS_FETCHED", () => $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5);
$parcel$export(module.exports, "initialBoardsFetched", () => $2c2ab6c7d54a4c3f$export$dbfcdbabfdf3bf51);
$parcel$export(module.exports, "INITIAL_BOARDS_FETCH_FAILURE", () => $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9);
$parcel$export(module.exports, "initialBoardsFetchFailure", () => $2c2ab6c7d54a4c3f$export$211b282993bd486e);
$parcel$export(module.exports, "SET_UP_CONTEXT", () => $2c2ab6c7d54a4c3f$export$29b131a6dc592198);
$parcel$export(module.exports, "setUpContext", () => $2c2ab6c7d54a4c3f$export$7f11c4a72483f26e);
$parcel$export(module.exports, "ITEM_CLICKED", () => $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8);
$parcel$export(module.exports, "itemClicked", () => $2c2ab6c7d54a4c3f$export$a69a8075bfb04cc8);
$parcel$export(module.exports, "SET_RECENTLY_CLICKED_ITEM", () => $2c2ab6c7d54a4c3f$export$ead64e29386c273);
$parcel$export(module.exports, "setRecentlyClickedItem", () => $2c2ab6c7d54a4c3f$export$9ee49063ac41671c);
$parcel$export(module.exports, "SEARCH_CHANGED", () => $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20);
$parcel$export(module.exports, "changeSearch", () => $2c2ab6c7d54a4c3f$export$423e386eae2eeca4);
$parcel$export(module.exports, "SEARCH_SUCCESS", () => $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45);
$parcel$export(module.exports, "searchSuccess", () => $2c2ab6c7d54a4c3f$export$538de7f69e830e13);
$parcel$export(module.exports, "SEARCH_FAILURE", () => $2c2ab6c7d54a4c3f$export$8799d6d9051924fe);
$parcel$export(module.exports, "searchFailure", () => $2c2ab6c7d54a4c3f$export$6634344b3cfbac37);
$parcel$export(module.exports, "LOAD_MORE", () => $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312);
$parcel$export(module.exports, "loadMore", () => $2c2ab6c7d54a4c3f$export$b346ae7c9d204e07);
$parcel$export(module.exports, "LOAD_MORE_SUCCESS", () => $2c2ab6c7d54a4c3f$export$af8844515dcab66a);
$parcel$export(module.exports, "loadMoreSuccess", () => $2c2ab6c7d54a4c3f$export$352633e2f9f75426);
$parcel$export(module.exports, "LOAD_MORE_FAILURE", () => $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13);
$parcel$export(module.exports, "loadMoreFailure", () => $2c2ab6c7d54a4c3f$export$a5ef50c2daec45c6);
$parcel$export(module.exports, "FETCHED_BOARD_OWNER_ACCOUNT_ID", () => $2c2ab6c7d54a4c3f$export$17fef7ac68281f47);
$parcel$export(module.exports, "fetchedBoardOwnerAccountId", () => $2c2ab6c7d54a4c3f$export$b23c0c6b4bd9a29b);
$parcel$export(module.exports, "RETRY", () => $2c2ab6c7d54a4c3f$export$49428740fd4b1483);
$parcel$export(module.exports, "retry", () => $2c2ab6c7d54a4c3f$export$9369b12211e1fce4);
const $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd = 'state.FETCH_INITIAL_BOARDS';
const $2c2ab6c7d54a4c3f$export$3590168539f726b6 = (forceRetrieve = false)=>({
        type: $2c2ab6c7d54a4c3f$export$5814f5dbd0e4defd,
        payload: forceRetrieve
    });
const $2c2ab6c7d54a4c3f$export$20604d59ee87223 = 'state.START_FETCHING_INITIAL_BOARDS';
const $2c2ab6c7d54a4c3f$export$64d54000aec63db2 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$20604d59ee87223
    });
const $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5 = 'state.INITIAL_BOARDS_FETCHED';
const $2c2ab6c7d54a4c3f$export$dbfcdbabfdf3bf51 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$87e24a43d036c1e5,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9 = 'state.INITIAL_BOARDS_FETCH_FAILURE';
const $2c2ab6c7d54a4c3f$export$211b282993bd486e = ()=>({
        type: $2c2ab6c7d54a4c3f$export$4a4c0d78288f6cc9
    });
const $2c2ab6c7d54a4c3f$export$29b131a6dc592198 = 'state.SET_UP_CONTEXT';
const $2c2ab6c7d54a4c3f$export$7f11c4a72483f26e = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$29b131a6dc592198,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8 = 'state.ITEM_CLICKED';
const $2c2ab6c7d54a4c3f$export$a69a8075bfb04cc8 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$2851e3c0f224fb8,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$ead64e29386c273 = 'state.SET_RECENTLY_CLICKED_ITEM';
const $2c2ab6c7d54a4c3f$export$9ee49063ac41671c = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$ead64e29386c273,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20 = 'state.SEARCH_CHANGED';
const $2c2ab6c7d54a4c3f$export$423e386eae2eeca4 = (search)=>({
        type: $2c2ab6c7d54a4c3f$export$a3d24dda7ab3bf20,
        payload: search
    });
const $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45 = 'state.SEARCH_SUCCESS';
const $2c2ab6c7d54a4c3f$export$538de7f69e830e13 = (inLocation, notInLocation)=>({
        type: $2c2ab6c7d54a4c3f$export$bcf46bdbaf9ada45,
        payload: {
            inLocation: inLocation,
            notInLocation: notInLocation
        }
    });
const $2c2ab6c7d54a4c3f$export$8799d6d9051924fe = 'state.SEARCH_FAILURE';
const $2c2ab6c7d54a4c3f$export$6634344b3cfbac37 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$8799d6d9051924fe
    });
const $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312 = 'state.LOAD_MORE';
const $2c2ab6c7d54a4c3f$export$b346ae7c9d204e07 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$64a7c8ea6b049312
    });
const $2c2ab6c7d54a4c3f$export$af8844515dcab66a = 'state.LOAD_MORE_SUCCESS';
const $2c2ab6c7d54a4c3f$export$352633e2f9f75426 = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$af8844515dcab66a,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13 = 'state.LOAD_MORE_FAILURE';
const $2c2ab6c7d54a4c3f$export$a5ef50c2daec45c6 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$66c2ca6df6311f13
    });
const $2c2ab6c7d54a4c3f$export$17fef7ac68281f47 = 'state.FETCHED_BOARD_OWNER_ACCOUNT_ID';
const $2c2ab6c7d54a4c3f$export$b23c0c6b4bd9a29b = (payload)=>({
        type: $2c2ab6c7d54a4c3f$export$17fef7ac68281f47,
        payload: payload
    });
const $2c2ab6c7d54a4c3f$export$49428740fd4b1483 = 'state.RETRY';
const $2c2ab6c7d54a4c3f$export$9369b12211e1fce4 = ()=>({
        type: $2c2ab6c7d54a4c3f$export$49428740fd4b1483
    });

});

parcelRegister("1oWhI", function(module, exports) {

$parcel$export(module.exports, "getInitialBoardsProps", () => $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3);
$parcel$export(module.exports, "getBaseUrl", () => $6eebaf74836a76d2$export$f654b28f82155665);
$parcel$export(module.exports, "getBoardsInLocation", () => $6eebaf74836a76d2$export$2ada7be29e6d80c3);
$parcel$export(module.exports, "isBoardInLocation", () => $6eebaf74836a76d2$export$cafdce7d03168152);
$parcel$export(module.exports, "getOnNavigateUrl", () => $6eebaf74836a76d2$export$dcfbefab6f455ad3);
$parcel$export(module.exports, "getOnBoardClick", () => $6eebaf74836a76d2$export$d2238358884d2e10);
$parcel$export(module.exports, "getRecentBoards", () => $6eebaf74836a76d2$export$bf57948c9c2c2673);
$parcel$export(module.exports, "wereInitialBoardsFetched", () => $6eebaf74836a76d2$export$26420cdb4a84f7af);
$parcel$export(module.exports, "isLoadingInitialBoards", () => $6eebaf74836a76d2$export$559b671f5355707b);
$parcel$export(module.exports, "getSelectedBoard", () => $6eebaf74836a76d2$export$2789c573cd3f4849);
$parcel$export(module.exports, "getBoardById", () => $6eebaf74836a76d2$export$5a42d7caeec6e4e3);
$parcel$export(module.exports, "getLocationType", () => $6eebaf74836a76d2$export$a396f8065cc6929f);
$parcel$export(module.exports, "getLocationKey", () => $6eebaf74836a76d2$export$b134c52b507d6901);
$parcel$export(module.exports, "shouldLoadBoardOwnerAccountId", () => $6eebaf74836a76d2$export$e20cc77952fdf4ad);
$parcel$export(module.exports, "getRecentlyClickedBoard", () => $6eebaf74836a76d2$export$c1276a6838e2c69a);
$parcel$export(module.exports, "getViewAllUrl", () => $6eebaf74836a76d2$export$96e8b39eed587a1e);
$parcel$export(module.exports, "getSearchValue", () => $6eebaf74836a76d2$export$879e545af11703e9);
$parcel$export(module.exports, "getSearchResults", () => $6eebaf74836a76d2$export$cfcc0908d6dfb8a6);
$parcel$export(module.exports, "isSearchUsed", () => $6eebaf74836a76d2$export$e611265f491331e2);
$parcel$export(module.exports, "shouldRetryLoadMore", () => $6eebaf74836a76d2$export$5ffd0b29710da22a);
$parcel$export(module.exports, "getShowMoreStartAt", () => $6eebaf74836a76d2$export$14d8d5f03e067455);
$parcel$export(module.exports, "isLoadingMore", () => $6eebaf74836a76d2$export$86270845ad5760df);
$parcel$export(module.exports, "isLoading", () => $6eebaf74836a76d2$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $6eebaf74836a76d2$export$e6127cc7fe7395c3);

var $jrHLm = parcelRequire("jrHLm");
const $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3 = (state)=>state.initialBoards;
const $6eebaf74836a76d2$export$327c9d9fb55ff015 = (state)=>state.currentProjectKey;
const $6eebaf74836a76d2$export$f654b28f82155665 = (state)=>state.baseUrl;
const $6eebaf74836a76d2$export$2ada7be29e6d80c3 = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).inLocation.values;
const $6eebaf74836a76d2$export$cafdce7d03168152 = (state, board)=>$6eebaf74836a76d2$export$2ada7be29e6d80c3(state).includes(board);
const $6eebaf74836a76d2$export$dcfbefab6f455ad3 = (state)=>state.onNavigateUrl;
const $6eebaf74836a76d2$export$d2238358884d2e10 = (state)=>state.onBoardClick;
const $6eebaf74836a76d2$export$bf57948c9c2c2673 = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).recent;
const $6eebaf74836a76d2$export$26420cdb4a84f7af = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).wereFetched;
const $6eebaf74836a76d2$export$559b671f5355707b = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).isInProgress;
const $6eebaf74836a76d2$export$56a1664ae598b02d = (state)=>state.boardOwnerAccountId;
const $6eebaf74836a76d2$export$2789c573cd3f4849 = (state)=>state.currentBoard;
const $6eebaf74836a76d2$export$5a42d7caeec6e4e3 = (state, id)=>{
    if (!id) return undefined;
    const test = (board)=>board.id === id;
    return $6eebaf74836a76d2$export$2ada7be29e6d80c3(state).find(test) || $6eebaf74836a76d2$export$bf57948c9c2c2673(state).find(test) || state.searchResults && (state.searchResults.inLocation.values.find(test) || state.searchResults.notInLocation.values.find(test));
};
const $6eebaf74836a76d2$export$a396f8065cc6929f = (state)=>$6eebaf74836a76d2$export$327c9d9fb55ff015(state) ? (0, $jrHLm.ProjectLocation) : (0, $jrHLm.UserAccountLocation);
const $6eebaf74836a76d2$export$b134c52b507d6901 = (state)=>{
    switch($6eebaf74836a76d2$export$a396f8065cc6929f(state)){
        case 0, $jrHLm.ProjectLocation:
            return $6eebaf74836a76d2$export$327c9d9fb55ff015(state);
        default:
            return $6eebaf74836a76d2$export$56a1664ae598b02d(state);
    }
};
const $6eebaf74836a76d2$export$e20cc77952fdf4ad = (state)=>$6eebaf74836a76d2$export$a396f8065cc6929f(state) === (0, $jrHLm.UserAccountLocation) && !$6eebaf74836a76d2$export$56a1664ae598b02d(state);
const $6eebaf74836a76d2$export$a8e22a0e0ed1bd80 = (state)=>state.recentlyClickedItem;
const $6eebaf74836a76d2$export$c1276a6838e2c69a = (state)=>$6eebaf74836a76d2$export$5a42d7caeec6e4e3(state, $6eebaf74836a76d2$export$a8e22a0e0ed1bd80(state));
const $6eebaf74836a76d2$export$96e8b39eed587a1e = (state)=>`${$6eebaf74836a76d2$export$f654b28f82155665(state)}/jira/boards`;
const $6eebaf74836a76d2$export$97866788cd97f572 = (state)=>state.isSearchInProgress;
const $6eebaf74836a76d2$export$879e545af11703e9 = (state)=>state.searchValue;
const $6eebaf74836a76d2$export$cfcc0908d6dfb8a6 = (state)=>state.searchResults;
const $6eebaf74836a76d2$export$e611265f491331e2 = (state)=>!!state.searchValue;
const $6eebaf74836a76d2$export$5ffd0b29710da22a = (state)=>state.shouldRetryLoadMore;
const $6eebaf74836a76d2$export$14d8d5f03e067455 = (state)=>($6eebaf74836a76d2$export$e611265f491331e2(state) ? $6eebaf74836a76d2$export$cfcc0908d6dfb8a6(state) : $6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state)).inLocation.values.length;
const $6eebaf74836a76d2$export$86270845ad5760df = (state)=>state.isLoadMoreInProgress;
const $6eebaf74836a76d2$export$20bb0d907fbbe433 = (state)=>$6eebaf74836a76d2$export$559b671f5355707b(state) || $6eebaf74836a76d2$export$97866788cd97f572(state) || $6eebaf74836a76d2$export$86270845ad5760df(state) && $6eebaf74836a76d2$export$5ffd0b29710da22a(state);
const $6eebaf74836a76d2$export$e491bc2266c085a5 = (state)=>state.hasSearchError;
const $6eebaf74836a76d2$export$fb8d5f0b5308c34c = (state)=>$6eebaf74836a76d2$export$e7ef9b75e4bfbaf3(state).hasError;
const $6eebaf74836a76d2$export$465c38c1cadb2c7e = (state)=>!$6eebaf74836a76d2$export$86270845ad5760df(state) && $6eebaf74836a76d2$export$5ffd0b29710da22a(state);
const $6eebaf74836a76d2$export$e6127cc7fe7395c3 = (state)=>$6eebaf74836a76d2$export$465c38c1cadb2c7e(state) || ($6eebaf74836a76d2$export$e611265f491331e2(state) ? $6eebaf74836a76d2$export$e491bc2266c085a5(state) : $6eebaf74836a76d2$export$fb8d5f0b5308c34c(state));

});
parcelRegister("jrHLm", function(module, exports) {

$parcel$export(module.exports, "toAccountId", () => $83fc60eeaef6ba2c$export$ef1795c9a6f7e7ac);
$parcel$export(module.exports, "ProjectLocation", () => $83fc60eeaef6ba2c$export$3591918cb507380e);
$parcel$export(module.exports, "UserAccountLocation", () => $83fc60eeaef6ba2c$export$2beadc9ea8da06d9);
const $83fc60eeaef6ba2c$export$ef1795c9a6f7e7ac = (value)=>value;
const $83fc60eeaef6ba2c$export$3591918cb507380e = 'ProjectLocation';
const $83fc60eeaef6ba2c$export$2beadc9ea8da06d9 = 'UserAccountLocation';

});



parcelRegister("iYER9", function(module, exports) {

$parcel$export(module.exports, "fetchInitialBoardsEpic", () => $ba4e4217d796e0bf$export$37ce36869151db6c);
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("jFVZ1");
parcelRequire("1oQta");
parcelRequire("6cbqE");
parcelRequire("7Ts1V");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $6LMGB = parcelRequire("6LMGB");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $c4lIk = parcelRequire("c4lIk");
const $ba4e4217d796e0bf$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.fetch-initial-boards';
const $ba4e4217d796e0bf$export$e87d47297085325a = 15;
const $ba4e4217d796e0bf$export$e13b7e981bb78af = 'navigation-v2.scope-switcher-v2.browser-metrics.fetch-initial-boards';
const $ba4e4217d796e0bf$export$37ce36869151db6c = (action$, store)=>action$.ofType((0, $2rxWW.FETCH_INITIAL_BOARDS)).filter(({ payload: forceRetrieve })=>{
        const state = store.getState();
        const wereRecentBoardsFetched = (0, $1oWhI.wereInitialBoardsFetched)(state);
        const isLoadingRecentBoards = (0, $1oWhI.isLoadingInitialBoards)(state);
        return forceRetrieve || !wereRecentBoardsFetched && !isLoadingRecentBoards;
    }).switchMap(()=>{
        const fetchBoards$ = (locationKey)=>{
            const state = store.getState();
            const baseUrl = (0, $1oWhI.getBaseUrl)(state);
            const locationType = (0, $1oWhI.getLocationType)(state);
            const promise = Promise.all([
                (0, $6LMGB.default)(baseUrl, $ba4e4217d796e0bf$export$e87d47297085325a),
                (0, $l9eSS.default)(baseUrl, undefined, locationType, locationKey)
            ]);
            return (0, $kVLXA.Observable).fromPromise(promise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([recentBoards, boardsInLocation])=>(0, $2rxWW.initialBoardsFetched)({
                    recentBoards: recentBoards,
                    boardsInLocation: boardsInLocation
                })).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($ba4e4217d796e0bf$export$103bedf43ba882db, error.message, error);
                return (0, $kVLXA.Observable).of((0, $2rxWW.initialBoardsFetchFailure)());
            });
        };
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2rxWW.startFetchingInitialBoards)()), (0, $c4lIk.default)(store, fetchBoards$, (errorMessage)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($ba4e4217d796e0bf$export$103bedf43ba882db, errorMessage);
            return (0, $2rxWW.initialBoardsFetchFailure)();
        }));
    });

});
parcelRegister("6LMGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd5a7fe6a380d03b$export$2e2bcd8739ae039);

var $4fqrH = parcelRequire("4fqrH");

var $7v1um = parcelRequire("7v1um");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd5a7fe6a380d03b$export$2e2bcd8739ae039 = async (baseUrl, count)=>{
    const { views: views } = await (0, $4fqrH.default)(baseUrl, count);
    return (0, $7v1um.transformRecentBoards)(views);
};

});
parcelRegister("4fqrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7464b4ae610982b9$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
const $7464b4ae610982b9$export$fdddad2cffdefc0b = (baseUrl)=>`${baseUrl}/rest/greenhopper/1.0/rapidviews/recent`;
const $7464b4ae610982b9$export$94df0e59ebebf4a7 = (baseUrl, count)=>`${$7464b4ae610982b9$export$fdddad2cffdefc0b(baseUrl)}?maxResults=${count}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7464b4ae610982b9$export$2e2bcd8739ae039 = async (baseUrl, count)=>{
    const url = $7464b4ae610982b9$export$94df0e59ebebf4a7(baseUrl, count);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (response.ok) return response.json();
    const text = await response.text();
    throw new (0, $jJZqs.default)(response.status, text);
};

});

parcelRegister("7v1um", function(module, exports) {

$parcel$export(module.exports, "transformRecentBoards", () => $5c9e244b8019ba05$export$3d2bb25369a121ce);

var $iJiqx = parcelRequire("iJiqx");
const $5c9e244b8019ba05$var$USER_TYPE_BOARD = 'user';
const $5c9e244b8019ba05$export$3d2bb25369a121ce = (recentBoards)=>recentBoards.map(({ id: id, name: name, isSimpleBoard: isSimpleBoard, location: { displayText: locationName, avatarUrl: locationAvatarUrl, type: type, accountId: accountId, locationKey: locationKey } })=>({
            id: String(id),
            name: name,
            url: (0, $iJiqx.createBoardUrl)(id, locationKey, accountId, isSimpleBoard),
            isLocationUser: type === $5c9e244b8019ba05$var$USER_TYPE_BOARD,
            locationName: locationName,
            locationAvatarUrl: locationAvatarUrl
        }));

});
parcelRegister("iJiqx", function(module, exports) {

$parcel$export(module.exports, "createBoardUrl", () => $500481c9a17afa22$export$7037e05c8c7af6dc);
const $500481c9a17afa22$export$7037e05c8c7af6dc = (boardId, locationKey, accountId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isNextGenBoard)=>{
    if (isNextGenBoard) return `/jira/software/projects/${locationKey}/boards/${boardId}`;
    if (accountId != null) return `/jira/people/${accountId}/boards/${boardId}`;
    if (locationKey) return `/jira/software/c/projects/${locationKey}/boards/${boardId}`;
    return `/secure/RapidBoard.jspa?rapidView=${boardId}&useStoredSettings=true&locationless=true`;
};

});



parcelRegister("l9eSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1c97bd43e2c2c27$export$2e2bcd8739ae039);

var $iLGQh = parcelRequire("iLGQh");

var $rw2sW = parcelRequire("rw2sW");
const $f1c97bd43e2c2c27$var$searchBoards = async (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering = false, startAt = 0)=>{
    const response = await (0, $iLGQh.default)(baseUrl, search, locationType, locationKey, negateLocationFiltering, startAt);
    return (0, $rw2sW.transformSearchResponseBoards)(response);
};
var $f1c97bd43e2c2c27$export$2e2bcd8739ae039 = $f1c97bd43e2c2c27$var$searchBoards;

});
parcelRegister("iLGQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b46142d6e0453a3$export$2e2bcd8739ae039);

var $ebyGx = parcelRequire("ebyGx");

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");


var $jrHLm = parcelRequire("jrHLm");
const $6b46142d6e0453a3$export$fdddad2cffdefc0b = (baseUrl)=>`${baseUrl}/rest/agile/1.0/board`;
const $6b46142d6e0453a3$var$getLocationQueryParamName = (locationType)=>{
    switch(locationType){
        case 0, $jrHLm.ProjectLocation:
            return 'projectLocation';
        case 0, $jrHLm.UserAccountLocation:
            return 'accountIdLocation';
        default:
            return 'usernameLocation';
    }
};
const $6b46142d6e0453a3$export$94df0e59ebebf4a7 = (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering, startAt)=>{
    const locationParamName = $6b46142d6e0453a3$var$getLocationQueryParamName(locationType);
    const params = {
        ...search ? {
            name: search
        } : {},
        negateLocationFiltering: negateLocationFiltering,
        orderBy: (0, $ab186e26e08820dd$export$129fc3a353d7068b),
        maxResults: (0, $ab186e26e08820dd$export$b476a41a1b575909),
        startAt: startAt,
        [locationParamName]: locationKey,
        overrideFilterPermissions: true
    };
    const rawUrl = $6b46142d6e0453a3$export$fdddad2cffdefc0b(baseUrl);
    return `${rawUrl}?${(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(params)}`;
};
const $6b46142d6e0453a3$var$getSearchBoards = async (baseUrl, search, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
locationType, locationKey, negateLocationFiltering = false, startAt = 0)=>{
    const url = $6b46142d6e0453a3$export$94df0e59ebebf4a7(baseUrl, search, locationType, locationKey, negateLocationFiltering, startAt);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        throw new (0, $jJZqs.default)(response.status, text);
    }
    return response.json();
};
var $6b46142d6e0453a3$export$2e2bcd8739ae039 = $6b46142d6e0453a3$var$getSearchBoards;

});
const $ab186e26e08820dd$export$129fc3a353d7068b = 'name';
const $ab186e26e08820dd$export$b476a41a1b575909 = 15;


parcelRegister("rw2sW", function(module, exports) {

$parcel$export(module.exports, "transformSearchResponseBoards", () => $b368d39b4af2df13$export$8c349928f06a6ca8);

var $iJiqx = parcelRequire("iJiqx");
const $b368d39b4af2df13$export$8c349928f06a6ca8 = (response)=>{
    const { values: values, total: total } = response;
    const boards = values.map(({ id: id, name: name, location: location, type: type })=>({
            id: String(id),
            name: name,
            url: (0, $iJiqx.createBoardUrl)(id, location && location.projectKey || '', location?.userAccountId, type === 'simple'),
            ...location ? {
                locationName: location.name,
                isLocationUser: !!location.userId,
                locationAvatarUrl: location.avatarURI
            } : {}
        }));
    return {
        values: boards,
        total: total
    };
};

});


parcelRegister("c4lIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec29f4b678456a3$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $er6iG = parcelRequire("er6iG");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9ec29f4b678456a3$export$2e2bcd8739ae039 = (store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
locationKeyConsumer$, onFailure)=>{
    const state = store.getState();
    const baseUrl = (0, $1oWhI.getBaseUrl)(state);
    const selectedBoard = (0, $1oWhI.getSelectedBoard)(state);
    if ((0, $1oWhI.shouldLoadBoardOwnerAccountId)(state)) {
        if (!selectedBoard) return (0, $kVLXA.Observable).of(onFailure('Cannot fetch board owner account id if there is no selected board'));
        return (0, $kVLXA.Observable).fromPromise((0, $er6iG.default)(baseUrl, selectedBoard.id)).mergeMap((accountId)=>(0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2rxWW.fetchedBoardOwnerAccountId)(accountId)), locationKeyConsumer$(accountId))).catch((error)=>(0, $kVLXA.Observable).of(onFailure(error.message)));
    }
    const locationKey = (0, $1oWhI.getLocationKey)(state);
    if (!locationKey) return (0, $kVLXA.Observable).of(onFailure('Cannot find current location key'));
    return locationKeyConsumer$(locationKey);
};

});
parcelRegister("er6iG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9acb3e420aa6b6f2$export$2e2bcd8739ae039);

var $ivv3h = parcelRequire("ivv3h");

var $siKDy = parcelRequire("siKDy");
const $9acb3e420aa6b6f2$var$searchBoards = async (baseUrl, boardId)=>{
    const response = await (0, $ivv3h.default)(baseUrl, boardId);
    return (0, $siKDy.transformUserAccountFromBoard)(baseUrl, response);
};
var $9acb3e420aa6b6f2$export$2e2bcd8739ae039 = $9acb3e420aa6b6f2$var$searchBoards;

});
parcelRegister("ivv3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b019e5276160391c$export$2e2bcd8739ae039);

var $jJZqs = parcelRequire("jJZqs");

var $5HnTq = parcelRequire("5HnTq");
const $b019e5276160391c$export$94df0e59ebebf4a7 = (baseUrl, boardId)=>`${baseUrl}/rest/agile/1.0/board/${boardId}`;
const $b019e5276160391c$var$getBoard = async (baseUrl, boardId)=>{
    const url = $b019e5276160391c$export$94df0e59ebebf4a7(baseUrl, boardId);
    const response = await fetch(url, (0, $5HnTq.getDefaultOptions)(url));
    if (!response.ok) {
        const text = await response.text();
        throw new (0, $jJZqs.default)(response.status, text);
    }
    return response.json();
};
var $b019e5276160391c$export$2e2bcd8739ae039 = $b019e5276160391c$var$getBoard;

});

parcelRegister("siKDy", function(module, exports) {

$parcel$export(module.exports, "transformUserAccountFromBoard", () => $2803ec68a897e024$export$33865eda98273d51);

var $jrHLm = parcelRequire("jrHLm");
const $2803ec68a897e024$export$33865eda98273d51 = (baseUrl, response)=>{
    if (response && response.location && response.location.userAccountId) return (0, $jrHLm.toAccountId)(response.location.userAccountId);
    throw new Error('Expected userAccountId to appear in the response');
};

});




parcelRegister("6u1OS", function(module, exports) {

$parcel$export(module.exports, "loadMoreEpic", () => $387184df5fa5af72$export$e73907735bd2fde0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("7qVV7");
parcelRequire("c66Ur");
parcelRequire("7Ts1V");

var $2YZCu = parcelRequire("2YZCu");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $387184df5fa5af72$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.load-more';
const $387184df5fa5af72$export$e13b7e981bb78af = 'navigation-apps.scope-switcher-v2.browser-metrics.load-more';
const $387184df5fa5af72$export$e73907735bd2fde0 = (action$, store)=>{
    const stopActions$ = action$.ofType((0, $2rxWW.SEARCH_CHANGED));
    return action$.ofType((0, $2rxWW.LOAD_MORE)).mergeMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $1oWhI.getBaseUrl)(state);
        const locationType = (0, $1oWhI.getLocationType)(state);
        const locationKey = (0, $1oWhI.getLocationKey)(state);
        const value = (0, $1oWhI.isSearchUsed)(state) ? (0, $1oWhI.getSearchValue)(state) : undefined;
        const startAt = (0, $1oWhI.getShowMoreStartAt)(state);
        if (!locationKey) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData($387184df5fa5af72$export$103bedf43ba882db, 'Location key does not exist');
            return (0, $kVLXA.Observable).of((0, $2rxWW.loadMoreFailure)());
        }
        return (0, $kVLXA.Observable).fromPromise((0, $l9eSS.default)(baseUrl, value, locationType, locationKey, false, startAt)).mergeMap((inLocation)=>(0, $kVLXA.Observable).of((0, $2rxWW.loadMoreSuccess)(inLocation))).takeUntil(stopActions$).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($387184df5fa5af72$export$103bedf43ba882db, error.message, error);
            return (0, $kVLXA.Observable).of((0, $2rxWW.loadMoreFailure)());
        });
    });
};

});

parcelRegister("kNymF", function(module, exports) {

$parcel$export(module.exports, "retryEpic", () => $2cec3f4512347eb6$export$df8d455716799b54);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");
const $2cec3f4512347eb6$export$df8d455716799b54 = (action$, store)=>// @ts-expect-error - TS2322 - Type 'Observable<LoadMoreAction>' is not assignable to type 'Observable<State>'. | TS2345 - Argument of type '() => Observable<LoadMoreAction> | Observable<SearchChangedAction>' is not assignable to parameter of type '(value: State, index: number) => ObservableInput<LoadMoreAction>'.
    action$.ofType((0, $2rxWW.RETRY)).mergeMap(()=>{
        const state = store.getState();
        const isSearchUsed = (0, $1oWhI.isSearchUsed)(state);
        const searchValue = (0, $1oWhI.getSearchValue)(state);
        const shouldRetryLoadMore = (0, $1oWhI.shouldRetryLoadMore)(state);
        if (shouldRetryLoadMore) return (0, $kVLXA.Observable).of((0, $2rxWW.loadMore)());
        if (isSearchUsed) return (0, $kVLXA.Observable).of((0, $2rxWW.changeSearch)(searchValue));
        // @ts-expect-error - TS2769 - No overload matches this call.
        return (0, $kVLXA.Observable).of((0, $2rxWW.changeSearch)(''), (0, $2rxWW.fetchInitialBoards)());
    });

});

parcelRegister("hln65", function(module, exports) {

$parcel$export(module.exports, "searchBoardsEpic", () => $481bde5902701fc2$export$c6cd5fc1f50be3d4);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("7Ts1V");

var $2YZCu = parcelRequire("2YZCu");

var $l9eSS = parcelRequire("l9eSS");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $c4lIk = parcelRequire("c4lIk");
const $481bde5902701fc2$export$103bedf43ba882db = 'navigation-apps.scope-switcher-v2.search-boards';
const $481bde5902701fc2$export$e13b7e981bb78af = 'navigation-apps.scope-switcher-v2.browser-metrics.search-boards';
const $481bde5902701fc2$export$c6cd5fc1f50be3d4 = (action$, store)=>action$.ofType((0, $2rxWW.SEARCH_CHANGED)).filter(({ payload: value })=>!!value.length).mergeMap(()=>{
        const searchBoards$ = (locationKey)=>{
            const state = store.getState();
            const baseUrl = (0, $1oWhI.getBaseUrl)(state);
            const search = (0, $1oWhI.getSearchValue)(state);
            const locationType = (0, $1oWhI.getLocationType)(state);
            const searchBoardsPromise = Promise.all([
                (0, $l9eSS.default)(baseUrl, search, locationType, locationKey),
                (0, $l9eSS.default)(baseUrl, search, locationType, locationKey, true)
            ]);
            return (0, $kVLXA.Observable).fromPromise(searchBoardsPromise) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(([searchedBoardsInLocation, searchedBoardsNotInLocation])=>(0, $2rxWW.searchSuccess)(searchedBoardsInLocation, searchedBoardsNotInLocation)).catch((error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($481bde5902701fc2$export$103bedf43ba882db, error.message, error);
                return (0, $kVLXA.Observable).of((0, $2rxWW.searchFailure)());
            });
        };
        return (0, $c4lIk.default)(store, searchBoards$, (errorMessage)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($481bde5902701fc2$export$103bedf43ba882db, errorMessage);
            return (0, $2rxWW.searchFailure)();
        });
    });

});


parcelRegister("36kWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbc94c2b34701a21$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $aB8eX = parcelRequire("aB8eX");

var $e1AU2 = parcelRequire("e1AU2");

var $iGv2H = parcelRequire("iGv2H");

var $hkadP = parcelRequire("hkadP");

var $ac3n8 = parcelRequire("ac3n8");

var // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$fbc94c2b34701a21$export$2e2bcd8739ae039 = (rootOperation)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const middlewares = [];
    if ((0, $iGv2H.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("korqb"));
        middlewares.push(logger);
    }
    return (0, $3f2cs.createStore)((0, $aB8eX.enableBatching)((0, $ac3n8.default)), (0, $ac3n8.initialState), (0, $hkadP.default)({
        name: 'ScopeSwitcher'
    })((0, $3f2cs.applyMiddleware)(...middlewares, (0, $e1AU2.createEpicMiddleware)(rootOperation))));
};

});
parcelRegister("ac3n8", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $ff6d7c7bd67ca8f0$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $3JOCw = parcelRequire("3JOCw");

var $2rxWW = parcelRequire("2rxWW");
const $ff6d7c7bd67ca8f0$var$emptyBoardsList = ()=>({
        values: [],
        total: 0
    });
const $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a = {
    currentProjectKey: undefined,
    initialBoards: {
        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
        recent: [],
        wereFetched: false,
        isInProgress: false,
        hasError: false
    },
    currentBoard: undefined,
    searchResults: {
        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
        notInLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList()
    },
    boardOwnerAccountId: undefined,
    isSearchInProgress: false,
    isLoadMoreInProgress: false,
    shouldRetryLoadMore: false,
    hasSearchError: false,
    searchValue: '',
    viewAllUrl: '',
    baseUrl: '',
    recentlyClickedItem: undefined,
    // @ts-expect-error - TS2322 - Type '(...args: any[]) => void' is not assignable to type 'OnBoardClick'.
    onBoardClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onNavigateUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $ff6d7c7bd67ca8f0$var$patchInitialBoards = (state, initialBoardsPatch)=>({
        ...state,
        initialBoards: {
            ...state.initialBoards,
            ...initialBoardsPatch
        }
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ff6d7c7bd67ca8f0$export$2e2bcd8739ae039 = (state = $ff6d7c7bd67ca8f0$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2rxWW.SET_UP_CONTEXT:
            {
                const { boardsInLocation: boardsInLocation, ...rest } = action.payload;
                return {
                    ...state,
                    ...rest,
                    initialBoards: {
                        ...state.initialBoards,
                        ...boardsInLocation ? {
                            inLocation: boardsInLocation
                        } : Object.freeze({})
                    }
                };
            }
        case 0, $2rxWW.START_FETCHING_INITIAL_BOARDS:
            return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                isInProgress: true,
                hasError: false
            });
        case 0, $2rxWW.INITIAL_BOARDS_FETCHED:
            {
                const { recentBoards: recentBoards, boardsInLocation: boardsInLocation } = action.payload;
                return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                    recent: recentBoards,
                    hasError: false,
                    wereFetched: true,
                    isInProgress: false,
                    ...boardsInLocation ? {
                        inLocation: boardsInLocation
                    } : {}
                });
            }
        case 0, $2rxWW.INITIAL_BOARDS_FETCH_FAILURE:
            return $ff6d7c7bd67ca8f0$var$patchInitialBoards(state, {
                isInProgress: false,
                hasError: true
            });
        case 0, $2rxWW.SET_RECENTLY_CLICKED_ITEM:
            return {
                ...state,
                recentlyClickedItem: action.payload
            };
        case 0, $2rxWW.SEARCH_CHANGED:
            {
                const value = action.payload;
                return {
                    ...state,
                    searchValue: value,
                    isSearchInProgress: !!value.length,
                    hasSearchError: false,
                    shouldRetryLoadMore: false,
                    isLoadMoreInProgress: false,
                    searchResults: {
                        inLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList(),
                        notInLocation: $ff6d7c7bd67ca8f0$var$emptyBoardsList()
                    }
                };
            }
        case 0, $2rxWW.SEARCH_SUCCESS:
            {
                const { inLocation: inLocation, notInLocation: notInLocation } = action.payload;
                return {
                    ...state,
                    isSearchInProgress: false,
                    searchResults: {
                        inLocation: inLocation,
                        notInLocation: notInLocation
                    }
                };
            }
        case 0, $2rxWW.SEARCH_FAILURE:
            return {
                ...state,
                isSearchInProgress: false,
                hasSearchError: true
            };
        case 0, $2rxWW.LOAD_MORE:
            return {
                ...state,
                hasSearchError: false,
                isLoadMoreInProgress: true
            };
        case 0, $2rxWW.LOAD_MORE_SUCCESS:
            {
                const { values: values, total: total } = action.payload;
                const isSearchUsed = !!state.searchValue;
                const sourceValues = isSearchUsed ? state.searchResults : state.initialBoards;
                const mergedValues = [
                    ...sourceValues.inLocation.values,
                    ...values
                ];
                const uniqueValues = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(mergedValues, 'id');
                const results = {
                    ...sourceValues,
                    inLocation: {
                        values: uniqueValues,
                        total: total
                    }
                };
                const propName = isSearchUsed ? 'searchResults' : 'initialBoards';
                return {
                    ...state,
                    isLoadMoreInProgress: false,
                    shouldRetryLoadMore: false,
                    [propName]: results
                };
            }
        case 0, $2rxWW.LOAD_MORE_FAILURE:
            return {
                ...state,
                isLoadMoreInProgress: false,
                shouldRetryLoadMore: true
            };
        case 0, $2rxWW.FETCHED_BOARD_OWNER_ACCOUNT_ID:
            return {
                ...state,
                boardOwnerAccountId: action.payload
            };
        default:
            return state;
    }
};

});


parcelRegister("iMWMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda143c1c6fb22f6$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8lxl7 = parcelRequire("8lxl7");

var $bC2fB = parcelRequire("bC2fB");

var $2rxWW = parcelRequire("2rxWW");

var $1oWhI = parcelRequire("1oWhI");

var $Gyl50 = parcelRequire("Gyl50");

var $bu0aF = parcelRequire("bu0aF");
const $bda143c1c6fb22f6$var$mapStateToProps = (state)=>({
        boardsInLocation: (0, $Gyl50.getBoardsInLocation)(state),
        otherBoards: (0, $Gyl50.getOtherBoards)(state),
        selectedBoard: (0, $Gyl50.getSelectedBoard)(state),
        isLoading: (0, $1oWhI.isLoading)(state),
        isLoadingMore: (0, $1oWhI.isLoadingMore)(state),
        viewAllUrl: (0, $1oWhI.getViewAllUrl)(state),
        searchValue: (0, $1oWhI.getSearchValue)(state),
        isError: (0, $1oWhI.isError)(state),
        isSearchUsed: (0, $1oWhI.isSearchUsed)(state),
        hasShowMoreButton: (0, $Gyl50.hasShowMoreButton)(state),
        shouldRetryLoadMore: (0, $1oWhI.shouldRetryLoadMore)(state),
        remainingShowMoreBoards: (0, $Gyl50.getRemainingShowMoreBoards)(state)
    });
const $bda143c1c6fb22f6$var$mapDispatchToProps = (dispatch)=>({
        fetchInitialBoards: ()=>{
            dispatch((0, $2rxWW.fetchInitialBoards)());
        },
        searchBoards: (value)=>{
            dispatch((0, $2rxWW.changeSearch)(value));
        },
        loadMore: ()=>{
            dispatch((0, $2rxWW.loadMore)());
        },
        onClick: ({ isViewAll: isViewAll, key: key })=>{
            dispatch((0, $2rxWW.itemClicked)({
                isViewAll: !!isViewAll,
                id: key
            }));
        },
        onRetry: ()=>{
            dispatch((0, $2rxWW.retry)());
        }
    });
var $bda143c1c6fb22f6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8lxl7.default)((state)=>({
        attributes: {
            recentBoards: (0, $Gyl50.getRecentBoards)(state).length,
            boardsInLocation: (0, $Gyl50.getBoardsInLocation)(state).length,
            searchUsed: (0, $1oWhI.isSearchUsed)(state)
        }
    })), (0, $bC2fB.connect)($bda143c1c6fb22f6$var$mapStateToProps, $bda143c1c6fb22f6$var$mapDispatchToProps))(// @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "locationName" | "viewAllUrl" | "boardsInLocation" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "defaultOpen" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'. | Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "viewAllUrl" | "boardsInLocation" | "locationName" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "searchValue" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'.
(0, $bu0aF.default));

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $htBRZ = parcelRequire("htBRZ");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htBRZ.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


parcelRegister("Gyl50", function(module, exports) {

$parcel$export(module.exports, "getRecentBoards", () => $66b88e1dc4fa1893$export$bf57948c9c2c2673);
$parcel$export(module.exports, "getSelectedBoard", () => $66b88e1dc4fa1893$export$2789c573cd3f4849);
$parcel$export(module.exports, "getOtherBoards", () => $66b88e1dc4fa1893$export$10ebe9a8b9514a80);
$parcel$export(module.exports, "getBoardsInLocation", () => $66b88e1dc4fa1893$export$2ada7be29e6d80c3);
$parcel$export(module.exports, "getRemainingShowMoreBoards", () => $66b88e1dc4fa1893$export$774c7c0b6f4ac73f);
$parcel$export(module.exports, "hasShowMoreButton", () => $66b88e1dc4fa1893$export$a55a1a6294071229);

var $dGvGJ = parcelRequire("dGvGJ");


var $1oWhI = parcelRequire("1oWhI");
const $66b88e1dc4fa1893$export$bf57948c9c2c2673 = (0, $dGvGJ.createSelector)((0, $1oWhI.getRecentBoards), (0, $1oWhI.getBoardsInLocation), (recentBoards, boardsInLocation)=>{
    const isBoardIncluded = ({ id: id }, boards)=>boards.findIndex((board)=>board.id === id) !== -1;
    return recentBoards.filter((board)=>!isBoardIncluded(board, boardsInLocation));
});
const $66b88e1dc4fa1893$export$2789c573cd3f4849 = (state)=>(0, $1oWhI.getSelectedBoard)(state) || (0, $1oWhI.getRecentlyClickedBoard)(state);
const $66b88e1dc4fa1893$export$10ebe9a8b9514a80 = (state)=>{
    if ((0, $1oWhI.isSearchUsed)(state)) return (0, $1oWhI.getSearchResults)(state).notInLocation.values;
    return $66b88e1dc4fa1893$export$bf57948c9c2c2673(state);
};
const $66b88e1dc4fa1893$export$2ada7be29e6d80c3 = (state)=>{
    if ((0, $1oWhI.isSearchUsed)(state)) return (0, $1oWhI.getSearchResults)(state).inLocation.values;
    return (0, $1oWhI.getBoardsInLocation)(state);
};
const $66b88e1dc4fa1893$export$774c7c0b6f4ac73f = (state)=>{
    const { values: values, total: total } = (0, $1oWhI.isSearchUsed)(state) ? (0, $1oWhI.getSearchResults)(state).inLocation : (0, $1oWhI.getInitialBoardsProps)(state).inLocation;
    return Math.min(total - values.length, (0, $ab186e26e08820dd$export$b476a41a1b575909));
};
const $66b88e1dc4fa1893$export$a55a1a6294071229 = (state)=>$66b88e1dc4fa1893$export$774c7c0b6f4ac73f(state) > 0;

});

parcelRegister("bu0aF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49de1b2ac0fb057$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3xeqi = parcelRequire("3xeqi");

var $aqJO7 = parcelRequire("aqJO7");

var $iQv12 = parcelRequire("iQv12");

var $az4zD = parcelRequire("az4zD");

var $lXKEd = parcelRequire("lXKEd");

var $3vvFM = parcelRequire("3vvFM");

var $dymxi = parcelRequire("dymxi");

var $hjSul = parcelRequire("hjSul");

var $8aG9X = parcelRequire("8aG9X");
const $f49de1b2ac0fb057$var$before = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqJO7))), {
        label: "",
        color: "currentColor"
    });
const $f49de1b2ac0fb057$var$transformBoardInLocation = (board)=>({
        text: board.name,
        key: board.id,
        before: $f49de1b2ac0fb057$var$before,
        url: board.url
    });
const $f49de1b2ac0fb057$var$transformBoardNotInLocation = (board, subText)=>({
        text: board.name,
        key: board.id,
        subText: subText,
        before: $f49de1b2ac0fb057$var$before,
        url: board.url
    });
const $f49de1b2ac0fb057$var$getLastLetter = (name)=>name ? name.toLowerCase().slice(-1) : '';
const $f49de1b2ac0fb057$var$SwitcherWithAnalytics = (0, $iQv12.default)((0, $lXKEd.default)('board'))((0, $3vvFM.default)); // eslint-disable-next-line jira/react/no-class-components
class $f49de1b2ac0fb057$export$985572cc065dac8f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isLocationUser: false,
            isLoading: false,
            isLoadingMore: false,
            isSearchUsed: false,
            isError: false,
            hasCreateBoardButton: false,
            hasShowMoreButton: false,
            remainingShowMoreBoards: 0,
            defaultOpen: false,
            selectedBoard: undefined,
            searchValue: '',
            fetchInitialBoards: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            searchBoards: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            loadMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCreateBoard: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getCreateLabel() {
        const { hasCreateBoardButton: hasCreateBoardButton, intl: { formatMessage: formatMessage } } = this.props;
        if (hasCreateBoardButton) return formatMessage((0, $8aG9X.default).createBoard);
        return undefined;
    }
    getBoardsInLocationLabel() {
        const { locationName: locationName, isLocationUser: isLocationUser, intl: { formatMessage: formatMessage } } = this.props;
        if (this.areBoardsInLocationEmpty()) return undefined;
        if (!isLocationUser) return formatMessage((0, $8aG9X.default).labelBoardsInProjectLocation, {
            locationName: locationName
        });
        return formatMessage((0, $8aG9X.default).labelBoardsInUserLocationNew, {
            locationName: locationName,
            lastLetter: $f49de1b2ac0fb057$var$getLastLetter(locationName)
        });
    }
    getOtherBoardLocationDescription(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { locationName: locationName, isLocationUser: isLocationUser } = board;
        if (!locationName) return '';
        if (!isLocationUser) return formatMessage((0, $8aG9X.default).projectLocationDescription, {
            location: board.locationName
        });
        return formatMessage((0, $8aG9X.default).userLocationDescriptionNew, {
            locationName: locationName,
            lastLetter: $f49de1b2ac0fb057$var$getLastLetter(locationName)
        });
    }
    getListHeading() {
        const { locationName: locationName, isSearchUsed: isSearchUsed, boardsInLocation: boardsInLocation, otherBoards: otherBoards, intl: { formatMessage: formatMessage } } = this.props;
        const areThereEmptySearchResults = isSearchUsed && !(boardsInLocation.length + otherBoards.length);
        if (areThereEmptySearchResults) return formatMessage((0, $8aG9X.default).searchNoMatchesFound);
        if (!isSearchUsed && this.areBoardsInLocationEmpty()) return formatMessage((0, $8aG9X.default).locationDoesNotHaveBoard, {
            location: locationName
        });
        return undefined;
    }
    areBoardsInLocationEmpty() {
        return this.props.boardsInLocation.length === 0;
    }
    createOptions() {
        const { boardsInLocation: boardsInLocation, otherBoards: otherBoards, hasShowMoreButton: hasShowMoreButton, isLoadingMore: isLoadingMore, remainingShowMoreBoards: remainingShowMoreBoards, intl: { formatMessage: formatMessage } } = this.props;
        const curriedTransformBoardNotInLocation = (board)=>$f49de1b2ac0fb057$var$transformBoardNotInLocation(board, this.getOtherBoardLocationDescription(board));
        const showMore = {
            isLoading: isLoadingMore,
            label: formatMessage((0, $8aG9X.default).showMore, {
                remainingBoards: remainingShowMoreBoards
            })
        };
        return [
            boardsInLocation.length && {
                label: this.getBoardsInLocationLabel(),
                options: boardsInLocation.map($f49de1b2ac0fb057$var$transformBoardInLocation),
                ...hasShowMoreButton ? {
                    showMore: showMore
                } : {}
            },
            otherBoards.length && {
                label: this.createHeaderLabel(),
                options: otherBoards.map(curriedTransformBoardNotInLocation)
            }
        ].filter(Boolean);
    }
    createViewAll() {
        const { intl: { formatMessage: formatMessage }, viewAllUrl: viewAllUrl } = this.props;
        return {
            withoutTopMargin: true,
            options: [
                {
                    text: formatMessage((0, $8aG9X.default).viewAllBoards),
                    key: '-1',
                    url: viewAllUrl,
                    isViewAll: true
                }
            ]
        };
    }
    createHeaderLabel() {
        const { intl: { formatMessage: formatMessage }, viewAllUrl: viewAllUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f49de1b2ac0fb057$var$GroupHeadingLabel, null, formatMessage((0, $8aG9X.default).otherRecentBoards)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
            href: viewAllUrl,
            className: (0, $bwpsq.default)([
                "_kcon1kw7 _kq8jidpf _1laeidpf _1byqidpf"
            ])
        }, formatMessage((0, $8aG9X.default).viewAll)));
    }
    render() {
        const { selectedBoard: selectedBoard, defaultOpen: defaultOpen, isLoading: isLoading, isError: isError, onCreateBoard: onCreateBoard, onClick: onClick, onRetry: onRetry, searchValue: searchValue, loadMore: loadMore, intl: { formatMessage: formatMessage } } = this.props;
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dymxi.default), {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xeqi))),
            text: selectedBoard ? selectedBoard.name : formatMessage((0, $8aG9X.default).boards),
            subText: selectedBoard ? formatMessage((0, $8aG9X.default).board) : undefined
        }); // eslint-disable-next-line no-else-return
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f49de1b2ac0fb057$var$SwitcherWithAnalytics // @ts-expect-error - Type '({ showMore?: { isLoading: boolean; label: string; } | undefined; label: string | undefined; options: Item[]; } | { label: Element; options: Item[]; })[]' is not assignable to type 'ItemGroup[]'.
        , {
            items: this.createOptions(),
            isLoading: isLoading,
            selectedItem: selectedBoard ? $f49de1b2ac0fb057$var$transformBoardInLocation(selectedBoard) : undefined,
            createLabel: this.getCreateLabel(),
            searchValue: searchValue,
            searchPlaceholder: formatMessage((0, $8aG9X.default).searchPlaceholder),
            onClick: onClick,
            listHeading: this.getListHeading(),
            renderTrigger: this.renderTrigger,
            isDefaultOpen: defaultOpen,
            onOpenChange: this.onOpenChange,
            onCreate: onCreateBoard,
            isSearchEnabled: true,
            onSearchChange: this.onSearchChange,
            onRetry: onRetry,
            isError: isError,
            errorMessage: formatMessage((0, $8aG9X.default).errorMessage),
            onShowMore: loadMore
        });
    }
    constructor(...args){
        super(...args), this.onSearchChange = (value)=>{
            const { searchBoards: searchBoards, fetchInitialBoards: fetchInitialBoards } = this.props;
            if (value && value.length) searchBoards(value);
            else {
                searchBoards('');
                fetchInitialBoards();
            }
        }, this.onOpenChange = ({ isOpen: isOpen })=>{
            if (isOpen) this.props.fetchInitialBoards();
        }, this.renderTrigger = ({ isOpen: isOpen, targetRef: targetRef })=>{
            const { selectedBoard: selectedBoard, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                "data-test-id": "navigation-apps.scope-switcher-v2",
                "data-testid": "navigation-apps.scope-switcher-v2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dymxi.default), {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3xeqi))),
                text: selectedBoard ? selectedBoard.name : formatMessage((0, $8aG9X.default).boards),
                subText: selectedBoard ? formatMessage((0, $8aG9X.default).board) : undefined,
                isOpen: isOpen,
                targetRef: targetRef
            }));
        };
    }
}
var $f49de1b2ac0fb057$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($f49de1b2ac0fb057$export$985572cc065dac8f);
const $f49de1b2ac0fb057$var$GroupHeadingLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _u5f3u2gc _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $f49de1b2ac0fb057$var$linkStyles = null;

});
parcelRegister("3xeqi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbfaa58603b784789054dd0f73c52c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $292fa44e241ea235$var$_react = $292fa44e241ea235$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $292fa44e241ea235$var$_appSwitcher = $292fa44e241ea235$var$_interopRequireDefault((parcelRequire("hbr4z")));

var $292fa44e241ea235$var$_switcher = $292fa44e241ea235$var$_interopRequireDefault((parcelRequire("48BvJ")));
function $292fa44e241ea235$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "SwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $292fa44e241ea235$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $292fa44e241ea235$var$_react.default.createElement($292fa44e241ea235$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $292fa44e241ea235$var$_switcher.default
    }, props));
$292fa44e241ea235$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $292fa44e241ea235$var$_default = module.exports.default = $292fa44e241ea235$var$AppSwitcherIcon;

});

parcelRegister("iQv12", function(module, exports) {

$parcel$export(module.exports, "default", () => $945500a9598c3ac2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gvRPW = parcelRequire("gvRPW");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $gvRPW.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $5uXOq.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;

});

parcelRegister("az4zD", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $90dc1bd887533804$export$440265f0ca78e98e);
/* eslint-disable @typescript-eslint/consistent-type-assertions */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $5uXOq = parcelRequire("5uXOq");

var $dY8Js = parcelRequire("dY8Js");

var $koVbs = parcelRequire("koVbs");
const $90dc1bd887533804$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
function $90dc1bd887533804$var$getDisplayName(Component) {
    if ($90dc1bd887533804$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($90dc1bd887533804$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $90dc1bd887533804$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intl = (0, $koVbs.default)();
        const intlRef = (0, $5uXOq.useRef)(null);
        if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
        if (!intlRef.current) intlRef.current = {
            // @ts-expect-error We force v5 messages type on v2 type
            messages: intl.messages,
            locale: intl.locale,
            formats: intl.formats,
            formatDate: intl.formatDate,
            formatMessage: intl.formatMessage,
            formatNumber: intl.formatNumber,
            formatPlural: intl.formatPlural,
            formatTime: intl.formatTime
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            intl: intlRef.current,
            ref: withRef ? props.forwardedRef : null
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$90dc1bd887533804$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dY8Js)))(WithIntl, WrappedComponent);
};

});

parcelRegister("lXKEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $01f84629bca4dd45$export$2e2bcd8739ae039);

var $e4eHl = parcelRequire("e4eHl");

var $26Zd8 = parcelRequire("26Zd8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$01f84629bca4dd45$export$2e2bcd8739ae039 = (switcherType)=>{
    const camelCaseName = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(switcherType);
    const pascalCaseName = (0, (/*@__PURE__*/$parcel$interopDefault($26Zd8)))(camelCaseName);
    const onClick = ({ isViewAll: isViewAll }, sectionIndex)=>({
            name: camelCaseName,
            isViewAll: !!isViewAll,
            sectionIndex: sectionIndex
        });
    const onOpenChange = ({ isOpen: isOpen })=>({
            name: camelCaseName,
            isOpen: isOpen
        });
    const onClose = ({ closedWithoutInteracting: closedWithoutInteracting })=>({
            name: camelCaseName,
            closedWithoutInteracting: closedWithoutInteracting
        });
    const onSearchChange = (search)=>({
            name: camelCaseName,
            inputLength: search.length
        });
    return {
        onOpenChange: onOpenChange,
        onClose: onClose,
        onClick: onClick,
        onSearchChange: onSearchChange,
        onShowMore: `showMore${pascalCaseName}`,
        onCreate: `create${pascalCaseName}`,
        onRetry: `retry${pascalCaseName}`
    };
};

});

parcelRegister("3vvFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c763073d1299d22$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $fW7cr = parcelRequire("fW7cr");

var $8Rkzz = parcelRequire("8Rkzz");

var $b1kcy = parcelRequire("b1kcy");
var $1JbQI = parcelRequire("1JbQI");

var $8oe80 = parcelRequire("8oe80");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");


var $4HmJy = parcelRequire("4HmJy");

var $dAYGO = parcelRequire("dAYGO");

var $bTOZt = parcelRequire("bTOZt");

var $48kqC = parcelRequire("48kqC");

var $6rDs9 = parcelRequire("6rDs9");

var $9dtoa = parcelRequire("9dtoa");

var $gzFa5 = parcelRequire("gzFa5");

var $15ZDY = parcelRequire("15ZDY");

var $bv5KO = parcelRequire("bv5KO");
const $2c763073d1299d22$var$createButtonHeight = 52; // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c763073d1299d22$var$isOptionSelected = (option, selected)=>selected && selected.length === 1 && option.key === selected[0].key;
const $2c763073d1299d22$var$filterOption = ()=>true;
class $2c763073d1299d22$export$e313913ef2c28083 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDefaultOpen: false,
            isLoading: false,
            isSearchEnabled: false,
            isError: false,
            items: undefined,
            createLabel: '',
            searchValue: '',
            searchPlaceholder: '',
            errorMessage: '',
            selectedItem: undefined,
            listHeading: undefined,
            onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSearchChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onShowMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        if (this.props.isDefaultOpen) this.onOpen();
    }
    componentDidUpdate(prevProps) {
        // UI code
        const { searchValue: searchValue } = this.props;
        if (prevProps.searchValue !== searchValue) // this is guarded, so it's legit
        this.setState({
            searchValue: searchValue
        });
         // Analytics code
        if (this.state.isOpen) {
            // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasBoardSwitcherBeenOpened.current = true;
            if (!this.prevSwitcherOpenStateRef.current) {
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaClickRef.current = null; // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current = null;
            }
        } else // eslint-disable-next-line no-lonely-if
        if (!this.hasUserInteractedWithSwitcherViaClickRef.current && !this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current && this.hasBoardSwitcherBeenOpened.current) this.props.onClose({
            closedWithoutInteracting: true
        });
         // Analytics code
        // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
        this.prevSwitcherOpenStateRef.current = this.state.isOpen;
    }
    onOpenChange({ isOpen: isOpen }) {
        if (this.state.isOpen === isOpen) return;
        this.setState({
            isOpen: isOpen,
            lastMenuHeight: null
        });
        this.props.onOpenChange({
            isOpen: isOpen
        });
    }
    getMenuHeight() {
        return this.isCreateButtonAvailable() ? $2c763073d1299d22$var$menuHeight - $2c763073d1299d22$var$createButtonHeight : $2c763073d1299d22$var$menuHeight;
    }
    getLoadingHeight() {
        const { lastMenuHeight: lastMenuHeight } = this.state;
        if (lastMenuHeight) return lastMenuHeight;
        return this.getMenuHeight() - (0, $4HmJy.controlHeight);
    }
    closeSwitcher() {
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.popupRef.current && this.popupRef.current.close();
    }
    isCreateButtonAvailable() {
        return !!this.props.createLabel;
    }
    popperProps() {
        const placement = 'bottom-start';
        return {
            placement: placement,
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 5,
                        mainAxis: false // true by default
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            (0, $gwIPs.gridSize)
                        ]
                    }
                },
                {
                    name: 'hide',
                    options: {
                        padding: 5
                    }
                },
                {
                    name: 'flip',
                    options: {
                        padding: 5
                    }
                }
            ]
        };
    }
    renderFooter() {
        const { createLabel: createLabel } = this.props;
        return this.isCreateButtonAvailable() && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTOZt.default), {
            label: createLabel,
            onClick: this.onCreate
        });
    }
    render() {
        const { isLoading: isLoading, selectedItem: selectedItem, items: items, renderTrigger: renderTrigger, onMouseEnter: onMouseEnter } = this.props;
        const { isOpen: isOpen, searchValue: searchValue, triggerWidth: triggerWidth } = this.state;
        const onFocus = (onFocusProps, defaultOptions)=>{
            const { focused: focused } = onFocusProps;
            const isOptionFocused = (option)=>option.text === focused.text;
            const groupData = defaultOptions?.find((option)=>option.options?.some(isOptionFocused));
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            return `Option ${this.getOptionLabel(focused)}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
        }; // Helper function which identifies if options are grouped.
        const isOptionsGrouped = (arr)=>arr?.every((obj)=>Object.hasOwn(obj, 'options')); // @ts-expect-error - TS7031 - Binding element 'ref' implicitly has an 'any' type.
        const createTriggerRenderer = ({ ref: ref })=>renderTrigger({
                isOpen: isOpen,
                onMouseEnter: onMouseEnter,
                targetRef: ref
            });
        const renderPopupSelect = ()=>// @ts-expect-error - TS2769 - No overload matches this call.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JbQI.default), {
                ref: this.popupRef,
                onOpen: this.onOpen,
                onClose: this.onClose,
                autoFocus: true,
                maxMenuWidth: triggerWidth,
                minMenuWidth: triggerWidth,
                backspaceRemovesValue: false,
                classNamePrefix: "switcher",
                components: {
                    Control: this.renderControl,
                    Input: this.renderInput,
                    DropdownIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    Placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    IndicatorsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    LoadingIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    Option: $bv5KO.default,
                    Menu: this.renderMenu,
                    Group: this.renderGroup,
                    GroupHeading: this.renderGroupHeading,
                    MenuList: this.renderMenuList,
                    LoadingMessage: this.renderLoading,
                    NoOptionsMessage: this.renderLoading
                },
                getOptionLabel: this.getOptionLabel,
                controlShouldRenderValue: false,
                isLoading: isLoading,
                isClearable: false,
                searchThreshold: -1,
                isOptionSelected: $2c763073d1299d22$var$isOptionSelected,
                inputValue: searchValue,
                menuIsOpen: true // react-select does not respect 'isLoading' parameter in not async version
                ,
                // that's why we use NoOptionsMessage to display loading state
                // as we'll always have at least one option - view all link
                options: isLoading || !items ? [] : items,
                maxMenuHeight: this.getMenuHeight(),
                onChange: this.onSelectChange,
                filterOption: $2c763073d1299d22$var$filterOption,
                styles: $2c763073d1299d22$var$selectStyles(),
                tabSelectsValue: false,
                value: selectedItem,
                footer: this.renderFooter(),
                target: createTriggerRenderer,
                popperProps: this.popperProps(),
                defaultIsOpen: this.props.isDefaultOpen,
                ariaLiveMessages: isOptionsGrouped(this.props.items) ? {
                    onFocus: (data)=>onFocus(data, this.props.items)
                } : undefined
            });
        return(// In styled there is used a z-index hack to increase z-index
        // value of components inside SwitcherContainer. More info
        // in styled file
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c763073d1299d22$var$SwitcherContainer, {
            ref: this.switcherRef,
            onClick: this.onClick,
            onKeyDown: this.onKeyDown
        }, renderPopupSelect()));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.isDefaultOpen,
            lastMenuHeight: null,
            searchValue: this.props.searchValue,
            triggerWidth: (0, $gwIPs.gridSize) * 26
        }, // These refs store whether the user has interacted with the switcher or any of its child components
        // via recording whether an onClick or onKeyDown 'Enter' event occurred.
        // These refs are used to measure the analytics of when this component was opened, and then closed without
        // being used.
        // Click and KeyDown must be separated since onClick is called when create a board action is rendered via
        // the Enter key (accessibility usage)
        this.hasBoardSwitcherBeenOpened = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.hasUserInteractedWithSwitcherViaClickRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.prevSwitcherOpenStateRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.hasUserInteractedWithSwitcherViaEnterKeyDownRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.onSearchChange = (value)=>{
            if (value.length) this.debouncedOnChange(value);
            else {
                this.debouncedOnChange.cancel();
                this.props.onSearchChange(value);
            }
            this.setState({
                searchValue: value
            });
        }, this.onOpen = ()=>{
            this.onOpenChange({
                isOpen: true
            });
            if (this.switcherRef.current) {
                const { width: width } = this.switcherRef.current.getBoundingClientRect();
                this.setState({
                    triggerWidth: width
                });
            }
        }, this.onClose = ()=>{
            this.onOpenChange({
                isOpen: false
            });
        }, this.onSelectChange = (value)=>{
            const section = (0, (/*@__PURE__*/$parcel$interopDefault($fW7cr)))(this.props.items, (itemsGroup)=>itemsGroup.options.includes(value));
            this.props.onClick(value, section);
        }, this.onBeforeLoading = ({ height: height })=>{
            this.setState({
                lastMenuHeight: height
            });
        }, this.onCreate = ()=>{
            this.props.onCreate();
            this.closeSwitcher();
        }, this.onClick = ()=>{
            // Analytics code
            // This does not represent a user interaction, so ignore it if the ref has not been initialized
            if (this.hasUserInteractedWithSwitcherViaClickRef.current === null) {
                // Initialize the ref to pick up user interactions
                // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
                this.hasUserInteractedWithSwitcherViaClickRef.current = false;
                return;
            } // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasUserInteractedWithSwitcherViaClickRef.current = true;
        }, this.onKeyDown = (event)=>{
            // Analytics code
            if (event.key === 'Enter' && this.hasUserInteractedWithSwitcherViaClickRef.current !== null) // @ts-expect-error - TS2540 - Cannot assign to 'current' because it is a read-only property.
            this.hasUserInteractedWithSwitcherViaEnterKeyDownRef.current = true;
        }, this.switcherRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.popupRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.debouncedOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(this.props.onSearchChange, (0, $58a8cc6dba6ea954$export$8bd078c872bc40fb)), this.renderLoading = ()=>this.props.isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dtoa.default), {
                height: this.getLoadingHeight()
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderMenuList = (props)=>{
            const { isError: isError, errorMessage: errorMessage, onRetry: onRetry, listHeading: listHeading } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzFa5.default), {
                ...props,
                isError: isError,
                errorMessage: errorMessage,
                listHeading: listHeading,
                onBeforeLoading: this.onBeforeLoading,
                onRetry: onRetry
            });
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderGroupHeading = (props)=>{
            const { children: children, data: data } = props; // Suppressed due to new lint violation when upgrading to eslint-plugin-react-hooks v5
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const { formatMessage: formatMessage } = (0, $koVbs.default)();
            const ariaLabel = children && children[0] ? data?.label : formatMessage((0, $15ZDY.default).otherRecentBoards);
            return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1kcy.components).GroupHeading, {
                ...props,
                role: "group",
                "aria-label": ariaLabel
            }) : null;
        }, this.renderControl = (selectControlProps)=>{
            const { isSearchEnabled: isSearchEnabled } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAYGO.default), {
                isSearchEnabled: isSearchEnabled,
                ...selectControlProps
            });
        }, this.renderInput = (selectInputProps)=>{
            const { searchPlaceholder: searchPlaceholder } = this.props;
            const { searchValue: searchValue } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6rDs9.default), {
                onChange: this.onSearchChange,
                value: searchValue,
                placeholder: searchPlaceholder,
                inputProps: selectInputProps
            });
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.renderGroup = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48kqC.default), {
                ...props,
                onShowMore: this.props.onShowMore
            }), this.renderMenu = (props)=>{
            const { innerRef: innerRef, innerProps: innerProps, children: children } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: innerRef,
                ...innerProps
            }, children);
        }, this.getOptionLabel = (option)=>{
            let label = option.text;
            if (option.subText) label += ` ${option.subText}`;
            return label;
        };
    }
}
var $2c763073d1299d22$export$2e2bcd8739ae039 // This is z-index hack for the navigation
 = (0, $8oe80.default)('switcherMenu', {
    onClick: 'clicked',
    onOpenChange: 'opened',
    onClose: 'closed',
    onCreate: 'clicked',
    onRetry: 'clicked',
    onSearchChange: 'typed',
    onShowMore: 'clicked'
})($2c763073d1299d22$export$e313913ef2c28083);
// In navigation there are some items which are positioned using `z-index`
// and value is the same as popup select
// https://jdog.jira-dev.com/browse/KITKAT-936
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2c763073d1299d22$var$SwitcherContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1gn7zo7u",
            __cmplp.className
        ])
    });
});
const $2c763073d1299d22$var$menuHeight = 53 * (0, $gwIPs.gridSize);
const $2c763073d1299d22$var$selectStyles = ()=>({
        valueContainer: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        menu: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        groupHeading: (defaultStyles)=>({
                ...defaultStyles,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)",
                marginBottom: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: "var(--ds-surface, #FFFFFF)",
                display: 'flex',
                flexDirection: 'row',
                '&&&': {
                    width: 'inherit',
                    display: 'flex'
                }
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        group: (defaultStyles)=>({
                ...defaultStyles,
                paddingTop: 0,
                paddingBottom: 0
            }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        menuList: (defaultStyles)=>({
                ...defaultStyles,
                zIndex: 1,
                position: 'relative',
                paddingTop: 0,
                paddingBottom: 0
            })
    });

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});

parcelRegister("b1kcy", function(module, exports) {

$parcel$export(module.exports, "components", () => $bf570c186c29adcc$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $bf570c186c29adcc$export$71abc632aa29e6fe);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $bf570c186c29adcc$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $6oGQp.ClearIndicator),
    Control: (0, $gGvqh.default),
    DropdownIndicator: (0, $6oGQp.DropdownIndicator),
    Group: (0, $iluyz.default),
    GroupHeading: (0, $iluyz.GroupHeading),
    IndicatorsContainer: (0, $cSGW3.IndicatorsContainer),
    Input: (0, $4S2FY.default),
    LoadingIndicator: (0, $6oGQp.LoadingIndicator),
    Menu: (0, $fW3un.default),
    MenuList: (0, $fW3un.MenuList),
    MenuPortal: (0, $fW3un.MenuPortal),
    LoadingMessage: (0, $fW3un.LoadingMessage),
    NoOptionsMessage: (0, $fW3un.NoOptionsMessage),
    MultiValue: (0, $g6y65.default),
    MultiValueContainer: (0, $g6y65.MultiValueContainer),
    MultiValueLabel: (0, $g6y65.MultiValueLabel),
    MultiValueRemove: (0, $g6y65.MultiValueRemove),
    Option: (0, $FpaWY.default),
    Placeholder: (0, $41aBa.default),
    SelectContainer: (0, $cSGW3.SelectContainer),
    SingleValue: (0, $aPWnT.default),
    ValueContainer: (0, $cSGW3.ValueContainer)
};
const $bf570c186c29adcc$export$71abc632aa29e6fe = (props)=>({
        ...$bf570c186c29adcc$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("cSGW3", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $679454c07f89009f$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $679454c07f89009f$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $679454c07f89009f$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $679454c07f89009f$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $679454c07f89009f$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $679454c07f89009f$export$d0ffd7e649cab6f);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $jKNEb = parcelRequire("jKNEb");

var $8EwEq = parcelRequire("8EwEq");
const $679454c07f89009f$export$949392aeaf7d2e3a = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $jKNEb.containerCSS)() : (0, $8EwEq.containerCSS)(props);
const $679454c07f89009f$export$446eebadefe1123b = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jKNEb.SelectContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8EwEq.SelectContainer), {
        ...props
    });
const $679454c07f89009f$export$47aec73c7aa6b9aa = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $jKNEb.valueContainerCSS)() : (0, $8EwEq.valueContainerCSS)(props);
const $679454c07f89009f$export$4dc9f58ad9a1a000 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jKNEb.ValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8EwEq.ValueContainer), {
        ...props
    });
const $679454c07f89009f$export$9d74e3c8b5868ad7 = ()=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $jKNEb.indicatorsContainerCSS)() : (0, $8EwEq.indicatorsContainerCSS)();
const $679454c07f89009f$export$d0ffd7e649cab6f = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jKNEb.IndicatorsContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8EwEq.IndicatorsContainer), {
        ...props
    });

});
parcelRegister("jKNEb", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $f4ef691fd31960f3$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $f4ef691fd31960f3$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $f4ef691fd31960f3$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $f4ef691fd31960f3$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $f4ef691fd31960f3$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $f4ef691fd31960f3$export$d0ffd7e649cab6f);
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $fHpHg = parcelRequire("fHpHg");

var $b0fMV = parcelRequire("b0fMV");
const $f4ef691fd31960f3$export$949392aeaf7d2e3a = ()=>({});
const $f4ef691fd31960f3$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
const $f4ef691fd31960f3$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $b0fMV.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $f4ef691fd31960f3$var$containerStyles.default,
            isRtl && $f4ef691fd31960f3$var$containerStyles.rtl,
            isDisabled && $f4ef691fd31960f3$var$containerStyles.disabled,
            (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && $f4ef691fd31960f3$var$containerStyles.ff_safari_input_fix,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $f4ef691fd31960f3$export$47aec73c7aa6b9aa = ()=>({});
const $f4ef691fd31960f3$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qidpf _u5f312x7 _n3tdidpf _19bv12x7"
};
const $f4ef691fd31960f3$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $f4ef691fd31960f3$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $f4ef691fd31960f3$var$valueContainerStyles.flex,
            isCompact && $f4ef691fd31960f3$var$valueContainerStyles.compact,
            (0, $DEWI6.cx)(className || 'value-container', xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        children: children
    });
};
const $f4ef691fd31960f3$export$9d74e3c8b5868ad7 = ()=>({});
const $f4ef691fd31960f3$var$indicatorContainerStyles = null;
const $f4ef691fd31960f3$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};

});
parcelRegister("b0fMV", function(module, exports) {

$parcel$export(module.exports, "noop", () => $edcdeb7b1e79d8a8$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $edcdeb7b1e79d8a8$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $edcdeb7b1e79d8a8$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $edcdeb7b1e79d8a8$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $edcdeb7b1e79d8a8$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $edcdeb7b1e79d8a8$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $edcdeb7b1e79d8a8$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $edcdeb7b1e79d8a8$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $edcdeb7b1e79d8a8$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $edcdeb7b1e79d8a8$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $edcdeb7b1e79d8a8$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $edcdeb7b1e79d8a8$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $edcdeb7b1e79d8a8$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $edcdeb7b1e79d8a8$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $edcdeb7b1e79d8a8$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $edcdeb7b1e79d8a8$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $edcdeb7b1e79d8a8$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $edcdeb7b1e79d8a8$export$4213b25a1c4e877);
const $edcdeb7b1e79d8a8$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $edcdeb7b1e79d8a8$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$edcdeb7b1e79d8a8$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $edcdeb7b1e79d8a8$export$33f062f47f21a01 = (value)=>{
    if ($edcdeb7b1e79d8a8$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $edcdeb7b1e79d8a8$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $edcdeb7b1e79d8a8$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $edcdeb7b1e79d8a8$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $edcdeb7b1e79d8a8$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $edcdeb7b1e79d8a8$export$2e0654fad740d2e4(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(el) {
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $edcdeb7b1e79d8a8$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($edcdeb7b1e79d8a8$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $edcdeb7b1e79d8a8$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $edcdeb7b1e79d8a8$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $edcdeb7b1e79d8a8$export$858c30343199f3af(element, to, duration = 200, callback = $edcdeb7b1e79d8a8$export$8793edee2d425525) {
    const start = $edcdeb7b1e79d8a8$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $edcdeb7b1e79d8a8$var$easeOutCubic(currentTime, start, change, duration);
        $edcdeb7b1e79d8a8$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $edcdeb7b1e79d8a8$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $edcdeb7b1e79d8a8$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $edcdeb7b1e79d8a8$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $edcdeb7b1e79d8a8$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $edcdeb7b1e79d8a8$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $edcdeb7b1e79d8a8$var$passiveOptionAccessed = false;
const $edcdeb7b1e79d8a8$var$options = {
    get passive () {
        return $edcdeb7b1e79d8a8$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $edcdeb7b1e79d8a8$var$w = typeof window !== 'undefined' ? window : {};
if ($edcdeb7b1e79d8a8$var$w.addEventListener && $edcdeb7b1e79d8a8$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.addEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, $edcdeb7b1e79d8a8$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $edcdeb7b1e79d8a8$var$w.removeEventListener('p', $edcdeb7b1e79d8a8$export$8793edee2d425525, false);
}
const $edcdeb7b1e79d8a8$export$b0622a6911dbeaf5 = $edcdeb7b1e79d8a8$var$passiveOptionAccessed;
function $edcdeb7b1e79d8a8$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $edcdeb7b1e79d8a8$var$isArray(arg) {
    return Array.isArray(arg);
}
function $edcdeb7b1e79d8a8$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $edcdeb7b1e79d8a8$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $edcdeb7b1e79d8a8$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $edcdeb7b1e79d8a8$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("8EwEq", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $aa1d76c548c1ebd9$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $aa1d76c548c1ebd9$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $aa1d76c548c1ebd9$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $aa1d76c548c1ebd9$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $aa1d76c548c1ebd9$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $aa1d76c548c1ebd9$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $kU1q1 = parcelRequire("kU1q1");

var $b0fMV = parcelRequire("b0fMV");
const $aa1d76c548c1ebd9$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        position: 'relative',
        font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        pointerEvents: 'all',
        cursor: isDisabled ? 'not-allowed' : undefined,
        [`${(0, $kU1q1.media).above.xs}`]: {
            font: (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : undefined
        }
    });
const $aa1d76c548c1ebd9$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $aa1d76c548c1ebd9$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
    });
const $aa1d76c548c1ebd9$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $b0fMV.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $aa1d76c548c1ebd9$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0,
        paddingRight: "var(--ds-space-050, 4px)"
    });
const $aa1d76c548c1ebd9$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});


parcelRegister("gGvqh", function(module, exports) {

$parcel$export(module.exports, "css", () => $fc91e92c64db0b1d$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $fc91e92c64db0b1d$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $CVvJh = parcelRequire("CVvJh");

var $7mkPB = parcelRequire("7mkPB");
const $fc91e92c64db0b1d$export$dbf350e5966cf602 = (props)=>{
    return (0, $fHpHg.fg)('compiled-react-select') ? (0, $CVvJh.css)() : (0, $7mkPB.css)(props);
};
const $fc91e92c64db0b1d$var$Control = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $CVvJh.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7mkPB.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc91e92c64db0b1d$export$2e2bcd8739ae039 = $fc91e92c64db0b1d$var$Control;

});
parcelRegister("CVvJh", function(module, exports) {

$parcel$export(module.exports, "css", () => $b51a0fb4edf1170c$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $b51a0fb4edf1170c$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $b51a0fb4edf1170c$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkosqtm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _jqf6y3o9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123b1h4p _d0altlke _irr31d5g _1oglgxqn",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d3acm _bfhk18uv _1u6lnruj",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d3acm _bfhk18uv _1u6lnruj _4cvx3acm _irr318uv"
};
const $b51a0fb4edf1170c$export$dbf350e5966cf602 = ()=>({});
const $b51a0fb4edf1170c$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $b51a0fb4edf1170c$var$styles.default,
            isDisabled && $b51a0fb4edf1170c$var$styles.disabled,
            isInvalid && $b51a0fb4edf1170c$var$styles.invalid,
            isCompact && $b51a0fb4edf1170c$var$styles.compact,
            appearance === 'subtle' && $b51a0fb4edf1170c$var$styles.subtle,
            appearance === 'subtle' && isFocused && $b51a0fb4edf1170c$var$styles.subtleFocused,
            isFocused && $b51a0fb4edf1170c$var$styles.focused,
            appearance === 'none' && $b51a0fb4edf1170c$var$styles.none,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b51a0fb4edf1170c$export$2e2bcd8739ae039 = $b51a0fb4edf1170c$var$Control;

});

parcelRegister("7mkPB", function(module, exports) {

$parcel$export(module.exports, "css", () => $e56f316e746a9397$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $e56f316e746a9397$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $e56f316e746a9397$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
    let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
    let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
    if (isDisabled) {
        backgroundColor = "var(--ds-background-disabled, #091E4208)";
        borderColor = "var(--ds-background-disabled, #091E4208)";
    }
    if (isInvalid) {
        borderColor = "var(--ds-border-danger, #E2483D)";
        borderColorHover = "var(--ds-border-danger, #E2483D)";
    }
    const transitionDuration = '200ms';
    if (appearance === 'subtle') {
        borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
        backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
        backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
    }
    if (appearance === 'none') {
        borderColor = 'transparent';
        backgroundColor = 'transparent';
        backgroundColorHover = 'transparent';
        borderColorHover = 'transparent';
    }
    return {
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        outline: '0 !important',
        position: 'relative',
        // Turn pointer events off when disabled - this makes it so hover etc don't work.
        pointerEvents: isDisabled ? 'none' : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderStyle: 'solid',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
        '&:focus-within': {
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
        },
        minHeight: isCompact ? 32 : 40,
        padding: 0,
        transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
        '::-webkit-scrollbar': {
            height: 8,
            width: 8
        },
        '::-webkit-scrollbar-corner': {
            display: 'none'
        },
        ':hover': {
            '::-webkit-scrollbar-thumb': {
                // scrollbars occur only if the user passes in a custom component with overflow: scroll
                backgroundColor: 'rgba(0,0,0,0.2)'
            },
            cursor: 'pointer',
            backgroundColor: backgroundColorHover,
            borderColor: borderColorHover
        },
        '::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'rgba(0,0,0,0.4)'
        }
    };
};
const $e56f316e746a9397$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: innerRef,
        ...(0, $b0fMV.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e56f316e746a9397$export$2e2bcd8739ae039 = $e56f316e746a9397$var$Control;

});


parcelRegister("iluyz", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $4652dd5e4b6c9504$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $4652dd5e4b6c9504$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $4652dd5e4b6c9504$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $4652dd5e4b6c9504$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $iyl6P = parcelRequire("iyl6P");

var $8iXnr = parcelRequire("8iXnr");
const $4652dd5e4b6c9504$export$b6794329c1460634 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $iyl6P.groupCSS)() : (0, $8iXnr.groupCSS)(props);
const $4652dd5e4b6c9504$var$Group = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyl6P.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8iXnr.default), {
        ...props
    });
const $4652dd5e4b6c9504$export$e5a7fbb542efcb7d = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $iyl6P.groupHeadingCSS)() : (0, $8iXnr.groupHeadingCSS)(props);
const $4652dd5e4b6c9504$export$85c8b41a3cd87edc = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iyl6P.GroupHeading), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8iXnr.GroupHeading), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4652dd5e4b6c9504$export$2e2bcd8739ae039 = $4652dd5e4b6c9504$var$Group;

});
parcelRegister("iyl6P", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $11976841f939a705$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $11976841f939a705$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $11976841f939a705$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $11976841f939a705$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $11976841f939a705$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $11976841f939a705$export$b6794329c1460634 = ()=>({});
const $11976841f939a705$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $11976841f939a705$var$styles.root,
            (0, $DEWI6.cx)(className, xcss, innerProps?.className)
        ]),
        children: [
            label && /*#__PURE__*/ (0, $2OMIu.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: children
            })
        ]
    });
};
const $11976841f939a705$var$headingStyles = null;
const $11976841f939a705$export$e5a7fbb542efcb7d = ()=>({});
const $11976841f939a705$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _jqf6dpkn _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$11976841f939a705$export$2e2bcd8739ae039 = $11976841f939a705$var$Group;

});

parcelRegister("8iXnr", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $fe409b37f947273f$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $fe409b37f947273f$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $fe409b37f947273f$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $fe409b37f947273f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $fe409b37f947273f$export$b6794329c1460634 = ({})=>({
        paddingBottom: "var(--ds-space-100, 8px)",
        paddingTop: "var(--ds-space-100, 8px)"
    });
const $fe409b37f947273f$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, label && /*#__PURE__*/ (0, $f8Sb3.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", null, children));
};
const $fe409b37f947273f$export$e5a7fbb542efcb7d = ({})=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        marginBottom: '0.25em',
        paddingLeft: "var(--ds-space-150, 12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        color: "var(--ds-text-subtle, #44546F)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textTransform: 'none'
    });
const $fe409b37f947273f$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fe409b37f947273f$export$2e2bcd8739ae039 = $fe409b37f947273f$var$Group;

});


parcelRegister("6oGQp", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $c9370124461878f7$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $c9370124461878f7$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $c9370124461878f7$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $c9370124461878f7$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $c9370124461878f7$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $c9370124461878f7$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $9IW58 = parcelRequire("9IW58");

var $59Ync = parcelRequire("59Ync");
const $c9370124461878f7$export$e1687335805e1230 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $9IW58.dropdownIndicatorCSS)() : (0, $59Ync.dropdownIndicatorCSS)(props);
const $c9370124461878f7$export$ec98719d3db7f2e4 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9IW58.DropdownIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $59Ync.DropdownIndicator), {
        ...props
    });
const $c9370124461878f7$export$9c0419fd944c1def = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $9IW58.clearIndicatorCSS)() : (0, $59Ync.clearIndicatorCSS)(props);
const $c9370124461878f7$export$ecf9cf59142dd54a = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9IW58.ClearIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $59Ync.ClearIndicator), {
        ...props
    });
const $c9370124461878f7$export$1d3f24cde248e6b5 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $9IW58.loadingIndicatorCSS)() : (0, $59Ync.loadingIndicatorCSS)(props);
const $c9370124461878f7$export$7c20be4c1d342248 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9IW58.LoadingIndicator), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $59Ync.LoadingIndicator), {
        ...props
    });

});
parcelRegister("9IW58", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $9496c8eb482c7559$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $9496c8eb482c7559$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $9496c8eb482c7559$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $9496c8eb482c7559$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $9496c8eb482c7559$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $9496c8eb482c7559$export$7c20be4c1d342248);
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $dGKFs = parcelRequire("dGKFs");

var $7K2aG = parcelRequire("7K2aG");

var $5sLH0 = parcelRequire("5sLH0");
var $7rJgC = parcelRequire("7rJgC");

var $clxo5 = parcelRequire("clxo5");

var $b0fMV = parcelRequire("b0fMV");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $9496c8eb482c7559$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $9496c8eb482c7559$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
const $9496c8eb482c7559$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
const $9496c8eb482c7559$export$e1687335805e1230 = ()=>({});
const $9496c8eb482c7559$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $9496c8eb482c7559$var$dropdownStyles.default,
            isDisabled && $9496c8eb482c7559$var$dropdownStyles.disabled,
            isCompact && $9496c8eb482c7559$var$dropdownStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
            as: "span",
            xcss: $9496c8eb482c7559$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
                color: "currentColor",
                label: "open",
                LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
            })
        })
    });
};
const $9496c8eb482c7559$export$9c0419fd944c1def = ()=>({});
const $9496c8eb482c7559$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
const $9496c8eb482c7559$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $9496c8eb482c7559$var$clearIndicatorStyles.default,
            isCompact && $9496c8eb482c7559$var$clearIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
            xcss: $9496c8eb482c7559$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7K2aG))), {
                label: "",
                color: "currentColor",
                LEGACY_size: "small",
                LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
            })
        })
    });
};
const $9496c8eb482c7559$export$1d3f24cde248e6b5 = ()=>({});
const $9496c8eb482c7559$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
const $9496c8eb482c7559$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $9496c8eb482c7559$var$loadingIndicatorStyles.default,
            isCompact && $9496c8eb482c7559$var$loadingIndicatorStyles.compact,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $clxo5.default), {
            size: "small"
        })
    });
};

});
parcelRegister("7K2aG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7da2857c3151a92889bed61f5baa1334>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a2e8376ca30e11c$var$_react = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5a2e8376ca30e11c$var$_crossCircle = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("8wCU9")));

var $5a2e8376ca30e11c$var$_selectClear = $5a2e8376ca30e11c$var$_interopRequireDefault((parcelRequire("85kPS")));
function $5a2e8376ca30e11c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a2e8376ca30e11c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $5a2e8376ca30e11c$var$_react.default.createElement($5a2e8376ca30e11c$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $5a2e8376ca30e11c$var$_selectClear.default
    }, props));
$5a2e8376ca30e11c$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $5a2e8376ca30e11c$var$_default = module.exports.default = $5a2e8376ca30e11c$var$CrossCircleIcon;

});
parcelRegister("8wCU9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23b3104937a360e799abf4f0ea698b9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $634f7d853690f284$var$_react = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $634f7d853690f284$var$_baseNew = $634f7d853690f284$var$_interopRequireDefault((parcelRequire("enEmH")));
function $634f7d853690f284$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $634f7d853690f284$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $634f7d853690f284$var$_react.default.createElement($634f7d853690f284$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$634f7d853690f284$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $634f7d853690f284$var$_default = module.exports.default = $634f7d853690f284$var$CrossCircleIcon;

});

parcelRegister("85kPS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e2ef3e5407a9744$var$_react = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $5e2ef3e5407a9744$var$_crossCircle = $5e2ef3e5407a9744$var$_interopRequireDefault((parcelRequire("hvAON")));
function $5e2ef3e5407a9744$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5e2ef3e5407a9744$var$SelectClearIcon = (props)=>/*#__PURE__*/ $5e2ef3e5407a9744$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $5e2ef3e5407a9744$var$_crossCircle.default
    }));
$5e2ef3e5407a9744$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $5e2ef3e5407a9744$var$_default = module.exports.default = $5e2ef3e5407a9744$var$SelectClearIcon;

});



parcelRegister("59Ync", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", () => $7461f1d2a00e2524$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $7461f1d2a00e2524$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $7461f1d2a00e2524$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $7461f1d2a00e2524$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $7461f1d2a00e2524$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $7461f1d2a00e2524$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $dGKFs = parcelRequire("dGKFs");

var $7K2aG = parcelRequire("7K2aG");

var $2Eqc8 = parcelRequire("2Eqc8");
var $gVM6m = parcelRequire("gVM6m");
var $2s57o = parcelRequire("2s57o");

var $clxo5 = parcelRequire("clxo5");

var $b0fMV = parcelRequire("b0fMV");
// ==============================
// Dropdown & Clear Icons
// ==============================
const $7461f1d2a00e2524$var$iconContainerStyles = (0, $2s57o.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $7461f1d2a00e2524$var$dropdownWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.075'
});
const $7461f1d2a00e2524$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $7461f1d2a00e2524$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children ? children : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        as: "span",
        xcss: $7461f1d2a00e2524$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
};
const $7461f1d2a00e2524$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        color: "var(--ds-text-subtlest, #626F86)",
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
        ':hover': {
            color: "var(--ds-text-subtle, #44546F)"
        }
    });
const $7461f1d2a00e2524$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear' } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $gVM6m.default), {
        xcss: $7461f1d2a00e2524$var$iconContainerStyles,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7K2aG))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
};
const $7461f1d2a00e2524$export$1d3f24cde248e6b5 = ({ isCompact: isCompact })=>({
        label: 'loadingIndicator',
        padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
    });
const $7461f1d2a00e2524$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $clxo5.default), {
        size: "small"
    }));
};

});


parcelRegister("4S2FY", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $c70f729c4b739a40$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $c70f729c4b739a40$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $4Bkzx = parcelRequire("4Bkzx");

var $e5eRb = parcelRequire("e5eRb");
const $c70f729c4b739a40$export$14a7781d0ca7abea = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $4Bkzx.inputCSS)() : (0, $e5eRb.inputCSS)(props);
const $c70f729c4b739a40$var$Input = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4Bkzx.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e5eRb.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c70f729c4b739a40$export$2e2bcd8739ae039 = $c70f729c4b739a40$var$Input;

});
parcelRegister("4Bkzx", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $2396b3de8e1fae28$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $2396b3de8e1fae28$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $2396b3de8e1fae28$export$14a7781d0ca7abea = ()=>({});
const $2396b3de8e1fae28$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $2396b3de8e1fae28$var$nativeInnputStyles = null;
const $2396b3de8e1fae28$var$hidden = null;
const $2396b3de8e1fae28$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'input', {
        'input-container': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2396b3de8e1fae28$var$inputStyles.root,
            isDisabled && $2396b3de8e1fae28$var$inputStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $bwpsq.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName)
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2396b3de8e1fae28$export$2e2bcd8739ae039 = $2396b3de8e1fae28$var$Input;

});

parcelRegister("e5eRb", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $0b0c7cf6f7f72e76$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $0b0c7cf6f7f72e76$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $0b0c7cf6f7f72e76$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value })=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$0b0c7cf6f7f72e76$var$containerStyle,
        margin: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingTop: "var(--ds-space-025, 2px)",
        color: "var(--ds-text, #172B4D)"
    });
const $0b0c7cf6f7f72e76$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $0b0c7cf6f7f72e76$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$0b0c7cf6f7f72e76$var$spacingStyle
    }
};
const $0b0c7cf6f7f72e76$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$0b0c7cf6f7f72e76$var$spacingStyle
    });
const $0b0c7cf6f7f72e76$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $b0fMV.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $0b0c7cf6f7f72e76$var$inputStyle(isHidden),
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b0c7cf6f7f72e76$export$2e2bcd8739ae039 = $0b0c7cf6f7f72e76$var$Input;

});


parcelRegister("fW3un", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $d762f5ed921736bb$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $d762f5ed921736bb$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $d762f5ed921736bb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $d762f5ed921736bb$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $d762f5ed921736bb$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $d762f5ed921736bb$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $d762f5ed921736bb$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $d762f5ed921736bb$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $d762f5ed921736bb$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $d762f5ed921736bb$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $d762f5ed921736bb$export$793392f970497feb);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $AMxeU = parcelRequire("AMxeU");

var $6ljBh = parcelRequire("6ljBh");
const $d762f5ed921736bb$export$a228922d5ca42a79 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $AMxeU.menuCSS)() : (0, $6ljBh.menuCSS)(props);
const $d762f5ed921736bb$export$f32337f3a7617699 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.MenuPlacer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.MenuPlacer), {
        ...props
    });
const $d762f5ed921736bb$var$Menu = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d762f5ed921736bb$export$2e2bcd8739ae039 = $d762f5ed921736bb$var$Menu;
const $d762f5ed921736bb$export$abafed69cff95d5e = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $AMxeU.menuListCSS)() : (0, $6ljBh.menuListCSS)(props);
const $d762f5ed921736bb$export$d4c4e98c5044dc8 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.MenuList), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.MenuList), {
        ...props
    });
// ==============================
// Menu Notices
// ==============================
const $d762f5ed921736bb$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $d762f5ed921736bb$export$cf0e22534d8b0074 = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$98ec46397a8cb3cd = $d762f5ed921736bb$var$noticeCSS;
const $d762f5ed921736bb$export$d58b72b7d3c4072c = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.NoOptionsMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.NoOptionsMessage), {
        ...props
    });
const $d762f5ed921736bb$export$e928a71d039d3102 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.LoadingMessage), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.LoadingMessage), {
        ...props
    });
const $d762f5ed921736bb$export$1dbbeb9648d1fdc9 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $AMxeU.menuPortalCSS)() : (0, $6ljBh.menuPortalCSS)(props);
const $d762f5ed921736bb$export$793392f970497feb = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $AMxeU.MenuPortal), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ljBh.MenuPortal), {
        ...props
    });

});
parcelRegister("AMxeU", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $b6a49545e26bfdbe$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $b6a49545e26bfdbe$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $b6a49545e26bfdbe$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $b6a49545e26bfdbe$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $b6a49545e26bfdbe$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $b6a49545e26bfdbe$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $b6a49545e26bfdbe$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $b6a49545e26bfdbe$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $b6a49545e26bfdbe$export$793392f970497feb);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $fHpHg = parcelRequire("fHpHg");

var $k9nuy = parcelRequire("k9nuy");

var $b0fMV = parcelRequire("b0fMV");
function $b6a49545e26bfdbe$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $b0fMV.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $b0fMV.normalizedHeight)(scrollParent);
    const scrollTop = (0, $b0fMV.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $fHpHg.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $b0fMV.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $b6a49545e26bfdbe$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $b6a49545e26bfdbe$var$menuStyles = {
    root: "_2rkoglpi _jqf689mz _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qs17uf",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
const $b6a49545e26bfdbe$export$a228922d5ca42a79 = ()=>({});
const $b6a49545e26bfdbe$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b6a49545e26bfdbe$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b6a49545e26bfdbe$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $b6a49545e26bfdbe$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $b6a49545e26bfdbe$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $b6a49545e26bfdbe$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $b6a49545e26bfdbe$var$menuStyles.root,
            $b6a49545e26bfdbe$var$menuStyles[placement],
            (0, $DEWI6.cx)(xcss, className)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6a49545e26bfdbe$export$2e2bcd8739ae039 = $b6a49545e26bfdbe$var$Menu;
const $b6a49545e26bfdbe$export$abafed69cff95d5e = ()=>({});
const $b6a49545e26bfdbe$var$menuListStyles = null;
const $b6a49545e26bfdbe$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
// ==============================
// Menu Notices
// ==============================
const $b6a49545e26bfdbe$var$noticeCSS = ()=>({});
const $b6a49545e26bfdbe$var$noticeStyles = null;
const $b6a49545e26bfdbe$export$cf0e22534d8b0074 = $b6a49545e26bfdbe$var$noticeCSS;
const $b6a49545e26bfdbe$export$98ec46397a8cb3cd = $b6a49545e26bfdbe$var$noticeCSS;
const $b6a49545e26bfdbe$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $b6a49545e26bfdbe$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $DEWI6.cx)(className, xcss)
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
            color: "color.text.subtle",
            children: children
        })
    });
};
const $b6a49545e26bfdbe$export$1dbbeb9648d1fdc9 = ()=>({});
const $b6a49545e26bfdbe$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b6a49545e26bfdbe$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $b0fMV.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $DEWI6.cx)(className, xcss),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            zIndex: 9999,
            left: computedPosition.rect.left,
            position: menuPosition,
            top: computedPosition.offset,
            width: computedPosition.rect.width,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b6a49545e26bfdbe$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};

});
parcelRegister("g9RrE", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $bc36f1aefc070984$export$deee3a793edee05f);

var $gSfPF = parcelRequire("gSfPF");
var $cVo0M = parcelRequire("cVo0M");

var $cVo0M = parcelRequire("cVo0M");

var $f8LYQ = parcelRequire("f8LYQ");
function $bc36f1aefc070984$var$getCssDimensions(element) {
    const css = (0, $f8LYQ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $f8LYQ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $cVo0M.round)(width) !== offsetWidth || (0, $cVo0M.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $bc36f1aefc070984$var$unwrapElement(element) {
    return !(0, $f8LYQ.isElement)(element) ? element.contextElement : element;
}
function $bc36f1aefc070984$var$getScale(element) {
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    if (!(0, $f8LYQ.isHTMLElement)(domElement)) return (0, $cVo0M.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
    let x = ($ ? (0, $cVo0M.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $cVo0M.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $bc36f1aefc070984$var$noOffsets = /*#__PURE__*/ (0, $cVo0M.createCoords)(0);
function $bc36f1aefc070984$var$getVisualOffsets(element) {
    const win = (0, $f8LYQ.getWindow)(element);
    if (!(0, $f8LYQ.isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $f8LYQ.getWindow)(element)) return false;
    return isFixed;
}
function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $bc36f1aefc070984$var$unwrapElement(element);
    let scale = (0, $cVo0M.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $f8LYQ.isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
        } else scale = $bc36f1aefc070984$var$getScale(element);
    }
    const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, $cVo0M.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $f8LYQ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $f8LYQ.isElement)(offsetParent) ? (0, $f8LYQ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $f8LYQ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $f8LYQ.getWindow)(currentIFrame);
            currentIFrame = (0, $f8LYQ.getFrameElement)(currentWin);
        }
    }
    return (0, $cVo0M.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $f8LYQ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, $f8LYQ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $f8LYQ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $cVo0M.createCoords)(1);
    const offsets = (0, $cVo0M.createCoords)(0);
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if ((0, $f8LYQ.isHTMLElement)(offsetParent)) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
            scale = $bc36f1aefc070984$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, $cVo0M.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $bc36f1aefc070984$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $bc36f1aefc070984$var$getDocumentRect(element) {
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const scroll = (0, $f8LYQ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $cVo0M.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $cVo0M.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $f8LYQ.getComputedStyle)(body).direction === 'rtl') x += (0, $cVo0M.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
    const win = (0, $f8LYQ.getWindow)(element);
    const html = (0, $f8LYQ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $f8LYQ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $f8LYQ.isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, $cVo0M.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, $f8LYQ.getDocumentElement)(element));
    else if ((0, $f8LYQ.isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $cVo0M.rectToClientRect)(rect);
}
function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $f8LYQ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $f8LYQ.isElement)(parentNode) || (0, $f8LYQ.isLastTraversableNode)(parentNode)) return false;
    return (0, $f8LYQ.getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $f8LYQ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $f8LYQ.isElement)(el) && (0, $f8LYQ.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $f8LYQ.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $f8LYQ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $f8LYQ.isElement)(currentNode) && !(0, $f8LYQ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $f8LYQ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $f8LYQ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $f8LYQ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $f8LYQ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $bc36f1aefc070984$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $f8LYQ.isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $cVo0M.max)(rect.top, accRect.top);
        accRect.right = (0, $cVo0M.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cVo0M.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cVo0M.max)(rect.left, accRect.left);
        return accRect;
    }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $bc36f1aefc070984$var$getDimensions(element) {
    const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $f8LYQ.isHTMLElement)(offsetParent);
    const documentElement = (0, $f8LYQ.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $cVo0M.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f8LYQ.getNodeName)(offsetParent) !== 'body' || (0, $f8LYQ.isOverflowElement)(documentElement)) scroll = (0, $f8LYQ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, $cVo0M.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $bc36f1aefc070984$var$isStaticPositioned(element) {
    return (0, $f8LYQ.getComputedStyle)(element).position === 'static';
}
function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $f8LYQ.isHTMLElement)(element) || (0, $f8LYQ.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $f8LYQ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
    const win = (0, $f8LYQ.getWindow)(element);
    if ((0, $f8LYQ.isTopLayer)(element)) return win;
    if (!(0, $f8LYQ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $f8LYQ.getParentNode)(element);
        while(svgOffsetParent && !(0, $f8LYQ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $f8LYQ.isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $f8LYQ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $f8LYQ.isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $f8LYQ.isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, $f8LYQ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $f8LYQ.getContainingBlock)(element) || win;
}
const $bc36f1aefc070984$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $bc36f1aefc070984$var$isRTL(element) {
    return (0, $f8LYQ.getComputedStyle)(element).direction === 'rtl';
}
const $bc36f1aefc070984$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $f8LYQ.getDocumentElement,
    getClippingRect: $bc36f1aefc070984$var$getClippingRect,
    getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
    getElementRects: $bc36f1aefc070984$var$getElementRects,
    getClientRects: $bc36f1aefc070984$var$getClientRects,
    getDimensions: $bc36f1aefc070984$var$getDimensions,
    getScale: $bc36f1aefc070984$var$getScale,
    isElement: $f8LYQ.isElement,
    isRTL: $bc36f1aefc070984$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $bc36f1aefc070984$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $f8LYQ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $cVo0M.floor)(top);
        const insetRight = (0, $cVo0M.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $cVo0M.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $cVo0M.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $cVo0M.max)(0, (0, $cVo0M.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $f8LYQ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $f8LYQ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, $gSfPF.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $bc36f1aefc070984$export$cc800923e997bb8 = (0, $gSfPF.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, $gSfPF.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $bc36f1aefc070984$export$fba63a578e423eb = (0, $gSfPF.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, $gSfPF.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $bc36f1aefc070984$export$346677f925de839c = (0, $gSfPF.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $bc36f1aefc070984$export$fe8985bb6374093c = (0, $gSfPF.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, $gSfPF.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, $gSfPF.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, $gSfPF.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $bc36f1aefc070984$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $gSfPF.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("gSfPF", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $c48df878d8118962$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $c48df878d8118962$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $c48df878d8118962$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $c48df878d8118962$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $c48df878d8118962$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $c48df878d8118962$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $c48df878d8118962$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $c48df878d8118962$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $c48df878d8118962$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $c48df878d8118962$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $c48df878d8118962$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("cVo0M")).rectToClientRect);

var $cVo0M = parcelRequire("cVo0M");
function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $cVo0M.getSideAxis)(placement);
    const alignmentAxis = (0, $cVo0M.getAlignmentAxis)(placement);
    const alignLength = (0, $cVo0M.getAxisLength)(alignmentAxis);
    const side = (0, $cVo0M.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $cVo0M.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state);
    const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $cVo0M.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $cVo0M.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $cVo0M.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $cVo0M.getAlignmentAxis)(placement);
            const length = (0, $cVo0M.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $cVo0M.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $cVo0M.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $cVo0M.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $cVo0M.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $cVo0M.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $cVo0M.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $cVo0M.getAlignment)(placement) === alignment || (autoAlignment ? (0, $cVo0M.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $cVo0M.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $cVo0M.placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $cVo0M.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $cVo0M.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $cVo0M.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $cVo0M.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $cVo0M.getSide)(placement);
            const initialSideAxis = (0, $cVo0M.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $cVo0M.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $cVo0M.getOppositePlacement)(initialPlacement)
            ] : (0, $cVo0M.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $cVo0M.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $cVo0M.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $cVo0M.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
    return (0, $cVo0M.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $c48df878d8118962$var$getBoundingRect(rects) {
    const minX = (0, $cVo0M.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $cVo0M.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $cVo0M.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $cVo0M.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $c48df878d8118962$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $cVo0M.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $cVo0M.rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $cVo0M.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $cVo0M.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $cVo0M.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $cVo0M.getSide)(placement) === 'left';
                    const maxRight = (0, $cVo0M.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $cVo0M.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $c48df878d8118962$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $cVo0M.getSide)(placement);
    const alignment = (0, $cVo0M.getAlignment)(placement);
    const isVertical = (0, $cVo0M.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $cVo0M.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $c48df878d8118962$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $cVo0M.getSideAxis)((0, $cVo0M.getSide)(placement));
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $cVo0M.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $cVo0M.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $cVo0M.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $cVo0M.getSideAxis)(placement);
            const mainAxis = (0, $cVo0M.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $cVo0M.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $cVo0M.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $c48df878d8118962$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $cVo0M.evaluate)(options, state);
            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $cVo0M.getSide)(placement);
            const alignment = (0, $cVo0M.getAlignment)(placement);
            const isYAxis = (0, $cVo0M.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $cVo0M.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $cVo0M.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $cVo0M.max)(overflow.left, 0);
                const xMax = (0, $cVo0M.max)(overflow.right, 0);
                const yMin = (0, $cVo0M.max)(overflow.top, 0);
                const yMax = (0, $cVo0M.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $cVo0M.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $cVo0M.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("cVo0M", function(module, exports) {

$parcel$export(module.exports, "sides", () => $968d6f1d7e429938$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $968d6f1d7e429938$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $968d6f1d7e429938$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $968d6f1d7e429938$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $968d6f1d7e429938$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $968d6f1d7e429938$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $968d6f1d7e429938$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $968d6f1d7e429938$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $968d6f1d7e429938$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $968d6f1d7e429938$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $968d6f1d7e429938$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $968d6f1d7e429938$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $968d6f1d7e429938$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $968d6f1d7e429938$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $968d6f1d7e429938$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $968d6f1d7e429938$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $968d6f1d7e429938$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $968d6f1d7e429938$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $968d6f1d7e429938$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $968d6f1d7e429938$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $968d6f1d7e429938$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $968d6f1d7e429938$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $968d6f1d7e429938$export$803cd8101b6c182b = /*#__PURE__*/ $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $968d6f1d7e429938$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $968d6f1d7e429938$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
    return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
}
function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
    return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
}
function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
    const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
    const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
    return [
        $968d6f1d7e429938$export$2b182c584985588b(placement),
        oppositePlacement,
        $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
    ];
}
function $968d6f1d7e429938$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
}
function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
    let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
    }
    return list;
}
function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
}
function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("f8LYQ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $b05cd24baa7455b6$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $b05cd24baa7455b6$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $b05cd24baa7455b6$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $b05cd24baa7455b6$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b05cd24baa7455b6$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $b05cd24baa7455b6$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $b05cd24baa7455b6$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $b05cd24baa7455b6$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $b05cd24baa7455b6$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $b05cd24baa7455b6$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $b05cd24baa7455b6$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $b05cd24baa7455b6$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $b05cd24baa7455b6$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $b05cd24baa7455b6$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $b05cd24baa7455b6$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $b05cd24baa7455b6$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $b05cd24baa7455b6$export$7bf1f8740e3e34af);
function $b05cd24baa7455b6$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $b05cd24baa7455b6$export$651544f548703224(node) {
    if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $b05cd24baa7455b6$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
}
function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
}
function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
    if (!$b05cd24baa7455b6$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
}
function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
    if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($b05cd24baa7455b6$export$651544f548703224(element));
}
function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
    const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $b05cd24baa7455b6$export$940d8225183e1404(element) {
    let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
    while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
        if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $b05cd24baa7455b6$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($b05cd24baa7455b6$export$651544f548703224(node));
}
function $b05cd24baa7455b6$export$3735103072e4a80(element) {
    return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
    if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
    if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $b05cd24baa7455b6$export$e495491855dc5418(node);
    return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
    const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
    if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
    return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
}
function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("hrqx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2989fd9beaabfa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = (0, $5uXOq.useLayoutEffect);

});


parcelRegister("6ljBh", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $a6d4efc2f081a9c8$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $a6d4efc2f081a9c8$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $a6d4efc2f081a9c8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $a6d4efc2f081a9c8$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $a6d4efc2f081a9c8$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "NoOptionsMessage", () => $a6d4efc2f081a9c8$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $a6d4efc2f081a9c8$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $a6d4efc2f081a9c8$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $a6d4efc2f081a9c8$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $g9RrE = parcelRequire("g9RrE");

var $7nsd3 = parcelRequire("7nsd3");

var $hrqx3 = parcelRequire("hrqx3");

var $fHpHg = parcelRequire("fHpHg");

var $6eFvr = parcelRequire("6eFvr");

var $b0fMV = parcelRequire("b0fMV");
function $a6d4efc2f081a9c8$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $b0fMV.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight, top: scrollParentTop } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $b0fMV.normalizedHeight)(scrollParent);
    const scrollTop = (0, $b0fMV.getScrollTop)(scrollParent);
    // use menuTop - scrollParentTop for the actual top space of menu in the scroll container
    const menuTopFromParent = (0, $fHpHg.fg)('design-system-select-fix-placement') ? menuTop - scrollParentTop : menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $b0fMV.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $b0fMV.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $a6d4efc2f081a9c8$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $a6d4efc2f081a9c8$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $a6d4efc2f081a9c8$export$a228922d5ca42a79 = ({ placement: placement })=>({
        label: 'menu',
        [$a6d4efc2f081a9c8$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        borderRadius: "var(--ds-border-radius, 4px)",
        marginBottom: "var(--ds-space-100, 8px)",
        marginTop: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-overlay, white)",
        boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
    });
const $a6d4efc2f081a9c8$var$PortalPlacementContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $a6d4efc2f081a9c8$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($a6d4efc2f081a9c8$var$PortalPlacementContext) || {};
    const ref = (0, $5uXOq.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $5uXOq.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $hrqx3.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $a6d4efc2f081a9c8$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $a6d4efc2f081a9c8$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $a6d4efc2f081a9c8$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a6d4efc2f081a9c8$export$2e2bcd8739ae039 = $a6d4efc2f081a9c8$var$Menu;
const $a6d4efc2f081a9c8$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        paddingTop: "var(--ds-space-100, 8px)",
        paddingBottom: "var(--ds-space-100, 8px)"
    });
const $a6d4efc2f081a9c8$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $a6d4efc2f081a9c8$var$noticeCSS = ({})=>({
        textAlign: 'center',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    });
const $a6d4efc2f081a9c8$export$cf0e22534d8b0074 = $a6d4efc2f081a9c8$var$noticeCSS;
const $a6d4efc2f081a9c8$export$98ec46397a8cb3cd = $a6d4efc2f081a9c8$var$noticeCSS;
const $a6d4efc2f081a9c8$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $a6d4efc2f081a9c8$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6eFvr.default), {
        color: "color.text.subtle"
    }, children));
};
const $a6d4efc2f081a9c8$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $a6d4efc2f081a9c8$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $5uXOq.useRef)(null);
    const cleanupRef = (0, $5uXOq.useRef)(null);
    const [placement, setPortalPlacement] = (0, $5uXOq.useState)($a6d4efc2f081a9c8$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
    const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $b0fMV.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $hrqx3.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $g9RrE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $hrqx3.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $b0fMV.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($a6d4efc2f081a9c8$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});


parcelRegister("g6y65", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $81905f6290625738$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $81905f6290625738$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $81905f6290625738$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $81905f6290625738$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $81905f6290625738$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $81905f6290625738$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $81905f6290625738$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $kdxlb = parcelRequire("kdxlb");

var $fhNoT = parcelRequire("fhNoT");
const $81905f6290625738$export$23c213f7717186af = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $kdxlb.multiValueCSS)() : (0, $fhNoT.multiValueCSS)(props);
const $81905f6290625738$export$f40612612e0af964 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $kdxlb.multiValueLabelCSS)() : (0, $fhNoT.multiValueLabelCSS)(props);
const $81905f6290625738$export$283467f6c4ac142b = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $kdxlb.multiValueRemoveCSS)() : (0, $fhNoT.multiValueRemoveCSS)(props);
const $81905f6290625738$export$cf9cf2a30a59265c = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kdxlb.MultiValueContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fhNoT.MultiValueContainer), {
        ...props
    });
const $81905f6290625738$export$544aeea2a5ce08ee = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kdxlb.MultiValueLabel), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fhNoT.MultiValueLabel), {
        ...props
    });
function $81905f6290625738$export$8e1fd1a40e7a2f4a(props) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    (0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kdxlb.MultiValueRemove), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fhNoT.MultiValueRemove), {
        ...props
    }));
}
const $81905f6290625738$var$MultiValue = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kdxlb.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fhNoT.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$81905f6290625738$export$2e2bcd8739ae039 = $81905f6290625738$var$MultiValue;

});
parcelRegister("kdxlb", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $0fc1145ed3199469$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $0fc1145ed3199469$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $0fc1145ed3199469$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $0fc1145ed3199469$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $0fc1145ed3199469$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $0fc1145ed3199469$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $0fc1145ed3199469$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $85kPS = parcelRequire("85kPS");

var $gANiX = parcelRequire("gANiX");

var $fHpHg = parcelRequire("fHpHg");

var $5sLH0 = parcelRequire("5sLH0");

var $b0fMV = parcelRequire("b0fMV");
const $0fc1145ed3199469$var$multiValueStyles = {
    root: "_2rkogqwt _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs17si _1aewe4h9 _6up53acm _1xdnnqa1",
    refresh: "_2rkoiti9 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
const $0fc1145ed3199469$export$23c213f7717186af = ()=>({});
const $0fc1145ed3199469$export$f40612612e0af964 = ()=>({});
const $0fc1145ed3199469$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkogqwt _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
const $0fc1145ed3199469$export$283467f6c4ac142b = ()=>({});
const $0fc1145ed3199469$var$multiValueRemoveStyles = {
    focused: "_bfhk1km6 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rkoglpi _bfhk1w7a _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
const $0fc1145ed3199469$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0fc1145ed3199469$var$multiValueStyles.root,
            isDisabled && $0fc1145ed3199469$var$multiValueStyles.disabled,
            isFocused && $0fc1145ed3199469$var$multiValueStyles.focused,
            (0, $fHpHg.fg)('platform-component-visual-refresh') && $0fc1145ed3199469$var$multiValueStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: children
    });
};
const $0fc1145ed3199469$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0fc1145ed3199469$var$multiValueLabelStyles.root,
            isDisabled && $0fc1145ed3199469$var$multiValueLabelStyles.disabled,
            hasEllipsis && $0fc1145ed3199469$var$multiValueLabelStyles.ellipsis,
            (0, $fHpHg.fg)('platform-component-visual-refresh') && $0fc1145ed3199469$var$multiValueLabelStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: children
    });
};
const $0fc1145ed3199469$var$disabledStyles = null;
const $0fc1145ed3199469$var$enabledStyles = null;
const $0fc1145ed3199469$var$iconWrapperStyles = {
    root: "_ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
const $0fc1145ed3199469$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sLH0.default), {
        xcss: $0fc1145ed3199469$var$iconWrapperStyles.root,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
            label: "",
            color: "currentColor"
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85kPS))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    });
};
function $0fc1145ed3199469$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $0fc1145ed3199469$var$multiValueRemoveStyles.root,
            isFocused && $0fc1145ed3199469$var$multiValueRemoveStyles.focused,
            (0, $fHpHg.fg)('platform-component-visual-refresh') && $0fc1145ed3199469$var$multiValueRemoveStyles.refresh,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $bwpsq.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: $0fc1145ed3199469$var$renderIcon()
        })
    });
}
const $0fc1145ed3199469$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $b0fMV.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $b0fMV.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $b0fMV.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0fc1145ed3199469$export$2e2bcd8739ae039 = $0fc1145ed3199469$var$MultiValue;

});

parcelRegister("fhNoT", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $0e9d1da16ef5ccf5$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $0e9d1da16ef5ccf5$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $0e9d1da16ef5ccf5$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $0e9d1da16ef5ccf5$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $0e9d1da16ef5ccf5$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $0e9d1da16ef5ccf5$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $0e9d1da16ef5ccf5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $85kPS = parcelRequire("85kPS");

var $gANiX = parcelRequire("gANiX");

var $fHpHg = parcelRequire("fHpHg");

var $2Eqc8 = parcelRequire("2Eqc8");
var $2s57o = parcelRequire("2s57o");

var $b0fMV = parcelRequire("b0fMV");
function $0e9d1da16ef5ccf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e9d1da16ef5ccf5$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused })=>{
    let backgroundColor;
    let color;
    if (isDisabled) {
        // Use the basic neutral background so it is slightly separate from the
        // field's background
        backgroundColor = "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text-disabled, #091E424F)";
    } else if (isFocused) {
        backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
    } else {
        backgroundColor = (0, $fHpHg.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
        color = "var(--ds-text, hsl(0, 0%, 20%))";
    }
    return {
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        margin: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-border-radius-050, 2px)",
        backgroundColor: backgroundColor,
        boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
        maxWidth: '100%',
        '@media screen and (-ms-high-contrast: active)': {
            border: isFocused ? '1px solid transparent' : 'none'
        },
        color: color,
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            borderRadius: "var(--ds-border-radius-100, 4px)",
            // Hardcode this color for visual refresh as there is no token color yet
            borderColor: '#B7B9BE',
            borderWidth: "var(--ds-border-width, 1px)",
            borderStyle: 'solid',
            backgroundColor: "var(--ds-background-input, #FFFFFF)"
        }
    };
};
const $0e9d1da16ef5ccf5$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '85%',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        padding: "var(--ds-space-025, 2px)",
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
        paddingLeft: "var(--ds-space-075, 6px)",
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: "var(--ds-space-050, 4px)"
        }
    });
const $0e9d1da16ef5ccf5$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
        alignItems: 'center',
        display: 'flex',
        backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
        fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-025, 2px)",
        borderRadius: '0px 2px 2px 0px',
        // DSP-6470 we should style like Tag once we have the :has selector
        ':hover': {
            backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
            fill: "var(--ds-text-danger, #000)"
        },
        ':active': {
            backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
            fill: "var(--ds-text-danger, #000)"
        },
        ...(0, $fHpHg.fg)('platform-component-visual-refresh') && {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            border: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            appearance: 'none',
            borderRadius: "var(--ds-border-radius, 4px)",
            color: "var(--ds-text, #172B4D)",
            padding: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            ':focus-visible': {
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            },
            ':hover': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            }
        }
    });
const $0e9d1da16ef5ccf5$var$MultiValueGeneric = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, children);
const $0e9d1da16ef5ccf5$export$cf9cf2a30a59265c = $0e9d1da16ef5ccf5$var$MultiValueGeneric;
const $0e9d1da16ef5ccf5$export$544aeea2a5ce08ee = $0e9d1da16ef5ccf5$var$MultiValueGeneric;
const $0e9d1da16ef5ccf5$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $0e9d1da16ef5ccf5$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $0e9d1da16ef5ccf5$var$iconWrapperStyles = (0, $2s57o.xcss)({
    padding: 'space.025'
});
const $0e9d1da16ef5ccf5$var$renderIcon = ()=>{
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    });
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $fHpHg.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $2Eqc8.default), {
        xcss: $0e9d1da16ef5ccf5$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
        label: "",
        color: "currentColor"
    }));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($85kPS))), {
        label: "",
        primaryColor: "transparent",
        size: "small",
        secondaryColor: "inherit"
    });
};
function $0e9d1da16ef5ccf5$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, innerProps: innerProps }) {
    return(// The Remove button is intentionally excluded from the tab order, please avoid assigning a non-negative tabIndex to it. Context: https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+Options+on+an+Input+Field
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", innerProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: isDisabled ? $0e9d1da16ef5ccf5$var$disabledStyles : $0e9d1da16ef5ccf5$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, $0e9d1da16ef5ccf5$var$renderIcon())));
}
const $0e9d1da16ef5ccf5$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $f8Sb3.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $b0fMV.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            role: 'button',
            tabIndex: -1,
            'aria-label': `${ariaLabel || 'option'}, remove`,
            ...removeProps
        },
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0e9d1da16ef5ccf5$export$2e2bcd8739ae039 = $0e9d1da16ef5ccf5$var$MultiValue;

});


parcelRegister("FpaWY", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $3f5146e3502d3009$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $3f5146e3502d3009$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $gbVnD = parcelRequire("gbVnD");

var $ix8vW = parcelRequire("ix8vW");
const $3f5146e3502d3009$export$ef897119b7e920ba = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $gbVnD.optionCSS)() : (0, $ix8vW.optionCSS)(props);
const $3f5146e3502d3009$var$Option = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gbVnD.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ix8vW.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3f5146e3502d3009$export$2e2bcd8739ae039 = $3f5146e3502d3009$var$Option;

});
parcelRegister("gbVnD", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $8917cc3dee1701ef$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $8917cc3dee1701ef$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $8917cc3dee1701ef$export$ef897119b7e920ba = ()=>({});
const $8917cc3dee1701ef$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk18uv _16qsglyw _1di618uv _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pknj1ic",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pknj1ic",
    focusedSelected: "_bfhki1yw"
};
const $8917cc3dee1701ef$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $8917cc3dee1701ef$var$optionStyles.root,
            isFocused && $8917cc3dee1701ef$var$optionStyles.focused,
            isSelected && $8917cc3dee1701ef$var$optionStyles.selected,
            isFocused && isSelected && $8917cc3dee1701ef$var$optionStyles.focusedSelected,
            isDisabled && $8917cc3dee1701ef$var$optionStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8917cc3dee1701ef$export$2e2bcd8739ae039 = $8917cc3dee1701ef$var$Option;

});

parcelRegister("ix8vW", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $ccd549b7f90e6a04$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $ccd549b7f90e6a04$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $ccd549b7f90e6a04$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    let color = "var(--ds-text, #172B4D)";
    if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
    else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
    let boxShadow;
    let backgroundColor;
    if (isDisabled) backgroundColor = undefined;
    else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
    else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
    else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
    if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
    const cursor = isDisabled ? 'not-allowed' : 'default';
    return {
        label: 'option',
        display: 'block',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        backgroundColor: backgroundColor,
        color: color,
        cursor: cursor,
        boxShadow: boxShadow,
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
        }
    };
};
const $ccd549b7f90e6a04$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ccd549b7f90e6a04$export$2e2bcd8739ae039 = $ccd549b7f90e6a04$var$Option;

});


parcelRegister("41aBa", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $46d5944cb8b3b0b7$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $46d5944cb8b3b0b7$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $caIiY = parcelRequire("caIiY");

var $fLK7y = parcelRequire("fLK7y");
const $46d5944cb8b3b0b7$export$5f3ffacd6594d90f = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $caIiY.placeholderCSS)() : (0, $fLK7y.placeholderCSS)(props);
const $46d5944cb8b3b0b7$var$Placeholder = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $caIiY.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fLK7y.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$46d5944cb8b3b0b7$export$2e2bcd8739ae039 = $46d5944cb8b3b0b7$var$Placeholder;

});
parcelRegister("caIiY", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $2cb61bd9b79ad9eb$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $2cb61bd9b79ad9eb$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $2cb61bd9b79ad9eb$export$5f3ffacd6594d90f = ()=>({});
const $2cb61bd9b79ad9eb$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
const $2cb61bd9b79ad9eb$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $2cb61bd9b79ad9eb$var$placeholderStyles.root,
            isDisabled && $2cb61bd9b79ad9eb$var$placeholderStyles.disabled,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2cb61bd9b79ad9eb$export$2e2bcd8739ae039 = $2cb61bd9b79ad9eb$var$Placeholder;

});

parcelRegister("fLK7y", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $827c1c41d453899a$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $827c1c41d453899a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $827c1c41d453899a$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
    });
const $827c1c41d453899a$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$827c1c41d453899a$export$2e2bcd8739ae039 = $827c1c41d453899a$var$Placeholder;

});


parcelRegister("aPWnT", function(module, exports) {

$parcel$export(module.exports, "css", () => $d266cade0fb9c8f9$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $d266cade0fb9c8f9$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $k7Vop = parcelRequire("k7Vop");

var $jai1M = parcelRequire("jai1M");
const $d266cade0fb9c8f9$export$dbf350e5966cf602 = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? (0, $k7Vop.css)() : (0, $jai1M.css)(props);
const $d266cade0fb9c8f9$var$SingleValue = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k7Vop.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jai1M.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d266cade0fb9c8f9$export$2e2bcd8739ae039 = $d266cade0fb9c8f9$var$SingleValue;

});
parcelRegister("k7Vop", function(module, exports) {

$parcel$export(module.exports, "css", () => $a7c2ea661ce06b50$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $a7c2ea661ce06b50$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $DEWI6 = parcelRequire("DEWI6");

var $b0fMV = parcelRequire("b0fMV");
const $a7c2ea661ce06b50$export$dbf350e5966cf602 = ()=>({});
const $a7c2ea661ce06b50$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _jqf6bf1n _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
const $a7c2ea661ce06b50$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $b0fMV.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $bwpsq.default)([
            $a7c2ea661ce06b50$var$styles.root,
            isDisabled && $a7c2ea661ce06b50$var$styles.disalbed,
            (0, $DEWI6.cx)(className, xcss)
        ]),
        ...innerProps,
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a7c2ea661ce06b50$export$2e2bcd8739ae039 = $a7c2ea661ce06b50$var$SingleValue;

});

parcelRegister("jai1M", function(module, exports) {

$parcel$export(module.exports, "css", () => $2e79fc74253adcb6$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $2e79fc74253adcb6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $2e79fc74253adcb6$export$dbf350e5966cf602 = ({ isDisabled: isDisabled })=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
    });
const $2e79fc74253adcb6$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ...(0, $b0fMV.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e79fc74253adcb6$export$2e2bcd8739ae039 = $2e79fc74253adcb6$var$SingleValue;

});



parcelRegister("1JbQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1428ca8599b707$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $7nsd3 = parcelRequire("7nsd3");

var $ao4Ml = parcelRequire("ao4Ml");

var $cXw5N = parcelRequire("cXw5N");
var $dKwv2 = parcelRequire("dKwv2");
var $2HG8y = parcelRequire("2HG8y");

var $4wJSY = parcelRequire("4wJSY");

var $5a34e = parcelRequire("5a34e");

var $jJsBW = parcelRequire("jJsBW");

var $fHpHg = parcelRequire("fHpHg");

var $1BKyN = parcelRequire("1BKyN");


var $lau8t = parcelRequire("lau8t");

var $5IVHm = parcelRequire("5IVHm");

var $f2Cxi = parcelRequire("f2Cxi");

var $aztrV = parcelRequire("aztrV");
/**
 * Are we rendering on the client or server?
 */ const $ce1428ca8599b707$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $ce1428ca8599b707$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $ce1428ca8599b707$var$defaultPopperProps = {
    modifiers: $ce1428ca8599b707$var$modifiers,
    placement: 'bottom-start'
};
const $ce1428ca8599b707$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $ce1428ca8599b707$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            shouldCloseMenuOnTab: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$ce1428ca8599b707$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $f2Cxi.defaultComponents),
            ...props.components
        };
        if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$ce1428ca8599b707$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $cBeZP.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cXw5N.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jJsBW.IdProvider), {
                    postfix: "-popup-select",
                    children: ({ id: id })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2HG8y.Reference), {
                                    children: ({ ref: ref })=>target && target({
                                            isOpen: isOpen,
                                            onKeyDown: this.handleTargetKeyDown,
                                            ref: this.resolveTargetRef(ref),
                                            // Should technically be 'dialog' by default instead of 'true' via AriaAttributes, but will require further changes.
                                            // See go/DSP-22283
                                            'aria-haspopup': 'true',
                                            'aria-expanded': isOpen,
                                            'aria-controls': isOpen ? id : undefined
                                        })
                                }),
                                this.renderSelect(id)
                            ]
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aztrV.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.state.isOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $a7f8c6b391092279$export$eaa8c8a70ac22806})`
                })
        }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $f2Cxi.defaultComponents),
            mergedPopperProps: $ce1428ca8599b707$var$defaultPopperProps
        }, // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        }, this.handleKeyDown = (event)=>{
            //We shouldn't close PopupSelect on tab event if there are custom interactive element.
            const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
            if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        }, this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        }, this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        }, this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        }, // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            if (onMenuOpen) onMenuOpen();
            this.setState({
                isOpen: true
            }, ()=>{
                if (this.selectRef) this.selectRef.select?.openMenu('first');
            });
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $cBeZP.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        }, /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            //@ts-ignore react-select unsupported props
            const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            if (onMenuClose) onMenuClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }, // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            }, this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        }, // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        }, this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            const controlRef = this.selectRef.select?.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        }, // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        }, // Renderers
        // ==============================
        this.renderSelect = (id)=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $ce1428ca8599b707$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $f2Cxi.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const providedAriaLabel = getLabel();
            const updateInputAriaLabel = (ariaLabelText)=>{
                // Update aria-label to get first announcement when popup opened.
                if (this.selectRef?.select?.inputRef) {
                    if (providedAriaLabel) // I might want to use a comma instead of a period here, when the feature flag is removed.
                    ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                    this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                }
            };
            const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                const { focused: focused } = onFocusProps;
                const options = props?.options || [];
                const totalLength = options?.length;
                const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                const ariaLabelText = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `${optionName}, (${optionIndex + 1} of ${totalLength})` : `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                // Option LABEL focused, 1 of 8. 8 results available.
                // Use Up and Down to choose options, press Enter to select the currently focused option,
                // press Escape to exit the menu.
                return ariaLabelText;
            };
            const onReactSelectFocus = (onFocusProps)=>{
                const ariaLabelSuffix = (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? '' : ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                let ariaLabelText = '';
                let ariaLiveMessage = '';
                if (props.options?.length) {
                    if ((0, $5IVHm.isOptionsGrouped)(props.options)) {
                        const totalLength = (0, $5IVHm.countAllOptions)(props.options);
                        ariaLiveMessage = (0, $5IVHm.onFocus)(onFocusProps, props.options);
                        ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                    } else {
                        ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                        ariaLiveMessage = ariaLabelText;
                    }
                    // Safari still does not announce the first option when menu is opened, so forcing a change to the input label
                    // will include the first option in the initial announcement.
                    if (!(0, $fHpHg.fg)('design_system_select-a11y-improvement') || (0, $5a34e.isSafari)() && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) updateInputAriaLabel(ariaLabelText);
                    return ariaLiveMessage;
                }
                return ariaLiveMessage;
            };
            const popper = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dKwv2.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                },
                children: ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f2Cxi.MenuDialog), {
                        // There is not a limited amount of values for the widths, so they need to remain dynamic.
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        style: {
                            ...style,
                            maxWidth: maxMenuWidth,
                            minWidth: minMenuWidth
                        },
                        "data-placement": placement,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                            disabled: !focusLockEnabled,
                            returnFocus: true,
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lau8t.default), {
                                    label: providedAriaLabel,
                                    // TODO: Popup Select does not work well with active-descendant
                                    "aria-live": (0, $5a34e.isAppleDevice)() && (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'assertive' // only needed on Apple products
                                     : undefined,
                                    backspaceRemovesValue: false,
                                    controlShouldRenderValue: false,
                                    isClearable: false,
                                    tabSelectsValue: false,
                                    menuIsOpen: true,
                                    placeholder: placeholder,
                                    ref: this.getSelectRef,
                                    ...props,
                                    isSearchable: showSearchControl,
                                    styles: (0, $1BKyN.mergeStyles)(this.defaultStyles, props.styles || {}),
                                    maxMenuHeight: this.getMaxHeight(),
                                    components: selectComponents,
                                    onChange: this.handleSelectChange,
                                    testId: testId,
                                    ariaLiveMessages: {
                                        // Overwriting ariaLiveMessages builtin onFocus method to announce selected option when popup has been opened
                                        onFocus: onReactSelectFocus,
                                        ...props.ariaLiveMessages // priority to use user handlers if provided
                                    }
                                }),
                                footer
                            ]
                        })
                    })
            });
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $7nsd3.createPortal)(popper, portalDestination);
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.close();
        };
    }
}

});
parcelRegister("cXw5N", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $96f3e3a21854c201$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $96f3e3a21854c201$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $96f3e3a21854c201$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $96f3e3a21854c201$export$3dbd3405086fec7b = $5uXOq.createContext();
var $96f3e3a21854c201$export$cbabb21c2529b130 = $5uXOq.createContext();
function $96f3e3a21854c201$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($96f3e3a21854c201$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("dKwv2", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $a028c7fdc314a3d7$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");

var $1X8rn = parcelRequire("1X8rn");
var $a028c7fdc314a3d7$var$NOOP = function NOOP() {
    return void 0;
};
var $a028c7fdc314a3d7$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $a028c7fdc314a3d7$var$EMPTY_MODIFIERS = [];
function $a028c7fdc314a3d7$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $a028c7fdc314a3d7$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $9sasN.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1X8rn.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $a028c7fdc314a3d7$var$NOOP,
            update: update || $a028c7fdc314a3d7$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $9sasN.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("9sasN", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $6e1ed863939d4e09$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $6e1ed863939d4e09$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $6e1ed863939d4e09$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $6e1ed863939d4e09$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $6e1ed863939d4e09$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $6e1ed863939d4e09$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $6e1ed863939d4e09$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $6e1ed863939d4e09$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $6e1ed863939d4e09$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $6e1ed863939d4e09$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $6e1ed863939d4e09$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("1X8rn", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $16c1d93cabd0d15c$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $7aL90 = parcelRequire("7aL90");

var $lHrkK = parcelRequire("lHrkK");

var $9sasN = parcelRequire("9sasN");
var $16c1d93cabd0d15c$var$EMPTY_MODIFIERS = [];
var $16c1d93cabd0d15c$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $16c1d93cabd0d15c$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $9sasN.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $9sasN.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $7aL90.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("7aL90", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $538e096cd49574d6$export$8f7491d57c8f97a9);

var $3xOUx = parcelRequire("3xOUx");

var $5d22G = parcelRequire("5d22G");

var $erJZ3 = parcelRequire("erJZ3");

var $8AiNL = parcelRequire("8AiNL");

var $bAjmm = parcelRequire("bAjmm");

var $lcFdJ = parcelRequire("lcFdJ");

var $7KqQI = parcelRequire("7KqQI");

var $7zSEz = parcelRequire("7zSEz");

var $ek5P6 = parcelRequire("ek5P6");

var $anqoe = parcelRequire("anqoe");


var $538e096cd49574d6$export$d34966752335dd47 = [
    (0, $5d22G.default),
    (0, $erJZ3.default),
    (0, $8AiNL.default),
    (0, $bAjmm.default),
    (0, $lcFdJ.default),
    (0, $7KqQI.default),
    (0, $7zSEz.default),
    (0, $ek5P6.default),
    (0, $anqoe.default)
];
var $538e096cd49574d6$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3xOUx.popperGenerator)({
    defaultModifiers: $538e096cd49574d6$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3xOUx", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $294bf2077fa79917$export$ed5e13716264f202);

var $hBSZx = parcelRequire("hBSZx");

var $h7lRj = parcelRequire("h7lRj");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $iEr9Q = parcelRequire("iEr9Q");

var $bKdOP = parcelRequire("bKdOP");

var $650fv = parcelRequire("650fv");


var $fJ6Ac = parcelRequire("fJ6Ac");
var $294bf2077fa79917$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $294bf2077fa79917$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $294bf2077fa79917$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $294bf2077fa79917$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $294bf2077fa79917$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fJ6Ac.isElement)(reference) ? (0, $82kk0.default)(reference) : reference.contextElement ? (0, $82kk0.default)(reference.contextElement) : [],
                    popper: (0, $82kk0.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $iEr9Q.default)((0, $650fv.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hBSZx.default)(reference, (0, $iMJep.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $h7lRj.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bKdOP.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$294bf2077fa79917$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $294bf2077fa79917$export$8f7491d57c8f97a9 = /*#__PURE__*/ $294bf2077fa79917$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hBSZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd208c8e3dd9cb4f$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $6Kv1j = parcelRequire("6Kv1j");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $1lDxt = parcelRequire("1lDxt");

var $8WCqw = parcelRequire("8WCqw");

var $9YuAb = parcelRequire("9YuAb");

var $dNBRj = parcelRequire("dNBRj");
function $cd208c8e3dd9cb4f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $dNBRj.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $dNBRj.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cd208c8e3dd9cb4f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fJ6Ac.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fJ6Ac.isHTMLElement)(offsetParent) && $cd208c8e3dd9cb4f$var$isElementScaled(offsetParent);
    var documentElement = (0, $8WCqw.default)(offsetParent);
    var rect = (0, $2aOS9.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3UmrH.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $9YuAb.default)(documentElement)) scroll = (0, $6Kv1j.default)(offsetParent);
        if ((0, $fJ6Ac.isHTMLElement)(offsetParent)) {
            offsets = (0, $2aOS9.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $1lDxt.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2aOS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1953fa21ac68a407$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dNBRj = parcelRequire("dNBRj");

var $iHejO = parcelRequire("iHejO");

var $duzhc = parcelRequire("duzhc");
function $1953fa21ac68a407$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fJ6Ac.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $dNBRj.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $dNBRj.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fJ6Ac.isElement)(element) ? (0, $iHejO.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $duzhc.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("fJ6Ac", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b7302a2f8f3e16d5$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $b7302a2f8f3e16d5$export$af51f0f06c0f328a);

var $iHejO = parcelRequire("iHejO");
function $b7302a2f8f3e16d5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $iHejO.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b7302a2f8f3e16d5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $iHejO.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b7302a2f8f3e16d5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $iHejO.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("iHejO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c7598303229a8b$export$2e2bcd8739ae039);
function $d9c7598303229a8b$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("dNBRj", function(module, exports) {

$parcel$export(module.exports, "max", () => $a0bd37f1ec3b8c5c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c);
var $a0bd37f1ec3b8c5c$export$8960430cfd85939f = Math.max;
var $a0bd37f1ec3b8c5c$export$96ec731ed4dcb222 = Math.min;
var $a0bd37f1ec3b8c5c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("duzhc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2970d7bf044ee4$export$2e2bcd8739ae039);

var $eL5lS = parcelRequire("eL5lS");
function $9d2970d7bf044ee4$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eL5lS.default)());
}

});
parcelRegister("eL5lS", function(module, exports) {

$parcel$export(module.exports, "default", () => $abe99b418685a06a$export$2e2bcd8739ae039);
function $abe99b418685a06a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("6Kv1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9f19ecf6c383bb$export$2e2bcd8739ae039);

var $hNX0K = parcelRequire("hNX0K");

var $iHejO = parcelRequire("iHejO");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $d39KE = parcelRequire("d39KE");
function $4e9f19ecf6c383bb$export$2e2bcd8739ae039(node) {
    if (node === (0, $iHejO.default)(node) || !(0, $fJ6Ac.isHTMLElement)(node)) return (0, $hNX0K.default)(node);
    else return (0, $d39KE.default)(node);
}

});
parcelRegister("hNX0K", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64c9a95bd91d41$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $cf64c9a95bd91d41$export$2e2bcd8739ae039(node) {
    var win = (0, $iHejO.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("d39KE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0273a9c8aeed2a1a$export$2e2bcd8739ae039);
function $0273a9c8aeed2a1a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3UmrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d88034c5dd05ef3$export$2e2bcd8739ae039);
function $2d88034c5dd05ef3$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("1lDxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fb66c376a9887fc$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");

var $8WCqw = parcelRequire("8WCqw");

var $hNX0K = parcelRequire("hNX0K");
function $0fb66c376a9887fc$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2aOS9.default)((0, $8WCqw.default)(element)).left + (0, $hNX0K.default)(element).scrollLeft;
}

});
parcelRegister("8WCqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $68318c45b50bb45b$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $68318c45b50bb45b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fJ6Ac.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("9YuAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $743170baa6e13398$export$2e2bcd8739ae039);

var $326U9 = parcelRequire("326U9");
function $743170baa6e13398$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $326U9.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("326U9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2356ea197825164b$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
function $2356ea197825164b$export$2e2bcd8739ae039(element) {
    return (0, $iHejO.default)(element).getComputedStyle(element);
}

});



parcelRegister("h7lRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7640bd28e53eae4$export$2e2bcd8739ae039);

var $2aOS9 = parcelRequire("2aOS9");
function $c7640bd28e53eae4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2aOS9.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("82kk0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9e461cb51b14a7$export$2e2bcd8739ae039);

var $91lyT = parcelRequire("91lyT");

var $lDDlB = parcelRequire("lDDlB");

var $iHejO = parcelRequire("iHejO");

var $9YuAb = parcelRequire("9YuAb");
function $5d9e461cb51b14a7$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $91lyT.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $iHejO.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $9YuAb.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($5d9e461cb51b14a7$export$2e2bcd8739ae039((0, $lDDlB.default)(target)));
}

});
parcelRegister("91lyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6914eec2bc706a91$export$2e2bcd8739ae039);

var $lDDlB = parcelRequire("lDDlB");

var $9YuAb = parcelRequire("9YuAb");

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $6914eec2bc706a91$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3UmrH.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fJ6Ac.isHTMLElement)(node) && (0, $9YuAb.default)(node)) return node;
    return $6914eec2bc706a91$export$2e2bcd8739ae039((0, $lDDlB.default)(node));
}

});
parcelRegister("lDDlB", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0bc31192c04a8d$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $8WCqw = parcelRequire("8WCqw");

var $fJ6Ac = parcelRequire("fJ6Ac");
function $fc0bc31192c04a8d$export$2e2bcd8739ae039(element) {
    if ((0, $3UmrH.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fJ6Ac.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $8WCqw.default)(element) // fallback
    );
}

});



parcelRegister("iMJep", function(module, exports) {

$parcel$export(module.exports, "default", () => $dacfcbb55f910cab$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $3UmrH = parcelRequire("3UmrH");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $4hrjD = parcelRequire("4hrjD");

var $lDDlB = parcelRequire("lDDlB");

var $eL5lS = parcelRequire("eL5lS");
function $dacfcbb55f910cab$var$getTrueOffsetParent(element) {
    if (!(0, $fJ6Ac.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $326U9.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $dacfcbb55f910cab$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eL5lS.default)());
    var isIE = /Trident/i.test((0, $eL5lS.default)());
    if (isIE && (0, $fJ6Ac.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $326U9.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $lDDlB.default)(element);
    if ((0, $fJ6Ac.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fJ6Ac.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3UmrH.default)(currentNode)) < 0){
        var css = (0, $326U9.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $dacfcbb55f910cab$export$2e2bcd8739ae039(element) {
    var window = (0, $iHejO.default)(element);
    var offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $4hrjD.default)(offsetParent) && (0, $326U9.default)(offsetParent).position === 'static')offsetParent = $dacfcbb55f910cab$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3UmrH.default)(offsetParent) === 'html' || (0, $3UmrH.default)(offsetParent) === 'body' && (0, $326U9.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $dacfcbb55f910cab$var$getContainingBlock(element) || window;
}

});
parcelRegister("4hrjD", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ddf04ce957c4d3$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");
function $31ddf04ce957c4d3$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3UmrH.default)(element)) >= 0;
}

});


parcelRegister("iEr9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d941075e5e06e50f$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");
function $d941075e5e06e50f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d941075e5e06e50f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d941075e5e06e50f$var$order(modifiers); // order based on phase
    return (0, $iqJ7p.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("iqJ7p", function(module, exports) {

$parcel$export(module.exports, "top", () => $d6ada747b06c007d$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $d6ada747b06c007d$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $d6ada747b06c007d$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $d6ada747b06c007d$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $d6ada747b06c007d$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $d6ada747b06c007d$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $d6ada747b06c007d$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $d6ada747b06c007d$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $d6ada747b06c007d$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $d6ada747b06c007d$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $d6ada747b06c007d$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $d6ada747b06c007d$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $d6ada747b06c007d$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $d6ada747b06c007d$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $d6ada747b06c007d$export$d087d3878fdf71d5);
var $d6ada747b06c007d$export$1e95b668f3b82d = 'top';
var $d6ada747b06c007d$export$40e543e69a8b3fbb = 'bottom';
var $d6ada747b06c007d$export$79ffe56a765070d2 = 'right';
var $d6ada747b06c007d$export$eabcd2c8791e7bf4 = 'left';
var $d6ada747b06c007d$export$dfb5619354ba860 = 'auto';
var $d6ada747b06c007d$export$aec2ce47c367b8c3 = [
    $d6ada747b06c007d$export$1e95b668f3b82d,
    $d6ada747b06c007d$export$40e543e69a8b3fbb,
    $d6ada747b06c007d$export$79ffe56a765070d2,
    $d6ada747b06c007d$export$eabcd2c8791e7bf4
];
var $d6ada747b06c007d$export$b3571188c770cc5a = 'start';
var $d6ada747b06c007d$export$bd5df0f255a350f8 = 'end';
var $d6ada747b06c007d$export$390fd549c5303b4d = 'clippingParents';
var $d6ada747b06c007d$export$d7b7311ec04a3e8f = 'viewport';
var $d6ada747b06c007d$export$ae5ab1c730825774 = 'popper';
var $d6ada747b06c007d$export$ca50aac9f3ba507f = 'reference';
var $d6ada747b06c007d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $d6ada747b06c007d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []);
var $d6ada747b06c007d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($d6ada747b06c007d$export$aec2ce47c367b8c3, [
    $d6ada747b06c007d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $d6ada747b06c007d$export$b3571188c770cc5a,
        placement + "-" + $d6ada747b06c007d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $d6ada747b06c007d$export$421679a7c3d56e = 'beforeRead';
var $d6ada747b06c007d$export$aafa59e2e03f2942 = 'read';
var $d6ada747b06c007d$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $d6ada747b06c007d$export$c65e99957a05207c = 'beforeMain';
var $d6ada747b06c007d$export$f22da7240b7add18 = 'main';
var $d6ada747b06c007d$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $d6ada747b06c007d$export$8d4d2d70e7d46032 = 'beforeWrite';
var $d6ada747b06c007d$export$68d8715fc104d294 = 'write';
var $d6ada747b06c007d$export$70a6e5159acce2e6 = 'afterWrite';
var $d6ada747b06c007d$export$d087d3878fdf71d5 = [
    $d6ada747b06c007d$export$421679a7c3d56e,
    $d6ada747b06c007d$export$aafa59e2e03f2942,
    $d6ada747b06c007d$export$6964f6c886723980,
    $d6ada747b06c007d$export$c65e99957a05207c,
    $d6ada747b06c007d$export$f22da7240b7add18,
    $d6ada747b06c007d$export$bab79516f2d662fe,
    $d6ada747b06c007d$export$8d4d2d70e7d46032,
    $d6ada747b06c007d$export$68d8715fc104d294,
    $d6ada747b06c007d$export$70a6e5159acce2e6
];

});


parcelRegister("bKdOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $88ceb5bd2b05c557$export$2e2bcd8739ae039);
function $88ceb5bd2b05c557$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("650fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d367282185b78e$export$2e2bcd8739ae039);
function $46d367282185b78e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("5d22G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cafc035423eb95a$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");
var $3cafc035423eb95a$var$passive = {
    passive: true
};
function $3cafc035423eb95a$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $iHejO.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3cafc035423eb95a$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3cafc035423eb95a$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3cafc035423eb95a$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3cafc035423eb95a$var$effect,
    data: {}
};

});

parcelRegister("erJZ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84741b446df23b4$export$2e2bcd8739ae039);

var $e8ZLL = parcelRequire("e8ZLL");
function $a84741b446df23b4$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $e8ZLL.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a84741b446df23b4$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a84741b446df23b4$var$popperOffsets,
    data: {}
};

});
parcelRegister("e8ZLL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c1ba21d03868aa$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $ffRl6 = parcelRequire("ffRl6");

var $iqJ7p = parcelRequire("iqJ7p");
function $a4c1ba21d03868aa$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $lsJel.default)(placement) : null;
    var variation = placement ? (0, $jwYyR.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $iqJ7p.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $iqJ7p.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $iqJ7p.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $iqJ7p.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ffRl6.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $iqJ7p.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $iqJ7p.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("lsJel", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9ff4c508a576765$export$2e2bcd8739ae039);

function $f9ff4c508a576765$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("jwYyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37ffbaf78a48966$export$2e2bcd8739ae039);
function $e37ffbaf78a48966$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("ffRl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b1a1cd84aec3a6$export$2e2bcd8739ae039);
function $b1b1a1cd84aec3a6$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("8AiNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6400452045d38e02$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $iMJep = parcelRequire("iMJep");

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $lsJel = parcelRequire("lsJel");

var $jwYyR = parcelRequire("jwYyR");

var $dNBRj = parcelRequire("dNBRj");
var $6400452045d38e02$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $6400452045d38e02$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $dNBRj.round)(x * dpr) / dpr || 0,
        y: (0, $dNBRj.round)(y * dpr) / dpr || 0
    };
}
function $6400452045d38e02$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $iqJ7p.left);
    var sideY = (0, $iqJ7p.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $iMJep.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $iHejO.default)(popper)) {
            offsetParent = (0, $8WCqw.default)(popper);
            if ((0, $326U9.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $iqJ7p.top) || (placement === (0, $iqJ7p.left) || placement === (0, $iqJ7p.right)) && variation === (0, $iqJ7p.end)) {
            sideY = (0, $iqJ7p.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $iqJ7p.left) || (placement === (0, $iqJ7p.top) || placement === (0, $iqJ7p.bottom)) && variation === (0, $iqJ7p.end)) {
            sideX = (0, $iqJ7p.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $6400452045d38e02$var$unsetSides);
    var _ref4 = roundOffsets === true ? $6400452045d38e02$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $iHejO.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $6400452045d38e02$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $lsJel.default)(state.placement),
        variation: (0, $jwYyR.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $6400452045d38e02$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $6400452045d38e02$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $6400452045d38e02$var$computeStyles,
    data: {}
};

});

parcelRegister("bAjmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $86f212e7a517fbb5$export$2e2bcd8739ae039);

var $3UmrH = parcelRequire("3UmrH");

var $fJ6Ac = parcelRequire("fJ6Ac");
// and applies them to the HTMLElements such as popper and arrow
function $86f212e7a517fbb5$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $86f212e7a517fbb5$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fJ6Ac.isHTMLElement)(element) || !(0, $3UmrH.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $86f212e7a517fbb5$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $86f212e7a517fbb5$var$applyStyles,
    effect: $86f212e7a517fbb5$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lcFdJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fab17b9f71b622$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $iqJ7p = parcelRequire("iqJ7p");
function $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $lsJel.default)(placement);
    var invertDistance = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f6fab17b9f71b622$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $iqJ7p.placements).reduce(function(acc, placement) {
        acc[placement] = $f6fab17b9f71b622$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6fab17b9f71b622$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f6fab17b9f71b622$var$offset
};

});

parcelRegister("7KqQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a41a7ffd8eaaed3$export$2e2bcd8739ae039);

var $kQ8ZL = parcelRequire("kQ8ZL");

var $lsJel = parcelRequire("lsJel");

var $fyd1H = parcelRequire("fyd1H");

var $czpku = parcelRequire("czpku");

var $fW5QL = parcelRequire("fW5QL");

var $iqJ7p = parcelRequire("iqJ7p");

var $jwYyR = parcelRequire("jwYyR");
function $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(placement) {
    if ((0, $lsJel.default)(placement) === (0, $iqJ7p.auto)) return [];
    var oppositePlacement = (0, $kQ8ZL.default)(placement);
    return [
        (0, $fyd1H.default)(placement),
        oppositePlacement,
        (0, $fyd1H.default)(oppositePlacement)
    ];
}
function $5a41a7ffd8eaaed3$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $lsJel.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kQ8ZL.default)(preferredPlacement)
    ] : $5a41a7ffd8eaaed3$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $lsJel.default)(placement) === (0, $iqJ7p.auto) ? (0, $fW5QL.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $lsJel.default)(placement);
        var isStartVariation = (0, $jwYyR.default)(placement) === (0, $iqJ7p.start);
        var isVertical = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $iqJ7p.right) : (0, $iqJ7p.left) : isStartVariation ? (0, $iqJ7p.bottom) : (0, $iqJ7p.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var altVariationSide = (0, $kQ8ZL.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $5a41a7ffd8eaaed3$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $5a41a7ffd8eaaed3$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("kQ8ZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2bfa43e7acf7a1f$export$2e2bcd8739ae039);
var $f2bfa43e7acf7a1f$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $f2bfa43e7acf7a1f$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f2bfa43e7acf7a1f$var$hash[matched];
    });
}

});

parcelRegister("fyd1H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b52422c6016bd931$export$2e2bcd8739ae039);
var $b52422c6016bd931$var$hash = {
    start: 'end',
    end: 'start'
};
function $b52422c6016bd931$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $b52422c6016bd931$var$hash[matched];
    });
}

});

parcelRegister("czpku", function(module, exports) {

$parcel$export(module.exports, "default", () => $926c66d41a194a34$export$2e2bcd8739ae039);

var $c62Z3 = parcelRequire("c62Z3");

var $8WCqw = parcelRequire("8WCqw");

var $2aOS9 = parcelRequire("2aOS9");

var $e8ZLL = parcelRequire("e8ZLL");

var $4SDYu = parcelRequire("4SDYu");

var $iqJ7p = parcelRequire("iqJ7p");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");
function $926c66d41a194a34$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $iqJ7p.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $iqJ7p.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $iqJ7p.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
    var altContext = elementContext === (0, $iqJ7p.popper) ? (0, $iqJ7p.reference) : (0, $iqJ7p.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $c62Z3.default)((0, $fJ6Ac.isElement)(element) ? element : element.contextElement || (0, $8WCqw.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2aOS9.default)(state.elements.reference);
    var popperOffsets = (0, $e8ZLL.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4SDYu.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $iqJ7p.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $iqJ7p.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $iqJ7p.right),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $iqJ7p.top),
                (0, $iqJ7p.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("c62Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ce85c1418d21935$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $5AoPY = parcelRequire("5AoPY");

var $5d4pe = parcelRequire("5d4pe");

var $82kk0 = parcelRequire("82kk0");

var $iMJep = parcelRequire("iMJep");

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $fJ6Ac = parcelRequire("fJ6Ac");

var $2aOS9 = parcelRequire("2aOS9");

var $lDDlB = parcelRequire("lDDlB");

var $3M1PW = parcelRequire("3M1PW");

var $3UmrH = parcelRequire("3UmrH");

var $4SDYu = parcelRequire("4SDYu");

var $dNBRj = parcelRequire("dNBRj");
function $8ce85c1418d21935$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2aOS9.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $iqJ7p.viewport) ? (0, $4SDYu.default)((0, $5AoPY.default)(element, strategy)) : (0, $fJ6Ac.isElement)(clippingParent) ? $8ce85c1418d21935$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4SDYu.default)((0, $5d4pe.default)((0, $8WCqw.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $8ce85c1418d21935$var$getClippingParents(element) {
    var clippingParents = (0, $82kk0.default)((0, $lDDlB.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $326U9.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fJ6Ac.isHTMLElement)(element) ? (0, $iMJep.default)(element) : element;
    if (!(0, $fJ6Ac.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fJ6Ac.isElement)(clippingParent) && (0, $3M1PW.default)(clippingParent, clipperElement) && (0, $3UmrH.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $8ce85c1418d21935$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $8ce85c1418d21935$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $8ce85c1418d21935$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $dNBRj.max)(rect.top, accRect.top);
        accRect.right = (0, $dNBRj.min)(rect.right, accRect.right);
        accRect.bottom = (0, $dNBRj.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $dNBRj.max)(rect.left, accRect.left);
        return accRect;
    }, $8ce85c1418d21935$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("5AoPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $411394afa2383299$export$2e2bcd8739ae039);

var $iHejO = parcelRequire("iHejO");

var $8WCqw = parcelRequire("8WCqw");

var $1lDxt = parcelRequire("1lDxt");

var $duzhc = parcelRequire("duzhc");
function $411394afa2383299$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $iHejO.default)(element);
    var html = (0, $8WCqw.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $duzhc.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $1lDxt.default)(element),
        y: y
    };
}

});

parcelRegister("5d4pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cb195955e9900e4$export$2e2bcd8739ae039);

var $8WCqw = parcelRequire("8WCqw");

var $326U9 = parcelRequire("326U9");

var $1lDxt = parcelRequire("1lDxt");

var $hNX0K = parcelRequire("hNX0K");

var $dNBRj = parcelRequire("dNBRj");
function $3cb195955e9900e4$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $8WCqw.default)(element);
    var winScroll = (0, $hNX0K.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $dNBRj.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $dNBRj.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $1lDxt.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $326U9.default)(body || html).direction === 'rtl') x += (0, $dNBRj.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("3M1PW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf7478da67e8745$export$2e2bcd8739ae039);

var $fJ6Ac = parcelRequire("fJ6Ac");
function $2bf7478da67e8745$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fJ6Ac.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("4SDYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $38db36b96d02eccc$export$2e2bcd8739ae039);
function $38db36b96d02eccc$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("dmhsV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b9ae0b6550b6f37$export$2e2bcd8739ae039);

var $yT6R3 = parcelRequire("yT6R3");
function $9b9ae0b6550b6f37$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $yT6R3.default)(), paddingObject);
}

});
parcelRegister("yT6R3", function(module, exports) {

$parcel$export(module.exports, "default", () => $068decb3807e55f3$export$2e2bcd8739ae039);
function $068decb3807e55f3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("3qyWh", function(module, exports) {

$parcel$export(module.exports, "default", () => $27eee6fc63c552c6$export$2e2bcd8739ae039);
function $27eee6fc63c552c6$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("fW5QL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039);

var $jwYyR = parcelRequire("jwYyR");

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");

var $lsJel = parcelRequire("lsJel");
function $b9a0cf81f1fbb0d2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $iqJ7p.placements) : _options$allowedAutoP;
    var variation = (0, $jwYyR.default)(placement);
    var placements = variation ? flipVariations ? (0, $iqJ7p.variationPlacements) : (0, $iqJ7p.variationPlacements).filter(function(placement) {
        return (0, $jwYyR.default)(placement) === variation;
    }) : (0, $iqJ7p.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $czpku.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $lsJel.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("7zSEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5846324917bf1014$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $lsJel = parcelRequire("lsJel");

var $ffRl6 = parcelRequire("ffRl6");

var $kZNfy = parcelRequire("kZNfy");

var $cEkqa = parcelRequire("cEkqa");

var $h7lRj = parcelRequire("h7lRj");

var $iMJep = parcelRequire("iMJep");

var $czpku = parcelRequire("czpku");

var $jwYyR = parcelRequire("jwYyR");

var $yT6R3 = parcelRequire("yT6R3");

var $dNBRj = parcelRequire("dNBRj");
function $5846324917bf1014$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $czpku.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $lsJel.default)(state.placement);
    var variation = (0, $jwYyR.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ffRl6.default)(basePlacement);
    var altAxis = (0, $kZNfy.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var altSide = mainAxis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $iqJ7p.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $iqJ7p.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $h7lRj.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $yT6R3.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cEkqa.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $iMJep.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cEkqa.within)(tether ? (0, $dNBRj.min)(min, tetherMin) : min, offset, tether ? (0, $dNBRj.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
        var _altSide = mainAxis === 'x' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $iqJ7p.top),
            (0, $iqJ7p.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cEkqa.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cEkqa.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5846324917bf1014$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5846324917bf1014$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("kZNfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48fb5228a571c9a$export$2e2bcd8739ae039);
function $f48fb5228a571c9a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cEkqa", function(module, exports) {

$parcel$export(module.exports, "within", () => $93590faa2f1f82c6$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $93590faa2f1f82c6$export$86c8af6d3ef0b4a);

var $dNBRj = parcelRequire("dNBRj");
function $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max) {
    return (0, $dNBRj.max)(min, (0, $dNBRj.min)(value, max));
}
function $93590faa2f1f82c6$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $93590faa2f1f82c6$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("ek5P6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6d7735846c13c0b$export$2e2bcd8739ae039);

var $lsJel = parcelRequire("lsJel");

var $h7lRj = parcelRequire("h7lRj");

var $3M1PW = parcelRequire("3M1PW");

var $iMJep = parcelRequire("iMJep");

var $ffRl6 = parcelRequire("ffRl6");

var $cEkqa = parcelRequire("cEkqa");

var $dmhsV = parcelRequire("dmhsV");

var $3qyWh = parcelRequire("3qyWh");

var $iqJ7p = parcelRequire("iqJ7p");
var $a6d7735846c13c0b$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $dmhsV.default)(typeof padding !== 'number' ? padding : (0, $3qyWh.default)(padding, (0, $iqJ7p.basePlacements)));
};
function $a6d7735846c13c0b$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $lsJel.default)(state.placement);
    var axis = (0, $ffRl6.default)(basePlacement);
    var isVertical = [
        (0, $iqJ7p.left),
        (0, $iqJ7p.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $a6d7735846c13c0b$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $h7lRj.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $iqJ7p.top) : (0, $iqJ7p.left);
    var maxProp = axis === 'y' ? (0, $iqJ7p.bottom) : (0, $iqJ7p.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $iMJep.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cEkqa.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $a6d7735846c13c0b$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3M1PW.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $a6d7735846c13c0b$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $a6d7735846c13c0b$var$arrow,
    effect: $a6d7735846c13c0b$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("anqoe", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e085d14bcc9886$export$2e2bcd8739ae039);

var $iqJ7p = parcelRequire("iqJ7p");

var $czpku = parcelRequire("czpku");
function $78e085d14bcc9886$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $78e085d14bcc9886$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $iqJ7p.top),
        (0, $iqJ7p.right),
        (0, $iqJ7p.bottom),
        (0, $iqJ7p.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $78e085d14bcc9886$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $czpku.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $czpku.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $78e085d14bcc9886$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $78e085d14bcc9886$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $78e085d14bcc9886$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $78e085d14bcc9886$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $78e085d14bcc9886$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $78e085d14bcc9886$var$hide
};

});




parcelRegister("2HG8y", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $1f8048740832c02d$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $cXw5N = parcelRequire("cXw5N");

var $9sasN = parcelRequire("9sasN");
function $1f8048740832c02d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $cXw5N.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $9sasN.setRef)(innerRef, node);
        (0, $9sasN.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $9sasN.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $9sasN.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("4wJSY", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $34bdbe885d924a05$export$3e67810a3f0e9f1c);
function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
    return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("5a34e", function(module, exports) {

$parcel$export(module.exports, "isSafari", () => $838c050d2f176b76$export$95df08bae54cb4df);
$parcel$export(module.exports, "isAppleDevice", () => $838c050d2f176b76$export$e1865c3bedcd822b);
function $838c050d2f176b76$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $838c050d2f176b76$var$isIPhone() {
    return $838c050d2f176b76$var$testPlatform(/^iPhone/i);
}
function $838c050d2f176b76$var$isMac() {
    return $838c050d2f176b76$var$testPlatform(/^Mac/i);
}
function $838c050d2f176b76$var$isIPad() {
    return $838c050d2f176b76$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $838c050d2f176b76$var$isMac() && navigator.maxTouchPoints > 1;
}
function $838c050d2f176b76$var$isIOS() {
    return $838c050d2f176b76$var$isIPhone() || $838c050d2f176b76$var$isIPad();
}
function $838c050d2f176b76$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        const ua = window.navigator.userAgent?.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $838c050d2f176b76$export$e1865c3bedcd822b() {
    return $838c050d2f176b76$var$isMac() || $838c050d2f176b76$var$isIOS();
}

});

parcelRegister("1BKyN", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $a295ff46d412df78$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $a295ff46d412df78$export$e618dc39ac9ad607);

var $cSGW3 = parcelRequire("cSGW3");

var $gGvqh = parcelRequire("gGvqh");

var $iluyz = parcelRequire("iluyz");

var $6oGQp = parcelRequire("6oGQp");

var $4S2FY = parcelRequire("4S2FY");

var $fW3un = parcelRequire("fW3un");

var $g6y65 = parcelRequire("g6y65");

var $FpaWY = parcelRequire("FpaWY");

var $41aBa = parcelRequire("41aBa");

var $aPWnT = parcelRequire("aPWnT");
const $a295ff46d412df78$export$214b055320e0bf32 = {
    clearIndicator: (0, $6oGQp.clearIndicatorCSS),
    container: (0, $cSGW3.containerCSS),
    control: (0, $gGvqh.css),
    dropdownIndicator: (0, $6oGQp.dropdownIndicatorCSS),
    group: (0, $iluyz.groupCSS),
    groupHeading: (0, $iluyz.groupHeadingCSS),
    indicatorsContainer: (0, $cSGW3.indicatorsContainerCSS),
    input: (0, $4S2FY.inputCSS),
    loadingIndicator: (0, $6oGQp.loadingIndicatorCSS),
    loadingMessage: (0, $fW3un.loadingMessageCSS),
    menu: (0, $fW3un.menuCSS),
    menuList: (0, $fW3un.menuListCSS),
    menuPortal: (0, $fW3un.menuPortalCSS),
    multiValue: (0, $g6y65.multiValueCSS),
    multiValueLabel: (0, $g6y65.multiValueLabelCSS),
    multiValueRemove: (0, $g6y65.multiValueRemoveCSS),
    noOptionsMessage: (0, $fW3un.noOptionsMessageCSS),
    option: (0, $FpaWY.optionCSS),
    placeholder: (0, $41aBa.placeholderCSS),
    singleValue: (0, $aPWnT.css),
    valueContainer: (0, $cSGW3.valueContainerCSS)
};
function $a295ff46d412df78$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("lau8t", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $da5b97c526f06b5a$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $da5b97c526f06b5a$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $9Iej8 = parcelRequire("9Iej8");
var $asiGE = parcelRequire("asiGE");
var $3TR0I = parcelRequire("3TR0I");

var $fdJB9 = parcelRequire("fdJB9");

var $7Qatx = parcelRequire("7Qatx");
const $da5b97c526f06b5a$var$packageName = "platform-pkg";
const $da5b97c526f06b5a$var$packageVersion = "0.0.0-use.local";
const $da5b97c526f06b5a$export$d1de3b251ccaa8a3 = (0, $7Qatx.default)((0, $fdJB9.default));
const $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit = (0, $9Iej8.default)('atlaskit');
const $da5b97c526f06b5a$var$Select = (0, $asiGE.default)({
    componentName: 'select',
    packageName: $da5b97c526f06b5a$var$packageName,
    packageVersion: $da5b97c526f06b5a$var$packageVersion
})((0, $3TR0I.default)({
    onChange: $da5b97c526f06b5a$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $da5b97c526f06b5a$var$packageName,
            packageVersion: $da5b97c526f06b5a$var$packageVersion
        }
    })
})($da5b97c526f06b5a$export$d1de3b251ccaa8a3));
var $da5b97c526f06b5a$export$2e2bcd8739ae039 = $da5b97c526f06b5a$var$Select;

});
parcelRegister("fdJB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4292f0009a275a8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("2OKnX")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $djBXi = parcelRequire("djBXi");

var $2OKnX = parcelRequire("2OKnX");

var $63z2N = parcelRequire("63z2N");
const $a4292f0009a275a8$var$AsyncSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $2OKnX.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $63z2N.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $djBXi.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a4292f0009a275a8$export$2e2bcd8739ae039 = $a4292f0009a275a8$var$AsyncSelect;

});
parcelRegister("djBXi", function(module, exports) {

$parcel$export(module.exports, "default", () => $17a9f59c5814b8a9$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5a34e = parcelRequire("5a34e");

var $fHpHg = parcelRequire("fHpHg");

var $jwj8k = parcelRequire("jwj8k");

var $b1kcy = parcelRequire("b1kcy");

var $2PbHi = parcelRequire("2PbHi");
var $2dBDF = parcelRequire("2dBDF");
var $hFt5x = parcelRequire("hFt5x");

var $StbfM = parcelRequire("StbfM");

var $1NMZ0 = parcelRequire("1NMZ0");

var $fW3un = parcelRequire("fW3un");

var $gInKw = parcelRequire("gInKw");

var $1BKyN = parcelRequire("1BKyN");

var $b0fMV = parcelRequire("b0fMV");
const $17a9f59c5814b8a9$export$9c21a3269931e1e6 = {
    // aria-live is by default with the live region so we don't need it
    // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
    'aria-live': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $b0fMV.isTouchCapable)(),
    captureMenuScroll: !(0, $b0fMV.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $gInKw.createFilter)(),
    formatGroupLabel: (0, $jwj8k.formatGroupLabel),
    getOptionLabel: (0, $jwj8k.getOptionLabel),
    getOptionValue: (0, $jwj8k.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $jwj8k.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $b0fMV.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue);
    const label = $17a9f59c5814b8a9$var$getOptionLabel(props, option);
    const value = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$17a9f59c5814b8a9$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$17a9f59c5814b8a9$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $17a9f59c5814b8a9$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $b0fMV.notNullish));
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) {
    return $17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue));
}
function $17a9f59c5814b8a9$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$17a9f59c5814b8a9$var$shouldHideSelectedOptions(props) || !isSelected) && $17a9f59c5814b8a9$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $17a9f59c5814b8a9$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $17a9f59c5814b8a9$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $17a9f59c5814b8a9$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $17a9f59c5814b8a9$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $17a9f59c5814b8a9$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $17a9f59c5814b8a9$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $17a9f59c5814b8a9$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $17a9f59c5814b8a9$var$getOptionValue(props, option);
    return selectValue.some((i)=>$17a9f59c5814b8a9$var$getOptionValue(props, i) === candidate);
}
function $17a9f59c5814b8a9$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $17a9f59c5814b8a9$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $17a9f59c5814b8a9$var$instanceId = 1;
class $17a9f59c5814b8a9$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $17a9f59c5814b8a9$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isVoiceOver = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && (0, $5a34e.isAppleDevice)(), // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $b0fMV.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $b0fMV.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $b0fMV.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $b0fMV.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $b0fMV.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $b0fMV.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $17a9f59c5814b8a9$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $b0fMV.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $17a9f59c5814b8a9$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = (0, $1BKyN.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $b1kcy.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$17a9f59c5814b8a9$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$17a9f59c5814b8a9$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $b0fMV.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $17a9f59c5814b8a9$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            if (!(0, $fHpHg.fg)('platform_dst_layer_observer_select')) return;
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$17a9f59c5814b8a9$var$instanceId);
        this.state.selectValue = (0, $b0fMV.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $b0fMV.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $17a9f59c5814b8a9$var$buildFocusableOptionsWithIds($17a9f59c5814b8a9$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $17a9f59c5814b8a9$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $17a9f59c5814b8a9$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $17a9f59c5814b8a9$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $b0fMV.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $b0fMV.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $17a9f59c5814b8a9$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $17a9f59c5814b8a9$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription(action) {
        const descriptionProp = this.props['aria-describedby'] || this.props['descriptionId'];
        const { isMulti: isMulti } = this.props;
        const { selectValue: selectValue } = this.state;
        const defaultDescription = selectValue.length ? this.getElementId('live-region') : this.getElementId('placeholder');
        if (!isMulti && selectValue.length && action !== 'initial-input-focus') return;
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            return {
                'aria-describedby': descriptionProp ? [
                    descriptionProp,
                    defaultDescription,
                    multiMessage
                ].join(' ') : [
                    defaultDescription,
                    multiMessage
                ].join(' ')
            };
        } else return {
            'aria-describedby': descriptionProp ? [
                descriptionProp,
                defaultDescription
            ].join(' ') : defaultDescription
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'both',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-describedby': this.props['aria-describedby'] || descriptionId,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription(ariaSelection?.action)
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2PbHi.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $b0fMV.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $5uXOq.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $5uXOq.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $2OMIu.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled && (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : isDisabled,
                'aria-describedby': (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? headingId : undefined,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $5uXOq.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $2OMIu.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const calculateListboxLabel = ()=>{
            // First in name calculation, overwrites aria-label
            if (labelId) return {
                'aria-labelledby': labelId
            };
            // Second in name calcuation, overwrites everything else except aria-labelledby
            if (label) return {
                'aria-label': label
            };
            // Fallback if no label or labelId is provided, might catch label via <label for> otherwise
            // will most likely not have an accessible name
            return {
                'aria-labelledby': this.inputRef?.id || this.getElementId('input')
            };
        };
        const menuElement = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fW3un.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $2OMIu.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hFt5x.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $2OMIu.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    'aria-multiselectable': (this.isVoiceOver || !commonProps.isMulti) && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox when ff is on
                                    ...(0, $fHpHg.fg)('design_system_select-a11y-improvement') && calculateListboxLabel()
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $2OMIu.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2dBDF.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NMZ0.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isVoiceOver
        });
    }
    renderMultiselectMessage() {
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: ", multiple selections available,"
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $2OMIu.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $2OMIu.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $5a34e.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $StbfM.NotifyOpenLayerObserver), {
                    isOpen: (0, $fHpHg.fg)('platform_dst_layer_observer_select') && this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
}

});
parcelRegister("jwj8k", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $dff534f610407347$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $dff534f610407347$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $dff534f610407347$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $dff534f610407347$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $dff534f610407347$export$f4da216a6ca54656 = (group)=>group.label;
const $dff534f610407347$export$dac6ace3020563ca = (option)=>option.label;
const $dff534f610407347$export$40be908210c5a79c = (option)=>option.value;
const $dff534f610407347$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("2PbHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ef926a855a779be$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $5FcV4 = parcelRequire("5FcV4");

var $hP7rW = parcelRequire("hP7rW");
function $9ef926a855a779be$export$2e2bcd8739ae039(props) {
    return (0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5FcV4.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hP7rW.default), {
        ...props
    });
}

});
parcelRegister("5FcV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $999b7b8cd9f0c70e$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b0fMV = parcelRequire("b0fMV");
const $999b7b8cd9f0c70e$var$dummyInputStyles = null;
function $999b7b8cd9f0c70e$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $b0fMV.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d3acm _syaz3acm _1e02p1rm _tzy4idpf _t9ec1kuz"
        ])
    });
}

});

parcelRegister("hP7rW", function(module, exports) {

$parcel$export(module.exports, "default", () => $50c8655f2c03f1d9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $b0fMV = parcelRequire("b0fMV");
const $50c8655f2c03f1d9$var$dummyInputStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $50c8655f2c03f1d9$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $b0fMV.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $50c8655f2c03f1d9$var$dummyInputStyles
    });
}

});


parcelRegister("2dBDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $14249926a63529ad$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $3M0Ow = parcelRequire("3M0Ow");

var $6dhDP = parcelRequire("6dhDP");
const $14249926a63529ad$var$RequiredInput = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3M0Ow.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6dhDP.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$14249926a63529ad$export$2e2bcd8739ae039 = $14249926a63529ad$var$RequiredInput;

});
parcelRegister("3M0Ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $752575d8bbf9f979$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bKnKN = parcelRequire("bKnKN");
const $752575d8bbf9f979$var$styles = null;
const $752575d8bbf9f979$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $2OMIu.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $bKnKN.default),
        className: (0, $bwpsq.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _jqf61a21 _tzy4idpf _lcxvglyw"
        ])
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$752575d8bbf9f979$export$2e2bcd8739ae039 = $752575d8bbf9f979$var$RequiredInput;

});

parcelRegister("6dhDP", function(module, exports) {

$parcel$export(module.exports, "default", () => $da28cb792bf87fb6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $bKnKN = parcelRequire("bKnKN");
function $da28cb792bf87fb6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $da28cb792bf87fb6$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $da28cb792bf87fb6$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $da28cb792bf87fb6$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $bKnKN.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$da28cb792bf87fb6$export$2e2bcd8739ae039 = $da28cb792bf87fb6$var$RequiredInput;

});


parcelRegister("hFt5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $86de9e85d01f60c4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f9MvN = parcelRequire("f9MvN");

var $25zrI = parcelRequire("25zrI");
const $86de9e85d01f60c4$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $86de9e85d01f60c4$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $f9MvN.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $25zrI.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                onClick: $86de9e85d01f60c4$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}

});
parcelRegister("f9MvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c785698eb20a81e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
const $6c785698eb20a81e$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $6c785698eb20a81e$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $5uXOq.useRef)(false);
    const isTop = (0, $5uXOq.useRef)(false);
    const touchStart = (0, $5uXOq.useRef)(0);
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $6c785698eb20a81e$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $5uXOq.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $b0fMV.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $5uXOq.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("25zrI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d1383606735f058$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4d1383606735f058$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $4d1383606735f058$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $4d1383606735f058$var$preventTouchMove(e) {
    e.preventDefault();
}
function $4d1383606735f058$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4d1383606735f058$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4d1383606735f058$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $4d1383606735f058$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $4d1383606735f058$var$activeScrollLocks = 0;
const $4d1383606735f058$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4d1383606735f058$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $5uXOq.useRef)({});
    const scrollTarget = (0, $5uXOq.useRef)(null);
    const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4d1383606735f058$var$LOCK_STYLES).forEach((key)=>{
                const val = $4d1383606735f058$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4d1383606735f058$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
        if (!$4d1383606735f058$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4d1383606735f058$var$activeScrollLocks = Math.max($4d1383606735f058$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4d1383606735f058$var$activeScrollLocks < 1) $4d1383606735f058$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4d1383606735f058$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $4d1383606735f058$var$preventTouchMove, $4d1383606735f058$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $4d1383606735f058$var$preventInertiaScroll, $4d1383606735f058$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $4d1383606735f058$var$allowTouchMove, $4d1383606735f058$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("StbfM", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $10d04a4d3c9b7a75$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("1NMZ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $221388b1d82bde88$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-unsafe-spread-props */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $fEB5A = parcelRequire("fEB5A");

var $h1mGH = parcelRequire("h1mGH");
const $221388b1d82bde88$var$LiveRegion = (props)=>(0, $fHpHg.fg)('compiled-react-select') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fEB5A.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mGH.default), {
        ...props
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$221388b1d82bde88$export$2e2bcd8739ae039 = $221388b1d82bde88$var$LiveRegion;

});
parcelRegister("fEB5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed33a942f37fb49$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $gER7R = parcelRequire("gER7R");

var $jLN4A = parcelRequire("jLN4A");
const $7ed33a942f37fb49$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gER7R.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $fHpHg.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            }),
            !(0, $fHpHg.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-focused",
                        children: ariaFocused
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        id: "aria-guidance",
                        children: ariaGuidance
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jLN4A.default), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jLN4A.default), {
                "aria-live": ariaLive,
                "aria-atomic": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
                "aria-relevant": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
                role: (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'status' : 'log',
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7ed33a942f37fb49$export$2e2bcd8739ae039 = $7ed33a942f37fb49$var$LiveRegion;

});
parcelRegister("gER7R", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $f2979f887e9391fd$export$a7265767c78f9bae);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ 
var $fHpHg = parcelRequire("fHpHg");
const $f2979f887e9391fd$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option ${label}, deselected` : ''; // TODO: this should be handled on backspace|delete if no value, but doing it here first
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return label.length && (0, $fHpHg.fg)('design_system_select-a11y-improvement') || !(0, $fHpHg.fg)('design_system_select-a11y-improvement') ? `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.` : '';
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        // No longer needed after fg('design_system_select-a11y-improvement') is cleaned up
        if (context === 'menu' && !(0, $fHpHg.fg)('design_system_select-a11y-improvement')) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ' not selected'}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("jLN4A", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a8c2f19091ba4e$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $93a8c2f19091ba4e$var$styles = null;
const $93a8c2f19091ba4e$var$A11yText = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _jqf6ydhy _uiztglyw _o5721q9c"
        ])
    });
var $93a8c2f19091ba4e$export$2e2bcd8739ae039 = $93a8c2f19091ba4e$var$A11yText;

});


parcelRegister("h1mGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc3b3f1f04e63754$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $fHpHg = parcelRequire("fHpHg");

var $gER7R = parcelRequire("gER7R");

var $3scb2 = parcelRequire("3scb2");
const $cc3b3f1f04e63754$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // for safari, we will use minimum support from aria-live region
    const isA11yImprovementEnabled = (0, $fHpHg.fg)('design_system_select-a11y-improvement') && !isAppleDevice;
    // Update aria live message configuration when prop changes
    const messages = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gER7R.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $5uXOq.useMemo)(()=>{
        let message = '';
        if (isA11yImprovementEnabled && menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (isA11yImprovementEnabled && !label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        isA11yImprovementEnabled,
        menuIsOpen
    ]);
    const prevInputValue = (0, $5uXOq.useRef)('');
    const ariaFocused = (0, $5uXOq.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (inputValue === prevInputValue.current && isA11yImprovementEnabled) // only announce focus option when searching when ff is on and the input value changed
        // for safari, we will announce for all
        return '';
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isMulti: isMulti
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        prevInputValue.current = inputValue;
        return focusMsg;
    }, [
        inputValue,
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isA11yImprovementEnabled,
        isMulti
    ]);
    const ariaResults = (0, $5uXOq.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
        if ((0, $fHpHg.fg)('design_system_select-a11y-improvement')) // don't announce guidance at all when ff is on
        return '';
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-results"
    }, ariaResults), !(0, $fHpHg.fg)('design_system_select-a11y-improvement') && /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance)));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3scb2.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3scb2.default), {
        "aria-live": ariaLive,
        "aria-atomic": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'false',
        "aria-relevant": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'additions text',
        role: (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? 'status' : 'log'
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$cc3b3f1f04e63754$export$2e2bcd8739ae039 = $cc3b3f1f04e63754$var$LiveRegion;

});
parcelRegister("3scb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ef6575704ff2acb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $f8Sb3 = parcelRequire("f8Sb3");
function $1ef6575704ff2acb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $1ef6575704ff2acb$var$styles = {
    name: "jvmzbk-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;user-select:none;white-space:nowrap"
};
const $1ef6575704ff2acb$var$A11yText = (props)=>/*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $1ef6575704ff2acb$var$styles,
        ...props
    });
var $1ef6575704ff2acb$export$2e2bcd8739ae039 = $1ef6575704ff2acb$var$A11yText;

});



parcelRegister("gInKw", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $9499cdf192fc0df5$export$5d81789ff4aeccdf);

var $8QpSo = parcelRequire("8QpSo");

var $a36ws = parcelRequire("a36ws");
const $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput = (0, $8QpSo.default)((0, $a36ws.stripDiacritics));
const $9499cdf192fc0df5$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $9499cdf192fc0df5$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $9499cdf192fc0df5$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $9499cdf192fc0df5$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $9499cdf192fc0df5$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $9499cdf192fc0df5$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $9499cdf192fc0df5$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $a36ws.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("a36ws", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $b90cbf4384c79b10$export$b5bee4b27048330b);
const $b90cbf4384c79b10$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $b90cbf4384c79b10$var$anyDiacritic = new RegExp('[' + $b90cbf4384c79b10$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $b90cbf4384c79b10$var$diacriticToBase = {};
for(let i = 0; i < $b90cbf4384c79b10$var$diacritics.length; i++){
    let diacritic = $b90cbf4384c79b10$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$b90cbf4384c79b10$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $b90cbf4384c79b10$export$b5bee4b27048330b = (str)=>{
    return str.replace($b90cbf4384c79b10$var$anyDiacritic, (match)=>$b90cbf4384c79b10$var$diacriticToBase[match]);
};

});



parcelRegister("2OKnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2689712370970f9b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b0fMV = parcelRequire("b0fMV");
function $2689712370970f9b$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $5uXOq.useRef)(undefined);
    const mounted = (0, $5uXOq.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $5uXOq.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $b0fMV.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("63z2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $52e9513a75e7f00c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $52e9513a75e7f00c$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $5uXOq.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("7Qatx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac7c8ad4681692a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fHpHg = parcelRequire("fHpHg");

var $5IVHm = parcelRequire("5IVHm");
function $5ac7c8ad4681692a$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $5uXOq.useRef)(null);
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": (0, $fHpHg.fg)('design_system_select-a11y-improvement') ? undefined : 'assertive',
            ariaLiveMessages: //TO DO: Still need live region for PopupSelect because of the menu being open by default
            (0, $5IVHm.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $5IVHm.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("5IVHm", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $e1e3dc8406f8de80$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $e1e3dc8406f8de80$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $e1e3dc8406f8de80$export$8ee33f304118fce4);

var $fHpHg = parcelRequire("fHpHg");
function $e1e3dc8406f8de80$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    if (focused.label && groupData?.label && (0, $fHpHg.fg)('design_system_select-a11y-improvement')) return `${focused.label}, ${groupData?.label}`;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $e1e3dc8406f8de80$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $e1e3dc8406f8de80$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("f2Cxi", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $73214f191156d056$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $73214f191156d056$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $73214f191156d056$export$71abc632aa29e6fe);
/* components.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7kQOw = parcelRequire("7kQOw");

var $b1kcy = parcelRequire("b1kcy");

var $cBCgC = parcelRequire("cBCgC");
const $73214f191156d056$var$menuDialogStyles = null;
const $73214f191156d056$export$c94219dad7c0e37d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, id: id, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`,
        className: (0, $bwpsq.default)([
            "_2rkoiti9 _1pby16oo _bfhk1bhr _16qseva7"
        ]),
        children: children
    });
});
// ==============================
// Custom Components
// ==============================
const $73214f191156d056$var$dropdownStyles = null;
const $73214f191156d056$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _12l2v77o _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kQOw))), {
            color: "currentColor",
            label: ""
        })
    });
const $73214f191156d056$var$controlStyles = null;
const $73214f191156d056$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ref: innerRef,
        className: (0, $bwpsq.default)([
            "_85i51b66 _1q51u2gc _y4tiu2gc _bozgu2gc"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props,
            innerProps: innerProps
        })
    });
const $73214f191156d056$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).Control, {
            ...props
        })
    });
// NOTE `props` intentionally omitted from `Fragment`
const $73214f191156d056$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        children: children
    });
// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
const $73214f191156d056$var$ClearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).ClearIndicator, {
        ...props
    });
const $73214f191156d056$var$MultiValueRemove = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b1kcy.components).MultiValueRemove, {
        ...props
    });
const $73214f191156d056$export$71abc632aa29e6fe = {
    Control: $73214f191156d056$var$Control,
    DropdownIndicator: $73214f191156d056$var$DropdownIndicator,
    Menu: $73214f191156d056$var$Menu,
    ClearIndicator: $73214f191156d056$var$ClearIndicator,
    MultiValueRemove: $73214f191156d056$var$MultiValueRemove
};

});
parcelRegister("7kQOw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bd994b90fa78030d2d1c292998636115>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55735e66b3bc3e4b$var$_react = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $55735e66b3bc3e4b$var$_search = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("aWy0H")));

var $55735e66b3bc3e4b$var$_search2 = $55735e66b3bc3e4b$var$_interopRequireDefault((parcelRequire("Ltnm7")));
function $55735e66b3bc3e4b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SearchIcon.
 * This component is SearchIcon, with `UNSAFE_fallbackIcon` set to "EditorSearchIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $55735e66b3bc3e4b$var$SearchIcon = (props)=>/*#__PURE__*/ $55735e66b3bc3e4b$var$_react.default.createElement($55735e66b3bc3e4b$var$_search.default, Object.assign({
        LEGACY_fallbackIcon: $55735e66b3bc3e4b$var$_search2.default
    }, props));
$55735e66b3bc3e4b$var$SearchIcon.Name = 'SearchIconMigration';
var $55735e66b3bc3e4b$var$_default = module.exports.default = $55735e66b3bc3e4b$var$SearchIcon;

});
parcelRegister("Ltnm7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08eb2d4df89f92f3$var$_react = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $08eb2d4df89f92f3$var$_search = $08eb2d4df89f92f3$var$_interopRequireDefault((parcelRequire("aWy0H")));
function $08eb2d4df89f92f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08eb2d4df89f92f3$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $08eb2d4df89f92f3$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $08eb2d4df89f92f3$var$_search.default
    }));
$08eb2d4df89f92f3$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $08eb2d4df89f92f3$var$_default = module.exports.default = $08eb2d4df89f92f3$var$EditorSearchIcon;

});



parcelRegister("aztrV", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $eda715fe218ca2e5$export$17baa7c95b6ba1b8);

var $8Oct0 = parcelRequire("8Oct0");
function $eda715fe218ca2e5$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore error TS2353: Object literal may only specify known properties, and &#39;onClose&#39; does not exist in type &#39;{ isOpen?: boolean | undefined; }&#39;.
    (0, $8Oct0.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});


const $58a8cc6dba6ea954$export$8bd078c872bc40fb = 500;

parcelRegister("4HmJy", function(module, exports) {

$parcel$export(module.exports, "controlHeight", () => $e0e3bda040aef7bc$export$9b3bae4d96b17b58);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $e0e3bda040aef7bc$export$9b3bae4d96b17b58 = 58;

});

parcelRegister("dAYGO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ad341b23adec6d1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $k2Dsk = parcelRequire("k2Dsk");
class $2ad341b23adec6d1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isSearchEnabled: false
        };
    }
    renderFieldSearch() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2ad341b23adec6d1$var$ControlWrapper, {
            ...this.props.innerProps,
            onClick: this.onClick,
            ref: this.props.innerRef,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-testid": "navigation-apps.common.compontents.switcher.switcher.control"
        }, this.props.children);
    }
    renderEmptySearch() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2ad341b23adec6d1$var$EmptyControlWrapper, null, this.renderFieldSearch());
    }
    render() {
        if (!this.props.isSearchEnabled) return this.renderEmptySearch();
        return this.renderFieldSearch();
    }
    constructor(...args){
        super(...args), this.onClick = (0, $k2Dsk.stopImmediatePropagation)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2ad341b23adec6d1$var$ControlWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zludwz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $2ad341b23adec6d1$var$EmptyControlWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4t3iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k2Dsk", function(module, exports) {

$parcel$export(module.exports, "stopImmediatePropagation", () => $df6728ffcf902167$export$d5cb5f1c8a62fdf1);
const $df6728ffcf902167$export$d5cb5f1c8a62fdf1 = (eventHandler)=>// menu should no close when user click on any button
    // and classic stopPropagation does not work because
    // "close popup" event is attached to document
    // Ref: https://github.com/facebook/react/blob/a1be17140d/packages/react-dom/src/events/ReactBrowserEventEmitter.js
    (e)=>{
        e.nativeEvent.stopImmediatePropagation();
        return eventHandler(e);
    };

});


parcelRegister("bTOZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $086eebfe452501b2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jlx1P = parcelRequire("jlx1P");

var $60SKR = parcelRequire("60SKR");
const $086eebfe452501b2$var$styles = {
    root: "_1tnq1se7 _ulx8glyw _1yubudwz _18y111bn _1dy7udwz _16hgr01l _btpd1ex1 _1kba1h6o _1w901fxt _18y11j9a _u1mb1j9a _ksby1fxt"
};
class $086eebfe452501b2$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static renderIcon() {
        // @ts-expect-error - TS2769 - No overload matches this call.
        return /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jlx1P))), {
            LEGACY_size: "small"
        });
    }
    render() {
        const { label: label, onClick: onClick } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            // @ts-expect-error - TS2322 - Type '{ onClick: () => void; text: string; before: () => Element; styles: (state: any) => { '&:focus': { backgroundColor: string; border: string; borderTop: string; }; '& [data-item-elem-before]': { marginRight: string; color: string; }; ... 5 more ...; alignItems: string; }; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            onClick: onClick,
            text: label,
            before: $086eebfe452501b2$export$2e2bcd8739ae039.renderIcon,
            className: (0, $bwpsq.default)([
                $086eebfe452501b2$var$styles.root
            ])
        });
    }
}

});
parcelRegister("jlx1P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::739edc58ca910533dbcf168239dfad1b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e159993c6ff790f5$var$_react = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e159993c6ff790f5$var$_add = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("46OkO")));

var $e159993c6ff790f5$var$_add2 = $e159993c6ff790f5$var$_interopRequireDefault((parcelRequire("69UIa")));
function $e159993c6ff790f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AddIcon.
 * This component is AddIcon, with `UNSAFE_fallbackIcon` set to "AddIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e159993c6ff790f5$var$AddIcon = (props)=>/*#__PURE__*/ $e159993c6ff790f5$var$_react.default.createElement($e159993c6ff790f5$var$_add.default, Object.assign({
        LEGACY_fallbackIcon: $e159993c6ff790f5$var$_add2.default
    }, props));
$e159993c6ff790f5$var$AddIcon.Name = 'AddIconMigration';
var $e159993c6ff790f5$var$_default = module.exports.default = $e159993c6ff790f5$var$AddIcon;

});
parcelRegister("69UIa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47bf93089677178f$var$_react = $47bf93089677178f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $47bf93089677178f$var$_add = $47bf93089677178f$var$_interopRequireDefault((parcelRequire("46OkO")));
function $47bf93089677178f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47bf93089677178f$var$AddIcon = (props)=>/*#__PURE__*/ $47bf93089677178f$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
    }, props, {
        newIcon: $47bf93089677178f$var$_add.default
    }));
$47bf93089677178f$var$AddIcon.displayName = 'AddIcon';
var $47bf93089677178f$var$_default = module.exports.default = $47bf93089677178f$var$AddIcon;

});


parcelRegister("60SKR", function(module, exports) {

$parcel$export(module.exports, "Item", () => $1bdad1b694e9f595$export$6d08773d2e66f8f2);

var $5uXOq = parcelRequire("5uXOq");

var $2COCu = parcelRequire("2COCu");

var $hjSul = parcelRequire("hjSul");
const $1bdad1b694e9f595$var$WrapperComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, href: href, target: target, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        ref: ref
    };
    return href != null ? // @ts-expect-error - TS2322 - Type '{ href: string; target: (HTMLAttributeAnchorTarget & ("_self" | "_blank" | "_parent" | "_top")) | undefined; children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<...> | null; ... 266 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'RefAttributes<HTMLAnchorElement | HTMLButtonElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ...commonProps,
        href: href,
        target: target
    }) : // @ts-expect-error - TS2322 - Type '{ children: ReactNode; ref: ((instance: LinkProps | null) => void) | MutableRefObject<LinkProps | null> | null; download?: any; ... 265 more ...; prefetch?: false | ... 2 more ... | undefined; }' is not assignable to type 'DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("button", commonProps, children);
});
const $1bdad1b694e9f595$export$6d08773d2e66f8f2 = ({ CustomItem: CustomItem = (0, $2COCu.default), component: // @ts-expect-error - component props do not match
component = $1bdad1b694e9f595$var$WrapperComponent, text: text = null, before: before = ()=>null, after: after = ()=>null, subText: subText, className: className, ...rest })=>{
    const IconBefore = before;
    const IconAfter = after;
    const customProps = {
        ...rest,
        className: className,
        component: component,
        description: subText,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconBefore, {
            color: "currentColor"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconAfter, {
            color: "currentColor"
        }),
        children: text
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomItem, customProps);
};

});


parcelRegister("48kqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c6e15b553185ea0$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $b1kcy = parcelRequire("b1kcy");

var $clxo5 = parcelRequire("clxo5");

var $k2Dsk = parcelRequire("k2Dsk");
class $6c6e15b553185ea0$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onShowMore: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderShowMore() {
        const { showMore: showMore } = this.props.data;
        if (!showMore) return null;
        if (showMore.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c6e15b553185ea0$var$ShowMoreWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
            size: "medium"
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6c6e15b553185ea0$var$ShowMoreWrapper, {
            onKeyDown: this.onShowMoreKeyDown,
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            "data-test-id": "navigation-apps.common.compontents.switcher.switcher.group.show-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            role: "option",
            onClick: this.onShowMoreClick
        }, showMore.label));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1kcy.components).Group, this.props), this.renderShowMore());
    }
    constructor(...args){
        super(...args), this.onShowMoreKeyDown = (e)=>{
            // menu should be able to close
            // but all other events should not be passed to the react-select
            if (e.key !== 'Escape') e.stopPropagation();
        }, this.onShowMoreClick = (0, $k2Dsk.stopImmediatePropagation)(()=>this.props.onShowMore());
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6c6e15b553185ea0$var$ShowMoreWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6rDs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b37adfa019026a8a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2xSAL = parcelRequire("2xSAL");
const $b37adfa019026a8a$var$Input = ({ placeholder: placeholder, onChange: onChange, value: value, inputProps: selectInputProps })=>{
    const inputProps = {
        'aria-activedescendant': selectInputProps['aria-activedescendant'],
        'aria-autocomplete': selectInputProps['aria-autocomplete'],
        'aria-controls': selectInputProps['aria-controls'],
        'aria-errormessage': selectInputProps['aria-errormessage'],
        'aria-expanded': selectInputProps['aria-expanded'],
        'aria-haspopup': selectInputProps['aria-haspopup'],
        'aria-invalid': selectInputProps['aria-invalid'],
        role: selectInputProps.role
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        isAlwaysExpanded: true,
        placeholder: placeholder,
        autoFocus: true,
        shouldFitContainerWidth: true,
        onChange: onChange,
        value: value,
        id: selectInputProps.id,
        describedById: selectInputProps['aria-describedby'],
        ariaLabelText: selectInputProps['aria-label'],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onFocus: selectInputProps.onFocus,
        inputProps: inputProps
    });
};
var $b37adfa019026a8a$export$2e2bcd8739ae039 = $b37adfa019026a8a$var$Input;

});
parcelRegister("2xSAL", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $f115db1c327fbbaa$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fW62l = parcelRequire("fW62l");

var $bngFq = parcelRequire("bngFq");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cBssJ = parcelRequire("cBssJ");

var $hJBhl = parcelRequire("hJBhl");

var $5yLnO = parcelRequire("5yLnO");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const textInput = (0, $5uXOq.useRef)(null);
    const previousValueRef = (0, $5uXOq.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $5uXOq.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $cBssJ.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $f115db1c327fbbaa$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5yLnO.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hJBhl.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $cBssJ.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            reducedHeight: reducedHeight
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
$f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $f115db1c327fbbaa$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
$f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f115db1c327fbbaa$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $f115db1c327fbbaa$var$InputWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $lD23V.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $lD23V.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $lD23V.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $lD23V.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $lD23V.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fW62l", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("9r7BT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7747ff173c91dd60$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $fHpHg = parcelRequire("fHpHg");
const $7747ff173c91dd60$var$containerMedia = {
    invalid: "_srjtgir2",
    disabled: "_6up518qt"
};
const $7747ff173c91dd60$var$inputMediaDisabled = null;
const $7747ff173c91dd60$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7747ff173c91dd60$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf",
    none: "_1h6d3acm _bfhk18uv _syaz1lh4 _80om13gf"
};
const $7747ff173c91dd60$var$invalidStyle = null;
const $7747ff173c91dd60$var$focusWithinStyle = {
    standard: "_ochr1p6i _195er01l _bqhtq049",
    subtle: "_ochr1p6i _195er01l _bqhtq049",
    none: "_ochr3acm _195e18uv _bqhtnruj"
};
const $7747ff173c91dd60$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx3acm _irr318uv"
};
const $7747ff173c91dd60$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _srjtgir2",
    subtle: "_1h6d3acm _1dqonqa1 _syaz1fxt _80om1kdv _16hg18uv _srjtgir2",
    none: "_1h6d3acm _1dqoglyw _syaz1fxt _80om1kdv _16hg18uv _srjtgir2"
};
const $7747ff173c91dd60$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $7747ff173c91dd60$var$getMaxWidth = (width)=>!width ? `100%` : width in $7747ff173c91dd60$var$widthMap ? `${$7747ff173c91dd60$var$widthMap[width]}px` : `${+width}px`;
const $7747ff173c91dd60$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $7747ff173c91dd60$var$containerStyles = null;
const $7747ff173c91dd60$var$inputDisabledStyle = null;
const $7747ff173c91dd60$var$inputCompactStyleWithFg = null;
const $7747ff173c91dd60$var$inputCompactStyle = null;
const $7747ff173c91dd60$var$inputMonospacedStyle = null;
const $7747ff173c91dd60$var$inputFontStyleWithFG = null;
const $7747ff173c91dd60$var$inputStyleMonospacedWithFg = null;
const $7747ff173c91dd60$var$inputStyleNotDataCompactWithFG = null;
const $7747ff173c91dd60$var$inputStyle = null; /**
                          * __Textfield__
                          *
                          * A text field is an input that allows a user to write or edit text.
                          *
                          * - [Examples](https://atlassian.design/components/textfield/examples)
                          * - [Code](https://atlassian.design/components/textfield/code)
                          * - [Usage](https://atlassian.design/components/textfield/usage)
                          */ 
const $7747ff173c91dd60$var$Textfield = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $5uXOq.useRef)(null);
    const handleOnFocus = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnBlur = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7747ff173c91dd60$var$analyticsParams
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$7747ff173c91dd60$var$getMaxWidth(width)}`
        },
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $7747ff173c91dd60$var$getContainerTextBgAndBorderColor[appearance],
            $7747ff173c91dd60$var$containerStyleAppearance[appearance],
            !isDisabled && $7747ff173c91dd60$var$focusWithinStyle[appearance],
            !isDisabled && $7747ff173c91dd60$var$hoverStyle[appearance],
            isDisabled && $7747ff173c91dd60$var$containerMedia.disabled,
            isDisabled && $7747ff173c91dd60$var$disabledStyle[appearance],
            isInvalid && $7747ff173c91dd60$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _10j7r01l",
            className
        ]),
        children: [
            elemBeforeInput,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...spreadProps,
                "aria-invalid": isInvalid ? isInvalid : undefined,
                "data-compact": isCompact ? isCompact : undefined,
                "data-ds--text-field--input": true,
                "data-monospaced": isMonospaced ? isMonospaced : undefined,
                "data-testid": testId,
                disabled: isDisabled,
                name: name,
                onBlur: handleOnBlur,
                onChange: onChange,
                onFocus: handleOnFocus,
                placeholder: placeholder,
                readOnly: isReadOnly,
                ref: setInputRef,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk18uv _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
                    isMonospaced && "_ect41odn",
                    isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
                    isDisabled && "_syaz1lh4 _1idr1lh4",
                    isDisabled && "_1fnx18qt",
                    !isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
                    (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
                    isCompact && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
                    isMonospaced && (0, $fHpHg.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
                ])
            }),
            elemAfterInput
        ]
    });
});
var $7747ff173c91dd60$export$2e2bcd8739ae039 = $7747ff173c91dd60$var$Textfield;

});

parcelRegister("cBssJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $08273d4fc2a6d6da$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("hJBhl", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $99940a7c159b00c0$export$84038b503874befa);

var $5uXOq = parcelRequire("5uXOq");

var $1Seuh = parcelRequire("1Seuh");

var $eh9vz = parcelRequire("eh9vz");

var $0yZbT = parcelRequire("0yZbT");
var $kU1q1 = parcelRequire("kU1q1");
var $2s57o = parcelRequire("2s57o");
const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $99940a7c159b00c0$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1Seuh.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eh9vz)))
    }));
const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, $2s57o.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $kU1q1.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("5yLnO", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $71cc18983db63a0d$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $71cc18983db63a0d$export$8a82bff895521bd9);

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $kweMg = parcelRequire("kweMg");

var $4QlcP = parcelRequire("4QlcP");

var $aWy0H = parcelRequire("aWy0H");

var $0yZbT = parcelRequire("0yZbT");
var $kU1q1 = parcelRequire("kU1q1");
var $2s57o = parcelRequire("2s57o");
const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QlcP))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStyles,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kweMg))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: [
            $71cc18983db63a0d$var$wrapperStylesBefore,
            onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWy0H))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));
const $71cc18983db63a0d$var$wrapperStyles = (0, $2s57o.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $71cc18983db63a0d$var$spacingStyles = (0, $2s57o.xcss)({
    marginRight: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $71cc18983db63a0d$var$wrapperStylesBefore = (0, $2s57o.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $71cc18983db63a0d$var$spacingStylesBefore = (0, $2s57o.xcss)({
    marginLeft: 'space.075',
    [(0, $kU1q1.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});



parcelRegister("9dtoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be7444d19f2bd64$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $clxo5 = parcelRequire("clxo5");
function $6be7444d19f2bd64$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6be7444d19f2bd64$var$LoadingWrapper, {
        height: props.height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clxo5.default), {
        size: "medium"
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6be7444d19f2bd64$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i2nrh",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gzFa5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b794bcef7eba373$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $YgTYj = parcelRequire("YgTYj");

var $dr63l = parcelRequire("dr63l");
class $7b794bcef7eba373$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    renderMenuListContent() {
        const { onBeforeLoading: onBeforeLoading, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dr63l.default), props);
    }
    renderError() {
        const { errorMessage: errorMessage, onRetry: onRetry } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $YgTYj.default), {
            errorMessage: errorMessage,
            onRetry: onRetry
        });
    }
    render() {
        const { isError: isError } = this.props;
        return isError ? this.renderError() : this.renderMenuListContent();
    }
}

});
parcelRegister("YgTYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8db5d1e5e2920327$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $cNW3X = parcelRequire("cNW3X");

var $az4zD = parcelRequire("az4zD");

var $k2Dsk = parcelRequire("k2Dsk");

var $4Ef54 = parcelRequire("4Ef54");
class $8db5d1e5e2920327$export$edf27be85e5f6da0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { errorMessage: errorMessage, intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8db5d1e5e2920327$var$ErrorMessageParentContainer, {
            "data-test-id": "navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8db5d1e5e2920327$var$ErrorMessageContainer, null, errorMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
            onClick: this.onClick
        }, formatMessage((0, $4Ef54.default).retry))));
    }
    constructor(...args){
        super(...args), this.onClick = (0, $k2Dsk.stopImmediatePropagation)(()=>this.props.onRetry());
    }
}
var $8db5d1e5e2920327$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($8db5d1e5e2920327$export$edf27be85e5f6da0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8db5d1e5e2920327$var$ErrorMessageParentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $8db5d1e5e2920327$var$ErrorMessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81vhk _1bto1l2s _syaz1fxt _otyru2gc _slp31hna _1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Ef54", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccc38c6aa553a90$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ccc38c6aa553a90$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("dr63l", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd741accbf9449cb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b1kcy = parcelRequire("b1kcy");
class $cd741accbf9449cb$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    renderListHeading() {
        const { listHeading: listHeading, options: options, isLoading: isLoading } = this.props;
        if (!listHeading || isLoading || !options || options.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd741accbf9449cb$var$ListHeadingWrapper, null, listHeading);
    }
    render() {
        const { listHeading: listHeading, children: children, ...props } = this.props;
        return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; isLoading: boolean; options: ItemGroup[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b1kcy.components).MenuList, props, this.renderListHeading(), children));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cd741accbf9449cb$var$ListHeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _k48p1wq8 _1bto1l2s _ca0qutpp _u5f3utpp _n3tdu2gc _19bvutpp",
            __cmplp.className
        ])
    });
});

});


parcelRegister("15ZDY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae7ea467251319ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae7ea467251319ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    otherRecentBoards: {
        "id": "navigation-apps.switcher.other-recent-boards",
        "defaultMessage": "Other boards"
    }
});

});

parcelRegister("bv5KO", function(module, exports) {

$parcel$export(module.exports, "default", () => $722d8827e556040a$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $60SKR = parcelRequire("60SKR");
const $722d8827e556040a$var$styles = {
    root: "_1tnqidpf _16hgr01l _btpdoahv _1w901fxt _18y1r01l _ksby1fxt _i9a11fxt",
    isFocused: "_16hg166n",
    isSelected: "_16hgfg4m _1w901e6v _ksby1e6v",
    isFocusedAndSelected: "_16hgi1yw",
    isViewAll: "_1w901e6v"
};
class $722d8827e556040a$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { data: data, isFocused: isFocused, isSelected: isSelected } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            ...data,
            component: this.renderComponent,
            // @ts-expect-error - TS2322 - Type '{ component: (props: { className: string; children: ReactNode; }) => Element; isFocused: boolean; isSelected: boolean; styles: (state: any) => { '&:focus': { backgroundColor: string; }; ... 5 more ...; height: string; }; ... 6 more ...; isDemo?: boolean | undefined; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            isFocused: isFocused,
            isSelected: isSelected,
            className: (0, $bwpsq.default)([
                $722d8827e556040a$var$styles.root,
                isFocused && $722d8827e556040a$var$styles.isFocused,
                isSelected && $722d8827e556040a$var$styles.isSelected,
                isFocused && isSelected && $722d8827e556040a$var$styles.isFocusedAndSelected,
                data.isViewAll && $722d8827e556040a$var$styles.isViewAll
            ])
        });
    }
    constructor(...args){
        super(...args), this.onClick = (e)=>{
            if (e.ctrlKey || e.metaKey || e.button === 1) // if item was clicked with cmd or control or middle click -> simply open item in the new window
            return;
            e.preventDefault();
            if (this.props.innerProps && this.props.innerProps.onClick) this.props.innerProps.onClick();
        }, this.renderComponent = (props)=>{
            const { innerProps: innerProps, innerRef: innerRef, data: { url: url } } = this.props;
            return /*#__PURE__*/ $5uXOq.createElement("a", {
                ...innerProps,
                ref: innerRef,
                href: url,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: props.className,
                onClick: this.onClick
            }, props.children);
        };
    }
}

});


parcelRegister("dymxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d89767541e133d1$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dGKFs = parcelRequire("dGKFs");

var $60SKR = parcelRequire("60SKR");
const $5d89767541e133d1$var$styles = {
    root: "_1tnq1l7b _1wgmidpf _17bz1r31 _e0gcglyw _15451o36 _16hgr01l _1w901kw7 _12r21wq8 _1bk61b66 _davf1jma _u1mb1j9a _1fh11kw7 _ksby1kw7",
    isSelected: "_16hg1j9a _1w901e6v _1fh11e6v _ksby1e6v"
};
// @ts-expect-error - TS2769 - No overload matches this call.
const $5d89767541e133d1$var$renderChevron = ()=>/*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dGKFs))), {
        spacing: "spacious"
    });
class $5d89767541e133d1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isOpen: false,
            Icon: ()=>null,
            subText: '',
            targetRef: null,
            onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { isOpen: isOpen, text: text, subText: subText, onMouseEnter: onMouseEnter, targetRef: targetRef } = this.props;
        return /*#__PURE__*/ $5uXOq.createElement("div", null, /*#__PURE__*/ $5uXOq.createElement((0, $60SKR.Item), {
            component: this.renderComponent,
            text: text,
            subText: subText,
            before: this.props.Icon,
            after: $5d89767541e133d1$var$renderChevron,
            // @ts-expect-error - TS2322 - Type '{ component: (props: any) => Element; text: string; subText: string; before: ComponentType<any>; after: () => Element; isSelected: boolean; styles: (state: any) => any; onMouseEnter: () => void; targetRef: unknown; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
            isSelected: isOpen,
            onMouseEnter: onMouseEnter,
            targetRef: targetRef,
            className: (0, $bwpsq.default)([
                $5d89767541e133d1$var$styles.root,
                isOpen && $5d89767541e133d1$var$styles.isSelected
            ])
        }));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderComponent = (props)=>/*#__PURE__*/ $5uXOq.createElement("button", {
                ref: props.targetRef,
                "aria-expanded": this.props.isOpen,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: props.className,
                onMouseEnter: props.onMouseEnter,
                id: "navigation-apps.scope-switcher-trigger-button"
            }, props.children);
    }
}

});

parcelRegister("8aG9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fed20b40146a444$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1fed20b40146a444$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    labelBoardsInProjectLocation: {
        "id": "navigation-apps.scope-switcher-v2.label-boards-in-project-location",
        "defaultMessage": "Boards in {locationName}"
    },
    labelBoardsInUserLocationNew: {
        "id": "navigation-apps.scope-switcher-v2.label-boards-in-user-location-new",
        "defaultMessage": "{locationName}''{lastLetter, select, s {} z {} other {s}} boards"
    },
    otherRecentBoards: {
        "id": "navigation-apps.scope-switcher-v2.other-recent-boards",
        "defaultMessage": "Other boards"
    },
    createBoard: {
        "id": "navigation-apps.scope-switcher-v2.create-board",
        "defaultMessage": "Create board"
    },
    board: {
        "id": "navigation-apps.scope-switcher-v2.board",
        "defaultMessage": "Board"
    },
    boards: {
        "id": "navigation-apps.scope-switcher-v2.boards",
        "defaultMessage": "Boards"
    },
    locationDoesNotHaveBoard: {
        "id": "navigation-apps.scope-switcher-v2.location-does-not-have-board",
        "defaultMessage": "{location} doesn't have a board"
    },
    projectLocationDescription: {
        "id": "navigation-apps.scope-switcher-v2.project-location-description",
        "defaultMessage": "in {location}"
    },
    userLocationDescriptionNew: {
        "id": "navigation-apps.scope-switcher-v2.user-location-description-new",
        "defaultMessage": "{locationName}''{lastLetter, select, s {} z {} other {s}}"
    },
    viewAllBoards: {
        "id": "navigation-apps.scope-switcher-v2.view-all-boards",
        "defaultMessage": "View all boards"
    },
    viewAll: {
        "id": "navigation-apps.scope-switcher-v2.view-all",
        "defaultMessage": "View all"
    },
    searchPlaceholder: {
        "id": "navigation-apps.scope-switcher-v2.search-placeholder",
        "defaultMessage": "Search for boards\u2026"
    },
    searchBoardsInLocationLabel: {
        "id": "navigation-apps.scope-switcher-v2.search-boards-in-location-label",
        "defaultMessage": "Boards in {locationName}"
    },
    searchBoardsNotInLocationLabel: {
        "id": "navigation-apps.scope-switcher-v2.search-boards-not-in-location-label",
        "defaultMessage": "Other boards"
    },
    searchNoMatchesFound: {
        "id": "navigation-apps.scope-switcher-v2.search-no-matches-found",
        "defaultMessage": "No results"
    },
    errorMessage: {
        "id": "navigation-apps.scope-switcher-v2.error-message",
        "defaultMessage": "We're having troubles connecting to your boards"
    },
    showMore: {
        "id": "navigation-apps.scope-switcher-v2.show-more",
        "defaultMessage": "Show { remainingBoards } more"
    }
});

});




parcelRegister("cYlk7", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $cdd4ab536fcf9459$export$3901076af3749fa9);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");

var $leRCk = parcelRequire("leRCk");
const $cdd4ab536fcf9459$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $lzeFL.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cdd4ab536fcf9459$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cdd4ab536fcf9459$var$useCurrentUserBasic();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $leRCk.useUserSubscriber)();
    (0, $5uXOq.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cdd4ab536fcf9459$export$3901076af3749fa9 = ()=>(0, $9OXo1.useTenantContext)().isAnonymous ? $cdd4ab536fcf9459$var$useCurrentUserBasic() : $cdd4ab536fcf9459$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cdd4ab536fcf9459$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cdd4ab536fcf9459$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("leRCk", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $46a581f1f6efe569$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $46a581f1f6efe569$export$4e61bbf568682a96);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $314C6 = parcelRequire("314C6");
const $46a581f1f6efe569$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $46a581f1f6efe569$var$Store = (0, $iXqE5.createStore)({
    name: 'user',
    initialState: $46a581f1f6efe569$var$initialState,
    actions: $314C6
});
const $46a581f1f6efe569$export$7ff085589970ee0a = (0, $gg7kZ.createContainer)($46a581f1f6efe569$var$Store);
const $46a581f1f6efe569$export$4e61bbf568682a96 = (0, $3sQ5x.createHook)($46a581f1f6efe569$var$Store);

});
parcelRegister("314C6", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $acdfee9161693eca$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iF3m5 = parcelRequire("iF3m5");
const $acdfee9161693eca$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $iF3m5.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("iF3m5", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $d22d4c6d892f61f1$export$8134c072fddab6a5);

var $ebyGx = parcelRequire("ebyGx");

var $8QpSo = parcelRequire("8QpSo");

var $eusud = parcelRequire("eusud");

var $4R6GH = parcelRequire("4R6GH");

var $e5wyW = parcelRequire("e5wyW");

var $6Z846 = parcelRequire("6Z846");
const $d22d4c6d892f61f1$export$5e5a6664039ed1cc = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $ebyGx.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $eusud.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};
const $d22d4c6d892f61f1$var$fetchDataNew = (0, $8QpSo.default)($d22d4c6d892f61f1$export$5e5a6664039ed1cc, (newArgs, lastArgs)=>// compare params and headers to see if it should be memoised.
    (0, $6Z846.isShallowEqual)(newArgs[0].params, lastArgs[0].params) && (0, $6Z846.isShallowEqual)(newArgs[0].header, lastArgs[0].header));
const $d22d4c6d892f61f1$export$8134c072fddab6a5 = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('user-iv-llc-unnecessary-api'), $d22d4c6d892f61f1$var$fetchDataNew, $d22d4c6d892f61f1$export$5e5a6664039ed1cc);

});




parcelRegister("4DPZY", function(module, exports) {

$parcel$export(module.exports, "useContainerContext", () => $a65e0c39573f7437$export$c7066c2d215990cf);
$parcel$export(module.exports, "ContainerContextSubscriber", () => $a65e0c39573f7437$export$5b87a78c45d5dd17);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7xTO3 = parcelRequire("7xTO3");

var $ggg5j = parcelRequire("ggg5j");

var $2YP9W = parcelRequire("2YP9W");

var $6SkQo = parcelRequire("6SkQo");
const $a65e0c39573f7437$var$useProjectContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $ggg5j.staticProjectSidebarNavigationResource));
    const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getProjectContext)(data), [
        data
    ]);
    return [
        {
            data: projectContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));
    const userContext = (0, $5uXOq.useMemo)(()=>data && (0, $6SkQo.getUserContext)(data), [
        data
    ]);
    return [
        {
            data: userContext,
            error: error,
            loading: loading
        },
        {
            fetch: refresh,
            refetch: refresh
        }
    ];
};
const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
    const projectContext = $a65e0c39573f7437$var$useProjectContext();
    const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
    if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
    return projectContext;
};
const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
    const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
    // @ts-expect-error - TS2345 - Argument of type '{ readonly data: ContainerContext | null; readonly error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; readonly loading: boolean; }' is not assignable to parameter of type 'ContainerContextData'.
    return props.children(data, actions);
};
$a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';

});
parcelRegister("6SkQo", function(module, exports) {

$parcel$export(module.exports, "getUserContext", () => $84cf60e2c9c0e289$export$114c35c2c23732ab);
$parcel$export(module.exports, "getProjectContext", () => $84cf60e2c9c0e289$export$d17fffd59c7b3c60);

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $bsuuc = parcelRequire("bsuuc");
const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
    const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
    return {
        contextType: 'user',
        user: {
            id: owner.id,
            name: owner.name,
            avatarUrl: owner.avatarUrl,
            profileUrl: owner.profileUrl,
            accountId: owner.accountId
        },
        scope: {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        }
    };
};
const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
    if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
        const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
        return {
            id: boardInfo.id,
            type: boardInfo.type,
            name: boardInfo.name
        };
    }
    return undefined;
};
const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
    if (projectType === 'customer_service' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'business':
            return 0, $2vSU6.CORE_PROJECT;
        case 'software':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'service_desk':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'product_discovery':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
    const project = (0, $bsuuc.extractData)(projectNavInfo);
    const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
    if (project) {
        const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
        if (projectType) return {
            contextType: 'project',
            project: {
                key: project.key,
                // @ts-expect-error TS2322: Type 'number' is not assignable to type 'string'
                id: project.id,
                name: project.name,
                type: projectType,
                isSimplified: project.isSimplified,
                avatarUrl: project.avatarUrl,
                style: (0, $bsuuc.getStyle)(project.isSimplified)
            },
            scope: scope
        };
    }
    return null;
};

});


parcelRegister("cZpsT", function(module, exports) {

$parcel$export(module.exports, "useIsAnonymous", () => $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);

var $9OXo1 = parcelRequire("9OXo1");
const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isAnonymous;
};

});

parcelRegister("bdAP2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9902567d9e017eb1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9902567d9e017eb1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    board: {
        "id": "spa-apps-sidebar-common.scope-switcher.board",
        "defaultMessage": "Board"
    }
});

});


parcelRegister("3SzZi", function(module, exports) {

$parcel$export(module.exports, "shouldRenderNesting", () => $956cef61e43b05f1$export$a35baff1c4efd3da);
const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));

});

parcelRegister("7OqB4", function(module, exports) {

$parcel$export(module.exports, "withThrowOnError", () => $f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
/* eslint-disable jira/react-magnetic-di/no-unneeded */ 
var $gKZoD = parcelRequire("gKZoD");
const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
    return (...args)=>{
        // tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
        (0, $gKZoD.di)(theHook);
        const result = theHook(...args);
        // escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
        if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
        return result;
    };
}

});

parcelRegister("3tHFY", function(module, exports) {

$parcel$export(module.exports, "ConnectMenu", () => $1b0be5b9936240ae$export$19d0925d424b864a);

var $5uXOq = parcelRequire("5uXOq");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");
const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
    const filteredItems = (0, $au6nA.useFilteredItems)(items || null, shouldFilter);
    if (filteredItems == null || !filteredItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: item,
            key: item.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        })));
};

});
parcelRegister("au6nA", function(module, exports) {

$parcel$export(module.exports, "useFilteredItems", () => $cb371d7d8e582719$export$79762159776e61da);

var $5uXOq = parcelRequire("5uXOq");

var $kvHKs = parcelRequire("kvHKs");
const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
        if (!shouldFilter) return items || [];
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"services" | "collectors" | "attachments" | "eventtypes" | "webhooks-admin" | "greenhopper-lexorank-manage" | "admin-helper-admin-section" | "advanced_section" | "dark_features" | ... 74 more ... | "com.codebarrel.addons.automation__cb-automation" | "com.codebarrel.addons.automation.moderate__cb-automation"'.
        return items?.filter((item)=>!(0, $kvHKs.staticLegacyIds).includes(item.id)) || [];
    }, [
        items,
        shouldFilter
    ]);

});

parcelRegister("fh2pW", function(module, exports) {

$parcel$export(module.exports, "ConnectItem", () => $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $41Nl9 = parcelRequire("41Nl9");

var $kxnYb = parcelRequire("kxnYb");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $jjUR3 = parcelRequire("jjUR3");

var $hrlU6 = parcelRequire("hrlU6");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $3OGaE = parcelRequire("3OGaE");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");
const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
    const { addNew: addNew } = (0, $jjUR3.useConnectItemClickHistory)();
    const isDialog = item.styleClass && (0, $hrlU6.isConnectDialogWebItem)(item.styleClass);
    const webItemRef = (0, $5uXOq.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const BackMenuItem = {
        ...overrides.BackMenuItem,
        onClick: (ev)=>{
            // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
            // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
            // This is to satisfy a requirement for open expandable menus to remain open
            // when users return to the project settings menu
            if (submenuId != null) {
                const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                let parsedCookieData = null;
                try {
                    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                    parsedCookieData = JSON.parse(cookieData);
                } catch  {
                    // Rather than throw an error - just set the default state
                    parsedCookieData = {
                        submenuActive: false,
                        expanded: false
                    };
                }
                const newCookieData = {
                    ...parsedCookieData,
                    submenuActive: false
                };
                (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
            }
            // Setting navigateOnBackMenuItemClick to true will allow backToProject link to take user to the default project page
            if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
            overrides.BackMenuItem?.onClick?.(ev);
        }
    };
    const icon = (0, $5uXOq.useMemo)(()=>{
        if (showIcons !== true) return null;
        return item.iconUrl != null && item.iconUrl.trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
            src: item.iconUrl,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
            spacing: "spacious",
            label: ""
        });
    }, [
        showIcons,
        item.iconUrl
    ]);
    const onItemClick = (0, $5uXOq.useCallback)((event)=>{
        // We need to check we're clicking an item inside a nested menu for a connect item.
        // if we are deep linking to a nested connect item -> we need to maintain the hiding of nav-modules
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick && isNested) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        if (isDialog) (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
        });
        else item.url != null && addNew(item.url);
    }, [
        addNew,
        isDialog,
        isNested,
        item.styleClass,
        item.url,
        overrides
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        // Due to CMP project settings not being part to the SPA, we have to set / get the state of the
        // Expandable menu items from cookies - this is because the page does a complete refresh upon clicking a menuitem link.
        // This is to satisfy a requirement for open expandable menus to remain open
        // when users return to the project settings menu
        if (submenuId != null) {
            const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            if (cookieData != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                ...JSON.parse(cookieData),
                submenuActive: true
            }));
        }
        // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        if (overrides?.ParentMenuItem?.onClick) // @ts-expect-error TS2339 | TS2339 - Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'. | Property 'ParentMenuItem' does not exist on type 'Overrides & { CustomItem?: { render: (props: CustomItemProps<CustomItemComponentProps>) => ReactElement<any, string | JSXElementConstructor<any>>; } | undefined; } & { ...; }'.
        overrides.ParentMenuItem.onClick(event);
        return ()=>null;
    }, [
        overrides,
        submenuId
    ]);
    if (item.section === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: item.name,
        hasSeparator: Boolean(index)
    }, (item.items || []).map((si, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            index: idx,
            isNested: isNested
        })));
    if (item.items) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        id: item.id,
        analytics: {
            itemId: item.id
        },
        iconBefore: icon,
        overrides: {
            ...overrides,
            BackMenuItem: BackMenuItem
        },
        title: item.name,
        onClick: onNestedMenuItemClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.NavigationContentWrapper), {
        submenuActive: true,
        nestedMenuOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3OGaE.TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
            key: si.id,
            item: si,
            index: nestIndex,
            overrides: {
                ...overrides,
                BackMenuItem: {
                    href: item.url,
                    title: si.name,
                    onClick: (ev)=>ev.preventDefault()
                }
            },
            isNested: true
        })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: item.id
        },
        selectedOn: (0, $4OCke.matchUrlExact)(),
        iconBefore: icon,
        href: isDialog ? undefined : item.url,
        onClick: onItemClick,
        ref: webItemRef
    }, item.name);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f2bd062d7c8c5e44$var$ConnectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iUo88", function(module, exports) {

$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $89b5b8a4b358ad27$export$93509ff9a62ee022);

var $eb1mj = parcelRequire("eb1mj");
const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
    (0, $eb1mj.setStrictlyNecessaryCookie)(key, value, attributes);
};

});

parcelRegister("jjUR3", function(module, exports) {

$parcel$export(module.exports, "useConnectItemClickHistory", () => $c499ec49965fe6fe$export$c251e3fda1cce4a3);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
// A single instance for the entire SPA session
const $c499ec49965fe6fe$var$history = {
    unique: []
};
const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
    (0, $gKZoD.di)(window);
    const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
        // Here we want to store only unique items. For example, if the add-on updates Jira hash
        // and user clicks the same navigation link we consider it as a unique navigation action
        // so we can use this info later on to rerender the iframe
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.location.href.endsWith(historyItem) === false) // @ts-expect-error - TS2339 - Property 'push' does not exist on type 'readonly []'.
        $c499ec49965fe6fe$var$history.unique.push(historyItem);
    }, []);
    return (0, $5uXOq.useMemo)(()=>({
            history: $c499ec49965fe6fe$var$history,
            addNew: addNew
        }), [
        addNew
    ]);
};
const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
    // @ts-expect-error TS2540: Cannot assign to 'length' because it is a read-only property.
    $c499ec49965fe6fe$var$history.unique.length = 0;
};

});

parcelRegister("hrlU6", function(module, exports) {

$parcel$export(module.exports, "withConnectHost", () => $9316db67541b8a94$export$970e2411dd8601c8);
$parcel$export(module.exports, "getConnectHost", () => $9316db67541b8a94$export$186d423c00af146c);
$parcel$export(module.exports, "isConnectDialogWebItem", () => $9316db67541b8a94$export$920fb4b46d4f2eec);

var $dJZWD = parcelRequire("dJZWD");
const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
    const connectHost = await (0, $dJZWD.setupConnectJs)();
    action(connectHost);
};
const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');

});
parcelRegister("dJZWD", function(module, exports) {

$parcel$export(module.exports, "setupConnectJs", () => $762ba9fa524ea8e6$export$891414b605e5f038);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
var $cQZXC = parcelRequire("cQZXC");

var $dH9DT = parcelRequire("dH9DT");

const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
    // we need the heritage to load in order for WRM core and jQuery to exist.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $cQZXC.waitForHeritage)();
    await (0, $dH9DT.waitForJQuery)();
    const loader = await (parcelRequire("3hUjN"));
    await loader.performSideEffects();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};
let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
    // Only pages in the SPA will benefit from modernising connect
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__SPA__) {
        if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
        return $762ba9fa524ea8e6$var$installConnectJsPromise;
    }
    // eslint-disable-next-line jira/wrm/no-load-bridge
    await (0, $6BZYo.loadBridge)({
        name: 'ac/create',
        wrmKeys: [
            'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
            // Undeclared Dependency: jira/navigation
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
        ]
    });
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    return window.connectHost;
};

});
parcelRegister("6BZYo", function(module, exports) {

$parcel$export(module.exports, "loadBridge", () => $ce95ee3fd66207c7$export$df8409da353bde5a);

var $fqWWz = parcelRequire("fqWWz");
var $3GASE = parcelRequire("3GASE");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");

var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");
var $5Ik5Y = parcelRequire("5Ik5Y");
const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $fqWWz.MAX_RETRIES), timeout: timeout = (0, $fqWWz.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR) })=>{
    if (wrmKeys != null) return (0, $7T84i.loadBridgeStrict)({
        name: name,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        wrmKeys: [].concat(wrmKeys),
        shouldLogError: shouldLogError
    });
    if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
    if (tentatives <= 1) return (0, $3GASE.loadBridgeBail)({
        name: name,
        shouldLogError: shouldLogError
    });
    return (0, $ig88W.loadBridgeRace)({
        name: name,
        shouldLogError: shouldLogError,
        timeout: (tentatives - 1) * timeout
    });
};

});
parcelRegister("8JNtu", function(module, exports) {

$parcel$export(module.exports, "wrmRequire", () => $17e2d7d864398bad$export$cc9d8f51375ef66a);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError
    });

});

parcelRegister("5Ik5Y", function(module, exports) {

$parcel$export(module.exports, "wrmRequireWithPrefetch", () => $a1df1daee76d40f7$export$e53a5db19a39ed2f);

var $fVOHM = parcelRequire("fVOHM");

var $fqWWz = parcelRequire("fqWWz");
const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $fqWWz.SHOULD_LOG_ERROR))=>(0, $fVOHM.loadWrmResources)({
        wrmKeys: wrmKeys,
        shouldLogError: shouldLogError,
        batchUrl: batchUrl
    });

});


parcelRegister("dH9DT", function(module, exports) {

$parcel$export(module.exports, "getMeta", () => $a78c52ec7ed5d025$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getJQuery", () => $a78c52ec7ed5d025$export$7232a6dc780f9887);
$parcel$export(module.exports, "getGlobalAP", () => $a78c52ec7ed5d025$export$fbc82125a6bd8012);
$parcel$export(module.exports, "isObject", () => $a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "escapeSelector", () => $a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
$parcel$export(module.exports, "waitForJQuery", () => $a78c52ec7ed5d025$export$97214de9c546981c);
$parcel$export(module.exports, "ErrorDebugAddonKeys", () => $a78c52ec7ed5d025$export$d690da9bc8146677);

var $jcw0u = parcelRequire("jcw0u");

const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
    return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
};
const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>// In the future, we can add analytics events to know how this can fail to access the global variable.
    // We can improve it to load WRM in async
    // Just to add some context for future reviewers: `window._AP` is the actual Connect module that will no longer be loaded via WRM.
    // Its properties are both appended from modules like the dialog options and the public atlassian-connect-js library.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window._AP;
const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
    if (!s) throw new Error('No selector to escape');
    return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
};
const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
        const interval = setInterval(()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.AJS?.$) {
                clearInterval(interval);
                resolve();
            }
        }, 10);
        setTimeout(()=>{
            clearInterval(interval);
            (0, $jcw0u.default)({
                meta: {
                    id: 'connect-jquery-timeout',
                    packageName: 'jiraConnect'
                },
                error: new Error('Timeout when waiting for jQuery to be available on the page'),
                // this is an extremely common error, so we don't want to spam Sentry with it
                skipSentry: true
            });
            reject();
        }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
    });
const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
    $a78c52ec7ed5d025$export$cb954c21735b28e4,
    $a78c52ec7ed5d025$export$7315c38dc71bd41f
];

});

parcelRegister("3hUjN", function(module, exports) {

let $264ea540dc548cff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $264ea540dc548cff$var$load("aVR4N").then(()=>parcelRequire('8vJyT'));

});



parcelRegister("3OGaE", function(module, exports) {

$parcel$export(module.exports, "TitleHeader", () => $09f1bcc415909488$export$de3705f3d2162955);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fJoTF = parcelRequire("fJoTF");
const $09f1bcc415909488$var$overrideStyles = null;
const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJoTF.CustomHeader), {
        testId: "navigation-apps-sidebar-common.common.ui.title-header",
        className: (0, $bwpsq.default)([
            "_dqi54jg8 _1lfu4jg8"
        ])
    }, children);
};

});



parcelRegister("hWtQt", function(module, exports) {

$parcel$export(module.exports, "useProjectReportsConnectItems", () => $a740427f233367ba$export$a1c75c386c088992);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $a740427f233367ba$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectReportsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, $5W6pd.transformLinkV4)).filter(Boolean) : [], [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
            'reports'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        error: error,
        loading: loading,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});
parcelRegister("7tsV0", function(module, exports) {

$parcel$export(module.exports, "findItemAndStack", () => $93fa8c16baad19b1$export$751e2e6237002565);

var $ajpes = parcelRequire("ajpes");

var $k0iPT = parcelRequire("k0iPT");
// JSPA-1062 remove qs items that might not always be there
const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
// match query strings, but allow case where query param "s" is present in the menu item, but not the window url
const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
    let found = null;
    if (!(0, $k0iPT.CONNECT_ROUTES_SET).has(routeName)) return found;
    const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
    items.some((item)=>{
        const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
        const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
        const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
        if (item.section !== true && itemPath === location.pathname && sameQuery) {
            found = {
                stack: parentStack,
                selected: item
            };
            return true;
        }
        if (item.items) {
            const stack = item.section === true ? parentStack : parentStack.concat(item.id);
            found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
        }
        return Boolean(found);
    });
    return found;
};

});

parcelRegister("5W6pd", function(module, exports) {

$parcel$export(module.exports, "transformLink", () => $1efacbf40a7b73c8$export$5a32dc366b1d641f);
$parcel$export(module.exports, "transformLinkV4", () => $1efacbf40a7b73c8$export$27267b6b6650eaa5);
const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
    const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
    // section item
    if (link.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(link.name)
        };
        return {
            id: link.id,
            name: String(link.name),
            section: !!link.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: link.id,
        name: String(link.name),
        url: link.url,
        iconUrl: link.iconUrl || '',
        styleClass: link.styleClass || '',
        items: items
    };
};
const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
    const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
    // section item
    if (data.section === true) {
        // sometimes sections might be empty, is so remove them
        if (!items || !items.length) return null;
        // avoid nested groups with multiple headings
        if (items.length === 1 && items[0]?.section === true) return {
            ...items[0],
            name: items[0].name || String(data.name)
        };
        return {
            id: data.id,
            name: String(data.name),
            section: !!data.section,
            items: items
        };
    }
    // normal item (plain or with nest)
    return {
        id: data.id,
        name: String(data.name),
        url: data.url,
        iconUrl: data.iconUrl || '',
        styleClass: data.styleClass || '',
        items: items
    };
};

});


parcelRegister("jfqNX", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsConnectItems", () => $662340ab1e9d2787$export$41a50100db18b578);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
// use memoised functions per hook to avoid re-computation between same hooks
const $662340ab1e9d2787$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSettingsSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
            'settings'
        ]), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("gZbSF", function(module, exports) {

$parcel$export(module.exports, "useProjectConnectItems", () => $fcf7bc53994ae8f3$export$f23d0c24c77d7608);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $1J3t1 = parcelRequire("1J3t1");

var $doZTA = parcelRequire("doZTA");

var $7tsV0 = parcelRequire("7tsV0");

var $5W6pd = parcelRequire("5W6pd");
const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, $8QpSo.default)((0, $7tsV0.findItemAndStack));
const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
    const [{ route: route, location: location }] = (0, $doZTA.useRouter)();
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useProjectSidebarConnectNavigation)();
    const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, $5W6pd.transformLinkV4)).filter(Boolean), [
        data
    ]);
    const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
        items,
        route,
        location
    ]);
    return {
        data: items,
        loading: loading,
        error: error,
        selected: found && found.selected,
        stack: found && found.stack
    };
};

});

parcelRegister("6hMYg", function(module, exports) {

$parcel$export(module.exports, "useProjectSettingsForgeApps", () => $2106846b1818d2e6$export$bef2e514007d2f07);
$parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", () => $2106846b1818d2e6$export$b741e3e3cfb39b82);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");

var $2YP9W = parcelRequire("2YP9W");

var $kKdpt = parcelRequire("kKdpt");

var $7Tlti = parcelRequire("7Tlti");
const $2106846b1818d2e6$export$bef2e514007d2f07 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = (0, $2YP9W.useResource)((0, $5bkvv.forgeProjectSettingsModuleResource));
    const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
        isAdmin,
        isSiteAdmin,
        projectContext?.isProjectAdmin
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error
        }), [
        projectSettingsData,
        accessNarrowedData,
        loading,
        error,
        hasPermissions
    ]);
};
const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
    tmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        // it's genuinely missing Jira Product Discovery and CUSTOMER_SERVICE_PROJECT support
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    },
    cmp: {
        [(0, $2vSU6.CORE_PROJECT)]: 'core',
        [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software/c',
        [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk',
        [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: undefined,
        [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: undefined
    }
};
const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};
const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
    const stack = (0, $kKdpt.useForgeItemStack)(data, routeName, parentStack);
    const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
    return (0, $5uXOq.useMemo)(()=>({
            data: data ? data.map((extension)=>({
                    id: extension.id,
                    // @ts-expect-error - TS2345 - Argument of type 'ProjectType | undefined' is not assignable to parameter of type 'ProjectType'.
                    url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                    name: extension.properties.title,
                    iconUrl: extension.properties.icon,
                    environmentType: extension.environmentType,
                    environmentKey: extension.environmentKey,
                    moduleName: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
                    sections: (0, $7Tlti.toSections)(extension)
                })) : null,
            loading: loading,
            error: error,
            stack: stack
        }), [
        data,
        loading,
        error,
        stack,
        projectType,
        projectKey,
        isSimplified
    ]);
};

});
parcelRegister("5cmSg", function(module, exports) {

$parcel$export(module.exports, "isExtensionVisible", () => $30771269db74e480$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $30771269db74e480$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $30771269db74e480$export$5c38dfa9d1f96e61);
const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("cNd4s", function(module, exports) {

$parcel$export(module.exports, "useIsSiteAdmin", () => $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);

var $9OXo1 = parcelRequire("9OXo1");
const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.isSiteAdmin || false;
};

});

parcelRegister("kKdpt", function(module, exports) {

$parcel$export(module.exports, "useForgeItemStack", () => $dac9c7c54c5ccbb1$export$462f82a278743d46);

var $5uXOq = parcelRequire("5uXOq");

var $c70gQ = parcelRequire("c70gQ");

var $doZTA = parcelRequire("doZTA");

var $7Tlti = parcelRequire("7Tlti");
const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $doZTA.useRouter)();
    const matchedExtension = (0, $c70gQ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $7Tlti.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("c70gQ", function(module, exports) {

$parcel$export(module.exports, "useMatchedExtension", () => $b661f1f04cec9385$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $b661f1f04cec9385$export$25abed85383f0fbb);

var $5uXOq = parcelRequire("5uXOq");

var $e0AC8 = parcelRequire("e0AC8");
const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $e0AC8.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');

});

parcelRegister("7Tlti", function(module, exports) {

$parcel$export(module.exports, "toSections", () => $25b31557e9750c03$export$29678d1e04c0e8c4);

var $8QpSo = parcelRequire("8QpSo");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $25b31557e9750c03$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, $8QpSo.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($25b31557e9750c03$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($25b31557e9750c03$var$normalizeSection);
    return [];
});

});



parcelRegister("231OU", function(module, exports) {

$parcel$export(module.exports, "useProjectForgeApps", () => $1a247d2d1d6e7cdf$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $1a247d2d1d6e7cdf$export$80e84933a3e2f677);

var $5uXOq = parcelRequire("5uXOq");

var $5cmSg = parcelRequire("5cmSg");

var $5bkvv = parcelRequire("5bkvv");

var $324W5 = parcelRequire("324W5");

var $kKdpt = parcelRequire("kKdpt");
const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $324W5.useResourceWithCustomRouterContext)((0, $5bkvv.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, $5cmSg.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $kKdpt.useForgeItemStack)(projectData, routeName);
    return (0, $5uXOq.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);

});

parcelRegister("8zgGo", function(module, exports) {

$parcel$export(module.exports, "getItemHref", () => $4cec53abbd9c3c33$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeProjectSection", () => $4cec53abbd9c3c33$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");

var $2vSU6 = parcelRequire("2vSU6");

var $1rTGO = parcelRequire("1rTGO");

var $bXK4r = parcelRequire("bXK4r");

var $k2DRb = parcelRequire("k2DRb");

var $e0AC8 = parcelRequire("e0AC8");

var $koVbs = parcelRequire("koVbs");

var $dAfqg = parcelRequire("dAfqg");

var $k51JQ = parcelRequire("k51JQ");

var $7Tlti = parcelRequire("7Tlti");

var $231OU = parcelRequire("231OU");

var $kBPYs = parcelRequire("kBPYs");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
    [(0, $2vSU6.CORE_PROJECT)]: 'core',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'software',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $231OU.useProjectForgeApps)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bXK4r.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $kBPYs.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $7Tlti.toSections)(extension),
            moduleName: (0, $k2DRb.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $k2DRb.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("1rTGO", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $abbdb580491d9d09$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $abbdb580491d9d09$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $abbdb580491d9d09$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $abbdb580491d9d09$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $abbdb580491d9d09$export$14e56d7f5d3f917c);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $k2DRb = parcelRequire("k2DRb");

var $3mOWa = parcelRequire("3mOWa");

var $eOGyv = parcelRequire("eOGyv");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $4R6GH = parcelRequire("4R6GH");

var $hBuqR = parcelRequire("hBuqR");

var $6MtPV = parcelRequire("6MtPV");

var $dd7Uh = parcelRequire("dd7Uh");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");
const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: (0, $6MtPV.createAttributes)(attributes)
    });
const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $dd7Uh.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $eOGyv.useHasForgeAccess)();
    const analyticsAttributes = (0, $4R6GH.fg)('custom_fields_attempt_event_optimization') ? (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        }), [
        attributes,
        hasForgeAccess
    ]) : (0, $6MtPV.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, (0, $9BrHy.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: fireEvent
    });
};
const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: `${(0, $hBuqR.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, $6MtPV.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hBuqR.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, $6MtPV.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $k2DRb.CUSTOM_FIELD_MODULE) || extensionModule === (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $k2DRb.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $k2DRb.GLOBAL_PAGE_MODULE),
        (0, $k2DRb.ISSUE_ACTION_MODULE),
        (0, $k2DRb.ISSUE_ACTIVITY_MODULE),
        (0, $k2DRb.ISSUE_CONTEXT_MODULE),
        (0, $k2DRb.ISSUE_GLANCE_MODULE),
        (0, $k2DRb.ISSUE_NAVIGATOR_ACTION_MODULE),
        (0, $k2DRb.ISSUE_PANEL_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_MODULE),
        (0, $k2DRb.CUSTOM_FIELD_TYPE_MODULE),
        (0, $k2DRb.PROJECT_PAGE_MODULE),
        (0, $k2DRb.ADMIN_PAGE_MODULE),
        (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        (0, $k2DRb.BACKLOG_ACTION_MODULE),
        (0, $k2DRb.BOARD_ACTION_MODULE),
        (0, $k2DRb.SPRINT_ACTION_MODULE),
        (0, $k2DRb.PERSONAL_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $5uXOq.useRef)(performance.now());
        const isCustomUI = (0, $3mOWa.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
            module: module,
            entryPoint: entryPoint
        }) : (0, $9BrHy.getEventIdOld)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        }) : (0, $9BrHy.getBrowserMetricsEventIdOld)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $3mOWa.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $5uXOq.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        const onError = (0, $5uXOq.useCallback)(()=>{
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $dd7Uh.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            extensionId && (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("3mOWa", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $e79bbc527e600bd1$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $e79bbc527e600bd1$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $e79bbc527e600bd1$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $e79bbc527e600bd1$export$42b85bc9b386c977);

var $gccSB = parcelRequire("gccSB");
const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
    const { resource: resource } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        }
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("eOGyv", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);

var $cZpsT = parcelRequire("cZpsT");
const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("isuse", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $1df0619a43ad69d9$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $3TR0I = parcelRequire("3TR0I");
// eslint-disable-next-line jira/react/no-class-components
class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, $3TR0I.default)()($1df0619a43ad69d9$var$MountEventComponent);

});

parcelRegister("dd7Uh", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $7d829a81d29f9e72$export$add44f896fb31ba3);

var $hBuqR = parcelRequire("hBuqR");

var $8uOa6 = parcelRequire("8uOa6");
const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $8uOa6.fireOperationalEvent)((0, $hBuqR.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("2RhPB", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $3fba0b567cec1fe0$export$5d3b06ab08af139e);

var $3mOWa = parcelRequire("3mOWa");

var $e0AC8 = parcelRequire("e0AC8");
const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $e0AC8.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $3mOWa.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});

parcelRegister("9BrHy", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $10bc2a9e37d5a5bb$export$5639f6a927500d9);
$parcel$export(module.exports, "getEventIdOld", () => $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getBrowserMetricsEventIdOld", () => $10bc2a9e37d5a5bb$export$66db5d4145894f38);
$parcel$export(module.exports, "getEventActionName", () => $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);

var $k2DRb = parcelRequire("k2DRb");

var $6yg2S = parcelRequire("6yg2S");

var $hBuqR = parcelRequire("hBuqR");
const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, $k2DRb.SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${eventNamePostfix}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$b2919e256f1e5dfc = ({ module: module, moduleType: moduleType = (0, $hBuqR.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    // we use view entry point for custom field and custom field type but we don't want to update all the event names
    if (entryPoint === 'view' && (module === 'jira:customField' || module === 'jira:customFieldType')) return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}-${forgeUiType}`);
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$66db5d4145894f38 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>{
    return (0, $6yg2S.toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
};
const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hBuqR.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});


parcelRegister("bXK4r", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $488beba58e0bb189$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $488beba58e0bb189$export$e1a79e3d472c925a);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");
const $488beba58e0bb189$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: (0, $k2DRb.PROJECT_PAGE_MODULE),
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("k51JQ", function(module, exports) {

$parcel$export(module.exports, "ForgeSubpagesView", () => $b3f0da209e047dcf$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $b3f0da209e047dcf$export$26a5287439a1d287);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $41Nl9 = parcelRequire("41Nl9");

var $kxnYb = parcelRequire("kxnYb");

var $8kVg1 = parcelRequire("8kVg1");

var $fl3Yy = parcelRequire("fl3Yy");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $jv9Yy = parcelRequire("jv9Yy");

var $8iQMc = parcelRequire("8iQMc");

var $kZj7F = parcelRequire("kZj7F");

var $4OCke = parcelRequire("4OCke");

var $4R6GH = parcelRequire("4R6GH");
const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeIcon, {
        alt: "",
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($41Nl9))), {
        spacing: "spacious",
        label: ""
    });
const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    const onClick = ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
            startTime: performance.now()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $4OCke.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        },
        onClick: (0, $4R6GH.fg)('arken-1562_full_page_performance_metric_addition') ? undefined : onClick
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $8iQMc.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        nestedMenuActive: nestedMenuActive
    });
const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $5uXOq.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $4OCke.matchPartialUrlPathname)(), []);
    const onClick = ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(itemId).start({
            startTime: performance.now()
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$var$ForgeSubpagesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jv9Yy.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                },
                onClick: (0, $4R6GH.fg)('arken-1562_full_page_performance_metric_addition') ? undefined : onClick
            }, page.title)))));
};
const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kZj7F.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fl3Yy.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $b3f0da209e047dcf$var$ForgeSubpagesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_14tkpxbi _t3zcv47k _1so41gjq",
            __cmplp.className
        ])
    });
});
const $b3f0da209e047dcf$var$ForgeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fl3Yy", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $730173a4987fa3e4$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $730173a4987fa3e4$export$f9338c21ba7c7334);

var $5uXOq = parcelRequire("5uXOq");

var $eOat1 = parcelRequire("eOat1");

var $k2DRb = parcelRequire("k2DRb");

var $ousew = parcelRequire("ousew");

var $8Je4V = parcelRequire("8Je4V");
const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $k2DRb.DEVELOPMENT_ENVIRONMENT:
            return (0, $8Je4V.messages).developmentEnvironmentLozenge;
        case 0, $k2DRb.STAGING_ENVIRONMENT:
            return (0, $8Je4V.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), labelKey)) : null;
};
const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $k2DRb.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $k2DRb.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("8Je4V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $838ac71f7259b5ef$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $838ac71f7259b5ef$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("jv9Yy", function(module, exports) {

$parcel$export(module.exports, "SectionHeader", () => $c634a42deba697de$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1u5XK = parcelRequire("1u5XK");

var $fpoBX = parcelRequire("fpoBX");
const $c634a42deba697de$var$textColorCssVar = '--section-header-text-color';
const $c634a42deba697de$var$opacityCssVar = '--section-header-opacity';
const $c634a42deba697de$var$colorThemeStyles = null;
const $c634a42deba697de$var$opacityThemeStyles = null;
const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $5uXOq.createElement((0, $1u5XK.default), {
        // @ts-expect-error - className is a valid prop
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            [$c634a42deba697de$var$opacityCssVar]: item?.opacity,
            [$c634a42deba697de$var$textColorCssVar]: item?.color?.default
        },
        className: (0, $bwpsq.default)([
            item?.opacity && "_3bezblmq",
            item?.color?.default && "_1w90oa1y"
        ])
    }, children);
};

});

parcelRegister("8iQMc", function(module, exports) {

$parcel$export(module.exports, "ForgePageHeader", () => $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ew55A = parcelRequire("ew55A");

var $gOmoF = parcelRequire("gOmoF");

var $fl3Yy = parcelRequire("fl3Yy");

var $fJoTF = parcelRequire("fJoTF");
const $5bbfd34eb4e2a6d6$var$containerNestedStyles = null;
const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $ew55A.default), AddonIcon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($gOmoF))), Header: Header = (0, $fJoTF.CustomHeader), EnvironmentLozenge: EnvironmentLozenge = (0, $fl3Yy.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, nestedMenuActive: nestedMenuActive })=>{
    return /*#__PURE__*/ $5uXOq.createElement(Header, {
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ $5uXOq.createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ $5uXOq.createElement(AddonIcon, {
            label: "",
            size: "medium"
        }),
        iconAfter: /*#__PURE__*/ $5uXOq.createElement(EnvironmentLozenge, {
            environmentType: environmentType
        }),
        className: (0, $bwpsq.default)([
            nestedMenuActive && "_1yxx183y"
        ])
    }, (0, $fl3Yy.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});


parcelRegister("kBPYs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3e1e8355c24b18f2$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("aNdqN", function(module, exports) {

$parcel$export(module.exports, "useIsEditableToInline", () => $7e1f72364c69ca8f$export$5681ac4252a29721);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");


var $9yQlD = parcelRequire("9yQlD");

var $jX0pr = parcelRequire("jX0pr");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");
const $7e1f72364c69ca8f$var$JSW_PROJECT_RENAMED_TRAIT = 'jira-software_track_project_updated_onboardingprojectdetailsscreen_first';
const $7e1f72364c69ca8f$export$ccad6a8326c45d7b = async (cloudId)=>{
    const sessionStorageValue = (0, $9yQlD.sessionStorage).get('project_updated_in_welcome_modal');
    if (sessionStorageValue === 'true' || sessionStorageValue === 'false') return sessionStorageValue === 'true';
    const response = await (0, $jX0pr.memoizedFetchSitePersonalization)({
        cloudId: cloudId
    });
    const targetTraitValue = response.find((traits)=>traits.name === $7e1f72364c69ca8f$var$JSW_PROJECT_RENAMED_TRAIT)?.value;
    if (targetTraitValue) {
        (0, $9yQlD.sessionStorage).set('project_updated_in_welcome_modal', true);
        return true;
    }
    return false;
};
const $7e1f72364c69ca8f$export$5681ac4252a29721 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { software: softwareEdition } = (0, $k9JTq.useAppEditions)();
    const projectUpdatedLocalValue = (0, $9yQlD.sessionStorage).get('project_updated_in_welcome_modal');
    const shouldShowWelcomeModal = (0, $9yQlD.sessionStorage).get((0, $6784cbc7d62e5d7c$export$e3884212029f7bef));
    const isBasicTargetted = !shouldShowWelcomeModal && // Side bar loaded earlier than welcome modal, and we don't want to fire our exposure before welcome modal
    data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT) && softwareEdition === (0, $ldyPw.FREE_EDITION) && data?.isProjectAdmin && !(typeof projectUpdatedLocalValue === 'boolean' && projectUpdatedLocalValue);
    const cloudId = (0, $koeKL.useCloudId)();
    const { loading: loading, error: error, data: isProjectUpdated, fetch: fetch } = (0, $ld2hZ.useService)(()=>$7e1f72364c69ca8f$export$ccad6a8326c45d7b(cloudId));
    (0, $5uXOq.useEffect)(()=>{
        if (!isBasicTargetted) return;
        if (loading || error || isProjectUpdated !== undefined) return;
        fetch();
    }, [
        isProjectUpdated,
        fetch,
        isBasicTargetted,
        loading,
        error
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'getIsProjectUpdatedFromWelcomeModal',
                packageName: 'jiraNavigationAppsSidebarInlineConfigProjectHeader'
            }
        });
    }, [
        error
    ]);
    return ()=>isBasicTargetted && isProjectUpdated === false;
};

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("9yQlD", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $816fbeb16311dd64$export$f119d83aa936d634);
$parcel$export(module.exports, "sessionStorageProvider", () => $816fbeb16311dd64$export$5a24cb3021127ff7);
$parcel$export(module.exports, "localStorageProvider", () => $816fbeb16311dd64$export$aa821bfb3308a1f5);

var $bSSG7 = parcelRequire("bSSG7");

var $eNf8a = parcelRequire("eNf8a");




const $816fbeb16311dd64$export$f119d83aa936d634 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$5a24cb3021127ff7 = (0, $eNf8a.createSessionExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');
const $816fbeb16311dd64$export$aa821bfb3308a1f5 = (0, $bSSG7.createLocalExpirableStorageProvider)('onboarding-core');

});

parcelRegister("k9JTq", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $dde261c9da85268a$export$92ed15881fc090d7);

var $9OXo1 = parcelRequire("9OXo1");
const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});


parcelRegister("fZIti", function(module, exports) {

$parcel$export(module.exports, "InlineConfigurableProjectHeaderAsync", () => $31a32a873d5276c4$export$ba76684e7fbc4c13);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $l468O = parcelRequire("l468O");

var $30rnQ = parcelRequire("30rnQ");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $b7Svb = parcelRequire("b7Svb");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $31a32a873d5276c4$var$LazyInlineConfigurableProjectHeader = (0, $b7Svb.lazy)(()=>(parcelRequire("buUMN")).then((exportedModule)=>exportedModule.InlineConfigurableProjectHeader), {
    ssr: false,
    moduleId: "./src/packages/navigation-apps/sidebar/inline-config-project-header/src/ui/index.tsx"
});
const $31a32a873d5276c4$export$ba76684e7fbc4c13 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "inlineNameEditor",
        packageName: (0, $0175358ae1e6c114$export$b8b9d90f9e5bd72b),
        teamName: "jlove-makkuro",
        fallback: "unmount",
        attributes: (0, $30rnQ.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "side-nav-inline-config-project",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l468O.ProjectHeader), props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            subNamespaces: 'inlineConfigProjectHeader'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31a32a873d5276c4$var$LazyInlineConfigurableProjectHeader, props))));

});
parcelRegister("30rnQ", function(module, exports) {

$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", () => $53c68ff9a9edd0fe$export$807be5f3f1ea996);

var $5uXOq = parcelRequire("5uXOq");

var $3vs13 = parcelRequire("3vs13");
const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $3vs13.isLoaderError)(error)
    });
const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
            ...attributes,
            ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
        }), [
        attributes
    ]);

});

const $0175358ae1e6c114$export$b8b9d90f9e5bd72b = 'inlineConfigProjectHeader';
const $0175358ae1e6c114$export$7525482b5931e326 = 'input';
const $0175358ae1e6c114$export$9957974f8b4d8f74 = 'configurableProjectHeader';

parcelRegister("buUMN", function(module, exports) {

let $85ee8b8f30f52641$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $85ee8b8f30f52641$var$load("cM9em"),
    $85ee8b8f30f52641$var$load("fr9NE"),
    $85ee8b8f30f52641$var$load("gyaYr")
]).then(()=>parcelRequire('4XV6O'));

});


parcelRegister("73Ebi", function(module, exports) {

$parcel$export(module.exports, "OnCallIcon", () => $032fc68f517a5681$export$619e6e63f7c4e530);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $ltBcH = parcelRequire("ltBcH");
const $032fc68f517a5681$var$onCallIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        viewBox: "0 0 24 24",
        focusable: "false",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.092 2c1.317 0 2.353 1.111 2.244 2.408L11.1 7.227a2.186 2.186 0 01-2.188 1.99h-.026c-.114.862-.171 1.73-.171 2.59v.172c0 .921.066 1.861.197 2.805 1.142 0 2.093.866 2.188 1.99l.237 2.818C11.446 20.89 10.41 22 9.092 22h-1.63c-1.375 0-2.624-.908-3.109-2.259A22.81 22.81 0 013 11.98v-.171c0-2.61.453-5.161 1.349-7.581C4.849 2.874 6.064 2 7.446 2h1.646zm.001 2.222H7.446c-.425 0-.811.301-.983.767a19.568 19.568 0 00-1.213 6.819v.17c0 2.398.405 4.744 1.206 6.973.188.521.576.827 1.007.827h1.63l-.233-2.771H7.007l-.165-.915a23.082 23.082 0 01-.378-4.113v-.171c0-1.297.117-2.608.35-3.897l.164-.917H8.86l.233-2.772zm9.453 6.111c.931 0 1.687.747 1.687 1.667 0 .921-.756 1.667-1.687 1.667A1.677 1.677 0 0116.858 12c0-.92.756-1.667 1.688-1.667zm-4.5 0c.931 0 1.687.747 1.687 1.667 0 .921-.756 1.667-1.687 1.667A1.677 1.677 0 0112.358 12c0-.92.756-1.667 1.688-1.667z",
        fill: "currentColor",
        fillRule: "nonzero"
    }));
const $032fc68f517a5681$export$619e6e63f7c4e530 = ({ size: size = 'medium', primaryColor: primaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ltBcH.default), {
        glyph: $032fc68f517a5681$var$onCallIcon,
        size: size,
        label: "",
        primaryColor: primaryColor
    });

});

parcelRegister("aImhn", function(module, exports) {

$parcel$export(module.exports, "JswSideNavRecommendation", () => $4dca3eecced50738$export$6bbd8731fa84c19f);
$parcel$export(module.exports, "JpdSideNavRecommendation", () => $4dca3eecced50738$export$877c99dfed6b8c0b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $aD6MC = parcelRequire("aD6MC");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4yEIl = parcelRequire("4yEIl");

var $j2nvL = parcelRequire("j2nvL");

var $jp5kW = parcelRequire("jp5kW");

var $5pSYQ = parcelRequire("5pSYQ");

var $ZILlH = parcelRequire("ZILlH");
const $4dca3eecced50738$var$PLACEMENT_ID = 'jira-side-nav';
const $4dca3eecced50738$var$SideNavPlacement = ({ onHasMessageChanged: onHasMessageChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ZILlH.default), {
        placementId: $4dca3eecced50738$var$PLACEMENT_ID,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $aD6MC.default),
        placementProps: {
            onHasMessageChanged: onHasMessageChanged
        }
    });
const $4dca3eecced50738$var$SideNavRecommendation = ({ onHasMessageChanged: onHasMessageChanged })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sideNavRecommendation",
        packageName: "side-nav-recommendation",
        teamName: "post-office",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4yEIl.PostOfficeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "side-nav-recommendation.jira-side-nav",
        className: (0, $bwpsq.default)([
            "_otyru2gc"
        ])
    }, (0, $4R6GH.fg)('post_office_ssr_jira_side_nav_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2nvL.PlacementFetchProvider), {
        resource: (0, $5pSYQ.postOfficeJiraSideNavResource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavPlacement, {
        onHasMessageChanged: onHasMessageChanged
    }))));
};
const $4dca3eecced50738$export$6bbd8731fa84c19f = /*#__PURE__*/ (0, $5uXOq.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    !(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('post-office_enable_jira_sidenav_rec_msr_experiment') && (0, $6s1PB.expVal)('post_office_jira_side_nav_exp_msr_vs_no_rec', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});
const $4dca3eecced50738$export$877c99dfed6b8c0b = /*#__PURE__*/ (0, $5uXOq.memo)(({ onHasMessageChanged: onHasMessageChanged })=>{
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    !(0, $jp5kW.default)('killswitch_post_office_in_jira') && (0, $4R6GH.fg)('post-office_enable_jpd_side_nav_experiment') && (0, $6s1PB.expVal)('post_office_jpd_side_nav_experiment', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4dca3eecced50738$var$SideNavRecommendation, {
        onHasMessageChanged: onHasMessageChanged
    });
    return null;
});
const $4dca3eecced50738$var$sideNavPlacementWrapper = null;

});
parcelRegister("aD6MC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b41f1e5b72e90ab4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $e2ICd = parcelRequire("e2ICd");
var $kZgxR = parcelRequire("kZgxR");

var $5uXOq = parcelRequire("5uXOq");

var $hrr29 = parcelRequire("hrr29");


var $lDHLX = parcelRequire("lDHLX");
const $b41f1e5b72e90ab4$var$excludedMessages = new Set([
    'test-message-inapp',
    'message-template-template'
]);
const $b41f1e5b72e90ab4$export$5f4d7e99d8732fe7 = (0, $lDHLX.withJiraSideNavIntlProvider)((0, $e2ICd.createPlacementComponent)((0, $f9fe1349e81091e7$export$a5cfae247d8360ef), ({ initialData: initialData, onHasMessageChanged: onHasMessageChanged })=>{
    const { data: data, isLoading: isLoading } = (0, $kZgxR.useInitialData)(initialData);
    const [{ message: message, status: status }, setMessageState] = (0, $5uXOq.useState)({
        message: undefined,
        status: 'loading'
    });
    const handleOnDismissed = ()=>{
        setMessageState({
            message: undefined,
            status: 'done'
        });
        onHasMessageChanged?.(false);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!isLoading) {
            const newMessage = (data?.messages || []).filter((dataMessage)=>!$b41f1e5b72e90ab4$var$excludedMessages.has(dataMessage.messageTemplateId))[0];
            setMessageState({
                message: newMessage,
                status: 'done'
            });
            onHasMessageChanged?.(newMessage !== undefined);
        }
    }, [
        data,
        isLoading
    ]);
    if (isLoading || status === 'loading') return null;
    return message && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hrr29.MessageRenderer), {
        ...message,
        id: message.messageInstanceId,
        onDismissed: handleOnDismissed
    });
}, {
    choreographer: {
        isDefaultEnabled: false
    }
}));
var $b41f1e5b72e90ab4$export$2e2bcd8739ae039 = $b41f1e5b72e90ab4$export$5f4d7e99d8732fe7;

});
parcelRegister("e2ICd", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $1dea243ccb1ee301$export$8a57effc6307f916);

var $g6jw5 = parcelRequire("g6jw5");
const $1dea243ccb1ee301$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $g6jw5.createPlacementComponent)(placementId, Component, placementConfigurationOptions);

});
parcelRegister("g6jw5", function(module, exports) {

$parcel$export(module.exports, "createPlacementComponent", () => $c9bb81bd8eaa1f91$export$8a57effc6307f916);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $f3wkM = parcelRequire("f3wkM");

var $lOPND = parcelRequire("lOPND");

var $9lQh9 = parcelRequire("9lQh9");
var $9Aukk = parcelRequire("9Aukk");

var $4UTPF = parcelRequire("4UTPF");
const $c9bb81bd8eaa1f91$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $4UTPF.withErrorBoundary)((props)=>{
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        const stableContext = (0, $30kbx.useStableObject)(context);
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9lQh9.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Aukk.StableProviders), {
                route: route,
                context: stableContext,
                placement: {
                    placementId: placementId
                },
                choreographer: placementConfigurationOptions?.choreographer,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    context: stableContext,
                    initialData: initialData,
                    ...componentProps
                })
            })
        });
    });
const $c9bb81bd8eaa1f91$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $c9bb81bd8eaa1f91$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $lOPND.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $f3wkM.ERROR_BOUNDARY_LOCATION),
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};

});
parcelRegister("30kbx", function(module, exports) {

$parcel$export(module.exports, "useStableObject", () => $bec475bc874a93d3$export$ed02d4adf2068b08);

var $5uXOq = parcelRequire("5uXOq");
function $bec475bc874a93d3$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $bec475bc874a93d3$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $5uXOq.useMemo)(()=>obj, $bec475bc874a93d3$export$cdf98ded28406f69(obj));
}

});

parcelRegister("f3wkM", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONTEXT", () => $a8bec41c5a29948b$export$9c542858adf7dcd0);
$parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", () => $a8bec41c5a29948b$export$71ff7382870ef1b0);
const $a8bec41c5a29948b$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $a8bec41c5a29948b$export$71ff7382870ef1b0 = 'create-placement-component';

});

parcelRegister("lOPND", function(module, exports) {

$parcel$export(module.exports, "useComponentErrorHandling", () => $b1edd1250debac1d$export$3d127465d22fe4e5);

var $5uXOq = parcelRequire("5uXOq");
const $b1edd1250debac1d$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $5uXOq.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};

});

parcelRegister("9lQh9", function(module, exports) {

$parcel$export(module.exports, "PerformanceTracking", () => $eeeb78daf5be4c96$export$9a335a42ce02bdb8);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $jeAWE = parcelRequire("jeAWE");

var $2x1bx = parcelRequire("2x1bx");

var $2N91T = parcelRequire("2N91T");
const $eeeb78daf5be4c96$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
    const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $2N91T.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.PLACEMENT,
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
                name: (0, $jeAWE.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
};

});
parcelRegister("jeAWE", function(module, exports) {

$parcel$export(module.exports, "UFOv2", () => $983fcce4e885982c$export$c91b09caa8ecbab1);

var $8iquX = parcelRequire("8iquX");

var $5tDD0 = parcelRequire("5tDD0");
const $983fcce4e885982c$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $8iquX.default,
    UFOSegment: $5tDD0.default
};

});

parcelRegister("2x1bx", function(module, exports) {

$parcel$export(module.exports, "TrackMount", () => $dd434a72a35484c9$export$21b400a8c8ebc91a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $dd434a72a35484c9$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $5uXOq.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("2N91T", function(module, exports) {

$parcel$export(module.exports, "usePerformanceTracking", () => $290eab3364e5a55a$export$317d52099614f316);

var $5uXOq = parcelRequire("5uXOq");
const $290eab3364e5a55a$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const onMount = (0, $5uXOq.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $5uXOq.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};

});


parcelRegister("9Aukk", function(module, exports) {

$parcel$export(module.exports, "StableProviders", () => $bf4bc7f7479aacc5$export$2b6596bcb1383a71);

var $2OMIu = parcelRequire("2OMIu");

var $6HTor = parcelRequire("6HTor");

var $8otwM = parcelRequire("8otwM");

var $1z7k9 = parcelRequire("1z7k9");

var $2mHbD = parcelRequire("2mHbD");

var $51c3R = parcelRequire("51c3R");

var $1ZcCe = parcelRequire("1ZcCe");

var $9lQh9 = parcelRequire("9lQh9");
const $bf4bc7f7479aacc5$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2mHbD.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $51c3R.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1ZcCe.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8otwM.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1z7k9.StableChoreographerProvider), {
                        choreographer: choreographer,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6HTor.RenderTrackerProvider), {
                            placementId: placement.placementId,
                            children: children
                        })
                    })
                })
            })
        })
    });

});
parcelRegister("6HTor", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerProvider", () => $6b2b67dad92b784e$export$2d84fd9af6c9e378);

var $2OMIu = parcelRequire("2OMIu");

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");
/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $6b2b67dad92b784e$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $6b2b67dad92b784e$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if ($6b2b67dad92b784e$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
parcelRegister("ddiyw", function(module, exports) {

$parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", () => $86c2eaabc6cc5088$export$57d19d18d6e255a5);

var $bngFq = parcelRequire("bngFq");

var $5uXOq = parcelRequire("5uXOq");
const $86c2eaabc6cc5088$export$85183a312807388d = 'postOffice';
const $86c2eaabc6cc5088$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $5uXOq.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($86c2eaabc6cc5088$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};

});


parcelRegister("8otwM", function(module, exports) {

$parcel$export(module.exports, "StableAnaltyicsProvider", () => $55f0712814b9be83$export$5a66cdc9893b43e);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");
const $55f0712814b9be83$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: undefined,
            b: undefined,
            t: undefined
        }
    }
};
const $55f0712814b9be83$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
        data: $55f0712814b9be83$var$postOfficeAnalyticsContextData,
        children: children
    });
};

});

parcelRegister("1z7k9", function(module, exports) {

$parcel$export(module.exports, "StableChoreographerProvider", () => $6bf4189aae416d0e$export$e68b2c75bfb5682a);
$parcel$export(module.exports, "useChoreographerContext", () => $6bf4189aae416d0e$export$cab5a8adbabcee23);

var $2OMIu = parcelRequire("2OMIu");

var $ggVl0 = parcelRequire("ggVl0");
var $k9ais = parcelRequire("k9ais");

var $5uXOq = parcelRequire("5uXOq");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
const $6bf4189aae416d0e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;
const $6bf4189aae416d0e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $6bf4189aae416d0e$var$defaultContext = {
    choreographerEnabled: $6bf4189aae416d0e$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $6bf4189aae416d0e$var$ChoreographerContext = /*#__PURE__*/ (0, $5uXOq.createContext)($6bf4189aae416d0e$var$defaultContext);

const $6bf4189aae416d0e$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $5uXOq.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $5uXOq.useState)(choreographer?.isDefaultEnabled ?? $6bf4189aae416d0e$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $k9ais.usePostOfficeEnvironment)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    (0, $5uXOq.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("cwRME")).then((m)=>{
            const module = $6bf4189aae416d0e$var$importHelper(m);
            setChoreographerFactory(new module.ChoreographerRegistry(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
        }).catch(()=>{
            setChoreographerEnabled(false);
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv
    ]);
    const stableChoreographerContext = (0, $5uXOq.useMemo)(()=>({
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        }), [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($6bf4189aae416d0e$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $6bf4189aae416d0e$export$cab5a8adbabcee23 = ()=>(0, $5uXOq.useContext)($6bf4189aae416d0e$var$ChoreographerContext);

});
parcelRegister("ggVl0", function(module, exports) {

$parcel$export(module.exports, "defaultPostOfficeContextValue", () => $2a588e85980dae1a$export$da5dc9062cba6715);
$parcel$export(module.exports, "InternalPostOfficeContextProvider", () => $2a588e85980dae1a$export$3a10495c2cd2db0c);
$parcel$export(module.exports, "PostOfficeContextProvider", () => $2a588e85980dae1a$export$b77983be89bb0a4e);
$parcel$export(module.exports, "usePostOfficeContext", () => $2a588e85980dae1a$export$5bd9099e0ae94a43);

var $5uXOq = parcelRequire("5uXOq");
const $2a588e85980dae1a$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $2a588e85980dae1a$export$a228be81fcb77b42 = (0, $5uXOq.createContext)($2a588e85980dae1a$export$da5dc9062cba6715);
const $2a588e85980dae1a$export$3a10495c2cd2db0c = $2a588e85980dae1a$export$a228be81fcb77b42.Provider;
const $2a588e85980dae1a$export$b77983be89bb0a4e = $2a588e85980dae1a$export$3a10495c2cd2db0c;
const $2a588e85980dae1a$export$5bd9099e0ae94a43 = ()=>(0, $5uXOq.useContext)($2a588e85980dae1a$export$a228be81fcb77b42);

});

parcelRegister("cwRME", function(module, exports) {

let $91f23180b31e2425$var$load = (parcelRequire("28QjX"))(4);
module.exports = $91f23180b31e2425$var$load("3rsnr").then(()=>parcelRequire('aqms7'));

});


parcelRegister("2mHbD", function(module, exports) {

$parcel$export(module.exports, "StableContextProvider", () => $4635ad16673a46bb$export$d4982c0a28b18f63);

var $2OMIu = parcelRequire("2OMIu");

var $ggVl0 = parcelRequire("ggVl0");
var $30kbx = parcelRequire("30kbx");

var $f3wkM = parcelRequire("f3wkM");
const $4635ad16673a46bb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $30kbx.useStableObject)({
        ...(0, $f3wkM.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVl0.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};

});

parcelRegister("51c3R", function(module, exports) {

$parcel$export(module.exports, "StablePlacementProvider", () => $976c8379ea00cead$export$e9fd288527498af6);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $2EUTa = parcelRequire("2EUTa");
const $976c8379ea00cead$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $30kbx.useStableObject)(placement);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2EUTa.PlacementProvider), {
        value: stableValue,
        children: children
    });
};

});
parcelRegister("2EUTa", function(module, exports) {

$parcel$export(module.exports, "PlacementProvider", () => $ce3c5357121f811e$export$6272e220478c7f1d);
$parcel$export(module.exports, "usePlacementContext", () => $ce3c5357121f811e$export$4fc0446ee742ad80);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");

var $iHQZs = parcelRequire("iHQZs");

var $5uXOq = parcelRequire("5uXOq");
const $ce3c5357121f811e$export$6394bf86db095a8 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementId: undefined
});
const $ce3c5357121f811e$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $5uXOq.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $iHQZs.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ce3c5357121f811e$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $ce3c5357121f811e$export$4fc0446ee742ad80 = ()=>(0, $5uXOq.useContext)($ce3c5357121f811e$export$6394bf86db095a8);

});
parcelRegister("iHQZs", function(module, exports) {

$parcel$export(module.exports, "PostOfficeScreenContextProvider", () => $7be062d5df09f4cd$export$ca77a8cbe94108fe);
$parcel$export(module.exports, "usePostOfficeScreenPlacement", () => $7be062d5df09f4cd$export$f51d04a086368016);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $hHS4t = parcelRequire("hHS4t");
const $7be062d5df09f4cd$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $7be062d5df09f4cd$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placements: $7be062d5df09f4cd$var$initialPlacementState
});
const $7be062d5df09f4cd$export$70e19226ddeaf957 = ()=>(0, $5uXOq.useContext)($7be062d5df09f4cd$var$PostOfficeScreenContext);
const $7be062d5df09f4cd$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $7be062d5df09f4cd$export$5d27c0ee02be2a23 = ()=>(0, $5uXOq.useContext)($7be062d5df09f4cd$var$PostOfficeScreenUpdateContext);
const $7be062d5df09f4cd$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $5uXOq.useState)($7be062d5df09f4cd$var$initialPlacementState);
    const placementMount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $hHS4t.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $hHS4t.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $5uXOq.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $5uXOq.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $5uXOq.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7be062d5df09f4cd$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($7be062d5df09f4cd$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext,
            children: children
        })
    });
};
const $7be062d5df09f4cd$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $7be062d5df09f4cd$export$5d27c0ee02be2a23();
    (0, $5uXOq.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};

});
parcelRegister("hHS4t", function(module, exports) {

$parcel$export(module.exports, "uniqueArray", () => $e1d243333aeb86d5$export$bbd17ecb0679edd7);
const $e1d243333aeb86d5$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());

});




parcelRegister("1ZcCe", function(module, exports) {

$parcel$export(module.exports, "StableRouteProvider", () => $0aa90403cb1ade07$export$ce13d00e696dfc96);

var $2OMIu = parcelRequire("2OMIu");

var $7LKoA = parcelRequire("7LKoA");
var $30kbx = parcelRequire("30kbx");

var $eJvAJ = parcelRequire("eJvAJ");
const $0aa90403cb1ade07$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $eJvAJ.useLocationHref)();
    const stableRoute = (0, $30kbx.useStableObject)(route ?? {
        previous: href,
        current: href
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LKoA.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};

});
parcelRegister("7LKoA", function(module, exports) {

$parcel$export(module.exports, "PostOfficeRouteContext", () => $62c318a41c57bfc6$export$f7f47a74e8b47b1f);
$parcel$export(module.exports, "PostOfficeRouteProvider", () => $62c318a41c57bfc6$export$89eadc6b3e5f4e9e);
$parcel$export(module.exports, "usePostOfficeRoute", () => $62c318a41c57bfc6$export$79301b66f7808cd8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8tyNL = parcelRequire("8tyNL");

var $30kbx = parcelRequire("30kbx");
const $62c318a41c57bfc6$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $62c318a41c57bfc6$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $62c318a41c57bfc6$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $8tyNL.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $30kbx.useStableObject)(route);
};
const $62c318a41c57bfc6$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $62c318a41c57bfc6$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$62c318a41c57bfc6$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $62c318a41c57bfc6$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $5uXOq.createContext)($62c318a41c57bfc6$var$initialState);
const $62c318a41c57bfc6$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $62c318a41c57bfc6$export$98c77e1bd702ed15(props);
    const route = $62c318a41c57bfc6$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($62c318a41c57bfc6$export$f7f47a74e8b47b1f.Provider, {
        value: route,
        children: children
    });
};
const $62c318a41c57bfc6$export$79301b66f7808cd8 = ()=>(0, $5uXOq.useContext)($62c318a41c57bfc6$export$f7f47a74e8b47b1f); //Route listener

});

parcelRegister("eJvAJ", function(module, exports) {

$parcel$export(module.exports, "useLocationHref", () => $d8419c244aee9b70$export$49fc3f3d8c7f99);
const $d8419c244aee9b70$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $d8419c244aee9b70$export$49fc3f3d8c7f99 = ()=>{
    return $d8419c244aee9b70$var$isLocationAvailable() ? globalThis.location.href : undefined;
};

});



parcelRegister("4UTPF", function(module, exports) {

$parcel$export(module.exports, "withErrorBoundary", () => $e3df8a0c98fba3f5$export$f0c7a449e0cfaec7);

var $2OMIu = parcelRequire("2OMIu");


var $ddiyw = parcelRequire("ddiyw");

var $exWMY = parcelRequire("exWMY");
const $e3df8a0c98fba3f5$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $4e2819b72987a07d$export$12346a674644c156),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $2OMIu.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $exWMY.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation
            }, onError),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...data
            })
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $4e2819b72987a07d$export$a1562d08625f5d7e = 'ui';
const $4e2819b72987a07d$export$947dac6c72b26f81 = 'track';
const $4e2819b72987a07d$export$f1d537d508d2945a = 'screen';
const $4e2819b72987a07d$export$12346a674644c156 = 'operational';
const $4e2819b72987a07d$export$b055de0e665cb20c = 'unknown';

parcelRegister("exWMY", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $a971bfffb2c22071$export$e926676385687eaf);

var $5uXOq = parcelRequire("5uXOq");
'use client';
const $a971bfffb2c22071$export$b16d9fb1a22de840 = (0, $5uXOq.createContext)(null);
const $a971bfffb2c22071$var$initialState = {
    didCatch: false,
    error: null
};
class $a971bfffb2c22071$export$e926676385687eaf extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $a971bfffb2c22071$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($a971bfffb2c22071$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $a971bfffb2c22071$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($a971bfffb2c22071$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $5uXOq.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $5uXOq.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $5uXOq.createElement)($a971bfffb2c22071$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $a971bfffb2c22071$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $a971bfffb2c22071$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $a971bfffb2c22071$export$c052f6604b7d51fe() {
    const context = (0, $5uXOq.useContext)($a971bfffb2c22071$export$b16d9fb1a22de840);
    $a971bfffb2c22071$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $5uXOq.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $5uXOq.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $a971bfffb2c22071$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $5uXOq.forwardRef)((props, ref)=>(0, $5uXOq.createElement)($a971bfffb2c22071$export$e926676385687eaf, errorBoundaryProps, (0, $5uXOq.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});




parcelRegister("kZgxR", function(module, exports) {

$parcel$export(module.exports, "useInitialData", () => $adf556fc63dea129$export$5523c5f3222291d0);

var $5uXOq = parcelRequire("5uXOq");

var $02EmO = parcelRequire("02EmO");
const $adf556fc63dea129$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $5uXOq.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $02EmO.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};

});
parcelRegister("02EmO", function(module, exports) {

$parcel$export(module.exports, "AlreadyRunningError", () => $ca4bafb6eca4235c$export$8c5224d3af2f3c8b);
$parcel$export(module.exports, "useData", () => $ca4bafb6eca4235c$export$c1cf1cf4c5d51937);

var $ddiyw = parcelRequire("ddiyw");

var $lzG7s = parcelRequire("lzG7s");

var $5uXOq = parcelRequire("5uXOq");

var $hMtay = parcelRequire("hMtay");
class $ca4bafb6eca4235c$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $ca4bafb6eca4235c$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $5uXOq.useState)((0, $hMtay.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $5uXOq.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then((0, $hMtay.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
            setState((0, $hMtay.toData)(data));
            fireAnalyticsEvent({
                action: 'resolved',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes
                }
            });
        }).catch((err)=>{
            if (err instanceof $ca4bafb6eca4235c$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $hMtay.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, $lzG7s.camelCase)(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};

});
parcelRegister("lzG7s", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("hMtay", function(module, exports) {

$parcel$export(module.exports, "assertResponseIsOk", () => $cfed604ac54edf35$export$b3732c8ff6f9c463);
$parcel$export(module.exports, "toLoading", () => $cfed604ac54edf35$export$f9a5bd0ffba29ffc);
$parcel$export(module.exports, "toError", () => $cfed604ac54edf35$export$cc3b967c039ed3e7);
$parcel$export(module.exports, "toData", () => $cfed604ac54edf35$export$24a6b176bdc41ce5);
const $cfed604ac54edf35$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cfed604ac54edf35$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($cfed604ac54edf35$export$18a0019e5439b209(res));
};
const $cfed604ac54edf35$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $cfed604ac54edf35$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $cfed604ac54edf35$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });

});



parcelRegister("hrr29", function(module, exports) {

$parcel$export(module.exports, "MessageRenderer", () => $ca724bf78c7bd259$export$2df1250b8f917a59);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 
var $aMNd8 = parcelRequire("aMNd8");

var $5Umid = parcelRequire("5Umid");

var $4Y2M3 = parcelRequire("4Y2M3");

var $g4Gy4 = parcelRequire("g4Gy4");

var $aMI06 = parcelRequire("aMI06");
const $ca724bf78c7bd259$export$e30378e28ad3e6ab = {
    ...(0, $5Umid.default),
    ...(0, $4Y2M3.default),
    ...(0, $g4Gy4.default),
    ...(0, $aMI06.default)
};
const { initializeMessageRenderer: $ca724bf78c7bd259$export$bce4e5106d86e473, MessageRenderer: $ca724bf78c7bd259$export$2df1250b8f917a59 } = (0, $aMNd8.asMessageRenderer)($ca724bf78c7bd259$export$e30378e28ad3e6ab);

});
parcelRegister("aMNd8", function(module, exports) {

$parcel$export(module.exports, "MaybeSuspenseBoundary", () => $3aefc0bbdbf1eed1$export$9750eb54d7c7e789);
$parcel$export(module.exports, "asMessageRenderer", () => $3aefc0bbdbf1eed1$export$7b7e5a348ef9a7c1);
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $30kbx = parcelRequire("30kbx");

var $55GjK = parcelRequire("55GjK");
var $jeAWE = parcelRequire("jeAWE");

var $iSjjB = parcelRequire("iSjjB");

var $eFcnR = parcelRequire("eFcnR");

var $g9Rt9 = parcelRequire("g9Rt9");
var $cxwD2 = parcelRequire("cxwD2");
var $f7sfm = parcelRequire("f7sfm");
var $2x1bx = parcelRequire("2x1bx");
var $4UTPF = parcelRequire("4UTPF");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $7hNKr = parcelRequire("7hNKr");
const $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT = {};
const $3aefc0bbdbf1eed1$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        ...props,
        children: children
    });
};
const $3aefc0bbdbf1eed1$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $5uXOq.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense), ...data })=>{
            const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
            const recommendationSessionStable = (0, $30kbx.useStableObject)(recommendationSession ?? $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $30kbx.useStableObject)(postOffice ?? $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $5uXOq.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $55GjK.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $5uXOq.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $iSjjB.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $iSjjB.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
                        name: (0, $jeAWE.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
                        children: loadingFallback ?? null
                    }), [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $30kbx.useStableObject)(componentProps);
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                return (0, $96Irh.default).checkGate('po-refactor-message-renderer-provider') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f7sfm.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $3aefc0bbdbf1eed1$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                        ...componentProps
                    })
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7hNKr.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9Rt9.FeatureFlaggedUfoWrapper), {
                        messageTemplateId: messageTemplateId,
                        isEnabled: isUFOEnabled,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFcnR.MessageContextProvider), {
                            value: {
                                messageInstanceId: messageInstanceId,
                                messageTemplateId: messageTemplateId,
                                triggerId: triggerId,
                                messageCreationType: messageCreationType,
                                transactionAccountId: componentProps.transactionAccountId,
                                analyticsDetails: postOffice?.analyticsDetails
                            },
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NLx9.RecommendationProvider), {
                                value: recommendationSession ?? {},
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                                    fallback: loadingComponent,
                                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cxwD2.MessageAnalyticsContextProvider), {
                                        children: [
                                            messageSuccessComponent,
                                            /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                                ...componentProps
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                });
            };
            return (0, $4UTPF.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};

});
parcelRegister("55GjK", function(module, exports) {

$parcel$export(module.exports, "UFOv1", () => $2204ea052ae660ad$export$96236906ebaa7f87);

var $hhWKz = parcelRequire("hhWKz");

var $fhKaW = parcelRequire("fhKaW");
const $2204ea052ae660ad$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $hhWKz.MessagePerformanceTracker,
    PlacementPerformanceTracker: $fhKaW.PlacementPerformanceTracker
};

});
parcelRegister("hhWKz", function(module, exports) {

$parcel$export(module.exports, "MessagePerformanceTracker", () => $2258f83a04d7be92$export$ae5c73c7c4f454e6);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $5WtaI = parcelRequire("5WtaI");
class $2258f83a04d7be92$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kkzI0.UFOExperience)((0, $5WtaI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $lrUJ4.ExperienceTypes).Load,
            platform: {
                component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $kkzI0.UFOExperience)(`${(0, $5WtaI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $lrUJ4.ExperienceTypes).Load,
            platform: {
                component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}

});
parcelRegister("5WtaI", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceNames", () => $206558bbfd4f706c$export$cc7ddf8ca628f6f1);
$parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", () => $206558bbfd4f706c$export$6d482cfa20c9d220);
const $206558bbfd4f706c$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $206558bbfd4f706c$export$6d482cfa20c9d220 = 'post-office';

});


parcelRegister("fhKaW", function(module, exports) {

$parcel$export(module.exports, "PlacementPerformanceTracker", () => $cacbb6066396be7c$export$8b48c2105ba0b35a);

var $lrUJ4 = parcelRequire("lrUJ4");
var $kkzI0 = parcelRequire("kkzI0");

var $5WtaI = parcelRequire("5WtaI");
const $cacbb6066396be7c$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $lrUJ4.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $lrUJ4.ExperienceTypes).Load,
    platform: {
        component: (0, $5WtaI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $cacbb6066396be7c$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$cacbb6066396be7c$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $cacbb6066396be7c$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $kkzI0.UFOExperience)((0, $5WtaI.UFOExperienceNames).PLACEMENT, $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $kkzI0.UFOExperience)(`${(0, $5WtaI.UFOExperienceNames).PLACEMENT}.${placementId}`, $cacbb6066396be7c$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}

});


parcelRegister("iSjjB", function(module, exports) {

$parcel$export(module.exports, "InvalidMessageTemplateIdError", () => $3023577c52e62572$export$19cb89dd679394cb);
$parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", () => $3023577c52e62572$export$3dfc27a8d3942f4d);
var $3023577c52e62572$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $3023577c52e62572$export$46f86d28cd0a5d38 extends Error {
}
class $3023577c52e62572$export$627bc00a5ef5f6ae extends Error {
}
class $3023577c52e62572$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $3023577c52e62572$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $3023577c52e62572$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $3023577c52e62572$export$ed601cd0dc1a1be7 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(args){
        super('Error in message template code', "MessageTemplateError", args.cause);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8d39b103586e9fd4 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "NotAbleToProcessEmailTemplateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$f649da38897d27f7 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$c2852c1c4d9aba3e extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$4b7b4e09547e4bb3 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$360a094a97597d87 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$4d068b43eb55165b extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$ac007ee150add337 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$b79ba63f8ae791e0 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "HandlerValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$19cb89dd679394cb extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$78651662ad470cc5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8a5041670cdd8db2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$1240ddc25cf964e6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3c4884b7ae7fe517 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$913b8e68dc7ae8fe extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3dfc27a8d3942f4d extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$e5ccdf8bbfead7a2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$823733742d803ae6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$1caa32527f23acd2 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$a6f2aad8fa094b39 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(accountId){
        super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2f1e27130c2bf271 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$d0dc094613469f2b extends $3023577c52e62572$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$5603eab37ce562f5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$b35ca1cf49054efc extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, email){
        super(message, "UnsupportedEmailError");
        this.name = this.constructor.name;
        this.email = email;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$e0e9aa0e9c6b37ff extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$3ad818f64601e141 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$25470bb6cba4fba0 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$ce14d445679448b6 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $3023577c52e62572$export$c9a26a17db1045c8 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$8ab4fb362168b928 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2afd69f57fe5285f extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$7635d2b1a281d626 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$9e1c6d00e675bc86 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$6d1a4929f6ff1a32 extends $3023577c52e62572$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $3023577c52e62572$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.message = message, this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $3023577c52e62572$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $3023577c52e62572$export$c504492f06c975b5 extends $3023577c52e62572$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}

});

parcelRegister("eFcnR", function(module, exports) {

$parcel$export(module.exports, "MessageContextProvider", () => $f3127689662c06ba$export$42de33f7652dc3de);
$parcel$export(module.exports, "useMessageContext", () => $f3127689662c06ba$export$a5b6d14a2e25725a);

var $5uXOq = parcelRequire("5uXOq");
const $f3127689662c06ba$var$initialValue = {};
const $f3127689662c06ba$export$b060d577040138d8 = (0, $5uXOq.createContext)($f3127689662c06ba$var$initialValue);
const $f3127689662c06ba$export$42de33f7652dc3de = $f3127689662c06ba$export$b060d577040138d8.Provider;
const $f3127689662c06ba$export$a5b6d14a2e25725a = ()=>(0, $5uXOq.useContext)($f3127689662c06ba$export$b060d577040138d8);

});

parcelRegister("g9Rt9", function(module, exports) {

$parcel$export(module.exports, "FeatureFlaggedUfoWrapper", () => $b0f548f7f0e4c1bf$export$8e6fb7035018b3e4);

var $2OMIu = parcelRequire("2OMIu");

var $jeAWE = parcelRequire("jeAWE");
const $b0f548f7f0e4c1bf$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
            name: `${(0, $jeAWE.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});

parcelRegister("cxwD2", function(module, exports) {

$parcel$export(module.exports, "MessageAnalyticsContextProvider", () => $2e3fcdbae78acb99$export$1737ab199e83455e);
$parcel$export(module.exports, "useMessageAnalyticsContext", () => $2e3fcdbae78acb99$export$bb426ba114b64992);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $2e3fcdbae78acb99$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $2e3fcdbae78acb99$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $5uXOq.createContext)($2e3fcdbae78acb99$var$defaultMessageAnalyticsContextValue);
const $2e3fcdbae78acb99$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $5uXOq.useRef)(false);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2e3fcdbae78acb99$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $2e3fcdbae78acb99$export$bb426ba114b64992 = ()=>(0, $5uXOq.useContext)($2e3fcdbae78acb99$export$c81717973c6c4a90);

});

parcelRegister("f7sfm", function(module, exports) {

$parcel$export(module.exports, "MessageRendererProvider", () => $1eaf097979fe8fef$export$5fe06fe68913d493);

var $2OMIu = parcelRequire("2OMIu");

var $jeAWE = parcelRequire("jeAWE");

var $eFcnR = parcelRequire("eFcnR");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $cFgHJ = parcelRequire("cFgHJ");

var $g9Rt9 = parcelRequire("g9Rt9");

var $cxwD2 = parcelRequire("cxwD2");
const $1eaf097979fe8fef$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $1eaf097979fe8fef$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $5uXOq.Suspense) })=>{
    const loadingComponent = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOLoadHold, {
            name: (0, $jeAWE.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $5uXOq.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            postOffice: postOffice
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cFgHJ.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9Rt9.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eFcnR.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6NLx9.RecommendationProvider), {
                    value: recommendationSession ?? $1eaf097979fe8fef$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $cxwD2.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("6NLx9", function(module, exports) {

$parcel$export(module.exports, "RecommendationProvider", () => $3c770c90c429215d$export$f60e87d7b5f59562);
$parcel$export(module.exports, "useRecommendationContext", () => $3c770c90c429215d$export$3321c0b02f750bcc);

var $2OMIu = parcelRequire("2OMIu");

var $htBRZ = parcelRequire("htBRZ");

var $5uXOq = parcelRequire("5uXOq");
const $3c770c90c429215d$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $3c770c90c429215d$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c770c90c429215d$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $htBRZ.default), {
            data: value,
            children: children
        })
    });
};
const $3c770c90c429215d$export$3321c0b02f750bcc = ()=>(0, $5uXOq.useContext)($3c770c90c429215d$export$ba2f44035effd9c1);

});

parcelRegister("cFgHJ", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $3a4569dcbed80977$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");

var $1z7k9 = parcelRequire("1z7k9");
const $3a4569dcbed80977$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $3a4569dcbed80977$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $1z7k9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($3a4569dcbed80977$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("7hNKr", function(module, exports) {

$parcel$export(module.exports, "ChoreographerWrapper", () => $cc7e963dbb2f5717$export$8db7ba034addcd65);

var $2OMIu = parcelRequire("2OMIu");

var $96Irh = parcelRequire("96Irh");

var $ddiyw = parcelRequire("ddiyw");

var $1z7k9 = parcelRequire("1z7k9");

var $5uXOq = parcelRequire("5uXOq");
const $cc7e963dbb2f5717$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return null;
};
const $cc7e963dbb2f5717$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $1z7k9.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $96Irh.default).checkGate('enable_choreographed_post_office_messages');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) return /*#__PURE__*/ (0, $2OMIu.jsx)($cc7e963dbb2f5717$var$ChoreographedComponent, {
            choreographerFactory: factory,
            messageId: messageId,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});


parcelRegister("5Umid", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bfebd6628b2ca3$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $67ZTb = parcelRequire("67ZTb");

var $7eaZx = parcelRequire("7eaZx");

var $15JO3 = parcelRequire("15JO3");

var $brwZR = parcelRequire("brwZR");

var $9HzUU = parcelRequire("9HzUU");
var $b6bfebd6628b2ca3$export$2e2bcd8739ae039 = {
    'recommendation-confluence': (0, $67ZTb.default),
    'recommendation-jpd': (0, $7eaZx.default),
    'recommendation-jsm': (0, $15JO3.default),
    'recommendation-jsw-visualize-work': (0, $brwZR.default),
    'recommendation-loom': (0, $9HzUU.default)
};

});
parcelRegister("67ZTb", function(module, exports) {

$parcel$export(module.exports, "default", () => $693b9c9508f88f7e$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $jo1Bz = parcelRequire("jo1Bz");

var $h1mmH = parcelRequire("h1mmH");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $hcAYG = parcelRequire("hcAYG");
const $693b9c9508f88f7e$var$CCP_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';
const $693b9c9508f88f7e$var$HAMS_PRODUCT_ID = 'confluence.ondemand';
const $693b9c9508f88f7e$var$PRODUCT_NAME = 'Confluence';
const $693b9c9508f88f7e$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-confluence.reasons-modal.message",
            defaultMessage: "We think {confluence} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Confluence recommendation will be relevant to the customer.",
            values: {
                confluence: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $693b9c9508f88f7e$var$PRODUCT_NAME
                })
            }
        })
    })
};
const $693b9c9508f88f7e$export$b3890eb0ae9dca99 = (0, $hcAYG.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mmH.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $693b9c9508f88f7e$var$HAMS_PRODUCT_ID,
            ccpProductId: $693b9c9508f88f7e$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jo1Bz.ConfluenceIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-confluence.product-name.header",
                description: "Header for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Collaborate on pages in real-time"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-confluence.cta.label",
                description: "CTA text for Confluence recommendation message in Jira Side Nav",
                defaultMessage: "Try Confluence"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $693b9c9508f88f7e$var$whyAmISeeingThisModalContent
    }));
var $693b9c9508f88f7e$export$2e2bcd8739ae039 = $693b9c9508f88f7e$export$b3890eb0ae9dca99;

});
parcelRegister("jo1Bz", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $88a43adeb7653a71$export$68f3db7f6af48bcb);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $88a43adeb7653a71$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $88a43adeb7653a71$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $88a43adeb7653a71$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("h1mmH", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavFirstPartyRecommendation", () => $c94fb1b1b9351c70$export$35f6f23f7684ff6);

var $2OMIu = parcelRequire("2OMIu");

var $bWfiu = parcelRequire("bWfiu");

var $bEIgH = parcelRequire("bEIgH");

var $7xzbV = parcelRequire("7xzbV");

var $eFcnR = parcelRequire("eFcnR");

var $kDiio = parcelRequire("kDiio");
const $c94fb1b1b9351c70$var$BodyContent = ({ app: app })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bEIgH.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                children: app.logo
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bWfiu.default), {
                size: "xsmall",
                children: app.header
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kDiio.CTAButton), {
                app: app
            })
        ]
    });
};
const $c94fb1b1b9351c70$export$35f6f23f7684ff6 = ({ app: app, onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $eFcnR.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xzbV.JiraSideNavMessage), {
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
        bodyContent: /*#__PURE__*/ (0, $2OMIu.jsx)($c94fb1b1b9351c70$var$BodyContent, {
            app: app
        })
    });
};

});
parcelRegister("7xzbV", function(module, exports) {

$parcel$export(module.exports, "JiraSideNavMessage", () => $9ec90cddae71024b$export$ee97a7edb31193a8);
/* message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eFcnR = parcelRequire("eFcnR");

var $62TVc = parcelRequire("62TVc");
const $9ec90cddae71024b$var$jiraSideNavMessageStyle = null;
const $9ec90cddae71024b$export$ee97a7edb31193a8 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, bodyContent: bodyContent })=>{
    const { messageInstanceId: messageInstanceId } = (0, $eFcnR.useMessageContext)();
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": "jira-side-nav-message",
        className: (0, $bwpsq.default)([
            "_2rkoop52 _18zrpxbi _1rjcutpp _kqswh2mm _1e0c1txw _bfhk1hdx _1pbyidpf"
        ]),
        children: [
            bodyContent,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $62TVc.Actions), {
                whyAmISeeingThisModalContent: whyAmISeeingThisModalContent,
                onDismissed: ()=>onDismissed?.(messageInstanceId)
            })
        ]
    });
};

});
parcelRegister("62TVc", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $16a6eeebe5a4d681$export$b52183d5cfb26dc9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fXriO = parcelRequire("fXriO");
const $16a6eeebe5a4d681$var$actionsStyles = null;
const $16a6eeebe5a4d681$export$b52183d5cfb26dc9 = ({ onDismissed: onDismissed, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1yt4u2gc _kqswstnw _1e0c1txw _154iidpf _1xi2idpf"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fXriO.AdControls), {
            iconSize: "small",
            onDismissed: onDismissed,
            whyAmISeeingThisModalContent: whyAmISeeingThisModalContent
        })
    });
};

});
parcelRegister("fXriO", function(module, exports) {

$parcel$export(module.exports, "AdControls", () => $ee171605da84c078$export$c25b8b7217045de9);

var $2OMIu = parcelRequire("2OMIu");

var $1Seuh = parcelRequire("1Seuh");

var $j7m8K = parcelRequire("j7m8K");

var $f6ajG = parcelRequire("f6ajG");

var $5KCCi = parcelRequire("5KCCi");

var $ddiyw = parcelRequire("ddiyw");

var $eFcnR = parcelRequire("eFcnR");

var $bpU8k = parcelRequire("bpU8k");

var $lFpSS = parcelRequire("lFpSS");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $gcYBn = parcelRequire("gcYBn");

var $cW2cD = parcelRequire("cW2cD");

var $c8sYW = parcelRequire("c8sYW");
const $ee171605da84c078$var$DropdownTrigger = ({ triggerRef: triggerRef, name: name, iconSize: iconSize = 'small', iconColor: iconColor, ...triggerProps })=>{
    const intl = (0, $koVbs.default)();
    const ariaLabel = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.aria-label',
        defaultMessage: '{messageInstanceId} options menu',
        description: 'Options menu ad controls'
    }, {
        messageInstanceId: name
    });
    const tooltip = intl.formatMessage({
        id: 'post-office.ad-controls.dropdown-menu-trigger.tooltip',
        defaultMessage: 'More actions',
        description: 'Tooltip for ad-controls dropdown'
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5KCCi.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
            ...triggerProps,
            label: ariaLabel,
            appearance: "subtle",
            ref: triggerRef,
            icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f6ajG))), {
                    ...iconProps,
                    primaryColor: iconColor,
                    size: iconSize
                })
        })
    });
};
const $ee171605da84c078$export$c25b8b7217045de9 = ({ onDismissed: onDismissed, iconSize: iconSize, iconColor: iconColor, whyAmISeeingThisModalContent: whyAmISeeingThisModalContent, showWhyAmISeeingThis: showWhyAmISeeingThis = true, additionalAnalyticsAttributes: additionalAnalyticsAttributes = {}, zIndex: zIndex })=>{
    const [isWhyAmISeeingThisModelOpened, setIsWhyAmISeeingThisModelOpened] = (0, $5uXOq.useState)(false);
    const { messageDismissed: messageDismissed, messageAcknowledged: messageAcknowledged } = (0, $lFpSS.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bpU8k.useMessageInstanceEvent)();
    const { messageInstanceId: messageInstanceId } = (0, $eFcnR.useMessageContext)();
    const [currIconColor, setCurrIconColor] = (0, $5uXOq.useState)(iconColor);
    if (!messageInstanceId) throw new Error('messageInstanceId is required');
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    const [showDismissedFlag, setShowDismissedFlag] = (0, $5uXOq.useState)(false);
    const handleNotInterested = async ()=>{
        await messageDismissed();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'notInterested',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'notInterested'
        }, {
            ...additionalAnalyticsAttributes
        });
        if (messageInstanceId && typeof onDismissed === 'function') // integrating with useMessagePlacementHooks removes the need to pass this callback
        onDismissed(messageInstanceId);
        setShowDismissedFlag(true);
    };
    const handleWhyAmISeeingThis = async ()=>{
        setIsWhyAmISeeingThisModelOpened(true);
        await messageAcknowledged();
        await messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: {
                clickIdentifier: 'adControlsReasons',
                clickedElement: 'button',
                buttonType: 'primary'
            },
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        });
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'adControlsReasons'
        }, {
            ...additionalAnalyticsAttributes
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7m8K.default), {
                testId: "post-office-ad-controls-dropdown",
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)($ee171605da84c078$var$DropdownTrigger, {
                        name: messageInstanceId,
                        triggerRef: triggerRef,
                        iconSize: iconSize,
                        iconColor: currIconColor,
                        ...triggerProps
                    }),
                ...zIndex && {
                    zIndex: zIndex
                },
                onOpenChange: (args)=>{
                    if (args.isOpen) {
                        fireAnalyticsEvent({
                            eventType: 'ui',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'adControlsDropdown'
                        });
                        setCurrIconColor("var(--ds-icon-selected, #0C66E4)");
                    } else setCurrIconColor(iconColor);
                },
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cW2cD.AdControlsDropdown), {
                    onNotInterested: handleNotInterested,
                    onWhyAmISeeingThis: handleWhyAmISeeingThis,
                    showWhyAmISeeingThis: showWhyAmISeeingThis
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c8sYW.WhyAmISeeingThisModal), {
                content: whyAmISeeingThisModalContent,
                isOpen: isWhyAmISeeingThisModelOpened,
                additionalAnalyticsAttributes: additionalAnalyticsAttributes,
                onClose: ()=>{
                    setIsWhyAmISeeingThisModelOpened(false);
                    fireAnalyticsEvent({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'adControlsReasonsClose'
                    }, {
                        ...additionalAnalyticsAttributes
                    });
                }
            }),
            showDismissedFlag && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gcYBn.AdControlsFlag), {
                messageInstanceId: messageInstanceId,
                onCloseFlag: ()=>setShowDismissedFlag(false)
            })
        ]
    });
};

});
parcelRegister("bpU8k", function(module, exports) {

$parcel$export(module.exports, "useMessageInstanceEvent", () => $a3041837ebdef1bc$export$39b0f5626e96f41e);

var $ggVl0 = parcelRequire("ggVl0");

var $eFcnR = parcelRequire("eFcnR");

var $2EUTa = parcelRequire("2EUTa");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $dadai = parcelRequire("dadai");

var $dk8p3 = parcelRequire("dk8p3");
const $a3041837ebdef1bc$export$39b0f5626e96f41e = ()=>{
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $dk8p3.MessageInstanceEventClient)();
    const client = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, triggerId: messageTriggerId, messageCreationType: messageCreationType } = (0, $eFcnR.useMessageContext)();
    const { placementId: placementId } = (0, $2EUTa.usePlacementContext)();
    const browserContext = (0, $ggVl0.usePostOfficeContext)();
    const recommendationContext = (0, $6NLx9.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    const messageInstanceViewed = (0, $5uXOq.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const event = {
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : additionalMetadataFromFrontend,
            messageTriggerId: messageTriggerId,
            messageCreationType: messageCreationType,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(event);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    const messageInstanceClicked = (0, $5uXOq.useCallback)(async (params)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new (0, $dadai.MessageInstanceEventContextError)());
            return;
        }
        const clickEventPayload = {
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            ...params,
            additionalMetadataFromFrontend: transactionAccountId ? {
                ...params.additionalMetadataFromFrontend,
                transactionAccountId: transactionAccountId
            } : params.additionalMetadataFromFrontend,
            timestamp: Date.now()
        };
        await client.sendMessageInstanceEvent(clickEventPayload);
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        recommendationContext.entityId,
        recommendationContext.sessionId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};

});
parcelRegister("dadai", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventContextError", () => $13eabc7989eac29b$export$9ffc53d3edc152da);
class $13eabc7989eac29b$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $13eabc7989eac29b$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}

});

parcelRegister("dk8p3", function(module, exports) {

$parcel$export(module.exports, "MessageInstanceEventClient", () => $7813b67f6b66bb28$export$4564cfc2de39be55);
const $7813b67f6b66bb28$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $7813b67f6b66bb28$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($7813b67f6b66bb28$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $7813b67f6b66bb28$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $7813b67f6b66bb28$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});
parcelRegister("fS9d8", function(module, exports) {

$parcel$export(module.exports, "Headers", () => $b8e30b448f738d08$export$79b704688b15c0f4);
$parcel$export(module.exports, "Request", () => $b8e30b448f738d08$export$7fa6c5b6f8193917);
$parcel$export(module.exports, "Response", () => $b8e30b448f738d08$export$9f633d56d7ec90d3);
$parcel$export(module.exports, "DOMException", () => $b8e30b448f738d08$export$fe58bcf938607f6a);
$parcel$export(module.exports, "fetch", () => $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3);
/* eslint-disable no-prototype-builtins */ var $b8e30b448f738d08$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $b8e30b448f738d08$var$support = {
    searchParams: 'URLSearchParams' in $b8e30b448f738d08$var$g,
    iterable: 'Symbol' in $b8e30b448f738d08$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $b8e30b448f738d08$var$g && 'Blob' in $b8e30b448f738d08$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $b8e30b448f738d08$var$g,
    arrayBuffer: 'ArrayBuffer' in $b8e30b448f738d08$var$g
};
function $b8e30b448f738d08$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($b8e30b448f738d08$var$support.arrayBuffer) {
    var $b8e30b448f738d08$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $b8e30b448f738d08$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $b8e30b448f738d08$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $b8e30b448f738d08$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $b8e30b448f738d08$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $b8e30b448f738d08$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($b8e30b448f738d08$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $b8e30b448f738d08$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    value = $b8e30b448f738d08$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$b8e30b448f738d08$var$normalizeName(name)];
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $b8e30b448f738d08$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($b8e30b448f738d08$var$normalizeName(name));
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$b8e30b448f738d08$var$normalizeName(name)] = $b8e30b448f738d08$var$normalizeValue(value);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
$b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $b8e30b448f738d08$var$iteratorFor(items);
};
if ($b8e30b448f738d08$var$support.iterable) $b8e30b448f738d08$export$79b704688b15c0f4.prototype[Symbol.iterator] = $b8e30b448f738d08$export$79b704688b15c0f4.prototype.entries;
function $b8e30b448f738d08$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $b8e30b448f738d08$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $b8e30b448f738d08$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $b8e30b448f738d08$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $b8e30b448f738d08$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $b8e30b448f738d08$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $b8e30b448f738d08$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $b8e30b448f738d08$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($b8e30b448f738d08$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($b8e30b448f738d08$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($b8e30b448f738d08$var$support.arrayBuffer && $b8e30b448f738d08$var$support.blob && $b8e30b448f738d08$var$isDataView(body)) {
            this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($b8e30b448f738d08$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $b8e30b448f738d08$var$isArrayBufferView(body))) this._bodyArrayBuffer = $b8e30b448f738d08$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($b8e30b448f738d08$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($b8e30b448f738d08$var$support.blob) this.blob = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $b8e30b448f738d08$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($b8e30b448f738d08$var$support.blob) return this.blob().then($b8e30b448f738d08$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $b8e30b448f738d08$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $b8e30b448f738d08$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($b8e30b448f738d08$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($b8e30b448f738d08$var$support.formData) this.formData = function() {
        return this.text().then($b8e30b448f738d08$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $b8e30b448f738d08$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $b8e30b448f738d08$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $b8e30b448f738d08$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $b8e30b448f738d08$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $b8e30b448f738d08$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.method = $b8e30b448f738d08$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $b8e30b448f738d08$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$b8e30b448f738d08$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $b8e30b448f738d08$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $b8e30b448f738d08$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $b8e30b448f738d08$var$parseHeaders(rawHeaders) {
    var headers = new $b8e30b448f738d08$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$7fa6c5b6f8193917.prototype);
function $b8e30b448f738d08$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $b8e30b448f738d08$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $b8e30b448f738d08$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$b8e30b448f738d08$var$Body.call($b8e30b448f738d08$export$9f633d56d7ec90d3.prototype);
$b8e30b448f738d08$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $b8e30b448f738d08$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$b8e30b448f738d08$export$9f633d56d7ec90d3.error = function() {
    var response = new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $b8e30b448f738d08$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$b8e30b448f738d08$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($b8e30b448f738d08$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $b8e30b448f738d08$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $b8e30b448f738d08$export$fe58bcf938607f6a = $b8e30b448f738d08$var$g.DOMException;
try {
    new $b8e30b448f738d08$export$fe58bcf938607f6a();
} catch (err) {
    $b8e30b448f738d08$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $b8e30b448f738d08$export$fe58bcf938607f6a.prototype.constructor = $b8e30b448f738d08$export$fe58bcf938607f6a;
}
function $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $b8e30b448f738d08$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $b8e30b448f738d08$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $b8e30b448f738d08$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $b8e30b448f738d08$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $b8e30b448f738d08$var$g.location.href ? $b8e30b448f738d08$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($b8e30b448f738d08$var$support.blob) xhr.responseType = 'blob';
            else if ($b8e30b448f738d08$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $b8e30b448f738d08$export$79b704688b15c0f4 || $b8e30b448f738d08$var$g.Headers && init.headers instanceof $b8e30b448f738d08$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($b8e30b448f738d08$var$normalizeName(name));
                xhr.setRequestHeader(name, $b8e30b448f738d08$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$b8e30b448f738d08$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$b8e30b448f738d08$var$g.fetch) {
    $b8e30b448f738d08$var$g.fetch = $b8e30b448f738d08$export$e7aa7bc5c1b3cfb3;
    $b8e30b448f738d08$var$g.Headers = $b8e30b448f738d08$export$79b704688b15c0f4;
    $b8e30b448f738d08$var$g.Request = $b8e30b448f738d08$export$7fa6c5b6f8193917;
    $b8e30b448f738d08$var$g.Response = $b8e30b448f738d08$export$9f633d56d7ec90d3;
}

});



parcelRegister("lFpSS", function(module, exports) {

$parcel$export(module.exports, "useMessageEvent", () => $915c9ab2db68b367$export$3cbbf1e81e2ecb39);

var $aAASp = parcelRequire("aAASp");
var $ggVl0 = parcelRequire("ggVl0");

var $eFcnR = parcelRequire("eFcnR");

var $2EUTa = parcelRequire("2EUTa");

var $6NLx9 = parcelRequire("6NLx9");

var $5uXOq = parcelRequire("5uXOq");

var $jlpHn = parcelRequire("jlpHn");

var $5CBu0 = parcelRequire("5CBu0");

var $cwNOk = parcelRequire("cwNOk");
const $915c9ab2db68b367$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $5CBu0.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $aAASp.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $eFcnR.useMessageContext)();
    const { placementId: placementId } = (0, $2EUTa.usePlacementContext)();
    const browserContext = (0, $ggVl0.usePostOfficeContext)();
    const recommendationContext = (0, $6NLx9.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $5uXOq.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $cwNOk.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $cwNOk.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $cwNOk.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $jlpHn.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClicked = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageDismissed = (0, $5uXOq.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $5uXOq.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $jlpHn.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $cwNOk.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};

});
parcelRegister("aAASp", function(module, exports) {

$parcel$export(module.exports, "createMessagePlacementValues", () => $f10601e680b01ce9$export$a28a0c048b24fc5a);
$parcel$export(module.exports, "MessagePlacementProvider", () => $f10601e680b01ce9$export$c7535f8ebc5b75a9);
$parcel$export(module.exports, "useMessagePlacementHooks", () => $f10601e680b01ce9$export$89f8e1f623d8f5ac);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $f10601e680b01ce9$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
	 * Subscribes a callback function to the pub-sub system.
	 * @param {Callback} subscriber - The callback function to subscribe.
	 * @returns A function to unsubscribe the callback.
	 */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
	 * Publishes the payload to all subscribed callbacks.
	 * @param {Callback} payload - The payload to publish to the subscribers.
	 */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $f10601e680b01ce9$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $f10601e680b01ce9$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $f10601e680b01ce9$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $5uXOq.createContext)($f10601e680b01ce9$export$a28a0c048b24fc5a());
const $f10601e680b01ce9$export$c7535f8ebc5b75a9 = $f10601e680b01ce9$export$ea58328f3ceee4d4.Provider;
const $f10601e680b01ce9$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)($f10601e680b01ce9$export$c7535f8ebc5b75a9, {
            value: $f10601e680b01ce9$export$a28a0c048b24fc5a(),
            children: children
        });
const $f10601e680b01ce9$export$89f8e1f623d8f5ac = ()=>(0, $5uXOq.useContext)($f10601e680b01ce9$export$ea58328f3ceee4d4);

});

parcelRegister("jlpHn", function(module, exports) {

$parcel$export(module.exports, "MessageLifecycleContextError", () => $2242ff7b9be7eb6a$export$12bb62b204112f55);
$parcel$export(module.exports, "MessageLifecycleClientError", () => $2242ff7b9be7eb6a$export$44f397e2afeb89e0);
class $2242ff7b9be7eb6a$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $2242ff7b9be7eb6a$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}

});

parcelRegister("5CBu0", function(module, exports) {

$parcel$export(module.exports, "MessageEventClient", () => $1119338145cb433f$export$ae86a6dabe385178);
const $1119338145cb433f$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("fS9d8"));
class $1119338145cb433f$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($1119338145cb433f$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $1119338145cb433f$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $1119338145cb433f$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}

});

parcelRegister("cwNOk", function(module, exports) {

$parcel$export(module.exports, "InAppMessageEventType", () => $7e8eb241b4b10053$export$b31ffc6f7c85f1b);
var $7e8eb241b4b10053$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});

});


parcelRegister("gcYBn", function(module, exports) {

$parcel$export(module.exports, "AdControlsFlag", () => $2cc23d5838ac8a0b$export$6eb98925a948bca3);

var $2OMIu = parcelRequire("2OMIu");

var $1D5Rp = parcelRequire("1D5Rp");
var $5Xt64 = parcelRequire("5Xt64");

var $jDpWv = parcelRequire("jDpWv");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");


var $ousew = parcelRequire("ousew");

var $6EO5n = parcelRequire("6EO5n");
const $2cc23d5838ac8a0b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER = 'post-office-ad-controls-flag-wrapper';
/**-Title--**/ const $2cc23d5838ac8a0b$var$titleContainerStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $2cc23d5838ac8a0b$var$Title = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $2cc23d5838ac8a0b$var$titleContainerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dismiss-flag.not-interested.title",
            defaultMessage: "Got it, thanks for letting us know",
            description: "The title for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
        })
    });
/**--Description--**/ const $2cc23d5838ac8a0b$var$Description = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.dismiss-flag.not-interested.subtitle",
        defaultMessage: "You won\u2019t see this here as often.",
        description: "The subtitle for a flag which is displayed when the Not Interested button is pressed. https://hello.atlassian.net/l/cp/ssoqm2Fq"
    });
/**--Confirm Icon--*/ const $2cc23d5838ac8a0b$var$ConfirmIcon = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jDpWv))), {
        label: "Success",
        primaryColor: `var(--ds-icon-success, ${(0, $a7f8c6b391092279$export$940e1f69e873f202)})`
    });
const $2cc23d5838ac8a0b$export$6eb98925a948bca3 = ({ messageInstanceId: messageInstanceId, onCloseFlag: onCloseFlag })=>{
    (0, $6EO5n.portalZIndexFix)($2cc23d5838ac8a0b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Xt64.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            id: $2cc23d5838ac8a0b$var$POST_OFFICE_AD_CONTROLS_FLAG_WRAPPER,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1D5Rp.default), {
                icon: /*#__PURE__*/ (0, $2OMIu.jsx)($2cc23d5838ac8a0b$var$ConfirmIcon, {}),
                title: /*#__PURE__*/ (0, $2OMIu.jsx)($2cc23d5838ac8a0b$var$Title, {}),
                description: /*#__PURE__*/ (0, $2OMIu.jsx)($2cc23d5838ac8a0b$var$Description, {}),
                id: messageInstanceId,
                onDismissed: ()=>onCloseFlag()
            }, messageInstanceId)
        })
    });
};

});
parcelRegister("6EO5n", function(module, exports) {

$parcel$export(module.exports, "portalZIndexFix", () => $fcf8daf0189e5246$export$cef2f5415067aeab);
const $fcf8daf0189e5246$var$collectionHas = (all, curr)=>{
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
};
const $fcf8daf0189e5246$var$findParentBySelector = (elm, selector)=>{
    const all = globalThis.document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$fcf8daf0189e5246$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
};
const $fcf8daf0189e5246$export$cef2f5415067aeab = (wrapperId)=>{
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    setTimeout(()=>{
        if (globalThis.document) {
            const modalContent = globalThis.document.getElementById(wrapperId);
            const portalSelector = '.atlaskit-portal';
            const parentPortal = $fcf8daf0189e5246$var$findParentBySelector(modalContent, portalSelector);
            if (parentPortal) parentPortal.setAttribute('style', 'z-index:900;');
        }
    });
// DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
};

});


parcelRegister("cW2cD", function(module, exports) {

$parcel$export(module.exports, "AdControlsDropdown", () => $d4b75d0bebb7f1ac$export$ba7539b3ac68f9f1);

var $2OMIu = parcelRequire("2OMIu");

var $1eETS = parcelRequire("1eETS");
var $3jAdT = parcelRequire("3jAdT");

var $ousew = parcelRequire("ousew");
const $d4b75d0bebb7f1ac$export$99f2c116e7ad8950 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label",
            defaultMessage: "Why am I seeing this?",
            description: "The text for the button which opens a modal showing the reasons a message has been displayed."
        })
    });
const $d4b75d0bebb7f1ac$export$80eb3e3679dfe382 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1eETS.default), {
        ...props,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.dropdown-item.not-interested.label",
            defaultMessage: "Not interested",
            description: "The text for the button which removes a message from a placement."
        })
    });
const $d4b75d0bebb7f1ac$export$ba7539b3ac68f9f1 = ({ onWhyAmISeeingThis: onWhyAmISeeingThis, onNotInterested: onNotInterested, showWhyAmISeeingThis: showWhyAmISeeingThis = true })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $3jAdT.default), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($d4b75d0bebb7f1ac$export$80eb3e3679dfe382, {
                testId: "ad-controls-dropdown-not-interested",
                onClick: onNotInterested
            }),
            showWhyAmISeeingThis && /*#__PURE__*/ (0, $2OMIu.jsx)($d4b75d0bebb7f1ac$export$99f2c116e7ad8950, {
                testId: "ad-controls-dropdown-why-am-I-seeing-this",
                onClick: onWhyAmISeeingThis
            })
        ]
    });

});

parcelRegister("c8sYW", function(module, exports) {

$parcel$export(module.exports, "WhyAmISeeingThisModal", () => $ae39476bd5885f57$export$b29014abf8076d54);
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $cNW3X = parcelRequire("cNW3X");

var $8zIDr = parcelRequire("8zIDr");

var $hordk = parcelRequire("hordk");
var $g1QfP = parcelRequire("g1QfP");
var $7CjwE = parcelRequire("7CjwE");
var $eUaFh = parcelRequire("eUaFh");
var $7Sb4G = parcelRequire("7Sb4G");
var $kW74I = parcelRequire("kW74I");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $6EO5n = parcelRequire("6EO5n");
const $ae39476bd5885f57$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT = 'why-am-i-seeing-this-modal-content';
const $ae39476bd5885f57$var$REASONS = [
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.default-reason.team-size",
        description: "the first reason for displaying the message to the customer: the size of the customer's team",
        defaultMessage: "the size of your team"
    }),
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
        id: "post-office.ad-controls.default-reason.existing-products",
        description: "the second reason for displaying the message to the customer: the customer's existing Atlassian products",
        defaultMessage: "your existing Atlassian products"
    })
];
const $ae39476bd5885f57$export$2b77a92f1a5ad772 = ({ children: children, isOpen: isOpen, onClose: onClose })=>{
    (0, $6EO5n.portalZIndexFix)($ae39476bd5885f57$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kW74I.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hordk.default), {
            shouldCloseOnEscapePress: true,
            onClose: onClose,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                id: $ae39476bd5885f57$var$WHY_AM_I_SEEING_THIS_MODAL_CONTENT,
                children: children
            })
        })
    });
};
const $ae39476bd5885f57$var$AcceptButton = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cNW3X.default), {
        appearance: "primary",
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.accept-button.label-ok",
            defaultMessage: "OK",
            description: "The text on the button that dismisses a modal which provides reasons a message has been displayed"
        })
    });
/*--Title--*/ const $ae39476bd5885f57$var$titleContainerStyles = (0, $2s57o.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $ae39476bd5885f57$var$Title = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $0yZbT.default), {
        xcss: $ae39476bd5885f57$var$titleContainerStyles,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.title",
            defaultMessage: "Why am I seeing this?",
            description: "The title for a modal that displays the reasons a message was displayed."
        })
    });
/*--Body--*/ const $ae39476bd5885f57$var$DefaultBody = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "post-office.ad-controls.reasons-modal.body",
            defaultMessage: "We think you'd find this relevant. This is based on:",
            description: "Explanation of why we think the message will be releavant to the customer."
        })
    });
const $ae39476bd5885f57$var$reasonsListStyles = null;
const $ae39476bd5885f57$var$ReasonsList = ({ reasons: reasons })=>/*#__PURE__*/ (0, $2OMIu.jsx)("ul", {
        className: (0, $bwpsq.default)([
            "_2mzu1wth _19bvv47k _19pkutpp"
        ]),
        children: reasons.map((reason, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)("li", {
                children: reason
            }, index))
    });
const $ae39476bd5885f57$var$privacyPolicyLinkWrapperStyles = null;
const $ae39476bd5885f57$export$fdd773f48aebb8ab = ({ onClick: onClick })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_19pkutpp"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8zIDr.default), {
            href: 'https://www.atlassian.com/legal/privacy-policy',
            target: "_blank",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "post-office.ad-controls.reasons-modal.privacy-policy-link.text",
                defaultMessage: "Learn more about your data privacy with Atlassian",
                description: "The text linking to Atlassian's privacy policy. https://hello.atlassian.net/l/cp/ssoqm2Fq"
            })
        })
    });
const $ae39476bd5885f57$var$ReasonsModalDefaultBody = ({ onClose: onClose, content: content, additionalAnalyticsAttributes: additionalAnalyticsAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'adControlsReasonsModal'
        }, {
            ...additionalAnalyticsAttributes
        });
    }, [
        fireAnalyticsEvent,
        additionalAnalyticsAttributes
    ]);
    const handleOnPrivacyPolicy = ()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'adControlsPrivacyPolicy'
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eUaFh.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7Sb4G.default), {
                    children: content?.title || /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$var$Title, {})
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g1QfP.default), {
                children: content?.body || /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        content?.message || /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$var$DefaultBody, {}),
                        content?.reasons || /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$var$ReasonsList, {
                            reasons: $ae39476bd5885f57$var$REASONS
                        }),
                        content?.privacyPolicy || /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$export$fdd773f48aebb8ab, {
                            onClick: ()=>handleOnPrivacyPolicy()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7CjwE.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$var$AcceptButton, {
                    onClick: onClose
                })
            })
        ]
    });
};
const $ae39476bd5885f57$export$b29014abf8076d54 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$export$2b77a92f1a5ad772, {
        isOpen: props.isOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($ae39476bd5885f57$var$ReasonsModalDefaultBody, {
            ...props
        })
    });
};

});




parcelRegister("kDiio", function(module, exports) {

$parcel$export(module.exports, "CTAButton", () => $197ffda1ed076d74$export$bd36621ef7814117);

var $2OMIu = parcelRequire("2OMIu");

var $2s57o = parcelRequire("2s57o");

var $01jOt = parcelRequire("01jOt");
const $197ffda1ed076d74$var$JOURNEY = 'get-started';
const $197ffda1ed076d74$var$SOURCE_COMPONENT = 'jira-side-nav';
const $197ffda1ed076d74$var$SOURCE_CONTEXT = 'tryItNow';
const $197ffda1ed076d74$var$ctaButtonStyles = (0, $2s57o.xcss)({
    color: 'color.link',
    backgroundColor: 'color.background.accent.blue.subtlest',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    paddingLeft: '0'
});
const $197ffda1ed076d74$export$bd36621ef7814117 = ({ app: app })=>{
    const crossflowOptions = {
        targetProduct: app.hamsIdentifier,
        journey: $197ffda1ed076d74$var$JOURNEY,
        sourceComponent: $197ffda1ed076d74$var$SOURCE_COMPONENT,
        sourceContext: $197ffda1ed076d74$var$SOURCE_CONTEXT
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $01jOt.CrossflowCtaPrimaryPressable), {
        crossflowOptions: crossflowOptions,
        ctaText: app.ctaMessage,
        pressableStyle: $197ffda1ed076d74$var$ctaButtonStyles
    });
};

});
parcelRegister("01jOt", function(module, exports) {

$parcel$export(module.exports, "CrossflowCtaPrimaryLinkButton", () => $3d7c975e019cf03d$export$55d6f395fee83ac9);
$parcel$export(module.exports, "CrossflowCtaPrimaryPressable", () => $3d7c975e019cf03d$export$585a4ef79f2a8b77);
$parcel$export(module.exports, "CrossflowCtaSecondaryPressable", () => $3d7c975e019cf03d$export$ba0dce35a480e0b4);

var $2OMIu = parcelRequire("2OMIu");

var $bMFGq = parcelRequire("bMFGq");

var $gVM6m = parcelRequire("gVM6m");

var $cZHiK = parcelRequire("cZHiK");
const $3d7c975e019cf03d$var$PRIMARY_LINK_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $3d7c975e019cf03d$export$55d6f395fee83ac9 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, appearance: appearance, alt: alt })=>{
    const { handleClick: handleClick } = (0, $cZHiK.useCrossflowMessageClicked)(crossflowOptions, $3d7c975e019cf03d$var$PRIMARY_LINK_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bMFGq.default), {
        onClick: handleClick,
        appearance: appearance,
        "aria-label": alt,
        children: ctaText
    });
};
const $3d7c975e019cf03d$var$PRIMARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'primary'
};
const $3d7c975e019cf03d$export$585a4ef79f2a8b77 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $cZHiK.useCrossflowMessageClicked)(crossflowOptions, $3d7c975e019cf03d$var$PRIMARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};
const $3d7c975e019cf03d$var$SECONDARY_BUTTON_CLICKED_ELEMENT = {
    clickIdentifier: 'cta',
    clickedElement: 'button',
    buttonType: 'secondary'
};
const $3d7c975e019cf03d$export$ba0dce35a480e0b4 = ({ crossflowOptions: crossflowOptions, ctaText: ctaText, pressableStyle: pressableStyle, alt: alt })=>{
    const { handleClick: handleClick } = (0, $cZHiK.useCrossflowMessageClicked)(crossflowOptions, $3d7c975e019cf03d$var$SECONDARY_BUTTON_CLICKED_ELEMENT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gVM6m.default), {
        onClick: handleClick,
        xcss: pressableStyle,
        "aria-label": alt,
        children: ctaText
    });
};

});
parcelRegister("cZHiK", function(module, exports) {

$parcel$export(module.exports, "useCrossflowMessageClicked", () => $f18462ae672bad59$export$1c3f82bc53516a2a);

var $Q9DHJ = parcelRequire("Q9DHJ");

var $bpU8k = parcelRequire("bpU8k");

var $lFpSS = parcelRequire("lFpSS");

var $5uXOq = parcelRequire("5uXOq");
const $f18462ae672bad59$export$1c3f82bc53516a2a = (crossflowOptions, clickedElement)=>{
    const crossflow = (0, $Q9DHJ.useCrossFlow)();
    const { messageClicked: messageClicked } = (0, $lFpSS.useMessageEvent)();
    const { messageInstanceClicked: messageInstanceClicked } = (0, $bpU8k.useMessageInstanceEvent)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        messageClicked().catch(()=>{});
        messageInstanceClicked({
            messageEventType: 'clicked',
            clickedElement: clickedElement,
            action: {
                actionType: 'acknowledge'
            },
            additionalMetadataFromFrontend: {}
        }).catch(()=>{});
        if (crossflow.isEnabled) crossflow.api.open(crossflowOptions).catch(()=>{});
    }, [
        crossflow,
        crossflowOptions,
        clickedElement,
        messageClicked,
        messageInstanceClicked
    ]);
    return {
        handleClick: handleClick
    };
};

});




parcelRegister("hcAYG", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $7133caef70b7a1a0$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $7133caef70b7a1a0$export$78c758434c34d601, createValidate: $7133caef70b7a1a0$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $7133caef70b7a1a0$export$c905bc718befd59b, createHydrateExample: $7133caef70b7a1a0$export$1f41223e5b0a6622, createTransformMetadata: $7133caef70b7a1a0$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});
parcelRegister("6ifjo", function(module, exports) {

$parcel$export(module.exports, "createServerPipeline", () => $91375a40b26a6041$export$b8fedcd4634de5cd);
$parcel$export(module.exports, "createClientPipeline", () => $91375a40b26a6041$export$7d57dbe7f7617174);

var $2OMIu = parcelRequire("2OMIu");

var $j7YDj = parcelRequire("j7YDj");
const $91375a40b26a6041$export$7693b71d48f1bf7e = ()=>(render)=>(renderProps)=>{
            const rendered = render(renderProps);
            return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7YDj.MessageViewed), {}),
                    rendered
                ]
            });
        };
const $91375a40b26a6041$export$b4a84c754a962eee = ()=>(transformMetadata)=>(params)=>transformMetadata(params);
const $91375a40b26a6041$export$62864968b8b09cdf = ()=>(hydrate)=>(requestContext, placementContext, messageContext)=>hydrate(requestContext, placementContext, messageContext);
const $91375a40b26a6041$var$exampleHydrator = (hydrateExample, config)=>(_requestContext, placementContext, messageContext)=>{
        const _config = config;
        return {
            ...hydrateExample({
                ..._config?.requestContext ?? {}
            }, placementContext, messageContext),
            ..._config?.additionalRenderProps ?? {}
        };
    };
const $91375a40b26a6041$export$803c53721d530406 = ()=>(hydrateExample, config)=>$91375a40b26a6041$var$exampleHydrator(hydrateExample, config);
const $91375a40b26a6041$var$initializeValidate = ()=>(validate)=>(apiResponse)=>{
            try {
                validate(apiResponse);
            } catch (error) {
                throw error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Unknown validation error');
            }
            return apiResponse;
        };
const $91375a40b26a6041$export$b8fedcd4634de5cd = ()=>({
        createHydrate: $91375a40b26a6041$export$62864968b8b09cdf(),
        createHydrateExample: $91375a40b26a6041$export$803c53721d530406(),
        createTransformMetadata: $91375a40b26a6041$export$b4a84c754a962eee()
    });
const $91375a40b26a6041$export$7d57dbe7f7617174 = ()=>({
        createValidate: $91375a40b26a6041$var$initializeValidate(),
        createRender: $91375a40b26a6041$export$7693b71d48f1bf7e()
    });

});
parcelRegister("j7YDj", function(module, exports) {

$parcel$export(module.exports, "ManualMessageViewedEvent", () => $0279287873867410$export$de534803cb07dfcc);
$parcel$export(module.exports, "MessageViewed", () => $0279287873867410$export$14fe1fc3395b6e3f);

var $2OMIu = parcelRequire("2OMIu");

var $bpU8k = parcelRequire("bpU8k");

var $lFpSS = parcelRequire("lFpSS");

var $5uXOq = parcelRequire("5uXOq");

var $huaDn = parcelRequire("huaDn");

var $cxwD2 = parcelRequire("cxwD2");

var $2x1bx = parcelRequire("2x1bx");
const $0279287873867410$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $cxwD2.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};
const $0279287873867410$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $cxwD2.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $lFpSS.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bpU8k.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $5uXOq.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2x1bx.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $0279287873867410$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $5uXOq.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $bpU8k.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $huaDn.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $5uXOq.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $5uXOq.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $2OMIu.jsx)($0279287873867410$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};

});
parcelRegister("huaDn", function(module, exports) {

$parcel$export(module.exports, "useInViewport", () => $cbad7cb89a03ebf8$export$6215040b989f9b0f, (v) => $cbad7cb89a03ebf8$export$6215040b989f9b0f = v);
var $cbad7cb89a03ebf8$export$1e511d4a378977f5;
var $cbad7cb89a03ebf8$export$6215040b989f9b0f;
var $cbad7cb89a03ebf8$export$436b63fa4855237f;
var $cbad7cb89a03ebf8$export$2e2bcd8739ae039;
var $cbad7cb89a03ebf8$export$95cef81be5ddcfd4;
"use strict";
$cbad7cb89a03ebf8$export$1e511d4a378977f5 = true;
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = void 0;

var $cbad7cb89a03ebf8$var$_handleViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("T3qHg")));
$cbad7cb89a03ebf8$export$436b63fa4855237f = $cbad7cb89a03ebf8$var$_handleViewport.default;

var $cbad7cb89a03ebf8$var$_useInViewport = $cbad7cb89a03ebf8$var$_interopRequireDefault((parcelRequire("3FJrj")));
$cbad7cb89a03ebf8$export$6215040b989f9b0f = $cbad7cb89a03ebf8$var$_useInViewport.default;
function $cbad7cb89a03ebf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $cbad7cb89a03ebf8$var$customProps = $cbad7cb89a03ebf8$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $cbad7cb89a03ebf8$var$_default = $cbad7cb89a03ebf8$export$2e2bcd8739ae039 = $cbad7cb89a03ebf8$var$_handleViewport.default;

});
parcelRegister("T3qHg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0a57cc36f8cb8118$export$1e511d4a378977f5, (v) => $0a57cc36f8cb8118$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0a57cc36f8cb8118$export$2e2bcd8739ae039, (v) => $0a57cc36f8cb8118$export$2e2bcd8739ae039 = v);
var $0a57cc36f8cb8118$export$1e511d4a378977f5;
var $0a57cc36f8cb8118$export$2e2bcd8739ae039;
"use strict";
$0a57cc36f8cb8118$export$1e511d4a378977f5 = true;
$0a57cc36f8cb8118$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $0a57cc36f8cb8118$var$_hoistNonReactStatics = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("dY8Js")));

var $0a57cc36f8cb8118$var$_useInViewport = $0a57cc36f8cb8118$var$_interopRequireDefault((parcelRequire("3FJrj")));

var $1aHjR = parcelRequire("1aHjR");

var $2OMIu = parcelRequire("2OMIu");
var $0a57cc36f8cb8118$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $0a57cc36f8cb8118$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0a57cc36f8cb8118$var$_extends() {
    return $0a57cc36f8cb8118$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0a57cc36f8cb8118$var$_extends.apply(null, arguments);
}
function $0a57cc36f8cb8118$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)(TargetComponent, $0a57cc36f8cb8118$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $1aHjR.noop, onLeaveViewport: onLeaveViewport = $1aHjR.noop } = _ref, restProps = $0a57cc36f8cb8118$var$_objectWithoutPropertiesLoose(_ref, $0a57cc36f8cb8118$var$_excluded);
        var node = (0, $5uXOq.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $0a57cc36f8cb8118$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $0a57cc36f8cb8118$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ForwardedRefComponent, $0a57cc36f8cb8118$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $0a57cc36f8cb8118$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $0a57cc36f8cb8118$var$_default = $0a57cc36f8cb8118$export$2e2bcd8739ae039 = $0a57cc36f8cb8118$var$handleViewport;

});
parcelRegister("3FJrj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $2ac872c90dc0d9fc$export$1e511d4a378977f5, (v) => $2ac872c90dc0d9fc$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2ac872c90dc0d9fc$export$2e2bcd8739ae039, (v) => $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = v);
var $2ac872c90dc0d9fc$export$1e511d4a378977f5;
var $2ac872c90dc0d9fc$export$2e2bcd8739ae039;
"use strict";
$2ac872c90dc0d9fc$export$1e511d4a378977f5 = true;
$2ac872c90dc0d9fc$export$2e2bcd8739ae039 = void 0;

var $5uXOq = parcelRequire("5uXOq");

var $1aHjR = parcelRequire("1aHjR");
var $2ac872c90dc0d9fc$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $2ac872c90dc0d9fc$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $1aHjR.defaultOptions;
    if (config === void 0) config = $1aHjR.defaultConfig;
    if (props === void 0) props = $1aHjR.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $5uXOq.useState)();
    var observer = (0, $5uXOq.useRef)();
    var inViewportRef = (0, $5uXOq.useRef)(false);
    var intersected = (0, $5uXOq.useRef)(false);
    var enterCountRef = (0, $5uXOq.useRef)(0);
    var leaveCountRef = (0, $5uXOq.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $5uXOq.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $5uXOq.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $5uXOq.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $2ac872c90dc0d9fc$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $2ac872c90dc0d9fc$var$_default = $2ac872c90dc0d9fc$export$2e2bcd8739ae039 = $2ac872c90dc0d9fc$var$useInViewport;

});
parcelRegister("1aHjR", function(module, exports) {

$parcel$export(module.exports, "noop", () => $0da853e95098c517$export$8793edee2d425525, (v) => $0da853e95098c517$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $0da853e95098c517$export$9c21a3269931e1e6, (v) => $0da853e95098c517$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $0da853e95098c517$export$ba43bf67f3d48107, (v) => $0da853e95098c517$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $0da853e95098c517$export$f84bd70098573c5c, (v) => $0da853e95098c517$export$f84bd70098573c5c = v);
var $0da853e95098c517$export$1e511d4a378977f5;
var $0da853e95098c517$export$8793edee2d425525;
var $0da853e95098c517$export$9c21a3269931e1e6;
var $0da853e95098c517$export$ba43bf67f3d48107;
var $0da853e95098c517$export$f84bd70098573c5c;
"use strict";
$0da853e95098c517$export$1e511d4a378977f5 = true;
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$export$9c21a3269931e1e6 = $0da853e95098c517$export$ba43bf67f3d48107 = $0da853e95098c517$export$f84bd70098573c5c = void 0;
var $0da853e95098c517$var$defaultOptions = $0da853e95098c517$export$ba43bf67f3d48107 = {};
var $0da853e95098c517$var$defaultConfig = $0da853e95098c517$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $0da853e95098c517$var$noop = ()=>{};
$0da853e95098c517$export$8793edee2d425525 = $0da853e95098c517$var$noop;
var $0da853e95098c517$var$defaultProps = $0da853e95098c517$export$9c21a3269931e1e6 = {
    onEnterViewport: $0da853e95098c517$var$noop,
    onLeaveViewport: $0da853e95098c517$var$noop
};

});








parcelRegister("7eaZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c10cdc023db1b2a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $j7leM = parcelRequire("j7leM");

var $h1mmH = parcelRequire("h1mmH");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $e3b9C = parcelRequire("e3b9C");
const $0c10cdc023db1b2a$var$CCP_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';
const $0c10cdc023db1b2a$var$HAMS_PRODUCT_ID = 'jira-product-discovery';
const $0c10cdc023db1b2a$var$PRODUCT_NAME = 'Jira Product Discovery';
const $0c10cdc023db1b2a$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jpd.reasons-modal.message",
            defaultMessage: "We think {jpd} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JPD recommendation will be relevant to the customer.",
            values: {
                jpd: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $0c10cdc023db1b2a$var$PRODUCT_NAME
                })
            }
        })
    })
};
const $0c10cdc023db1b2a$export$b3890eb0ae9dca99 = (0, $e3b9C.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mmH.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $0c10cdc023db1b2a$var$HAMS_PRODUCT_ID,
            ccpProductId: $0c10cdc023db1b2a$var$CCP_PRODUCT_ID,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7leM.JiraProductDiscoveryIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jpd.product-name.header",
                description: "Header for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Transform insights into action plans"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jpd.cta.label",
                description: "CTA text for Jira Product Discovery recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Product Discovery"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $0c10cdc023db1b2a$var$whyAmISeeingThisModalContent
    }));
var $0c10cdc023db1b2a$export$2e2bcd8739ae039 = $0c10cdc023db1b2a$export$b3890eb0ae9dca99;

});
parcelRegister("e3b9C", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $9c4e56158ac98b29$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $9c4e56158ac98b29$export$78c758434c34d601, createValidate: $9c4e56158ac98b29$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $9c4e56158ac98b29$export$c905bc718befd59b, createHydrateExample: $9c4e56158ac98b29$export$1f41223e5b0a6622, createTransformMetadata: $9c4e56158ac98b29$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});


parcelRegister("15JO3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4742ab4d259041aa$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $ds5Yo = parcelRequire("ds5Yo");

var $h1mmH = parcelRequire("h1mmH");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $75fKs = parcelRequire("75fKs");
const $4742ab4d259041aa$export$3678c6c473f30928 = 'de63a248-1f93-46ed-b6ea-ab8e38af1c88';
const $4742ab4d259041aa$export$5fca8a2477be63d = 'jira-servicedesk.ondemand';
const $4742ab4d259041aa$var$PRODUCT_NAME = 'Jira Service Management';
const $4742ab4d259041aa$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jsm.reasons-modal.message",
            defaultMessage: "We think {jsm} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the JSM recommendation will be relevant to the customer.",
            values: {
                jsm: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: $4742ab4d259041aa$var$PRODUCT_NAME
                })
            }
        })
    })
};
const $4742ab4d259041aa$export$b3890eb0ae9dca99 = (0, $75fKs.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mmH.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: $4742ab4d259041aa$export$5fca8a2477be63d,
            ccpProductId: $4742ab4d259041aa$export$3678c6c473f30928,
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ds5Yo.JiraServiceManagementIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsm.product-name.header",
                description: "Header for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Automate workflows for faster resolutions"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsm.cta.label",
                description: "CTA text for Jira Service Management recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira Service Management"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $4742ab4d259041aa$var$whyAmISeeingThisModalContent
    }));
var $4742ab4d259041aa$export$2e2bcd8739ae039 = $4742ab4d259041aa$export$b3890eb0ae9dca99;

});
parcelRegister("75fKs", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $5b01277b27653336$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $5b01277b27653336$export$78c758434c34d601, createValidate: $5b01277b27653336$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $5b01277b27653336$export$c905bc718befd59b, createHydrateExample: $5b01277b27653336$export$1f41223e5b0a6622, createTransformMetadata: $5b01277b27653336$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});


parcelRegister("brwZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $63de7ca9b11c3f37$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $39fIG = parcelRequire("39fIG");

var $h1mmH = parcelRequire("h1mmH");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $12Eaa = parcelRequire("12Eaa");

const $63de7ca9b11c3f37$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-jsw-visualize-work.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Jira recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: (0, $4ae8b60cfb06f9bb$export$a75e537c279a265a)
                })
            }
        })
    })
};
const $63de7ca9b11c3f37$export$b3890eb0ae9dca99 = (0, $12Eaa.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mmH.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $4ae8b60cfb06f9bb$export$5fca8a2477be63d),
            ccpProductId: (0, $4ae8b60cfb06f9bb$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $39fIG.JiraIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsw-visualize-work.product-name.header",
                description: "Header for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Visualize your projects in lists, boards, and more"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-jsw-visualize-work.cta.label",
                description: "CTA text for Jira recommendation message in Jira Side Nav",
                defaultMessage: "Try Jira"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $63de7ca9b11c3f37$var$whyAmISeeingThisModalContent
    }));
var $63de7ca9b11c3f37$export$2e2bcd8739ae039 = $63de7ca9b11c3f37$export$b3890eb0ae9dca99;

});
parcelRegister("12Eaa", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $7efd671575828a99$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $7efd671575828a99$export$78c758434c34d601, createValidate: $7efd671575828a99$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $7efd671575828a99$export$c905bc718befd59b, createHydrateExample: $7efd671575828a99$export$1f41223e5b0a6622, createTransformMetadata: $7efd671575828a99$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});

const $4ae8b60cfb06f9bb$export$3678c6c473f30928 = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';
const $4ae8b60cfb06f9bb$export$5fca8a2477be63d = 'jira-software.ondemand';
const $4ae8b60cfb06f9bb$export$a75e537c279a265a = 'Jira';


parcelRegister("9HzUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf3282d60aa9623$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $9jZg7 = parcelRequire("9jZg7");

var $h1mmH = parcelRequire("h1mmH");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kW2Ke = parcelRequire("kW2Ke");

const $9bf3282d60aa9623$var$whyAmISeeingThisModalContent = {
    message: /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            id: "growth.recommendation-loom.reasons-modal.message",
            defaultMessage: "We think {product} will improve your team's productivity. The recommendation is based on:",
            description: "Explanation of why we think the Loom recommendation will be relevant to the customer.",
            values: {
                product: /*#__PURE__*/ (0, $2OMIu.jsx)("strong", {
                    children: (0, $243a484d02bb6512$export$a75e537c279a265a)
                })
            }
        })
    })
};
const $9bf3282d60aa9623$export$b3890eb0ae9dca99 = (0, $kW2Ke.createRender)(({ onDismissed: onDismissed })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h1mmH.JiraSideNavFirstPartyRecommendation), {
        app: {
            hamsIdentifier: (0, $243a484d02bb6512$export$5fca8a2477be63d),
            ccpProductId: (0, $243a484d02bb6512$export$3678c6c473f30928),
            logo: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9jZg7.LoomIcon), {
                appearance: "brand"
            }),
            header: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-loom.product-name.header",
                description: "Header for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Record and share videos easily"
            }),
            ctaMessage: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                id: "growth.recommendation-loom.cta.label",
                description: "CTA text for Loom recommendation message in Jira Side Nav",
                defaultMessage: "Try Loom"
            })
        },
        onDismissed: onDismissed,
        whyAmISeeingThisModalContent: $9bf3282d60aa9623$var$whyAmISeeingThisModalContent
    }));
var $9bf3282d60aa9623$export$2e2bcd8739ae039 = $9bf3282d60aa9623$export$b3890eb0ae9dca99;

});
parcelRegister("9jZg7", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", () => $da825721c5ac0541$export$8d789f76fde3e05);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $6VxGE = parcelRequire("6VxGE");

var $kpt43 = parcelRequire("kpt43");

var $2uZGe = parcelRequire("2uZGe");

var $j62qJ = parcelRequire("j62qJ");
const $da825721c5ac0541$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $2uZGe.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $da825721c5ac0541$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $kpt43.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $kpt43.defaultLogoParams).iconColor, textColor: textColor = (0, $kpt43.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $6VxGE.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j62qJ.default), {
        appearance: appearance,
        label: label,
        svg: $da825721c5ac0541$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kW2Ke", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $5501183dab19abb8$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $5501183dab19abb8$export$78c758434c34d601, createValidate: $5501183dab19abb8$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $5501183dab19abb8$export$c905bc718befd59b, createHydrateExample: $5501183dab19abb8$export$1f41223e5b0a6622, createTransformMetadata: $5501183dab19abb8$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});

const $243a484d02bb6512$export$ea76e6b040284832 = 'loom';
const $243a484d02bb6512$export$5fca8a2477be63d = 'loom';
const $243a484d02bb6512$export$a75e537c279a265a = 'Loom';
const $243a484d02bb6512$export$3678c6c473f30928 = '7683a73e-423d-41a1-b43f-d497656f8b5d';



parcelRegister("4Y2M3", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a80f13a1fc2149$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $lPRxf = parcelRequire("lPRxf");
var $52a80f13a1fc2149$export$2e2bcd8739ae039 = {
    'onboarding-import-nudge': (0, $lPRxf.default)
};

});
parcelRegister("lPRxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $687a17067d0e8ce7$export$2e2bcd8739ae039);
/* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $2OMIu = parcelRequire("2OMIu");

var $fmB2z = parcelRequire("fmB2z");
const $687a17067d0e8ce7$export$b3890eb0ae9dca99 = (0, $fmB2z.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        children: `Hello world!`
    }));
var $687a17067d0e8ce7$export$2e2bcd8739ae039 = $687a17067d0e8ce7$export$b3890eb0ae9dca99;

});
parcelRegister("fmB2z", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $d3248d9129211563$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $d3248d9129211563$export$78c758434c34d601, createValidate: $d3248d9129211563$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $d3248d9129211563$export$c905bc718befd59b, createHydrateExample: $d3248d9129211563$export$1f41223e5b0a6622, createTransformMetadata: $d3248d9129211563$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});



parcelRegister("g4Gy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdca80ed82ed6435$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $jWNMX = parcelRequire("jWNMX");
var $bdca80ed82ed6435$export$2e2bcd8739ae039 = {
    'message-template-template': (0, $jWNMX.default)
};

});
parcelRegister("jWNMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d14cd4a20b52006$export$2e2bcd8739ae039);
/* eslint-disable formatjs/no-literal-string-in-jsx */ 
var $2OMIu = parcelRequire("2OMIu");

var $cn24c = parcelRequire("cn24c");
const $2d14cd4a20b52006$export$b3890eb0ae9dca99 = (0, $cn24c.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        children: `Hello world!`
    }));
var $2d14cd4a20b52006$export$2e2bcd8739ae039 = $2d14cd4a20b52006$export$b3890eb0ae9dca99;

});
parcelRegister("cn24c", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $76cef7efcd3e9613$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $76cef7efcd3e9613$export$78c758434c34d601, createValidate: $76cef7efcd3e9613$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $76cef7efcd3e9613$export$c905bc718befd59b, createHydrateExample: $76cef7efcd3e9613$export$1f41223e5b0a6622, createTransformMetadata: $76cef7efcd3e9613$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});



parcelRegister("aMI06", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc6461beba71d94$export$2e2bcd8739ae039);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/ 
var $2i8Bw = parcelRequire("2i8Bw");
var $7cc6461beba71d94$export$2e2bcd8739ae039 = {
    'test-message-inapp': (0, $2i8Bw.default)
};

});
parcelRegister("2i8Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeaf921be4cf6f46$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $46A7b = parcelRequire("46A7b");
const $eeaf921be4cf6f46$export$b3890eb0ae9dca99 = (0, $46A7b.createRender)(()=>/*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        children: "This is an example test button"
    }));
var $eeaf921be4cf6f46$export$2e2bcd8739ae039 = $eeaf921be4cf6f46$export$b3890eb0ae9dca99;

});
parcelRegister("46A7b", function(module, exports) {

$parcel$export(module.exports, "createRender", () => $0062ddd89aaaf937$export$78c758434c34d601);

var $6ifjo = parcelRequire("6ifjo");
const { createRender: $0062ddd89aaaf937$export$78c758434c34d601, createValidate: $0062ddd89aaaf937$export$2859a83e4d6da57d } = (0, $6ifjo.createClientPipeline)();
const { createHydrate: $0062ddd89aaaf937$export$c905bc718befd59b, createHydrateExample: $0062ddd89aaaf937$export$1f41223e5b0a6622, createTransformMetadata: $0062ddd89aaaf937$export$88fe13b4d13f8423 } = (0, $6ifjo.createServerPipeline)();

});




/* GeneratedContentHash: 9c47655ae0da7c4a10425612f1be5cf9c57ec22e23c4d4b1e4a2589c469dc001 */ /*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $f9fe1349e81091e7$export$a5cfae247d8360ef = 'jira-side-nav';

parcelRegister("lDHLX", function(module, exports) {

$parcel$export(module.exports, "withJiraSideNavIntlProvider", () => $0e41a1bac2b4159c$export$6844f5e0cf66d318);
/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $lyW0g = parcelRequire("lyW0g");

var $5sgas = parcelRequire("5sgas");

var $JY3pb = parcelRequire("JY3pb");

var $fJUJM = parcelRequire("fJUJM");

var $kZ7Oy = parcelRequire("kZ7Oy");
const $0e41a1bac2b4159c$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $5sgas.messagesLoader)(locale),
        (0, $JY3pb.messagesLoader)(locale),
        (0, $fJUJM.messagesLoader)(locale),
        (0, $kZ7Oy.messagesLoader)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $0e41a1bac2b4159c$export$6844f5e0cf66d318 = (Component)=>{
    return (0, $lyW0g.withIntlProvider)({
        messagesLoader: $0e41a1bac2b4159c$export$d5a462ce7bd04520
    }, Component);
};

});
parcelRegister("lyW0g", function(module, exports) {

$parcel$export(module.exports, "withIntlProvider", () => $6c5d5073182ce361$export$a5d940130f33be3f);

var $2OMIu = parcelRequire("2OMIu");

var $2vvBP = parcelRequire("2vvBP");
const $6c5d5073182ce361$export$a5d940130f33be3f = (intlProviderProps, Component)=>({ preloadedMessages: preloadedMessages, ...props })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2vvBP.default), {
            ...intlProviderProps,
            messages: preloadedMessages,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                ...props
            })
        });
    };

});
parcelRegister("2vvBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6222cebaa5b6365a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $ddiyw = parcelRequire("ddiyw");

var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $f7cRw = parcelRequire("f7cRw");
function $6222cebaa5b6365a$var$useFetchLocale() {
    let locale = 'en';
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    try {
        const { locale: intlLocale } = (0, $koVbs.default)();
        locale = intlLocale;
    } catch (err) {
        fireAnalyticsEvent({
            action: 'errored',
            actionSubject: 'intlProvider',
            eventType: 'operational',
            attributes: {
                errorMessage: err
            }
        });
    }
    return {
        locale: locale
    };
}
function $6222cebaa5b6365a$export$2e2bcd8739ae039(props) {
    const { locale: locale } = $6222cebaa5b6365a$var$useFetchLocale();
    const messages = (0, $f7cRw.useIntlMessages)(locale, props.messagesLoader, props.messages);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: locale,
        messages: messages,
        children: props.children
    });
}

});
parcelRegister("f7cRw", function(module, exports) {

$parcel$export(module.exports, "useIntlMessages", () => $a208f595baafbf49$export$2641ec9a2025a81f);

var $ddiyw = parcelRequire("ddiyw");

var $5uXOq = parcelRequire("5uXOq");
const $a208f595baafbf49$export$2641ec9a2025a81f = (locale, messageLoader, initialMessages)=>{
    const [messages, setMessages] = (0, $5uXOq.useState)(initialMessages);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $ddiyw.useFirePostOfficeAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (initialMessages) return;
        messageLoader(locale).then((loadedMessages)=>{
            if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
            if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlMessagesLoader',
                eventType: 'operational',
                attributes: {
                    locale: locale,
                    errorMessage: loadedMessages.errors
                }
            });
        })// eslint-disable-next-line no-console
        .catch(console.error);
    }, [
        locale,
        initialMessages
    ]);
    return messages;
};

});



parcelRegister("5sgas", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $7d3c37c8709bff28$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dU7yi = parcelRequire("dU7yi");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7d3c37c8709bff28$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;































const $7d3c37c8709bff28$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("gD3HZ")));
        case 'da':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("c5uwD")));
        case 'de':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("eOnG5")));
        case 'en-GB':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2dEkS")));
        case 'en-US':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2639H")));
        case 'en-XA':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("lG42T")));
        case 'en-XB':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("f946f")));
        case 'en-ZZ':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2NuJP")));
        case 'en':
            return $7d3c37c8709bff28$var$importHelper(await Promise.resolve((parcelRequire("dU7yi"))));
        case 'es':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("9udOh")));
        case 'et':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("drIvG")));
        case 'fi':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("5ocfS")));
        case 'fr':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("2X4dh")));
        case 'hu':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("elkju")));
        case 'it':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("bZzmg")));
        case 'ja':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("k6ozU")));
        case 'ko':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("horFd")));
        case 'nb':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("ic586")));
        case 'nl':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("gVolN")));
        case 'pl':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("6F3S7")));
        case 'pt-BR':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("9784C")));
        case 'ro':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("6Unlx")));
        case 'ru':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("7KXwg")));
        case 'sv':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("kYvdD")));
        case 'th':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("dTOv7")));
        case 'tr':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("aHWYt")));
        case 'uk':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("lwjDR")));
        case 'vi':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("fY4tq")));
        case 'zh-CN':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("EUPUH")));
        case 'zh-TW':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("fqAld")));
        case 'zh':
            return $7d3c37c8709bff28$var$importHelper(await (parcelRequire("56ePW")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dU7yi));
    }
};

});
parcelRegister("dU7yi", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.admin-hub-recommendation.actions-heading":[{"type":0,"value":"Actions"}],"growth.admin-hub-recommendation.free-plan":[{"type":0,"value":"Free, cancel anytime"}],"growth.admin-hub-recommendation.heading":[{"type":0,"value":"Recommended based on your existing products"}],"growth.admin-hub-recommendation.plan-heading":[{"type":0,"value":"Plan"}],"growth.admin-hub-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.admin-hub-recommendation-value-proposition":[{"type":0,"value":"Plan and deliver all on the same platform"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.admin-hub-recommendation-value-prop":[{"type":0,"value":"Bring your developers, IT, and operations onto the same platform."}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-dynamic-description.value-proposition":[{"type":0,"value":"Plan, track, and organize any project"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name-for-use-case":[{"type":0,"value":"Screen recorder"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.value-proposition-for-use-case":[{"type":0,"value":"Record and share with an instant link"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"jpd.customRoadmapsPlacementHeader":[{"type":0,"value":"Custom roadmaps"}],"jpd.customRoadmapsPlacementTagLine":[{"type":0,"value":"Create and share high-level plans"}],"jpd.deliveryProgressPlacementHeader":[{"type":0,"value":"Delivery progress"}],"jpd.deliveryProgressPlacementTagLine":[{"type":0,"value":"Connect ideas to delivery status"}],"jpd.ideasAndPrioritiesPlacementHeader":[{"type":0,"value":"Ideas and priorities"}],"jpd.ideasAndPrioritiesPlacementTagLine":[{"type":0,"value":"Use RICE and data to prioritize ideas"}],"jpd.insightsAndIdeasPlacementHeader":[{"type":0,"value":"Insights and ideas"}],"jpd.insightsAndIdeasPlacementTagLine":[{"type":0,"value":"See ideas and feedback in one place"}],"jsm.assetsPlacementHeader":[{"type":0,"value":"Assets"}],"jsm.assetsPlacementTagLine":[{"type":0,"value":"Bring your enterprise assets together"}],"jsm.bugTrackingPlacementHeader":[{"type":0,"value":"Bug tracking"}],"jsm.bugTrackingPlacementTagLine":[{"type":0,"value":"Gather and resolve bugs in one place"}],"jsm.changeManagementPlacementHeader":[{"type":0,"value":"Change management"}],"jsm.changeManagementPlacementTagLine":[{"type":0,"value":"Create one place to manage changes"}],"jsm.customerServicePlacementHeader":[{"type":0,"value":"Customer service"}],"jsm.customerServicePlacementTagLine":[{"type":0,"value":"Help people get service and support"}],"jsm.helpDeskPlacementHeader":[{"type":0,"value":"Help desk"}],"jsm.helpDeskPlacementTagLine":[{"type":0,"value":"Receive requests and provide support"}],"jsm.issueManagementPlacementHeader":[{"type":0,"value":"Issue management"}],"jsm.issueManagementPlacementTagLine":[{"type":0,"value":"Capture and resolve issues"}],"jsm.onCallSchedulesPlacementHeader":[{"type":0,"value":"On-call schedules"}],"jsm.onCallSchedulesPlacementTagLine":[{"type":0,"value":"Create schedules, rotations, and more"}],"jsm.workRequestsPlacementHeader":[{"type":0,"value":"Work requests"}],"jsm.workRequestsPlacementTagLine":[{"type":0,"value":"Create one place to manage requests"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("gD3HZ", function(module, exports) {

let $c1b32a4a377309b5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1b32a4a377309b5$var$load("iOlnk").then(()=>parcelRequire('bQlUN'));

});

parcelRegister("c5uwD", function(module, exports) {

let $8ccda157f31ef721$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8ccda157f31ef721$var$load("kjB4S").then(()=>parcelRequire('1UEkc'));

});

parcelRegister("eOnG5", function(module, exports) {

let $ac881a19965142ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ac881a19965142ab$var$load("88iU8").then(()=>parcelRequire('ls6D6'));

});

parcelRegister("2dEkS", function(module, exports) {

let $19dc157a563efc24$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19dc157a563efc24$var$load("jTZeb").then(()=>parcelRequire('8QCI8'));

});

parcelRegister("2639H", function(module, exports) {

let $186e96e3d0f26f30$var$load = (parcelRequire("28QjX"))(4);
module.exports = $186e96e3d0f26f30$var$load("4a4SV").then(()=>parcelRequire('docQr'));

});

parcelRegister("lG42T", function(module, exports) {

let $fc80a89d47d25c53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc80a89d47d25c53$var$load("8iKip").then(()=>parcelRequire('aESw6'));

});

parcelRegister("f946f", function(module, exports) {

let $b06ae064fb65af65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b06ae064fb65af65$var$load("hGhmW").then(()=>parcelRequire('fHsGT'));

});

parcelRegister("2NuJP", function(module, exports) {

let $209800595bc038bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $209800595bc038bf$var$load("lHgWo").then(()=>parcelRequire('527kD'));

});

parcelRegister("9udOh", function(module, exports) {

let $6e81a0c159cc7645$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e81a0c159cc7645$var$load("e9K7A").then(()=>parcelRequire('itO8c'));

});

parcelRegister("drIvG", function(module, exports) {

let $9ca052ba688e7363$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9ca052ba688e7363$var$load("bEkDv").then(()=>parcelRequire('43dyL'));

});

parcelRegister("5ocfS", function(module, exports) {

let $3ec8b33aaf6526db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3ec8b33aaf6526db$var$load("b4T4f").then(()=>parcelRequire('5soOF'));

});

parcelRegister("2X4dh", function(module, exports) {

let $22645c1deea271fd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22645c1deea271fd$var$load("8zIAF").then(()=>parcelRequire('99QN5'));

});

parcelRegister("elkju", function(module, exports) {

let $a712c8a7233a32b6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a712c8a7233a32b6$var$load("bXCfz").then(()=>parcelRequire('3XnEp'));

});

parcelRegister("bZzmg", function(module, exports) {

let $8bb0d1925f7f5f9a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8bb0d1925f7f5f9a$var$load("dBuyA").then(()=>parcelRequire('lGfIU'));

});

parcelRegister("k6ozU", function(module, exports) {

let $ea276ee0e849fa41$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ea276ee0e849fa41$var$load("ivCKU").then(()=>parcelRequire('5vRyJ'));

});

parcelRegister("horFd", function(module, exports) {

let $ca9a23042cf9997b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca9a23042cf9997b$var$load("aW45P").then(()=>parcelRequire('7ZpXJ'));

});

parcelRegister("ic586", function(module, exports) {

let $d3ed53a3bfa1951a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d3ed53a3bfa1951a$var$load("3e3dr").then(()=>parcelRequire('4LBXw'));

});

parcelRegister("gVolN", function(module, exports) {

let $c524dbbdcc4effcf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c524dbbdcc4effcf$var$load("gNdh9").then(()=>parcelRequire('iiqFK'));

});

parcelRegister("6F3S7", function(module, exports) {

let $4d9993481a07647c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d9993481a07647c$var$load("3jfTc").then(()=>parcelRequire('1VIL4'));

});

parcelRegister("9784C", function(module, exports) {

let $6a2b07b9782325e6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a2b07b9782325e6$var$load("9Fqso").then(()=>parcelRequire('8gBDp'));

});

parcelRegister("6Unlx", function(module, exports) {

let $507a1529dee35089$var$load = (parcelRequire("28QjX"))(4);
module.exports = $507a1529dee35089$var$load("8yLyY").then(()=>parcelRequire('elxbR'));

});

parcelRegister("7KXwg", function(module, exports) {

let $5a5aff9e03c39611$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5a5aff9e03c39611$var$load("3A6dW").then(()=>parcelRequire('38qbF'));

});

parcelRegister("kYvdD", function(module, exports) {

let $f451a0a9105784c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f451a0a9105784c5$var$load("gPHZK").then(()=>parcelRequire('leI6s'));

});

parcelRegister("dTOv7", function(module, exports) {

let $a1e795ddbc91a3e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a1e795ddbc91a3e2$var$load("bPFgQ").then(()=>parcelRequire('jH5ke'));

});

parcelRegister("aHWYt", function(module, exports) {

let $7cbbaa9f2aedbb80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cbbaa9f2aedbb80$var$load("iuxQP").then(()=>parcelRequire('jrMkA'));

});

parcelRegister("lwjDR", function(module, exports) {

let $faabd29609d9d77b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $faabd29609d9d77b$var$load("eAuKg").then(()=>parcelRequire('hcrf5'));

});

parcelRegister("fY4tq", function(module, exports) {

let $b9ffedf68e46f95d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b9ffedf68e46f95d$var$load("jVK6j").then(()=>parcelRequire('hduFx'));

});

parcelRegister("EUPUH", function(module, exports) {

let $07afd30cb1b0f757$var$load = (parcelRequire("28QjX"))(4);
module.exports = $07afd30cb1b0f757$var$load("fcDu7").then(()=>parcelRequire('4XouL'));

});

parcelRegister("fqAld", function(module, exports) {

let $b3b5795082e56521$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b3b5795082e56521$var$load("9Xxsh").then(()=>parcelRequire('ajlMz'));

});

parcelRegister("56ePW", function(module, exports) {

let $3b69059443888267$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3b69059443888267$var$load("aWIjN").then(()=>parcelRequire('2QqTx'));

});


parcelRegister("JY3pb", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $a9903d3c652b0932$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fpG01 = parcelRequire("fpG01");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a9903d3c652b0932$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $a9903d3c652b0932$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("ebMt2")));
        case 'da':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("aTZBV")));
        case 'de':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("4fhgw")));
        case 'en-GB':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("e6gOq")));
        case 'en-US':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("1gBd0")));
        case 'en-XA':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("hNXYT")));
        case 'en-XB':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("8TxvP")));
        case 'en-ZZ':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("aQ6w6")));
        case 'en':
            return $a9903d3c652b0932$var$importHelper(await Promise.resolve((parcelRequire("fpG01"))));
        case 'es':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("jC5O5")));
        case 'et':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("eTeNR")));
        case 'fi':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("b2WEf")));
        case 'fr':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("hYPfH")));
        case 'hu':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("2Fq0r")));
        case 'it':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("akqL5")));
        case 'ja':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("3APJp")));
        case 'ko':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("90aPl")));
        case 'nb':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("lp37O")));
        case 'nl':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("9jnPh")));
        case 'pl':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("04Yvf")));
        case 'pt-BR':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("fHZKx")));
        case 'ro':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("hGQMe")));
        case 'ru':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("3UR2H")));
        case 'sv':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("i72kW")));
        case 'th':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("jIFpm")));
        case 'tr':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("5tye2")));
        case 'uk':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("g3zJv")));
        case 'vi':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("KZQ2p")));
        case 'zh-CN':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("4fFbA")));
        case 'zh-TW':
            return $a9903d3c652b0932$var$importHelper(await (parcelRequire("2zjYj")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fpG01));
    }
};

});
parcelRegister("fpG01", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("ebMt2", function(module, exports) {

let $a547b05a87800f84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a547b05a87800f84$var$load("7xNnL").then(()=>parcelRequire('bWiy4'));

});

parcelRegister("aTZBV", function(module, exports) {

let $7efed50f5f31a0f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7efed50f5f31a0f3$var$load("9p3mB").then(()=>parcelRequire('37lK4'));

});

parcelRegister("4fhgw", function(module, exports) {

let $3175f4b13df11cd6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3175f4b13df11cd6$var$load("PGjT0").then(()=>parcelRequire('l42Hy'));

});

parcelRegister("e6gOq", function(module, exports) {

let $a43eaad031feeccd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a43eaad031feeccd$var$load("fcZHF").then(()=>parcelRequire('et2UT'));

});

parcelRegister("1gBd0", function(module, exports) {

let $0ec425fa5b1d37b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0ec425fa5b1d37b0$var$load("7vxMB").then(()=>parcelRequire('29agH'));

});

parcelRegister("hNXYT", function(module, exports) {

let $cf658a4917e40938$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cf658a4917e40938$var$load("jVMFK").then(()=>parcelRequire('AZRSS'));

});

parcelRegister("8TxvP", function(module, exports) {

let $679d74a5e7daa89d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $679d74a5e7daa89d$var$load("kLAYA").then(()=>parcelRequire('46ZAq'));

});

parcelRegister("aQ6w6", function(module, exports) {

let $7e43d0cdfce25247$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7e43d0cdfce25247$var$load("iJO9F").then(()=>parcelRequire('2eSEs'));

});

parcelRegister("jC5O5", function(module, exports) {

let $e476120c28b6a62d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e476120c28b6a62d$var$load("bXHGn").then(()=>parcelRequire('hWr3u'));

});

parcelRegister("eTeNR", function(module, exports) {

let $ad71af5d9c2ab675$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ad71af5d9c2ab675$var$load("gMDGY").then(()=>parcelRequire('jgCER'));

});

parcelRegister("b2WEf", function(module, exports) {

let $80ad5fea3fafdf95$var$load = (parcelRequire("28QjX"))(4);
module.exports = $80ad5fea3fafdf95$var$load("lV3BZ").then(()=>parcelRequire('2lgNn'));

});

parcelRegister("hYPfH", function(module, exports) {

let $d16fcbe9a1df69d7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d16fcbe9a1df69d7$var$load("7jkin").then(()=>parcelRequire('gpyDO'));

});

parcelRegister("2Fq0r", function(module, exports) {

let $1f13955f3ba57c6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f13955f3ba57c6e$var$load("2Hzvl").then(()=>parcelRequire('hmMC0'));

});

parcelRegister("akqL5", function(module, exports) {

let $7850875150afc069$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7850875150afc069$var$load("fLYv7").then(()=>parcelRequire('7nMA6'));

});

parcelRegister("3APJp", function(module, exports) {

let $29dcdca8dd54089a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29dcdca8dd54089a$var$load("7eCIf").then(()=>parcelRequire('3vaeH'));

});

parcelRegister("90aPl", function(module, exports) {

let $68dc833513ebe230$var$load = (parcelRequire("28QjX"))(4);
module.exports = $68dc833513ebe230$var$load("3o5qP").then(()=>parcelRequire('b4hAx'));

});

parcelRegister("lp37O", function(module, exports) {

let $f94e5b577ec57303$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f94e5b577ec57303$var$load("eFFdO").then(()=>parcelRequire('djiyH'));

});

parcelRegister("9jnPh", function(module, exports) {

let $01bfe07ef9e8a49f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $01bfe07ef9e8a49f$var$load("cjMZO").then(()=>parcelRequire('2zg3E'));

});

parcelRegister("04Yvf", function(module, exports) {

let $00ef4e7461de6696$var$load = (parcelRequire("28QjX"))(4);
module.exports = $00ef4e7461de6696$var$load("ek9u8").then(()=>parcelRequire('as10K'));

});

parcelRegister("fHZKx", function(module, exports) {

let $b6fac55daed09b80$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6fac55daed09b80$var$load("aoHYM").then(()=>parcelRequire('4X6tE'));

});

parcelRegister("hGQMe", function(module, exports) {

let $ce0f4c4e8f4f0cfa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ce0f4c4e8f4f0cfa$var$load("iRArP").then(()=>parcelRequire('hoVj2'));

});

parcelRegister("3UR2H", function(module, exports) {

let $2d9fbf324d92b566$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2d9fbf324d92b566$var$load("dwiy1").then(()=>parcelRequire('jSlSE'));

});

parcelRegister("i72kW", function(module, exports) {

let $d2fab17f20ff345a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d2fab17f20ff345a$var$load("h5wUV").then(()=>parcelRequire('4XV0k'));

});

parcelRegister("jIFpm", function(module, exports) {

let $e5b23f2806a57042$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e5b23f2806a57042$var$load("19IgD").then(()=>parcelRequire('7NOPc'));

});

parcelRegister("5tye2", function(module, exports) {

let $3fca35a25c337112$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fca35a25c337112$var$load("5bw9s").then(()=>parcelRequire('3GF5C'));

});

parcelRegister("g3zJv", function(module, exports) {

let $bb08a4fa36f381d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb08a4fa36f381d1$var$load("6As4e").then(()=>parcelRequire('6kh2F'));

});

parcelRegister("KZQ2p", function(module, exports) {

let $08d443cb812a0b17$var$load = (parcelRequire("28QjX"))(4);
module.exports = $08d443cb812a0b17$var$load("eTvM6").then(()=>parcelRequire('lGxv4'));

});

parcelRegister("4fFbA", function(module, exports) {

let $318882cf9da0d3b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $318882cf9da0d3b8$var$load("n2qIN").then(()=>parcelRequire('9Ty4m'));

});

parcelRegister("2zjYj", function(module, exports) {

let $1dee57a3675faea2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1dee57a3675faea2$var$load("1r33e").then(()=>parcelRequire('c9D2G'));

});


parcelRegister("fJUJM", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $e662814fb82cdf34$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bZUHK = parcelRequire("bZUHK");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e662814fb82cdf34$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $e662814fb82cdf34$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("5AXCj")));
        case 'da':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("khTA5")));
        case 'de':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("9mRna")));
        case 'en-GB':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("e1SVQ")));
        case 'en-US':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6N3fx")));
        case 'en-XA':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("2Ctko")));
        case 'en-XB':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("dqAu2")));
        case 'en-ZZ':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("bqySC")));
        case 'en':
            return $e662814fb82cdf34$var$importHelper(await Promise.resolve((parcelRequire("bZUHK"))));
        case 'es':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fMzTR")));
        case 'et':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fI5Zq")));
        case 'fi':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6iui9")));
        case 'fr':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("lMW8m")));
        case 'hu':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("5ubwJ")));
        case 'it':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("iYqkj")));
        case 'ja':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("kC4Lp")));
        case 'ko':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("ghA7e")));
        case 'nb':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("e1JKl")));
        case 'nl':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("1XwIM")));
        case 'pl':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("leHHs")));
        case 'pt-BR':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("lj54n")));
        case 'ro':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6rIs0")));
        case 'ru':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("6ipoX")));
        case 'sv':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("htVCY")));
        case 'th':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("fwKNL")));
        case 'tr':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("krOcU")));
        case 'uk':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("iAh7o")));
        case 'vi':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("1Vpu8")));
        case 'zh-CN':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("jM2lN")));
        case 'zh-TW':
            return $e662814fb82cdf34$var$importHelper(await (parcelRequire("gIlyn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bZUHK));
    }
};

});
parcelRegister("bZUHK", function(module, exports) {
module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("5AXCj", function(module, exports) {

let $412e8f367e3232ab$var$load = (parcelRequire("28QjX"))(4);
module.exports = $412e8f367e3232ab$var$load("dyQbB").then(()=>parcelRequire('8TGXU'));

});

parcelRegister("khTA5", function(module, exports) {

let $ec508267a61f3b18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ec508267a61f3b18$var$load("32QYd").then(()=>parcelRequire('lWsj3'));

});

parcelRegister("9mRna", function(module, exports) {

let $6d1f91cdde5ca2f2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6d1f91cdde5ca2f2$var$load("4l7ZQ").then(()=>parcelRequire('grGfH'));

});

parcelRegister("e1SVQ", function(module, exports) {

let $a36bc5092acb7349$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a36bc5092acb7349$var$load("3d8Qb").then(()=>parcelRequire('drL7k'));

});

parcelRegister("6N3fx", function(module, exports) {

let $4f19d6ff16d87799$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4f19d6ff16d87799$var$load("1yDVc").then(()=>parcelRequire('7JbDo'));

});

parcelRegister("2Ctko", function(module, exports) {

let $1e85e14edbec266b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1e85e14edbec266b$var$load("2DU0q").then(()=>parcelRequire('aoD1a'));

});

parcelRegister("dqAu2", function(module, exports) {

let $9c6a00ec88d947c5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $9c6a00ec88d947c5$var$load("8cWT4").then(()=>parcelRequire('aRs4b'));

});

parcelRegister("bqySC", function(module, exports) {

let $851d2dd3f415fdeb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $851d2dd3f415fdeb$var$load("7o9pj").then(()=>parcelRequire('7RqNa'));

});

parcelRegister("fMzTR", function(module, exports) {

let $b7d72fb5d2802984$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b7d72fb5d2802984$var$load("e4Idr").then(()=>parcelRequire('2HMYZ'));

});

parcelRegister("fI5Zq", function(module, exports) {

let $b6ff9c81c74459fa$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b6ff9c81c74459fa$var$load("8mepu").then(()=>parcelRequire('dG47B'));

});

parcelRegister("6iui9", function(module, exports) {

let $495bebd2ea958386$var$load = (parcelRequire("28QjX"))(4);
module.exports = $495bebd2ea958386$var$load("dMRB2").then(()=>parcelRequire('15aZt'));

});

parcelRegister("lMW8m", function(module, exports) {

let $fdcb2cd6f0e21307$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fdcb2cd6f0e21307$var$load("kuElu").then(()=>parcelRequire('4xOJg'));

});

parcelRegister("5ubwJ", function(module, exports) {

let $3fe8b21bdf4122db$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3fe8b21bdf4122db$var$load("rE0x9").then(()=>parcelRequire('bZPwi'));

});

parcelRegister("iYqkj", function(module, exports) {

let $03908d6d7bf5af66$var$load = (parcelRequire("28QjX"))(4);
module.exports = $03908d6d7bf5af66$var$load("4Dwf2").then(()=>parcelRequire('i2rQL'));

});

parcelRegister("kC4Lp", function(module, exports) {

let $f01b0d3d5e186961$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f01b0d3d5e186961$var$load("c9qyC").then(()=>parcelRequire('byicS'));

});

parcelRegister("ghA7e", function(module, exports) {

let $bdaa3fb17fc3040e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bdaa3fb17fc3040e$var$load("kPmXi").then(()=>parcelRequire('6Crb3'));

});

parcelRegister("e1JKl", function(module, exports) {

let $a364a4fd3098a966$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a364a4fd3098a966$var$load("h8Me2").then(()=>parcelRequire('kAj5d'));

});

parcelRegister("1XwIM", function(module, exports) {

let $16d4aee7706a9721$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16d4aee7706a9721$var$load("9jpLq").then(()=>parcelRequire('bJDhT'));

});

parcelRegister("leHHs", function(module, exports) {

let $f75ccdb375a43784$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f75ccdb375a43784$var$load("ieQDS").then(()=>parcelRequire('jVGfH'));

});

parcelRegister("lj54n", function(module, exports) {

let $f82f4e0a20ee5fef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f82f4e0a20ee5fef$var$load("3yHdQ").then(()=>parcelRequire('eJMof'));

});

parcelRegister("6rIs0", function(module, exports) {

let $4b17beaf2dd0e82f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4b17beaf2dd0e82f$var$load("lcAhY").then(()=>parcelRequire('graEZ'));

});

parcelRegister("6ipoX", function(module, exports) {

let $495820c1744cf404$var$load = (parcelRequire("28QjX"))(4);
module.exports = $495820c1744cf404$var$load("hyioc").then(()=>parcelRequire('fTAyV'));

});

parcelRegister("htVCY", function(module, exports) {

let $cba1d8c0060ffbc9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cba1d8c0060ffbc9$var$load("avXYJ").then(()=>parcelRequire('3zrQg'));

});

parcelRegister("fwKNL", function(module, exports) {

let $b4de26012cfa1cfc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b4de26012cfa1cfc$var$load("hjAQK").then(()=>parcelRequire('3zK2p'));

});

parcelRegister("krOcU", function(module, exports) {

let $ee2d4660c617ef98$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee2d4660c617ef98$var$load("5O6ot").then(()=>parcelRequire('dbL6c'));

});

parcelRegister("iAh7o", function(module, exports) {

let $d878de16c3e324e2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d878de16c3e324e2$var$load("DQUYM").then(()=>parcelRequire('6vQva'));

});

parcelRegister("1Vpu8", function(module, exports) {

let $166ee2218b6f6f2b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $166ee2218b6f6f2b$var$load("bfhS3").then(()=>parcelRequire('5NDsz'));

});

parcelRegister("jM2lN", function(module, exports) {

let $e65452c91820d12f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e65452c91820d12f$var$load("dH62H").then(()=>parcelRequire('g9sed'));

});

parcelRegister("gIlyn", function(module, exports) {

let $c2b17976ef7f88ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c2b17976ef7f88ca$var$load("jynfz").then(()=>parcelRequire('c3H0z'));

});


parcelRegister("kZ7Oy", function(module, exports) {

$parcel$export(module.exports, "messagesLoader", () => $1269c265d489534a$export$720676d8cac8fbb);
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fHO1s = parcelRequire("fHO1s");

var $2AtjH = parcelRequire("2AtjH");
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1269c265d489534a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;






























const $1269c265d489534a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $2AtjH.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("fOgrq")));
        case 'da':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("efmlV")));
        case 'de':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3B3Ji")));
        case 'en-GB':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4Tr54")));
        case 'en-US':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("Eb7JP")));
        case 'en-XA':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("241wg")));
        case 'en-XB':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("8smiy")));
        case 'en-ZZ':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("6a2Vv")));
        case 'en':
            return $1269c265d489534a$var$importHelper(await Promise.resolve((parcelRequire("fHO1s"))));
        case 'es':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4uiXw")));
        case 'et':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3vFdG")));
        case 'fi':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("gaIkE")));
        case 'fr':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("fF5pV")));
        case 'hu':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("37bMy")));
        case 'it':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("98n09")));
        case 'ja':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("hTBB0")));
        case 'ko':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("jjM3Z")));
        case 'nb':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4LT4y")));
        case 'nl':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("j6kGJ")));
        case 'pl':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("lmzib")));
        case 'pt-BR':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4NUeB")));
        case 'ro':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("eYD1m")));
        case 'ru':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("5dSbb")));
        case 'sv':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("bJDUm")));
        case 'th':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("3cPmd")));
        case 'tr':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("bNJbb")));
        case 'uk':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("ioxF9")));
        case 'vi':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("foI7c")));
        case 'zh-CN':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("4KGtJ")));
        case 'zh-TW':
            return $1269c265d489534a$var$importHelper(await (parcelRequire("6DrnH")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fHO1s));
    }
};

});
parcelRegister("fHO1s", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message-digest-email-template.test-message.email.body.digest-title\":[{\"type\":0,\"value\":\"You have \"},{\"type\":1,\"value\":\"numberOfMsg\"},{\"type\":0,\"value\":\" new messages!\"}],\"post-office.test-message-digest-email-template.test-message.email.body.message-body\":[{\"type\":1,\"value\":\"defaultMessage\"}],\"post-office.test-message-microsoft-teams.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, this is test message from Post Office: \"},{\"type\":1,\"value\":\"text\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted test mobile push notification from post office.\"}],\"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a redacted mobile push notification test from post office.\"}],\"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.app-switcher-upgrade-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-upgrade-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Redacted Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-digest-email.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hey \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-digest-email.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. Here is your daily digest (rick) rollup for the \"},{\"type\":1,\"value\":\"site\"},{\"type\":0,\"value\":\" workspace\"}],\"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-ugc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate\":[{\"type\":0,\"value\":\"This is a redacted test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-message-failures.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-message-failures.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate\":[{\"type\":1,\"value\":\"greeting\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi,\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");

});

parcelRegister("fOgrq", function(module, exports) {

let $b8284774feb44180$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b8284774feb44180$var$load("9SoxW").then(()=>parcelRequire('cIJ7t'));

});

parcelRegister("efmlV", function(module, exports) {

let $a5f3ce2fe8500f6b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a5f3ce2fe8500f6b$var$load("bRKmQ").then(()=>parcelRequire('4BlC0'));

});

parcelRegister("3B3Ji", function(module, exports) {

let $29e7b865494dae74$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29e7b865494dae74$var$load("fBfPs").then(()=>parcelRequire('cWcaf'));

});

parcelRegister("4Tr54", function(module, exports) {

let $39014e2596c10076$var$load = (parcelRequire("28QjX"))(4);
module.exports = $39014e2596c10076$var$load("6qYbg").then(()=>parcelRequire('4LSMP'));

});

parcelRegister("Eb7JP", function(module, exports) {

let $078c5d7fa33382b7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $078c5d7fa33382b7$var$load("8xY1p").then(()=>parcelRequire('5c4St'));

});

parcelRegister("241wg", function(module, exports) {

let $180d2238743e2fa0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $180d2238743e2fa0$var$load("ihleU").then(()=>parcelRequire('FNCsh'));

});

parcelRegister("8smiy", function(module, exports) {

let $62823c3758afa475$var$load = (parcelRequire("28QjX"))(4);
module.exports = $62823c3758afa475$var$load("hPPLz").then(()=>parcelRequire('dM2yG'));

});

parcelRegister("6a2Vv", function(module, exports) {

let $47c5f26b3f2cbac1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47c5f26b3f2cbac1$var$load("9Dy0D").then(()=>parcelRequire('lvKzQ'));

});

parcelRegister("4uiXw", function(module, exports) {

let $3448aba5dc42c6ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3448aba5dc42c6ce$var$load("iTASK").then(()=>parcelRequire('hcDbV'));

});

parcelRegister("3vFdG", function(module, exports) {

let $28e43db2cb85b8d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $28e43db2cb85b8d9$var$load("cZJF7").then(()=>parcelRequire('7FNmp'));

});

parcelRegister("gaIkE", function(module, exports) {

let $bc5ff7ef3c17d95f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc5ff7ef3c17d95f$var$load("hlo4z").then(()=>parcelRequire('h7nPi'));

});

parcelRegister("fF5pV", function(module, exports) {

let $b66ee31aee6fa739$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b66ee31aee6fa739$var$load("bFahX").then(()=>parcelRequire('fjVt7'));

});

parcelRegister("37bMy", function(module, exports) {

let $244b2a363fdf4710$var$load = (parcelRequire("28QjX"))(4);
module.exports = $244b2a363fdf4710$var$load("af6La").then(()=>parcelRequire('jos5m'));

});

parcelRegister("98n09", function(module, exports) {

let $6a66b400b8bab102$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a66b400b8bab102$var$load("43bKP").then(()=>parcelRequire('5WuLD'));

});

parcelRegister("hTBB0", function(module, exports) {

let $d074bc7dedf1a94e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d074bc7dedf1a94e$var$load("4UXsQ").then(()=>parcelRequire('g8lYr'));

});

parcelRegister("jjM3Z", function(module, exports) {

let $e105131156beac37$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e105131156beac37$var$load("7eqQ5").then(()=>parcelRequire('jDutY'));

});

parcelRegister("4LT4y", function(module, exports) {

let $3796456e31430419$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3796456e31430419$var$load("ap9Z2").then(()=>parcelRequire('1JL7m'));

});

parcelRegister("j6kGJ", function(module, exports) {

let $de7ea017d5a0877e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de7ea017d5a0877e$var$load("lcXsH").then(()=>parcelRequire('50ncH'));

});

parcelRegister("lmzib", function(module, exports) {

let $f8d707567b2b6a7f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8d707567b2b6a7f$var$load("8Dtcb").then(()=>parcelRequire('icSuz'));

});

parcelRegister("4NUeB", function(module, exports) {

let $37f75c0eb7f92c84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $37f75c0eb7f92c84$var$load("dtMzo").then(()=>parcelRequire('5ggMx'));

});

parcelRegister("eYD1m", function(module, exports) {

let $ae74f008c9c9d2f3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ae74f008c9c9d2f3$var$load("drzY7").then(()=>parcelRequire('fIeJ4'));

});

parcelRegister("5dSbb", function(module, exports) {

let $3cd83191a8f20b53$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3cd83191a8f20b53$var$load("VPbvD").then(()=>parcelRequire('ifhWq'));

});

parcelRegister("bJDUm", function(module, exports) {

let $88b2da952badd698$var$load = (parcelRequire("28QjX"))(4);
module.exports = $88b2da952badd698$var$load("4Dgpf").then(()=>parcelRequire('dhiF2'));

});

parcelRegister("3cPmd", function(module, exports) {

let $255a5499e3bbcfea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $255a5499e3bbcfea$var$load("5knkb").then(()=>parcelRequire('aEI8u'));

});

parcelRegister("bNJbb", function(module, exports) {

let $89775100d2f33d32$var$load = (parcelRequire("28QjX"))(4);
module.exports = $89775100d2f33d32$var$load("lLdwH").then(()=>parcelRequire('5prwP'));

});

parcelRegister("ioxF9", function(module, exports) {

let $d644949d6f721ee5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d644949d6f721ee5$var$load("9L3MV").then(()=>parcelRequire('33SMQ'));

});

parcelRegister("foI7c", function(module, exports) {

let $b35b514086aa6861$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b35b514086aa6861$var$load("UnQhJ").then(()=>parcelRequire('gUEw4'));

});

parcelRegister("4KGtJ", function(module, exports) {

let $375c68a2000fb187$var$load = (parcelRequire("28QjX"))(4);
module.exports = $375c68a2000fb187$var$load("exOuq").then(()=>parcelRequire('bC1CY'));

});

parcelRegister("6DrnH", function(module, exports) {

let $4d4b9feeca8594d8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4d4b9feeca8594d8$var$load("cBYCT").then(()=>parcelRequire('e36el'));

});




parcelRegister("4yEIl", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $21214568f856c41e$export$fb465b6e855c1e85);
$parcel$export(module.exports, "PostOfficeRouterListener", () => $21214568f856c41e$export$9f8d3084fd3d5fc0);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $jp5kW = parcelRequire("jp5kW");

var $lpwtK = parcelRequire("lpwtK");

var $14XJw = parcelRequire("14XJw");

var $fY39E = parcelRequire("fY39E");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $cNd4s = parcelRequire("cNd4s");

var $DVljb = parcelRequire("DVljb");

var $3TYPx = parcelRequire("3TYPx");
var $keqfq = parcelRequire("keqfq");

var $doZTA = parcelRequire("doZTA");

var $adncp = parcelRequire("adncp");
const $21214568f856c41e$var$JiraPostOfficeProvider = ({ children: children })=>{
    const { data: data } = (0, $lpwtK.useProject)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const locale = (0, $DVljb.useLocale)();
    const environment = (0, $2tT7R.useEnvironment)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const editions = (0, $k9JTq.useAppEditions)();
    const subproduct = data?.type;
    const edition = (0, $adncp.subproductToEdition)(subproduct, editions);
    const context = (0, $5uXOq.useMemo)(()=>{
        return {
            current: {
                ...(0, $adncp.tenantToPostOfficeContext)({
                    activationId: activationId,
                    cloudId: cloudId,
                    isSiteAdmin: isSiteAdmin,
                    locale: locale
                }),
                orgId: orgId,
                productEdition: edition || undefined,
                subproduct: subproduct
            }
        };
    }, [
        cloudId,
        orgId,
        activationId,
        subproduct,
        isSiteAdmin,
        locale,
        edition
    ]);
    const env = (0, $5uXOq.useMemo)(()=>({
            env: (0, $adncp.transformJiraEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TYPx.PostOfficeProvider), {
        context: context,
        environment: env
    }, children);
};
const $21214568f856c41e$export$fb465b6e855c1e85 = ({ children: children })=>{
    // Using the Feature Gate used for the placement app-switcher-discovery-section because PostOfficeProvider is always needed when the app-switcher-discovery-section is enabled
    const isPostOfficeEnabled = !(0, $jp5kW.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "postOfficeJiraProvider",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$JiraPostOfficeProvider, null, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$var$ReactResourceRouterListener = ({ children: children })=>{
    const [route] = (0, $doZTA.useRouter)();
    (0, $keqfq.usePostOfficeRouteUpdate)([
        route.basePath,
        route.location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $21214568f856c41e$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    const isPostOfficeEnabled = !(0, $jp5kW.default)('killswitch_post_office_in_jira');
    return isPostOfficeEnabled && (0, $4R6GH.fg)('post-office-screen-space-overlay-jfe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21214568f856c41e$var$ReactResourceRouterListener, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("fY39E", function(module, exports) {

$parcel$export(module.exports, "useActivationId", () => $d72c67677898c114$export$43686faa787c943);

var $9OXo1 = parcelRequire("9OXo1");
const $d72c67677898c114$export$43686faa787c943 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.activationId;
};

});

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("3TYPx", function(module, exports) {

$parcel$export(module.exports, "PostOfficeProvider", () => $1a63e82e2d6ab167$export$fb465b6e855c1e85);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ggVl0 = parcelRequire("ggVl0");

var $k9ais = parcelRequire("k9ais");

var $keqfq = parcelRequire("keqfq");

var $iHQZs = parcelRequire("iHQZs");

var $j5kk0 = parcelRequire("j5kk0");

var $30kbx = parcelRequire("30kbx");

var $aAASp = parcelRequire("aAASp");

var $4FPR0 = parcelRequire("4FPR0");
const $1a63e82e2d6ab167$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
    const stableEnvironment = (0, $30kbx.useStableObject)((0, $4FPR0.generateEnvironmentConfigWithOverrides)((0, $k9ais.defaultEnvironmentValues), envWithOverrides));
    const stableContext = (0, $30kbx.useStableObject)($1a63e82e2d6ab167$var$composeConfig((0, $ggVl0.defaultPostOfficeContextValue), context.current));
    const memoizedMessagePlacementValues = (0, $5uXOq.useMemo)(()=>(0, $aAASp.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9ais.PostOfficeEnvironmentProvider), {
        value: stableEnvironment,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ggVl0.InternalPostOfficeContextProvider), {
            value: stableContext,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iHQZs.PostOfficeScreenContextProvider), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aAASp.MessagePlacementProvider), {
                    value: memoizedMessagePlacementValues,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $keqfq.RouteListenerProvider), {
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j5kk0.TriggerContextProvider), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $1a63e82e2d6ab167$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });

});
parcelRegister("keqfq", function(module, exports) {

$parcel$export(module.exports, "usePostOfficeRouteUpdate", () => $cb9c71bd126023f0$export$bb606326acdd1a64);
$parcel$export(module.exports, "RouteListenerProvider", () => $cb9c71bd126023f0$export$31986273b686f5ea);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bkD77 = parcelRequire("bkD77");

var $7LKoA = parcelRequire("7LKoA");
const $cb9c71bd126023f0$var$noop = ()=>{};
const $cb9c71bd126023f0$var$RouteListenerContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    update: $cb9c71bd126023f0$var$noop
});
const $cb9c71bd126023f0$export$7a2084f4baac29a7 = ()=>(0, $bkD77.createSimplePubSub)();
const $cb9c71bd126023f0$export$72fd8977abf03d60 = ()=>(0, $5uXOq.useContext)($cb9c71bd126023f0$var$RouteListenerContext);
const $cb9c71bd126023f0$export$755edb1665399d41 = ()=>{
    const ref = (0, $5uXOq.useRef)();
    if (!ref.current) ref.current = $cb9c71bd126023f0$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $5uXOq.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $5uXOq.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $cb9c71bd126023f0$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $cb9c71bd126023f0$export$72fd8977abf03d60();
    (0, $5uXOq.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $cb9c71bd126023f0$export$31986273b686f5ea = ({ children: children })=>{
    const [route, routeUpdater] = $cb9c71bd126023f0$export$755edb1665399d41();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($cb9c71bd126023f0$var$RouteListenerContext.Provider, {
        value: routeUpdater,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7LKoA.PostOfficeRouteProvider), {
            ...route,
            children: children
        })
    });
};

});
parcelRegister("bkD77", function(module, exports) {

$parcel$export(module.exports, "createSimplePubSub", () => $5a68086fa6118d51$export$92469b55607f005b);
const $5a68086fa6118d51$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};

});


parcelRegister("j5kk0", function(module, exports) {

$parcel$export(module.exports, "TriggerContextProvider", () => $af1a979995a7009c$export$e80a5720bb4c8fe3);
$parcel$export(module.exports, "useTrigger", () => $af1a979995a7009c$export$3b196fe93a948c18);
$parcel$export(module.exports, "useFirePostOfficeTrigger", () => $af1a979995a7009c$export$83b33e5fe4cce64);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $af1a979995a7009c$var$initialActiveTriggerState = {
    activeTriggerState: {
        activeTriggerId: undefined
    }
};
const $af1a979995a7009c$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $af1a979995a7009c$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialActiveTriggerState);
const $af1a979995a7009c$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext($af1a979995a7009c$var$initialTriggerDispatchState);
const $af1a979995a7009c$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [activeTriggerState, setActiveTriggerState] = (0, $5uXOq.useState)($af1a979995a7009c$var$initialActiveTriggerState.activeTriggerState);
    const setTriggerState = (0, $5uXOq.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setActiveTriggerState((current)=>{
            const hasStateChanged = current.activeTriggerId !== triggerId || current.activeTriggerId === triggerId && isActive === false;
            if (!hasStateChanged) return current;
            if (isActive) return {
                activeTriggerId: triggerId
            };
            return {
                activeTriggerId: undefined
            };
        });
    }, []);
    const triggerContextValue = (0, $5uXOq.useMemo)(()=>({
            activeTriggerState: activeTriggerState
        }), [
        activeTriggerState
    ]);
    const triggerContexDispatchValue = (0, $5uXOq.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerContext.Provider, {
        value: triggerContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($af1a979995a7009c$var$TriggerDispatchContext.Provider, {
            value: triggerContexDispatchValue,
            children: children
        })
    });
};
const $af1a979995a7009c$export$454c1d7c35958f5e = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerContext);
const $af1a979995a7009c$export$23cbf084e08bdb93 = ()=>(0, $5uXOq.useContext)($af1a979995a7009c$var$TriggerDispatchContext);
const $af1a979995a7009c$export$3b196fe93a948c18 = (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $af1a979995a7009c$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: activeTriggerState.activeTriggerId === triggerId
    } : {
        isActive: undefined
    };
};
const $af1a979995a7009c$export$83b33e5fe4cce64 = ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $af1a979995a7009c$export$23cbf084e08bdb93();
    const fireTrigger = (0, $5uXOq.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};

});

parcelRegister("4FPR0", function(module, exports) {

$parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", () => $0363165f9cd8d022$export$ae3dab16eb1fc2cc);
const $0363165f9cd8d022$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};

});



parcelRegister("j2nvL", function(module, exports) {

$parcel$export(module.exports, "PlacementFetchProvider", () => $d1dd0ebdae4a4c66$export$9be10e5cc29463c9);

var $5uXOq = parcelRequire("5uXOq");

var $jm1yu = parcelRequire("jm1yu");

var $fyLzM = parcelRequire("fyLzM");
const $d1dd0ebdae4a4c66$export$9be10e5cc29463c9 = ({ children: children, resource: resource })=>{
    const fetch = (0, $fyLzM.usePlacementSSRFetch)(resource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jm1yu.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};

});
parcelRegister("jm1yu", function(module, exports) {

$parcel$export(module.exports, "usePlacementFetchingContext", () => $34e99787e88fad9f$export$e1e2cdb0425a9fa8);
$parcel$export(module.exports, "PlacementFetchingProvider", () => $34e99787e88fad9f$export$5f25a6ddf0324fa8);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $34e99787e88fad9f$export$afec669dc416ee7e = /*#__PURE__*/ (0, $5uXOq.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $34e99787e88fad9f$export$e1e2cdb0425a9fa8 = ()=>(0, $5uXOq.useContext)($34e99787e88fad9f$export$afec669dc416ee7e);
const $34e99787e88fad9f$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($34e99787e88fad9f$export$afec669dc416ee7e.Provider, {
        value: value,
        children: children
    });
};

});


parcelRegister("ZILlH", function(module, exports) {

$parcel$export(module.exports, "default", () => $71405a30e5d17f84$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $30kbx = parcelRequire("30kbx");

var $2RXFI = parcelRequire("2RXFI");

var $e2ICd = parcelRequire("e2ICd");

var $5uXOq = parcelRequire("5uXOq");

var $2JIyR = parcelRequire("2JIyR");

const $71405a30e5d17f84$var$STABLE_OBJECT = {};
const $71405a30e5d17f84$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $5uXOq.useMemo)(()=>(0, $e2ICd.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $30kbx.useStableObject)(placementProps ?? $71405a30e5d17f84$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2RXFI.default), {
        placementId: placementId,
        consumptionType: "local",
        onEvent: onEvent,
        disableInitialData: disableInitialData,
        children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2JIyR.default), {
                analyticsChannel: (0, $ca7b69aae3473d90$export$85183a312807388d),
                placementId: placementId,
                onError: sharedOnEvent,
                fallback: ErrorFallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(MemoizedPlacement, {
                    initialData: initialData,
                    context: context,
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore - Confluence Local Consumption
                    errorFallback: ErrorFallback,
                    ...stableLocalPlacementProps,
                    children: children
                })
            })
    });
};
var $71405a30e5d17f84$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($71405a30e5d17f84$var$Placement);

});
parcelRegister("2RXFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8aead34fad01c03$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $cnhic = parcelRequire("cnhic");

var $96Irh = parcelRequire("96Irh");

var $ggVl0 = parcelRequire("ggVl0");
var $7LKoA = parcelRequire("7LKoA");
var $30kbx = parcelRequire("30kbx");

var $55GjK = parcelRequire("55GjK");
var $jeAWE = parcelRequire("jeAWE");

var $jm1yu = parcelRequire("jm1yu");

var $5uXOq = parcelRequire("5uXOq");


var $2eHYz = parcelRequire("2eHYz");

var $2UQuz = parcelRequire("2UQuz");
const $d8aead34fad01c03$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $jm1yu.usePlacementFetchingContext)();
    return (0, $5uXOq.useMemo)(()=>disableInitialData ? undefined : (0, $2eHYz.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
const $d8aead34fad01c03$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = (0, $96Irh.default).checkGate('enable_ufo_tracking_in_post_office');
    const postOfficeRoute = (0, $7LKoA.usePostOfficeRoute)();
    const context = (0, $ggVl0.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $2UQuz.useBuildBasePath)();
    const stableContextWithRoute = (0, $30kbx.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $5uXOq.useMemo)(()=>isUFOEnabled ? new (0, $55GjK.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    // Callback function to listen to the different stages of the remote component and track its performance
    const remoteComponentOnEvent = (0, $5uXOq.useCallback)(({ type: type, error: error })=>{
        placementOnEvent?.({
            type: type,
            error: error
        });
        switch(type){
            case 'fetch-complete':
                ufoV1PlacementTracker?.markFetchComplete();
                break;
            case 'fetch-error':
                ufoV1PlacementTracker?.markFetchFailure(error);
                break;
            case 'render-complete':
                ufoV1PlacementTracker?.markRenderComplete();
                break;
            case 'render-error':
                ufoV1PlacementTracker?.markRenderFailure(error);
                break;
            case 'initial-data-complete':
                ufoV1PlacementTracker?.markInitialDataComplete();
                break;
            case 'initial-data-error':
                ufoV1PlacementTracker?.markInitialDataFailure(error);
                break;
            case 'component-error':
                ufoV1PlacementTracker?.markComponentFailure(error);
                break;
            case 'component-ready':
                ufoV1PlacementTracker?.markComponentReady();
                break;
            case 'unmount':
                ufoV1PlacementTracker?.markComponentAborted();
                break;
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker
    ]);
    const initialData = $d8aead34fad01c03$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $5uXOq.useMemo)(()=>({
            source: (0, $861ed2a668863e6a$export$f7109619a5e9e0d6),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($d8aead34fad01c03$var$FeatureFlaggedUfoWrapper, {
        placementId: placementId,
        isEnabled: isUFOEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnhic.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext,
            children: children({
                initialData: initialData,
                context: stableContextWithRoute,
                onEvent: remoteComponentOnEvent
            })
        })
    });
};
var $d8aead34fad01c03$export$2e2bcd8739ae039 = $d8aead34fad01c03$var$Placement;
const $d8aead34fad01c03$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
        name: (0, $jeAWE.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jeAWE.UFOv2).UFOSegment, {
            name: `${(0, $jeAWE.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
};

});
const $861ed2a668863e6a$export$85183a312807388d = 'postOffice';
const $861ed2a668863e6a$export$f7109619a5e9e0d6 = 'post-office-frontend';

parcelRegister("2UQuz", function(module, exports) {

$parcel$export(module.exports, "useBuildBasePath", () => $b225cf1355bc34a5$export$83d6c58b7ab7ae67);

var $kBATP = parcelRequire("kBATP");
var $k9ais = parcelRequire("k9ais");

var $5uXOq = parcelRequire("5uXOq");
const $b225cf1355bc34a5$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $k9ais.usePostOfficeEnvironment)();
    return (0, $5uXOq.useMemo)(()=>(0, $kBATP.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};

});


parcelRegister("2JIyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $76d767b143660fe0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $3TR0I = parcelRequire("3TR0I");

var $5uXOq = parcelRequire("5uXOq");
class $76d767b143660fe0$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
}
var $76d767b143660fe0$export$2e2bcd8739ae039 = (0, $3TR0I.default)()($76d767b143660fe0$var$ErrorBoundary);

});

const $ca7b69aae3473d90$export$85183a312807388d = 'postOffice';



parcelRegister("20Eax", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ef566cb4c0c3ad9$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");
const $5ef566cb4c0c3ad9$export$8ca62af4adbfe46 = 'incidents_page_in_jira_-_dummy_experiment';
const $5ef566cb4c0c3ad9$export$3a4dca446b6408b5 = 'incidents_in_jira_jsm_x_jsw_-_dummy_experiment';
const $5ef566cb4c0c3ad9$export$eb8521c2e579754b = 'incidents_in_jira_jsm_x_jsw';
const $5ef566cb4c0c3ad9$export$eabb6fbacfaee0c9 = 'incidents_in_jira_jsm_x_jsw_-_secondary_experiment';
const $5ef566cb4c0c3ad9$export$5b7423264d48ab04 = 'not-enrolled';
const $5ef566cb4c0c3ad9$export$fa04ad826acc90da = 'variation';
const $5ef566cb4c0c3ad9$var$isPrimaryExperimentEnabled = (isInCohort)=>isInCohort && (0, $6s1PB.expValEquals)('incidents_in_jira_jsm_x_jsw', 'cohort', 'variation');
const $5ef566cb4c0c3ad9$var$isSecondaryExperimentEnabled = (isInCohort)=>isInCohort && (0, $6s1PB.expValEquals)('incidents_in_jira_jsm_x_jsw_-_secondary_experiment', 'cohort', 'variation');
const $5ef566cb4c0c3ad9$var$isIncidentsPageEnabled = (incidentExperimentTraits)=>{
    const featureEnabled = $5ef566cb4c0c3ad9$var$isSecondaryExperimentEnabled(incidentExperimentTraits.cohort2) || $5ef566cb4c0c3ad9$var$isPrimaryExperimentEnabled(incidentExperimentTraits.cohort1);
    return featureEnabled;
};
var $5ef566cb4c0c3ad9$export$2e2bcd8739ae039 = $5ef566cb4c0c3ad9$var$isIncidentsPageEnabled;

});

parcelRegister("hADcq", function(module, exports) {

$parcel$export(module.exports, "MENU_ID", () => $3558467d9bee997b$export$d4cd258d01c03112);
$parcel$export(module.exports, "SECTION_ID", () => $3558467d9bee997b$export$501955bd67991a25);
const $3558467d9bee997b$export$d4cd258d01c03112 = 'project/classic';
const $3558467d9bee997b$export$501955bd67991a25 = {
    ISSUES: 'issues',
    REPORTS: 'reports',
    SETTINGS: 'settings',
    REQUESTS: 'requests'
};

});

parcelRegister("ezRTW", function(module, exports) {

$parcel$export(module.exports, "useFeatures", () => $0396841ba6adfb11$export$4a39035bacc4ed76);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $hRzej = parcelRequire("hRzej");
const $0396841ba6adfb11$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $hRzej.extractData)(data), [
        data
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("hRzej", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $ec1c13e67ecdf44f$export$9df5fa0a366163d2);

var $6s1PB = parcelRequire("6s1PB");
const $ec1c13e67ecdf44f$export$9df5fa0a366163d2 = (data)=>{
    const { aiInfo: aiInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCalendar: hasCalendar, hasCode: hasCode, hasComponents: hasComponents, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasForms: hasForms, hasGoals: hasGoals, hasIncidents: hasIncidents, hasIssues: hasIssues, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasReports: hasReports, hasRequests: hasRequests, hasRoadmap: hasRoadmap, hasSecurity: hasSecurity, hasSummaryPage: hasSummaryPage, permissionInfo: permissionInfo, hasArchivedIssues: hasArchivedIssues = false } = data;
    const isProjectOrSiteAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasEditIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasAIInNIN: hasIssues && aiInfo?.isEnabledInIssueNavigator === true,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasCalendar: hasCalendar,
        hasCode: hasCode,
        hasComponents: hasComponents,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasForms: (0, $6s1PB.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasGoals: hasGoals,
        hasIncidents: hasIncidents,
        hasIssues: hasIssues,
        hasList: (0, $6s1PB.expValEquals)('jsw_list_view', 'cohort', 'variation') ? hasList : false,
        hasOpsgenieSchedule: hasOpsgenieSchedule,
        hasPages: hasPages,
        hasReleases: hasReleases,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasRoadmap: hasRoadmap,
        hasSecurity: hasSecurity,
        hasSettings: isProjectOrSiteAdmin || hasEditWorkflowPermissions || hasEditIssueLayoutPermissions,
        hasShortcutsAdd: isProjectOrSiteAdmin,
        hasSummaryPage: hasSummaryPage
    };
};

});


parcelRegister("69H2H", function(module, exports) {

$parcel$export(module.exports, "DeploymentsMenuItem", () => $704cd66d6734f53b$export$916ff6bbd9370319);

var $5uXOq = parcelRequire("5uXOq");

var $lUn6w = parcelRequire("lUn6w");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $6jY6G = parcelRequire("6jY6G");

var $jNCQJ = parcelRequire("jNCQJ");
const $704cd66d6734f53b$export$916ff6bbd9370319 = ({ projectKey: projectKey, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const deploymentsRoute = (0, $6jY6G.useRouteByName)('software-deployments-classic');
    // The route definition will be null when this component is rendered outside
    // of the SPA (e.g. the settings page in Classic projects)
    const menuItemProps = deploymentsRoute !== null ? {
        to: deploymentsRoute,
        params: {
            projectKey: projectKey
        }
    } : {
        href: `/jira/software/c/projects/${projectKey}/deployments`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...menuItemProps,
        analytics: {
            itemId: 'deployments'
        },
        selectedOn: [
            'software-deployments-classic'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUn6w))), {
            spacing: "spacious",
            label: ""
        }),
        testId: testId
    }, formatMessage((0, $jNCQJ.default).deploymentsItem));
};

});
parcelRegister("lUn6w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff30bfed1a85ba7b$var$_react = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ff30bfed1a85ba7b$var$_cloudArrowUp = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("fbDNl")));

var $ff30bfed1a85ba7b$var$_upload = $ff30bfed1a85ba7b$var$_interopRequireDefault((parcelRequire("c2AHP")));
function $ff30bfed1a85ba7b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ff30bfed1a85ba7b$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $ff30bfed1a85ba7b$var$_react.default.createElement($ff30bfed1a85ba7b$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $ff30bfed1a85ba7b$var$_upload.default
    }, props));
$ff30bfed1a85ba7b$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $ff30bfed1a85ba7b$var$_default = module.exports.default = $ff30bfed1a85ba7b$var$CloudArrowUpIcon;

});
parcelRegister("fbDNl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0e6c08723df58e1$var$_react = $b0e6c08723df58e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0e6c08723df58e1$var$_baseNew = $b0e6c08723df58e1$var$_interopRequireDefault((parcelRequire("enEmH")));
function $b0e6c08723df58e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0e6c08723df58e1$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $b0e6c08723df58e1$var$_react.default.createElement($b0e6c08723df58e1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$b0e6c08723df58e1$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $b0e6c08723df58e1$var$_default = module.exports.default = $b0e6c08723df58e1$var$CloudArrowUpIcon;

});

parcelRegister("c2AHP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c4224fd0fe9f51e$var$_react = $8c4224fd0fe9f51e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $8c4224fd0fe9f51e$var$_cloudArrowUp = $8c4224fd0fe9f51e$var$_interopRequireDefault((parcelRequire("fbDNl")));
function $8c4224fd0fe9f51e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8c4224fd0fe9f51e$var$UploadIcon = (props)=>/*#__PURE__*/ $8c4224fd0fe9f51e$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $8c4224fd0fe9f51e$var$_cloudArrowUp.default
    }));
$8c4224fd0fe9f51e$var$UploadIcon.displayName = 'UploadIcon';
var $8c4224fd0fe9f51e$var$_default = module.exports.default = $8c4224fd0fe9f51e$var$UploadIcon;

});


parcelRegister("jNCQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6bd53c02c4fff21$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e6bd53c02c4fff21$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    deploymentsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.deployments-menu-item.deployments-item",
        "defaultMessage": "Deployments"
    }
});

});


parcelRegister("3QUEt", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $57d4838bac191a86$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $aWse0 = parcelRequire("aWse0");

var $auDmG = parcelRequire("auDmG");

var $fxFUw = parcelRequire("fxFUw");

var $cZpsT = parcelRequire("cZpsT");

var $hjSul = parcelRequire("hjSul");

var $ldgzi = parcelRequire("ldgzi");
const $57d4838bac191a86$export$a06f1c675e846f6f = ({ HelpPanelButton: HelpPanelButton = (0, $auDmG.HelpPanelButton), Link: Link = (0, $hjSul.Link), ProjectFooter: ProjectFooter = (0, $fxFUw.ProjectFooter), useIntl: useIntl = (0, $aWse0.useIntlV2) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ProjectFooter, {
        description: !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HelpPanelButton, {
            articleId: "7qmj8lQILFCzcHlVGgC1JR",
            "aria-label": formatMessage((0, $ldgzi.default).learnMoreAriaLabel),
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Link, {
                href: "https://support.atlassian.com/jira-software-cloud/docs/what-are-team-managed-and-company-managed-projects/",
                target: "_blank",
                "aria-label": formatMessage((0, $ldgzi.default).learnMoreAriaLabel)
            }, formatMessage((0, $ldgzi.default).learnMore))
        }, formatMessage((0, $ldgzi.default).learnMore))
    }, formatMessage((0, $ldgzi.default).title));
};

});
parcelRegister("auDmG", function(module, exports) {

$parcel$export(module.exports, "HelpPanelButton", () => $c4b9c1de653fb6b2$export$4b6bbd2e0136b372);

var $5uXOq = parcelRequire("5uXOq");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");
const $c4b9c1de653fb6b2$export$4b6bbd2e0136b372 = ({ HelpButtonLink: HelpButtonLink = (0, $5Zxxp.default), articleId: articleId, fireUIAnalytics: fireUIAnalytics = (0, $8zOmE.fireUIAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, $bngFq.useAnalyticsEvents), useCallback: useCallback = (0, $5uXOq.useCallback), ...rest })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = useCallback(()=>fireUIAnalytics(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), 'sidebar', {
            helpArticleId: articleId,
            itemId: 'learnMore'
        }), [
        articleId,
        createAnalyticsEvent,
        fireUIAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HelpButtonLink, {
        articleId: articleId,
        type: "HELP_ARTICLE",
        appearance: "subtle-link",
        spacing: "none",
        onClick: onClick,
        ...rest
    });
};

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cNW3X = parcelRequire("cNW3X");

var $8zIDr = parcelRequire("8zIDr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zIDr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cNW3X.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expVal)('m1_features_page_experiment', 'cohort', 'not-enrolled') === 'variation' && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});
parcelRegister("6BNJk", function(module, exports) {

$parcel$export(module.exports, "HELP_PANEL_VERSION", () => $20386d7da4313ff0$export$c43c7444da662fa1);
$parcel$export(module.exports, "HELP_PANEL_ID", () => $20386d7da4313ff0$export$e99efa3985fa3c26);
$parcel$export(module.exports, "HELP_PANEL_WIDTH", () => $20386d7da4313ff0$export$23aa6670f346c214);

var $gwIPs = parcelRequire("gwIPs");
const $20386d7da4313ff0$export$c43c7444da662fa1 = '1';
const $20386d7da4313ff0$export$e99efa3985fa3c26 = 'helpPanel';
const $20386d7da4313ff0$export$23aa6670f346c214 = (0, $gwIPs.gridSize) * 46;

});

parcelRegister("kspz4", function(module, exports) {

$parcel$export(module.exports, "useHelpPanel", () => $aee6103177ce0723$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $aee6103177ce0723$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $51nlc = parcelRequire("51nlc");

var $jgGDm = parcelRequire("jgGDm");
const $aee6103177ce0723$export$3fe94d66377a53b8 = (0, $3sQ5x.createHook)((0, $jgGDm.default));
const $aee6103177ce0723$export$c61f56f4797e22db = (0, $3sQ5x.createHook)((0, $jgGDm.default), {
    selector: null
});
const $aee6103177ce0723$export$513717a84f55db1a = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelSubscriber'
});
const $aee6103177ce0723$export$5f4de38bd79f4446 = (0, $51nlc.createSubscriber)((0, $jgGDm.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("jgGDm", function(module, exports) {

$parcel$export(module.exports, "default", () => $465615692863cce9$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $iXqE5 = parcelRequire("iXqE5");

var $958ua = parcelRequire("958ua");
let $465615692863cce9$var$iphStorage;
const $465615692863cce9$var$createStorage = ()=>{
    if ($465615692863cce9$var$iphStorage) return $465615692863cce9$var$iphStorage;
    $465615692863cce9$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
    return $465615692863cce9$var$iphStorage;
};
const $465615692863cce9$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $465615692863cce9$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $465615692863cce9$export$2e2bcd8739ae039 = (0, $iXqE5.createStore)({
    name: 'help-panel',
    initialState: $465615692863cce9$var$initialState,
    actions: $958ua
});

});
parcelRegister("958ua", function(module, exports) {

$parcel$export(module.exports, "setNavigationData", () => $177ac56c5a5bf49e$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $177ac56c5a5bf49e$export$cdabe01d01a8da1e);

var $eNf8a = parcelRequire("eNf8a");
const $177ac56c5a5bf49e$var$iphStorage = (0, $eNf8a.createSessionStorageProvider)('iph');
const $177ac56c5a5bf49e$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $177ac56c5a5bf49e$var$iphStorage.set('history', []);
    };
const $177ac56c5a5bf49e$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});



parcelRegister("hsmeR", function(module, exports) {

$parcel$export(module.exports, "useActiveRightSidebarState", () => $39a48ee662f10943$export$ba763ab7661c3103);
$parcel$export(module.exports, "useRightSidebarState", () => $39a48ee662f10943$export$d1828e7f46a4960b);
$parcel$export(module.exports, "useRightSidebarController", () => $39a48ee662f10943$export$ebe5e907fb0bb63a);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");

var $byk51 = parcelRequire("byk51");

var $5e5zm = parcelRequire("5e5zm");
const $39a48ee662f10943$var$useActiveRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>{
        const rightSidebarState = (0, $byk51.selectCurrentRightSidebar)(state.content.rightSidebar);
        if (!rightSidebarState) return null;
        return {
            ...rightSidebarState,
            shouldRender: !state.isChromeless
        };
    }
});
const $39a48ee662f10943$export$ba763ab7661c3103 = ()=>{
    const [rightSidebar] = $39a48ee662f10943$var$useActiveRightSidebar();
    return rightSidebar;
};
const $39a48ee662f10943$var$useRightSidebar = (0, $3sQ5x.createHook)((0, $5e5zm.layoutStore), {
    selector: (state)=>state.content.rightSidebar
});
const $39a48ee662f10943$export$d1828e7f46a4960b = ()=>{
    const [rightSidebarState] = $39a48ee662f10943$var$useRightSidebar();
    return rightSidebarState;
};
const $39a48ee662f10943$export$ebe5e907fb0bb63a = ()=>{
    const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $5e5zm.useLayoutStoreActions)();
    return (0, $5uXOq.useMemo)(()=>({
            setRightSidebarState: setRightSidebarState,
            closeRightSidebar: closeRightSidebar,
            openRightSidebar: openRightSidebar,
            closeCurrentRightSidebar: closeCurrentRightSidebar,
            closeAllRightSidebar: closeAllRightSidebar,
            minimiseRightSidebar: minimiseRightSidebar
        }), [
        closeAllRightSidebar,
        closeCurrentRightSidebar,
        closeRightSidebar,
        openRightSidebar,
        setRightSidebarState,
        minimiseRightSidebar
    ]);
};

});



parcelRegister("fxFUw", function(module, exports) {

$parcel$export(module.exports, "ProjectFooter", () => $60f5e4c9257f773e$export$84c2ab70be8ad47b);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1lATI = parcelRequire("1lATI");

var $fpoBX = parcelRequire("fpoBX");
const $60f5e4c9257f773e$var$bgColorCssVar = '--project-footer-bg-color';
const $60f5e4c9257f773e$var$textColorCssVar = '--project-footer-text-color';
const $60f5e4c9257f773e$var$customFooterStyles = null;
const $60f5e4c9257f773e$var$bgColorThemeStyles = null;
const $60f5e4c9257f773e$var$colorThemeStyles = null;
const $60f5e4c9257f773e$export$88140d3970f0ce84 = ({ className: className, ...props })=>{
    const theme = (0, $fpoBX.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $bwpsq.default)([
            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf _tkqh1ule _1g6a1h6o _dqi54jg8 _1lfu4jg8 _1bnm1gjq _1t3912x7 _qz5b12x7 _xd2912x7 _2i0812x7 _2pzv1o8l _1w711gjq",
            item?.background?.default && "_16hg1p3a",
            item?.color?.default && "_1w90enff _i9a1enff _1cmdenff",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$60f5e4c9257f773e$var$bgColorCssVar]: item?.background?.default,
            [$60f5e4c9257f773e$var$textColorCssVar]: item?.color?.default
        }
    });
};
const $60f5e4c9257f773e$export$84c2ab70be8ad47b = ({ Footer: Footer = (0, $1lATI.default), children: children, description: description })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Footer, {
        component: $60f5e4c9257f773e$export$88140d3970f0ce84,
        // @ts-expect-error - TS2769 - No overload matches this call.
        description: description,
        testId: "navigation-apps-sidebar-common.ui.project-footer.test-footer"
    }, children);
};

});
parcelRegister("1lATI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df4485cd7f519a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/consistent-props-definitions */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $5sRpy = parcelRequire("5sRpy");
var $gOkqF = parcelRequire("gOkqF");
var $k9nuy = parcelRequire("k9nuy");

var $3w19c = parcelRequire("3w19c");

var $bY5Mc = parcelRequire("bY5Mc");

var $6cAn5 = parcelRequire("6cAn5");
const $7df4485cd7f519a3$var$styles = {
    iconContainer: "_1e0c1o8l _1bsb1k8s _4t3i1k8s",
    oldFooter: "_vrjtdcr7 _16vx1h6o _1cg71wug _if291ule _14741h6o _oiqe1tcg _1kba1h6o _w1ap1osq _1mt2ze3t _159iu2gc _76zj1o8l _13e21h6o _14bw1o8l _eq7s12x7 _1jkv12x7 _1rla12x7 _z2a212x7 _11kj1w7a _jl2n73ad _1et61w7a _1v6jjjyb"
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$OldFooter = (props)=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ iconBefore: iconBefore, onClick: onClick, description: description, children: children, testId: testId })=>({
            iconBefore: iconBefore,
            onClick: onClick,
            description: description,
            children: children,
            testId: testId
        }))(props);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bY5Mc.default), {
        ...safeProps,
        component: props.component || (0, $3w19c.Container),
        className: (0, $bwpsq.default)([
            $7df4485cd7f519a3$var$styles.oldFooter
        ])
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$Footer = ({ description: description, children: children, iconBefore: iconBefore, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
        padding: "space.100",
        testId: testId,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
            space: "space.100",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5sRpy.default), {
                    xcss: $7df4485cd7f519a3$var$styles.iconContainer,
                    children: iconBefore
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gOkqF.default), {
                    space: "space.075",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "UNSAFE_small",
                            align: "center",
                            color: "inherit",
                            children: children
                        }),
                        description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k9nuy.default), {
                            size: "UNSAFE_small",
                            as: "p",
                            align: "center",
                            color: "color.text.subtlest",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * __Footer__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $7df4485cd7f519a3$var$FooterFacade = ({ useDeprecatedApi: useDeprecatedApi = true, description: description, iconBefore: iconBefore, testId: testId, children: children, component: component, onClick: onClick })=>{
    if (!useDeprecatedApi) return /*#__PURE__*/ (0, $2OMIu.jsx)($7df4485cd7f519a3$var$Footer, {
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
    typeof $6cAn5;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($7df4485cd7f519a3$var$OldFooter, {
        onClick: onClick,
        component: component,
        iconBefore: iconBefore,
        description: description,
        testId: testId,
        children: children
    });
};
var $7df4485cd7f519a3$export$2e2bcd8739ae039 = $7df4485cd7f519a3$var$FooterFacade;

});


parcelRegister("ldgzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a938ba7571cb52$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $92a938ba7571cb52$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-software-classic.menu.footer.title",
        "defaultMessage": "You're in a company-managed project"
    },
    learnMore: {
        "id": "spa-apps-sidebar-software-classic.menu.footer.learn-more",
        "defaultMessage": "Learn more"
    },
    learnMoreAriaLabel: {
        "id": "spa-apps-sidebar-software-classic.menu.footer.learn-more-aria-label",
        "defaultMessage": "Learn more about team-managed and company-managed projects"
    }
});

});


parcelRegister("dvdrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f673933d977cc8c1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f673933d977cc8c1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    itemArchives: {
        "id": "spa-apps-sidebar-software-classic.menu.item-archives",
        "defaultMessage": "Archived issues"
    },
    backlogItem: {
        "id": "spa-apps-sidebar-software-classic.menu.backlog-item",
        "defaultMessage": "Backlog"
    },
    scrumBoard: {
        "id": "spa-apps-sidebar-software-classic.menu.scrum-board",
        "defaultMessage": "Active sprints"
    },
    kanbanBoard: {
        "id": "spa-apps-sidebar-software-classic.menu.kanban-board",
        "defaultMessage": "Kanban board"
    },
    backItem: {
        "id": "spa-apps-sidebar-software-classic.menu.back-item",
        "defaultMessage": "Back to project"
    },
    reportsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.reports-item",
        "defaultMessage": "Reports"
    },
    timelineItem: {
        "id": "spa-apps-sidebar-software-classic.menu.timeline-item",
        "defaultMessage": "Timeline"
    },
    calendarItem: {
        "id": "spa-apps-sidebar-software-classic.menu.calendar-item",
        "defaultMessage": "Calendar"
    },
    listItem: {
        "id": "spa-apps-sidebar-software-classic.menu.list-item",
        "defaultMessage": "List"
    },
    codeItem: {
        "id": "spa-apps-sidebar-software-classic.menu.code-item",
        "defaultMessage": "Code"
    },
    formsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.forms-item",
        "defaultMessage": "Forms"
    },
    goalsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.goals-item",
        "defaultMessage": "Goals"
    },
    projectSettingsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.project-settings-item",
        "defaultMessage": "Project settings"
    },
    securityItem: {
        "id": "spa-apps-sidebar-software-classic.menu.security-item",
        "defaultMessage": "Security"
    },
    summaryItem: {
        "id": "spa-apps-sidebar-software-classic.menu.summary-item",
        "defaultMessage": "Summary"
    },
    releasesItem: {
        "id": "spa-apps-sidebar-software-classic.menu.releases-item",
        "defaultMessage": "Releases"
    },
    periscopeItemNonFinal: {
        "id": "spa-apps-sidebar-software-classic.menu.periscope-item-non-final",
        "defaultMessage": "Development"
    },
    pinItem: {
        "id": "spa-apps-sidebar-software-classic.menu.pin-item",
        "defaultMessage": "Issues and filters"
    },
    ninItem: {
        "id": "spa-apps-sidebar-software-classic.menu.nin-item",
        "defaultMessage": "Issues"
    },
    newNinNestedMenuItemTitleHeader: {
        "id": "spa-apps-sidebar-software-classic.menu.new-nin-nested-menu-item-title-header",
        "defaultMessage": "Default Filters"
    },
    pagesItem: {
        "id": "spa-apps-sidebar-software-classic.menu.pages-item",
        "defaultMessage": "Pages"
    },
    opsgenieItem: {
        "id": "spa-apps-sidebar-software-classic.menu.opsgenie-item",
        "defaultMessage": "On-call"
    },
    whoIsOnCall: {
        "id": "spa-apps-sidebar-software-classic.menu.who-is-on-call",
        "defaultMessage": "On-call"
    },
    componentsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.components-item",
        "defaultMessage": "Components"
    },
    beta: {
        "id": "spa-apps-sidebar-software-classic.menu.beta",
        "defaultMessage": "Beta"
    },
    alpha: {
        "id": "spa-apps-sidebar-software-classic.menu.alpha",
        "defaultMessage": "Alpha"
    },
    new: {
        "id": "spa-apps-sidebar-software-classic.menu.new",
        "defaultMessage": "New"
    },
    recommended: {
        "id": "spa-apps-sidebar-software-classic.menu.recommended",
        "defaultMessage": "Recommended"
    },
    atlassianIntelligence: {
        "id": "spa-apps-sidebar-software-classic.menu.atlassian-intelligence",
        "defaultMessage": "AI"
    },
    // Rebranded
    headerDescriptionCompanyManaged: {
        "id": "spa-apps-sidebar-software-classic.menu.header-description-company-managed",
        "defaultMessage": "Software project"
    },
    planningModule: {
        "id": "spa-apps-sidebar-software-classic.menu.planning-module",
        "defaultMessage": "PLANNING"
    },
    developmentModule: {
        "id": "spa-apps-sidebar-software-classic.menu.development-module",
        "defaultMessage": "DEVELOPMENT"
    },
    operationsModule: {
        "id": "spa-apps-sidebar-software-classic.menu.operations-module",
        "defaultMessage": "OPERATIONS"
    },
    incidentsItem: {
        "id": "spa-apps-sidebar-software-classic.menu.incidents-item",
        "defaultMessage": "Incidents"
    },
    itemArchivesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.item-archives-issue-term-refresh",
        "defaultMessage": "Archived work items"
    },
    ninItemIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.nin-item-issue-term-refresh",
        "defaultMessage": "All work"
    },
    pinItemIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.pin-item-issue-term-refresh",
        "defaultMessage": "Work items and filters"
    }
});

});

parcelRegister("l5Ald", function(module, exports) {

$parcel$export(module.exports, "ReleasesMenuItem", () => $06f45aafb996326a$export$1f2eca6ed70a192b);

var $5uXOq = parcelRequire("5uXOq");

var $2MieS = parcelRequire("2MieS");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $6jY6G = parcelRequire("6jY6G");

var $esLBq = parcelRequire("esLBq");
const $06f45aafb996326a$export$1f2eca6ed70a192b = ({ projectKey: projectKey, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const releasesRoute = (0, $6jY6G.useRouteByName)('project-versions');
    // The route definition will be null when this component is rendered outside
    // of the SPA (e.g. the settings page in Classic projects)
    const menuItemProps = releasesRoute !== null ? {
        to: releasesRoute,
        params: {
            projectKey: projectKey
        },
        prefetch: 'hover',
        query: {
            selectedItem: 'com.atlassian.jira.jira-projects-plugin:release-page'
        }
    } : {
        href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:release-page`
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        ...menuItemProps,
        analytics: {
            itemId: 'releases'
        },
        selectedOn: [
            'project-versions',
            'legacy-project-releases',
            'legacy-project-releases-bamboo',
            'legacy-project-releases-note',
            'legacy-project-releases-note-config',
            'software-release-notes',
            'software-version-detail'
        ],
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2MieS))), {
            spacing: "spacious",
            label: ""
        }),
        testId: testId
    }, formatMessage((0, $esLBq.default).releasesItem));
};

});
parcelRegister("esLBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb41153bea5e4ea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6bb41153bea5e4ea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    releasesItem: {
        "id": "spa-apps-sidebar-software-classic.menu.releases-menu-item.releases-item",
        "defaultMessage": "Releases"
    }
});

});


parcelRegister("7pPua", function(module, exports) {

$parcel$export(module.exports, "Reports", () => $a44bdf8019bd01f5$export$883262dc952d8f59);

var $5uXOq = parcelRequire("5uXOq");

var $3w19c = parcelRequire("3w19c");
var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $fNi03 = parcelRequire("fNi03");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $8CVvd = parcelRequire("8CVvd");

var $4eL7a = parcelRequire("4eL7a");

var $eFwpm = parcelRequire("eFwpm");

var $7mDg6 = parcelRequire("7mDg6");

var $lsng8 = parcelRequire("lsng8");

var $8uwUM = parcelRequire("8uwUM");

var $SWNL7 = parcelRequire("SWNL7");

var $dPZj9 = parcelRequire("dPZj9");
const $a44bdf8019bd01f5$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $a44bdf8019bd01f5$export$883262dc952d8f59 = ({ Header: Header = (0, $3w19c.default), MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $kxnYb.default), SkeletonItem: SkeletonItem = (0, $9K9UK.default), useIntl: useIntl = (0, $aWse0.useIntlV2), useProject: useProject = $a44bdf8019bd01f5$var$useThrowProjectDI, AgileReports: AgileReports = (0, $eFwpm.default), DevOpsReports: DevOpsReports = (0, $7mDg6.DevOpsReports), JsErrorBoundary: JsErrorBoundary = (0, $7CMCs.JSErrorBoundary), IssueAnalysisReports: IssueAnalysisReports = (0, $8uwUM.default), ForecastManagementReports: ForecastManagementReports = (0, $lsng8.default), OtherReports: OtherReports = (0, $dPZj9.default), connectItems: connectItems })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    const { data: board, loading: isBoardLoading, error: error } = (0, $fNi03.useBoard)();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    if (isBoardLoading && (0, $4R6GH.fg)('reports-overview-page-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    // Team solaris should be monitoring this, not navigation team.
    const devOpsErrorBoundaryProps = {
        teamName: 'fusion-solaris',
        // We don't want to blow-up anything, but just not to render devOps nav group only.
        fallback: 'unmount',
        packageName: 'navigationAppsSidebarSoftwareClassic',
        id: 'classicDevOpsMenuGroup'
    };
    const newReportsHref = board == null && !isBoardLoading && !error ? `/jira/software/c/projects/${project.key}/reports` : `/jira/software/c/projects/${project.key}/boards/${board?.id}/reports`;
    const reportsHref = (0, $4R6GH.fg)('reports-overview-page-migration') ? newReportsHref : `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, null, formatMessage((0, $SWNL7.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'all'
        },
        selectedOn: [
            ...(0, $4R6GH.fg)('reports-overview-page-migration') ? [
                'software-reports',
                'software-reports-boardless'
            ] : [],
            'legacy-all-reports'
        ],
        href: reportsHref
    }, formatMessage((0, $SWNL7.messages).allReports)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AgileReports, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JsErrorBoundary, devOpsErrorBoundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DevOpsReports, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueAnalysisReports, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForecastManagementReports, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OtherReports, {
        connectItems: connectItems
    }), (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eL7a.default), {
        project: project
    }));
};

});
parcelRegister("4eL7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $b83b9ccf649accae$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fNi03 = parcelRequire("fNi03");

var $9hLEH = parcelRequire("9hLEH");
const $b83b9ccf649accae$var$ProjectShortcuts = ({ project: project })=>{
    const { data: board, loading: loading, error: error } = (0, $fNi03.useBoard)();
    if (!board || loading || error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        isCMPBoard: true,
        projectKey: project.key,
        boardId: board.id
    });
};
var $b83b9ccf649accae$export$2e2bcd8739ae039 = $b83b9ccf649accae$var$ProjectShortcuts;

});
parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $b7Svb = parcelRequire("b7Svb");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $b7Svb.lazy)(()=>(parcelRequire("8pp6L")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("8pp6L", function(module, exports) {

let $61f42276bdabf6ca$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $61f42276bdabf6ca$var$load("cM9em"),
    $61f42276bdabf6ca$var$load("fr9NE"),
    $61f42276bdabf6ca$var$load("3gkNR")
]).then(()=>parcelRequire('9pQJj'));

});



parcelRegister("eFwpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $36defa6c169957cc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $fNi03 = parcelRequire("fNi03");

var $lpwtK = parcelRequire("lpwtK");

var $7EMGV = parcelRequire("7EMGV");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $4R6GH = parcelRequire("4R6GH");

var $6zQVi = parcelRequire("6zQVi");

var $3oyD4 = parcelRequire("3oyD4");
const $36defa6c169957cc$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $36defa6c169957cc$var$useThrowBoardDI = (0, $7OqB4.withThrowOnError)((0, $fNi03.useBoard));
const $36defa6c169957cc$var$useThrowFlexibleNomenclatureDI = (0, $7OqB4.withThrowOnError)((0, $6zQVi.useFlexibleNomenclature));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$36defa6c169957cc$export$2e2bcd8739ae039 = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $kxnYb.default), SkeletonItem: SkeletonItem = (0, $9K9UK.default), ScopeSwitcher: ScopeSwitcher = (0, $7EMGV.ScopeSwitcher), useIntl: useIntl = (0, $aWse0.useIntlV2), useProject: useProject = $36defa6c169957cc$var$useThrowProjectDI, useBoard: useBoard = $36defa6c169957cc$var$useThrowBoardDI, useFlexibleNomenclature: useFlexibleNomenclature = $36defa6c169957cc$var$useThrowFlexibleNomenclatureDI, matchUrlPathname: matchUrlPathname = (0, $4OCke.matchUrlPathname) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { data: board } = useBoard();
    const { data: project } = useProject();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    if (board == null) return null;
    const { data: flexibleNomenclature } = useFlexibleNomenclature();
    const isScrumProject = board.type === 'scrum';
    const baseReportUrl = `/jira/software/c/projects/${project.key}/boards/${board.id}/reports`;
    const epicLevelName = flexibleNomenclature.levelOneName || 'Epic';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $3oyD4.messages).agile)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScopeSwitcher, null), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'burndown'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/burndown-chart`
    }, formatMessage((0, $3oyD4.messages).burndown)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'burnup'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/burnup-chart`
    }, formatMessage((0, $3oyD4.messages).burnup)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'sprint-retrospective'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/sprint-retrospective`
    }, formatMessage((0, $3oyD4.messages).sprint)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'velocity'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}${(0, $4R6GH.fg)('reports-overview-page-migration') ? '/velocity' : '/velocity-chart'}`
    }, formatMessage((0, $3oyD4.messages).velocity)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'cumulative-flow-diagram'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/cumulative-flow-diagram`
    }, formatMessage((0, $3oyD4.messages).flow)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'version'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/version-report`
    }, formatMessage((0, $3oyD4.messages).version)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'epic-report'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/epic-report`
    }, epicLevelName !== 'Epic' ? formatMessage((0, $3oyD4.messages).epicReportFlexible, {
        epicLevelName: epicLevelName
    }) : formatMessage((0, $3oyD4.messages).epic)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'control'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/control-chart`
    }, formatMessage((0, $3oyD4.messages).control)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'epic-burndown'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/epic-burndown`
    }, epicLevelName !== 'Epic' ? formatMessage((0, $3oyD4.messages).epicBurndownFlexible, {
        epicLevelName: epicLevelName
    }) : formatMessage((0, $3oyD4.messages).epicBurndown)), isScrumProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'release-burndown'
        },
        selectedOn: matchUrlPathname(),
        href: `${baseReportUrl}/release-burndown`
    }, formatMessage((0, $3oyD4.messages).releaseBurndown)));
};

});
parcelRegister("6zQVi", function(module, exports) {

$parcel$export(module.exports, "useFlexibleNomenclature", () => $006574733e5a63fc$export$f60db71846d76a40);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");
const $006574733e5a63fc$export$f60db71846d76a40 = ()=>{
    // V4 API, useJiraSoftwareProjectNavigation is cached.
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && data.flexibleNomenclatureData, [
        data
    ]);
    return {
        data: {
            levelOneName: extractedData?.levelOneName
        },
        loading: loading,
        error: error
    };
};

});

parcelRegister("3oyD4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $164dcc6b5d84288d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $164dcc6b5d84288d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    agile: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.agile",
        "defaultMessage": "Agile"
    },
    burndown: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.burndown",
        "defaultMessage": "Burndown Chart"
    },
    burnup: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.burnup",
        "defaultMessage": "Burnup Chart"
    },
    sprint: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.sprint",
        "defaultMessage": "Sprint Report"
    },
    velocity: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.velocity",
        "defaultMessage": "Velocity Chart"
    },
    flow: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.flow",
        "defaultMessage": "Cumulative Flow Diagram"
    },
    version: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.version",
        "defaultMessage": "Version Report"
    },
    epic: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.epic",
        "defaultMessage": "Epic Report"
    },
    epicReportFlexible: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.epic-report-flexible",
        "defaultMessage": "{epicLevelName} Report"
    },
    control: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.control",
        "defaultMessage": "Control Chart"
    },
    epicBurndown: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.epic-burndown",
        "defaultMessage": "Epic Burndown"
    },
    epicBurndownFlexible: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.epic-burndown-flexible",
        "defaultMessage": "{epicLevelName} Burndown"
    },
    releaseBurndown: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.agile.release-burndown",
        "defaultMessage": "Release Burndown"
    }
});

});


parcelRegister("7mDg6", function(module, exports) {

$parcel$export(module.exports, "DevOpsReports", () => $d1ad3743324171b5$export$bccdfcf05df6540b);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $kfztd = parcelRequire("kfztd");

var $a9ErF = parcelRequire("a9ErF");

var $akRgj = parcelRequire("akRgj");
const $d1ad3743324171b5$export$bccdfcf05df6540b = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const devOpsReportGroupPrecondition = (0, $akRgj.useDevOpsReportPreconditionResourceAutoRefetch)();
    const { data: project } = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject))();
    if (project == null || devOpsReportGroupPrecondition == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null));
    const renderCycleTimeReport = (0, $akRgj.shouldCycleTimeReportRendered)(devOpsReportGroupPrecondition);
    const renderDeploymentFrequencyReport = (0, $akRgj.shouldDeploymentFrequencyReportRendered)(devOpsReportGroupPrecondition);
    if ((0, $kfztd.isDevopsFeatureDisabledInFedRamp)() || !renderCycleTimeReport && !renderDeploymentFrequencyReport) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), {
        title: formatMessage((0, $a9ErF.messages).devOps)
    }, renderCycleTimeReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'cycleTimeReport'
        },
        selectedOn: [
            'software-reports-cycle-time-classic'
        ],
        href: `/jira/software/c/projects/${project.key}/reports/cycle-time`
    }, formatMessage((0, $a9ErF.messages).cycleTime)), renderDeploymentFrequencyReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'deploymentFrequencyReport'
        },
        selectedOn: [
            'software-reports-deployment-frequency-classic'
        ],
        href: `/jira/software/c/projects/${project.key}/reports/deployment-frequency`
    }, formatMessage((0, $a9ErF.messages).deploymentFrequency)));
};
var $d1ad3743324171b5$export$2e2bcd8739ae039 = $d1ad3743324171b5$export$bccdfcf05df6540b;

});
parcelRegister("a9ErF", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d32d869a8b4ba99a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d32d869a8b4ba99a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    devOps: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.dev-ops.dev-ops",
        "defaultMessage": "DevOps"
    },
    cycleTime: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.dev-ops.cycle-time",
        "defaultMessage": "Cycle time report"
    },
    deploymentFrequency: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.dev-ops.deployment-frequency",
        "defaultMessage": "Deployment frequency report"
    }
});

});

parcelRegister("akRgj", function(module, exports) {

$parcel$export(module.exports, "useDevOpsReportPreconditionResourceAutoRefetch", () => $e57a669968cc1ace$export$9d6b303eeaf51bcc);
$parcel$export(module.exports, "shouldCycleTimeReportRendered", () => $e57a669968cc1ace$export$52d2d3b48621eb55);
$parcel$export(module.exports, "shouldDeploymentFrequencyReportRendered", () => $e57a669968cc1ace$export$db5db951e6a2c5d3);

var $5uXOq = parcelRequire("5uXOq");

var $4Bwc0 = parcelRequire("4Bwc0");
const $e57a669968cc1ace$export$9d6b303eeaf51bcc = ()=>{
    const { data: data, loading: loading, error: error, refresh: refresh } = (0, $4Bwc0.useDevOpsReportPreconditionResource)();
    // In case someone forgets adding our precondition resource to any Reports page, this will at least fetch the precondition and render the menu
    (0, $5uXOq.useEffect)(()=>{
        if (loading === false && data == null) {
            if (error) throw error;
            refresh();
        }
    }, [
        data,
        error,
        loading,
        refresh
    ]);
    return data;
};
const $e57a669968cc1ace$export$52d2d3b48621eb55 = (devOpsReportGroupPrecondition)=>devOpsReportGroupPrecondition.hasViewDevToolsPermission && devOpsReportGroupPrecondition.hasViewAggregateDataPermission;
const $e57a669968cc1ace$export$db5db951e6a2c5d3 = (devOpsReportGroupPrecondition)=>devOpsReportGroupPrecondition.hasViewDevToolsPermission && devOpsReportGroupPrecondition.hasViewAggregateDataPermission;

});
parcelRegister("4Bwc0", function(module, exports) {

$parcel$export(module.exports, "devOpsReportPreconditionResource", () => $5073d432665dfcf8$export$96cb0eae1b3413f4);
$parcel$export(module.exports, "useDevOpsReportPreconditionResource", () => $5073d432665dfcf8$export$e9adc6103e9ed514);

var $2M1hQ = parcelRequire("2M1hQ");
var $2YP9W = parcelRequire("2YP9W");


const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $2M1hQ.createResource)({
    type: (0, $16165c7eb855363c$export$14c5ce449424c281),
    getKey: ({ query: query })=>query.projectKey,
    getDataLoader: ()=>(parcelRequire("llYR0")),
    maxAge: 60000
});
const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $2YP9W.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);

});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';

parcelRegister("llYR0", function(module, exports) {

let $f8bac370a50ce0d2$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f8bac370a50ce0d2$var$load("goFaC").then(()=>parcelRequire('5aldt'));

});




parcelRegister("lsng8", function(module, exports) {

$parcel$export(module.exports, "default", () => $332d89d0d5f0863e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $etw3L = parcelRequire("etw3L");

var $lIsiW = parcelRequire("lIsiW");
const $332d89d0d5f0863e$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $332d89d0d5f0863e$var$useThrowReportsDI = (0, $7OqB4.withThrowOnError)((0, $etw3L.useReports));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$332d89d0d5f0863e$export$2e2bcd8739ae039 = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $kxnYb.default), SkeletonItem: SkeletonItem = (0, $9K9UK.default), useIntl: useIntl = (0, $aWse0.useIntlV2), useProject: useProject = $332d89d0d5f0863e$var$useThrowProjectDI, useReports: useReports = $332d89d0d5f0863e$var$useThrowReportsDI, matchUrlParams: matchUrlParams = (0, $4OCke.matchUrlParams) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    const { data: reports } = useReports();
    if (project == null || reports == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const baseReportUrl = `/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $lIsiW.messages).forecastManagement)
    }, reports.hasTimeTrackingReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-tracking'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:time-tracking`
    }, formatMessage((0, $lIsiW.messages).timeTrackingReport)), reports.hasUserWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'developer-workload'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:developer-workload`
    }, formatMessage((0, $lIsiW.messages).userWorkloadReport)), reports.hasVersionWorkloadReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'version-workload'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugins.jira-software-plugin:version-workload-report`
    }, formatMessage((0, $lIsiW.messages).versionWorkloadReport)));
};

});
parcelRegister("etw3L", function(module, exports) {

$parcel$export(module.exports, "useReports", () => $94e9e6aca28c2b81$export$fa3120960baf4ea2);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $daoB1 = parcelRequire("daoB1");

var $afVvA = parcelRequire("afVvA");
const $94e9e6aca28c2b81$export$fa3120960baf4ea2 = ()=>{
    const { loading: loading, error: error } = (0, $1J3t1.useProjectSidebarNavigation)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    const extractedData = (0, $5uXOq.useMemo)(()=>(0, $afVvA.extractData)(hasSoftwareAccess), [
        hasSoftwareAccess
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("daoB1", function(module, exports) {

$parcel$export(module.exports, "ApplicationPermissionsSubscriber", () => $77add4b5420e5058$export$d8c76f7e52d0a856);
$parcel$export(module.exports, "useApplicationPermissions", () => $77add4b5420e5058$export$4d9cadb4042acc1b);

var $dGvGJ = parcelRequire("dGvGJ");

var $51nlc = parcelRequire("51nlc");

var $2gywT = parcelRequire("2gywT");

var $9OXo1 = parcelRequire("9OXo1");
const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
        data: {
            applicationPermissions: applicationPermissions
        }
    }));
const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $51nlc.createSubscriber)((0, $2gywT.default), {
    displayName: 'ApplicationPermissionsSubscriber',
    selector: $77add4b5420e5058$var$selector
});
const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.appPermissions;
};

});

parcelRegister("afVvA", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $96dace1af46a5543$export$9df5fa0a366163d2);
const $96dace1af46a5543$export$9df5fa0a366163d2 = (hasSoftwareAccess)=>({
        hasTimeTrackingReport: true,
        hasUserWorkloadReport: true,
        hasVersionWorkloadReport: hasSoftwareAccess
    });

});


parcelRegister("lIsiW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $63c164143bfc7c55$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $63c164143bfc7c55$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    forecastManagement: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.forecast-management.forecast-management",
        "defaultMessage": "Forecast & management"
    },
    timeTrackingReport: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.forecast-management.time-tracking-report",
        "defaultMessage": "Time Tracking Report"
    },
    userWorkloadReport: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.forecast-management.user-workload-report",
        "defaultMessage": "User Workload Report"
    },
    versionWorkloadReport: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.forecast-management.version-workload-report",
        "defaultMessage": "Version Workload Report"
    }
});

});


parcelRegister("8uwUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $33039923fdc98e48$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $bGLNh = parcelRequire("bGLNh");
const $33039923fdc98e48$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$33039923fdc98e48$export$2e2bcd8739ae039 = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $kxnYb.default), SkeletonItem: SkeletonItem = (0, $9K9UK.default), useIntl: useIntl = (0, $aWse0.useIntlV2), useProject: useProject = $33039923fdc98e48$var$useThrowProjectDI, matchUrlParams: matchUrlParams = (0, $4OCke.matchUrlParams) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const baseReportUrl = `/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bGLNh.messages).issueAnalysisIssueTermRefresh : (0, $bGLNh.messages).issueAnalysis)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'average-age'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:averageage-report`
    }, formatMessage((0, $bGLNh.messages).averageAge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'created-vs-resolved'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bGLNh.messages).createdResolvedIssuesIssueTermRefresh : (0, $bGLNh.messages).createdResolvedIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'pie'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:pie-report`
    }, formatMessage((0, $bGLNh.messages).pieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'recently-created'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bGLNh.messages).recentlyCreatedIssuesIssueTermRefresh : (0, $bGLNh.messages).recentlyCreatedIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'resolution-time'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:resolutiontime-report`
    }, formatMessage((0, $bGLNh.messages).resolutionTime)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'single-level-group-by'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:singlelevelgroupby`
    }, formatMessage((0, $bGLNh.messages).singleLevelGroup)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'time-since'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `${baseReportUrl}&reportKey=com.atlassian.jira.plugin.system.reports:timesince-report`
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bGLNh.messages).timeSinceIssuesIssueTermRefresh : (0, $bGLNh.messages).timeSinceIssues)));
};

});
parcelRegister("bGLNh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37568e43721d7017$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37568e43721d7017$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueAnalysis: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.issue-analysis",
        "defaultMessage": "Issue analysis"
    },
    averageAge: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.average-age",
        "defaultMessage": "Average Age Report"
    },
    createdResolvedIssues: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.created-resolved-issues",
        "defaultMessage": "Created vs Resolved Issues Report"
    },
    pieChart: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.pie-chart",
        "defaultMessage": "Pie Chart Report"
    },
    recentlyCreatedIssues: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.recently-created-issues",
        "defaultMessage": "Recently Created Issues Report"
    },
    resolutionTime: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.resolution-time",
        "defaultMessage": "Resolution Time Report"
    },
    singleLevelGroup: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.single-level-group",
        "defaultMessage": "Single Level Group By Report"
    },
    timeSinceIssues: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.time-since-issues",
        "defaultMessage": "Time Since Issues Report"
    },
    issueAnalysisIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.issue-analysis-issue-term-refresh",
        "defaultMessage": "Work item analysis"
    },
    createdResolvedIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.created-resolved-issues-issue-term-refresh",
        "defaultMessage": "Created vs Resolved Work items Report"
    },
    recentlyCreatedIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.recently-created-issues-issue-term-refresh",
        "defaultMessage": "Recently Created Work items Report"
    },
    timeSinceIssuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.issue-analysis.time-since-issues-issue-term-refresh",
        "defaultMessage": "Time Since Work Report"
    }
});

});


parcelRegister("SWNL7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $45b74da3f2d69bc6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $45b74da3f2d69bc6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.title",
        "defaultMessage": "Reports"
    },
    allReports: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.all-reports",
        "defaultMessage": "All reports"
    }
});

});

parcelRegister("dPZj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4593d265f191c9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $4R6GH = parcelRequire("4R6GH");

var $fNi03 = parcelRequire("fNi03");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $3tHFY = parcelRequire("3tHFY");

var $2lzjP = parcelRequire("2lzjP");
const $2c4593d265f191c9$var$useThrowProjectDI = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2c4593d265f191c9$export$2e2bcd8739ae039 = ({ MenuItem: MenuItem = (0, $k0ZZ2.MenuItem), Section: Section = (0, $kxnYb.default), SkeletonItem: SkeletonItem = (0, $9K9UK.default), useIntl: useIntl = (0, $aWse0.useIntlV2), useProject: useProject = $2c4593d265f191c9$var$useThrowProjectDI, ConnectMenu: ConnectMenu = (0, $3tHFY.ConnectMenu), matchUrlParams: matchUrlParams = (0, $4OCke.matchUrlParams), connectItems: connectItems })=>{
    const { formatMessage: formatMessage } = useIntl();
    const { data: project } = useProject();
    const { data: board, loading: isBoardLoading, error: error } = (0, $fNi03.useBoard)();
    if (project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    if (isBoardLoading && (0, $4R6GH.fg)('reports-overview-page-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
    const newReportsHref = board == null && !isBoardLoading && !error ? `/jira/software/c/projects/${project.key}/reports` : `/jira/software/c/projects/${project.key}/boards/${board?.id}/reports`;
    const reportsHref = (0, $4R6GH.fg)('reports-overview-page-migration') ? newReportsHref : `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    const BackMenuItem = {
        href: reportsHref,
        title: formatMessage((0, $2lzjP.messages).backItem)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $2lzjP.messages).other)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, {
        analytics: {
            itemId: 'workload-pie'
        },
        selectedOn: matchUrlParams([
            'reportKey'
        ]),
        href: `/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=com.atlassian.jira.ext.charting:workloadpie-report`
    }, formatMessage((0, $2lzjP.messages).workloadPieChart)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
        items: connectItems,
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }));
};

});
parcelRegister("2lzjP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9f9cfdc6b170fc73$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9f9cfdc6b170fc73$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    backItem: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.other.back-item",
        "defaultMessage": "Back to reports"
    },
    other: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.other.other",
        "defaultMessage": "Other"
    },
    workloadPieChart: {
        "id": "spa-apps-sidebar-software-classic.menu.reports.other.workload-pie-chart",
        "defaultMessage": "Workload Pie Chart Report"
    }
});

});



parcelRegister("fzMyx", function(module, exports) {

$parcel$export(module.exports, "Settings", () => $f4cb61bb62fa52a1$export$c72f6eaae7b9adff);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eOat1 = parcelRequire("eOat1");

var $3w19c = parcelRequire("3w19c");
var $kxnYb = parcelRequire("kxnYb");
var $9K9UK = parcelRequire("9K9UK");

var $k0iPT = parcelRequire("k0iPT");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $k2DRb = parcelRequire("k2DRb");

var $koVbs = parcelRequire("koVbs");

var $2MtwW = parcelRequire("2MtwW");

var $xc3fY = parcelRequire("xc3fY");

var $2Uv55 = parcelRequire("2Uv55");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $eYDk7 = parcelRequire("eYDk7");

var $2gP8z = parcelRequire("2gP8z");

var $lpwtK = parcelRequire("lpwtK");

var $71bFU = parcelRequire("71bFU");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $5xslo = parcelRequire("5xslo");

var $6EZeH = parcelRequire("6EZeH");

var $doZTA = parcelRequire("doZTA");

var $fYdir = parcelRequire("fYdir");

var $cQ3BE = parcelRequire("cQ3BE");

var $cilD6 = parcelRequire("cilD6");
const $f4cb61bb62fa52a1$var$useThrowProject = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $f4cb61bb62fa52a1$var$useThrowSettings = (0, $7OqB4.withThrowOnError)((0, $fYdir.useSettings));
const $f4cb61bb62fa52a1$var$ISSUES_ROUTE_NAMES = [
    'legacy-project-settings-issue-types',
    'legacy-project-settings-issue-layout',
    'legacy-project-settings-screens',
    'legacy-project-settings-fields',
    'legacy-project-settings-collectors',
    'legacy-project-settings-issue-security'
];
const $f4cb61bb62fa52a1$var$APPS_ROUTES = [
    'project-settings-software-forge-apps',
    ...(0, $k0iPT.CONNECT_ROUTES_SET).values()
];
const $f4cb61bb62fa52a1$export$5bc979096dddd25f = (routeName)=>$f4cb61bb62fa52a1$var$ISSUES_ROUTE_NAMES.includes(routeName);
const $f4cb61bb62fa52a1$var$calculateAppsMenuOpen = (routeName)=>$f4cb61bb62fa52a1$var$APPS_ROUTES.includes(routeName);
const $f4cb61bb62fa52a1$var$calculateNotificationsActive = ({ name: name })=>name === 'classic-software-notifications-issue-logs';
const $f4cb61bb62fa52a1$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: project } = $f4cb61bb62fa52a1$var$useThrowProject();
    const { data: features } = $f4cb61bb62fa52a1$var$useThrowSettings();
    const [{ route: route }] = (0, $doZTA.useRouter)();
    const hasDlpEnabled = (0, $6EZeH.useDlpEntitlement)();
    const baseProjectConfigUrl = `/plugins/servlet/project-config/${project?.key ?? ''}`; // We need a way to tell a neseted menu item within a expandable section that it is currently
    // expanded on order to get the sidbar scrolling to work correctly
    const [issuesMenuItem, setIssuesMenuItem] = (0, $5uXOq.useState)($f4cb61bb62fa52a1$export$5bc979096dddd25f(route.name));
    const [appsMenuOpen, setAppsMenuOpen] = (0, $5uXOq.useState)($f4cb61bb62fa52a1$var$calculateAppsMenuOpen(route.name));
    const [notificationsActive] = (0, $5uXOq.useState)($f4cb61bb62fa52a1$var$calculateNotificationsActive(route));
    (0, $5uXOq.useEffect)(()=>{
        setIssuesMenuItem($f4cb61bb62fa52a1$export$5bc979096dddd25f(route.name));
        setAppsMenuOpen($f4cb61bb62fa52a1$var$calculateAppsMenuOpen(route.name));
    }, [
        route
    ]);
    if (features == null || project == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const BackMenuItem = {
        href: `/plugins/servlet/project-config/${project.key}`,
        title: formatMessage((0, $cQ3BE.messages).backItem)
    };
    const defaultIssuesSettingsSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'issues'
        },
        menuItemLabel: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cQ3BE.messages).issuesIssueTermRefresh : (0, $cQ3BE.messages).issues),
        forceExpand: issuesMenuItem,
        submenuId: "classic-issues-setttings",
        testId: "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issues"
    }, features.hasIssueTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'issue-types'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/issuetypes`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issue-types"
    }, formatMessage((0, $cQ3BE.messages).types)), features.hasIssueLayout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'issue-layout'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/issuelayout`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issue-layout"
    }, formatMessage((0, $cQ3BE.messages).layout)), features.hasScreens && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'screens'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/screens`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-screens"
    }, formatMessage((0, $cQ3BE.messages).screens)), features.hasFields && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'fields'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/fields`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-fields"
    }, formatMessage((0, $cQ3BE.messages).fields)), (0, $4R6GH.fg)('proforma_mvp_jsw_project_settings') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'proforma-forms'
        },
        href: `/jira/software/c/projects/${project.key}/settings/forms`,
        selectedOn: [
            'project-settings-software-proforma-project-forms'
        ],
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-proforma-fields"
    }, (0, $6s1PB.expVal)('forms_for_jsw_experiment', 'isEnabled', false) ? formatMessage((0, $cQ3BE.messages).advancedForms) : formatMessage((0, $cQ3BE.messages).forms)), features.hasIssueCollectors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'issue-collectors'
        },
        selectedOn: [
            'legacy-project-settings-collectors'
        ],
        href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issue-collectors"
    }, formatMessage((0, $cQ3BE.messages).collectors)), features.hasIssueSecurity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'issue-security'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/issuesecurity`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issue-security"
    }, formatMessage((0, $cQ3BE.messages).security)));
    const nonAdminIssueLayoutSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'issues'
        },
        menuItemLabel: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cQ3BE.messages).issuesIssueTermRefresh : (0, $cQ3BE.messages).issues),
        forceExpand: issuesMenuItem,
        submenuId: "classic-issues-setttings",
        testId: "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'issue-layout'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/issuelayout`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-issue-layout"
    }, formatMessage((0, $cQ3BE.messages).layout)));
    const issuesSection = (()=>{
        if (features.hasIssuesDropdown) return defaultIssuesSettingsSection;
        if (!features.hasIssuesDropdown && features.hasIssueLayout) return nonAdminIssueLayoutSection;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eYDk7.ExpandableProjectSettingsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kxnYb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4cb61bb62fa52a1$var$ProjectSettingsLunarHeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3w19c.default), null, formatMessage((0, $cQ3BE.messages).settings))), features.hasDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'details'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/jira/software/c/projects/${project.key}/settings/details`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-details"
    }, formatMessage((0, $cQ3BE.messages).details)), features.hasSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'summary'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/summary`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-summary"
    }, formatMessage((0, $cQ3BE.messages).summary)), features.hasPeople && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'people'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/people`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-people"
    }, formatMessage((0, $cQ3BE.messages).people)), features.hasPermissions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'permissions'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/permissions`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-permissions"
    }, formatMessage((0, $cQ3BE.messages).permissions)), features.hasNotifications && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'notifications'
        },
        menuItemLabel: formatMessage((0, $cQ3BE.messages).notifications),
        forceExpand: notificationsActive,
        submenuId: "classic-notifications-settings",
        testId: "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71bFU.NotificationsSubMenu), {
        settingsUrl: `${baseProjectConfigUrl}/notifications`,
        issueLogsUrl: `/jira/software/c/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`
    })), features.hasAutomation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: "spotlight-sidebar-project-automation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'automation'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/jira/software/c/projects/${project.key}/settings/automate`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-automation"
    }, formatMessage((0, $cQ3BE.messages).automation))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-automation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Uv55.FireUiAnalytics), {
        actionSubject: "automationNavigationItem",
        action: "viewed"
    })), features.hasFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2gP8z.SpotlightTarget), {
        name: "spotlight-sidebar-project-features"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'features'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/jira/software/c/projects/${project.key}/settings/features`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-features"
    }, formatMessage((0, $cQ3BE.messages).features))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2MtwW.EngagementSpotlight), {
        engagementId: "spotlight-sidebar-project-features"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Uv55.FireUiAnalytics), {
        actionSubject: "featuresNavigationItem",
        action: "viewed"
    })), features.hasToolchains && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cilD6.ToolchainMenuItem), {
        projectId: project.id,
        projectKey: project.key
    }), features.hasWorkflows && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'workflows'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `${baseProjectConfigUrl}/workflows`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-workflows"
    }, formatMessage((0, $cQ3BE.messages).workflows)), issuesSection, features.hasComponents && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'components'
        },
        selectedOn: [
            'project-settings-components'
        ],
        href: `${baseProjectConfigUrl}/administer-components`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-components"
    }, formatMessage((0, $cQ3BE.messages).components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4cb61bb62fa52a1$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $cQ3BE.messages).new)))), features.hasApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $xc3fY.ExpandableSubmenuItem), {
        analytics: {
            itemId: 'apps'
        },
        menuItemLabel: formatMessage((0, $cQ3BE.messages).apps),
        forceExpand: appsMenuOpen,
        submenuId: "classic-apps-setttings",
        testId: "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-apps"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5xslo.default), {
        items: ecosystemItems,
        forgeModule: (0, $k2DRb.PROJECT_SETTINGS_PAGE_MODULE),
        overrides: {
            BackMenuItem: BackMenuItem
        }
    }), features.hasOpsgenie && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'opsgenie'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/jira/software/c/projects/${project.key}/settings/opsgenie`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-testid": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-opsgenie"
    }, formatMessage((0, $cQ3BE.messages).opsgenie))), features.hasDevtools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        analytics: {
            itemId: 'devtools'
        },
        href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-devtools"
    }, formatMessage((0, $cQ3BE.messages).devtools)), features.hasDeleteProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'delete-project'
        },
        selectedOn: [
            'legacy-project-settings-delete'
        ],
        href: `/secure/project/DeleteProject!default.jspa?pid=${project.id}&pcp=true`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.menu-item-delete-project"
    }, formatMessage((0, $cQ3BE.messages).deleteProject)), hasDlpEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'data-classification'
        },
        href: `${baseProjectConfigUrl}/data-classifications`,
        selectedOn: [
            'project-settings-classic-data-classifications'
        ]
    }, formatMessage((0, $cQ3BE.messages).dataClassificationNonFinal))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $f4cb61bb62fa52a1$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled
const $f4cb61bb62fa52a1$var$ProjectSettingsLunarHeadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xc3fY", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubmenuItem", () => $dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3TzYp = parcelRequire("3TzYp");

var $iUo88 = parcelRequire("iUo88");

var $8zOmE = parcelRequire("8zOmE");
var $bngFq = parcelRequire("bngFq");

var $fXJBp = parcelRequire("fXJBp");

var $k0ZZ2 = parcelRequire("k0ZZ2");
const $dec8d2ea50472f86$var$defaultExpandMenuState = {
    submenuActive: false,
    expanded: false
};
const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
    const getExpandableState = (submenuId)=>{
        const cookieData = (0, $3TzYp.getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
        let parsedCookieData = null;
        try {
            // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            parsedCookieData = JSON.parse(cookieData);
        } catch  {
            // Rather than throw an error - just set the default state
            parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
        }
        return parsedCookieData;
    };
    const setExpandedState = (submenuId, newExpandedState)=>{
        if (submenuId != null) (0, $iUo88.setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
    };
    return {
        getExpandableState: getExpandableState,
        setExpandedState: setExpandedState
    };
};
const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
    const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
    const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
    const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
    const [expanded, setExpanded] = (0, $5uXOq.useState)(forceExpand);
    const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (currentCookieData?.expanded) {
            setExpanded(currentCookieData.expanded);
            setSubMenuActive(currentCookieData.submenuActive);
        }
    }, [
        currentCookieData
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (submenuId != null) setExpandedState(submenuId, {
            submenuActive: false,
            expanded: !expanded
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
            expandMenuId: analytics?.itemId,
            expanded: !expanded
        });
        setExpanded(!expanded);
        requestAnimationFrame(()=>{
            expandableMenuItemRef?.current?.focus();
        });
    }, [
        analytics,
        createAnalyticsEvent,
        expanded,
        setExpandedState,
        submenuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
        isExpanded: subMenuActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: analytics,
        href: href,
        useButtonLink: useButtonLink,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXJBp.ExpandButton), {
            id: expandButtonId,
            label: expandButtonLabel,
            isActive: true,
            isExpanded: expanded,
            size: "medium"
        }), iconBefore),
        onClick: onClick,
        "data-test-id": testId,
        ref: expandableMenuItemRef,
        tabIndex: -1
    }, menuItemLabel), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
        noListStyle: noListStyle
    }, children));
};
// Buttons inside the Expandable Menu indicate sub-expandable menus,
// these are styled differently that top level expandable menu items so the aligment look ok
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
            __cmplp.isExpanded && "_4t3i1osq",
            __cmplp.className
        ])
    });
});
const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2Uv55", function(module, exports) {

$parcel$export(module.exports, "FireUiAnalytics", () => $c81bbbeeb609506c$export$5a67e7291fd4569e);

var $5oFIy = parcelRequire("5oFIy");

var $axUP7 = parcelRequire("axUP7");
const $c81bbbeeb609506c$export$5a67e7291fd4569e = (0, $axUP7.withNestingOptimisation)((0, $5oFIy.FireUiAnalytics));

});

parcelRegister("71bFU", function(module, exports) {

$parcel$export(module.exports, "NotificationsSubMenu", () => $4606ea7b05b7e72d$export$f80567459a5e304a);

var $5uXOq = parcelRequire("5uXOq");

var $6puUq = parcelRequire("6puUq");

var $eOat1 = parcelRequire("eOat1");

var $Pxnvj = parcelRequire("Pxnvj");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $9K9UK = parcelRequire("9K9UK");

var $aWse0 = parcelRequire("aWse0");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $lpwtK = parcelRequire("lpwtK");

var $7OqB4 = parcelRequire("7OqB4");

var $4OCke = parcelRequire("4OCke");

var $icKiA = parcelRequire("icKiA");
const $4606ea7b05b7e72d$export$51b1383ef8844a7 = (0, $7OqB4.withThrowOnError)((0, $lpwtK.useProject));
const $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
const $4606ea7b05b7e72d$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const { data: project, loading: projectLoading } = $4606ea7b05b7e72d$export$51b1383ef8844a7();
    if (projectLoading || !project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9K9UK.default), null);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notifications-settings'
        },
        href: settingsUrl,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, formatMessage((0, $icKiA.messages).itemSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Pxnvj.default), {
        name: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'notifications-issue-logs'
        },
        href: issueLogsUrl,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        selectedOn: (0, $4OCke.matchUrlPathname)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $4606ea7b05b7e72d$var$issueLogsContainerStyles
    }, formatMessage((0, $icKiA.messages).itemProjectEmailAuditLogs), displayLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eOat1.default), {
        appearance: "new"
    }, formatMessage((0, $icKiA.messages).newLozenge)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6puUq.EngagementSpotlight), {
        engagementId: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
};
const $4606ea7b05b7e72d$var$issueLogsContainerStyles = (0, $2s57o.xcss)({
    display: 'flex',
    justifyContent: 'space-between'
});

});
parcelRegister("icKiA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0ac4b8c96850fb1d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0ac4b8c96850fb1d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    itemSettings: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
        "defaultMessage": "Settings"
    },
    itemProjectEmailAuditLogs: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
        "defaultMessage": "Project email audit"
    },
    newLozenge: {
        "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("5xslo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f574dcd99762a8d6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $hBuqR = parcelRequire("hBuqR");

var $au6nA = parcelRequire("au6nA");

var $fh2pW = parcelRequire("fh2pW");

var $k51JQ = parcelRequire("k51JQ");
const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
    const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
        items.forge
    ]);
    const connectItems = (0, $au6nA.useFilteredItems)(items.connect, shouldFilter);
    const sortedItems = (0, $5uXOq.useMemo)(()=>[
            ...forgeItems.map((item)=>({
                    type: 'forge',
                    item: item
                })),
            ...connectItems.map((item)=>({
                    type: 'connect',
                    item: item
                }))
        ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
        connectItems,
        forgeItems
    ]);
    if (!sortedItems.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
        if (type === 'forge') {
            // @ts-expect-error - TS2322 - Type 'ConnectDataItem | ForgeItemProps' is not assignable to type 'ForgeProjectSettingsItem'.
            const forgeItem = item;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k51JQ.ForgeItem), {
                key: forgeItem.id,
                ...forgeItem,
                overrides: overrides,
                showIcon: showIcons,
                nestedMenuActive: nestedMenuActive
            });
        }
        const connectItem = item;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fh2pW.ConnectItem), {
            item: connectItem,
            key: connectItem.id,
            index: index,
            overrides: overrides,
            showIcons: showIcons,
            submenuId: submenuId
        });
    }), forgeItems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), null) : null);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
        module: forgeModule,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));

});

parcelRegister("6EZeH", function(module, exports) {

$parcel$export(module.exports, "useDlpEntitlement", () => $c4c8661954b324b0$export$4472465702535e7);

var $9OXo1 = parcelRequire("9OXo1");
const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.hasDlpEnabled || false;
};

});

parcelRegister("fYdir", function(module, exports) {

$parcel$export(module.exports, "useSettings", () => $ff650e02a5987734$export$9115b42802a3e44f);

var $5uXOq = parcelRequire("5uXOq");

var $1J3t1 = parcelRequire("1J3t1");

var $jIwth = parcelRequire("jIwth");

var $cfEDC = parcelRequire("cfEDC");
const $ff650e02a5987734$export$9115b42802a3e44f = ()=>{
    const { data: data, loading: loading, error: error } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const hasActiveSoftwareAccess = (0, $jIwth.useHasActiveSoftwareAccess)();
    const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, $cfEDC.extractData)(data, hasActiveSoftwareAccess), [
        data,
        hasActiveSoftwareAccess
    ]);
    return {
        data: extractedData,
        loading: loading,
        error: error
    };
};

});
parcelRegister("jIwth", function(module, exports) {

$parcel$export(module.exports, "useHasActiveSoftwareAccess", () => $c3adde43a433f1b5$export$895f9b38ce00671e);

var $k9JTq = parcelRequire("k9JTq");

var $daoB1 = parcelRequire("daoB1");
const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const { hasSoftwareAccess: hasSoftwareAccess } = (0, $daoB1.useApplicationPermissions)();
    return software !== 'UNLICENSED' && hasSoftwareAccess === true;
};

});

parcelRegister("cfEDC", function(module, exports) {

$parcel$export(module.exports, "extractData", () => $c656a990f38437a1$export$9df5fa0a366163d2);
const $c656a990f38437a1$export$9df5fa0a366163d2 = (navData, hasActiveSoftwareAccess)=>{
    const { permissionInfo: permissionInfo } = navData;
    const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
    const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const isProjectOrSiteAdmin = isAdmin || isProjectAdmin;
    const hasEditWorkflowPermissions = permissionInfo.projectPermissionsQueried.EDIT_WORKFLOW === true;
    const hasIssueLayoutPermissions = permissionInfo.projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
    return {
        hasApps: isProjectOrSiteAdmin,
        hasAutomation: isProjectOrSiteAdmin,
        hasComponents: isProjectOrSiteAdmin,
        hasDeleteProject: false,
        hasDetails: isProjectOrSiteAdmin,
        hasDevtools: hasActiveSoftwareAccess && isProjectAdmin,
        hasFeatures: isProjectOrSiteAdmin,
        hasFields: isProjectOrSiteAdmin,
        hasIssueCollectors: isProjectOrSiteAdmin,
        hasIssueLayout: isProjectOrSiteAdmin || hasIssueLayoutPermissions,
        /**
		 * If Issue Layout is true but Issues Dropdown is false (in the case of non admin with Edit Issue Layout permission),
		 * the issues expandable section will be replaced by a top-level menu item for edit issue layout only.
		 */ hasIssuesDropdown: isProjectOrSiteAdmin,
        hasIssueSecurity: isProjectOrSiteAdmin,
        hasIssueTypes: isAdmin,
        hasNotifications: isProjectOrSiteAdmin,
        hasOpsgenie: isAdmin,
        hasPeople: isProjectOrSiteAdmin,
        hasPermissions: isProjectOrSiteAdmin,
        hasPersonaForms: isProjectOrSiteAdmin,
        hasScreens: isProjectOrSiteAdmin,
        hasSummary: isProjectOrSiteAdmin,
        hasToolchains: isProjectOrSiteAdmin,
        hasWorkflows: isProjectOrSiteAdmin || hasEditWorkflowPermissions
    };
};

});


parcelRegister("cQ3BE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $db9f90db55a7da72$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $db9f90db55a7da72$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    backItem: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.back-item",
        "defaultMessage": "Back"
    },
    automation: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.automation",
        "defaultMessage": "Automation"
    },
    features: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.features",
        "defaultMessage": "Features"
    },
    details: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.people",
        "defaultMessage": "People"
    },
    summary: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.summary",
        "defaultMessage": "Summary"
    },
    deleteProject: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.delete-project",
        "defaultMessage": "Delete project"
    },
    issueTypes: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-types",
        "defaultMessage": "Issue types"
    },
    issueLayout: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-layout",
        "defaultMessage": "Issue layout"
    },
    workflows: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.workflows",
        "defaultMessage": "Workflows"
    },
    screens: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.screens",
        "defaultMessage": "Screens"
    },
    fields: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.fields",
        "defaultMessage": "Fields"
    },
    components: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.components",
        "defaultMessage": "Components"
    },
    opsgenie: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    permissions: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.permissions",
        "defaultMessage": "Permissions"
    },
    issueSecurity: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-security",
        "defaultMessage": "Issue security"
    },
    notifications: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.notifications",
        "defaultMessage": "Notifications"
    },
    notificationsEmail: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.notifications-email",
        "defaultMessage": "Notification email"
    },
    hipChat: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.hip-chat",
        "defaultMessage": "HipChat integration"
    },
    devtools: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.devtools",
        "defaultMessage": "Development tools"
    },
    issueCollectors: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-collectors",
        "defaultMessage": "Issue collectors"
    },
    settings: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.settings",
        "defaultMessage": "Project settings"
    },
    forms: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.forms",
        "defaultMessage": "Forms"
    },
    advancedForms: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.advanced-forms",
        "defaultMessage": "Advanced Forms"
    },
    connections: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.connections",
        "defaultMessage": "Connections"
    },
    types: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.types",
        "defaultMessage": "Types"
    },
    layout: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.layout",
        "defaultMessage": "Layout"
    },
    security: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.security",
        "defaultMessage": "Security"
    },
    collectors: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.collectors",
        "defaultMessage": "Collectors"
    },
    apps: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.apps",
        "defaultMessage": "Apps"
    },
    issues: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issues",
        "defaultMessage": "Issues"
    },
    new: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.new",
        "defaultMessage": "New"
    },
    dataClassificationNonFinal: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.data-classification-non-final",
        "defaultMessage": "Data classification"
    },
    issueTypesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-types-issue-term-refresh",
        "defaultMessage": "Work types"
    },
    issueLayoutIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-layout-issue-term-refresh",
        "defaultMessage": "Work item layout"
    },
    issueSecurityIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-security-issue-term-refresh",
        "defaultMessage": "Work item security"
    },
    issueCollectorsIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issue-collectors-issue-term-refresh",
        "defaultMessage": "Work item collectors"
    },
    issuesIssueTermRefresh: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.issues-issue-term-refresh",
        "defaultMessage": "All work"
    }
});

});

parcelRegister("cilD6", function(module, exports) {

$parcel$export(module.exports, "ToolchainMenuItem", () => $5223f8e1017dde42$export$338f72f6d700e3a9);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $k0ZZ2 = parcelRequire("k0ZZ2");

var $4OCke = parcelRequire("4OCke");

var $6jY6G = parcelRequire("6jY6G");

var $kfztd = parcelRequire("kfztd");

var $lpYXP = parcelRequire("lpYXP");
const $5223f8e1017dde42$export$338f72f6d700e3a9 = ({ projectId: projectId, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const toolchainRoute = (0, $6jY6G.useRouteByName)('project-settings-software-toolchain-company-managed');
    // The route definition will be null when this component is rendered outside
    // of the SPA (e.g. the `Development tools` tab in Classic projects)
    // Don't render MenuItem if FedRAMP enabled
    if ((0, $kfztd.isDevopsFeatureDisabledInFedRamp)()) return null;
    return toolchainRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'toolchain'
        },
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.toolchain-menu-item.menu-item-toolchain",
        selectedOn: [
            'project-settings-software-toolchain-company-managed'
        ],
        to: toolchainRoute,
        params: {
            projectKey: projectKey
        },
        query: {
            projectId: String(projectId)
        },
        prefetch: "hover"
    }, formatMessage((0, $lpYXP.messages).toolchain)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0ZZ2.MenuItem), {
        analytics: {
            itemId: 'toolchain'
        },
        selectedOn: (0, $4OCke.matchUrlPathname)(),
        href: `/jira/software/c/projects/${projectKey}/settings/toolchain?projectId=${projectId}`,
        ref: /*#__PURE__*/ (0, $5uXOq.createRef)(),
        "data-test-id": "navigation-apps-sidebar-software-classic.ui.menu.settings.toolchain-menu-item.menu-item-toolchain"
    }, formatMessage((0, $lpYXP.messages).toolchain));
};

});
parcelRegister("lpYXP", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7adbc898ba650855$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7adbc898ba650855$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    toolchain: {
        "id": "spa-apps-sidebar-software-classic.menu.settings.toolchain-menu-item.toolchain",
        "defaultMessage": "Toolchain"
    }
});

});



parcelRegister("egnSq", function(module, exports) {

$parcel$export(module.exports, "handleRapidboardSPAClick", () => $5c4cf1febe4faa7e$export$69450215b01510cc);
const $5c4cf1febe4faa7e$export$69450215b01510cc = (mode)=>(e)=>{
        const href = // @ts-expect-error - TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'. | TS2339 - Property 'href' does not exist on type 'EventTarget | (EventTarget & HTMLAnchorElement)'.
        typeof e.currentTarget.href === 'string' ? e.currentTarget.href : undefined;
        const openInNewTab = e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || // @ts-expect-error - TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'. | TS2339 - Property 'button' does not exist on type 'KeyboardEvent<HTMLAnchorElement> | MouseEvent<HTMLAnchorElement, MouseEvent> | MouseEvent<EventTarget, MouseEvent> | KeyboardEvent<...>'.
        e.button != null && e.button === 1;
        if (href == null || href === '' || e.defaultPrevented || openInNewTab) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (window.GH && window.GH.RapidBoard && window.GH.RapidBoard.ViewController) {
            e.preventDefault();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.GH.RapidBoard.ViewController.setMode(mode);
        }
    };

});





//# sourceMappingURL=async-sidebar-software-classic.5b19cf53.js.map
